
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("eOat1", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $45b631a0c2da2b22$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $fHpHg = parcelRequire("fHpHg");

var $gDVGL = parcelRequire("gDVGL");

var $9cf90 = parcelRequire("9cf90");
/**
 * __Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 *
 * - [Examples](https://atlassian.design/components/lozenge/examples)
 * - [Code](https://atlassian.design/components/lozenge/code)
 * - [Usage](https://atlassian.design/components/lozenge/usage)
 */ const $45b631a0c2da2b22$var$Lozenge = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo((props)=>(0, $fHpHg.fg)('platform_dst_lozenge_fg') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gDVGL.default), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9cf90.default), {
        ...props
    }));
// NOTE: Remove this and just directly `export { default } from '…';` when tidying `platform_dst_lozenge_fg`
$45b631a0c2da2b22$var$Lozenge.displayName = 'Lozenge';
var $45b631a0c2da2b22$export$2e2bcd8739ae039 = $45b631a0c2da2b22$var$Lozenge;

});
parcelRegister("gDVGL", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b11ccdfc5df0562$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fHpHg = parcelRequire("fHpHg");

var $5sRpy = parcelRequire("5sRpy");
const $0b11ccdfc5df0562$var$stylesOld = {
    container: "_2rkoglpi _1reo15vq _18m915vq _18zr1b66 _1e0c116y _1kz6184x _kqswpfqs _vchhusvi",
    'text.bold.default': "_syaz15cr",
    'text.bold.inprogress': "_syaz15cr",
    'text.bold.moved': "_syazal3n",
    'text.bold.new': "_syaz15cr",
    'text.bold.removed': "_syaz15cr",
    'text.bold.success': "_syaz15cr",
    'text.subtle.default': "_syazjjyb",
    'text.subtle.inprogress': "_syaz1lpn",
    'text.subtle.moved': "_syaz1tm6",
    'text.subtle.new': "_syaz1mvf",
    'text.subtle.removed': "_syaz1ick",
    'text.subtle.success': "_syaz17fi"
};
// NOTE: This is isolated to avoid breaking the bounded `stylesOld` interface as they do not fall within the Design System.
const $0b11ccdfc5df0562$var$stylesOldUnbounded = {
    text: "_1reo15vq _18m915vq _ect41gqc _1wyb1skh _zg8l4jg8 _k48pmoej _vwz47vkz _1bto1l2s _1p1dangw _o5721q9c",
    customLetterspacing: "_1dyz9vsi"
};
const $0b11ccdfc5df0562$var$backgroundColorsOld = {
    bold: {
        default: 'color.background.neutral.bold',
        inprogress: 'color.background.information.bold',
        moved: 'color.background.warning.bold',
        new: 'color.background.discovery.bold',
        removed: 'color.background.danger.bold',
        success: 'color.background.success.bold'
    },
    subtle: {
        default: 'color.background.neutral',
        inprogress: 'color.background.information',
        moved: 'color.background.warning',
        new: 'color.background.discovery',
        removed: 'color.background.danger',
        success: 'color.background.success'
    }
};
/**
 * TODO: We should be using our bounded `cssMap` here, but most of
 * these styles from the visual refresh are not in the Design System.
 */ const $0b11ccdfc5df0562$var$stylesNew = {
    container: "_2rko1l7b _1reo15vq _18m915vq _1e0c116y _vchhusvi _kqswpfqs _1kz6184x _bozg1b66 _y4ti1b66",
    containerSubtle: "_1cwg1n1a",
    text: "_1reo15vq _18m915vq _ect41gqc _1wyb1skh _zg8l4jg8 _k48pmoej _vwz47vkz _1bto1l2s _1p1dangw _o5721q9c",
    customLetterspacing: "_1dyz9vsi",
    'bg.bold.default': "_bfhk1fkg",
    'bg.bold.inprogress': "_bfhk1ymo",
    'bg.bold.moved': "_bfhkxmjf",
    'bg.bold.new': "_bfhkshej",
    'bg.bold.removed': "_bfhk1366",
    'bg.bold.success': "_bfhk3uhp",
    'bg.subtle.default': "_bfhk1w7a",
    'bg.subtle.inprogress': "_bfhk1w7a",
    'bg.subtle.moved': "_bfhk1w7a",
    'bg.subtle.new': "_bfhk1w7a",
    'bg.subtle.removed': "_bfhk1w7a",
    'bg.subtle.success': "_bfhk1w7a",
    'border.subtle.default': "_19it14mp",
    'border.subtle.inprogress': "_19it1cy7",
    'border.subtle.moved': "_19itzi1n",
    'border.subtle.new': "_19it1apr",
    'border.subtle.removed': "_19itoa5t",
    'border.subtle.success': "_19it1am1",
    'outline.subtle.default': "_12ji14je _1qu2nqa1 _12y3t94y",
    'outline.subtle.inprogress': "_12jiuisw _1qu2nqa1 _12y3t94y",
    'outline.subtle.moved': "_12jih727 _1qu2nqa1 _12y3t94y",
    'outline.subtle.new': "_12ji157s _1qu2nqa1 _12y3t94y",
    'outline.subtle.removed': "_12jia2c0 _1qu2nqa1 _12y3t94y",
    'outline.subtle.success': "_12jin0nx _1qu2nqa1 _12y3t94y",
    'text.subtle': "_syaz1fxt",
    'text.bold': "_syazwwip"
};
const $0b11ccdfc5df0562$var$appearanceTypes = [
    'default',
    'inprogress',
    'moved',
    'new',
    'removed',
    'success'
];
/**
 * __Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 *
 * - [Examples](https://atlassian.design/components/lozenge/examples)
 * - [Code](https://atlassian.design/components/lozenge/code)
 * - [Usage](https://atlassian.design/components/lozenge/usage)
 */ const $0b11ccdfc5df0562$var$Lozenge = /*#__PURE__*/ (0, $5uXOq.memo)(({ children: children, testId: testId, isBold: isBold = false, appearance: appearance = 'default', maxWidth: maxWidth = 200, style: style })=>{
    const appearanceStyle = isBold ? 'bold' : 'subtle';
    const appearanceType = (0, $5uXOq.useMemo)(()=>$0b11ccdfc5df0562$var$appearanceTypes.includes(appearance) ? appearance : 'default', [
        appearance
    ]);
    const maxWidthValue = typeof maxWidth === 'string' ? maxWidth : `${maxWidth}px`;
    const maxWidthIsPc = typeof maxWidth === 'string' && /%$/.test(maxWidth);
    if ((0, $fHpHg.fg)('platform-component-visual-refresh')) return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        style: {
            backgroundColor: style?.backgroundColor,
            maxWidth: maxWidthIsPc ? maxWidth : '100%'
        },
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            $0b11ccdfc5df0562$var$stylesNew.container,
            $0b11ccdfc5df0562$var$stylesNew[`bg.${appearanceStyle}.${appearanceType}`],
            appearanceStyle === 'subtle' && !(0, $fHpHg.fg)('visual-refresh_drop_5') && $0b11ccdfc5df0562$var$stylesNew[`border.subtle.${appearanceType}`],
            appearanceStyle === 'subtle' && (0, $fHpHg.fg)('visual-refresh_drop_5') && $0b11ccdfc5df0562$var$stylesNew[`outline.subtle.${appearanceType}`],
            appearanceStyle === 'subtle' && (0, $fHpHg.fg)('visual-refresh_drop_5') && $0b11ccdfc5df0562$var$stylesNew.containerSubtle
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
            style: {
                color: style?.color,
                // to negate paddingInline specified on Box above
                maxWidth: maxWidthIsPc ? '100%' : `calc(${maxWidthValue} - ${"var(--ds-space-100, 8px)"})`
            },
            "data-testid": testId && `${testId}--text`,
            className: (0, $bwpsq.default)([
                $0b11ccdfc5df0562$var$stylesNew.text,
                (0, $fHpHg.fg)('platform-lozenge-custom-letterspacing') && $0b11ccdfc5df0562$var$stylesNew.customLetterspacing,
                $0b11ccdfc5df0562$var$stylesNew[`text.${appearanceStyle}`]
            ]),
            children: children
        })
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        as: "span",
        backgroundColor: $0b11ccdfc5df0562$var$backgroundColorsOld[appearanceStyle][appearanceType],
        style: {
            backgroundColor: style?.backgroundColor,
            maxWidth: maxWidthIsPc ? maxWidth : '100%'
        },
        paddingInline: "space.050",
        xcss: $0b11ccdfc5df0562$var$stylesOld.container,
        testId: testId,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
            style: {
                color: style?.color,
                // to negate paddingInline specified on Box above
                maxWidth: maxWidthIsPc ? '100%' : `calc(${maxWidthValue} - ${"var(--ds-space-100, 8px)"})`
            },
            "data-testid": testId && `${testId}--text`,
            className: (0, $bwpsq.default)([
                $0b11ccdfc5df0562$var$stylesOldUnbounded.text,
                (0, $fHpHg.fg)('platform-lozenge-custom-letterspacing') && $0b11ccdfc5df0562$var$stylesOldUnbounded.customLetterspacing,
                $0b11ccdfc5df0562$var$stylesOld[`text.${appearanceStyle}.${appearanceType}`]
            ]),
            children: children
        })
    });
});
$0b11ccdfc5df0562$var$Lozenge.displayName = 'Lozenge';
var $0b11ccdfc5df0562$export$2e2bcd8739ae039 = $0b11ccdfc5df0562$var$Lozenge;

});

parcelRegister("9cf90", function(module, exports) {

$parcel$export(module.exports, "default", () => $7af69e0951395108$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $fHpHg = parcelRequire("fHpHg");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");
function $7af69e0951395108$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7af69e0951395108$var$baseStylesOld = (0, $2s57o.xcss)({
    display: 'inline-flex',
    borderRadius: 'border.radius',
    blockSize: 'min-content',
    position: 'static',
    overflow: 'hidden'
});
const $7af69e0951395108$var$styles = {
    container: {
        name: "1s8rs5f",
        styles: "display:inline-flex;box-sizing:border-box;position:static;block-size:min-content;border-radius:3px;overflow:hidden;padding-inline:var(--ds-space-050, 4px)"
    },
    containerSubtle: /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        outlineOffset: -1
    }),
    background: {
        bold: {
            default: {
                name: "1007ca",
                styles: "background-color:#DDDEE1"
            },
            inprogress: {
                name: "5nwhd8",
                styles: "background-color:#8FB8F6"
            },
            moved: {
                name: "1v45608",
                styles: "background-color:#F9C84E"
            },
            new: {
                name: "1ra4w2w",
                styles: "background-color:#D8A0F7"
            },
            removed: {
                name: "1y25gsq",
                styles: "background-color:#FD9891"
            },
            success: {
                name: "2bpbki",
                styles: "background-color:#B3DF72"
            }
        },
        subtle: {
            default: {
                name: "1v09iay",
                styles: "background-color:var(--ds-background-neutral-subtle, #00000000)"
            },
            inprogress: {
                name: "1v09iay",
                styles: "background-color:var(--ds-background-neutral-subtle, #00000000)"
            },
            moved: {
                name: "1v09iay",
                styles: "background-color:var(--ds-background-neutral-subtle, #00000000)"
            },
            new: {
                name: "1v09iay",
                styles: "background-color:var(--ds-background-neutral-subtle, #00000000)"
            },
            removed: {
                name: "1v09iay",
                styles: "background-color:var(--ds-background-neutral-subtle, #00000000)"
            },
            success: {
                name: "1v09iay",
                styles: "background-color:var(--ds-background-neutral-subtle, #00000000)"
            }
        }
    },
    border: {
        subtle: {
            default: /*#__PURE__*/ (0, $f8Sb3.css)({
                border: `1px solid #B7B9BE`
            }),
            inprogress: /*#__PURE__*/ (0, $f8Sb3.css)({
                border: `1px solid #669DF1`
            }),
            moved: /*#__PURE__*/ (0, $f8Sb3.css)({
                border: `1px solid #FCA700`
            }),
            new: /*#__PURE__*/ (0, $f8Sb3.css)({
                border: `1px solid #C97CF4`
            }),
            removed: /*#__PURE__*/ (0, $f8Sb3.css)({
                border: `1px solid #F87168`
            }),
            success: /*#__PURE__*/ (0, $f8Sb3.css)({
                border: `1px solid #94C748`
            })
        }
    },
    outline: {
        subtle: {
            default: /*#__PURE__*/ (0, $f8Sb3.css)({
                outline: `1px solid #B7B9BE`
            }),
            inprogress: /*#__PURE__*/ (0, $f8Sb3.css)({
                outline: `1px solid #669DF1`
            }),
            moved: /*#__PURE__*/ (0, $f8Sb3.css)({
                outline: `1px solid #FCA700`
            }),
            new: /*#__PURE__*/ (0, $f8Sb3.css)({
                outline: `1px solid #C97CF4`
            }),
            removed: /*#__PURE__*/ (0, $f8Sb3.css)({
                outline: `1px solid #F87168`
            }),
            success: /*#__PURE__*/ (0, $f8Sb3.css)({
                outline: `1px solid #94C748`
            })
        }
    },
    text: {
        subtle: {
            name: "nws7uq",
            styles: "color:var(--ds-text, #172B4D)"
        },
        bold: {
            name: "14qj9ca",
            styles: "color:#292A2E"
        }
    }
};
const $7af69e0951395108$var$textStyles = {
    name: "zdgrwm",
    styles: "font-family:var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);font-size:11px;font-style:normal;font-weight:var(--ds-font-weight-bold, 700);line-height:16px;overflow:hidden;text-overflow:ellipsis;text-transform:uppercase;white-space:nowrap"
};
const $7af69e0951395108$var$customLetterspacingStyles = {
    name: "gkoibw",
    styles: "letter-spacing:0.165px"
};
/**
 * __Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 *
 * - [Examples](https://atlassian.design/components/lozenge/examples)
 * - [Code](https://atlassian.design/components/lozenge/code)
 * - [Usage](https://atlassian.design/components/lozenge/usage)
 */ const $7af69e0951395108$var$Lozenge = /*#__PURE__*/ (0, $5uXOq.memo)(({ children: children, testId: testId, isBold: isBold = false, appearance: appearance = 'default', maxWidth: maxWidth = 200, style: style })=>{
    const appearanceStyle = isBold ? 'bold' : 'subtle';
    const appearanceType = appearance in $7af69e0951395108$var$styles.background[appearanceStyle] ? appearance : 'default';
    const maxWidthValue = typeof maxWidth === 'string' ? maxWidth : `${maxWidth}px`;
    const maxWidthIsPc = typeof maxWidth === 'string' && /%$/.test(maxWidth);
    if ((0, $fHpHg.fg)('platform-component-visual-refresh')) return /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        style: {
            backgroundColor: style?.backgroundColor,
            maxWidth: maxWidthIsPc ? maxWidth : '100%'
        },
        css: [
            $7af69e0951395108$var$styles.container,
            $7af69e0951395108$var$styles.background[appearanceStyle][appearanceType],
            appearanceStyle === 'subtle' && !(0, $fHpHg.fg)('visual-refresh_drop_5') && $7af69e0951395108$var$styles.border.subtle[appearanceType],
            appearanceStyle === 'subtle' && (0, $fHpHg.fg)('visual-refresh_drop_5') && $7af69e0951395108$var$styles.outline.subtle[appearanceType],
            appearanceStyle === 'subtle' && (0, $fHpHg.fg)('visual-refresh_drop_5') && $7af69e0951395108$var$styles.containerSubtle
        ],
        "data-testid": testId
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: [
            $7af69e0951395108$var$textStyles,
            (0, $fHpHg.fg)('platform-lozenge-custom-letterspacing') && $7af69e0951395108$var$customLetterspacingStyles,
            $7af69e0951395108$var$styles.text[appearanceStyle]
        ],
        style: {
            color: style?.color,
            // to negate paddingInline specified on Box above
            maxWidth: maxWidthIsPc ? '100%' : `calc(${maxWidthValue} - ${"var(--ds-space-100, 8px)"})`
        },
        "data-testid": testId && `${testId}--text`
    }, children));
    const appearanceTypeOld = appearance in $7af69e0951395108$var$backgroundColorsOld[appearanceStyle] ? appearance : 'default';
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $0yZbT.default), {
        as: "span",
        backgroundColor: $7af69e0951395108$var$backgroundColorsOld[appearanceStyle][appearanceTypeOld],
        style: {
            backgroundColor: style?.backgroundColor,
            maxWidth: maxWidthIsPc ? maxWidth : '100%'
        },
        paddingInline: "space.050",
        xcss: $7af69e0951395108$var$baseStylesOld,
        testId: testId
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: [
            $7af69e0951395108$var$textStyles,
            (0, $fHpHg.fg)('platform-lozenge-custom-letterspacing') && $7af69e0951395108$var$customLetterspacingStyles,
            $7af69e0951395108$var$textColorsOld[appearanceStyle][appearanceType]
        ],
        style: {
            color: style?.color,
            // to negate paddingInline specified on Box above
            maxWidth: maxWidthIsPc ? '100%' : `calc(${maxWidthValue} - ${"var(--ds-space-100, 8px)"})`
        },
        "data-testid": testId && `${testId}--text`
    }, children));
});
$7af69e0951395108$var$Lozenge.displayName = 'Lozenge';
var $7af69e0951395108$export$2e2bcd8739ae039 = $7af69e0951395108$var$Lozenge;
const $7af69e0951395108$var$backgroundColorsOld = {
    bold: {
        default: 'color.background.neutral.bold',
        inprogress: 'color.background.information.bold',
        moved: 'color.background.warning.bold',
        new: 'color.background.discovery.bold',
        removed: 'color.background.danger.bold',
        success: 'color.background.success.bold'
    },
    subtle: {
        default: 'color.background.neutral',
        inprogress: 'color.background.information',
        moved: 'color.background.warning',
        new: 'color.background.discovery',
        removed: 'color.background.danger',
        success: 'color.background.success'
    }
};
const $7af69e0951395108$var$textColorsOld = {
    bold: {
        default: {
            name: "1wvsb8v",
            styles: "color:var(--ds-text-inverse, #FFFFFF)"
        },
        inprogress: {
            name: "1wvsb8v",
            styles: "color:var(--ds-text-inverse, #FFFFFF)"
        },
        moved: {
            name: "tgubtb",
            styles: "color:var(--ds-text-warning-inverse, #172B4D)"
        },
        new: {
            name: "1wvsb8v",
            styles: "color:var(--ds-text-inverse, #FFFFFF)"
        },
        removed: {
            name: "1wvsb8v",
            styles: "color:var(--ds-text-inverse, #FFFFFF)"
        },
        success: {
            name: "1wvsb8v",
            styles: "color:var(--ds-text-inverse, #FFFFFF)"
        }
    },
    subtle: {
        default: {
            name: "kmxsjg",
            styles: "color:var(--ds-text-subtle, #42526E)"
        },
        inprogress: {
            name: "3j31nl",
            styles: "color:var(--ds-text-information, #0052CC)"
        },
        moved: {
            name: "1g2i1rp",
            styles: "color:var(--ds-text-warning, #974F0C)"
        },
        new: {
            name: "3juofh",
            styles: "color:var(--ds-text-discovery, #403294)"
        },
        removed: {
            name: "18zo14t",
            styles: "color:var(--ds-text-danger, #DE350B)"
        },
        success: {
            name: "1ychrch",
            styles: "color:var(--ds-text-success, #006644)"
        }
    }
};

});
parcelRegister("0yZbT", function(module, exports) {

$parcel$export(module.exports, "Box", () => $84c75eabf1687f52$export$e71c4d32a2263218);
$parcel$export(module.exports, "default", () => $84c75eabf1687f52$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $a2Xlh = parcelRequire("a2Xlh");

var $avgEF = parcelRequire("avgEF");

var $2s57o = parcelRequire("2s57o");
function $84c75eabf1687f52$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $84c75eabf1687f52$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: Component = 'div', children: children, backgroundColor: backgroundColor, padding: padding, paddingBlock: paddingBlock, paddingBlockStart: paddingBlockStart, paddingBlockEnd: paddingBlockEnd, paddingInline: paddingInline, paddingInlineStart: paddingInlineStart, paddingInlineEnd: paddingInlineEnd, style: style, testId: testId, xcss: xcss, ...htmlAttributes }, ref)=>{
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    const resolvedStyles = (0, $2s57o.parseXcss)(xcss);
    const node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    /*#__PURE__*/ (0, $f8Sb3.jsx)(Component, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        ...safeHtmlAttributes,
        css: [
            $84c75eabf1687f52$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $avgEF.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $avgEF.isSurfaceColorToken)(backgroundColor) && (0, $avgEF.surfaceColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $avgEF.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $avgEF.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $avgEF.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $avgEF.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $avgEF.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $avgEF.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $avgEF.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }, children);
    return backgroundColor ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $a2Xlh.SurfaceContext).Provider, {
        value: backgroundColor
    }, node) : node;
});
var $84c75eabf1687f52$export$2e2bcd8739ae039 = $84c75eabf1687f52$export$e71c4d32a2263218;
const $84c75eabf1687f52$var$baseStyles = {
    name: "1b8qmvl",
    styles: "box-sizing:border-box;appearance:none;border:none"
};

});
parcelRegister("2s57o", function(module, exports) {

$parcel$export(module.exports, "tokensMap", () => $b0ac67d2e8144f9b$export$9a199fbafee0014e);
$parcel$export(module.exports, "parseXcss", () => $b0ac67d2e8144f9b$export$a9c84988c8f81f2d);
$parcel$export(module.exports, "xcss", () => $b0ac67d2e8144f9b$export$f6c783d06584602c);
/* xcss.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $avgEF = parcelRequire("avgEF");

var $6cAn5 = parcelRequire("6cAn5");
const $b0ac67d2e8144f9b$export$9a199fbafee0014e = {
    backgroundColor: (0, $avgEF.backgroundColorMap),
    blockSize: (0, $avgEF.dimensionMap),
    borderBlockColor: (0, $avgEF.borderColorMap),
    borderBlockEndColor: (0, $avgEF.borderColorMap),
    borderBlockEndWidth: (0, $avgEF.borderWidthMap),
    borderBlockStartColor: (0, $avgEF.borderColorMap),
    borderBlockStartWidth: (0, $avgEF.borderWidthMap),
    borderBlockWidth: (0, $avgEF.borderWidthMap),
    borderBottomColor: (0, $avgEF.borderColorMap),
    borderBottomLeftRadius: (0, $avgEF.borderRadiusMap),
    borderBottomRightRadius: (0, $avgEF.borderRadiusMap),
    borderBottomWidth: (0, $avgEF.borderWidthMap),
    borderColor: (0, $avgEF.borderColorMap),
    borderEndEndRadius: (0, $avgEF.borderRadiusMap),
    borderEndStartRadius: (0, $avgEF.borderRadiusMap),
    borderInlineColor: (0, $avgEF.borderColorMap),
    borderInlineEndColor: (0, $avgEF.borderColorMap),
    borderInlineEndWidth: (0, $avgEF.borderWidthMap),
    borderInlineStartColor: (0, $avgEF.borderColorMap),
    borderInlineStartWidth: (0, $avgEF.borderWidthMap),
    borderInlineWidth: (0, $avgEF.borderWidthMap),
    borderLeftColor: (0, $avgEF.borderColorMap),
    borderLeftWidth: (0, $avgEF.borderWidthMap),
    borderRadius: (0, $avgEF.borderRadiusMap),
    borderRightColor: (0, $avgEF.borderColorMap),
    borderRightWidth: (0, $avgEF.borderWidthMap),
    borderStartEndRadius: (0, $avgEF.borderRadiusMap),
    borderStartStartRadius: (0, $avgEF.borderRadiusMap),
    borderTopColor: (0, $avgEF.borderColorMap),
    borderTopLeftRadius: (0, $avgEF.borderRadiusMap),
    borderTopRightRadius: (0, $avgEF.borderRadiusMap),
    borderTopWidth: (0, $avgEF.borderWidthMap),
    borderWidth: (0, $avgEF.borderWidthMap),
    bottom: (0, $avgEF.allSpaceMap),
    boxShadow: (0, $avgEF.shadowMap),
    color: (0, $avgEF.textColorMap),
    columnGap: (0, $avgEF.positiveSpaceMap),
    font: (0, $avgEF.fontMap),
    fontFamily: (0, $avgEF.fontFamilyMap),
    fontWeight: (0, $avgEF.fontWeightMap),
    gap: (0, $avgEF.positiveSpaceMap),
    height: (0, $avgEF.dimensionMap),
    inlineSize: (0, $avgEF.dimensionMap),
    inset: (0, $avgEF.allSpaceMap),
    insetBlock: (0, $avgEF.allSpaceMap),
    insetBlockEnd: (0, $avgEF.allSpaceMap),
    insetBlockStart: (0, $avgEF.allSpaceMap),
    insetInline: (0, $avgEF.allSpaceMap),
    insetInlineEnd: (0, $avgEF.allSpaceMap),
    insetInlineStart: (0, $avgEF.allSpaceMap),
    left: (0, $avgEF.allSpaceMap),
    margin: (0, $avgEF.allSpaceMap),
    marginBlock: (0, $avgEF.allSpaceMap),
    marginBlockEnd: (0, $avgEF.allSpaceMap),
    marginBlockStart: (0, $avgEF.allSpaceMap),
    marginBottom: (0, $avgEF.allSpaceMap),
    marginInline: (0, $avgEF.allSpaceMap),
    marginInlineEnd: (0, $avgEF.allSpaceMap),
    marginInlineStart: (0, $avgEF.allSpaceMap),
    marginLeft: (0, $avgEF.allSpaceMap),
    marginRight: (0, $avgEF.allSpaceMap),
    marginTop: (0, $avgEF.allSpaceMap),
    maxBlockSize: (0, $avgEF.dimensionMap),
    maxHeight: (0, $avgEF.dimensionMap),
    maxInlineSize: (0, $avgEF.dimensionMap),
    maxWidth: (0, $avgEF.dimensionMap),
    minBlockSize: (0, $avgEF.dimensionMap),
    minHeight: (0, $avgEF.dimensionMap),
    minInlineSize: (0, $avgEF.dimensionMap),
    minWidth: (0, $avgEF.dimensionMap),
    opacity: (0, $avgEF.opacityMap),
    outlineColor: (0, $avgEF.borderColorMap),
    outlineOffset: (0, $avgEF.allSpaceMap),
    outlineWidth: (0, $avgEF.borderWidthMap),
    padding: (0, $avgEF.positiveSpaceMap),
    paddingBlock: (0, $avgEF.positiveSpaceMap),
    paddingBlockEnd: (0, $avgEF.positiveSpaceMap),
    paddingBlockStart: (0, $avgEF.positiveSpaceMap),
    paddingBottom: (0, $avgEF.positiveSpaceMap),
    paddingInline: (0, $avgEF.positiveSpaceMap),
    paddingInlineEnd: (0, $avgEF.positiveSpaceMap),
    paddingInlineStart: (0, $avgEF.positiveSpaceMap),
    paddingLeft: (0, $avgEF.positiveSpaceMap),
    paddingRight: (0, $avgEF.positiveSpaceMap),
    paddingTop: (0, $avgEF.positiveSpaceMap),
    right: (0, $avgEF.allSpaceMap),
    rowGap: (0, $avgEF.positiveSpaceMap),
    top: (0, $avgEF.allSpaceMap),
    width: (0, $avgEF.dimensionMap),
    zIndex: (0, $avgEF.layerMap)
};
const $b0ac67d2e8144f9b$var$uniqueSymbol = Symbol('UNSAFE_INTERNAL_styles');
const $b0ac67d2e8144f9b$var$isSafeEnvToThrow = ()=>typeof $6cAn5 === 'object' && typeof $6cAn5.env === 'object' && false;
const $b0ac67d2e8144f9b$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
const $b0ac67d2e8144f9b$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
const $b0ac67d2e8144f9b$var$transformStyles = (styleObj)=>{
    if (!styleObj || typeof styleObj !== 'object') return styleObj;
     // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map($b0ac67d2e8144f9b$var$transformStyles);
     // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(([key, value])=>{
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if (typeof value === 'object' && $b0ac67d2e8144f9b$var$safeSelectors.test(key)) {
            styleObj[key] = $b0ac67d2e8144f9b$var$transformStyles(value);
            return;
        }
        if ($b0ac67d2e8144f9b$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($b0ac67d2e8144f9b$var$reNestedSelectors.test(key)) throw new Error(`Styles not supported for key '${key}'.`);
        } // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $b0ac67d2e8144f9b$export$9a199fbafee0014e)) return;
        const tokenValue = $b0ac67d2e8144f9b$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue ?? value;
    });
    return styleObj;
};
const $b0ac67d2e8144f9b$var$baseXcss = (style)=>{
    const transformedStyles = $b0ac67d2e8144f9b$var$transformStyles(style);
    return {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [$b0ac67d2e8144f9b$var$uniqueSymbol]: /*#__PURE__*/ (0, $f8Sb3.css)(transformedStyles)
    };
}; /**
    * Picks out runtime XCSS objects and build-time XCSS strings. This is needed
    * to supported both Emotion and Compiled styles until we've fully migrated
    * to Compiled.
    *
    * @private
    * @deprecated
    */ 
const $b0ac67d2e8144f9b$export$a9c84988c8f81f2d = (args)=>{
    if (Array.isArray(args)) {
        const emotion = [];
        const staticArr = [];
        for (const arg of args){
            const result = $b0ac67d2e8144f9b$export$a9c84988c8f81f2d(arg);
            if (result.emotion) emotion.push(...result.emotion);
            if (result.static) staticArr.push(result.static);
        }
        return {
            emotion: emotion,
            static: staticArr.join(' ')
        };
    }
    const objArgs = args;
    const { [$b0ac67d2e8144f9b$var$uniqueSymbol]: styles } = objArgs || {};
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        const stringifiedArgs = `${args}`;
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $b0ac67d2e8144f9b$export$f6c783d06584602c(style) {
    return $b0ac67d2e8144f9b$var$baseXcss(style);
}

});




parcelRegister("eGeCO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d4ce7dd41e05f3ded01848e6f06d1f7d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ab00552c9a43c3a3$var$_react = $ab00552c9a43c3a3$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $ab00552c9a43c3a3$var$_peopleGroup = $ab00552c9a43c3a3$var$_interopRequireDefault((parcelRequire("gfxSS")));

var $ab00552c9a43c3a3$var$_peopleGroup2 = $ab00552c9a43c3a3$var$_interopRequireDefault((parcelRequire("3lyRn")));
function $ab00552c9a43c3a3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for PeopleGroupIcon.
 * This component is PeopleGroupIcon, with `UNSAFE_fallbackIcon` set to "PeopleGroupIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a group or collection of people or users.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ab00552c9a43c3a3$var$PeopleGroupIcon = (props)=>/*#__PURE__*/ $ab00552c9a43c3a3$var$_react.default.createElement($ab00552c9a43c3a3$var$_peopleGroup.default, Object.assign({
        LEGACY_fallbackIcon: $ab00552c9a43c3a3$var$_peopleGroup2.default
    }, props));
$ab00552c9a43c3a3$var$PeopleGroupIcon.Name = 'PeopleGroupIconMigration';
var $ab00552c9a43c3a3$var$_default = module.exports.default = $ab00552c9a43c3a3$var$PeopleGroupIcon;

});
parcelRegister("gfxSS", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8bbccaea74398c387e69395dfeae5f34>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bd4854ba5b4e7d17$var$_react = $bd4854ba5b4e7d17$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $bd4854ba5b4e7d17$var$_baseNew = $bd4854ba5b4e7d17$var$_interopRequireDefault((parcelRequire("enEmH")));
function $bd4854ba5b4e7d17$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PeopleGroup".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a group or collection of people or users.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bd4854ba5b4e7d17$var$PeopleGroupIcon = (props)=>/*#__PURE__*/ $bd4854ba5b4e7d17$var$_react.default.createElement($bd4854ba5b4e7d17$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M9 4.5a2 2 0 1 1 4 0 2 2 0 0 1-4 0M11 1a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7M3 5.5a1 1 0 1 1 2 0 1 1 0 0 1-2 0M4 3a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M2.625 9A2.625 2.625 0 0 0 0 11.625V13h1.5v-1.375c0-.621.504-1.125 1.125-1.125H5V9zM6 12.5A3.5 3.5 0 0 1 9.5 9h3a3.5 3.5 0 0 1 3.5 3.5V14h-1.5v-1.5a2 2 0 0 0-2-2h-3a2 2 0 0 0-2 2V14H6z" clip-rule="evenodd"/>`
    }, props));
$bd4854ba5b4e7d17$var$PeopleGroupIcon.displayName = 'PeopleGroupIcon';
var $bd4854ba5b4e7d17$var$_default = module.exports.default = $bd4854ba5b4e7d17$var$PeopleGroupIcon;

});

parcelRegister("3lyRn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $26fe5fbcb2ef0fcc$var$_react = $26fe5fbcb2ef0fcc$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $26fe5fbcb2ef0fcc$var$_peopleGroup = $26fe5fbcb2ef0fcc$var$_interopRequireDefault((parcelRequire("gfxSS")));
function $26fe5fbcb2ef0fcc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $26fe5fbcb2ef0fcc$var$PeopleGroupIcon = (props)=>/*#__PURE__*/ $26fe5fbcb2ef0fcc$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M8.13 10H4a2 2 0 0 0-2 2v3.73c0 1.31 1.87 2.05 4 2.23V15a3 3 0 0 1 3-3h.35a4 4 0 0 1-1.23-2m7.75 0H20c1.11 0 2 .89 2 2v3.73c0 1.31-1.87 2.05-4 2.23V15a3 3 0 0 0-3-3h-.35a4 4 0 0 0 1.23-2M9.97 5.55a3 3 0 1 0-1.96 3.27 4 4 0 0 1 1.96-3.27M16 8.83a3 3 0 1 0-1.96-3.28A4 4 0 0 1 16 8.83"/><path d="M7 15c0-1.105.887-2 2-2h6c1.105 0 2 .885 2 2v3.73c0 3.027-10 3.027-10 0z"/><circle cx="12" cy="9" r="3"/></g></svg>`
    }, props, {
        newIcon: $26fe5fbcb2ef0fcc$var$_peopleGroup.default
    }));
$26fe5fbcb2ef0fcc$var$PeopleGroupIcon.displayName = 'PeopleGroupIcon';
var $26fe5fbcb2ef0fcc$var$_default = module.exports.default = $26fe5fbcb2ef0fcc$var$PeopleGroupIcon;

});


parcelRegister("39fIG", function(module, exports) {

$parcel$export(module.exports, "JiraIcon", () => $64ca0264123efe08$export$c4b5b1f965d8b3eb);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $6VxGE = parcelRequire("6VxGE");

var $kpt43 = parcelRequire("kpt43");

var $2uZGe = parcelRequire("2uZGe");

var $j62qJ = parcelRequire("j62qJ");
const $64ca0264123efe08$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $2uZGe.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M11.034 21.99h-2.22c-3.346 0-5.747-2.05-5.747-5.052h11.932c.619 0 1.019.44 1.019 1.062v12.007c-2.983 0-4.984-2.416-4.984-5.784zm5.893-5.967h-2.219c-3.347 0-5.748-2.013-5.748-5.015h11.933c.618 0 1.055.402 1.055 1.025V24.04c-2.983 0-5.02-2.416-5.02-5.784zm5.93-5.93h-2.219c-3.347 0-5.748-2.05-5.748-5.052h11.933c.618 0 1.018.439 1.018 1.025v12.007c-2.983 0-4.984-2.416-4.984-5.784z"/>
    </svg>`;
};
const $64ca0264123efe08$export$c4b5b1f965d8b3eb = ({ appearance: appearance, label: label = 'Jira', size: size = (0, $kpt43.defaultLogoParams).size, testId: testId, textColor: textColor = (0, $kpt43.defaultLogoParams).textColor, iconColor: iconColor = (0, $kpt43.defaultLogoParams).iconColor })=>{
    const { colorMode: colorMode } = (0, $6VxGE.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $j62qJ.default), {
        appearance: appearance,
        label: label,
        svg: $64ca0264123efe08$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});
parcelRegister("6VxGE", function(module, exports) {

$parcel$export(module.exports, "default", () => $e153d0d7e5fab62f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8dUOv = parcelRequire("8dUOv");

var $griCX = parcelRequire("griCX");
/**
 * A React hook which returns the current themes and color-mode set on `<html>`.
 *
 * @example
 * ```
 * const { colorMode, dark, light, spacing, typography } = useThemeObserver();
 *
 * // Performing side effects when it changes
 * useEffect(() => {
 *   console.log(`The color mode has changed to ${theme.colorMode}`);
 * }, [theme.colorMode]);
 * ```
 */ const $e153d0d7e5fab62f$var$useThemeObserver = ()=>{
    const [theme, setTheme] = (0, $5uXOq.useState)((0, $8dUOv.default)());
    (0, $5uXOq.useEffect)(()=>{
        const observer = new (0, $griCX.default)((theme)=>setTheme(theme));
        observer.observe();
        return ()=>observer.disconnect();
    }, []);
    return theme;
};
var $e153d0d7e5fab62f$export$2e2bcd8739ae039 = $e153d0d7e5fab62f$var$useThemeObserver;

});
parcelRegister("8dUOv", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b432b479a32486c$export$2e2bcd8739ae039);

var $d5aOx = parcelRequire("d5aOx");

var $g0l9Y = parcelRequire("g0l9Y");

var $6nvuU = parcelRequire("6nvuU");
const $5b432b479a32486c$var$isThemeColorMode = (colorMode)=>{
    return (0, $g0l9Y.themeColorModes).find((mode)=>mode === colorMode) !== undefined;
};
const $5b432b479a32486c$var$getGlobalTheme = ()=>{
    if (typeof document === 'undefined') return {};
    const element = document.documentElement;
    const colorMode = element.getAttribute((0, $d5aOx.COLOR_MODE_ATTRIBUTE)) || '';
    const theme = element.getAttribute((0, $d5aOx.THEME_DATA_ATTRIBUTE)) || '';
    return {
        ...(0, $6nvuU.themeStringToObject)(theme),
        ...$5b432b479a32486c$var$isThemeColorMode(colorMode) && {
            colorMode: colorMode
        }
    };
};
var $5b432b479a32486c$export$2e2bcd8739ae039 = $5b432b479a32486c$var$getGlobalTheme;

});
parcelRegister("g0l9Y", function(module, exports) {

$parcel$export(module.exports, "themeColorModes", () => $d77aed2160d1b668$export$83993de8eb66733);
$parcel$export(module.exports, "themeIds", () => $d77aed2160d1b668$export$7d43e72a58e3283f);
$parcel$export(module.exports, "themeIdsWithOverrides", () => $d77aed2160d1b668$export$92ba366331403db2);
$parcel$export(module.exports, "themeStateDefaults", () => $d77aed2160d1b668$export$9aedcfa7336a207);
$parcel$export(module.exports, "default", () => $d77aed2160d1b668$export$2e2bcd8739ae039);

var $fHpHg = parcelRequire("fHpHg");
const $d77aed2160d1b668$export$83993de8eb66733 = [
    'light',
    'dark',
    'auto'
];
/**
 * Contrast preferences: The system contrast preference
 */ const $d77aed2160d1b668$var$themeContrastModes = [
    'more',
    'no-preference',
    'auto'
];
const $d77aed2160d1b668$export$7d43e72a58e3283f = [
    'light-increased-contrast',
    'light',
    'light-future',
    'light-brand-refresh',
    'dark',
    'dark-future',
    'dark-increased-contrast',
    'dark-brand-refresh',
    'legacy-light',
    'legacy-dark',
    'spacing',
    'shape',
    'typography-adg3',
    'typography-modernized',
    'typography-refreshed'
];
/**
 * Theme override ids: the equivalent of themeIds for theme overrides.
 * Theme overrides are temporary and there may not be any defined at times.
 */ const $d77aed2160d1b668$var$themeOverrideIds = [];
const $d77aed2160d1b668$export$92ba366331403db2 = [
    ...$d77aed2160d1b668$export$7d43e72a58e3283f,
    ...$d77aed2160d1b668$var$themeOverrideIds
];
const $d77aed2160d1b668$var$themeConfig = {
    'atlassian-light': {
        id: 'light',
        displayName: 'Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        }
    },
    'atlassian-light-future': {
        id: 'light-future',
        displayName: 'Future Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        override: 'light'
    },
    'atlassian-light-increased-contrast': {
        id: 'light-increased-contrast',
        displayName: 'Light Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        extends: 'light',
        increasesContrastFor: 'light'
    },
    'atlassian-dark': {
        id: 'dark',
        displayName: 'Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        }
    },
    'atlassian-dark-future': {
        id: 'dark-future',
        displayName: 'Future Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        override: 'light'
    },
    'atlassian-dark-increased-contrast': {
        id: 'dark-increased-contrast',
        displayName: 'Dark Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        extends: 'dark',
        increasesContrastFor: 'dark'
    },
    'atlassian-legacy-light': {
        id: 'legacy-light',
        displayName: 'Light Theme (legacy)',
        palette: 'legacyPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        }
    },
    'atlassian-legacy-dark': {
        id: 'legacy-dark',
        displayName: 'Dark Theme (legacy)',
        palette: 'legacyPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        }
    },
    'atlassian-spacing': {
        id: 'spacing',
        displayName: 'Atlassian Spacing',
        palette: 'spacingScale',
        attributes: {
            type: 'spacing'
        }
    },
    'atlassian-typography-adg3': {
        id: 'typography-adg3',
        displayName: 'ADG3 Typography',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        }
    },
    'atlassian-shape': {
        id: 'shape',
        displayName: 'Atlassian Shape',
        palette: 'shapePalette',
        attributes: {
            type: 'shape'
        }
    },
    'atlassian-typography-modernized': {
        id: 'typography-modernized',
        displayName: 'Atlassian Typography (Modernized)',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        }
    },
    'atlassian-typography-refreshed': {
        id: 'typography-refreshed',
        displayName: 'Atlassian Typography (Refreshed)',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        }
    },
    'atlassian-light-brand-refresh': {
        id: 'light-brand-refresh',
        displayName: 'Light theme (Brand refresh)',
        palette: 'brandRefreshPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        }
    },
    'atlassian-dark-brand-refresh': {
        id: 'dark-brand-refresh',
        displayName: 'Dark theme (Brand refresh)',
        palette: 'brandRefreshPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        }
    }
};
const $d77aed2160d1b668$export$9aedcfa7336a207 = {
    colorMode: 'auto',
    contrastMode: 'auto',
    dark: 'dark',
    light: 'light',
    shape: undefined,
    spacing: 'spacing',
    typography: ()=>{
        if ((0, $fHpHg.fg)('platform-default-typography-modernized')) return 'typography-modernized';
        return undefined;
    },
    UNSAFE_themeOptions: undefined
};
var $d77aed2160d1b668$export$2e2bcd8739ae039 = $d77aed2160d1b668$var$themeConfig;

});

parcelRegister("6nvuU", function(module, exports) {

$parcel$export(module.exports, "themeStringToObject", () => $bff57aefbcac20ef$export$f19b488f7c0547ee);
$parcel$export(module.exports, "themeObjectToString", () => $bff57aefbcac20ef$export$62c37ab81302621a);

var $g0l9Y = parcelRequire("g0l9Y");
const $bff57aefbcac20ef$var$themeKinds = [
    'light',
    'dark',
    'spacing',
    'typography',
    'shape'
];
const $bff57aefbcac20ef$var$customThemeOptions = 'UNSAFE_themeOptions';
const $bff57aefbcac20ef$var$isThemeKind = (themeKind)=>{
    return $bff57aefbcac20ef$var$themeKinds.find((kind)=>kind === themeKind) !== undefined;
};
const $bff57aefbcac20ef$var$isThemeIds = (themeId)=>{
    return (0, $g0l9Y.themeIds).find((id)=>id === themeId) !== undefined;
};
const $bff57aefbcac20ef$var$isColorMode = (modeId)=>{
    return [
        'light',
        'dark',
        'auto'
    ].includes(modeId);
};
const $bff57aefbcac20ef$export$f19b488f7c0547ee = (themeState)=>{
    return themeState.split(' ').map((theme)=>theme.split(/:(.*)/s)).reduce((themeObject, [kind, id])=>{
        if (kind === 'colorMode' && $bff57aefbcac20ef$var$isColorMode(id)) themeObject[kind] = id;
        if ($bff57aefbcac20ef$var$isThemeKind(kind) && $bff57aefbcac20ef$var$isThemeIds(id)) // @ts-expect-error FIXME - this is a valid ts error
        themeObject[kind] = id;
        if (kind === $bff57aefbcac20ef$var$customThemeOptions) try {
            themeObject[$bff57aefbcac20ef$var$customThemeOptions] = JSON.parse(id);
        } catch (e) {
            new Error('Invalid custom theme string');
        }
        return themeObject;
    }, {});
};
const $bff57aefbcac20ef$export$62c37ab81302621a = (themeState)=>Object.entries(themeState).reduce((themeString, [kind, id])=>{
        if (// colorMode theme state
        kind === 'colorMode' && typeof id === 'string' && $bff57aefbcac20ef$var$isColorMode(id) || // custom theme state
        kind === $bff57aefbcac20ef$var$customThemeOptions && typeof id === 'object' || // other theme states
        $bff57aefbcac20ef$var$isThemeKind(kind) && typeof id === 'string' && $bff57aefbcac20ef$var$isThemeIds(id)) return themeString + `${themeString ? ' ' : ''}` + `${kind}:${typeof id === 'object' ? JSON.stringify(id) : id}`;
        return themeString;
    }, '');

});


parcelRegister("griCX", function(module, exports) {

$parcel$export(module.exports, "default", () => $22ab7fa399223d4e$export$2e2bcd8739ae039);

var $d5aOx = parcelRequire("d5aOx");

var $8dUOv = parcelRequire("8dUOv");
class $22ab7fa399223d4e$export$2e2bcd8739ae039 {
    static{
        this.observer = null;
    }
    static{
        this.callbacks = new Set();
    }
    constructor(callback){
        this.legacyObserver = null;
        this.callback = callback;
        $22ab7fa399223d4e$export$2e2bcd8739ae039.callbacks.add(callback);
    }
    observe() {
        if (!$22ab7fa399223d4e$export$2e2bcd8739ae039.observer) {
            $22ab7fa399223d4e$export$2e2bcd8739ae039.observer = new MutationObserver(()=>{
                const theme = (0, $8dUOv.default)();
                $22ab7fa399223d4e$export$2e2bcd8739ae039.callbacks.forEach((callback)=>callback(theme));
            });
            // Observer only needs to be configured once
            $22ab7fa399223d4e$export$2e2bcd8739ae039.observer.observe(document.documentElement, {
                attributeFilter: [
                    (0, $d5aOx.THEME_DATA_ATTRIBUTE),
                    (0, $d5aOx.COLOR_MODE_ATTRIBUTE)
                ]
            });
        }
    }
    disconnect() {
        if (this.callback) $22ab7fa399223d4e$export$2e2bcd8739ae039.callbacks.delete(this.callback);
        if ($22ab7fa399223d4e$export$2e2bcd8739ae039.callbacks.size === 0 && $22ab7fa399223d4e$export$2e2bcd8739ae039.observer) {
            $22ab7fa399223d4e$export$2e2bcd8739ae039.observer.disconnect();
            $22ab7fa399223d4e$export$2e2bcd8739ae039.observer = null;
        }
    }
}

});


parcelRegister("kpt43", function(module, exports) {

$parcel$export(module.exports, "defaultLogoParams", () => $26687436df4dd607$export$438460117ae6b7ee);
$parcel$export(module.exports, "legacyDefaultLogoParams", () => $26687436df4dd607$export$793fba32aed8942a);
const $26687436df4dd607$export$438460117ae6b7ee = {
    iconColor: 'inherit',
    label: '',
    size: 'medium',
    textColor: 'currentColor'
};
const $26687436df4dd607$export$793fba32aed8942a = {
    iconGradientStart: 'inherit',
    iconGradientStop: 'inherit'
};
const $26687436df4dd607$export$31d7044b7540a6d8 = $26687436df4dd607$export$438460117ae6b7ee;

});

parcelRegister("2uZGe", function(module, exports) {

$parcel$export(module.exports, "getColorsFromAppearanceOldLogos", () => $ae40e434cb1632e8$export$362a25f017e2bc8a);
$parcel$export(module.exports, "getColorsFromAppearance", () => $ae40e434cb1632e8$export$bbacc3980e0f3029);
$parcel$export(module.exports, "getColorsForLoom", () => $ae40e434cb1632e8$export$7818df200941dbbf);

const $ae40e434cb1632e8$export$362a25f017e2bc8a = (appearance, colorMode)=>{
    let iconGradientStart, iconGradientStop, iconColor, textColor, atlassianLogoTextColor;
    switch(appearance){
        case 'brand':
            iconGradientStart = (0, $a7f8c6b391092279$export$b3de0ae08da2ce64);
            iconGradientStop = (0, $a7f8c6b391092279$export$215b7063051591f1);
            iconColor = (0, $a7f8c6b391092279$export$215b7063051591f1);
            textColor = `var(--ds-text, ${0, $a7f8c6b391092279$export$7d61b15e0da132af})`;
            // This is only used for the top level Atlassian wordmark (see AtlassianLogo
            // or AtlassianStartLogo for example), and is only different for the Brand
            // appearance - a bold brand color. For other appearances,
            // atlassianLogoTextColor is the same as textColor.
            atlassianLogoTextColor = (0, $a7f8c6b391092279$export$b3de0ae08da2ce64);
            break;
        case 'neutral':
            iconGradientStart = (0, $a7f8c6b391092279$export$7090862dc3038a9f);
            iconGradientStop = (0, $a7f8c6b391092279$export$d6447c357493214f);
            iconColor = (0, $a7f8c6b391092279$export$d6447c357493214f);
            textColor = (0, $a7f8c6b391092279$export$eece5f492e429f08);
            atlassianLogoTextColor = (0, $a7f8c6b391092279$export$eece5f492e429f08);
            break;
        case 'inverse':
            iconGradientStart = '#FFFFFF66';
            iconGradientStop = '#FFFFFF';
            iconColor = '#FFFFFF';
            textColor = '#FFFFFF';
            atlassianLogoTextColor = '#FFFFFF';
            break;
    }
    if (colorMode === 'dark' && appearance === 'inverse') {
        iconGradientStart = '#161A1D66';
        iconGradientStop = '#161A1D';
        iconColor = '#161A1D';
        textColor = '#161A1D';
        atlassianLogoTextColor = '#161A1D';
    }
    return {
        iconGradientStart: iconGradientStart,
        iconGradientStop: iconGradientStop,
        iconColor: iconColor,
        textColor: textColor,
        atlassianLogoTextColor: atlassianLogoTextColor
    };
};
const $ae40e434cb1632e8$export$bbacc3980e0f3029 = (appearance, colorMode)=>{
    let iconColor, textColor, atlassianLogoTextColor;
    if (colorMode === 'dark') switch(appearance){
        case 'brand':
            iconColor = '#357DE8';
            textColor = '#E2E3E4';
            atlassianLogoTextColor = '#357DE8';
            break;
        case 'neutral':
            iconColor = '#96999E';
            textColor = '#BFC1C4';
            atlassianLogoTextColor = '#96999E';
            break;
        case 'inverse':
            iconColor = '#101214';
            textColor = '#101214';
            atlassianLogoTextColor = '#101214';
            break;
    }
    else switch(appearance){
        case 'brand':
            iconColor = '#1868DB';
            textColor = '#101214';
            atlassianLogoTextColor = '#1868DB';
            break;
        case 'neutral':
            iconColor = '#6C6F77';
            textColor = '#3B3D42';
            atlassianLogoTextColor = '#6C6F77';
            break;
        case 'inverse':
            iconColor = (0, $a7f8c6b391092279$export$29a4f05edc054374);
            textColor = (0, $a7f8c6b391092279$export$29a4f05edc054374);
            atlassianLogoTextColor = (0, $a7f8c6b391092279$export$29a4f05edc054374);
            break;
    }
    return {
        iconColor: iconColor,
        textColor: textColor,
        atlassianLogoTextColor: atlassianLogoTextColor
    };
};
const $ae40e434cb1632e8$export$7818df200941dbbf = (appearance, colorMode)=>{
    let iconColor = $ae40e434cb1632e8$export$bbacc3980e0f3029(appearance, colorMode).iconColor;
    let textColor = $ae40e434cb1632e8$export$bbacc3980e0f3029(appearance, colorMode).textColor;
    if (colorMode === 'dark') switch(appearance){
        case 'brand':
            iconColor = '#625DF5';
            textColor = '#EFF0FF';
            break;
    }
    else switch(appearance){
        case 'brand':
            iconColor = '#625DF5';
            textColor = '#252434';
            break;
    }
    return {
        iconColor: iconColor,
        textColor: textColor
    };
};

});
var $a7f8c6b391092279$exports = {};

$parcel$export($a7f8c6b391092279$exports, "R50", () => $a7f8c6b391092279$export$4b84fd0e2c617bd);
$parcel$export($a7f8c6b391092279$exports, "R75", () => $a7f8c6b391092279$export$b34b069eff244586);
$parcel$export($a7f8c6b391092279$exports, "R100", () => $a7f8c6b391092279$export$be802dd0d8b57f35);
$parcel$export($a7f8c6b391092279$exports, "R200", () => $a7f8c6b391092279$export$60847d42f9da92a6);
$parcel$export($a7f8c6b391092279$exports, "R300", () => $a7f8c6b391092279$export$4a7404f376229999);
$parcel$export($a7f8c6b391092279$exports, "R400", () => $a7f8c6b391092279$export$2010d0fb4295b346);
$parcel$export($a7f8c6b391092279$exports, "R500", () => $a7f8c6b391092279$export$2837b5a1a71d5c02);
$parcel$export($a7f8c6b391092279$exports, "Y50", () => $a7f8c6b391092279$export$8d9596b529bbb9cf);
$parcel$export($a7f8c6b391092279$exports, "Y75", () => $a7f8c6b391092279$export$41060a744ab0b7ae);
$parcel$export($a7f8c6b391092279$exports, "Y100", () => $a7f8c6b391092279$export$1cc05bbbf340e559);
$parcel$export($a7f8c6b391092279$exports, "Y200", () => $a7f8c6b391092279$export$5aae31392d72caaa);
$parcel$export($a7f8c6b391092279$exports, "Y300", () => $a7f8c6b391092279$export$c6930421db9fa514);
$parcel$export($a7f8c6b391092279$exports, "Y400", () => $a7f8c6b391092279$export$59619663aa6500fb);
$parcel$export($a7f8c6b391092279$exports, "Y500", () => $a7f8c6b391092279$export$874739ea9e379ab6);
$parcel$export($a7f8c6b391092279$exports, "G50", () => $a7f8c6b391092279$export$8a6341c32b6a3ee6);
$parcel$export($a7f8c6b391092279$exports, "G75", () => $a7f8c6b391092279$export$69a3bf21b9686c2b);
$parcel$export($a7f8c6b391092279$exports, "G100", () => $a7f8c6b391092279$export$afbce1382ec95f73);
$parcel$export($a7f8c6b391092279$exports, "G200", () => $a7f8c6b391092279$export$747d86715d4175de);
$parcel$export($a7f8c6b391092279$exports, "G300", () => $a7f8c6b391092279$export$940e1f69e873f202);
$parcel$export($a7f8c6b391092279$exports, "G400", () => $a7f8c6b391092279$export$a49394138f7b8e85);
$parcel$export($a7f8c6b391092279$exports, "G500", () => $a7f8c6b391092279$export$6fa04827ac68a4fb);
$parcel$export($a7f8c6b391092279$exports, "B50", () => $a7f8c6b391092279$export$226de0355ed012f8);
$parcel$export($a7f8c6b391092279$exports, "B75", () => $a7f8c6b391092279$export$8c13c2ee36917869);
$parcel$export($a7f8c6b391092279$exports, "B100", () => $a7f8c6b391092279$export$ecfc1dff386a3e7a);
$parcel$export($a7f8c6b391092279$exports, "B200", () => $a7f8c6b391092279$export$215b7063051591f1);
$parcel$export($a7f8c6b391092279$exports, "B300", () => $a7f8c6b391092279$export$e62e8919cca44969);
$parcel$export($a7f8c6b391092279$exports, "B400", () => $a7f8c6b391092279$export$b3de0ae08da2ce64);
$parcel$export($a7f8c6b391092279$exports, "B500", () => $a7f8c6b391092279$export$a6ee3d71bc067634);
$parcel$export($a7f8c6b391092279$exports, "B600", () => $a7f8c6b391092279$export$67f15409e87642a1);
$parcel$export($a7f8c6b391092279$exports, "B700", () => $a7f8c6b391092279$export$f0539dbc42dbb067);
$parcel$export($a7f8c6b391092279$exports, "P50", () => $a7f8c6b391092279$export$363e4475840015bb);
$parcel$export($a7f8c6b391092279$exports, "P75", () => $a7f8c6b391092279$export$4b0a4417ed59760f);
$parcel$export($a7f8c6b391092279$exports, "P100", () => $a7f8c6b391092279$export$6011520a64d9a187);
$parcel$export($a7f8c6b391092279$exports, "P200", () => $a7f8c6b391092279$export$a7175d4e9206bc80);
$parcel$export($a7f8c6b391092279$exports, "P300", () => $a7f8c6b391092279$export$b48405b95304b5a1);
$parcel$export($a7f8c6b391092279$exports, "P400", () => $a7f8c6b391092279$export$c71e4279dd54a18d);
$parcel$export($a7f8c6b391092279$exports, "P500", () => $a7f8c6b391092279$export$147899de772240ec);
$parcel$export($a7f8c6b391092279$exports, "T50", () => $a7f8c6b391092279$export$2cf711fe14c66f06);
$parcel$export($a7f8c6b391092279$exports, "T75", () => $a7f8c6b391092279$export$7a8f4d33f6f9772c);
$parcel$export($a7f8c6b391092279$exports, "T100", () => $a7f8c6b391092279$export$776c9c497ef08533);
$parcel$export($a7f8c6b391092279$exports, "T200", () => $a7f8c6b391092279$export$69cb3ca10c1e330e);
$parcel$export($a7f8c6b391092279$exports, "T300", () => $a7f8c6b391092279$export$9dc1ef0f3f48059b);
$parcel$export($a7f8c6b391092279$exports, "T400", () => $a7f8c6b391092279$export$7c835c78b6fcdef8);
$parcel$export($a7f8c6b391092279$exports, "T500", () => $a7f8c6b391092279$export$6036577f95c3877e);
$parcel$export($a7f8c6b391092279$exports, "N0", () => $a7f8c6b391092279$export$29a4f05edc054374);
$parcel$export($a7f8c6b391092279$exports, "N10", () => $a7f8c6b391092279$export$e655ef011c4aa1a2);
$parcel$export($a7f8c6b391092279$exports, "N20", () => $a7f8c6b391092279$export$9fdfb749e33cdf97);
$parcel$export($a7f8c6b391092279$exports, "N30", () => $a7f8c6b391092279$export$3e51e8f1440314ba);
$parcel$export($a7f8c6b391092279$exports, "N40", () => $a7f8c6b391092279$export$1ce2d1575d444ceb);
$parcel$export($a7f8c6b391092279$exports, "N50", () => $a7f8c6b391092279$export$8754fc7e6d8b3000);
$parcel$export($a7f8c6b391092279$exports, "N60", () => $a7f8c6b391092279$export$c2e91cbeada39b8b);
$parcel$export($a7f8c6b391092279$exports, "N70", () => $a7f8c6b391092279$export$5f71e19f3a7ad9de);
$parcel$export($a7f8c6b391092279$exports, "N80", () => $a7f8c6b391092279$export$eaa8c8a70ac22806);
$parcel$export($a7f8c6b391092279$exports, "N90", () => $a7f8c6b391092279$export$7c87d337fb91a97d);
$parcel$export($a7f8c6b391092279$exports, "N100", () => $a7f8c6b391092279$export$d6447c357493214f);
$parcel$export($a7f8c6b391092279$exports, "N200", () => $a7f8c6b391092279$export$f563ee71e9ee74cd);
$parcel$export($a7f8c6b391092279$exports, "N300", () => $a7f8c6b391092279$export$e2ef2124cf4024b1);
$parcel$export($a7f8c6b391092279$exports, "N400", () => $a7f8c6b391092279$export$eece5f492e429f08);
$parcel$export($a7f8c6b391092279$exports, "N500", () => $a7f8c6b391092279$export$c39c0fe0f26207ae);
$parcel$export($a7f8c6b391092279$exports, "N600", () => $a7f8c6b391092279$export$7090862dc3038a9f);
$parcel$export($a7f8c6b391092279$exports, "N700", () => $a7f8c6b391092279$export$ad0bacf983b7ddaa);
$parcel$export($a7f8c6b391092279$exports, "N800", () => $a7f8c6b391092279$export$7d61b15e0da132af);
$parcel$export($a7f8c6b391092279$exports, "N900", () => $a7f8c6b391092279$export$fbda843f0a27fe96);
$parcel$export($a7f8c6b391092279$exports, "N10A", () => $a7f8c6b391092279$export$791e57b27ca738ef);
$parcel$export($a7f8c6b391092279$exports, "N20A", () => $a7f8c6b391092279$export$8d43898f60b96a82);
$parcel$export($a7f8c6b391092279$exports, "N30A", () => $a7f8c6b391092279$export$920c0d5c49070351);
$parcel$export($a7f8c6b391092279$exports, "N40A", () => $a7f8c6b391092279$export$46987b49aab6d1a8);
$parcel$export($a7f8c6b391092279$exports, "N50A", () => $a7f8c6b391092279$export$7d3359664e8bb0e5);
$parcel$export($a7f8c6b391092279$exports, "N60A", () => $a7f8c6b391092279$export$d2d3bedfb276cac0);
$parcel$export($a7f8c6b391092279$exports, "N70A", () => $a7f8c6b391092279$export$6e5e7499ff054f6d);
$parcel$export($a7f8c6b391092279$exports, "N80A", () => $a7f8c6b391092279$export$59264b346c877fa7);
$parcel$export($a7f8c6b391092279$exports, "N90A", () => $a7f8c6b391092279$export$d092757d7c64925c);
$parcel$export($a7f8c6b391092279$exports, "N100A", () => $a7f8c6b391092279$export$486ab785e4bac3c6);
$parcel$export($a7f8c6b391092279$exports, "N200A", () => $a7f8c6b391092279$export$fba592bbc6419fea);
$parcel$export($a7f8c6b391092279$exports, "N300A", () => $a7f8c6b391092279$export$13609db0e6812ab8);
$parcel$export($a7f8c6b391092279$exports, "N400A", () => $a7f8c6b391092279$export$fbae4efaa892d883);
$parcel$export($a7f8c6b391092279$exports, "N500A", () => $a7f8c6b391092279$export$f13946d26f440ce6);
$parcel$export($a7f8c6b391092279$exports, "N600A", () => $a7f8c6b391092279$export$19f58225ac52a306);
$parcel$export($a7f8c6b391092279$exports, "N700A", () => $a7f8c6b391092279$export$6384f09da70e7b62);
$parcel$export($a7f8c6b391092279$exports, "N800A", () => $a7f8c6b391092279$export$d0dccc730683edc2);
$parcel$export($a7f8c6b391092279$exports, "DN900", () => $a7f8c6b391092279$export$2f6319cf7d736c2a);
$parcel$export($a7f8c6b391092279$exports, "DN800", () => $a7f8c6b391092279$export$95126bc8884d6634);
$parcel$export($a7f8c6b391092279$exports, "DN700", () => $a7f8c6b391092279$export$8338d8c35d44ff1);
$parcel$export($a7f8c6b391092279$exports, "DN600", () => $a7f8c6b391092279$export$5368d76ae4fbbda7);
$parcel$export($a7f8c6b391092279$exports, "DN500", () => $a7f8c6b391092279$export$9f0a771d16ec8d36);
$parcel$export($a7f8c6b391092279$exports, "DN400", () => $a7f8c6b391092279$export$abcf8c38338b4aa5);
$parcel$export($a7f8c6b391092279$exports, "DN300", () => $a7f8c6b391092279$export$97e81faa16a182c7);
$parcel$export($a7f8c6b391092279$exports, "DN200", () => $a7f8c6b391092279$export$bfe21c59123ecf33);
$parcel$export($a7f8c6b391092279$exports, "DN100", () => $a7f8c6b391092279$export$ee82aa2ea6a1558);
$parcel$export($a7f8c6b391092279$exports, "DN90", () => $a7f8c6b391092279$export$682927c6ed76be02);
$parcel$export($a7f8c6b391092279$exports, "DN80", () => $a7f8c6b391092279$export$91fd9994c5be9757);
$parcel$export($a7f8c6b391092279$exports, "DN70", () => $a7f8c6b391092279$export$d281fbfe3cff2df6);
$parcel$export($a7f8c6b391092279$exports, "DN60", () => $a7f8c6b391092279$export$3902c91d8b98a753);
$parcel$export($a7f8c6b391092279$exports, "DN50", () => $a7f8c6b391092279$export$8e8133c1ba5845b5);
$parcel$export($a7f8c6b391092279$exports, "DN40", () => $a7f8c6b391092279$export$33ff357f6620b39);
$parcel$export($a7f8c6b391092279$exports, "DN30", () => $a7f8c6b391092279$export$633847cf062b69e0);
$parcel$export($a7f8c6b391092279$exports, "DN20", () => $a7f8c6b391092279$export$9776a6e503bdbf76);
$parcel$export($a7f8c6b391092279$exports, "DN10", () => $a7f8c6b391092279$export$6c813d5160dff5db);
$parcel$export($a7f8c6b391092279$exports, "DN0", () => $a7f8c6b391092279$export$3d4f271a500072a);
$parcel$export($a7f8c6b391092279$exports, "DN800A", () => $a7f8c6b391092279$export$fe151285c22759ec);
$parcel$export($a7f8c6b391092279$exports, "DN700A", () => $a7f8c6b391092279$export$a101c6190d0da34);
$parcel$export($a7f8c6b391092279$exports, "DN600A", () => $a7f8c6b391092279$export$4b16f52932fda51);
$parcel$export($a7f8c6b391092279$exports, "DN500A", () => $a7f8c6b391092279$export$a74bcd7b9845b0d8);
$parcel$export($a7f8c6b391092279$exports, "DN400A", () => $a7f8c6b391092279$export$9209c179316d1751);
$parcel$export($a7f8c6b391092279$exports, "DN300A", () => $a7f8c6b391092279$export$88f55133f636c8dd);
$parcel$export($a7f8c6b391092279$exports, "DN200A", () => $a7f8c6b391092279$export$51126f85d1009512);
$parcel$export($a7f8c6b391092279$exports, "DN100A", () => $a7f8c6b391092279$export$a069b547bd23af78);
$parcel$export($a7f8c6b391092279$exports, "DN90A", () => $a7f8c6b391092279$export$40cce05af3b2600a);
$parcel$export($a7f8c6b391092279$exports, "DN80A", () => $a7f8c6b391092279$export$b78942185925a0d);
$parcel$export($a7f8c6b391092279$exports, "DN70A", () => $a7f8c6b391092279$export$e058fb44b8eaafca);
$parcel$export($a7f8c6b391092279$exports, "DN60A", () => $a7f8c6b391092279$export$92b0b8de26920c18);
$parcel$export($a7f8c6b391092279$exports, "DN50A", () => $a7f8c6b391092279$export$67564f7459d3fc9e);
$parcel$export($a7f8c6b391092279$exports, "DN40A", () => $a7f8c6b391092279$export$77868e1ca884ffa3);
$parcel$export($a7f8c6b391092279$exports, "DN30A", () => $a7f8c6b391092279$export$2afd71d7d3ea2cd5);
$parcel$export($a7f8c6b391092279$exports, "DN20A", () => $a7f8c6b391092279$export$f2a0acaab9972c70);
$parcel$export($a7f8c6b391092279$exports, "DN10A", () => $a7f8c6b391092279$export$9ab70e67d6475361);
$parcel$export($a7f8c6b391092279$exports, "T30", () => $a7f8c6b391092279$export$d2adc5dedf09fced);
$parcel$export($a7f8c6b391092279$exports, "L50", () => $a7f8c6b391092279$export$f51762073d2bb381);
$parcel$export($a7f8c6b391092279$exports, "L75", () => $a7f8c6b391092279$export$95e26d54def96891);
// Reds
const $a7f8c6b391092279$export$4b84fd0e2c617bd = '#FFEBE6';
const $a7f8c6b391092279$export$b34b069eff244586 = '#FFBDAD';
const $a7f8c6b391092279$export$be802dd0d8b57f35 = '#FF8F73';
const $a7f8c6b391092279$export$60847d42f9da92a6 = '#FF7452';
const $a7f8c6b391092279$export$4a7404f376229999 = '#FF5630';
const $a7f8c6b391092279$export$2010d0fb4295b346 = '#DE350B';
const $a7f8c6b391092279$export$2837b5a1a71d5c02 = '#BF2600';
const $a7f8c6b391092279$export$8d9596b529bbb9cf = '#FFFAE6';
const $a7f8c6b391092279$export$41060a744ab0b7ae = '#FFF0B3';
const $a7f8c6b391092279$export$1cc05bbbf340e559 = '#FFE380';
const $a7f8c6b391092279$export$5aae31392d72caaa = '#FFC400';
const $a7f8c6b391092279$export$c6930421db9fa514 = '#FFAB00';
const $a7f8c6b391092279$export$59619663aa6500fb = '#FF991F';
const $a7f8c6b391092279$export$874739ea9e379ab6 = '#FF8B00';
const $a7f8c6b391092279$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $a7f8c6b391092279$export$69a3bf21b9686c2b = '#ABF5D1';
const $a7f8c6b391092279$export$afbce1382ec95f73 = '#79F2C0';
const $a7f8c6b391092279$export$747d86715d4175de = '#57D9A3';
const $a7f8c6b391092279$export$940e1f69e873f202 = '#36B37E';
const $a7f8c6b391092279$export$a49394138f7b8e85 = '#00875A';
const $a7f8c6b391092279$export$6fa04827ac68a4fb = '#006644';
const $a7f8c6b391092279$export$226de0355ed012f8 = '#DEEBFF';
const $a7f8c6b391092279$export$8c13c2ee36917869 = '#B3D4FF';
const $a7f8c6b391092279$export$ecfc1dff386a3e7a = '#4C9AFF';
const $a7f8c6b391092279$export$215b7063051591f1 = '#2684FF';
const $a7f8c6b391092279$export$e62e8919cca44969 = '#0065FF';
const $a7f8c6b391092279$export$b3de0ae08da2ce64 = '#0052CC';
const $a7f8c6b391092279$export$a6ee3d71bc067634 = '#0747A6';
const $a7f8c6b391092279$export$67f15409e87642a1 = '#669DF1';
const $a7f8c6b391092279$export$f0539dbc42dbb067 = '#8FB8F6';
const $a7f8c6b391092279$export$363e4475840015bb = '#EAE6FF';
const $a7f8c6b391092279$export$4b0a4417ed59760f = '#C0B6F2';
const $a7f8c6b391092279$export$6011520a64d9a187 = '#998DD9';
const $a7f8c6b391092279$export$a7175d4e9206bc80 = '#8777D9';
const $a7f8c6b391092279$export$b48405b95304b5a1 = '#6554C0';
const $a7f8c6b391092279$export$c71e4279dd54a18d = '#5243AA';
const $a7f8c6b391092279$export$147899de772240ec = '#403294';
const $a7f8c6b391092279$export$2cf711fe14c66f06 = '#E6FCFF';
const $a7f8c6b391092279$export$7a8f4d33f6f9772c = '#B3F5FF';
const $a7f8c6b391092279$export$776c9c497ef08533 = '#79E2F2';
const $a7f8c6b391092279$export$69cb3ca10c1e330e = '#00C7E6';
const $a7f8c6b391092279$export$9dc1ef0f3f48059b = '#00B8D9';
const $a7f8c6b391092279$export$7c835c78b6fcdef8 = '#00A3BF';
const $a7f8c6b391092279$export$6036577f95c3877e = '#008DA6';
const $a7f8c6b391092279$export$29a4f05edc054374 = '#FFFFFF';
const $a7f8c6b391092279$export$e655ef011c4aa1a2 = '#FAFBFC';
const $a7f8c6b391092279$export$9fdfb749e33cdf97 = '#F4F5F7';
const $a7f8c6b391092279$export$3e51e8f1440314ba = '#EBECF0';
const $a7f8c6b391092279$export$1ce2d1575d444ceb = '#DFE1E6';
const $a7f8c6b391092279$export$8754fc7e6d8b3000 = '#C1C7D0';
const $a7f8c6b391092279$export$c2e91cbeada39b8b = '#B3BAC5';
const $a7f8c6b391092279$export$5f71e19f3a7ad9de = '#A5ADBA';
const $a7f8c6b391092279$export$eaa8c8a70ac22806 = '#97A0AF';
const $a7f8c6b391092279$export$7c87d337fb91a97d = '#8993A4';
const $a7f8c6b391092279$export$d6447c357493214f = '#7A869A';
const $a7f8c6b391092279$export$f563ee71e9ee74cd = '#6B778C';
const $a7f8c6b391092279$export$e2ef2124cf4024b1 = '#5E6C84';
const $a7f8c6b391092279$export$eece5f492e429f08 = '#505F79';
const $a7f8c6b391092279$export$c39c0fe0f26207ae = '#42526E';
const $a7f8c6b391092279$export$7090862dc3038a9f = '#344563';
const $a7f8c6b391092279$export$ad0bacf983b7ddaa = '#253858';
const $a7f8c6b391092279$export$7d61b15e0da132af = '#172B4D';
const $a7f8c6b391092279$export$fbda843f0a27fe96 = '#091E42';
const $a7f8c6b391092279$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $a7f8c6b391092279$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $a7f8c6b391092279$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $a7f8c6b391092279$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $a7f8c6b391092279$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $a7f8c6b391092279$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $a7f8c6b391092279$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $a7f8c6b391092279$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $a7f8c6b391092279$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $a7f8c6b391092279$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $a7f8c6b391092279$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $a7f8c6b391092279$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $a7f8c6b391092279$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $a7f8c6b391092279$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $a7f8c6b391092279$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $a7f8c6b391092279$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $a7f8c6b391092279$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $a7f8c6b391092279$export$2f6319cf7d736c2a = '#E6EDFA';
const $a7f8c6b391092279$export$95126bc8884d6634 = '#DCE5F5';
const $a7f8c6b391092279$export$8338d8c35d44ff1 = '#CED9EB';
const $a7f8c6b391092279$export$5368d76ae4fbbda7 = '#B8C7E0';
const $a7f8c6b391092279$export$9f0a771d16ec8d36 = '#ABBBD6';
const $a7f8c6b391092279$export$abcf8c38338b4aa5 = '#9FB0CC';
const $a7f8c6b391092279$export$97e81faa16a182c7 = '#8C9CB8';
const $a7f8c6b391092279$export$bfe21c59123ecf33 = '#7988A3';
const $a7f8c6b391092279$export$ee82aa2ea6a1558 = '#67758F';
const $a7f8c6b391092279$export$682927c6ed76be02 = '#56637A';
const $a7f8c6b391092279$export$91fd9994c5be9757 = '#455166';
const $a7f8c6b391092279$export$d281fbfe3cff2df6 = '#3B475C';
const $a7f8c6b391092279$export$3902c91d8b98a753 = '#313D52';
const $a7f8c6b391092279$export$8e8133c1ba5845b5 = '#283447';
const $a7f8c6b391092279$export$33ff357f6620b39 = '#202B3D';
const $a7f8c6b391092279$export$633847cf062b69e0 = '#1B2638';
const $a7f8c6b391092279$export$9776a6e503bdbf76 = '#121A29';
const $a7f8c6b391092279$export$6c813d5160dff5db = '#0E1624';
const $a7f8c6b391092279$export$3d4f271a500072a = '#0D1424';
const $a7f8c6b391092279$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $a7f8c6b391092279$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $a7f8c6b391092279$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $a7f8c6b391092279$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $a7f8c6b391092279$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $a7f8c6b391092279$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $a7f8c6b391092279$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $a7f8c6b391092279$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $a7f8c6b391092279$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $a7f8c6b391092279$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $a7f8c6b391092279$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $a7f8c6b391092279$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $a7f8c6b391092279$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $a7f8c6b391092279$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $a7f8c6b391092279$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $a7f8c6b391092279$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $a7f8c6b391092279$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $a7f8c6b391092279$export$d2adc5dedf09fced = '#292A2E';
const $a7f8c6b391092279$export$f51762073d2bb381 = '#94C748';
const $a7f8c6b391092279$export$95e26d54def96891 = '#B3DF72';


parcelRegister("j62qJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b41654dc254ce0e$export$2e2bcd8739ae039);
/* wrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $8b41654dc254ce0e$var$CSS_VAR_COLOR = '--logo-color';
const $8b41654dc254ce0e$var$CSS_VAR_FILL = '--logo-fill';
const $8b41654dc254ce0e$var$styles = {
    root: "_1e0c1o8l _kqswh2mm _syaz1vry _lswu1xf6 _vwz4kb7n _uiztglyw _o5724jg8 _zbji1osq _3se11kw7",
    stop: "_vc881r31",
    xsmall: "_4t3i7vkz",
    small: "_4t3i1tcg",
    medium: "_4t3izwfg",
    large: "_4t3i1ylp",
    xlarge: "_4t3ickbl"
};
/**
 * __Wrapper__
 *
 * An internal component used by `@atlaskit/logo` to render logo SVGs with correct styles.
 */ const $8b41654dc254ce0e$var$Wrapper = ({ label: label, svg: svg, size: size, appearance: appearance, iconColor: iconColor, textColor: textColor, testId: userDefinedTestId, ...rest })=>{
    // Only required for old logos with gradients, which set gradient values to `inherit` when no appearance is provided
    const shouldApplyStopColor = appearance === undefined;
    const testId = userDefinedTestId && `${userDefinedTestId}--wrapper`;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "data-testid": testId,
        style: {
            [$8b41654dc254ce0e$var$CSS_VAR_COLOR]: iconColor,
            [$8b41654dc254ce0e$var$CSS_VAR_FILL]: textColor
        },
        "aria-label": label ? label : undefined,
        role: label ? 'img' : undefined,
        dangerouslySetInnerHTML: {
            __html: svg
        },
        ...rest,
        className: (0, $bwpsq.default)([
            $8b41654dc254ce0e$var$styles.root,
            shouldApplyStopColor && $8b41654dc254ce0e$var$styles.stop,
            size && $8b41654dc254ce0e$var$styles[size]
        ])
    });
};
var $8b41654dc254ce0e$export$2e2bcd8739ae039 = $8b41654dc254ce0e$var$Wrapper;

});


parcelRegister("GLupd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0808c2c46048f16e$var$_react = $0808c2c46048f16e$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $0808c2c46048f16e$var$_peopleGroup = $0808c2c46048f16e$var$_interopRequireDefault((parcelRequire("gfxSS")));
function $0808c2c46048f16e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $0808c2c46048f16e$var$PeopleIcon = (props)=>/*#__PURE__*/ $0808c2c46048f16e$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><circle cx="16" cy="9" r="3"/><circle cx="8" cy="6" r="3"/><path d="M11 15c0-1.105.887-2 2-2h6c1.105 0 2 .885 2 2v3.73c0 3.027-10 3.027-10 0z"/><path d="M13 12a1.997 1.997 0 0 0-2-2H5c-1.113 0-2 .897-2 2.003v3.826c0 1.921 4.054 2.518 7 1.984v-2.807A3 3 0 0 1 12.997 12z"/></g></svg>`
    }, props, {
        newIcon: $0808c2c46048f16e$var$_peopleGroup.default
    }));
$0808c2c46048f16e$var$PeopleIcon.displayName = 'PeopleIcon';
var $0808c2c46048f16e$var$_default = module.exports.default = $0808c2c46048f16e$var$PeopleIcon;

});

parcelRegister("cCv9R", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $930133fb31142fb7$var$_react = $930133fb31142fb7$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $930133fb31142fb7$var$_dashboard = $930133fb31142fb7$var$_interopRequireDefault((parcelRequire("gdqFV")));
function $930133fb31142fb7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $930133fb31142fb7$var$ActivityIcon = (props)=>/*#__PURE__*/ $930133fb31142fb7$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M19.004 17C19 17 19 7.006 19 7.006 19 7 4.996 7 4.996 7 5 7 5 16.994 5 16.994 5 17 19.004 17 19.004 17M3 7.006A2 2 0 0 1 4.995 5h14.01A2 2 0 0 1 21 7.006v9.988A2 2 0 0 1 19.005 19H4.995A2 2 0 0 1 3 16.994z"/><path d="M4 6h16v5H4zm5 2c0 .556.446 1 .995 1h8.01c.54 0 .995-.448.995-1 0-.556-.446-1-.995-1h-8.01C9.455 7 9 7.448 9 8M5 8c0 .556.448 1 1 1 .556 0 1-.448 1-1 0-.556-.448-1-1-1-.556 0-1 .448-1 1"/></g></svg>`
    }, props, {
        newIcon: $930133fb31142fb7$var$_dashboard.default
    }));
$930133fb31142fb7$var$ActivityIcon.displayName = 'ActivityIcon';
var $930133fb31142fb7$var$_default = module.exports.default = $930133fb31142fb7$var$ActivityIcon;

});
parcelRegister("gdqFV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4502f1006918f00802afd208dfed8019>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bce28d5f08c5e3c7$var$_react = $bce28d5f08c5e3c7$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $bce28d5f08c5e3c7$var$_baseNew = $bce28d5f08c5e3c7$var$_interopRequireDefault((parcelRequire("enEmH")));
function $bce28d5f08c5e3c7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Dashboard".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for dashboards in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bce28d5f08c5e3c7$var$DashboardIcon = (props)=>/*#__PURE__*/ $bce28d5f08c5e3c7$var$_react.default.createElement($bce28d5f08c5e3c7$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 2.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h4.25v-11zm5.75 0v4.75h4.75V3a.5.5 0 0 0-.5-.5zm4.75 6.25H8.75v4.75H13a.5.5 0 0 0 .5-.5zM1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$bce28d5f08c5e3c7$var$DashboardIcon.displayName = 'DashboardIcon';
var $bce28d5f08c5e3c7$var$_default = module.exports.default = $bce28d5f08c5e3c7$var$DashboardIcon;

});


parcelRegister("gOmoF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c3d2b06c6b4258d6$var$_react = $c3d2b06c6b4258d6$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $c3d2b06c6b4258d6$var$_app = $c3d2b06c6b4258d6$var$_interopRequireDefault((parcelRequire("IS9QB")));
function $c3d2b06c6b4258d6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c3d2b06c6b4258d6$var$AddonIcon = (props)=>/*#__PURE__*/ $c3d2b06c6b4258d6$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="m5.376 6.455 5.248-3.104c.792-.469 1.963-.467 2.752 0l5.248 3.104C19.416 6.923 20 7.962 20 8.895v6.21c0 .936-.587 1.973-1.376 2.44l-5.248 3.104c-.792.469-1.963.467-2.752 0l-5.248-3.104C4.584 17.077 4 16.038 4 15.105v-6.21c0-.936.587-1.973 1.376-2.44m6.99-1.314c-.165-.098-.566-.098-.733 0L6.385 8.245c-.166.098-.367.454-.367.65v6.21c0 .195.2.551.367.65l5.248 3.104c.166.098.567.098.734 0l5.248-3.104c.166-.098.367-.454.367-.65v-6.21c0-.195-.2-.551-.367-.65z"/><path d="M12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8m0-2a2 2 0 1 0 0-4 2 2 0 0 0 0 4"/></g></svg>`
    }, props, {
        newIcon: $c3d2b06c6b4258d6$var$_app.default
    }));
$c3d2b06c6b4258d6$var$AddonIcon.displayName = 'AddonIcon';
var $c3d2b06c6b4258d6$var$_default = module.exports.default = $c3d2b06c6b4258d6$var$AddonIcon;

});
parcelRegister("IS9QB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5c18dea19497efa81c490b216a2f8ff9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $086e1ecadf87a4f9$var$_react = $086e1ecadf87a4f9$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $086e1ecadf87a4f9$var$_baseNew = $086e1ecadf87a4f9$var$_interopRequireDefault((parcelRequire("enEmH")));
function $086e1ecadf87a4f9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "App".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for marketplace apps and integrations across products.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $086e1ecadf87a4f9$var$AppIcon = (props)=>/*#__PURE__*/ $086e1ecadf87a4f9$var$_react.default.createElement($086e1ecadf87a4f9$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.257 1.779a.5.5 0 0 0-.514 0l-5 3a.5.5 0 0 0-.243.429v5.584a.5.5 0 0 0 .243.429l5 3a.5.5 0 0 0 .514 0l5-3a.5.5 0 0 0 .243-.429V5.208a.5.5 0 0 0-.243-.429zM6.971.493a2 2 0 0 1 2.058 0l5 3A2 2 0 0 1 15 5.208v5.584a2 2 0 0 1-.971 1.715l-5 3a2 2 0 0 1-2.058 0l-5-3A2 2 0 0 1 1 10.792V5.208a2 2 0 0 1 .971-1.715zM8 6.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M5 8a3 3 0 1 1 6 0 3 3 0 0 1-6 0" clip-rule="evenodd"/>`
    }, props));
$086e1ecadf87a4f9$var$AppIcon.displayName = 'AppIcon';
var $086e1ecadf87a4f9$var$_default = module.exports.default = $086e1ecadf87a4f9$var$AppIcon;

});


parcelRegister("h0b1c", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c60afbc5d273fc33$var$_react = $c60afbc5d273fc33$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $c60afbc5d273fc33$var$_appSwitcher = $c60afbc5d273fc33$var$_interopRequireDefault((parcelRequire("hbr4z")));
function $c60afbc5d273fc33$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c60afbc5d273fc33$var$AppSwitcherIcon = (props)=>/*#__PURE__*/ $c60afbc5d273fc33$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4 5.01C4 4.451 4.443 4 5.01 4h1.98C7.549 4 8 4.443 8 5.01v1.98C8 7.549 7.557 8 6.99 8H5.01C4.451 8 4 7.557 4 6.99zm0 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98C8 13.549 7.557 14 6.99 14H5.01C4.451 14 4 13.557 4 12.99zm6-6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98C14 7.549 13.557 8 12.99 8h-1.98C10.451 8 10 7.557 10 6.99zm0 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01zm6-6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98C20 7.549 19.557 8 18.99 8h-1.98C16.451 8 16 7.557 16 6.99zm0 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01zm-12 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98C8 19.549 7.557 20 6.99 20H5.01C4.451 20 4 19.557 4 18.99zm6 0c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01zm6 0c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01z"/></svg>`
    }, props, {
        newIcon: $c60afbc5d273fc33$var$_appSwitcher.default
    }));
$c60afbc5d273fc33$var$AppSwitcherIcon.displayName = 'AppSwitcherIcon';
var $c60afbc5d273fc33$var$_default = module.exports.default = $c60afbc5d273fc33$var$AppSwitcherIcon;

});
parcelRegister("hbr4z", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5a710c2ad5ea3773aa39998727af6369>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c82876d04b138895$var$_react = $c82876d04b138895$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c82876d04b138895$var$_baseNew = $c82876d04b138895$var$_interopRequireDefault((parcelRequire("enEmH")));
function $c82876d04b138895$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AppSwitcher".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for app switcher in global product navigation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c82876d04b138895$var$AppSwitcherIcon = (props)=>/*#__PURE__*/ $c82876d04b138895$var$_react.default.createElement($c82876d04b138895$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM9 3a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM1 11a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5zm6 .5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/>`
    }, props));
$c82876d04b138895$var$AppSwitcherIcon.displayName = 'AppSwitcherIcon';
var $c82876d04b138895$var$_default = module.exports.default = $c82876d04b138895$var$AppSwitcherIcon;

});


parcelRegister("7nSZB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $560556c3332b441a$var$_react = $560556c3332b441a$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $560556c3332b441a$var$_backlog = $560556c3332b441a$var$_interopRequireDefault((parcelRequire("2wG4I")));
function $560556c3332b441a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $560556c3332b441a$var$BacklogIcon = (props)=>/*#__PURE__*/ $560556c3332b441a$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M5 19.002C5 19 17 19 17 19v-2.002C17 17 5 17 5 17zm-2-2.004C3 15.894 3.895 15 4.994 15h12.012c1.101 0 1.994.898 1.994 1.998v2.004A1.997 1.997 0 0 1 17.006 21H4.994A2 2 0 0 1 3 19.002z"/><path d="M5 15h12v-2H5zm-2-4h16v6H3z"/><path d="M7 11.002C7 11 19 11 19 11V8.998C19 9 7 9 7 9zM5 8.998C5 7.894 5.895 7 6.994 7h12.012C20.107 7 21 7.898 21 8.998v2.004A1.997 1.997 0 0 1 19.006 13H6.994A2 2 0 0 1 5 11.002z"/><path d="M5 5v2h12V5zm-2-.002C3 3.894 3.895 3 4.994 3h12.012C18.107 3 19 3.898 19 4.998V9H3z"/></g></svg>`
    }, props, {
        newIcon: $560556c3332b441a$var$_backlog.default
    }));
$560556c3332b441a$var$BacklogIcon.displayName = 'BacklogIcon';
var $560556c3332b441a$var$_default = module.exports.default = $560556c3332b441a$var$BacklogIcon;

});
parcelRegister("2wG4I", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::471b5e5cdc883753bc3e3b52ee5ae2e2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1d6f3528a0ebbe1e$var$_react = $1d6f3528a0ebbe1e$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $1d6f3528a0ebbe1e$var$_baseNew = $1d6f3528a0ebbe1e$var$_interopRequireDefault((parcelRequire("enEmH")));
function $1d6f3528a0ebbe1e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Backlog".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for backlogs in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1d6f3528a0ebbe1e$var$BacklogIcon = (props)=>/*#__PURE__*/ $1d6f3528a0ebbe1e$var$_react.default.createElement($1d6f3528a0ebbe1e$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v2.167h11V3a.5.5 0 0 0-.5-.5zm10.5 4.167h-11v2.666h11zm0 4.166h-11V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5z" clip-rule="evenodd"/>`
    }, props));
$1d6f3528a0ebbe1e$var$BacklogIcon.displayName = 'BacklogIcon';
var $1d6f3528a0ebbe1e$var$_default = module.exports.default = $1d6f3528a0ebbe1e$var$BacklogIcon;

});


parcelRegister("eoggv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a79fec81a090ba67$var$_react = $a79fec81a090ba67$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");
function $a79fec81a090ba67$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a79fec81a090ba67$var$BillingIcon = (props)=>/*#__PURE__*/ $a79fec81a090ba67$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M7 4v16h10V4zm-2-.01C5 2.892 5.897 2 7.006 2h9.988C18.102 2 19 2.898 19 3.99v16.02c0 1.099-.897 1.99-2.006 1.99H7.006A2.003 2.003 0 0 1 5 20.01z"/><rect width="8" height="2" x="8" y="6" rx="1"/><rect width="5" height="2" x="8" y="9" rx="1"/><rect width="5" height="2" x="8" y="12" rx="1"/><rect width="5" height="2" x="8" y="15" rx="1"/><rect width="2" height="2" x="14" y="12" rx="1"/><rect width="2" height="2" x="14" y="15" rx="1"/><rect width="2" height="2" x="14" y="9" rx="1"/></g></svg>`
    }, props));
$a79fec81a090ba67$var$BillingIcon.displayName = 'BillingIcon';
var $a79fec81a090ba67$var$_default = module.exports.default = $a79fec81a090ba67$var$BillingIcon;

});

parcelRegister("2ix7K", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1ac6f4ee51fb53d4$var$_react = $1ac6f4ee51fb53d4$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $1ac6f4ee51fb53d4$var$_board = $1ac6f4ee51fb53d4$var$_interopRequireDefault((parcelRequire("bPaTh")));
function $1ac6f4ee51fb53d4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1ac6f4ee51fb53d4$var$BoardIcon = (props)=>/*#__PURE__*/ $1ac6f4ee51fb53d4$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M4 18h16.008C20 18 20 6 20 6H3.992C4 6 4 18 4 18M2 5.994C2 4.893 2.898 4 3.99 4h16.02C21.108 4 22 4.895 22 5.994v12.012A1.997 1.997 0 0 1 20.01 20H3.99A1.994 1.994 0 0 1 2 18.006z"/><path d="M8 6v12h2V6zm6 0v12h2V6z"/></g></svg>`
    }, props, {
        newIcon: $1ac6f4ee51fb53d4$var$_board.default
    }));
$1ac6f4ee51fb53d4$var$BoardIcon.displayName = 'BoardIcon';
var $1ac6f4ee51fb53d4$var$_default = module.exports.default = $1ac6f4ee51fb53d4$var$BoardIcon;

});
parcelRegister("bPaTh", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6bfc058bc597636775f186a66702ef9b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $89bce7c4de862898$var$_react = $89bce7c4de862898$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $89bce7c4de862898$var$_baseNew = $89bce7c4de862898$var$_interopRequireDefault((parcelRequire("enEmH")));
function $89bce7c4de862898$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Board".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for boards in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $89bce7c4de862898$var$BoardIcon = (props)=>/*#__PURE__*/ $89bce7c4de862898$var$_react.default.createElement($89bce7c4de862898$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 3.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h2.833v-9zm4.333 0v9h3.334v-9zm4.834 0v9H14a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5zM0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$89bce7c4de862898$var$BoardIcon.displayName = 'BoardIcon';
var $89bce7c4de862898$var$_default = module.exports.default = $89bce7c4de862898$var$BoardIcon;

});


parcelRegister("6nxkb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4a4ebd9d47f38c28$var$_react = $4a4ebd9d47f38c28$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $4a4ebd9d47f38c28$var$_listBulleted = $4a4ebd9d47f38c28$var$_interopRequireDefault((parcelRequire("ll5rh")));
function $4a4ebd9d47f38c28$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $4a4ebd9d47f38c28$var$BulletListIcon = (props)=>/*#__PURE__*/ $4a4ebd9d47f38c28$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><rect width="8" height="2" x="10" y="15" rx="1"/><rect width="2" height="2" x="6" y="15" rx="1"/><rect width="8" height="2" x="10" y="11" rx="1"/><rect width="2" height="2" x="6" y="11" rx="1"/><rect width="8" height="2" x="10" y="7" rx="1"/><rect width="2" height="2" x="6" y="7" rx="1"/></g></svg>`
    }, props, {
        newIcon: $4a4ebd9d47f38c28$var$_listBulleted.default
    }));
$4a4ebd9d47f38c28$var$BulletListIcon.displayName = 'BulletListIcon';
var $4a4ebd9d47f38c28$var$_default = module.exports.default = $4a4ebd9d47f38c28$var$BulletListIcon;

});
parcelRegister("ll5rh", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c464a7d95484e897372db9f1fff872cb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f88fc7358a2ef161$var$_react = $f88fc7358a2ef161$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $f88fc7358a2ef161$var$_baseNew = $f88fc7358a2ef161$var$_interopRequireDefault((parcelRequire("enEmH")));
function $f88fc7358a2ef161$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ListBulleted".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: bulleted lists, view all.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f88fc7358a2ef161$var$ListBulletedIcon = (props)=>/*#__PURE__*/ $f88fc7358a2ef161$var$_react.default.createElement($f88fc7358a2ef161$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M.5 4.25a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m0 7.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M16 5H6V3.5h10zm0 7.5H6V11h10z" clip-rule="evenodd"/>`
    }, props));
$f88fc7358a2ef161$var$ListBulletedIcon.displayName = 'ListBulletedIcon';
var $f88fc7358a2ef161$var$_default = module.exports.default = $f88fc7358a2ef161$var$ListBulletedIcon;

});


parcelRegister("cUaD8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9652f5ea5116c1ae$var$_react = $9652f5ea5116c1ae$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $9652f5ea5116c1ae$var$_chevronDown = $9652f5ea5116c1ae$var$_interopRequireDefault((parcelRequire("jVpd1")));
function $9652f5ea5116c1ae$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9652f5ea5116c1ae$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $9652f5ea5116c1ae$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8.292 10.293a1.01 1.01 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.01 1.01 0 0 0 0-1.419.987.987 0 0 0-1.406 0l-2.298 2.317-2.307-2.327a.99.99 0 0 0-1.406 0"/></svg>`
    }, props, {
        newIcon: $9652f5ea5116c1ae$var$_chevronDown.default,
        iconType: "utility"
    }));
$9652f5ea5116c1ae$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $9652f5ea5116c1ae$var$_default = module.exports.default = $9652f5ea5116c1ae$var$ChevronDownIcon;

});

parcelRegister("GYj5l", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0812b4099a03ddf6$var$_react = $0812b4099a03ddf6$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $0812b4099a03ddf6$var$_chevronRight = $0812b4099a03ddf6$var$_interopRequireDefault((parcelRequire("LD2gx")));
function $0812b4099a03ddf6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $0812b4099a03ddf6$var$ChevronRightIcon = (props)=>/*#__PURE__*/ $0812b4099a03ddf6$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M10.294 9.698a.99.99 0 0 1 0-1.407 1.01 1.01 0 0 1 1.419 0l2.965 2.94a1.09 1.09 0 0 1 0 1.548l-2.955 2.93a1.01 1.01 0 0 1-1.42 0 .99.99 0 0 1 0-1.407l2.318-2.297z"/></svg>`
    }, props, {
        newIcon: $0812b4099a03ddf6$var$_chevronRight.default,
        iconType: "utility"
    }));
$0812b4099a03ddf6$var$ChevronRightIcon.displayName = 'ChevronRightIcon';
var $0812b4099a03ddf6$var$_default = module.exports.default = $0812b4099a03ddf6$var$ChevronRightIcon;

});
parcelRegister("LD2gx", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::281ba53efaa7c88b789646091262f5f9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $08f2ab8c02a7b08b$var$_react = $08f2ab8c02a7b08b$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $08f2ab8c02a7b08b$var$_baseNew = $08f2ab8c02a7b08b$var$_interopRequireDefault((parcelRequire("enEmH")));
function $08f2ab8c02a7b08b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronRight".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for menu fly outs and to indicate next in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $08f2ab8c02a7b08b$var$ChevronRightIcon = (props)=>/*#__PURE__*/ $08f2ab8c02a7b08b$var$_react.default.createElement($08f2ab8c02a7b08b$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7.94 6 3.97 2.03 5.03.97l4.5 4.5a.75.75 0 0 1 0 1.06l-4.5 4.5-1.06-1.06z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$08f2ab8c02a7b08b$var$ChevronRightIcon.displayName = 'ChevronRightIcon';
var $08f2ab8c02a7b08b$var$_default = module.exports.default = $08f2ab8c02a7b08b$var$ChevronRightIcon;

});


parcelRegister("9HHyy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7109ea974c5788d9$var$_react = $7109ea974c5788d9$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $7109ea974c5788d9$var$_creditCard = $7109ea974c5788d9$var$_interopRequireDefault((parcelRequire("3f3VS")));
function $7109ea974c5788d9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7109ea974c5788d9$var$CreditcardFilledIcon = (props)=>/*#__PURE__*/ $7109ea974c5788d9$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M3 10.99h18V17c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2zM6.01 16h2v-2h-2zM21 8.99V7c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v1.99"/></svg>`
    }, props, {
        newIcon: $7109ea974c5788d9$var$_creditCard.default
    }));
$7109ea974c5788d9$var$CreditcardFilledIcon.displayName = 'CreditcardFilledIcon';
var $7109ea974c5788d9$var$_default = module.exports.default = $7109ea974c5788d9$var$CreditcardFilledIcon;

});
parcelRegister("3f3VS", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4932f6dfff92518aeab5d46f90dd8b8a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $25c5d2b7317bc444$var$_react = $25c5d2b7317bc444$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $25c5d2b7317bc444$var$_baseNew = $25c5d2b7317bc444$var$_interopRequireDefault((parcelRequire("enEmH")));
function $25c5d2b7317bc444$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CreditCard".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: billing in Admin, invoices in PPC, payments.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $25c5d2b7317bc444$var$CreditCardIcon = (props)=>/*#__PURE__*/ $25c5d2b7317bc444$var$_react.default.createElement($25c5d2b7317bc444$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v1.5h13V4a.5.5 0 0 0-.5-.5zM14.5 7h-13v5a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5zM9 9.5h4V11H9z" clip-rule="evenodd"/>`
    }, props));
$25c5d2b7317bc444$var$CreditCardIcon.displayName = 'CreditCardIcon';
var $25c5d2b7317bc444$var$_default = module.exports.default = $25c5d2b7317bc444$var$CreditCardIcon;

});


parcelRegister("4y6Pt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $34ffa28f508dcad3$var$_react = $34ffa28f508dcad3$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $34ffa28f508dcad3$var$_crossCircle = $34ffa28f508dcad3$var$_interopRequireDefault((parcelRequire("hvAON")));
function $34ffa28f508dcad3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $34ffa28f508dcad3$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $34ffa28f508dcad3$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="m13.477 9.113-4.36 4.386a1 1 0 1 0 1.418 1.41l4.36-4.386a1 1 0 0 0-1.418-1.41"/><path fill="inherit" d="m9.084 10.501 4.358 4.377a1 1 0 1 0 1.418-1.411L10.5 9.09a1 1 0 0 0-1.417 1.411"/></g></svg>`
    }, props, {
        newIcon: $34ffa28f508dcad3$var$_crossCircle.default
    }));
$34ffa28f508dcad3$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
var $34ffa28f508dcad3$var$_default = module.exports.default = $34ffa28f508dcad3$var$CrossCircleIcon;

});
parcelRegister("hvAON", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::70e4741cbfa8f6087ac64902b38a7366>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cbf1e4449eb517ef$var$_react = $cbf1e4449eb517ef$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $cbf1e4449eb517ef$var$_baseNew = $cbf1e4449eb517ef$var$_interopRequireDefault((parcelRequire("enEmH")));
function $cbf1e4449eb517ef$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CrossCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: clear text field, error status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cbf1e4449eb517ef$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $cbf1e4449eb517ef$var$_react.default.createElement($cbf1e4449eb517ef$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m4.03 5.03L9.06 8l2.97 2.97-1.06 1.06L8 9.06l-2.97 2.97-1.06-1.06L6.94 8 3.97 5.03l1.06-1.06L8 6.94l2.97-2.97z" clip-rule="evenodd"/>`
    }, props));
$cbf1e4449eb517ef$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
var $cbf1e4449eb517ef$var$_default = module.exports.default = $cbf1e4449eb517ef$var$CrossCircleIcon;

});


parcelRegister("5OyEj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $43bc7fe4e60cffa9$var$_react = $43bc7fe4e60cffa9$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $43bc7fe4e60cffa9$var$_dashboard = $43bc7fe4e60cffa9$var$_interopRequireDefault((parcelRequire("gdqFV")));
function $43bc7fe4e60cffa9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $43bc7fe4e60cffa9$var$DashboardIcon = (props)=>/*#__PURE__*/ $43bc7fe4e60cffa9$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M4 18h16.008C20 18 20 6 20 6H3.992C4 6 4 18 4 18M2 5.994C2 4.893 2.898 4 3.99 4h16.02C21.108 4 22 4.895 22 5.994v12.012A1.997 1.997 0 0 1 20.01 20H3.99A1.994 1.994 0 0 1 2 18.006z"/><path d="M7 5v14h2V5z"/><path d="M7 11h14V9H7z"/></g></svg>`
    }, props, {
        newIcon: $43bc7fe4e60cffa9$var$_dashboard.default
    }));
$43bc7fe4e60cffa9$var$DashboardIcon.displayName = 'DashboardIcon';
var $43bc7fe4e60cffa9$var$_default = module.exports.default = $43bc7fe4e60cffa9$var$DashboardIcon;

});

parcelRegister("9qRdk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6ddfd1f1646883db$var$_react = $6ddfd1f1646883db$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $6ddfd1f1646883db$var$_add = $6ddfd1f1646883db$var$_interopRequireDefault((parcelRequire("46OkO")));
function $6ddfd1f1646883db$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $6ddfd1f1646883db$var$EditorAddIcon = (props)=>/*#__PURE__*/ $6ddfd1f1646883db$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M13 11V7a1 1 0 0 0-2 0v4H7a1 1 0 0 0 0 2h4v4a1 1 0 0 0 2 0v-4h4a1 1 0 0 0 0-2z"/></svg>`
    }, props, {
        newIcon: $6ddfd1f1646883db$var$_add.default
    }));
$6ddfd1f1646883db$var$EditorAddIcon.displayName = 'EditorAddIcon';
var $6ddfd1f1646883db$var$_default = module.exports.default = $6ddfd1f1646883db$var$EditorAddIcon;

});
parcelRegister("46OkO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e570c2c471e9f2c44e5e57e4d5245eb9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2fdec462c3b66da0$var$_react = $2fdec462c3b66da0$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $2fdec462c3b66da0$var$_baseNew = $2fdec462c3b66da0$var$_interopRequireDefault((parcelRequire("enEmH")));
function $2fdec462c3b66da0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Add".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for creating and adding an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2fdec462c3b66da0$var$AddIcon = (props)=>/*#__PURE__*/ $2fdec462c3b66da0$var$_react.default.createElement($2fdec462c3b66da0$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7.25 8.75V15h1.5V8.75H15v-1.5H8.75V1h-1.5v6.25H1v1.5z" clip-rule="evenodd"/>`
    }, props));
$2fdec462c3b66da0$var$AddIcon.displayName = 'AddIcon';
var $2fdec462c3b66da0$var$_default = module.exports.default = $2fdec462c3b66da0$var$AddIcon;

});


parcelRegister("51om6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3a7ff03f7406df12$var$_react = $3a7ff03f7406df12$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $3a7ff03f7406df12$var$_information = $3a7ff03f7406df12$var$_interopRequireDefault((parcelRequire("9a675")));
function $3a7ff03f7406df12$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3a7ff03f7406df12$var$EditorPanelIcon = (props)=>/*#__PURE__*/ $3a7ff03f7406df12$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 19a7 7 0 1 1 0-14 7 7 0 0 1 0 14m0-1.5a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11m0-6a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 1-1m0-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2"/></svg>`
    }, props, {
        newIcon: $3a7ff03f7406df12$var$_information.default
    }));
$3a7ff03f7406df12$var$EditorPanelIcon.displayName = 'EditorPanelIcon';
var $3a7ff03f7406df12$var$_default = module.exports.default = $3a7ff03f7406df12$var$EditorPanelIcon;

});

parcelRegister("7mOjd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $55d19ccd226bfa42$var$_react = $55d19ccd226bfa42$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");
function $55d19ccd226bfa42$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $55d19ccd226bfa42$var$EmojiAtlassianIcon = (props)=>/*#__PURE__*/ $55d19ccd226bfa42$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M8.7 11.48c-.24-.25-.61-.24-.77.09l-3.88 7.76a.46.46 0 0 0 .42.67h5.41a.45.45 0 0 0 .42-.26c1.17-2.41.46-6.08-1.59-8.27m2.84-7.06c-2.17 3.44-2.03 7.26-.6 10.12l2.61 5.22c.08.16.24.26.42.26h5.41a.46.46 0 0 0 .42-.67S12.53 4.77 12.35 4.41c-.17-.32-.58-.33-.79 0"/></svg>`
    }, props));
$55d19ccd226bfa42$var$EmojiAtlassianIcon.displayName = 'EmojiAtlassianIcon';
var $55d19ccd226bfa42$var$_default = module.exports.default = $55d19ccd226bfa42$var$EmojiAtlassianIcon;

});

parcelRegister("26w26", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1884fd5defb11f66$var$_react = $1884fd5defb11f66$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $1884fd5defb11f66$var$_filter = $1884fd5defb11f66$var$_interopRequireDefault((parcelRequire("2tGrM")));
function $1884fd5defb11f66$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1884fd5defb11f66$var$FilterIcon = (props)=>/*#__PURE__*/ $1884fd5defb11f66$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M7 13h10l1-2H6zM3.99 6c-.55 0-.79.41-.55.9L4 8h16l.55-1.1c.25-.5.01-.9-.54-.9zm6.79 11.56a.87.87 0 0 0 .73.44h.99c.28 0 .61-.2.73-.44L14 16h-4z"/></svg>`
    }, props, {
        newIcon: $1884fd5defb11f66$var$_filter.default
    }));
$1884fd5defb11f66$var$FilterIcon.displayName = 'FilterIcon';
var $1884fd5defb11f66$var$_default = module.exports.default = $1884fd5defb11f66$var$FilterIcon;

});
parcelRegister("2tGrM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e89b7505e55a28f8d68b8d102eb88514>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1cdf3752c0f34558$var$_react = $1cdf3752c0f34558$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $1cdf3752c0f34558$var$_baseNew = $1cdf3752c0f34558$var$_interopRequireDefault((parcelRequire("enEmH")));
function $1cdf3752c0f34558$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Filter".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for filterting data or objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1cdf3752c0f34558$var$FilterIcon = (props)=>/*#__PURE__*/ $1cdf3752c0f34558$var$_react.default.createElement($1cdf3752c0f34558$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 3.5H1V2h14zm-2 5.25H3v-1.5h10zM11 14H5v-1.5h6z" clip-rule="evenodd"/>`
    }, props));
$1cdf3752c0f34558$var$FilterIcon.displayName = 'FilterIcon';
var $1cdf3752c0f34558$var$_default = module.exports.default = $1cdf3752c0f34558$var$FilterIcon;

});


parcelRegister("8GE7C", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $65315e5a9667b8cb$var$_react = $65315e5a9667b8cb$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $65315e5a9667b8cb$var$_folderClosed = $65315e5a9667b8cb$var$_interopRequireDefault((parcelRequire("8P27X")));
function $65315e5a9667b8cb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $65315e5a9667b8cb$var$FolderIcon = (props)=>/*#__PURE__*/ $65315e5a9667b8cb$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M20 19V8h-9.154l-.503-1.258-.455-1.136C9.778 5.33 9.291 5 9.003 5H3.997C4.002 5 4 19 4 19zM12.2 6h7.809C21.109 6 22 6.893 22 7.992v11.016c0 1.1-.898 1.992-1.991 1.992H3.991C2.891 21 2 20.107 2 19.008V5.006C2 3.898 2.896 3 3.997 3h5.006c1.103 0 2.327.826 2.742 1.862z"/></svg>`
    }, props, {
        newIcon: $65315e5a9667b8cb$var$_folderClosed.default
    }));
$65315e5a9667b8cb$var$FolderIcon.displayName = 'FolderIcon';
var $65315e5a9667b8cb$var$_default = module.exports.default = $65315e5a9667b8cb$var$FolderIcon;

});
parcelRegister("8P27X", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b0bcbb1797ade28bc1c80b60f118d24e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $66c4bc9dae5fe18a$var$_react = $66c4bc9dae5fe18a$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $66c4bc9dae5fe18a$var$_baseNew = $66c4bc9dae5fe18a$var$_interopRequireDefault((parcelRequire("enEmH")));
function $66c4bc9dae5fe18a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "FolderClosed".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for folders in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $66c4bc9dae5fe18a$var$FolderClosedIcon = (props)=>/*#__PURE__*/ $66c4bc9dae5fe18a$var$_react.default.createElement($66c4bc9dae5fe18a$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 2.5a.5.5 0 0 0-.5.5v3h11V4.75a.5.5 0 0 0-.5-.5H7.69L5.94 2.5zm10.5 5h-11V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5zM1 3a2 2 0 0 1 2-2h3.56l1.75 1.75H13a2 2 0 0 1 2 2V13a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$66c4bc9dae5fe18a$var$FolderClosedIcon.displayName = 'FolderClosedIcon';
var $66c4bc9dae5fe18a$var$_default = module.exports.default = $66c4bc9dae5fe18a$var$FolderClosedIcon;

});


parcelRegister("aKav4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7d26585d489edf27$var$_react = $7d26585d489edf27$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $7d26585d489edf27$var$_issues = $7d26585d489edf27$var$_interopRequireDefault((parcelRequire("bY4ef")));
function $7d26585d489edf27$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7d26585d489edf27$var$IssuesIcon = (props)=>/*#__PURE__*/ $7d26585d489edf27$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M5 12.99C5 13 19.01 13 19.01 13 19 13 19 5.01 19 5.01 19 5 5 5 5 5zM3 5.01C3 3.9 3.89 3 5 3h14.01A2 2 0 0 1 21 5.01v7.98A2 2 0 0 1 19.01 15H5a2 2 0 0 1-2-2.01zM19 19c0 1.11-.9 2-2.01 2H7.01A2.01 2.01 0 0 1 5 19zm1-3a2 2 0 0 1-1.99 2H5.99A2 2 0 0 1 4 16z"/><path d="M10.674 11.331c.36.36.941.36 1.3 0l2.758-2.763a.92.92 0 0 0-1.301-1.298l-2.108 2.11-.755-.754a.92.92 0 0 0-1.3 1.3z"/></g></svg>`
    }, props, {
        newIcon: $7d26585d489edf27$var$_issues.default
    }));
$7d26585d489edf27$var$IssuesIcon.displayName = 'IssuesIcon';
var $7d26585d489edf27$var$_default = module.exports.default = $7d26585d489edf27$var$IssuesIcon;

});
parcelRegister("bY4ef", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::756d4fa5fd77b2680e9e19bf5f6c468d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8b689413b35a7596$var$_react = $8b689413b35a7596$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $8b689413b35a7596$var$_baseNew = $8b689413b35a7596$var$_interopRequireDefault((parcelRequire("enEmH")));
function $8b689413b35a7596$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Issues".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for representing multiple work items.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8b689413b35a7596$var$IssuesIcon = (props)=>/*#__PURE__*/ $8b689413b35a7596$var$_react.default.createElement($8b689413b35a7596$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 3.5a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5zM0 4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm8.302.641 1.146.968-3.167 3.75a.75.75 0 0 1-1.146 0L3.552 7.484l1.146-.968 1.01 1.197z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M16 7v4.75A3.25 3.25 0 0 1 12.75 15H5v-1.5h7.75a1.75 1.75 0 0 0 1.75-1.75V7z" clip-rule="evenodd"/>`
    }, props));
$8b689413b35a7596$var$IssuesIcon.displayName = 'IssuesIcon';
var $8b689413b35a7596$var$_default = module.exports.default = $8b689413b35a7596$var$IssuesIcon;

});


parcelRegister("lHo2L", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fcc043aeefcf9201$var$_react = $fcc043aeefcf9201$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $fcc043aeefcf9201$var$_lightbulb = $fcc043aeefcf9201$var$_interopRequireDefault((parcelRequire("cu8LJ")));
function $fcc043aeefcf9201$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $fcc043aeefcf9201$var$LightbulbFilledIcon = (props)=>/*#__PURE__*/ $fcc043aeefcf9201$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11.998 4A5.997 5.997 0 0 0 6 9.998c0 2.218 2.288 4.484 2.288 4.484.39.387.71 1.112.71 1.611s.45.907 1 .907h4c.55 0 1-.408 1-.907s.32-1.224.71-1.611c0 0 2.288-2.266 2.288-4.484A5.997 5.997 0 0 0 11.998 4m2.965 15c0-.55-.45-1-1-1h-4c-.55 0-1 .45-1 1v.003c0 .55.45 1 1 1h4c.55 0 1-.45 1-1z"/></svg>`
    }, props, {
        newIcon: $fcc043aeefcf9201$var$_lightbulb.default
    }));
$fcc043aeefcf9201$var$LightbulbFilledIcon.displayName = 'LightbulbFilledIcon';
var $fcc043aeefcf9201$var$_default = module.exports.default = $fcc043aeefcf9201$var$LightbulbFilledIcon;

});
parcelRegister("cu8LJ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::aff1a0601d1dfa1b068f5f916af0a8fe>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $916f16b2e6ab67a2$var$_react = $916f16b2e6ab67a2$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $916f16b2e6ab67a2$var$_baseNew = $916f16b2e6ab67a2$var$_interopRequireDefault((parcelRequire("enEmH")));
function $916f16b2e6ab67a2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Lightbulb".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: learnings in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $916f16b2e6ab67a2$var$LightbulbIcon = (props)=>/*#__PURE__*/ $916f16b2e6ab67a2$var$_react.default.createElement($916f16b2e6ab67a2$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a4.5 4.5 0 0 0-2.516 8.232c.545.368 1.002.994 1.016 1.768h3c.014-.774.471-1.4 1.016-1.768A4.5 4.5 0 0 0 8 1.5M9.5 13h-3v1a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5zM2 6a6 6 0 1 1 9.355 4.975c-.247.167-.355.385-.355.56V14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-2.465c0-.175-.108-.393-.355-.56A6 6 0 0 1 2 6" clip-rule="evenodd"/>`
    }, props));
$916f16b2e6ab67a2$var$LightbulbIcon.displayName = 'LightbulbIcon';
var $916f16b2e6ab67a2$var$_default = module.exports.default = $916f16b2e6ab67a2$var$LightbulbIcon;

});


parcelRegister("f6ajG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $afdf6b32ad445e92$var$_react = $afdf6b32ad445e92$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $afdf6b32ad445e92$var$_showMoreHorizontal = $afdf6b32ad445e92$var$_interopRequireDefault((parcelRequire("c8rIN")));
function $afdf6b32ad445e92$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $afdf6b32ad445e92$var$MoreIcon = (props)=>/*#__PURE__*/ $afdf6b32ad445e92$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><circle cx="5" cy="12" r="2"/><circle cx="12" cy="12" r="2"/><circle cx="19" cy="12" r="2"/></g></svg>`
    }, props, {
        newIcon: $afdf6b32ad445e92$var$_showMoreHorizontal.default
    }));
$afdf6b32ad445e92$var$MoreIcon.displayName = 'MoreIcon';
var $afdf6b32ad445e92$var$_default = module.exports.default = $afdf6b32ad445e92$var$MoreIcon;

});
parcelRegister("c8rIN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fb6bef909769872b46b1e0328cacf596>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8d5bbc4ca67800c7$var$_react = $8d5bbc4ca67800c7$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $8d5bbc4ca67800c7$var$_baseNew = $8d5bbc4ca67800c7$var$_interopRequireDefault((parcelRequire("enEmH")));
function $8d5bbc4ca67800c7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ShowMoreHorizontal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for more action menus.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8d5bbc4ca67800c7$var$ShowMoreHorizontalIcon = (props)=>/*#__PURE__*/ $8d5bbc4ca67800c7$var$_react.default.createElement($8d5bbc4ca67800c7$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m6.5 0a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M13 8a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0" clip-rule="evenodd"/>`
    }, props));
$8d5bbc4ca67800c7$var$ShowMoreHorizontalIcon.displayName = 'ShowMoreHorizontalIcon';
var $8d5bbc4ca67800c7$var$_default = module.exports.default = $8d5bbc4ca67800c7$var$ShowMoreHorizontalIcon;

});


parcelRegister("cELUk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $936e61e3b6d894db$var$_react = $936e61e3b6d894db$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $936e61e3b6d894db$var$_notification = $936e61e3b6d894db$var$_interopRequireDefault((parcelRequire("imLNv")));
function $936e61e3b6d894db$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $936e61e3b6d894db$var$NotificationIcon = (props)=>/*#__PURE__*/ $936e61e3b6d894db$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M6.49 17.67a2 2 0 0 0 2.83 0l-2.83-2.83a2 2 0 0 0 0 2.83m4.89-12.19-.72.73c-.78.78-2.21 1.81-3.21 2.31l-3.02 1.51c-.49.25-.58.77-.19 1.17l8.56 8.56c.4.4.92.31 1.17-.19l1.51-3.02c.49-.99 1.53-2.42 2.31-3.21l.73-.73a5.05 5.05 0 0 0 .64-6.36 1.01 1.01 0 1 0-1.35-1.49q-.04.04-.07.08A5.04 5.04 0 0 0 14.95 4a5.04 5.04 0 0 0-3.57 1.48"/></svg>`
    }, props, {
        newIcon: $936e61e3b6d894db$var$_notification.default
    }));
$936e61e3b6d894db$var$NotificationIcon.displayName = 'NotificationIcon';
var $936e61e3b6d894db$var$_default = module.exports.default = $936e61e3b6d894db$var$NotificationIcon;

});
parcelRegister("imLNv", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f1e0c080c29498771abac7d6e0a3c394>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d5ef5ba3a33e5ddc$var$_react = $d5ef5ba3a33e5ddc$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $d5ef5ba3a33e5ddc$var$_baseNew = $d5ef5ba3a33e5ddc$var$_interopRequireDefault((parcelRequire("enEmH")));
function $d5ef5ba3a33e5ddc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Notification".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for notifications within global product navigation and within product screens.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d5ef5ba3a33e5ddc$var$NotificationIcon = (props)=>/*#__PURE__*/ $d5ef5ba3a33e5ddc$var$_react.default.createElement($d5ef5ba3a33e5ddc$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 5a5 5 0 0 1 10 0v3.535l1.788 2.861a1.375 1.375 0 0 1-1.166 2.104h-2.459a3.251 3.251 0 0 1-6.326 0h-2.46a1.375 1.375 0 0 1-1.165-2.104L3 8.535zm3.418 8.5a1.75 1.75 0 0 0 3.164 0zM8 1.5A3.5 3.5 0 0 0 4.5 5v3.636c0 .215-.06.426-.175.608L2.603 12h10.794l-1.723-2.756a1.15 1.15 0 0 1-.174-.608V5A3.5 3.5 0 0 0 8 1.5" clip-rule="evenodd"/>`
    }, props));
$d5ef5ba3a33e5ddc$var$NotificationIcon.displayName = 'NotificationIcon';
var $d5ef5ba3a33e5ddc$var$_default = module.exports.default = $d5ef5ba3a33e5ddc$var$NotificationIcon;

});


parcelRegister("9wCjp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6ef4d2373cce6aeb$var$_react = $6ef4d2373cce6aeb$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $6ef4d2373cce6aeb$var$_notification = $6ef4d2373cce6aeb$var$_interopRequireDefault((parcelRequire("imLNv")));
function $6ef4d2373cce6aeb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $6ef4d2373cce6aeb$var$NotificationDirectIcon = (props)=>/*#__PURE__*/ $6ef4d2373cce6aeb$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M6.59 17.83a2 2 0 0 0 2.83 0L6.59 15a2 2 0 0 0 0 2.83m4.79-12.35A5.04 5.04 0 0 1 14.95 4c.97 0 1.95.28 2.79.84q.03-.04.07-.07a1.01 1.01 0 1 1 1.35 1.49 5.05 5.05 0 0 1-.64 6.36l-.72.73c-.78.78-1.81 2.21-2.31 3.21l-1.51 3.02c-.25.5-.77.58-1.17.19l-8.56-8.55c-.4-.4-.31-.92.19-1.17l3.02-1.51c.99-.49 2.42-1.53 3.21-2.31zm2.74 9.63c.52-.97 1.57-2.4 2.35-3.18l.73-.73a3.05 3.05 0 0 0 .39-3.83c-.19-.29-.72-.77-.86-.86A3.04 3.04 0 0 0 15.05 6c-.8 0-1.57.31-2.16.89l-.95.95c-.78.79-2.22 1.82-3.2 2.31L7 11.02l6.07 6.07z"/></svg>`
    }, props, {
        newIcon: $6ef4d2373cce6aeb$var$_notification.default
    }));
$6ef4d2373cce6aeb$var$NotificationDirectIcon.displayName = 'NotificationDirectIcon';
var $6ef4d2373cce6aeb$var$_default = module.exports.default = $6ef4d2373cce6aeb$var$NotificationDirectIcon;

});

parcelRegister("ez2lY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a9a628e641583393$var$_react = $a9a628e641583393$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $a9a628e641583393$var$_arrowUpRight = $a9a628e641583393$var$_interopRequireDefault((parcelRequire("1vIgO")));
function $a9a628e641583393$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a9a628e641583393$var$OpenIcon = (props)=>/*#__PURE__*/ $a9a628e641583393$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M11.031 7A1.03 1.03 0 0 0 10 8.036a1.05 1.05 0 0 0 1.044 1.045l3.121.014.014 3.121a1.05 1.05 0 0 0 1.045 1.044 1.03 1.03 0 0 0 1.036-1.035l-.019-4.161a1.053 1.053 0 0 0-1.045-1.045L11.035 7z"/><path d="m13.364 8.292-7.071 7.071a1 1 0 0 0 0 1.415 1 1 0 0 0 1.414 0l7.071-7.071A1.002 1.002 0 0 0 14.071 8a1 1 0 0 0-.707.292"/></g></svg>`
    }, props, {
        newIcon: $a9a628e641583393$var$_arrowUpRight.default
    }));
$a9a628e641583393$var$OpenIcon.displayName = 'OpenIcon';
var $a9a628e641583393$var$_default = module.exports.default = $a9a628e641583393$var$OpenIcon;

});
parcelRegister("1vIgO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::aa37e7fb05387379200e2a91e20ea76e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $119b06d5275d0d70$var$_react = $119b06d5275d0d70$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $119b06d5275d0d70$var$_baseNew = $119b06d5275d0d70$var$_interopRequireDefault((parcelRequire("enEmH")));
function $119b06d5275d0d70$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowUpRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $119b06d5275d0d70$var$ArrowUpRightIcon = (props)=>/*#__PURE__*/ $119b06d5275d0d70$var$_react.default.createElement($119b06d5275d0d70$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m2.47 12.47 9.75-9.75 1.06 1.06-9.75 9.75z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M12 4H5.75V2.5h7a.75.75 0 0 1 .75.75v7H12z" clip-rule="evenodd"/>`
    }, props));
$119b06d5275d0d70$var$ArrowUpRightIcon.displayName = 'ArrowUpRightIcon';
var $119b06d5275d0d70$var$_default = module.exports.default = $119b06d5275d0d70$var$ArrowUpRightIcon;

});


parcelRegister("fjBW7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b2660ec1637f3f59$var$_react = $b2660ec1637f3f59$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $b2660ec1637f3f59$var$_page = $b2660ec1637f3f59$var$_interopRequireDefault((parcelRequire("4HiZI")));
function $b2660ec1637f3f59$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $b2660ec1637f3f59$var$PageIcon = (props)=>/*#__PURE__*/ $b2660ec1637f3f59$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><rect width="8" height="2" x="8" y="6" rx="1"/><rect width="8" height="2" x="8" y="9" rx="1"/><rect width="4" height="2" x="8" y="12" rx="1"/><path fill-rule="nonzero" d="M7 4v16h10V4zm-2-.01C5 2.892 5.897 2 7.006 2h9.988C18.102 2 19 2.898 19 3.99v16.02c0 1.099-.897 1.99-2.006 1.99H7.006A2.003 2.003 0 0 1 5 20.01z"/></g></svg>`
    }, props, {
        newIcon: $b2660ec1637f3f59$var$_page.default
    }));
$b2660ec1637f3f59$var$PageIcon.displayName = 'PageIcon';
var $b2660ec1637f3f59$var$_default = module.exports.default = $b2660ec1637f3f59$var$PageIcon;

});
parcelRegister("4HiZI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f64abe706416b0877b5dd221be64e7d7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $36b9e9779f1e612d$var$_react = $36b9e9779f1e612d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $36b9e9779f1e612d$var$_baseNew = $36b9e9779f1e612d$var$_interopRequireDefault((parcelRequire("enEmH")));
function $36b9e9779f1e612d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Page".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for pages in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $36b9e9779f1e612d$var$PageIcon = (props)=>/*#__PURE__*/ $36b9e9779f1e612d$var$_react.default.createElement($36b9e9779f1e612d$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM12 6H4V4.5h8zm-2 3.5H4V8h6z" clip-rule="evenodd"/>`
    }, props));
$36b9e9779f1e612d$var$PageIcon.displayName = 'PageIcon';
var $36b9e9779f1e612d$var$_default = module.exports.default = $36b9e9779f1e612d$var$PageIcon;

});


parcelRegister("akQrW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $78647507feea2f38$var$_react = $78647507feea2f38$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $78647507feea2f38$var$_person = $78647507feea2f38$var$_interopRequireDefault((parcelRequire("3cwUp")));
function $78647507feea2f38$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $78647507feea2f38$var$PersonIcon = (props)=>/*#__PURE__*/ $78647507feea2f38$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M6 14c0-1.105.902-2 2.009-2h7.982c1.11 0 2.009.894 2.009 2.006v4.44c0 3.405-12 3.405-12 0z"/><circle cx="12" cy="7" r="4"/></g></svg>`
    }, props, {
        newIcon: $78647507feea2f38$var$_person.default
    }));
$78647507feea2f38$var$PersonIcon.displayName = 'PersonIcon';
var $78647507feea2f38$var$_default = module.exports.default = $78647507feea2f38$var$PersonIcon;

});
parcelRegister("3cwUp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::69f4e6f87c1306b0b7d1107d65930cc1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $254c05172c53a480$var$_react = $254c05172c53a480$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $254c05172c53a480$var$_baseNew = $254c05172c53a480$var$_interopRequireDefault((parcelRequire("enEmH")));
function $254c05172c53a480$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Person".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a person or user, owner, contributor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $254c05172c53a480$var$PersonIcon = (props)=>/*#__PURE__*/ $254c05172c53a480$var$_react.default.createElement($254c05172c53a480$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4 4a4 4 0 1 1 8 0 4 4 0 0 1-8 0m-2 9a3.75 3.75 0 0 1 3.75-3.75h4.5A3.75 3.75 0 0 1 14 13v2h-1.5v-2a2.25 2.25 0 0 0-2.25-2.25h-4.5A2.25 2.25 0 0 0 3.5 13v2H2z" clip-rule="evenodd"/>`
    }, props));
$254c05172c53a480$var$PersonIcon.displayName = 'PersonIcon';
var $254c05172c53a480$var$_default = module.exports.default = $254c05172c53a480$var$PersonIcon;

});


parcelRegister("jvjSq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e33054b807b1e77a$var$_react = $e33054b807b1e77a$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $e33054b807b1e77a$var$_personAvatar = $e33054b807b1e77a$var$_interopRequireDefault((parcelRequire("l1s8i")));
function $e33054b807b1e77a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e33054b807b1e77a$var$PersonCircleIcon = (props)=>/*#__PURE__*/ $e33054b807b1e77a$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M14.5 13.009h-5c-1.38 0-2.5 1.12-2.5 2.503v3.978a8.95 8.95 0 0 0 5 1.519 8.95 8.95 0 0 0 5-1.519v-3.978a2.5 2.5 0 0 0-2.5-2.503"/><circle cx="12" cy="9" r="3"/><path fill-rule="nonzero" d="M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16m0 2C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10"/></g></svg>`
    }, props, {
        newIcon: $e33054b807b1e77a$var$_personAvatar.default
    }));
$e33054b807b1e77a$var$PersonCircleIcon.displayName = 'PersonCircleIcon';
var $e33054b807b1e77a$var$_default = module.exports.default = $e33054b807b1e77a$var$PersonCircleIcon;

});
parcelRegister("l1s8i", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::aedef9bb726854d64999097926d2fc86>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f4df839259444615$var$_react = $f4df839259444615$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $f4df839259444615$var$_baseNew = $f4df839259444615$var$_interopRequireDefault((parcelRequire("enEmH")));
function $f4df839259444615$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PersonAvatar".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for user avatar.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f4df839259444615$var$PersonAvatarIcon = (props)=>/*#__PURE__*/ $f4df839259444615$var$_react.default.createElement($f4df839259444615$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 0 0-4.148 11.505A2.75 2.75 0 0 1 6.5 11h3c1.26 0 2.323.848 2.648 2.005A6.5 6.5 0 0 0 8 1.5m2.75 12.392v-.142c0-.69-.56-1.25-1.25-1.25h-3c-.69 0-1.25.56-1.25 1.25v.142l.06.027c.82.373 1.73.581 2.69.581s1.87-.208 2.69-.58q.03-.016.06-.028M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-3.5a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-3.5 2a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0" clip-rule="evenodd"/>`
    }, props));
$f4df839259444615$var$PersonAvatarIcon.displayName = 'PersonAvatarIcon';
var $f4df839259444615$var$_default = module.exports.default = $f4df839259444615$var$PersonAvatarIcon;

});


parcelRegister("gRmq4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c462fca590ebac64$var$_react = $c462fca590ebac64$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $c462fca590ebac64$var$_premium = $c462fca590ebac64$var$_interopRequireDefault((parcelRequire("kDE7H")));
function $c462fca590ebac64$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c462fca590ebac64$var$PremiumIcon = (props)=>/*#__PURE__*/ $c462fca590ebac64$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M9.276 4.382 7.357 9.247l-4.863 1.917a.78.78 0 0 0 0 1.45l4.863 1.918 1.919 4.863a.78.78 0 0 0 1.45 0h-.001l1.918-4.863 4.864-1.919a.781.781 0 0 0 0-1.45l-4.864-1.916-1.918-4.865a.78.78 0 0 0-.44-.438.78.78 0 0 0-1.01.438m8.297-2.03-.743 1.886-1.884.743a.56.56 0 0 0 0 1.038l1.884.743.743 1.886a.558.558 0 0 0 1.038 0l.745-1.886 1.883-.743a.557.557 0 0 0 0-1.038l-1.883-.743-.745-1.885a.55.55 0 0 0-.314-.314.56.56 0 0 0-.724.314m-.704 13.003-.744 1.883-1.883.744a.55.55 0 0 0-.316.314.56.56 0 0 0 .316.724l1.883.743.744 1.884c.057.144.17.258.314.315a.56.56 0 0 0 .724-.315l.744-1.884 1.883-.743a.557.557 0 0 0 0-1.038l-1.883-.744-.744-1.883a.55.55 0 0 0-.315-.316.56.56 0 0 0-.723.316"/></svg>`
    }, props, {
        newIcon: $c462fca590ebac64$var$_premium.default
    }));
$c462fca590ebac64$var$PremiumIcon.displayName = 'PremiumIcon';
var $c462fca590ebac64$var$_default = module.exports.default = $c462fca590ebac64$var$PremiumIcon;

});
parcelRegister("kDE7H", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::821d8a868bec01d1b9c95a45239911fb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f06692cfc39b36c4$var$_react = $f06692cfc39b36c4$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $f06692cfc39b36c4$var$_baseNew = $f06692cfc39b36c4$var$_interopRequireDefault((parcelRequire("enEmH")));
function $f06692cfc39b36c4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Premium".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for premium features.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f06692cfc39b36c4$var$PremiumIcon = (props)=>/*#__PURE__*/ $f06692cfc39b36c4$var$_react.default.createElement($f06692cfc39b36c4$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1.5 3v1.5H3V3h1.5V1.5H3V0H1.5v1.5H0V3zM8 1c.31 0 .587.19.699.478l1.63 4.193 4.193 1.63a.75.75 0 0 1 0 1.398l-4.193 1.63-1.63 4.193a.75.75 0 0 1-1.398 0l-1.63-4.193L1.478 8.7a.75.75 0 0 1 0-1.398l4.193-1.63L7.3 1.478A.75.75 0 0 1 8 1m0 2.82L6.949 6.521a.75.75 0 0 1-.427.427L3.819 8l2.703 1.051a.75.75 0 0 1 .427.427L8 12.181l1.051-2.703a.75.75 0 0 1 .427-.427L12.181 8 9.478 6.949a.75.75 0 0 1-.427-.427zm5 10.68V16h1.5v-1.5H16V13h-1.5v-1.5H13V13h-1.5v1.5z" clip-rule="evenodd"/>`
    }, props));
$f06692cfc39b36c4$var$PremiumIcon.displayName = 'PremiumIcon';
var $f06692cfc39b36c4$var$_default = module.exports.default = $f06692cfc39b36c4$var$PremiumIcon;

});


parcelRegister("6YheI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5135b77859a954ca$var$_react = $5135b77859a954ca$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $5135b77859a954ca$var$_questionCircle = $5135b77859a954ca$var$_interopRequireDefault((parcelRequire("4vF4i")));
function $5135b77859a954ca$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $5135b77859a954ca$var$QuestionCircleIcon = (props)=>/*#__PURE__*/ $5135b77859a954ca$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><circle cx="12" cy="18" r="1" fill="inherit"/><path fill="inherit" d="M15.89 9.05a3.98 3.98 0 0 0-2.957-2.942C10.321 5.514 8.017 7.446 8 9.95l.005.147a.99.99 0 0 0 .982.904c.552 0 1-.447 1.002-.998a2.004 2.004 0 0 1 4.007-.002c0 1.102-.898 2-2.003 2H12a1 1 0 0 0-1 .987v2.014a1.001 1.001 0 0 0 2.004 0v-.782c0-.217.145-.399.35-.472A3.99 3.99 0 0 0 15.89 9.05"/></g></svg>`
    }, props, {
        newIcon: $5135b77859a954ca$var$_questionCircle.default
    }));
$5135b77859a954ca$var$QuestionCircleIcon.displayName = 'QuestionCircleIcon';
var $5135b77859a954ca$var$_default = module.exports.default = $5135b77859a954ca$var$QuestionCircleIcon;

});
parcelRegister("4vF4i", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::63dc429f33c9470dc156b62d0ec66db5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3489e9fb29304034$var$_react = $3489e9fb29304034$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $3489e9fb29304034$var$_baseNew = $3489e9fb29304034$var$_interopRequireDefault((parcelRequire("enEmH")));
function $3489e9fb29304034$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "QuestionCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: help, tip.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3489e9fb29304034$var$QuestionCircleIcon = (props)=>/*#__PURE__*/ $3489e9fb29304034$var$_react.default.createElement($3489e9fb29304034$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-3c-.586 0-1 .414-1 1H5.5c0-1.414 1.086-2.5 2.5-2.5s2.5 1.086 2.5 2.5c0 1.133-.713 1.706-1.162 2.058-.511.402-.588.494-.588.692v.75h-1.5v-.75c0-.977.689-1.507 1.078-1.806l.084-.065C8.838 6.544 9 6.367 9 6c0-.586-.414-1-1-1" clip-rule="evenodd"/><path fill="currentcolor" d="M9 11.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$3489e9fb29304034$var$QuestionCircleIcon.displayName = 'QuestionCircleIcon';
var $3489e9fb29304034$var$_default = module.exports.default = $3489e9fb29304034$var$QuestionCircleIcon;

});


parcelRegister("6PZTp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4fa7841ef7b9261d$var$_react = $4fa7841ef7b9261d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $4fa7841ef7b9261d$var$_clock = $4fa7841ef7b9261d$var$_interopRequireDefault((parcelRequire("5purl")));
function $4fa7841ef7b9261d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $4fa7841ef7b9261d$var$RecentIcon = (props)=>/*#__PURE__*/ $4fa7841ef7b9261d$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11 8.002v4.002c0 .28.116.53.301.712l2.47 2.47a1.003 1.003 0 0 0 1.414 0 1.003 1.003 0 0 0 0-1.415L13 11.586V6a1 1 0 0 0-2 0zM12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10"/></svg>`
    }, props, {
        newIcon: $4fa7841ef7b9261d$var$_clock.default
    }));
$4fa7841ef7b9261d$var$RecentIcon.displayName = 'RecentIcon';
var $4fa7841ef7b9261d$var$_default = module.exports.default = $4fa7841ef7b9261d$var$RecentIcon;

});
parcelRegister("5purl", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::92ee1be6e4ceec90ef291a87140cefc4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3f06e648a53109f5$var$_react = $3f06e648a53109f5$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $3f06e648a53109f5$var$_baseNew = $3f06e648a53109f5$var$_interopRequireDefault((parcelRequire("enEmH")));
function $3f06e648a53109f5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Clock".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: recent, time input, sprint time remaining. Overdue task issue status in JSM Calendar view.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3f06e648a53109f5$var$ClockIcon = (props)=>/*#__PURE__*/ $3f06e648a53109f5$var$_react.default.createElement($3f06e648a53109f5$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8.75-.36V3.25h-1.5v5.11l2.781 2.226.938-1.172z" clip-rule="evenodd"/>`
    }, props));
$3f06e648a53109f5$var$ClockIcon.displayName = 'ClockIcon';
var $3f06e648a53109f5$var$_default = module.exports.default = $3f06e648a53109f5$var$ClockIcon;

});


parcelRegister("lKjAS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fd4d17c8a1c3d7ec$var$_react = $fd4d17c8a1c3d7ec$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $fd4d17c8a1c3d7ec$var$_roadmap = $fd4d17c8a1c3d7ec$var$_interopRequireDefault((parcelRequire("aCAjf")));
function $fd4d17c8a1c3d7ec$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $fd4d17c8a1c3d7ec$var$RoadmapIcon = (props)=>/*#__PURE__*/ $fd4d17c8a1c3d7ec$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M6 2h10a3 3 0 0 1 0 6H6a3 3 0 1 1 0-6m0 2a1 1 0 1 0 0 2h10a1 1 0 0 0 0-2zm4 5h8a3 3 0 0 1 0 6h-8a3 3 0 0 1 0-6m0 2a1 1 0 0 0 0 2h8a1 1 0 0 0 0-2zm-4 5h6a3 3 0 0 1 0 6H6a3 3 0 0 1 0-6m0 2a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2z"/></svg>`
    }, props, {
        newIcon: $fd4d17c8a1c3d7ec$var$_roadmap.default
    }));
$fd4d17c8a1c3d7ec$var$RoadmapIcon.displayName = 'RoadmapIcon';
var $fd4d17c8a1c3d7ec$var$_default = module.exports.default = $fd4d17c8a1c3d7ec$var$RoadmapIcon;

});
parcelRegister("aCAjf", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1e0a5e9b0b4b1b954a0d2b89a777fbfe>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7bb99e467a1c8fe4$var$_react = $7bb99e467a1c8fe4$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $7bb99e467a1c8fe4$var$_baseNew = $7bb99e467a1c8fe4$var$_interopRequireDefault((parcelRequire("enEmH")));
function $7bb99e467a1c8fe4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Roadmap".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for roadmaps in Jira or Trello.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7bb99e467a1c8fe4$var$RoadmapIcon = (props)=>/*#__PURE__*/ $7bb99e467a1c8fe4$var$_react.default.createElement($7bb99e467a1c8fe4$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5zM3 11a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/>`
    }, props));
$7bb99e467a1c8fe4$var$RoadmapIcon.displayName = 'RoadmapIcon';
var $7bb99e467a1c8fe4$var$_default = module.exports.default = $7bb99e467a1c8fe4$var$RoadmapIcon;

});


parcelRegister("cwZY7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $91f88ae021f17d63$var$_react = $91f88ae021f17d63$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $91f88ae021f17d63$var$_screen = $91f88ae021f17d63$var$_interopRequireDefault((parcelRequire("kAA90")));
function $91f88ae021f17d63$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $91f88ae021f17d63$var$ScreenIcon = (props)=>/*#__PURE__*/ $91f88ae021f17d63$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M3 6.009C3 4.899 3.893 4 4.995 4h14.01C20.107 4 21 4.902 21 6.009v7.982c0 1.11-.893 2.009-1.995 2.009H4.995A2.004 2.004 0 0 1 3 13.991zM5 14h14V6H5z"/><path d="M10 17h4v3h-4zm-1 3.5a.5.5 0 0 1 .49-.5h5.02a.5.5 0 0 1 .49.5v.5H9z"/></g></svg>`
    }, props, {
        newIcon: $91f88ae021f17d63$var$_screen.default
    }));
$91f88ae021f17d63$var$ScreenIcon.displayName = 'ScreenIcon';
var $91f88ae021f17d63$var$_default = module.exports.default = $91f88ae021f17d63$var$ScreenIcon;

});
parcelRegister("kAA90", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1698552166bfef93121ec02f2fff1081>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $efd334f3270a5bb5$var$_react = $efd334f3270a5bb5$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $efd334f3270a5bb5$var$_baseNew = $efd334f3270a5bb5$var$_interopRequireDefault((parcelRequire("enEmH")));
function $efd334f3270a5bb5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Screen".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: assets in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $efd334f3270a5bb5$var$ScreenIcon = (props)=>/*#__PURE__*/ $efd334f3270a5bb5$var$_react.default.createElement($efd334f3270a5bb5$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H8.75v1.5H12V15H4v-1.5h3.25V12H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/>`
    }, props));
$efd334f3270a5bb5$var$ScreenIcon.displayName = 'ScreenIcon';
var $efd334f3270a5bb5$var$_default = module.exports.default = $efd334f3270a5bb5$var$ScreenIcon;

});


parcelRegister("fVct6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b975d9dfaaf4a0f2$var$_react = $b975d9dfaaf4a0f2$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $b975d9dfaaf4a0f2$var$_search = $b975d9dfaaf4a0f2$var$_interopRequireDefault((parcelRequire("aWy0H")));
function $b975d9dfaaf4a0f2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $b975d9dfaaf4a0f2$var$SearchIcon = (props)=>/*#__PURE__*/ $b975d9dfaaf4a0f2$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m16.436 15.085 3.94 4.01a1 1 0 0 1-1.425 1.402l-3.938-4.006a7.5 7.5 0 1 1 1.423-1.406M10.5 16a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11"/></svg>`
    }, props, {
        newIcon: $b975d9dfaaf4a0f2$var$_search.default
    }));
$b975d9dfaaf4a0f2$var$SearchIcon.displayName = 'SearchIcon';
var $b975d9dfaaf4a0f2$var$_default = module.exports.default = $b975d9dfaaf4a0f2$var$SearchIcon;

});
parcelRegister("aWy0H", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::17c2ea3862f75cebada30b1178c22cdb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7f79b3e9dcd067a8$var$_react = $7f79b3e9dcd067a8$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $7f79b3e9dcd067a8$var$_baseNew = $7f79b3e9dcd067a8$var$_interopRequireDefault((parcelRequire("enEmH")));
function $7f79b3e9dcd067a8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Search".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for searching objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7f79b3e9dcd067a8$var$SearchIcon = (props)=>/*#__PURE__*/ $7f79b3e9dcd067a8$var$_react.default.createElement($7f79b3e9dcd067a8$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7 2.5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9M1 7a6 6 0 1 1 10.74 3.68l3.29 3.29-1.06 1.06-3.29-3.29A6 6 0 0 1 1 7" clip-rule="evenodd"/>`
    }, props));
$7f79b3e9dcd067a8$var$SearchIcon.displayName = 'SearchIcon';
var $7f79b3e9dcd067a8$var$_default = module.exports.default = $7f79b3e9dcd067a8$var$SearchIcon;

});


parcelRegister("6sQcY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4b4ddb111fef2ff6$var$_react = $4b4ddb111fef2ff6$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $4b4ddb111fef2ff6$var$_settings = $4b4ddb111fef2ff6$var$_interopRequireDefault((parcelRequire("51oeD")));
function $4b4ddb111fef2ff6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $4b4ddb111fef2ff6$var$SettingsIcon = (props)=>/*#__PURE__*/ $4b4ddb111fef2ff6$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11.701 16.7a5.002 5.002 0 1 1 0-10.003 5.002 5.002 0 0 1 0 10.004m8.368-3.117a1.995 1.995 0 0 1-1.346-1.885c0-.876.563-1.613 1.345-1.885a.48.48 0 0 0 .315-.574 9 9 0 0 0-.836-1.993.48.48 0 0 0-.598-.195 2.04 2.04 0 0 1-1.29.08 1.99 1.99 0 0 1-1.404-1.395 2.04 2.04 0 0 1 .076-1.297.48.48 0 0 0-.196-.597 9 9 0 0 0-1.975-.826.48.48 0 0 0-.574.314 1.995 1.995 0 0 1-1.885 1.346 1.99 1.99 0 0 1-1.884-1.345.48.48 0 0 0-.575-.315c-.708.2-1.379.485-2.004.842a.47.47 0 0 0-.198.582A2.002 2.002 0 0 1 4.445 7.06a.48.48 0 0 0-.595.196 9 9 0 0 0-.833 1.994.48.48 0 0 0 .308.572 1.995 1.995 0 0 1 1.323 1.877c0 .867-.552 1.599-1.324 1.877a.48.48 0 0 0-.308.57 9 9 0 0 0 .723 1.79.477.477 0 0 0 .624.194c.595-.273 1.343-.264 2.104.238.117.077.225.185.302.3.527.8.512 1.58.198 2.188a.473.473 0 0 0 .168.628 9 9 0 0 0 2.11.897.474.474 0 0 0 .57-.313 1.995 1.995 0 0 1 1.886-1.353c.878 0 1.618.567 1.887 1.353a.475.475 0 0 0 .57.313 9 9 0 0 0 2.084-.883.473.473 0 0 0 .167-.631c-.318-.608-.337-1.393.191-2.195.077-.116.185-.225.302-.302.772-.511 1.527-.513 2.125-.23a.477.477 0 0 0 .628-.19 9 9 0 0 0 .728-1.793.48.48 0 0 0-.314-.573"/></svg>`
    }, props, {
        newIcon: $4b4ddb111fef2ff6$var$_settings.default
    }));
$4b4ddb111fef2ff6$var$SettingsIcon.displayName = 'SettingsIcon';
var $4b4ddb111fef2ff6$var$_default = module.exports.default = $4b4ddb111fef2ff6$var$SettingsIcon;

});
parcelRegister("51oeD", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::654979ffcf55141d2c08f198a843721e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3a7fd84f1fe04113$var$_react = $3a7fd84f1fe04113$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $3a7fd84f1fe04113$var$_baseNew = $3a7fd84f1fe04113$var$_interopRequireDefault((parcelRequire("enEmH")));
function $3a7fd84f1fe04113$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Settings".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for any object or user settings.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3a7fd84f1fe04113$var$SettingsIcon = (props)=>/*#__PURE__*/ $3a7fd84f1fe04113$var$_react.default.createElement($3a7fd84f1fe04113$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.058.462A.75.75 0 0 1 6.75 0h2.5a.75.75 0 0 1 .692.462l1.026 2.462 2.578-.374a.75.75 0 0 1 .757.367l1.25 2.166a.75.75 0 0 1-.049.824L13.937 8l1.567 2.093c.18.24.2.565.05.825l-1.25 2.165a.75.75 0 0 1-.758.367l-2.578-.374-1.026 2.463A.75.75 0 0 1 9.25 16h-2.5a.75.75 0 0 1-.692-.461l-1.026-2.463-2.578.374a.75.75 0 0 1-.757-.367l-1.25-2.165a.75.75 0 0 1 .049-.825L2.063 8 .496 5.907a.75.75 0 0 1-.05-.824l1.25-2.166a.75.75 0 0 1 .758-.367l2.578.374zM7.25 1.5l-.871 2.09c-.242.58-.845.923-1.467.833l-2.17-.315-.749 1.296L3.32 7.176c.366.488.366 1.16 0 1.648l-1.327 1.772.749 1.296 2.17-.315a1.375 1.375 0 0 1 1.467.832L7.25 14.5h1.5l.871-2.09c.242-.58.845-.923 1.467-.833l2.17.315.749-1.296-1.327-1.772a1.375 1.375 0 0 1 0-1.648l1.327-1.772-.749-1.296-2.17.315A1.375 1.375 0 0 1 9.62 3.59L8.75 1.5zm.75 5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M5 8a3 3 0 1 1 6 0 3 3 0 0 1-6 0" clip-rule="evenodd"/>`
    }, props));
$3a7fd84f1fe04113$var$SettingsIcon.displayName = 'SettingsIcon';
var $3a7fd84f1fe04113$var$_default = module.exports.default = $3a7fd84f1fe04113$var$SettingsIcon;

});


parcelRegister("flOXi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b2d057d7824eec4a$var$_react = $b2d057d7824eec4a$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $b2d057d7824eec4a$var$_release = $b2d057d7824eec4a$var$_interopRequireDefault((parcelRequire("6rsly")));
function $b2d057d7824eec4a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $b2d057d7824eec4a$var$ShipIcon = (props)=>/*#__PURE__*/ $b2d057d7824eec4a$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M6 12h8v-2H6zM4 8.99C4 8.445 4.456 8 5.002 8h9.996C15.55 8 16 8.451 16 8.99V14H4z"/><path d="M6 7.005C6 5.898 6.898 5 7.998 5h2.004C11.106 5 12 5.894 12 7.005V10H6zm4 0V7H7.999c.005 0 .002.003.002.005V8h2z"/><path fill-rule="nonzero" d="M4.5 17h13.994l1.002-3H4.14zm-2.495-4.012A.862.862 0 0 1 2.883 12h18.393c.55 0 .857.417.681.944l-1.707 5.112c-.174.521-.758.944-1.315.944H3.725a1.15 1.15 0 0 1-1.118-.988z"/></g></svg>`
    }, props, {
        newIcon: $b2d057d7824eec4a$var$_release.default
    }));
$b2d057d7824eec4a$var$ShipIcon.displayName = 'ShipIcon';
var $b2d057d7824eec4a$var$_default = module.exports.default = $b2d057d7824eec4a$var$ShipIcon;

});
parcelRegister("6rsly", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a1a26e96d639121c034f7ae4d8530108>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4b0b40bcda2e48d0$var$_react = $4b0b40bcda2e48d0$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $4b0b40bcda2e48d0$var$_baseNew = $4b0b40bcda2e48d0$var$_interopRequireDefault((parcelRequire("enEmH")));
function $4b0b40bcda2e48d0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Release".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for releases in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4b0b40bcda2e48d0$var$ReleaseIcon = (props)=>/*#__PURE__*/ $4b0b40bcda2e48d0$var$_react.default.createElement($4b0b40bcda2e48d0$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4 2h3v2h2a.75.75 0 0 1 .648.372L11.18 7h4.069a.75.75 0 0 1 .646 1.132l-2.887 4.886a2 2 0 0 1-1.722.982H2a2 2 0 0 1-2-2V7.75A.75.75 0 0 1 .75 7H2V4.75A.75.75 0 0 1 2.75 4H4zm-.5 5h5.944L8.57 5.5H3.5zm-2 1.5V12a.5.5 0 0 0 .5.5h9.287a.5.5 0 0 0 .43-.246L13.936 8.5z" clip-rule="evenodd"/>`
    }, props));
$4b0b40bcda2e48d0$var$ReleaseIcon.displayName = 'ReleaseIcon';
var $4b0b40bcda2e48d0$var$_default = module.exports.default = $4b0b40bcda2e48d0$var$ReleaseIcon;

});


parcelRegister("a8Wzb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $762814cd2ddc53bf$var$_react = $762814cd2ddc53bf$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $762814cd2ddc53bf$var$_linkExternal = $762814cd2ddc53bf$var$_interopRequireDefault((parcelRequire("lggcf")));
function $762814cd2ddc53bf$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $762814cd2ddc53bf$var$ShortcutIcon = (props)=>/*#__PURE__*/ $762814cd2ddc53bf$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M5 19.01V19zM5 4.99V5zM19 19v-6h2v6a2 2 0 0 1-1.99 2H5a2 2 0 0 1-2-1.99V4.99C3 3.89 3.9 3 5 3h6v2H5v14zM5 4.99V5zM11 5H5v14h14v-6h2v6a2 2 0 0 1-1.99 2H5a2 2 0 0 1-2-1.99V4.99C3 3.89 3.9 3 5 3h6zm8 0v3a1 1 0 0 0 2 0V4a1 1 0 0 0-1-1h-4a1 1 0 0 0 0 2z"/><path d="m12.707 12.707 8-8a1 1 0 1 0-1.414-1.414l-8 8a1 1 0 0 0 1.414 1.414"/></g></svg>`
    }, props, {
        newIcon: $762814cd2ddc53bf$var$_linkExternal.default
    }));
$762814cd2ddc53bf$var$ShortcutIcon.displayName = 'ShortcutIcon';
var $762814cd2ddc53bf$var$_default = module.exports.default = $762814cd2ddc53bf$var$ShortcutIcon;

});
parcelRegister("lggcf", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3602017c9c0db571ac57dae4d1f426bd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f7a7a7e381538853$var$_react = $f7a7a7e381538853$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $f7a7a7e381538853$var$_baseNew = $f7a7a7e381538853$var$_interopRequireDefault((parcelRequire("enEmH")));
function $f7a7a7e381538853$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LinkExternal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links that open up a new tab.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f7a7a7e381538853$var$LinkExternalIcon = (props)=>/*#__PURE__*/ $f7a7a7e381538853$var$_react.default.createElement($f7a7a7e381538853$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 2.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5v-3H15v3a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h3v1.5zM10 1h4.25a.75.75 0 0 1 .75.75V6h-1.5V3.56L7.53 9.53 6.47 8.47l5.97-5.97H10z" clip-rule="evenodd"/>`
    }, props));
$f7a7a7e381538853$var$LinkExternalIcon.displayName = 'LinkExternalIcon';
var $f7a7a7e381538853$var$_default = module.exports.default = $f7a7a7e381538853$var$LinkExternalIcon;

});


parcelRegister("bQzaw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $89ffd4cdf2f0d6fe$var$_react = $89ffd4cdf2f0d6fe$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $89ffd4cdf2f0d6fe$var$_logIn = $89ffd4cdf2f0d6fe$var$_interopRequireDefault((parcelRequire("1ASTt")));
function $89ffd4cdf2f0d6fe$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $89ffd4cdf2f0d6fe$var$SignInIcon = (props)=>/*#__PURE__*/ $89ffd4cdf2f0d6fe$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M15.503 3H12v2h7v14h-7v2h7.006c1.1 0 1.994-.893 1.994-1.995V4.995A1.993 1.993 0 0 0 19.006 3z"/><path d="M3.977 11A.99.99 0 0 0 3 12.001c0 .551.437.999.977.999h11.047a.99.99 0 0 0 .976-.999.99.99 0 0 0-.976-1.001z"/><path d="M12.303 8.305a1.053 1.053 0 0 0 0 1.478L14.5 12l-2.197 2.217a1.05 1.05 0 0 0 0 1.476c.404.409 1.06.409 1.465 0l2.93-2.955a1.055 1.055 0 0 0 0-1.477l-2.93-2.956a1.034 1.034 0 0 0-1.465 0"/></g></svg>`
    }, props, {
        newIcon: $89ffd4cdf2f0d6fe$var$_logIn.default
    }));
$89ffd4cdf2f0d6fe$var$SignInIcon.displayName = 'SignInIcon';
var $89ffd4cdf2f0d6fe$var$_default = module.exports.default = $89ffd4cdf2f0d6fe$var$SignInIcon;

});
parcelRegister("1ASTt", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cd6da84e11aa1d5b6e9ca710faf282a3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1293bbfd294990bc$var$_react = $1293bbfd294990bc$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $1293bbfd294990bc$var$_baseNew = $1293bbfd294990bc$var$_interopRequireDefault((parcelRequire("enEmH")));
function $1293bbfd294990bc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LogIn".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for log in.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1293bbfd294990bc$var$LogInIcon = (props)=>/*#__PURE__*/ $1293bbfd294990bc$var$_react.default.createElement($1293bbfd294990bc$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M13 2.5H8V1h5a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H8v-1.5h5a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5M7.44 7.25 5.22 5.03l1.06-1.06 3.5 3.5a.75.75 0 0 1 0 1.06l-3.5 3.5-1.06-1.06 2.22-2.22H1v-1.5z" clip-rule="evenodd"/>`
    }, props));
$1293bbfd294990bc$var$LogInIcon.displayName = 'LogInIcon';
var $1293bbfd294990bc$var$_default = module.exports.default = $1293bbfd294990bc$var$LogInIcon;

});


parcelRegister("k71Jv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ea45ce3da7a27f98$var$_react = $ea45ce3da7a27f98$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $ea45ce3da7a27f98$var$_starUnstarred = $ea45ce3da7a27f98$var$_interopRequireDefault((parcelRequire("fkyxu")));
function $ea45ce3da7a27f98$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $ea45ce3da7a27f98$var$StarIcon = (props)=>/*#__PURE__*/ $ea45ce3da7a27f98$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="m12 16.373 3.98 2.193-.76-4.655 3.276-3.347-4.524-.69L12 5.687l-1.972 4.189-4.524.689L8.78 13.91l-.762 4.655zm0 2.283-3.016 1.662a2 2 0 0 1-2.939-2.075l.599-3.656-2.57-2.624a2 2 0 0 1 1.129-3.377l3.47-.528 1.518-3.224a2 2 0 0 1 3.618 0l1.519 3.224 3.47.528a2 2 0 0 1 1.127 3.377l-2.569 2.624.599 3.656a2 2 0 0 1-2.94 2.075z"/></svg>`
    }, props, {
        newIcon: $ea45ce3da7a27f98$var$_starUnstarred.default
    }));
$ea45ce3da7a27f98$var$StarIcon.displayName = 'StarIcon';
var $ea45ce3da7a27f98$var$_default = module.exports.default = $ea45ce3da7a27f98$var$StarIcon;

});
parcelRegister("fkyxu", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::79fdc87e6bc8c8ac301f370494c87ace>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b2938407971fb2e3$var$_react = $b2938407971fb2e3$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $b2938407971fb2e3$var$_baseNew = $b2938407971fb2e3$var$_interopRequireDefault((parcelRequire("enEmH")));
function $b2938407971fb2e3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StarUnstarred".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for starring or favoriting objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b2938407971fb2e3$var$StarUnstarredIcon = (props)=>/*#__PURE__*/ $b2938407971fb2e3$var$_react.default.createElement($b2938407971fb2e3$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a.75.75 0 0 1 .7.48l1.705 4.434 4.403.338a.75.75 0 0 1 .422 1.324l-3.38 2.818 1.25 4.662a.75.75 0 0 1-1.148.813L8 12.159l-3.95 2.71a.75.75 0 0 1-1.15-.813l1.251-4.662L.77 6.576a.75.75 0 0 1 .422-1.324l4.403-.338L7.3.48A.75.75 0 0 1 8 0m0 2.84L6.655 6.335l-3.506.27 2.7 2.25-.973 3.627L8 10.341l3.124 2.142-.973-3.627 2.7-2.25-3.506-.27z" clip-rule="evenodd"/>`
    }, props));
$b2938407971fb2e3$var$StarUnstarredIcon.displayName = 'StarUnstarredIcon';
var $b2938407971fb2e3$var$_default = module.exports.default = $b2938407971fb2e3$var$StarUnstarredIcon;

});


parcelRegister("awkL7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7a8cfed9663375d2$var$_react = $7a8cfed9663375d2$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $7a8cfed9663375d2$var$_starStarred = $7a8cfed9663375d2$var$_interopRequireDefault((parcelRequire("X3Phd")));
function $7a8cfed9663375d2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7a8cfed9663375d2$var$StarFilledIcon = (props)=>/*#__PURE__*/ $7a8cfed9663375d2$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m12.072 17.284-3.905 2.053a1 1 0 0 1-1.451-1.054l.745-4.349-3.159-3.08a1 1 0 0 1 .554-1.705l4.366-.635 1.953-3.956a1 1 0 0 1 1.794 0l1.952 3.956 4.366.635a1 1 0 0 1 .555 1.705l-3.16 3.08.746 4.349a1 1 0 0 1-1.45 1.054z"/></svg>`
    }, props, {
        newIcon: $7a8cfed9663375d2$var$_starStarred.default
    }));
$7a8cfed9663375d2$var$StarFilledIcon.displayName = 'StarFilledIcon';
var $7a8cfed9663375d2$var$_default = module.exports.default = $7a8cfed9663375d2$var$StarFilledIcon;

});
parcelRegister("X3Phd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::84298877a5ffec5302189e1356603055>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0b187a933c7654d0$var$_react = $0b187a933c7654d0$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $0b187a933c7654d0$var$_baseNew = $0b187a933c7654d0$var$_interopRequireDefault((parcelRequire("enEmH")));
function $0b187a933c7654d0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StarStarred".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for starred or favourited objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0b187a933c7654d0$var$StarStarredIcon = (props)=>/*#__PURE__*/ $0b187a933c7654d0$var$_react.default.createElement($0b187a933c7654d0$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a.75.75 0 0 1 .7.48l1.705 4.434 4.403.338a.75.75 0 0 1 .422 1.324l-3.38 2.818 1.25 4.662a.75.75 0 0 1-1.148.813L8 12.159l-3.95 2.71a.75.75 0 0 1-1.15-.813l1.251-4.662L.77 6.576a.75.75 0 0 1 .422-1.324l4.403-.338L7.3.48A.75.75 0 0 1 8 0m0 2.84L6.655 6.335l-3.506.27 2.7 2.25-.973 3.627L8 10.341l3.124 2.142-.973-3.627 2.7-2.25-3.506-.27z" clip-rule="evenodd"/><path fill="currentcolor" d="M6.655 6.336 8 2.84l1.345 3.497 3.506.27-2.7 2.25.973 3.627L8 10.341l-3.124 2.142.973-3.627-2.7-2.25z"/>`
    }, props));
$0b187a933c7654d0$var$StarStarredIcon.displayName = 'StarStarredIcon';
var $0b187a933c7654d0$var$_default = module.exports.default = $0b187a933c7654d0$var$StarStarredIcon;

});


parcelRegister("6K1uI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4e8832bd4b1ad536$var$_react = $4e8832bd4b1ad536$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $4e8832bd4b1ad536$var$_personAvatar = $4e8832bd4b1ad536$var$_interopRequireDefault((parcelRequire("l1s8i")));
function $4e8832bd4b1ad536$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $4e8832bd4b1ad536$var$UserAvatarCircleIcon = (props)=>/*#__PURE__*/ $4e8832bd4b1ad536$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><circle cx="12" cy="9" r="3" fill="inherit"/><path fill="inherit" fill-rule="nonzero" d="M7 18.245A7.97 7.97 0 0 0 12 20c1.892 0 3.63-.657 5-1.755V15c0-1.115-.895-2-2-2H9c-1.113 0-2 .895-2 2z"/></g></svg>`
    }, props, {
        newIcon: $4e8832bd4b1ad536$var$_personAvatar.default
    }));
$4e8832bd4b1ad536$var$UserAvatarCircleIcon.displayName = 'UserAvatarCircleIcon';
var $4e8832bd4b1ad536$var$_default = module.exports.default = $4e8832bd4b1ad536$var$UserAvatarCircleIcon;

});

parcelRegister("eUaFh", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $fd2cf97f87c3ad51$export$2e2bcd8739ae039);
/* modal-header.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");
parcelRequire("5uXOq");

var $eWkgo = parcelRequire("eWkgo");
var $2s57o = parcelRequire("2s57o");

var $jorqd = parcelRequire("jorqd");

var $i2ajl = parcelRequire("i2ajl");
const $fd2cf97f87c3ad51$var$headerStyles = null;
const $fd2cf97f87c3ad51$var$flexStyles = (0, $2s57o.xcss)({
    flexDirection: 'row-reverse',
    width: '100%'
});
/**
 * __Modal header__
 *
 * A modal header contains the title of the modal and can contain other React elements such as a close button.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples#modal-header)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-header-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ const $fd2cf97f87c3ad51$var$ModalHeader = (props)=>{
    const { children: children, testId: userDefinedTestId, hasCloseButton: hasCloseButton = false } = props;
    const { hasProvidedOnClose: hasProvidedOnClose, onClose: onClose, testId: modalTestId } = (0, $i2ajl.useModal)();
    const testId = userDefinedTestId || modalTestId && `${modalTestId}--header`;
    // Only show if an onClose was provided for the modal dialog
    const shouldShowCloseButton = hasCloseButton && hasProvidedOnClose && onClose;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            "_18zr1ejb _1e0c1txw _kqswh2mm _4cvr1h6o _1bah1yb4 _6rth1ezb _85i5pxbi _1q511ejb"
        ]),
        children: shouldShowCloseButton ? // The reason we are putting the close button first in the DOM and then
        // reordering them is to ensure that users of assistive technology get
        // all the context of a modal when initial focus is placed on the close
        // button, since it's the first interactive element.
        /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $eWkgo.default), {
            gap: "space.200",
            justifyContent: "space-between",
            xcss: $fd2cf97f87c3ad51$var$flexStyles,
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eWkgo.default), {
                    justifyContent: "end",
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jorqd.CloseButton), {
                        onClick: onClose,
                        testId: modalTestId
                    })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eWkgo.default), {
                    justifyContent: "start",
                    alignItems: "center",
                    children: children
                })
            ]
        }) : children
    });
};
var $fd2cf97f87c3ad51$export$2e2bcd8739ae039 = $fd2cf97f87c3ad51$var$ModalHeader;

});
parcelRegister("eWkgo", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a474443a19d3969$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $avgEF = parcelRequire("avgEF");

var $2s57o = parcelRequire("2s57o");
function $7a474443a19d3969$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7a474443a19d3969$var$justifyContentMap = {
    start: {
        name: "j1lm6p",
        styles: "justify-content:start"
    },
    center: {
        name: "f7ay7b",
        styles: "justify-content:center"
    },
    end: {
        name: "jab4lt",
        styles: "justify-content:end"
    },
    'space-between': {
        name: "2o6p8u",
        styles: "justify-content:space-between"
    },
    'space-around': {
        name: "46cjum",
        styles: "justify-content:space-around"
    },
    'space-evenly': {
        name: "16166rn",
        styles: "justify-content:space-evenly"
    },
    stretch: {
        name: "11z2bqs",
        styles: "justify-content:stretch"
    }
};
const $7a474443a19d3969$var$flexDirectionMap = {
    column: {
        name: "qdeacm",
        styles: "flex-direction:column"
    },
    row: {
        name: "mcnhyd",
        styles: "flex-direction:row"
    }
};
const $7a474443a19d3969$var$flexWrapMap = {
    wrap: {
        name: "1qemjat",
        styles: "flex-wrap:wrap"
    },
    nowrap: {
        name: "14gl6v0",
        styles: "flex-wrap:nowrap"
    }
};
const $7a474443a19d3969$var$alignItemsMap = {
    start: {
        name: "yvwru5",
        styles: "align-items:start"
    },
    center: {
        name: "1h3rtzg",
        styles: "align-items:center"
    },
    baseline: {
        name: "fzr848",
        styles: "align-items:baseline"
    },
    end: {
        name: "uj5xqj",
        styles: "align-items:end"
    },
    stretch: {
        name: "1ikgkii",
        styles: "align-items:stretch"
    }
};
const $7a474443a19d3969$var$baseStyles = {
    name: "kxpnum",
    styles: "display:flex;box-sizing:border-box"
};
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ const $7a474443a19d3969$var$Flex = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: Component = 'div', role: role, alignItems: alignItems, justifyContent: justifyContent, gap: gap, columnGap: columnGap, rowGap: rowGap, children: children, testId: testId, direction: direction, wrap: wrap, xcss: xcss }, ref)=>{
    const resolvedStyles = (0, $2s57o.parseXcss)(xcss);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)(Component, {
        role: role,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        css: [
            $7a474443a19d3969$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            gap && (0, $avgEF.spaceStylesMap).gap[gap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            columnGap && (0, $avgEF.spaceStylesMap).columnGap[columnGap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            rowGap && (0, $avgEF.spaceStylesMap).rowGap[rowGap],
            alignItems && $7a474443a19d3969$var$alignItemsMap[alignItems],
            direction && $7a474443a19d3969$var$flexDirectionMap[direction],
            justifyContent && $7a474443a19d3969$var$justifyContentMap[justifyContent],
            wrap && $7a474443a19d3969$var$flexWrapMap[wrap],
            resolvedStyles.emotion
        ],
        "data-testid": testId,
        ref: ref
    }, children);
}));
$7a474443a19d3969$var$Flex.displayName = 'Flex';
var $7a474443a19d3969$export$2e2bcd8739ae039 = $7a474443a19d3969$var$Flex;

});

parcelRegister("jorqd", function(module, exports) {

$parcel$export(module.exports, "CloseButton", () => $a91579aeda0e7f89$export$de65de8213222d10);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $1Seuh = parcelRequire("1Seuh");

var $kweMg = parcelRequire("kweMg");
const $a91579aeda0e7f89$export$de65de8213222d10 = ({ label: label, onClick: onClick, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $1Seuh.default), {
        testId: testId && `${testId}--close-button`,
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kweMg))),
        label: label || 'Close Modal',
        onClick: onClick
    });

});
parcelRegister("1Seuh", function(module, exports) {

$parcel$export(module.exports, "default", () => $37a0e3ae5433a335$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $cD7p8 = parcelRequire("cD7p8");

var $5KCCi = parcelRequire("5KCCi");

var $cBCgC = parcelRequire("cBCgC");

var $2ifdJ = parcelRequire("2ifdJ");

var $4gHTL = parcelRequire("4gHTL");

var $153Gb = parcelRequire("153Gb");
/**
 * __Icon Button__
 *
 * Renders an icon-only button lets people take a common and recognizable action where space is limited.
 *
 * - [Examples](https://atlassian.design/components/button/icon-button/examples)
 * - [Code](https://atlassian.design/components/button/icon-button/code)
 * - [Usage](https://atlassian.design/components/button/icon-button/usage)
 */ const $37a0e3ae5433a335$var$IconButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef(function Button({ // Prevent duplicate labels being added.
'aria-label': preventedAriaLabel, 'aria-labelledby': ariaLabelledBy, analyticsContext: analyticsContext, appearance: appearance, autoFocus: autoFocus, icon: icon, interactionName: interactionName, isDisabled: isDisabled, isLoading: isLoading = false, isSelected: isSelected, isTooltipDisabled: isTooltipDisabled = true, label: label, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, shape: shape, spacing: spacing, testId: testId, tooltip: tooltip, type: type = 'button', ...unsafeRest }, ref) {
    // @ts-expect-error
    const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
    if (isTooltipDisabled) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2ifdJ.default), {
        ...saferRest,
        ref: ref,
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        isIconButton: true,
        isCircle: shape === 'circle',
        hasIconBefore: !!icon,
        spacing: spacing,
        ariaLabelledBy: ariaLabelledBy,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        testId: testId,
        componentName: "IconButton",
        analyticsContext: analyticsContext,
        type: type,
        interactionName: interactionName,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $4gHTL.default), {
            type: "icon",
            isLoading: isLoading,
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $153Gb.default), {
                    icon: icon
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cBCgC.default), {
                    children: label
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5KCCi.default), {
        content: tooltip?.content ?? label,
        testId: tooltip?.testId,
        position: tooltip?.position,
        delay: tooltip?.delay,
        onShow: tooltip?.onShow,
        onHide: tooltip?.onHide,
        mousePosition: tooltip?.mousePosition,
        analyticsContext: tooltip?.analyticsContext,
        strategy: tooltip?.strategy,
        tag: tooltip?.tag,
        truncate: tooltip?.truncate,
        component: tooltip?.component,
        hideTooltipOnClick: tooltip?.hideTooltipOnClick,
        hideTooltipOnMouseDown: tooltip?.hideTooltipOnMouseDown,
        ignoreTooltipPointerEvents: tooltip?.ignoreTooltipPointerEvents,
        children: (triggerProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $2ifdJ.default), {
                ...saferRest,
                appearance: appearance,
                autoFocus: autoFocus,
                isDisabled: isDisabled,
                isLoading: isLoading,
                isSelected: isSelected,
                isIconButton: true,
                isCircle: shape === 'circle',
                hasIconBefore: false,
                spacing: spacing,
                ariaLabelledBy: ariaLabelledBy,
                onClick: (e, analyticsEvent)=>{
                    onClick?.(e, analyticsEvent);
                    triggerProps.onClick?.(e);
                },
                onMouseOver: (e)=>{
                    triggerProps.onMouseOver?.(e);
                    saferRest.onMouseOver?.(e);
                },
                onMouseOut: (e)=>{
                    triggerProps.onMouseOut?.(e);
                    saferRest.onMouseOut?.(e);
                },
                onMouseMove: (e)=>{
                    triggerProps.onMouseMove?.(e);
                    saferRest.onMouseMove?.(e);
                },
                onMouseDown: (e)=>{
                    triggerProps.onMouseDown?.(e);
                    saferRest.onMouseDown?.(e);
                },
                onFocus: (e)=>{
                    triggerProps.onFocus?.(e);
                    saferRest.onFocus?.(e);
                },
                onBlur: (e)=>{
                    triggerProps.onBlur?.(e);
                    saferRest.onBlur?.(e);
                },
                ref: (0, $cD7p8.default)([
                    ref,
                    triggerProps?.ref
                ].filter(Boolean)),
                onMouseDownCapture: onMouseDownCapture,
                onMouseUpCapture: onMouseUpCapture,
                onKeyDownCapture: onKeyDownCapture,
                onKeyUpCapture: onKeyUpCapture,
                onTouchStartCapture: onTouchStartCapture,
                onTouchEndCapture: onTouchEndCapture,
                onPointerDownCapture: onPointerDownCapture,
                onPointerUpCapture: onPointerUpCapture,
                onClickCapture: onClickCapture,
                type: type,
                testId: testId,
                analyticsContext: analyticsContext,
                interactionName: interactionName,
                componentName: "IconButton",
                children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $4gHTL.default), {
                    type: "icon",
                    isLoading: isLoading,
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $153Gb.default), {
                            icon: icon
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cBCgC.default), {
                            children: label
                        })
                    ]
                })
            })
    });
}));
$37a0e3ae5433a335$var$IconButton.displayName = 'IconButton';
var $37a0e3ae5433a335$export$2e2bcd8739ae039 = $37a0e3ae5433a335$var$IconButton;

});
parcelRegister("cD7p8", function(module, exports) {

$parcel$export(module.exports, "default", () => $753bfad712d8d788$export$2e2bcd8739ae039);
function $753bfad712d8d788$export$2e2bcd8739ae039(refs) {
    // TODO: could this be wrapped in `useCallback` so we get a stable function?
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === 'function') ref(value);
            else if (ref !== null) ref.current = value;
        });
    };
}

});

parcelRegister("5KCCi", function(module, exports) {

$parcel$export(module.exports, "default", () => $377f3fc91d8e1254$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");

var $6moNf = parcelRequire("6moNf");

var $bKnKN = parcelRequire("bKnKN");

var $2rNTw = parcelRequire("2rNTw");

var $hGKXL = parcelRequire("hGKXL");

var $8Oct0 = parcelRequire("8Oct0");

var $7xhdA = parcelRequire("7xhdA");
var $geBdj = parcelRequire("geBdj");

var $fHpHg = parcelRequire("fHpHg");

var $e5neF = parcelRequire("e5neF");

var $5g2iQ = parcelRequire("5g2iQ");

var $b4a3S = parcelRequire("b4a3S");

var $fYF3v = parcelRequire("fYF3v");

var $h1k5z = parcelRequire("h1k5z");

var $7zE3a = parcelRequire("7zE3a");

var $1vU7f = parcelRequire("1vU7f");

var $jyc55 = parcelRequire("jyc55");
const $377f3fc91d8e1254$var$tooltipZIndex = (0, $b4a3S.layers).tooltip();
const $377f3fc91d8e1254$var$analyticsAttributes = {
    componentName: 'tooltip',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
// Inverts motion direction
const $377f3fc91d8e1254$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
/**
 * Converts a Popper placement to it's general direction.
 *
 * @param placement - Popper Placement value, e.g. 'top-start'
 * @returns Popper Direction, e.g. 'top'
 */ const $377f3fc91d8e1254$var$getDirectionFromPlacement = (placement)=>placement.split('-')[0];
/**
 * __Tooltip__
 *
 * A tooltip is a floating, non-actionable label used to explain a user interface element or feature.
 */ function $377f3fc91d8e1254$var$Tooltip({ children: children, position: position = 'bottom', mousePosition: mousePosition = 'bottom', content: content, truncate: truncate = false, // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
component: Container = (0, $1vU7f.default), tag: TargetContainer = 'div', testId: testId, delay: delay = 300, onShow: onShow = (0, $bKnKN.default), onHide: onHide = (0, $bKnKN.default), canAppear: canAppear, hideTooltipOnClick: hideTooltipOnClick = false, hideTooltipOnMouseDown: hideTooltipOnMouseDown = false, analyticsContext: analyticsContext, strategy: strategy = 'fixed', ignoreTooltipPointerEvents: ignoreTooltipPointerEvents = false, isScreenReaderAnnouncementDisabled: isScreenReaderAnnouncementDisabled = false }) {
    const tooltipPosition = position === 'mouse' ? mousePosition : position;
    const onShowHandler = (0, $6moNf.usePlatformLeafSyntheticEventHandler)({
        fn: onShow,
        action: 'displayed',
        analyticsData: analyticsContext,
        ...$377f3fc91d8e1254$var$analyticsAttributes
    });
    const onHideHandler = (0, $6moNf.usePlatformLeafSyntheticEventHandler)({
        fn: onHide,
        action: 'hidden',
        analyticsData: analyticsContext,
        ...$377f3fc91d8e1254$var$analyticsAttributes
    });
    const apiRef = (0, $5uXOq.useRef)(null);
    const [state, setState] = (0, $5uXOq.useState)('hide');
    const targetRef = (0, $5uXOq.useRef)(null);
    const containerRef = (0, $5uXOq.useRef)(null);
    // This function is deliberately _not_ memoized as it needs to re-run every render
    // to pick up any child ref changes. If you use render props you don't have this issue.
    const setImplicitRefFromChildren = (node)=>{
        containerRef.current = node;
        targetRef.current = node ? node.firstElementChild : null;
    };
    // This is memoized and passed into the render props callback.
    const setDirectRef = (0, $5uXOq.useCallback)((node)=>{
        targetRef.current = node;
    }, []);
    // Putting a few things into refs so that we don't have to break memoization
    const stableState = (0, $hGKXL.default)(state);
    // These props are placed in separate refs instead of a single object to reduce memory usage.
    // Placing them in the same object previously caused an increase in the number of JavaScript event listeners
    // before garbage collection.
    const onShowHandlerStable = (0, $hGKXL.default)(onShowHandler);
    const onHideHandlerStable = (0, $hGKXL.default)(onHideHandler);
    const delayStable = (0, $hGKXL.default)(delay);
    const canAppearStable = (0, $hGKXL.default)(canAppear);
    const hasCalledShowHandler = (0, $5uXOq.useRef)(false);
    const start = (0, $5uXOq.useCallback)((api)=>{
        // @ts-ignore
        apiRef.current = api;
        hasCalledShowHandler.current = false;
    }, []);
    const done = (0, $5uXOq.useCallback)(()=>{
        if (!apiRef.current) return;
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        // @ts-ignore
        apiRef.current = null;
        // @ts-ignore
        hasCalledShowHandler.current = false;
        // just in case
        setState('hide');
    }, [
        onHideHandlerStable
    ]);
    const abort = (0, $5uXOq.useCallback)(()=>{
        if (!apiRef.current) return;
        apiRef.current.abort();
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        // @ts-ignore
        apiRef.current = null;
    }, [
        onHideHandlerStable
    ]);
    (0, $5uXOq.useEffect)(function mount() {
        return function unmount() {
            if (apiRef.current) abort();
        };
    }, [
        abort
    ]);
    const isDraggingRef = (0, $5uXOq.useRef)(false);
    (0, $5uXOq.useEffect)(()=>{
        return (0, $fYF3v.register)({
            onRegister ({ isDragging: isDragging }) {
                isDraggingRef.current = isDragging;
            },
            onDragStart () {
                /**
         * Hiding any visible tooltips when a drag starts because otherwise it
         * looks janky (disappears and reappears), and is not required.
         */ apiRef.current?.requestHide({
                    isImmediate: true
                });
                isDraggingRef.current = true;
            },
            onDragEnd () {
                isDraggingRef.current = false;
            }
        });
    }, []);
    const tryShowTooltip = (0, $5uXOq.useCallback)((source)=>{
        /**
     * Prevent tooltips from being shown during a drag. This can occur with
     * the native drag and drop API, where some pointer events can fire
     * when they should not and lead to jank with tooltips.
     */ if (isDraggingRef.current) return;
        // Another tooltip is has been active but we still have the old `api`
        // around. We need to finish up the last usage.
        // Note: just being safe - this should not happen
        if (apiRef.current && !apiRef.current.isActive()) abort();
        // This tooltip is already active, we can exit
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
        /**
     * Check if tooltip is allowed to show.
     *
     * Once a tooltip has started, or has scheduled to start
     * we won't be checking `canAppear` again.
     *
     * - We don't want tooltips to disappear once they are shown
     * - For consistency, we start after a single positive `canAppear`.
     *   Otherwise the amount of times we ask consumers would depend on
     *   how many times we get a "mousemove", which _could_ lead to situations
     *   where moving the mouse could result in a different outcome to if
     *   the mouse was not moved.
     */ if (canAppearStable.current && !canAppearStable.current?.()) return;
        const entry = {
            source: source,
            delay: delayStable.current,
            show: ({ isImmediate: isImmediate })=>{
                // Call the onShow handler if it hasn't been called yet
                if (!hasCalledShowHandler.current) {
                    hasCalledShowHandler.current = true;
                    onShowHandlerStable.current();
                }
                setState(isImmediate ? 'show-immediate' : 'fade-in');
            },
            hide: ({ isImmediate: isImmediate })=>{
                if (isImmediate) setState('hide');
                else setState('before-fade-out');
            },
            done: done
        };
        const api = (0, $h1k5z.show)(entry);
        start(api);
    }, [
        canAppearStable,
        delayStable,
        done,
        start,
        abort,
        onShowHandlerStable
    ]);
    const hideTooltipOnEsc = (0, $5uXOq.useCallback)(()=>{
        apiRef.current?.requestHide({
            isImmediate: true
        });
    }, [
        apiRef
    ]);
    (0, $2rNTw.default)({
        onClose: hideTooltipOnEsc,
        isDisabled: state === 'hide' || state === 'fade-out'
    });
    (0, $5uXOq.useEffect)(()=>{
        if (state === 'hide') return 0, $bKnKN.default;
        if (state === 'before-fade-out') setState('fade-out');
        const unbind = (0, $cBeZP.bind)(window, {
            type: 'scroll',
            listener: ()=>{
                if (apiRef.current) apiRef.current.requestHide({
                    isImmediate: true
                });
            },
            options: {
                capture: true,
                passive: true,
                once: true
            }
        });
        return unbind;
    }, [
        state
    ]);
    const onMouseDown = (0, $5uXOq.useCallback)(()=>{
        if (hideTooltipOnMouseDown && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnMouseDown
    ]);
    const onClick = (0, $5uXOq.useCallback)(()=>{
        if (hideTooltipOnClick && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnClick
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseover of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    const onMouseOver = (0, $5uXOq.useCallback)((event)=>{
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        const source = position === 'mouse' ? {
            type: 'mouse',
            // TODO: ideally not recalculating this object each time
            mouse: (0, $jyc55.getMousePosition)({
                left: event.clientX,
                top: event.clientY
            })
        } : {
            type: 'keyboard'
        };
        tryShowTooltip(source);
    }, [
        position,
        tryShowTooltip
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseout of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    const onMouseOut = (0, $5uXOq.useCallback)((event)=>{
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    const onMouseMove = position === 'mouse' ? (event)=>{
        if (apiRef.current?.isActive()) apiRef.current.mousePosition = (0, $jyc55.getMousePosition)({
            left: event.clientX,
            top: event.clientY
        });
    } : undefined;
    const onMouseOverTooltip = (0, $5uXOq.useCallback)(()=>{
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
    }, []);
    const onFocus = (0, $5uXOq.useCallback)(()=>{
        // TODO: this does not play well with `hideTooltipOnMouseDown`
        // as "focus" will occur after the "mousedown".
        tryShowTooltip({
            type: 'keyboard'
        });
    }, [
        tryShowTooltip
    ]);
    const onBlur = (0, $5uXOq.useCallback)(()=>{
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    const onAnimationFinished = (0, $5uXOq.useCallback)((transition)=>{
        // Using lastState here because motion is not picking up the latest value
        if (transition === 'exiting' && stableState.current === 'fade-out' && apiRef.current) // @ts-ignore: refs are writeable
        apiRef.current.finishHideAnimation();
    }, [
        stableState
    ]);
    // Doing a cast because typescript is struggling to narrow the type
    const CastTargetContainer = TargetContainer;
    const shouldRenderTooltipPopup = state !== 'hide' && Boolean(content);
    const shouldRenderHiddenContent = !isScreenReaderAnnouncementDisabled && shouldRenderTooltipPopup;
    const shouldRenderTooltipChildren = state !== 'hide' && state !== 'fade-out';
    const handleOpenLayerObserverCloseSignal = (0, $5uXOq.useCallback)(()=>{
        apiRef.current?.requestHide({
            isImmediate: true
        });
    }, []);
    (0, $8Oct0.useNotifyOpenLayerObserver)({
        // Layer is only visually open if both the tooltip popup (container) and children are rendered.
        isOpen: shouldRenderTooltipPopup && ((0, $fHpHg.fg)('platform_dst_open_layer_observer_close_layers') ? shouldRenderTooltipChildren : true),
        /**
     * We don't strictly need to provide an onClose callback at this time, as there is
     * already code that handles hiding the tooltip when a drag is started (and the only
     * usage right now is closing all layers when the user resizes the side nav).
     *
     * However, for future-proofing and semantic reasons, it makes sense to close the tooltip
     * whenever the open layer observer requests a close.
     */ onClose: handleOpenLayerObserverCloseSignal
    });
    const getReferenceElement = ()=>{
        if (position === 'mouse' && apiRef.current?.mousePosition) return apiRef.current?.mousePosition;
        return targetRef.current || undefined;
    };
    const tooltipIdForHiddenContent = (0, $7zE3a.default)('tooltip', shouldRenderHiddenContent);
    const tooltipTriggerProps = {
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseMove: onMouseMove,
        onMouseDown: onMouseDown,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur
    };
    // Don't set `data-testid` unless it's defined, as it's not in the interface.
    if (testId) // @ts-expect-error - Adding `data-testid` to the TriggerProps interface breaks Buttons.
    tooltipTriggerProps['data-testid'] = `${testId}--container`;
    // This useEffect is purely for managing the aria attribute when using the
    // wrapped children approach.
    const isChildrenAFunction = typeof children === 'function';
    (0, $5uXOq.useEffect)(()=>{
        if (isChildrenAFunction) return;
        // If `children` is _not_ a function, we are stepping outside of the public
        // API to add a `aria-describedby` attribute.
        const target = targetRef.current;
        if (!target || !tooltipIdForHiddenContent) return;
        target.setAttribute('aria-describedby', tooltipIdForHiddenContent);
        return ()=>target.removeAttribute('aria-describedby');
    }, [
        isChildrenAFunction,
        tooltipIdForHiddenContent
    ]);
    const hiddenContent = shouldRenderHiddenContent ? /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "data-testid": testId ? `${testId}-hidden` : undefined,
        hidden: true,
        id: tooltipIdForHiddenContent,
        children: typeof content === 'function' ? content({}) : content
    }) : null;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            typeof children === 'function' ? // once we deprecate the wrapped approach, we can put the aria
            // attribute back into the tooltipTriggerProps and make it required
            // instead of optional in `types`
            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
                children: [
                    children({
                        ...tooltipTriggerProps,
                        'aria-describedby': tooltipIdForHiddenContent,
                        ref: setDirectRef
                    }),
                    hiddenContent
                ]
            }) : /*#__PURE__*/ (0, $2OMIu.jsxs)(CastTargetContainer, {
                ...tooltipTriggerProps,
                ref: setImplicitRefFromChildren,
                /**
     * TODO: Why is role="presentation" added?
     * - Is it only to "remove" the `Container` from screen readers?
     * - Why is it added only to the `Container` but not to `tooltipTriggerProps`?
     * - Should `role="presentation"` only be used if `shouldRenderHiddenContent == false`?
     */ role: "presentation",
                children: [
                    children,
                    hiddenContent
                ]
            }),
            shouldRenderTooltipPopup ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5g2iQ.default), {
                zIndex: $377f3fc91d8e1254$var$tooltipZIndex,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $e5neF.Popper), {
                    placement: tooltipPosition,
                    referenceElement: getReferenceElement(),
                    strategy: strategy,
                    children: ({ ref: ref, style: style, update: update, placement: placement })=>{
                        // Invert the entrance and exit directions.
                        // E.g. a tooltip's position is on the 'right', it should enter from and exit to the 'left'
                        // This gives the effect the tooltip is appearing from the target
                        const direction = position === 'mouse' ? undefined : $377f3fc91d8e1254$var$invertedDirection[$377f3fc91d8e1254$var$getDirectionFromPlacement(placement)];
                        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7xhdA.default), {
                            appear: true,
                            children: shouldRenderTooltipChildren && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $geBdj.default), {
                                distance: "constant",
                                entranceDirection: direction,
                                exitDirection: direction,
                                onFinish: onAnimationFinished,
                                duration: state !== 'show-immediate' ? 'medium' : 'none',
                                children: ({ className: className })=>/*#__PURE__*/ (0, $2OMIu.jsx)(Container, {
                                        ref: ref,
                                        /**
               * "Tooltip" classname is a hook used by tests to manipulate
               * and hide tooltips, including in VR snapshots
               */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                        className: `Tooltip ${className}`,
                                        style: {
                                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                                            ...style,
                                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                                            ...ignoreTooltipPointerEvents && {
                                                pointerEvents: 'none'
                                            }
                                        },
                                        truncate: truncate,
                                        placement: tooltipPosition,
                                        testId: getReferenceElement() ? testId : testId && `${testId}--unresolved`,
                                        onMouseOut: onMouseOut,
                                        onMouseOver: onMouseOverTooltip,
                                        children: typeof content === 'function' ? content({
                                            update: update
                                        }) : content
                                    })
                            })
                        });
                    }
                })
            }) : null
        ]
    });
}
$377f3fc91d8e1254$var$Tooltip.displayName = 'Tooltip';
var $377f3fc91d8e1254$export$2e2bcd8739ae039 = $377f3fc91d8e1254$var$Tooltip;

});
parcelRegister("2rNTw", function(module, exports) {

$parcel$export(module.exports, "default", () => $b7cbae3b927bdd5d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");

function $b7cbae3b927bdd5d$export$2e2bcd8739ae039({ onClose: onClose, isDisabled: isDisabled }) {
    const escapePressed = (0, $5uXOq.useRef)(false);
    const onKeyDown = (0, $5uXOq.useCallback)((e)=>{
        if (isDisabled || escapePressed.current || e.key !== (0, $f13eec7fa1d5338f$export$2bb790b9008907b4)) // We're either already handling the key down event or it's not escape.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled
    ]);
    const onKeyUp = (0, $5uXOq.useCallback)(()=>{
        escapePressed.current = false;
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        return (0, $cBeZP.bindAll)(document, [
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'keyup',
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp
    ]);
}

});
/**
 * Character key codes which can be used in keyboard events.
 */ const $f13eec7fa1d5338f$export$390330c10ff2b9a1 = 'ArrowUp';
const $f13eec7fa1d5338f$export$a80636c6f41931fe = 'ArrowDown';
const $f13eec7fa1d5338f$export$4af703091671bc = 'Home';
const $f13eec7fa1d5338f$export$e2bc30913faa5db7 = 'End';
const $f13eec7fa1d5338f$export$10f6869ed0a7d75b = 'Tab';
const $f13eec7fa1d5338f$export$8152f929a25a0ff4 = 'Enter';
const $f13eec7fa1d5338f$export$e51a3576c045c8d5 = 'Space';
const $f13eec7fa1d5338f$export$2bb790b9008907b4 = 'Escape';


parcelRegister("hGKXL", function(module, exports) {

$parcel$export(module.exports, "default", () => $64360680fa0ce500$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $64360680fa0ce500$export$2e2bcd8739ae039(value) {
    const ref = (0, $5uXOq.useRef)(value);
    (0, $5uXOq.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}

});

parcelRegister("8Oct0", function(module, exports) {

$parcel$export(module.exports, "useNotifyOpenLayerObserver", () => $7e24738be4ef441d$export$469bb693f11edc7f);

var $5uXOq = parcelRequire("5uXOq");

var $fHpHg = parcelRequire("fHpHg");

var $90wDB = parcelRequire("90wDB");

var $ldsRA = parcelRequire("ldsRA");
function $7e24738be4ef441d$export$469bb693f11edc7f({ isOpen: isOpen, onClose: onClose }) {
    const context = (0, $5uXOq.useContext)((0, $90wDB.OpenLayerObserverContext));
    const namespace = (0, $ldsRA.useOpenLayerObserverNamespace)();
    (0, $5uXOq.useEffect)(()=>{
        if ((0, $fHpHg.fg)('platform_dst_open_layer_observer_close_layers')) return;
        /**
		 * Increments the layer count when the component mounts or becomes visible.
		 *
		 * Returns a cleanup function to decrement the layer count when the component unmounts or becomes hidden.
		 */ if (context === null) return;
        if (!isOpen) return;
        context.increment();
        return function cleanup() {
            context.decrement();
        };
    }, [
        context,
        isOpen,
        namespace
    ]);
    (0, $5uXOq.useEffect)(()=>{
        /**
		 * Registers the `onClose` callback with the OpenLayerObserver.
		 */ if (!(0, $fHpHg.fg)('platform_dst_open_layer_observer_close_layers')) return;
        if (context === null) return;
        if (!isOpen) /**
			 * If the layer is not open, we are not registering the `onClose` callback.
			 * This is important to prevent the `onClose` from being called for layers that
			 * are not open.
			 *
			 * Some consumers mistakenly pass "toggle" functions to `onClose` callbacks for
			 * layer components, as Popup, e.g. `onClose={() => setIsOpen(!isOpen)}`.
			 */ return;
        return context.onClose(onClose, {
            namespace: namespace
        });
    }, [
        context,
        isOpen,
        namespace,
        onClose
    ]);
}

});
parcelRegister("90wDB", function(module, exports) {

$parcel$export(module.exports, "OpenLayerObserverContext", () => $11098231e4392276$export$5fbf4d7fae6cdc00);

var $5uXOq = parcelRequire("5uXOq");
const $11098231e4392276$export$5fbf4d7fae6cdc00 = /*#__PURE__*/ (0, $5uXOq.createContext)(null);

});

parcelRegister("ldsRA", function(module, exports) {

$parcel$export(module.exports, "useOpenLayerObserverNamespace", () => $b124057153f32e9d$export$1d57e79091cc3046);

var $5uXOq = parcelRequire("5uXOq");

var $koa4a = parcelRequire("koa4a");
function $b124057153f32e9d$export$1d57e79091cc3046() {
    const namespace = (0, $5uXOq.useContext)((0, $koa4a.OpenLayerObserverNamespaceContext));
    return namespace;
}

});
parcelRegister("koa4a", function(module, exports) {

$parcel$export(module.exports, "OpenLayerObserverNamespaceContext", () => $05e1d5d1267c85bf$export$644a49f3b8c50fcd);

var $5uXOq = parcelRequire("5uXOq");
const $05e1d5d1267c85bf$export$644a49f3b8c50fcd = /*#__PURE__*/ (0, $5uXOq.createContext)(null);

});



parcelRegister("fYF3v", function(module, exports) {

$parcel$export(module.exports, "register", () => $ecf41253e70add0d$export$6503ec6e8aabbaf);
/* eslint-disable @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop */ /**
 * We are listening directly to drag events instead of using a monitor from
 * `@atlaskit/pragmatic-drag-and-drop` to avoid the bundle size cost, as it
 * would affect almost every view in every product.
 *
 * We can reconsider this choice in the future.
 */ 
var $cBeZP = parcelRequire("cBeZP");
const $ecf41253e70add0d$var$registrations = new Set();
let $ecf41253e70add0d$var$cleanupEndEventListeners = null;
function $ecf41253e70add0d$var$onDragStart() {
    if ($ecf41253e70add0d$var$cleanupEndEventListeners) // If the cleanup function exists then we've already run this
    return;
    $ecf41253e70add0d$var$cleanupEndEventListeners = (0, $cBeZP.bindAll)(window, [
        {
            type: 'dragend',
            listener: $ecf41253e70add0d$var$onDragEnd
        },
        {
            type: 'pointerdown',
            listener: $ecf41253e70add0d$var$onDragEnd
        },
        {
            type: 'pointermove',
            listener: (()=>{
                let callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    $ecf41253e70add0d$var$onDragEnd();
                };
            })()
        }
    ]);
    const clone = Array.from($ecf41253e70add0d$var$registrations);
    clone.forEach((subscriber)=>{
        subscriber.onDragStart();
    });
}
function $ecf41253e70add0d$var$onDragEnd() {
    $ecf41253e70add0d$var$cleanupEndEventListeners?.();
    $ecf41253e70add0d$var$cleanupEndEventListeners = null;
    const clone = Array.from($ecf41253e70add0d$var$registrations);
    clone.forEach((subscriber)=>{
        subscriber.onDragEnd();
    });
}
function $ecf41253e70add0d$var$bindStartEvents() {
    return (0, $cBeZP.bindAll)(window, [
        {
            type: 'dragstart',
            listener: $ecf41253e70add0d$var$onDragStart
        },
        {
            type: 'dragenter',
            listener: $ecf41253e70add0d$var$onDragStart
        }
    ]);
}
let $ecf41253e70add0d$var$cleanupStartEventListeners = null;
function $ecf41253e70add0d$export$6503ec6e8aabbaf(registration) {
    // if first registration, bind event listeners
    if (!$ecf41253e70add0d$var$cleanupStartEventListeners) // note: currently never unbinding these event listeners
    $ecf41253e70add0d$var$cleanupStartEventListeners = $ecf41253e70add0d$var$bindStartEvents();
    $ecf41253e70add0d$var$registrations.add(registration);
    /**
	 * The reasoning for this behavior is so that if a tooltip mounts during
	 * a drag it can still be suppressed.
	 *
	 * We use a separate callback instead of onDragStart to avoid infinite loops.
	 */ registration.onRegister({
        isDragging: $ecf41253e70add0d$var$cleanupEndEventListeners !== null
    });
    return function unregister() {
        $ecf41253e70add0d$var$registrations.delete(registration);
        if ($ecf41253e70add0d$var$registrations.size === 0) {
            $ecf41253e70add0d$var$cleanupStartEventListeners?.();
            $ecf41253e70add0d$var$cleanupStartEventListeners = null;
        }
    };
}

});

parcelRegister("h1k5z", function(module, exports) {

$parcel$export(module.exports, "show", () => $d8c1e52c97a3d3f1$export$57bf213be019eeb0);

var $g3mc7 = parcelRequire("g3mc7");
let $d8c1e52c97a3d3f1$var$active = null;
function $d8c1e52c97a3d3f1$export$57bf213be019eeb0(entry) {
    let phase = 'waiting-to-show';
    function isActive() {
        return Boolean($d8c1e52c97a3d3f1$var$active && $d8c1e52c97a3d3f1$var$active.entry === entry);
    }
    function cleanup() {
        if (isActive()) {
            (0, $g3mc7.clearScheduled)();
            $d8c1e52c97a3d3f1$var$active = null;
        }
    }
    function done() {
        if (isActive()) entry.done();
        phase = 'done';
        cleanup();
    }
    function immediatelyHideAndDone() {
        if (isActive()) entry.hide({
            isImmediate: true
        });
        done();
    }
    function keep() {
        if (!isActive()) return;
        // aborting a wait to hide
        if (phase === 'waiting-to-hide') {
            phase = 'shown';
            (0, $g3mc7.clearScheduled)();
            return;
        }
        // aborting hide animation
        if (phase === 'hide-animating') {
            phase = 'shown';
            (0, $g3mc7.clearScheduled)();
            entry.show({
                isImmediate: false
            });
            return;
        }
    }
    function requestHide({ isImmediate: isImmediate }) {
        if (!isActive()) return;
        // If we were not showing yet anyway; finish straight away
        if (phase === 'waiting-to-show') {
            immediatelyHideAndDone();
            return;
        }
        // already waiting to hide
        if (phase === 'waiting-to-hide') return;
        if (isImmediate) {
            immediatelyHideAndDone();
            return;
        }
        phase = 'waiting-to-hide';
        (0, $g3mc7.scheduleTimeout)(()=>{
            phase = 'hide-animating';
            entry.hide({
                isImmediate: false
            });
        }, entry.delay);
    }
    function finishHideAnimation() {
        if (isActive() && phase === 'hide-animating') done();
    }
    function isVisible() {
        return phase === 'shown' || phase === 'waiting-to-hide' || phase === 'hide-animating';
    }
    function getInitialMouse() {
        if (entry.source.type === 'mouse') return entry.source.mouse;
        return null;
    }
    function start() {
        const showImmediately = Boolean($d8c1e52c97a3d3f1$var$active && $d8c1e52c97a3d3f1$var$active.isVisible());
        // If there was an active tooltip; we tell it to remove itself at once!
        if ($d8c1e52c97a3d3f1$var$active) {
            (0, $g3mc7.clearScheduled)();
            $d8c1e52c97a3d3f1$var$active.entry.hide({
                isImmediate: true
            });
            $d8c1e52c97a3d3f1$var$active.entry.done();
            $d8c1e52c97a3d3f1$var$active = null;
        }
        // this tooltip is now the active tooltip
        $d8c1e52c97a3d3f1$var$active = {
            entry: entry,
            isVisible: isVisible
        };
        function show() {
            phase = 'shown';
            entry.show({
                isImmediate: showImmediately
            });
        }
        if (showImmediately) {
            show();
            return;
        }
        phase = 'waiting-to-show';
        (0, $g3mc7.scheduleTimeout)(show, entry.delay);
    }
    // let's get started!
    start();
    const result = {
        keep: keep,
        abort: cleanup,
        isActive: isActive,
        requestHide: requestHide,
        finishHideAnimation: finishHideAnimation,
        mousePosition: getInitialMouse()
    };
    return result;
}

});
parcelRegister("g3mc7", function(module, exports) {

$parcel$export(module.exports, "clearScheduled", () => $5bf54eaa5bb1ed77$export$eaf678f6f93f5250);
$parcel$export(module.exports, "scheduleTimeout", () => $5bf54eaa5bb1ed77$export$5f4d6617421d489b);
let $5bf54eaa5bb1ed77$var$delayId = null;
function $5bf54eaa5bb1ed77$export$eaf678f6f93f5250() {
    if ($5bf54eaa5bb1ed77$var$delayId != null) {
        window.clearTimeout($5bf54eaa5bb1ed77$var$delayId);
        $5bf54eaa5bb1ed77$var$delayId = null;
    }
}
function $5bf54eaa5bb1ed77$export$5f4d6617421d489b(fn, delay) {
    $5bf54eaa5bb1ed77$export$eaf678f6f93f5250();
    $5bf54eaa5bb1ed77$var$delayId = window.setTimeout(()=>{
        $5bf54eaa5bb1ed77$var$delayId = null;
        fn();
    }, delay);
}

});


parcelRegister("7zE3a", function(module, exports) {

$parcel$export(module.exports, "default", () => $33cf1412eba723fb$export$2e2bcd8739ae039);

var $jJsBW = parcelRequire("jJsBW");
function $33cf1412eba723fb$export$2e2bcd8739ae039(prefix, shouldRenderId) {
    const seed = (0, $jJsBW.useIdSeed)();
    return shouldRenderId ? `${seed(prefix)}` : undefined;
}

});
parcelRegister("jJsBW", function(module, exports) {

$parcel$export(module.exports, "useId", () => $8edb1181f4d82d28$export$f680877a34711e37);
$parcel$export(module.exports, "IdProvider", () => $8edb1181f4d82d28$export$6be90bcb437e928f);
$parcel$export(module.exports, "useIdSeed", () => $8edb1181f4d82d28$export$6ee17796e3d70de2);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $22Gxp = parcelRequire("22Gxp");

var $fHpHg = parcelRequire("fHpHg");
// @ts-ignore - useId is not accessible in React 16
const $8edb1181f4d82d28$var$react18UseId = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useId ?? undefined;
function $8edb1181f4d82d28$export$f680877a34711e37() {
    if ($8edb1181f4d82d28$var$react18UseId && (0, $fHpHg.fg)('platform-dst-react-18-use-id')) return $8edb1181f4d82d28$var$react18UseId();
    return `uid${(0, $22Gxp.useUID)()}`;
}
const $8edb1181f4d82d28$export$6be90bcb437e928f = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, postfix: postfix = '', prefix: prefix = '' }, ref)=>{
    const id = `${prefix}${$8edb1181f4d82d28$export$f680877a34711e37()}${postfix}`;
    (0, $5uXOq.useEffect)(()=>{
        if (!ref) return;
        switch(typeof ref){
            case 'function':
                ref(id);
                break;
            case 'object':
                ref.current = id;
                break;
            default:
                throw new Error(`Unreachable case for unsupported type of ref "${typeof ref}"`);
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: typeof children === 'function' ? children({
            id: id
        }) : children
    });
});
function $8edb1181f4d82d28$export$6ee17796e3d70de2() {
    if ($8edb1181f4d82d28$var$react18UseId && (0, $fHpHg.fg)('platform-dst-react-18-use-id')) {
        const uid = $8edb1181f4d82d28$var$react18UseId();
        return (id)=>`${uid}-${id.toString()}`;
    }
    return (0, $22Gxp.useUIDSeed)();
}

});


parcelRegister("1vU7f", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1e3b35811aaf1bf$export$2e2bcd8739ae039);
/* tooltip-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $1Jlkv = parcelRequire("1Jlkv");
const $b1e3b35811aaf1bf$var$baseStyles = null;
const $b1e3b35811aaf1bf$var$truncateStyles = null;
/**
 * Used as the default tooltip container component for the exported `Tooltip` component.
 * Adds some styles to the tooltip primitive.
 */ const $b1e3b35811aaf1bf$var$TooltipContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function TooltipContainer({ style: style, className: className, children: children, truncate: truncate, placement: placement, testId: testId, onMouseOut: onMouseOut, onMouseOver: onMouseOver, id: id }, ref) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1Jlkv.default), {
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $bwpsq.default)([
            "_2rko1sit _11c8dcr7 _vchhusvi _p12fp3fh _bfhkgkf6 _syaz15cr _152tze3t _1e02ze3t _1i4q1hna _85i5v77o _1q51v77o _y4ti12x7 _bozg12x7 _slp31hna",
            truncate && "_1reo15vq _18m915vq _p12f1pna _1bto1l2s _o5721q9c",
            className
        ]),
        placement: placement,
        testId: testId,
        id: id,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        children: children
    });
});
$b1e3b35811aaf1bf$var$TooltipContainer.displayName = 'TooltipContainer';
var $b1e3b35811aaf1bf$export$2e2bcd8739ae039 = $b1e3b35811aaf1bf$var$TooltipContainer;

});
parcelRegister("1Jlkv", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec89b3e4e3445112$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $b4a3S = parcelRequire("b4a3S");
const $ec89b3e4e3445112$var$VAR_PRIMITIVE_ZINDEX = 'tooltipPrimitiveZindex';
const $ec89b3e4e3445112$var$primitiveStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    zindex: `var(${$ec89b3e4e3445112$var$VAR_PRIMITIVE_ZINDEX})`,
    cursor: `default`
});
/**
 * The lower level component for rendering a tooltip.
 */ const $ec89b3e4e3445112$var$TooltipPrimitive = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function TooltipPrimitive({ style: style, className: className, children: children, placement: placement, testId: testId, onMouseOut: onMouseOut, onMouseOver: onMouseOver, id: id }, ref) {
    const styleWithZIndex = {
        ...style,
        [$ec89b3e4e3445112$var$VAR_PRIMITIVE_ZINDEX]: (0, $b4a3S.layers).tooltip()
    };
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: styleWithZIndex,
        "data-testid": testId ? `${testId}--wrapper` : undefined
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        role: "tooltip",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        // Because the tooltip should not be focusable, there is no reason to have key events.
        /* eslint-disable-next-line jsx-a11y/mouse-events-have-key-events */ onMouseOut: onMouseOut,
        /* eslint-disable-next-line jsx-a11y/mouse-events-have-key-events */ onMouseOver: onMouseOver,
        css: $ec89b3e4e3445112$var$primitiveStyles,
        "data-placement": placement,
        "data-testid": testId,
        id: id
    }, children));
});
$ec89b3e4e3445112$var$TooltipPrimitive.displayName = 'TooltipPrimitive';
var $ec89b3e4e3445112$export$2e2bcd8739ae039 = $ec89b3e4e3445112$var$TooltipPrimitive;

});


parcelRegister("jyc55", function(module, exports) {

$parcel$export(module.exports, "getMousePosition", () => $c48049c71fa4af98$export$642213d516a9b928);
function $c48049c71fa4af98$export$642213d516a9b928(mouseCoordinates) {
    const safeMouse = mouseCoordinates || {
        top: 0,
        left: 0
    };
    const getBoundingClientRect = ()=>({
            top: safeMouse.top,
            left: safeMouse.left,
            bottom: safeMouse.top,
            right: safeMouse.left,
            width: 0,
            height: 0
        });
    return {
        getBoundingClientRect: getBoundingClientRect,
        clientWidth: 0,
        clientHeight: 0
    };
}

});


parcelRegister("2ifdJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa7fbdb5787487e6$export$2e2bcd8739ae039);
/* button-base.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $6tzHJ = parcelRequire("6tzHJ");

var $cD7p8 = parcelRequire("cD7p8");

var $42A03 = parcelRequire("42A03");

var $jJsBW = parcelRequire("jJsBW");

var $fHpHg = parcelRequire("fHpHg");

var $7rJgC = parcelRequire("7rJgC");

var $cBCgC = parcelRequire("cBCgC");

var $63CDT = parcelRequire("63CDT");

var $doWJf = parcelRequire("doWJf");

var $asMkR = parcelRequire("asMkR");
const $aa7fbdb5787487e6$var$LOADING_LABEL = ', Loading';
const $aa7fbdb5787487e6$var$styles = {
    base: "_2rkosqtm _11c82smr _v5649dqc _189eidpf _1rjc12x7 _1e0c116y _vchhusvi _1bsb1wug _p12f1osq _kqswh2mm _4cvr1q9y _1bah1h6o _gy1p1b66 _1o9zidpf _4t3iviql _k48p1wq8 _y4tiutpp _bozgutpp _y3gn1h6o _s7n4nkob _14mj1kw7 _9v7aze3t _1tv3nqa1 _39yqe4h9 _11fnglyw _18postnw",
    linkDecorationUnset: "_4bfu18uv _1hmsglyw _ajmmnqa1 _1a3b18uv _4fprglyw _5goinqa1 _9oik18uv _1bnxglyw _jf4cnqa1 _1nrm18uv _c2waglyw _1iohnqa1",
    disabled: "_80om13gf _bfhk1caa _syaz1lh4 _aetrglyw _irr31caa _30l31lh4 _1di61caa _9h8h1lh4",
    spacingCompact: "_1rjcv77o _gy1p1b66 _4t3i1k8s _y4tiutpp _bozgutpp _s7n4nkob",
    circle: "_2rko14q2",
    fullWidth: "_1bsb1osq",
    loading: "_80om15jw",
    iconButton: "_4t3iviql _1bsbviql _y4tize3t _bozgze3t",
    iconButtonCompact: "_4t3i1k8s _1bsb1k8s",
    buttonIconBefore: "_bozgu2gc",
    buttonIconAfter: "_y4tiu2gc",
    splitButton: "_g0pbb4wl",
    loadingOverlay: "_1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _u7coze3t _152tze3t _rjxpze3t _1e02ze3t",
    navigationSplitButton: "_1bsb1tcg _bfhk1w7a _y4ti12x7 _bozg12x7"
};
const $aa7fbdb5787487e6$var$defaultStyles = {
    root: "_bfhkiw92 _syaz10s3 _105310s3 _f8pj10s3 _30l310s3 _9h8h10s3",
    rootRefreshed: "_bfhk1w7a _syaz1gjq _8l3mmuej _aetrb3bt _10531gjq _f8pj1gjq _30l31gjq _9h8h1gjq",
    interactive: "_irr3yw9d _30l310s3 _1di6ih13 _9h8h10s3",
    interactiveRefreshed: "_irr3166n _30l31gjq _1di61dty _9h8h1gjq"
};
const $aa7fbdb5787487e6$var$primaryStyles = {
    root: "_bfhkomb0 _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr31wqm _9h8h15cr _1di617hq"
};
const $aa7fbdb5787487e6$var$warningStyles = {
    root: "_bfhk1ikc _syazal3n _1053al3n _f8pjal3n _30l3al3n _9h8hal3n",
    interactive: "_30l3al3n _irr31j43 _9h8hal3n _1di6h4op"
};
const $aa7fbdb5787487e6$var$dangerStyles = {
    root: "_bfhk1v7l _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr31rwk _9h8h15cr _1di6yycf"
};
const $aa7fbdb5787487e6$var$discoveryStyles = {
    root: "_bfhk1vbi _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr37gr8 _9h8h15cr _1di61wu2"
};
const $aa7fbdb5787487e6$var$subtleStyles = {
    root: "_bfhk1w7a _syaz10s3 _105310s3 _f8pj10s3 _30l310s3 _9h8h10s3",
    rootRefreshed: "_bfhk1w7a _syaz1gjq _10531gjq _f8pj1gjq _30l31gjq _9h8h1gjq",
    interactive: "_irr34mfv _30l310s3 _1di619qy _9h8h10s3",
    interactiveRefreshed: "_irr34mfv _30l31gjq _1di619qy _9h8h1gjq"
};
const $aa7fbdb5787487e6$var$selectedStyles = {
    root: "_bfhk7btw _syaz1pke _10531pke _f8pj1pke _30l31pke _9h8h1pke",
    rootRefreshed: "_bfhkfg4m _syaz1ldt _8l3mcoux _aetrb3bt _10531ldt _f8pj1ldt _30l31ldt _9h8h1ldt",
    insideSplitButton: "_1pbycs5v",
    interactive: "_irr3t71w _30l31pke _1di6yssv _9h8h1pke",
    warning: "_bfhkvdtc _syaz16q2 _30l31pke _irr3vdtc _9h8h1pke _1di6vdtc",
    danger: "_bfhkbeib _syaz1pke _30l31pke _irr3beib _9h8h1pke _1di6beib",
    discovery: "_bfhk1g49 _syaz1pke _30l31pke _irr31g49 _9h8h1pke _1di61g49"
};
/**
 * __button base__
 *
 * - Implements auto focus when enabled.
 * - Appends the `onClick` event with UFO analytics tracking.
 *
 * @private
 */ const $aa7fbdb5787487e6$var$ButtonBase = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef(({ appearance: propAppearance, autoFocus: autoFocus = false, isDisabled: propIsDisabled = false, isLoading: isLoading = false, isSelected: propIsSelected = false, isIconButton: isIconButton = false, isCircle: isCircle = false, hasIconBefore: hasIconBefore = false, hasIconAfter: hasIconAfter = false, shouldFitContainer: shouldFitContainer = false, spacing: propSpacing = 'default', ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy, children: children, interactionName: interactionName, onClick: onClick, onMouseDown: onMouseDown, onMouseDownCapture: onMouseDownCapture, onMouseUp: onMouseUp, onMouseUpCapture: onMouseUpCapture, onKeyDown: onKeyDown, onKeyDownCapture: onKeyDownCapture, onKeyUp: onKeyUp, onKeyUpCapture: onKeyUpCapture, onTouchStart: onTouchStart, onTouchStartCapture: onTouchStartCapture, onTouchEnd: onTouchEnd, onTouchEndCapture: onTouchEndCapture, onPointerDown: onPointerDown, onPointerDownCapture: onPointerDownCapture, onPointerUp: onPointerUp, onPointerUpCapture: onPointerUpCapture, onClickCapture: onClickCapture, testId: testId, analyticsContext: analyticsContext, componentName: componentName, role: role, onMouseOver: onMouseOver, onMouseOut: onMouseOut, onFocus: onFocus, onBlur: onBlur, onMouseMove: onMouseMove, type: type, ...unsafeRest }, ref)=>{
    const localRef = (0, $5uXOq.useRef)(null);
    const splitButtonContext = (0, $63CDT.useSplitButtonContext)();
    const loadingLabelId = (0, $jJsBW.useId)();
    const isSplitButton = Boolean(splitButtonContext);
    const isNavigationSplitButton = splitButtonContext?.isNavigationSplitButton || false;
    const isDefaultAppearanceSplitButton = splitButtonContext?.appearance === 'default';
    const appearance = isDefaultAppearanceSplitButton && (0, $fHpHg.fg)('platform-component-visual-refresh') ? 'subtle' : propAppearance || splitButtonContext?.appearance || 'default';
    const spacing = splitButtonContext?.spacing || propSpacing;
    const isDisabled = splitButtonContext?.isDisabled || propIsDisabled;
    const isInteractive = !isDisabled && !isLoading;
    // Also treat loading buttons as disabled
    const isEffectivelyDisabled = isDisabled || isLoading;
    const isSelected = propIsSelected && !isDisabled;
    (0, $42A03.default)(localRef, autoFocus);
    // @ts-expect-error
    const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7rJgC.default), {
        ...saferRest,
        componentName: componentName || 'button',
        analyticsContext: analyticsContext,
        role: role,
        ref: (0, $cD7p8.default)([
            localRef,
            ref
        ]),
        xcss: (0, $6tzHJ.cx)($aa7fbdb5787487e6$var$styles.base, appearance === 'default' && ((0, $fHpHg.fg)('platform-component-visual-refresh') ? $aa7fbdb5787487e6$var$defaultStyles.rootRefreshed : $aa7fbdb5787487e6$var$defaultStyles.root), appearance === 'default' && isInteractive && ((0, $fHpHg.fg)('platform-component-visual-refresh') ? $aa7fbdb5787487e6$var$defaultStyles.interactiveRefreshed : $aa7fbdb5787487e6$var$defaultStyles.interactive), appearance === 'primary' && $aa7fbdb5787487e6$var$primaryStyles.root, appearance === 'primary' && isInteractive && $aa7fbdb5787487e6$var$primaryStyles.interactive, appearance === 'warning' && $aa7fbdb5787487e6$var$warningStyles.root, appearance === 'warning' && isInteractive && $aa7fbdb5787487e6$var$warningStyles.interactive, appearance === 'danger' && $aa7fbdb5787487e6$var$dangerStyles.root, appearance === 'danger' && isInteractive && $aa7fbdb5787487e6$var$dangerStyles.interactive, appearance === 'discovery' && $aa7fbdb5787487e6$var$discoveryStyles.root, appearance === 'discovery' && isInteractive && $aa7fbdb5787487e6$var$discoveryStyles.interactive, appearance === 'subtle' && ((0, $fHpHg.fg)('platform-component-visual-refresh') ? $aa7fbdb5787487e6$var$subtleStyles.rootRefreshed : $aa7fbdb5787487e6$var$subtleStyles.root), appearance === 'subtle' && isInteractive && ((0, $fHpHg.fg)('platform-component-visual-refresh') ? $aa7fbdb5787487e6$var$subtleStyles.interactiveRefreshed : $aa7fbdb5787487e6$var$subtleStyles.interactive), $aa7fbdb5787487e6$var$styles.linkDecorationUnset, isSelected && ((0, $fHpHg.fg)('platform-component-visual-refresh') ? $aa7fbdb5787487e6$var$selectedStyles.rootRefreshed : $aa7fbdb5787487e6$var$selectedStyles.root), isSelected && isSplitButton && $aa7fbdb5787487e6$var$selectedStyles.insideSplitButton, isSelected && isInteractive && $aa7fbdb5787487e6$var$selectedStyles.interactive, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'danger' && $aa7fbdb5787487e6$var$selectedStyles.danger, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'warning' && $aa7fbdb5787487e6$var$selectedStyles.warning, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'discovery' && $aa7fbdb5787487e6$var$selectedStyles.discovery, isDisabled && $aa7fbdb5787487e6$var$styles.disabled, isCircle && !isSplitButton && $aa7fbdb5787487e6$var$styles.circle, spacing === 'compact' && $aa7fbdb5787487e6$var$styles.spacingCompact, hasIconBefore && $aa7fbdb5787487e6$var$styles.buttonIconBefore, shouldFitContainer && $aa7fbdb5787487e6$var$styles.fullWidth, hasIconAfter && $aa7fbdb5787487e6$var$styles.buttonIconAfter, isIconButton && $aa7fbdb5787487e6$var$styles.iconButton, isIconButton && spacing === 'compact' && $aa7fbdb5787487e6$var$styles.iconButtonCompact, isLoading && $aa7fbdb5787487e6$var$styles.loading, isSplitButton && $aa7fbdb5787487e6$var$styles.splitButton, isNavigationSplitButton && $aa7fbdb5787487e6$var$styles.navigationSplitButton),
        isDisabled: isEffectivelyDisabled,
        "aria-label": isLoading && ariaLabel && !ariaLabelledBy ? `${ariaLabel} ${$aa7fbdb5787487e6$var$LOADING_LABEL}` : ariaLabel,
        "aria-labelledby": isLoading && ariaLabelledBy ? `${ariaLabelledBy} ${loadingLabelId}` : ariaLabelledBy,
        onClick: onClick,
        ...(0, $doWJf.default)(isEffectivelyDisabled, {
            onMouseDownCapture: onMouseDownCapture,
            onMouseUpCapture: onMouseUpCapture,
            onKeyDownCapture: onKeyDownCapture,
            onKeyUpCapture: onKeyUpCapture,
            onTouchStartCapture: onTouchStartCapture,
            onTouchEndCapture: onTouchEndCapture,
            onPointerDownCapture: onPointerDownCapture,
            onPointerUpCapture: onPointerUpCapture,
            onClickCapture: onClickCapture
        }),
        testId: testId,
        onMouseOver: onMouseOver,
        onFocus: onFocus,
        onMouseMove: onMouseMove,
        onBlur: onBlur,
        type: type,
        interactionName: interactionName,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onKeyDown: onKeyDown,
        onMouseOut: onMouseOut,
        onKeyUp: onKeyUp,
        onTouchStart: onTouchStart,
        onTouchEnd: onTouchEnd,
        onPointerDown: onPointerDown,
        onPointerUp: onPointerUp,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $63CDT.SplitButtonContext).Provider, {
            value: undefined,
            children: [
                children,
                isLoading && /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                    className: (0, $bwpsq.default)([
                        $aa7fbdb5787487e6$var$styles.loadingOverlay
                    ]),
                    children: (0, $asMkR.default)({
                        spacing: spacing,
                        appearance: appearance,
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        testId: testId
                    })
                }),
                isLoading && (ariaLabelledBy || !ariaLabel) && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cBCgC.default), {
                    id: loadingLabelId,
                    children: $aa7fbdb5787487e6$var$LOADING_LABEL
                })
            ]
        })
    });
});
var $aa7fbdb5787487e6$export$2e2bcd8739ae039 = $aa7fbdb5787487e6$var$ButtonBase;

});
parcelRegister("63CDT", function(module, exports) {

$parcel$export(module.exports, "SplitButtonContext", () => $70ef404d78cad288$export$4b86304b2c0d7e71);
$parcel$export(module.exports, "useSplitButtonContext", () => $70ef404d78cad288$export$47e2c6fdb142d947);

var $5uXOq = parcelRequire("5uXOq");
const $70ef404d78cad288$export$4b86304b2c0d7e71 = /*#__PURE__*/ (0, $5uXOq.createContext)(undefined);
const $70ef404d78cad288$export$47e2c6fdb142d947 = ()=>{
    const context = (0, $5uXOq.useContext)($70ef404d78cad288$export$4b86304b2c0d7e71);
    if (!context) return undefined;
    if (context.appearance === 'navigation') {
        const newContext = {
            spacing: 'default',
            appearance: 'subtle',
            isDisabled: false,
            isActiveOverSelected: false,
            isNavigationSplitButton: true,
            isHighlighted: context.isHighlighted
        };
        return newContext;
    }
    const splitButtonContext = {
        spacing: context.spacing,
        appearance: context.appearance,
        isDisabled: context.isDisabled,
        isActiveOverSelected: true,
        isNavigationSplitButton: false,
        isHighlighted: false
    };
    return splitButtonContext;
};

});

parcelRegister("doWJf", function(module, exports) {

$parcel$export(module.exports, "default", () => $091f742e5eb1f675$export$2e2bcd8739ae039);
function $091f742e5eb1f675$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
const $091f742e5eb1f675$var$tabKeyCode = 9;
function $091f742e5eb1f675$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $091f742e5eb1f675$var$tabKeyCode) return;
    $091f742e5eb1f675$var$abort(event);
}
function $091f742e5eb1f675$export$2e2bcd8739ae039(shouldBlockEvents, events) {
    return shouldBlockEvents ? {
        onMouseDownCapture: $091f742e5eb1f675$var$abort,
        onMouseUpCapture: $091f742e5eb1f675$var$abort,
        onKeyDownCapture: $091f742e5eb1f675$var$onKey,
        onKeyUpCapture: $091f742e5eb1f675$var$onKey,
        onTouchStartCapture: $091f742e5eb1f675$var$abort,
        onTouchEndCapture: $091f742e5eb1f675$var$abort,
        onPointerDownCapture: $091f742e5eb1f675$var$abort,
        onPointerUpCapture: $091f742e5eb1f675$var$abort,
        onClickCapture: $091f742e5eb1f675$var$abort,
        // Just smashing the existing onClick for good measure
        onClick: $091f742e5eb1f675$var$abort
    } : events;
}

});

parcelRegister("asMkR", function(module, exports) {

$parcel$export(module.exports, "default", () => $20991ae6452be183$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $clxo5 = parcelRequire("clxo5");
function $20991ae6452be183$var$getIconSpacing(spacing) {
    switch(spacing){
        case 'compact':
            return 'small';
        default:
            return 'medium';
    }
}
function $20991ae6452be183$var$getSpinnerAppearance({ appearance: appearance, isDisabled: isDisabled, isSelected: isSelected }) {
    if (isDisabled || isSelected) return 'inherit';
    if (appearance === 'primary' || appearance === 'danger' || appearance === 'discovery') return 'invert';
    return 'inherit';
}
function $20991ae6452be183$export$2e2bcd8739ae039({ appearance: appearance, spacing: spacing, isDisabled: isDisabled, isSelected: isSelected, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $clxo5.default), {
        size: $20991ae6452be183$var$getIconSpacing(spacing),
        appearance: $20991ae6452be183$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        }),
        testId: testId ? `${testId}--loading-spinner` : undefined
    });
}

});


parcelRegister("4gHTL", function(module, exports) {

$parcel$export(module.exports, "default", () => $750e4a4dce8f4c12$export$2e2bcd8739ae039);
/* content.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");
parcelRequire("5uXOq");
const $750e4a4dce8f4c12$var$styles = {
    text: "_1reo15vq _18m915vq _16jlkb7n _1o9zkb7n _1bto1l2s _o5721q9c",
    icon: "_1e0c1txw _16jlidpf _1o9zidpf _1wpz1h6o _1wybidpf _vwz4idpf _uiztglyw",
    beforeIcon: "_1he91b66 _w795v77o",
    afterIcon: "_1he9v77o _w7951b66",
    common: "_v564g17y",
    fade: "_tzy4idpf"
};
/**
 * __Content__
 *
 * Used for slots within a Button, including icons and text content.
 */ const $750e4a4dce8f4c12$var$Content = ({ children: children, type: type = 'text', isLoading: isLoading, position: position })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        className: (0, $bwpsq.default)([
            $750e4a4dce8f4c12$var$styles.common,
            type === 'text' && $750e4a4dce8f4c12$var$styles.text,
            type === 'icon' && $750e4a4dce8f4c12$var$styles.icon,
            isLoading && $750e4a4dce8f4c12$var$styles.fade,
            position === 'before' && $750e4a4dce8f4c12$var$styles.beforeIcon,
            position === 'after' && $750e4a4dce8f4c12$var$styles.afterIcon
        ]),
        children: children
    });
};
var $750e4a4dce8f4c12$export$2e2bcd8739ae039 = $750e4a4dce8f4c12$var$Content;

});

parcelRegister("153Gb", function(module, exports) {

$parcel$export(module.exports, "default", () => $023a32eb533da90b$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
function $023a32eb533da90b$var$isIconRenderProp(func) {
    return !func.displayName && // most function components and class components have a displayName, negate them
    !func.render && // forwardRef doesn't require a display name, however it does include a render function, negate them
    typeof func === 'function' // at the very least we need to be a function
    ;
}
/**
 * __Icon renderer__
 *
 * Used to support render props with icons.
 *
 */ const $023a32eb533da90b$var$IconRenderer = ({ icon: Icon })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: $023a32eb533da90b$var$isIconRenderProp(Icon) ? Icon({
            label: '',
            color: 'currentColor'
        }) : /*#__PURE__*/ (0, $2OMIu.jsx)(Icon, {
            label: "",
            color: 'currentColor'
        })
    });
};
var $023a32eb533da90b$export$2e2bcd8739ae039 = $023a32eb533da90b$var$IconRenderer;

});



parcelRegister("i2ajl", function(module, exports) {

$parcel$export(module.exports, "useModal", () => $42b2b9e2e7dfef1b$export$33ffd74ebf07f060);

var $5uXOq = parcelRequire("5uXOq");

var $kQNf9 = parcelRequire("kQNf9");
const $42b2b9e2e7dfef1b$export$33ffd74ebf07f060 = ()=>{
    const modalContext = (0, $5uXOq.useContext)((0, $kQNf9.ModalContext));
    if (modalContext == null) throw Error("@atlaskit/modal-dialog: Modal context unavailable \u2013 this component needs to be a child of ModalDialog.");
    return modalContext;
};

});
parcelRegister("kQNf9", function(module, exports) {

$parcel$export(module.exports, "ModalContext", () => $d4ddc46e849fa282$export$ab57792b9b6974a6);
$parcel$export(module.exports, "ScrollContext", () => $d4ddc46e849fa282$export$dece24112a937f92);

var $5uXOq = parcelRequire("5uXOq");
const $d4ddc46e849fa282$export$ab57792b9b6974a6 = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $d4ddc46e849fa282$export$dece24112a937f92 = /*#__PURE__*/ (0, $5uXOq.createContext)(null);

});



parcelRegister("7Sb4G", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $e6a164e83162181f$export$2e2bcd8739ae039);
/* modal-title.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $5E93O = parcelRequire("5E93O");

var $85eFT = parcelRequire("85eFT");

var $i2ajl = parcelRequire("i2ajl");
const $e6a164e83162181f$var$iconColor = {
    danger: "var(--ds-icon-danger, #C9372C)",
    warning: "var(--ds-icon-warning, #E56910)"
};
const $e6a164e83162181f$var$iconStyles = null;
const $e6a164e83162181f$var$titleStyles = null;
const $e6a164e83162181f$var$textStyles = null;
const $e6a164e83162181f$var$truncatedTextStyles = null;
const $e6a164e83162181f$var$TitleIcon = ({ appearance: appearance })=>{
    const Icon = appearance === 'danger' ? (0, (/*@__PURE__*/$parcel$interopDefault($5E93O))) : (0, (/*@__PURE__*/$parcel$interopDefault($85eFT)));
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        className: (0, $bwpsq.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _syaz1kw7 _1wyb1kw7 _zg8l1kw7 _k48p1kw7 _1dyz1kw7 _vwz41kw7"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)(Icon, {
            label: appearance,
            color: $e6a164e83162181f$var$iconColor[appearance],
            spacing: "spacious"
        })
    });
};
/**
 * __Modal title__
 *
 * A modal title is used to display a title within a modal.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ const $e6a164e83162181f$var$ModalTitle = (props)=>{
    const { appearance: appearance, children: children, isMultiline: isMultiline = true, testId: userDefinedTestId } = props;
    const { titleId: titleId, testId: modalTestId } = (0, $i2ajl.useModal)();
    const testId = userDefinedTestId || modalTestId && `${modalTestId}--title`;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("h1", {
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            "_zulpu2gc _11c8lodh _1e0c1txw _1ul9idpf _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t"
        ]),
        children: [
            appearance && /*#__PURE__*/ (0, $2OMIu.jsx)($e6a164e83162181f$var$TitleIcon, {
                appearance: appearance
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                id: titleId,
                "data-testid": testId && `${testId}-text`,
                className: (0, $bwpsq.default)([
                    "_16jlkb7n _1o9zkb7n _i0dl1wug _1ul9idpf _slp31hna",
                    !isMultiline && "_1reo15vq _18m915vq _1bto1l2s _o5721q9c"
                ]),
                children: children
            })
        ]
    });
};
var $e6a164e83162181f$export$2e2bcd8739ae039 = $e6a164e83162181f$var$ModalTitle;

});

parcelRegister("g1QfP", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $fda9af9d7b881e5f$export$2e2bcd8739ae039);
/* modal-body.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");
parcelRequire("5uXOq");

var $2alJM = parcelRequire("2alJM");

var $fHpHg = parcelRequire("fHpHg");

var $i2ajl = parcelRequire("i2ajl");

var $bNMQd = parcelRequire("bNMQd");

var $fPXvL = parcelRequire("fPXvL");
const $fda9af9d7b881e5f$var$bodyStyles = null;
const $fda9af9d7b881e5f$var$fontStyles = null;
/**
 * Adding the padding here avoids cropping the keyline on its sides.
 * The combined vertical spacing is maintained by subtracting the
 * keyline height from header and footer using negative margins.
 */ const $fda9af9d7b881e5f$var$bodyScrollStyles = null;
/**
 * Keylines will not be shown if scrolling in viewport so we do
 * not account for them in this case.
 */ const $fda9af9d7b881e5f$var$viewportScrollStyles = null;
/**
 * __Modal body__
 *
 * A modal body is used to display the main content of a modal.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-body-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ const $fda9af9d7b881e5f$var$ModalBody = (props)=>{
    const { children: children, testId: userDefinedTestId } = props;
    const { testId: modalTestId } = (0, $i2ajl.useModal)();
    const shouldScrollInViewport = (0, $fPXvL.default)();
    const testId = userDefinedTestId || modalTestId && `${modalTestId}--body`;
    return shouldScrollInViewport ? /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug",
            "_18zr1ejb",
            (0, $fHpHg.fg)('platform_ads_explicit_font_styles') && "_11c82smr"
        ]),
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2alJM.TouchScrollable), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bNMQd.default), {
            testId: userDefinedTestId || modalTestId,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                "data-testid": testId,
                className: (0, $bwpsq.default)([
                    "_16jlkb7n _1o9zkb7n _i0dl1wug",
                    "_1rjc1bk5 _18zr1ejb",
                    (0, $fHpHg.fg)('platform_ads_explicit_font_styles') && "_11c82smr"
                ]),
                children: children
            })
        })
    });
};
var $fda9af9d7b881e5f$export$2e2bcd8739ae039 = $fda9af9d7b881e5f$var$ModalBody;

});
parcelRegister("bNMQd", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6799e68f887b7c2$export$2e2bcd8739ae039);
/* scroll-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");

var $7nRxN = parcelRequire("7nRxN");

var $cD7p8 = parcelRequire("cD7p8");

var $bKnKN = parcelRequire("bKnKN");

var $bLDkX = parcelRequire("bLDkX");

var $6fV04 = parcelRequire("6fV04");
const $e6799e68f887b7c2$var$keylineColor = "var(--ds-border, #091E4224)";
const $e6799e68f887b7c2$var$baseStyles = null;
const $e6799e68f887b7c2$var$keylineHeight = 2;
const $e6799e68f887b7c2$var$topKeylineStyles = null;
const $e6799e68f887b7c2$var$bottomKeylineStyles = null;
/**
 * A container that shows top and bottom keylines when the
 * content overflows into the scrollable element.
 */ const $e6799e68f887b7c2$var$ScrollContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ testId: testId, children: children }, ref)=>{
    const scrollableRef = (0, $5uXOq.useRef)(null);
    const [showTopKeyline, setTopKeyline] = (0, $5uXOq.useState)(false);
    const [showBottomKeyline, setBottomKeyline] = (0, $5uXOq.useState)(false);
    const [showContentFocus, setContentFocus] = (0, $5uXOq.useState)(false);
    // Schedule a content focus on the target element
    // WARNING: In theory, `target` may not be available when `rafSchedule` hits in concurrent rendering
    (0, $5uXOq.useEffect)(()=>{
        const schedule = (0, $7nRxN.default)(()=>{
            const target = scrollableRef.current;
            target && setContentFocus(target.scrollHeight > target.clientHeight);
        });
        schedule();
    }, [
        scrollableRef
    ]);
    const setLazyKeylines = (0, $bLDkX.default)((0, $7nRxN.default)(()=>{
        const target = scrollableRef.current;
        if (target) {
            const scrollableDistance = target.scrollHeight - target.clientHeight;
            if (target.previousElementSibling) setTopKeyline(target.scrollTop > $e6799e68f887b7c2$var$keylineHeight);
            if (target.nextElementSibling) setBottomKeyline(target.scrollTop <= scrollableDistance - $e6799e68f887b7c2$var$keylineHeight);
        }
    }));
    // On load (and scroll/resize events), we set "keylines"
    // these border the content to indicate scrollability when content underflows the header or footer
    (0, $5uXOq.useEffect)(()=>{
        const target = scrollableRef.current;
        setLazyKeylines();
        const unbindWindowEvent = (0, $cBeZP.bind)(window, {
            type: 'resize',
            listener: setLazyKeylines
        });
        const unbindTargetEvent = target ? (0, $cBeZP.bind)(target, {
            type: 'scroll',
            listener: setLazyKeylines
        }) : (0, $bKnKN.default);
        return ()=>{
            unbindWindowEvent();
            unbindTargetEvent();
        };
    }, [
        setLazyKeylines
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6fV04.default), {
        isInset: true,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            // tabindex is allowed here so that keyboard users can scroll content
            // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
            tabIndex: showContentFocus ? 0 : undefined,
            role: showContentFocus ? 'region' : undefined,
            "aria-label": showContentFocus ? 'Scrollable content' : undefined,
            "data-testid": testId && `${testId}--scrollable`,
            ref: (0, $cD7p8.default)([
                ref,
                scrollableRef
            ]),
            className: (0, $bwpsq.default)([
                "_16jlkb7n _1o9zkb7n _i0dl1kw7 _1e0c1kw7 _2lx21kw7 _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _1reo15vq _18m91wug _1jykn7od _wzg61wug",
                showTopKeyline && "_mqm2v2xi",
                showBottomKeyline && "_179rv2xi"
            ]),
            children: children
        })
    });
});
$e6799e68f887b7c2$var$ScrollContainer.displayName = 'ScrollContainer';
var $e6799e68f887b7c2$export$2e2bcd8739ae039 = $e6799e68f887b7c2$var$ScrollContainer;

});
parcelRegister("bLDkX", function(module, exports) {

$parcel$export(module.exports, "default", () => $60e002e594e99aa6$export$2e2bcd8739ae039);

var $e9tUk = parcelRequire("e9tUk");
function $60e002e594e99aa6$export$2e2bcd8739ae039(callback) {
    const ref = (0, $e9tUk.default)(()=>callback);
    return ref.current;
}

});
parcelRegister("e9tUk", function(module, exports) {

$parcel$export(module.exports, "default", () => $e91ca4b080189dcc$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $e91ca4b080189dcc$var$uniqueReferencedValue = {};
function $e91ca4b080189dcc$export$2e2bcd8739ae039(initializer) {
    const ref = (0, $5uXOq.useRef)($e91ca4b080189dcc$var$uniqueReferencedValue);
    if (ref.current === $e91ca4b080189dcc$var$uniqueReferencedValue) ref.current = initializer();
    return ref;
}

});



parcelRegister("fPXvL", function(module, exports) {

$parcel$export(module.exports, "default", () => $4323108026de3c51$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $kQNf9 = parcelRequire("kQNf9");
function $4323108026de3c51$export$2e2bcd8739ae039() {
    const shouldScrollInViewport = (0, $5uXOq.useContext)((0, $kQNf9.ScrollContext));
    if (shouldScrollInViewport == null) throw Error("@atlaskit/modal-dialog: Scroll context unavailable \u2013 this component needs to be a child of ModalDialog.");
    return shouldScrollInViewport;
}

});


parcelRegister("7CjwE", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $8dd2e46886b3426e$export$2e2bcd8739ae039);
/* modal-footer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $i2ajl = parcelRequire("i2ajl");
const $8dd2e46886b3426e$var$footerStyles = null;
/**
 * __Modal footer__
 *
 * A modal footer often contains a primary action and the ability to cancel and close the dialog, though can contain any React element.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples#modal-footer)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-footer-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ const $8dd2e46886b3426e$var$ModalFooter = (props)=>{
    const { children: children, testId: userDefinedTestId } = props;
    const { testId: modalTestId } = (0, $i2ajl.useModal)();
    const testId = userDefinedTestId || modalTestId && `${modalTestId}--footer`;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            "_zulpu2gc _18zr1ejb _1e0c1txw _kqswh2mm _4cvr1h6o _1bahesu3 _1pfh1ezb _85i51ejb _1q51pxbi"
        ]),
        children: children
    });
};
var $8dd2e46886b3426e$export$2e2bcd8739ae039 = $8dd2e46886b3426e$var$ModalFooter;

});

parcelRegister("f0PnG", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::182e7300aed0f8931ea6d6a6afcdcbad>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $aedeb6494e3a3d22$var$_react = $aedeb6494e3a3d22$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $aedeb6494e3a3d22$var$_page = $aedeb6494e3a3d22$var$_interopRequireDefault((parcelRequire("4HiZI")));

var $aedeb6494e3a3d22$var$_page2 = $aedeb6494e3a3d22$var$_interopRequireDefault((parcelRequire("fjBW7")));
function $aedeb6494e3a3d22$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for PageIcon.
 * This component is PageIcon, with `UNSAFE_fallbackIcon` set to "PageIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for pages in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $aedeb6494e3a3d22$var$PageIcon = (props)=>/*#__PURE__*/ $aedeb6494e3a3d22$var$_react.default.createElement($aedeb6494e3a3d22$var$_page.default, Object.assign({
        LEGACY_fallbackIcon: $aedeb6494e3a3d22$var$_page2.default
    }, props));
$aedeb6494e3a3d22$var$PageIcon.Name = 'PageIconMigration';
var $aedeb6494e3a3d22$var$_default = module.exports.default = $aedeb6494e3a3d22$var$PageIcon;

});

parcelRegister("kW74I", function(module, exports) {

$parcel$export(module.exports, "default", () => $586bdf6ffdf71365$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $7xhdA = parcelRequire("7xhdA");
/**
 * __Modal transition__
 *
 * A modal transition wraps a modal to provide a fluid transition upon opening and closing.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ const $586bdf6ffdf71365$var$ModalTransition = (props)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7xhdA.default), {
        appear: true,
        children: //Checking if children are undefined to prevent potential runtime errors in React 17
        props.children ?? null
    });
};
var $586bdf6ffdf71365$export$2e2bcd8739ae039 = $586bdf6ffdf71365$var$ModalTransition;

});

parcelRegister("8zIDr", function(module, exports) {

$parcel$export(module.exports, "default", () => $d85af6c3c1228b2a$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $6tzHJ = parcelRequire("6tzHJ");

var $fHpHg = parcelRequire("fHpHg");

var $3YyrB = parcelRequire("3YyrB");
var $5sRpy = parcelRequire("5sRpy");
const $d85af6c3c1228b2a$var$styles = {
    visitedLink: "_ect41gqc _1053w7te _1ienw7te _n0fxw7te _1vhvg3x0",
    defaultAppearance: "_4bfu18uv _1hms8stv _ajmmnqa1 _syaz14q2 _ect41gqc _1a3b18uv _4fpr8stv _5goinqa1 _f8pj14q2 _9oik18uv _1bnxglyw _jf4cnqa1 _30l314q2 _1nrm18uv _c2waglyw _1iohnqa1 _9h8h16c2",
    subtleAppearance: "_4bfu18uv _1hmsglyw _ajmmnqa1 _ect41gqc _syaz1gjq _1a3b18uv _4fprglyw _5goinqa1 _f8pj1gjq _9oik18uv _1bnx8stv _jf4cnqa1 _30l31gjq _1nrm18uv _c2wa8stv _1iohnqa1 _9h8h1fxt",
    inverseAppearance: "_4bfu18uv _1hms8stv _ajmmnqa1 _ect41gqc _syaz15cr _105315cr _1a3b18uv _4fpr8stv _5goinqa1 _f8pj15cr _9oik18uv _1bnxglyw _jf4cnqa1 _30l315cr _1nrm18uv _c2waglyw _1iohnqa1 _9h8h15cr",
    iconWrapper: "_1e0c1nu9 _o5721q9c _s7n4jp4b _kqswh2mm _152ttb3r"
};
const $d85af6c3c1228b2a$var$iconStyles = null;
const $d85af6c3c1228b2a$var$LinkWithoutRef = ({ children: children, testId: testId, appearance: appearance = 'default', newWindowLabel: newWindowLabel, target: target, // @ts-expect-error
className: preventedClassName, // @ts-expect-error
style: preventedStyle, ...htmlAttributes }, ref)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $3YyrB.default), {
        ...htmlAttributes,
        target: target,
        ref: ref,
        xcss: (0, $6tzHJ.cx)(appearance === 'default' && $d85af6c3c1228b2a$var$styles.defaultAppearance, appearance === 'subtle' && $d85af6c3c1228b2a$var$styles.subtleAppearance, appearance === 'inverse' && $d85af6c3c1228b2a$var$styles.inverseAppearance, // Visited styles are not supported for inverse links due to contrast issues
        appearance !== 'inverse' && $d85af6c3c1228b2a$var$styles.visitedLink),
        testId: testId,
        componentName: "Link",
        newWindowLabel: newWindowLabel,
        children: [
            children,
            target === '_blank' && /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5sRpy.default), {
                as: "span",
                xcss: $d85af6c3c1228b2a$var$styles.iconWrapper,
                testId: testId && `${testId}__icon`,
                children: [
                    "\uFEFF",
                    (0, $fHpHg.fg)('platform-visual-refresh-icons') ? /*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
                        width: "12",
                        height: "12",
                        viewBox: "0 0 12 12",
                        fill: "none",
                        className: (0, $bwpsq.default)([
                            "_1bsbgm0b _4t3igm0b _ahbqzjw7"
                        ]),
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M0 1.82609C0 0.817938 0.817938 0 1.82609 0H3.91304V1.04348H1.82609C1.39424 1.04348 1.04348 1.39424 1.04348 1.82609V10.1739C1.04348 10.6058 1.39424 10.9565 1.82609 10.9565H10.1739C10.6058 10.9565 10.9565 10.6058 10.9565 10.1739V8.08696H12V10.1739C12 11.1821 11.1821 12 10.1739 12H1.82609C0.817938 12 0 11.1821 0 10.1739V1.82609ZM7.04348 0H12V4.95652H10.9565V1.78133L6.36893 6.36893L5.63107 5.63107L10.2187 1.04348H7.04348V0Z",
                            fill: "currentColor"
                        })
                    }) : /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
                        width: "20",
                        height: "20",
                        viewBox: "0 0 20 20",
                        fill: "currentColor",
                        className: (0, $bwpsq.default)([
                            "_1bsbgm0b _4t3igm0b _ahbqzjw7"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                                d: "M17.5715 3.95926L10.7587 10.772C10.5546 10.9692 10.2811 11.0784 9.99723 11.0759C9.71338 11.0734 9.44185 10.9596 9.24113 10.7589C9.04041 10.5581 8.92655 10.2866 8.92409 10.0027C8.92162 9.7189 9.03074 9.44543 9.22794 9.24125L16.0407 2.4285H14.3237C14.0366 2.4285 13.7613 2.31444 13.5582 2.11142C13.3552 1.90839 13.2411 1.63303 13.2411 1.34591C13.2411 1.05879 13.3552 0.783424 13.5582 0.580399C13.7613 0.377373 14.0366 0.263314 14.3237 0.263314H18.4981C18.5509 0.254962 18.6043 0.250507 18.658 0.250041C18.8017 0.248792 18.9443 0.276183 19.0773 0.330617C19.2104 0.385051 19.3313 0.465437 19.4329 0.567084C19.5346 0.668732 19.6149 0.789606 19.6694 0.922652C19.7238 1.0557 19.7512 1.19825 19.75 1.342C19.7495 1.3956 19.7451 1.44896 19.7367 1.50165V5.67628C19.7367 5.9634 19.6227 6.23877 19.4196 6.44179C19.2166 6.64482 18.9412 6.75888 18.6541 6.75888C18.367 6.75888 18.0916 6.64482 17.8886 6.44179C17.6856 6.23877 17.5715 5.9634 17.5715 5.67628V3.95926Z"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                                d: "M2.41519 17.5848V2.4285H8.91076V0.263314H2.41194C1.22001 0.263314 0.25 1.23007 0.25 2.42201V17.5913C0.250574 18.1638 0.47834 18.7127 0.883283 19.1175C1.28823 19.5222 1.83724 19.7497 2.40978 19.75H17.5769C17.8608 19.7499 18.1418 19.6938 18.404 19.585C18.6662 19.4762 18.9044 19.3168 19.105 19.116C19.3055 18.9151 19.4646 18.6767 19.573 18.4143C19.6814 18.152 19.737 17.8708 19.7367 17.587V11.0893H17.5715V17.5848H2.41519Z"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
// Workarounds to support generic types with forwardRef
/**
 * __Link__
 *
 * A link is an inline text element that navigates to a new location when clicked.
 *
 * - [Examples](https://atlassian.design/components/primitives/link/examples)
 * - [Code](https://atlassian.design/components/primitives/link/code)
 * - [Usage](https://atlassian.design/components/primitives/link/usage)
 */ const $d85af6c3c1228b2a$var$Link = /*#__PURE__*/ (0, $5uXOq.forwardRef)($d85af6c3c1228b2a$var$LinkWithoutRef);
var $d85af6c3c1228b2a$export$2e2bcd8739ae039 = $d85af6c3c1228b2a$var$Link;

});
parcelRegister("3YyrB", function(module, exports) {

$parcel$export(module.exports, "default", () => $21052412b99bf8d6$export$2e2bcd8739ae039);
/* anchor.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $DEWI6 = parcelRequire("DEWI6");

var $3joPi = parcelRequire("3joPi");

var $eNCZ4 = parcelRequire("eNCZ4");

var $3BT8o = parcelRequire("3BT8o");

var $bKnKN = parcelRequire("bKnKN");

var $jJsBW = parcelRequire("jJsBW");

var $9ewsv = parcelRequire("9ewsv");

var $cBCgC = parcelRequire("cBCgC");

var $kueXD = parcelRequire("kueXD");
const $21052412b99bf8d6$var$styles = {
    root: "_4bfu18uv _1hms8stv _ajmmnqa1 _vchhusvi"
};
const $21052412b99bf8d6$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
const $21052412b99bf8d6$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms|blob):)|(#))/; /**
                                                              * __Anchor__
                                                              *
                                                              * A primitive for building custom anchor links.
                                                              *
                                                              * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
                                                              * - [Code](https://atlassian.design/components/primitives/anchor/code)
                                                              * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
                                                              */ 
const $21052412b99bf8d6$var$AnchorNoRef = ({ href: href, children: children, onClick: providedOnClick = (0, $bKnKN.default), interactionName: interactionName, componentName: componentName, analyticsContext: analyticsContext, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, style: style, target: target, testId: testId, xcss: xcss, newWindowLabel: newWindowLabel = '(opens new window)', ...htmlAttributes }, ref)=>{
    const interactionContext = (0, $5uXOq.useContext)((0, $9ewsv.default));
    const handleClick = (0, $5uXOq.useCallback)((e, analyticsEvent)=>{
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    const opensNewWindowLabelId = (0, $jJsBW.useId)();
    const onClick = (0, $eNCZ4.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Anchor',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local",
        analyticsData: analyticsContext,
        actionSubject: 'link'
    }); // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    const RouterLink = (0, $3BT8o.default)();
    const isExternal = typeof href === 'string' && $21052412b99bf8d6$var$IS_EXTERNAL_LINK_REGEX.test(href);
    const isNonHttpBased = typeof href === 'string' && $21052412b99bf8d6$var$IS_NON_HTTP_BASED.test(href); /**
                                                                                    * Renders a router link if:
                                                                                    *
                                                                                    * - a link component is set in the app provider
                                                                                    * - it's not an external link (starting with `http://` or `https://`)
                                                                                    * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.).
                                                                                    */ 
    const isRouterLink = RouterLink && !isExternal && !isNonHttpBased;
    const hrefObjectUsedWithoutRouterLink = RouterLink === undefined && typeof href === 'object';
    (0, $3joPi.default)(!hrefObjectUsedWithoutRouterLink, `@atlaskit/primitives: Anchor primitive cannot pass an object to 'href' unless a router link is configured in the AppProvider`);
    const Component = isRouterLink ? RouterLink : 'a';
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $kueXD.default // @ts-expect-error we don't allow `a` on Focusable for makers as they should use Anchor instead
    ), {
        as: Component,
        className: xcss,
        style: style,
        ref: ref,
        ...safeHtmlAttributes,
        href: !isRouterLink && typeof href !== 'string' ? undefined : href,
        target: target,
        onClick: onClick,
        "aria-label": ariaLabel && target === '_blank' && !ariaLabelledBy ? `${ariaLabel} , ${newWindowLabel}` : ariaLabel,
        "aria-labelledby": ariaLabelledBy && target === '_blank' ? `${ariaLabelledBy} ${opensNewWindowLabelId}` : ariaLabelledBy,
        xcss: (0, $DEWI6.cx)($21052412b99bf8d6$var$styles.root, xcss),
        testId: testId,
        "data-is-router-link": testId ? isRouterLink ? 'true' : 'false' : undefined,
        children: [
            children,
            target === '_blank' && (children && !ariaLabel && !ariaLabelledBy || ariaLabelledBy) && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cBCgC.default), {
                id: opensNewWindowLabelId,
                children: `, ${newWindowLabel}`
            })
        ]
    });
};
// Workarounds to support generic types with forwardRef
/**
 * __Anchor__
 *
 * Anchor is a primitive for building custom anchor links. It's a wrapper around the HTML `<a>` element that provides a consistent API for handling client-side routing and Atlassian Design System styling.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ const $21052412b99bf8d6$var$Anchor = /*#__PURE__*/ (0, $5uXOq.forwardRef)($21052412b99bf8d6$var$AnchorNoRef);
var $21052412b99bf8d6$export$2e2bcd8739ae039 = $21052412b99bf8d6$var$Anchor;

});
parcelRegister("3BT8o", function(module, exports) {

$parcel$export(module.exports, "default", () => $4439e7dc70822c7f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $i7GAe = parcelRequire("i7GAe");
/**
 * __useRouterLink()__
 *
 * Hook: Returns app-configured router link component.
 *
 * A generic can be passed to define advanced link configuration:
 * ```
 * type MyRouterLinkConfig = {
 *  to: string;
 *  replace?: boolean;
 * }
 *
 * const RouterLink = useRouterLink<MyRouterLinkConfig>();
 * ```
 */ const $4439e7dc70822c7f$var$useRouterLink = ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $5uXOq.useContext)((0, $i7GAe.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
};
var $4439e7dc70822c7f$export$2e2bcd8739ae039 = $4439e7dc70822c7f$var$useRouterLink;

});
parcelRegister("i7GAe", function(module, exports) {

$parcel$export(module.exports, "RouterLinkProviderContext", () => $70b5e0b0ffaec32e$export$2931e0ee690eee88);
$parcel$export(module.exports, "default", () => $70b5e0b0ffaec32e$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
const $70b5e0b0ffaec32e$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $5uXOq.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ const $70b5e0b0ffaec32e$var$RouterLinkProvider = ({ routerLinkComponent: routerLinkComponent, children: children })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)($70b5e0b0ffaec32e$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        },
        children: children
    });
};
var $70b5e0b0ffaec32e$export$2e2bcd8739ae039 = $70b5e0b0ffaec32e$var$RouterLinkProvider;

});




parcelRegister("9eEJv", function(module, exports) {

$parcel$export(module.exports, "default", () => $6cf4b9ea2c3209f6$export$2e2bcd8739ae039);
/* banner.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $5sRpy = parcelRequire("5sRpy");
var $5sLH0 = parcelRequire("5sLH0");

const $6cf4b9ea2c3209f6$var$CSS_VAR_TEXT_COLOR = '--banner-text-color';
const $6cf4b9ea2c3209f6$var$inlineStyles = {
    root: "_1ul9idpf"
};
const $6cf4b9ea2c3209f6$var$textStyles = {
    root: "_11c82smr _1reo15vq _18m915vq _syaz12s4 _k48p1wq8 _1bto1l2s _o5721q9c _593818uv _7hxb18uv _9m7f18uv _rfqo18uv _qfs118uv _yha28stv _15zv8stv _w7sw8stv _1bgk8stv _s41o8stv _1nmznqa1 _1xvinqa1 _15a9nqa1 _1t0pnqa1 _1k6pnqa1 _43ds1r31 _p03c1r31 _oavv1r31 _oxk41r31 _1cay1r31"
};
const $6cf4b9ea2c3209f6$var$backgroundColors = {
    warning: 'color.background.warning.bold',
    error: 'color.background.danger.bold',
    announcement: 'color.background.neutral.bold'
};
const $6cf4b9ea2c3209f6$var$tokenBackgroundColors = {
    warning: `var(--ds-background-warning-bold, ${(0, $a7f8c6b391092279$export$c6930421db9fa514)})`,
    error: `var(--ds-background-danger-bold, ${(0, $a7f8c6b391092279$export$2010d0fb4295b346)})`,
    announcement: `var(--ds-background-neutral-bold, ${(0, $a7f8c6b391092279$export$c39c0fe0f26207ae)})`
};
const $6cf4b9ea2c3209f6$var$tokenTextColors = {
    warning: `var(--ds-text-warning-inverse, ${(0, $a7f8c6b391092279$export$ad0bacf983b7ddaa)})`,
    error: `var(--ds-text-inverse, ${(0, $a7f8c6b391092279$export$29a4f05edc054374)})`,
    announcement: `var(--ds-text-inverse, ${(0, $a7f8c6b391092279$export$29a4f05edc054374)})`
};
const $6cf4b9ea2c3209f6$var$containerStyles = {
    root: "_4t3i1wto _4cvr1h6o _1e0c1txw"
};
const $6cf4b9ea2c3209f6$var$iconWrapperStyles = {
    root: "_1e0c1txw _4cvr1h6o _1bah1h6o _1bsb1k8s _4t3i1k8s _1o9zidpf"
};
/**
 * __Banner__
 *
 * A banner displays a prominent message at the top of the screen.
 *
 * - [Examples](https://atlassian.design/components/banner/examples)
 * - [Code](https://atlassian.design/components/banner/code)
 * - [Usage](https://atlassian.design/components/banner/usage)
 */ const $6cf4b9ea2c3209f6$var$Banner = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ appearance: appearance = 'warning', children: children, icon: icon, testId: testId }, ref)=>{
    const appearanceType = appearance in $6cf4b9ea2c3209f6$var$backgroundColors ? appearance : 'warning';
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        xcss: $6cf4b9ea2c3209f6$var$containerStyles.root,
        backgroundColor: $6cf4b9ea2c3209f6$var$backgroundColors[appearanceType],
        padding: "space.150",
        testId: testId,
        ref: ref,
        role: "alert",
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5sLH0.default), {
            space: "space.050",
            alignBlock: "center",
            alignInline: "start",
            xcss: $6cf4b9ea2c3209f6$var$inlineStyles.root,
            children: [
                icon ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
                    as: "span",
                    xcss: $6cf4b9ea2c3209f6$var$iconWrapperStyles.root,
                    style: {
                        fill: $6cf4b9ea2c3209f6$var$tokenBackgroundColors[appearanceType],
                        color: $6cf4b9ea2c3209f6$var$tokenTextColors[appearanceType]
                    },
                    children: icon
                }) : null,
                /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                    style: {
                        [$6cf4b9ea2c3209f6$var$CSS_VAR_TEXT_COLOR]: $6cf4b9ea2c3209f6$var$tokenTextColors[appearanceType]
                    },
                    className: (0, $bwpsq.default)([
                        $6cf4b9ea2c3209f6$var$textStyles.root
                    ]),
                    children: children
                })
            ]
        })
    });
});
var $6cf4b9ea2c3209f6$export$2e2bcd8739ae039 = $6cf4b9ea2c3209f6$var$Banner;

});

parcelRegister("55tuP", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e1dbd302bfd2e6a$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");

var $eNCZ4 = parcelRequire("eNCZ4");

var $bKnKN = parcelRequire("bKnKN");

var $86D9T = parcelRequire("86D9T");
var $aLUgv = parcelRequire("aLUgv");

var $fHpHg = parcelRequire("fHpHg");

var $7Ye64 = parcelRequire("7Ye64");
var $e5neF = parcelRequire("e5neF");
var $87gQG = parcelRequire("87gQG");

var $aGzDO = parcelRequire("aGzDO");

var $4z3Sd = parcelRequire("4z3Sd");
const $7e1dbd302bfd2e6a$var$checkIsChildOfPortal = (node)=>{
    if (!node) return false;
    return node.classList && node.classList.contains('atlaskit-portal-container') || $7e1dbd302bfd2e6a$var$checkIsChildOfPortal(node.parentElement);
};
// Close manager for layering
const $7e1dbd302bfd2e6a$var$CloseManager = ({ handleEscapeClose: handleEscapeClose, handleClick: handleClick })=>{
    (0, $aLUgv.useCloseOnEscapePress)({
        onClose: handleEscapeClose
    });
    const { isLayerDisabled: isLayerDisabled } = (0, $aLUgv.useLayering)();
    (0, $5uXOq.useEffect)(()=>{
        return (0, $cBeZP.bind)(window, {
            type: 'click',
            listener: (e)=>{
                if (isLayerDisabled()) return;
                handleClick(e);
            },
            options: {
                capture: true
            }
        });
    }, [
        handleClick,
        isLayerDisabled
    ]);
    // only create a dummy component for using ths hook in class component
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {});
};
const $7e1dbd302bfd2e6a$var$InlineDialog = /*#__PURE__*/ (0, $5uXOq.memo)(function InlineDialog({ isOpen: isOpen = false, onContentBlur: onContentBlur = (0, $bKnKN.default), onContentClick: onContentClick = (0, $bKnKN.default), onContentFocus: onContentFocus = (0, $bKnKN.default), onClose: providedOnClose = (0, $bKnKN.default), placement: placement = 'bottom-start', strategy: strategy = 'fixed', testId: testId, content: content, children: children }) {
    const containerRef = (0, $5uXOq.useRef)(null);
    const triggerRef = (0, $5uXOq.useRef)(null);
    const onClose = (0, $eNCZ4.usePlatformLeafEventHandler)({
        fn: (event)=>providedOnClose(event),
        action: 'closed',
        componentName: 'inlineDialog',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    // we put this into a ref to avoid handleCloseRequest having this as a dependency
    const onCloseRef = (0, $5uXOq.useRef)(onClose);
    (0, $5uXOq.useEffect)(()=>{
        onCloseRef.current = onClose;
    });
    const handleCloseRequest = (0, $5uXOq.useCallback)((event)=>{
        const { target: target } = event;
        // checks for when target is not HTMLElement
        if (!(target instanceof HTMLElement)) return;
        // TODO: This is to handle the case where the target is no longer in the DOM.
        // This happens with react-select in datetime picker. There might be other
        // edge cases for this.
        if (!document.body.contains(target)) return;
        if (isOpen) {
            onCloseRef.current?.({
                isOpen: false,
                event: event
            });
            return;
        }
        // handles the case where inline dialog opens portalled elements such as modal
        if ($7e1dbd302bfd2e6a$var$checkIsChildOfPortal(target)) return;
        // call onClose if the click originated from outside the dialog
        if (containerRef.current && !containerRef.current.contains(target)) onCloseRef.current?.({
            isOpen: false,
            event: event
        });
    }, [
        isOpen
    ]);
    const handleClick = (0, $5uXOq.useCallback)((event)=>{
        // exit if we click outside but on the trigger — it can handle the clicks itself
        if (triggerRef.current && triggerRef.current.contains(event.target)) return;
        if (containerRef.current?.contains(event.target)) return;
        handleCloseRequest(event);
    }, [
        handleCloseRequest,
        containerRef,
        triggerRef
    ]);
    const popper = isOpen ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $e5neF.Popper), {
        placement: placement,
        strategy: strategy,
        children: ({ ref: ref, style: style })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $4z3Sd.Container), {
                onBlur: onContentBlur,
                onFocus: onContentFocus,
                onClick: onContentClick,
                ref: (node)=>{
                    if (node) {
                        containerRef.current = node;
                        if (typeof ref === 'function') ref(node);
                        else ref.current = node;
                    }
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: style,
                testId: testId,
                children: typeof content === 'function' ? content() : content
            })
    }) : null;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $7Ye64.Manager), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $87gQG.Reference), {
                children: ({ ref: ref })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $aGzDO.default), {
                        innerRef: (node)=>{
                            triggerRef.current = node;
                            if (typeof ref === 'function') ref(node);
                            else ref.current = node;
                        },
                        hasNodeResolver: !(0, $fHpHg.fg)('platform_design_system_team_portal_logic_r18_fix'),
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, {
                            children: children
                        })
                    })
            }),
            isOpen ? /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $86D9T.Layering), {
                isDisabled: false,
                children: [
                    popper,
                    /*#__PURE__*/ (0, $2OMIu.jsx)($7e1dbd302bfd2e6a$var$CloseManager, {
                        handleEscapeClose: handleCloseRequest,
                        handleClick: handleClick
                    })
                ]
            }) : popper
        ]
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$7e1dbd302bfd2e6a$export$2e2bcd8739ae039 = $7e1dbd302bfd2e6a$var$InlineDialog;

});
parcelRegister("86D9T", function(module, exports) {

$parcel$export(module.exports, "LevelContext", () => $ae43bd50a14326c1$export$650d12d3c2ddb8fc);
$parcel$export(module.exports, "TopLevelContext", () => $ae43bd50a14326c1$export$48b383b280e20440);
$parcel$export(module.exports, "Layering", () => $ae43bd50a14326c1$export$7c885f891c940977);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bKnKN = parcelRequire("bKnKN");

var $fHpHg = parcelRequire("fHpHg");
const $ae43bd50a14326c1$export$650d12d3c2ddb8fc = /*#__PURE__*/ (0, $5uXOq.createContext)(0);
const $ae43bd50a14326c1$export$48b383b280e20440 = /*#__PURE__*/ (0, $5uXOq.createContext)({
    topLevelRef: {
        current: null
    },
    layerList: {
        current: null
    },
    setTopLevel: (0, $bKnKN.default)
});
/**
 *
 *  @internal
 * Context Provider Component which provider the current level of nested layers
 * It handles level management when it mounts and unmounts
 *
 */ const $ae43bd50a14326c1$var$LevelProvider = ({ children: children, currentLevel: currentLevel })=>{
    const { setTopLevel: setTopLevel, topLevelRef: topLevelRef, layerList: layerList } = (0, $5uXOq.useContext)($ae43bd50a14326c1$export$48b383b280e20440);
    // This is not unstable, it will run once for ref creation.
    // eslint-disable-next-line  @repo/internal/react/disallow-unstable-values
    const id = (0, $5uXOq.useRef)((0, $fHpHg.fg)('layering-top-level-use-array') ? Math.random().toString(36) : '');
    if (!(0, $fHpHg.fg)('layering-top-level-use-array')) {
        if (topLevelRef.current === null || currentLevel > topLevelRef.current) setTopLevel(currentLevel);
    }
    if (!(0, $fHpHg.fg)('layering-top-level-use-array')) // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useEffect)(()=>{
        return ()=>{
            // avoid immediate cleanup using setTimeout when component unmount
            // this will make sure non-top layer components can get the correct top level value
            // when multiple layers trigger onClose in sequence
            setTimeout(()=>{
                setTopLevel(currentLevel - 1);
            }, 0);
        };
    }, [
        setTopLevel,
        currentLevel,
        topLevelRef
    ]);
    if ((0, $fHpHg.fg)('layering-top-level-use-array')) // Remove eslint error on FG cleanup
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useEffect)(()=>{
        const safeLayerList = layerList?.current;
        const safeId = id.current;
        if (!safeLayerList) return;
        safeLayerList.push(safeId);
        return ()=>{
            const index = safeLayerList.indexOf(safeId);
            if (index > -1) safeLayerList.splice(index, 1);
        };
    }, [
        layerList,
        id
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($ae43bd50a14326c1$export$650d12d3c2ddb8fc.Provider, {
        value: currentLevel,
        children: children
    });
};
/**
 *
 *  @internal
 * Context Provider Component which provides the top level of all nested layers
 * It provides initial top level ref value as 0 and set top level method
 *
 */ const $ae43bd50a14326c1$var$LayeringProvider = ({ children: children })=>{
    const topLevelRef = (0, $5uXOq.useRef)(0);
    const layerList = (0, $5uXOq.useRef)([]);
    const value = (0, $5uXOq.useMemo)(()=>({
            topLevelRef: topLevelRef,
            setTopLevel: (level)=>{
                topLevelRef.current = level;
            },
            ...(0, $fHpHg.fg)('layering-top-level-use-array') ? {
                layerList: layerList
            } : {}
        }), [
        topLevelRef
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($ae43bd50a14326c1$export$48b383b280e20440.Provider, {
        value: value,
        children: children
    });
};
const $ae43bd50a14326c1$export$7c885f891c940977 = ({ children: children, isDisabled: isDisabled = true })=>{
    const currentLevel = (0, $5uXOq.useContext)($ae43bd50a14326c1$export$650d12d3c2ddb8fc);
    if (isDisabled) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: children
    });
    const isNested = currentLevel > 0;
    const content = /*#__PURE__*/ (0, $2OMIu.jsx)($ae43bd50a14326c1$var$LevelProvider, {
        currentLevel: currentLevel + 1,
        children: children
    });
    return isNested ? content : /*#__PURE__*/ (0, $2OMIu.jsx)($ae43bd50a14326c1$var$LayeringProvider, {
        children: content
    });
};

});

parcelRegister("aLUgv", function(module, exports) {

$parcel$export(module.exports, "useCloseOnEscapePress", () => $a71d55c3d055a6f1$export$4a4bf067ea9e7886);
$parcel$export(module.exports, "useLayering", () => $a71d55c3d055a6f1$export$c8b4d54e03dee6ed);

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");

var $fHpHg = parcelRequire("fHpHg");

var $86D9T = parcelRequire("86D9T");
const $a71d55c3d055a6f1$var$ESCAPE = 'Escape';
function $a71d55c3d055a6f1$export$4a4bf067ea9e7886({ onClose: onClose, isDisabled: isDisabled }) {
    const escapePressed = (0, $5uXOq.useRef)(false);
    const { isLayerDisabled: isLayerDisabled } = $a71d55c3d055a6f1$export$c8b4d54e03dee6ed();
    const onKeyDown = (0, $5uXOq.useCallback)((e)=>{
        const isDisabledLayer = isLayerDisabled();
        if (isDisabled || escapePressed.current || e.key !== $a71d55c3d055a6f1$var$ESCAPE || isDisabledLayer) // We're either already handling the key down event or it's not escape or disabled.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled,
        isLayerDisabled
    ]);
    const onKeyUp = (0, $5uXOq.useCallback)(()=>{
        escapePressed.current = false;
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        return (0, $cBeZP.bindAll)(window, [
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'keyup',
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp
    ]);
}
function $a71d55c3d055a6f1$export$c8b4d54e03dee6ed() {
    const currentLevel = (0, $5uXOq.useContext)((0, $86D9T.LevelContext));
    const { topLevelRef: topLevelRef, layerList: layerList } = (0, $5uXOq.useContext)((0, $86D9T.TopLevelContext));
    const isLayerDisabled = (0, $5uXOq.useCallback)(()=>{
        if ((0, $fHpHg.fg)('layering-top-level-use-array')) return (layerList?.current?.length ?? 0) !== currentLevel;
        return !!topLevelRef.current && currentLevel !== topLevelRef.current;
    }, [
        currentLevel,
        topLevelRef,
        layerList
    ]);
    return {
        currentLevel: currentLevel,
        topLevelRef: topLevelRef,
        isLayerDisabled: isLayerDisabled,
        ...(0, $fHpHg.fg)('layering-top-level-use-array') ? {
            layerList: layerList
        } : {}
    };
}

});

parcelRegister("aGzDO", function(module, exports) {

$parcel$export(module.exports, "default", () => $45dd892a75078e7a$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $dI393 = parcelRequire("dI393");
/**
 * A wrapper component that conditionally applies a NodeResolver to its children.
 *
 * Note: NodeResolver should not be used in React 18 concurrent mode. This component
 * is intended to be removed once the feature flag  is removed.
 * @param {boolean} props.hasNodeResolver - Determines whether to apply the NodeResolver.
 * @param {ReactElement} props.children - The child elements to be wrapped.
 * @param {(instance: HTMLDivElement) => void} props.innerRef - A ref callback to get the instance of the HTMLDivElement.
 * @returns {ReactElement} The children wrapped with NodeResolver if hasNodeResolver is true, wrape the children in a div setting innerRef with ref to the div.
 */ const $45dd892a75078e7a$var$NodeResolverWrapper = ({ hasNodeResolver: hasNodeResolver, children: children, innerRef: innerRef })=>{
    if (hasNodeResolver) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dI393))), {
        innerRef: innerRef,
        children: children
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ref: (node)=>{
            innerRef(node?.firstElementChild);
        },
        children: children
    });
};
var $45dd892a75078e7a$export$2e2bcd8739ae039 = $45dd892a75078e7a$var$NodeResolverWrapper;

});

parcelRegister("4z3Sd", function(module, exports) {

$parcel$export(module.exports, "Container", () => $44d8ee9aa0e1b249$export$42a852a2b6b56249);
/* container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

const $44d8ee9aa0e1b249$var$CSS_THEME_BACKGROUND = '--theme-background';
const $44d8ee9aa0e1b249$var$CSS_THEME_COLOR = '--theme-color';
const $44d8ee9aa0e1b249$var$CSS_THEME_BOX_SHADOW = '--theme-box-shadow';
const $44d8ee9aa0e1b249$var$containerStyles = null;
const $44d8ee9aa0e1b249$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, onBlur: onBlur, onClick: onClick, onFocus: onFocus, style: style, testId: testId }, ref)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": testId,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            [$44d8ee9aa0e1b249$var$CSS_THEME_BACKGROUND]: `var(--ds-surface-overlay, ${(0, $a7f8c6b391092279$export$29a4f05edc054374)})`,
            [$44d8ee9aa0e1b249$var$CSS_THEME_COLOR]: `var(--ds-text, ${(0, $a7f8c6b391092279$export$fbda843f0a27fe96)})`,
            [$44d8ee9aa0e1b249$var$CSS_THEME_BOX_SHADOW]: `var(--ds-shadow-overlay, ${`0 4px 8px -2px ${(0, $a7f8c6b391092279$export$7d3359664e8bb0e5)}, 0 0 1px ${(0, $a7f8c6b391092279$export$d2d3bedfb276cac0)}`})`,
            ...style
        },
        className: (0, $bwpsq.default)([
            "_11q7gluh _2rko1sit _vchh18uv _p12flti4 _c71llti4 _1pbyowjs _16qs1r44 _syazjslb _85i5pxbi _1q51pxbi _y4ti1ejb _bozg1ejb _nt751r31 _49pcglyw _1hvw1o36"
        ]),
        children: typeof children === 'function' ? children() : children
    });
});

});


parcelRegister("hordk", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed2a4dabe3132988$export$2e2bcd8739ae039);
/* modal-wrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $ao4Ml = parcelRequire("ao4Ml");

var $2alJM = parcelRequire("2alJM");

var $eNCZ4 = parcelRequire("eNCZ4");

var $1wnUy = parcelRequire("1wnUy");

var $bKnKN = parcelRequire("bKnKN");

var $86D9T = parcelRequire("86D9T");

var $geBdj = parcelRequire("geBdj");

var $5g2iQ = parcelRequire("5g2iQ");

var $b4a3S = parcelRequire("b4a3S");

var $6qRzz = parcelRequire("6qRzz");

var $4PjUQ = parcelRequire("4PjUQ");

var $haWXj = parcelRequire("haWXj");
const $ed2a4dabe3132988$var$fillScreenStyles = null;
const $ed2a4dabe3132988$var$allowlistElements = (element, callback)=>{
    // Allow focus to reach elements outside the modal:
    // if AUI dialog is allowListed and visible
    if (!!document.querySelector('.aui-blanket:not([hidden])')) return false;
     // allows to pass a callback function to allow elements be ignored by focus lock
    if (typeof callback === 'function') return callback(element);
    return true;
}; /**
    * __Modal wrapper__
    *
    * A modal wrapper displays content that requires user interaction, in a layer above the page.
    * This component is primary container for other modal components.
    *
    * - [Examples](https://atlassian.design/components/modal-dialog/examples)
    * - [Code](https://atlassian.design/components/modal-dialog/code)
    * - [Usage](https://atlassian.design/components/modal-dialog/usage)
    */ 
const $ed2a4dabe3132988$var$ModalWrapper = (props)=>{
    const { autoFocus: autoFocus = true, focusLockAllowlist: focusLockAllowlist, shouldCloseOnEscapePress: shouldCloseOnEscapePress = true, shouldCloseOnOverlayClick: shouldCloseOnOverlayClick = true, shouldScrollInViewport: shouldScrollInViewport = false, shouldReturnFocus: shouldReturnFocus = true, stackIndex: stackIndexOverride, onClose: providedOnClose, onStackChange: onStackChange = (0, $bKnKN.default), isBlanketHidden: isBlanketHidden, children: children, height: height, width: width, onCloseComplete: onCloseComplete, onOpenComplete: onOpenComplete, label: label, testId: testId } = props;
    const calculatedStackIndex = (0, $4PjUQ.default)({
        onStackChange: onStackChange
    });
    const stackIndex = stackIndexOverride || calculatedStackIndex;
    const isForeground = stackIndex === 0; // When a user supplies a ref to focus we skip auto focus via react-focus-lock
    const autoFocusLock = typeof autoFocus === 'boolean' ? autoFocus : false;
    const onCloseHandler = (0, $eNCZ4.usePlatformLeafEventHandler)({
        fn: providedOnClose || (0, $bKnKN.default),
        action: 'closed',
        componentName: 'modalDialog',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const onBlanketClicked = (0, $5uXOq.useCallback)((e)=>{
        if (shouldCloseOnOverlayClick) onCloseHandler(e);
    }, [
        shouldCloseOnOverlayClick,
        onCloseHandler
    ]); // This ensures to prevent additional re-renders while nothing is passed to focusLockAllowlist explicitly.
    const allowListCallback = (0, $5uXOq.useCallback)((element)=>$ed2a4dabe3132988$var$allowlistElements(element, focusLockAllowlist), [
        focusLockAllowlist
    ]);
    (0, $haWXj.default)();
    const modalDialogWithBlanket = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1wnUy.default), {
        isTinted: !isBlanketHidden,
        onBlanketClicked: onBlanketClicked,
        testId: testId && `${testId}--blanket`,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6qRzz.default), {
            testId: testId,
            label: label,
            autoFocus: autoFocus,
            stackIndex: stackIndex,
            onClose: onCloseHandler,
            shouldCloseOnEscapePress: shouldCloseOnEscapePress && isForeground,
            shouldScrollInViewport: shouldScrollInViewport,
            height: height,
            width: width,
            onCloseComplete: onCloseComplete,
            onOpenComplete: onOpenComplete,
            hasProvidedOnClose: Boolean(providedOnClose),
            children: children
        })
    });
    let returnFocus = true;
    let onDeactivation;
    if ('boolean' === typeof shouldReturnFocus) returnFocus = shouldReturnFocus;
    else onDeactivation = ()=>{
        window.setTimeout(()=>{
            shouldReturnFocus.current?.focus();
        }, 0);
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $86D9T.Layering), {
        isDisabled: false,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5g2iQ.default), {
            zIndex: (0, $b4a3S.layers).modal(),
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $geBdj.default), {
                children: (fadeInProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        ...fadeInProps,
                        className: (0, $bwpsq.default)([
                            "_1bsbauwl _4t3i1kxc _kqsw1n9t _152tze3t _1e02ze3t _18m91wug _8am5i4x0",
                            fadeInProps.className
                        ]),
                        "aria-hidden": !isForeground,
                        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $ao4Ml.default), {
                            autoFocus: autoFocusLock,
                            returnFocus: returnFocus,
                            onDeactivation: onDeactivation,
                            whiteList: allowListCallback,
                            children: [
                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2alJM))), {}),
                                shouldScrollInViewport ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2alJM.TouchScrollable), {
                                    children: modalDialogWithBlanket
                                }) : modalDialogWithBlanket
                            ]
                        })
                    })
            })
        })
    });
};
var $ed2a4dabe3132988$export$2e2bcd8739ae039 = $ed2a4dabe3132988$var$ModalWrapper;

});
parcelRegister("1wnUy", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c5d154d5d4fe41a$export$2e2bcd8739ae039);
/* blanket.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $eNCZ4 = parcelRequire("eNCZ4");

var $bKnKN = parcelRequire("bKnKN");
const $3c5d154d5d4fe41a$var$packageName = "platform-pkg";
const $3c5d154d5d4fe41a$var$packageVersion = "0.0.0-use.local";
const $3c5d154d5d4fe41a$var$analyticsAttributes = {
    componentName: 'blanket',
    packageName: $3c5d154d5d4fe41a$var$packageName,
    packageVersion: $3c5d154d5d4fe41a$var$packageVersion
};
const $3c5d154d5d4fe41a$var$baseStyles = null;
const $3c5d154d5d4fe41a$var$shouldAllowClickThroughStyles = null;
const $3c5d154d5d4fe41a$var$invisibleStyles = null; /**
                               * __Blanket__
                               *
                               * A Blanket provides the overlay layer for components such as a modal dialog or a tooltip
                               *
                               * - [Examples](https://atlaskit.atlassian.com/examples/design-system/blanket/basic-usage)
                               */ 
const $3c5d154d5d4fe41a$var$Blanket = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(function Blanket({ shouldAllowClickThrough: shouldAllowClickThrough = false, isTinted: isTinted = false, onBlanketClicked: onBlanketClicked = (0, $bKnKN.default), testId: testId, children: children, analyticsContext: analyticsContext }, ref) {
    const mouseDownTarget = (0, $5uXOq.useRef)(null);
    const onBlanketClickedWithAnalytics = (0, $eNCZ4.usePlatformLeafEventHandler)({
        fn: onBlanketClicked,
        action: 'clicked',
        analyticsData: analyticsContext,
        ...$3c5d154d5d4fe41a$var$analyticsAttributes
    });
    const blanketClickOutsideChildren = (0, $5uXOq.useCallback)((e)=>e.currentTarget === e.target && mouseDownTarget.current === e.target ? onBlanketClickedWithAnalytics(e) : undefined, [
        onBlanketClickedWithAnalytics
    ]);
    const onClick = shouldAllowClickThrough ? undefined : blanketClickOutsideChildren;
    const onMouseDown = (0, $5uXOq.useCallback)((e)=>{
        mouseDownTarget.current = e.target;
    }, []);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        role: "presentation",
        onClick: onClick,
        onMouseDown: onMouseDown,
        "data-testid": testId,
        ref: ref,
        className: (0, $bwpsq.default)([
            "_1r04idpf _kqsw1n9t _1pbybfng _bfhku5cu _18m91wug _lcxv1wug",
            shouldAllowClickThrough && "_lcxvglyw",
            !isTinted && "_bfhk18uv"
        ]),
        children: children
    });
}));
$3c5d154d5d4fe41a$var$Blanket.displayName = 'Blanket';
var $3c5d154d5d4fe41a$export$2e2bcd8739ae039 = $3c5d154d5d4fe41a$var$Blanket;

});

parcelRegister("6qRzz", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f8209524c1b3a42$export$2e2bcd8739ae039);
/* modal-dialog.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $cD7p8 = parcelRequire("cD7p8");

var $42A03 = parcelRequire("42A03");

var $jJsBW = parcelRequire("jJsBW");

var $aLUgv = parcelRequire("aLUgv");

var $geBdj = parcelRequire("geBdj");

var $l5MhD = parcelRequire("l5MhD");

var $kQNf9 = parcelRequire("kQNf9");

var $cidB1 = parcelRequire("cidB1");

var $du7S6 = parcelRequire("du7S6");

var $gyEl7 = parcelRequire("gyEl7");

var $1QUpH = parcelRequire("1QUpH");

var $4TeuE = parcelRequire("4TeuE");

var $lnVj3 = parcelRequire("lnVj3");
const $1f8209524c1b3a42$var$LOCAL_CURRENT_SURFACE_CSS_VAR = '--ds-elevation-surface-current';
const $1f8209524c1b3a42$var$dialogStyles = {
    root: "_16jlidpf _1o9zkb7n _i0dl1wug _1e0c1txw _1bsb1osq _p12fauwl _4t3i1osq _1tkeidpf _c71l1kxc _2lx21bp4 _bfhk1bhr _syaz1fxt _1q1l1bhr _lcxv1wug _1mq81kw7 _m01u1kw7 _1dg11kw7 _mizu1p6i _1ah31bk5 _ra3xnqa1 _128m1bk5 _1cvmnqa1 _4davt94y _epkx1sit _we1i1kw7 _zg7p1cd0 _yakv1kw7 _4lht1kw7 _1xlt6m9r"
};
const $1f8209524c1b3a42$var$viewportScrollStyles = null;
const $1f8209524c1b3a42$var$bodyScrollStyles = null;
const $1f8209524c1b3a42$var$ModalDialog = (props)=>{
    const { width: width = 'medium', shouldScrollInViewport: shouldScrollInViewport = false, shouldCloseOnEscapePress: shouldCloseOnEscapePress, autoFocus: autoFocus, stackIndex: stackIndex, onClose: onClose, onCloseComplete: onCloseComplete, onOpenComplete: onOpenComplete, height: height, hasProvidedOnClose: hasProvidedOnClose, children: children, label: label, testId: testId } = props;
    const id = (0, $jJsBW.useId)();
    const titleId = `modal-dialog-title-${id}`;
    (0, $5uXOq.useEffect)(()=>{
        // Modal dialogs can appear on top of iframe elements that are on another domain.
        // There is a Chrome bug where drag and drop in an element on top of a cross domain
        // iframe is not working. We are applying the workaround for this bug in modal so
        // that consumers of our modal don't have to worry about this bug and are free to
        // create whatever drag and drop experience they like inside a modal
        //
        // Chrome bug: https://issues.chromium.org/issues/362301053
        return (0, $l5MhD.combine)((0, $du7S6.disableDraggingToCrossOriginIFramesForElement)(), (0, $1QUpH.disableDraggingToCrossOriginIFramesForTextSelection)(), (0, $gyEl7.disableDraggingToCrossOriginIFramesForExternal)());
    }, []);
    (0, $42A03.default)(typeof autoFocus === 'object' ? autoFocus : undefined, // When a user supplies  a ref to focus we enable this hook
    typeof autoFocus === 'object');
    const [motionRef, onMotionFinish] = (0, $cidB1.default)({
        onOpenComplete: onOpenComplete,
        onCloseComplete: onCloseComplete
    });
    const modalDialogContext = (0, $5uXOq.useMemo)(()=>({
            testId: testId,
            titleId: titleId,
            onClose: onClose,
            hasProvidedOnClose: hasProvidedOnClose
        }), [
        testId,
        titleId,
        onClose,
        hasProvidedOnClose
    ]);
    (0, $aLUgv.useCloseOnEscapePress)({
        onClose: onClose,
        isDisabled: !shouldCloseOnEscapePress
    });
    const { currentLevel: currentLevel } = (0, $aLUgv.useLayering)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lnVj3.default), {
        stackIndex: stackIndex,
        shouldScrollInViewport: shouldScrollInViewport,
        testId: testId,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kQNf9.ModalContext).Provider, {
            value: modalDialogContext,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kQNf9.ScrollContext).Provider, {
                value: shouldScrollInViewport,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $geBdj.default), {
                    entranceDirection: "bottom",
                    onFinish: onMotionFinish,
                    children: (bottomFadeInProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)("section", {
                            ...bottomFadeInProps,
                            "aria-label": label,
                            ref: (0, $cD7p8.default)([
                                bottomFadeInProps.ref,
                                motionRef
                            ]),
                            style: {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                                '--modal-dialog-width': (0, $4TeuE.dialogWidth)(width),
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                                '--modal-dialog-height': (0, $4TeuE.dialogHeight)(height)
                            },
                            className: (0, $bwpsq.default)([
                                $1f8209524c1b3a42$var$dialogStyles.root,
                                shouldScrollInViewport ? "_1tke1kxc _c71lglyw _8kn617ks" : "_cbiz17ks _bolh1kw7",
                                bottomFadeInProps.className
                            ]),
                            role: "dialog",
                            "aria-labelledby": label ? undefined : titleId,
                            "data-testid": testId,
                            "data-modal-stack": stackIndex,
                            tabIndex: -1,
                            "aria-modal": true,
                            "data-ds--level": currentLevel,
                            children: children
                        })
                })
            })
        })
    });
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $1f8209524c1b3a42$export$2e2bcd8739ae039 = $1f8209524c1b3a42$var$ModalDialog;

});
parcelRegister("cidB1", function(module, exports) {

$parcel$export(module.exports, "default", () => $74a6a09379b26813$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $74a6a09379b26813$export$2e2bcd8739ae039({ onOpenComplete: onOpenComplete, onCloseComplete: onCloseComplete }) {
    const motionRef = (0, $5uXOq.useRef)(null);
    const onMotionFinish = (0, $5uXOq.useCallback)((state)=>{
        if (state === 'entering' && onOpenComplete) onOpenComplete(motionRef.current, true);
        if (state === 'exiting' && onCloseComplete) onCloseComplete(motionRef.current);
    }, [
        onOpenComplete,
        onCloseComplete
    ]);
    return [
        motionRef,
        onMotionFinish
    ];
}

});

parcelRegister("du7S6", function(module, exports) {

$parcel$export(module.exports, "disableDraggingToCrossOriginIFramesForElement", () => $5d74234f7be682ce$export$ec28e97c7d8b1b35);

var $cBeZP = parcelRequire("cBeZP");

var $l5MhD = parcelRequire("l5MhD");

var $4nayr = parcelRequire("4nayr");

var $4WNVg = parcelRequire("4WNVg");
function $5d74234f7be682ce$var$watchForInteractionEnd({ stop: stop }) {
    let isDragging = false;
    function stopIfNotDragging() {
        if (isDragging) return;
        stop();
    }
    const unbindEvents = (0, $cBeZP.bindAll)(window, [
        {
            // Another interaction is starting, this fix should be removed.
            type: 'pointerdown',
            listener: stop
        },
        {
            // The user did not start a drag
            type: 'pointerup',
            listener: stopIfNotDragging
        },
        {
            // if a "dragstart" occurs and the flag is not set,
            // then a drag has not started.
            // Note: could not use "pointercancel" as it is not
            // published in Safari
            // → https://bugs.webkit.org/show_bug.cgi?id=222632
            type: 'dragstart',
            listener: stopIfNotDragging,
            // Need to come after the element adapter
            options: {
                capture: false
            }
        }
    ], {
        // Listening in the capture phase to increase resilience
        // against events being stopped.
        capture: true,
        // Being super clear these should only run once
        once: true
    });
    const unbindMonitor = (0, $4nayr.monitorForElements)({
        onGenerateDragPreview () {
            isDragging = true;
        },
        onDrop () {
            isDragging = false;
            stop();
        }
    });
    return (0, $l5MhD.combine)(unbindEvents, unbindMonitor);
}
function $5d74234f7be682ce$var$watchForInteractionStart({ start: start }) {
    return (0, $cBeZP.bind)(window, {
        // Note: Using "mousedown" rather than "pointerdown" due to a Safari bug.
        // Safari not publish a "pointerdown" on the interaction after a drag
        // → https://bugs.webkit.org/show_bug.cgi?id=279749
        type: 'mousedown',
        listener (event) {
            // Only starting if pressing down inside a draggable element
            // At this point, we are not sure which if:
            // 1. a text selection drag is starting
            // 2. a draggable managed by pdnd is going to be dragged
            // 3. a draggable not managed by pdnd is going to be dragged
            // 4. The user will be dragging anything at all (might be doing a click)
            if (event.target instanceof HTMLElement && event.target.closest('[draggable="true"]')) start();
        }
    });
}
const $5d74234f7be682ce$var$api = (0, $4WNVg.makeFixForAdapter)({
    watchForInteractionStart: $5d74234f7be682ce$var$watchForInteractionStart,
    watchForInteractionEnd: $5d74234f7be682ce$var$watchForInteractionEnd
});
function $5d74234f7be682ce$export$ec28e97c7d8b1b35() {
    return $5d74234f7be682ce$var$api.registerUsage();
}

});
parcelRegister("4WNVg", function(module, exports) {

$parcel$export(module.exports, "makeFixForAdapter", () => $8b9ecfc1259f94b7$export$a74bff2507e6126b);

var $l5MhD = parcelRequire("l5MhD");
/**
 * Set a `style` property on a `HTMLElement`
 *
 * @returns a `cleanup` function to restore the `style` property to it's original state
 */ function $8b9ecfc1259f94b7$var$setStyle(el, { property: property, rule: rule, priority: priority = '' }) {
    const originalValue = el.style.getPropertyValue(property);
    const originalPriority = el.style.getPropertyPriority(property);
    el.style.setProperty(property, rule, priority);
    return function cleanup() {
        el.style.setProperty(property, originalValue, originalPriority);
    };
}
function $8b9ecfc1259f94b7$var$hasSameOrigin(href1, href2) {
    let url1;
    let url2;
    try {
        url1 = new URL(href1);
        url2 = new URL(href2);
    } catch (error) {
        // failed to parse a href
        return false;
    }
    // https://developer.mozilla.org/en-US/docs/Web/Security/Same-origin_policy
    return url1.protocol === url2.protocol && url1.host === url2.host && url1.port === url2.port;
}
function $8b9ecfc1259f94b7$var$isIframeOnAnotherDomain(iframe) {
    /**
	 * iframe with contents defined inline. Runs on the current origin.
	 * `<iframe srcdoc="<!doctype html><body>Hello</body>" />`
	 */ if (iframe.srcdoc) return false;
    /**
	 * iframe with contents defined inline. Runs on the current origin.
	 * `<iframe src={`data:text/html;charset=utf-8,${encodeURI('<!doctype html><body>Hello</body>')}`} />`
	 */ if (iframe.src.startsWith('data:')) return false;
    return !$8b9ecfc1259f94b7$var$hasSameOrigin(window.location.href, iframe.src);
}
const $8b9ecfc1259f94b7$var$registry = new Map();
function $8b9ecfc1259f94b7$var$applyFix(watchForEndOfInteraction) {
    const iframes = Array.from(document.querySelectorAll('iframe')).filter($8b9ecfc1259f94b7$var$isIframeOnAnotherDomain);
    const cleanups = iframes.map((iframe)=>{
        let entry = $8b9ecfc1259f94b7$var$registry.get(iframe);
        if (!entry) {
            entry = {
                reset: $8b9ecfc1259f94b7$var$setStyle(iframe, {
                    property: 'pointer-events',
                    rule: 'none',
                    priority: 'important'
                }),
                count: 1
            };
            $8b9ecfc1259f94b7$var$registry.set(iframe, entry);
        } else // pointer-events:none already applied to the iframe
        // increment how many things requested the fix
        entry.count++;
        return function cleanup() {
            entry.count--;
            if (entry.count < 1) {
                entry.reset();
                $8b9ecfc1259f94b7$var$registry.delete(iframe);
            }
        };
    });
    function stop() {
        cleanupWatcher();
        (0, $l5MhD.combine)(...cleanups)();
    }
    const cleanupWatcher = watchForEndOfInteraction({
        stop: stop
    });
}
function $8b9ecfc1259f94b7$export$a74bff2507e6126b({ watchForInteractionStart: watchForInteractionStart, watchForInteractionEnd: watchForInteractionEnd }) {
    let registrationCount = 0;
    let stopWatchingInteractionStart = null;
    function start() {
        $8b9ecfc1259f94b7$var$applyFix(watchForInteractionEnd);
    }
    function registerUsage() {
        if (registrationCount === 0) stopWatchingInteractionStart = watchForInteractionStart({
            start: start
        });
        registrationCount++;
        return function unregisterUsage() {
            registrationCount--;
            if (registrationCount !== 0) return;
            stopWatchingInteractionStart?.();
            stopWatchingInteractionStart = null;
        };
    }
    return {
        registerUsage: registerUsage
    };
}

});


parcelRegister("gyEl7", function(module, exports) {

$parcel$export(module.exports, "disableDraggingToCrossOriginIFramesForExternal", () => $3508de49c33b7bd4$export$27d79116d3a4e7d5);

var $aSMdt = parcelRequire("aSMdt");

var $4WNVg = parcelRequire("4WNVg");
function $3508de49c33b7bd4$var$watchForInteractionStart({ start: start }) {
    return (0, $aSMdt.monitorForExternal)({
        onDragStart () {
            start();
        }
    });
}
function $3508de49c33b7bd4$var$watchForInteractionEnd({ stop: stop }) {
    return (0, $aSMdt.monitorForExternal)({
        onDrop () {
            stop();
        }
    });
}
const $3508de49c33b7bd4$var$api = (0, $4WNVg.makeFixForAdapter)({
    watchForInteractionStart: $3508de49c33b7bd4$var$watchForInteractionStart,
    watchForInteractionEnd: $3508de49c33b7bd4$var$watchForInteractionEnd
});
function $3508de49c33b7bd4$export$27d79116d3a4e7d5() {
    return $3508de49c33b7bd4$var$api.registerUsage();
}

});

parcelRegister("1QUpH", function(module, exports) {

$parcel$export(module.exports, "disableDraggingToCrossOriginIFramesForTextSelection", () => $827dd345b514582f$export$9c0606fcefb5d1e2);

var $cBeZP = parcelRequire("cBeZP");

var $l5MhD = parcelRequire("l5MhD");

var $8L8Lw = parcelRequire("8L8Lw");

var $4WNVg = parcelRequire("4WNVg");
function $827dd345b514582f$var$watchForInteractionEnd({ stop: stop }) {
    let isDragging = false;
    function stopIfNotDragging() {
        if (isDragging) return;
        stop();
    }
    let frameId = null;
    const unbindEvents = (0, $cBeZP.bindAll)(window, [
        {
            // User is starting another interaction
            type: 'pointerdown',
            listener: stop
        },
        {
            // User did not start a drag.
            // "pointerdown" won't be fired if a drag started
            type: 'pointerup',
            listener: stopIfNotDragging
        },
        {
            type: 'dragstart',
            listener () {
                /**
					 * The pdnd `onDragStart()` fires in the frame after "dragstart"
					 * So we are delaying our isDragging check to give a chance
					 * for `onDragStart()` to set the value correctly.
					 *
					 * Note: could not use "pointercancel" as it is not
					 * published in Safari → https://bugs.webkit.org/show_bug.cgi?id=222632
					 */ frameId = requestAnimationFrame(()=>{
                    frameId = null;
                    stopIfNotDragging();
                });
            },
            // need to schedule our frame after the text-selection
            // adapter queues it's `onDragStart` frame.
            options: {
                capture: false
            }
        }
    ], {
        // Listening in the capture phase to increase resilience
        // against events being stopped.
        capture: true,
        // being super clear these should only run once
        once: true
    });
    const unbindMonitor = (0, $8L8Lw.monitorForTextSelection)({
        onDragStart () {
            isDragging = true;
        },
        onDrop () {
            isDragging = false;
            stop();
        }
    });
    return (0, $l5MhD.combine)(unbindEvents, unbindMonitor, function abortFrame() {
        if (frameId != null) cancelAnimationFrame(frameId);
    });
}
function $827dd345b514582f$var$watchForInteractionStart({ start: start }) {
    return (0, $cBeZP.bind)(window, {
        // Note: Using "mousedown" rather than "pointerdown" due to a Safari bug.
        // Safari not publish a "pointerdown" on the interaction after a drag
        // → https://bugs.webkit.org/show_bug.cgi?id=279749
        type: 'mousedown',
        listener () {
            // A text selection drag will only start when there is
            // an active text selection.
            const selection = window.getSelection();
            // No selection object found
            if (!selection) return;
            // `isCollapsed` is "true" if there is currently no selected text
            if (selection.isCollapsed) return;
            start();
        }
    });
}
const $827dd345b514582f$var$api = (0, $4WNVg.makeFixForAdapter)({
    watchForInteractionStart: $827dd345b514582f$var$watchForInteractionStart,
    watchForInteractionEnd: $827dd345b514582f$var$watchForInteractionEnd
});
function $827dd345b514582f$export$9c0606fcefb5d1e2() {
    return $827dd345b514582f$var$api.registerUsage();
}

});

parcelRegister("4TeuE", function(module, exports) {

$parcel$export(module.exports, "dialogWidth", () => $2ec5b6e95ea23119$export$a3da89b899389ed8);
$parcel$export(module.exports, "dialogHeight", () => $2ec5b6e95ea23119$export$ceba93bf0bdd16f2);
const $2ec5b6e95ea23119$export$7e3df82ee760448c = {
    values: [
        'small',
        'medium',
        'large',
        'x-large'
    ],
    widths: {
        small: 400,
        medium: 600,
        large: 800,
        'x-large': 968
    },
    defaultValue: 'medium'
};
const $2ec5b6e95ea23119$export$a3da89b899389ed8 = (input)=>{
    if (!input) return 'auto';
    const isWidthName = $2ec5b6e95ea23119$export$7e3df82ee760448c.values.indexOf(input.toString()) !== -1;
    const widthName = isWidthName && input;
    if (widthName) return `${$2ec5b6e95ea23119$export$7e3df82ee760448c.widths[widthName]}px`;
    return typeof input === 'number' ? `${input}px` : input;
};
const $2ec5b6e95ea23119$export$ceba93bf0bdd16f2 = (input)=>{
    if (!input) return 'auto';
    return typeof input === 'number' ? `${input}px` : input;
};

});

parcelRegister("lnVj3", function(module, exports) {

$parcel$export(module.exports, "default", () => $718e107cbf9df933$export$2e2bcd8739ae039);
/* positioner.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");


var $471WD = parcelRequire("471WD");
const $718e107cbf9df933$var$gutter = 60;
const $718e107cbf9df933$var$maxWidthDimensions = `calc(100vw - ${$718e107cbf9df933$var$gutter * 2}px)`;
const $718e107cbf9df933$var$maxHeightDimensions = `calc(100vh - ${$718e107cbf9df933$var$gutter * 2 - 1}px)`;
// Flex and min-content are set to constrain the height of the body and support multi-column scrolling experiences
const $718e107cbf9df933$var$positionerStyles = null;
const $718e107cbf9df933$var$viewportScrollStyles = null;
const $718e107cbf9df933$var$bodyScrollStyles = null;
const $718e107cbf9df933$var$stackTransitionStyles = null;
const $718e107cbf9df933$var$stackTransformStyles = null;
const $718e107cbf9df933$var$stackIdleStyles = null;
const $718e107cbf9df933$var$Positioner = (props)=>{
    const { children: children, stackIndex: stackIndex, shouldScrollInViewport: shouldScrollInViewport, testId: testId } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        style: {
            '--modal-dialog-translate-y': `calc(${stackIndex}px * ${"var(--ds-space-100, 8px)"})`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            transitionDuration: `${(0, $471WD.durations).medium}ms`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            transitionTimingFunction: (0, $99bc8d2d71e909fb$export$c07234257a03d5e9)
        },
        "data-testid": testId && `${testId}--positioner`,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bsb1osq _p12f1osq _4t3i1osq _kqsw1n9t _1pby16oo _2lx21bp4 _152tidpf _1e02idpf",
            "_k8m01e03 _1bumglyw _sedtglyw",
            stackIndex > 0 ? "_t9ec1b95" : "_t9ecglyw",
            shouldScrollInViewport ? "_4t3i1wug _kqswh2mm _1sg41wqb _maxs1wug _1jvh1wqb _1uca1wug _eoawglyw" : "_we1i18uh _e8uozwhf _y1k5stnw _5ee41wqb _1urridpf _1juqidpf _yakv1wug _4lht1wug _eoawglyw"
        ]),
        children: children
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$718e107cbf9df933$export$2e2bcd8739ae039 = $718e107cbf9df933$var$Positioner;

});
const $99bc8d2d71e909fb$export$c07234257a03d5e9 = 'cubic-bezier(0.15,1,0.3,1)';
const $99bc8d2d71e909fb$export$57636bb43b1ccbb0 = 'cubic-bezier(0.2,0,0,1)';
const $99bc8d2d71e909fb$export$929e5a82286172a6 = 'cubic-bezier(0.8,0,0,0.8)';
const $99bc8d2d71e909fb$export$45db2fc2f15997e7 = 'cubic-bezier(0,0,1,1)';



parcelRegister("4PjUQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $a37b3122b870e771$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $bLDkX = parcelRequire("bLDkX");

var $jOvxk = parcelRequire("jOvxk");

var $f2URj = parcelRequire("f2URj");

var $7xhdA = parcelRequire("7xhdA");
/**
 *  ________________________________________________
 * | MAJOR VERSIONS WILL NOT KNOW ABOUT EACH OTHER! |
 *  ------------------------------------------------
 *
 * An array which holds references to all currently open modal dialogs.
 * This will only work for modal dialogs of the same major version,
 * as the reference will be different between them.
 *
 * E.g. V11 won't know about any from V12.
 */ const $a37b3122b870e771$var$modalStackRegister = [];
function $a37b3122b870e771$export$2e2bcd8739ae039({ onStackChange: onStackChange }) {
    const { isExiting: isExiting } = (0, $7xhdA.useExitingPersistence)();
    const [stackIndexRef, setStackIndex] = (0, $f2URj.default)(0);
    const currentStackIndex = stackIndexRef.current;
    const previousStackIndex = (0, $jOvxk.default)(stackIndexRef.current);
    // We want to ensure this function **never changes** during the lifecycle of this component.
    // This is why it's assigned to a ref and not in a useMemo/useCallback.
    const updateStack = (0, $bLDkX.default)(()=>{
        const newStackIndex = $a37b3122b870e771$var$modalStackRegister.indexOf(updateStack);
        // We access the stack index ref instead of state because this closure will always only
        // have the initial state and not any of the later values.
        if (stackIndexRef.current !== newStackIndex) {
            setStackIndex(newStackIndex);
            stackIndexRef.current = newStackIndex;
        }
    });
    (0, $5uXOq.useEffect)(()=>{
        const currentStackIndex = $a37b3122b870e771$var$modalStackRegister.indexOf(updateStack);
        if (!isExiting && currentStackIndex === -1) // We are opening the modal dialog.
        // Add ourselves to the modal stack register!
        $a37b3122b870e771$var$modalStackRegister.unshift(updateStack);
        if (isExiting && currentStackIndex !== -1) // We are closing the modal dialog using a wrapping modal transition component.
        // Remove ourselves from the modal stack register!
        // NOTE: Modal dialogs that don't have a wrapping modal transition component won't flow through here!
        // For that scenario we cleanup when the component unmounts.
        $a37b3122b870e771$var$modalStackRegister.splice(currentStackIndex, 1);
        // Fire all registered modal dialogs to update their position in the stack.
        $a37b3122b870e771$var$modalStackRegister.forEach((cb)=>cb());
    }, [
        updateStack,
        isExiting
    ]);
    (0, $5uXOq.useEffect)(()=>()=>{
            // Final cleanup just in case this modal dialog did not have a wrapping modal transition.
            const currentStackIndex = $a37b3122b870e771$var$modalStackRegister.indexOf(updateStack);
            if (currentStackIndex !== -1) {
                $a37b3122b870e771$var$modalStackRegister.splice(currentStackIndex, 1);
                $a37b3122b870e771$var$modalStackRegister.forEach((cb)=>cb());
            }
        }, [
        updateStack
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (previousStackIndex === undefined) // Initial case that we don't need to notify about.
        return;
        if (previousStackIndex !== currentStackIndex) onStackChange(currentStackIndex);
    }, [
        onStackChange,
        previousStackIndex,
        currentStackIndex
    ]);
    return currentStackIndex;
}

});
parcelRegister("jOvxk", function(module, exports) {

$parcel$export(module.exports, "default", () => $46cd62570e0cbd0a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $46cd62570e0cbd0a$export$2e2bcd8739ae039(value) {
    const ref = (0, $5uXOq.useRef)();
    (0, $5uXOq.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}

});

parcelRegister("f2URj", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c50e745de2c9351$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $1c50e745de2c9351$export$2e2bcd8739ae039(initialState) {
    const [value, setValue] = (0, $5uXOq.useState)(initialState);
    const valueRef = (0, $5uXOq.useRef)(value);
    valueRef.current = value;
    return [
        valueRef,
        setValue
    ];
}

});


parcelRegister("haWXj", function(module, exports) {

$parcel$export(module.exports, "default", () => $76e148cd41a6c57c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");
/**
 * Returns how far the body is scrolled from the top of the viewport.
 *
 *   ____
 * ||____|| <-- overflow
 *  |    |  <-- viewport
 *  |____|
 *
 * Scroll distance is the height of overflow outside the viewport.
 */ function $76e148cd41a6c57c$var$getScrollDistance() {
    return window.pageYOffset || document.documentElement?.scrollTop || document.body?.scrollTop || 0;
}
function $76e148cd41a6c57c$export$2e2bcd8739ae039() {
    const [scrollTopOffset, setScrollTopOffset] = (0, $5uXOq.useState)(0);
    (0, $5uXOq.useLayoutEffect)(()=>{
        setScrollTopOffset($76e148cd41a6c57c$var$getScrollDistance());
    }, []);
    const onWindowScroll = (0, $5uXOq.useCallback)(()=>{
        if ($76e148cd41a6c57c$var$getScrollDistance() !== scrollTopOffset) window.scrollTo(window.pageXOffset, scrollTopOffset);
    }, [
        scrollTopOffset
    ]);
    (0, $5uXOq.useEffect)(()=>{
        return (0, $cBeZP.bind)(window, {
            type: 'scroll',
            listener: onWindowScroll
        });
    }, [
        onWindowScroll
    ]);
    return scrollTopOffset;
}

});


parcelRegister("vCqQa", function(module, exports) {

$parcel$export(module.exports, "default", () => $17358c9836508465$export$2e2bcd8739ae039);
$parcel$export(module.exports, "Popup", () => (parcelRequire("iKTiG")).Popup);

var $iKTiG = parcelRequire("iKTiG");
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$17358c9836508465$export$2e2bcd8739ae039 = (0, $iKTiG.Popup);

});
parcelRegister("iKTiG", function(module, exports) {

$parcel$export(module.exports, "Popup", () => $cdf08cf3424fe318$export$129a32eedafa97c5);
/* popup.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $jJsBW = parcelRequire("jJsBW");

var $86D9T = parcelRequire("86D9T");

var $8Oct0 = parcelRequire("8Oct0");

var $fHpHg = parcelRequire("fHpHg");

var $7Ye64 = parcelRequire("7Ye64");
var $87gQG = parcelRequire("87gQG");

var $5g2iQ = parcelRequire("5g2iQ");

var $5sRpy = parcelRequire("5sRpy");

var $gS2FY = parcelRequire("gS2FY");

var $S4sWI = parcelRequire("S4sWI");

var $iuqDB = parcelRequire("iuqDB");

var $f66MG = parcelRequire("f66MG");
const $cdf08cf3424fe318$var$defaultLayer = 400;
const $cdf08cf3424fe318$var$wrapperStyles = {
    root: "_kqswh2mm"
};
const $cdf08cf3424fe318$export$129a32eedafa97c5 = /*#__PURE__*/ (0, $5uXOq.memo)(({ xcss: xcss, appearance: inAppearance = 'default', isOpen: isOpen, id: providedId, offset: offset, testId: testId, trigger: trigger, content: content, onClose: onClose, boundary: boundary, rootBoundary: rootBoundary = 'viewport', shouldFlip: shouldFlip = true, placement: placement = 'auto', fallbackPlacements: fallbackPlacements, popupComponent: PopupContainer, autoFocus: autoFocus = true, zIndex: zIndex = $cdf08cf3424fe318$var$defaultLayer, shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick = false, shouldRenderToParent: inShouldRenderToParent = false, shouldFitContainer: shouldFitContainer = false, shouldDisableFocusLock: shouldDisableFocusLock = false, shouldReturnFocus: shouldReturnFocus = true, strategy: strategy, role: role, label: label, titleId: titleId, modifiers: modifiers, shouldFitViewport: shouldFitViewport })=>{
    const [triggerRef, setTriggerRef] = (0, $5uXOq.useState)(null);
    const getMergedTriggerRef = (0, $iuqDB.useGetMemoizedMergedTriggerRef)();
    const getMergedTriggerRefNew = (0, $f66MG.useGetMemoizedMergedTriggerRefNew)();
    const generatedId = (0, $jJsBW.useId)();
    const { appearance: appearance, shouldRenderToParent: shouldRenderToParent } = (0, $S4sWI.usePopupAppearance)({
        appearance: inAppearance,
        shouldRenderToParent: inShouldRenderToParent
    });
    const id = providedId || generatedId;
    const handleOpenLayerObserverCloseSignal = (0, $5uXOq.useCallback)(()=>{
        onClose?.(null);
    }, [
        onClose
    ]);
    (0, $8Oct0.useNotifyOpenLayerObserver)({
        isOpen: isOpen,
        onClose: handleOpenLayerObserverCloseSignal
    });
    const renderPopperWrapper = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $86D9T.Layering), {
        isDisabled: false,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gS2FY.default), {
            xcss: xcss,
            appearance: appearance,
            content: content,
            isOpen: isOpen,
            placement: placement,
            fallbackPlacements: fallbackPlacements,
            boundary: boundary,
            rootBoundary: rootBoundary,
            shouldFlip: shouldFlip,
            offset: offset,
            popupComponent: PopupContainer,
            id: id,
            testId: testId,
            onClose: onClose,
            autoFocus: autoFocus,
            shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
            shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
            shouldFitContainer: shouldFitContainer,
            shouldDisableFocusLock: shouldDisableFocusLock,
            shouldReturnFocus: shouldReturnFocus,
            triggerRef: triggerRef,
            strategy: shouldFitContainer ? 'absolute' : strategy,
            role: role,
            label: label,
            titleId: titleId,
            modifiers: modifiers,
            shouldFitViewport: shouldFitViewport
        })
    });
    const popupContent = /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $7Ye64.Manager), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $87gQG.Reference), {
                children: ({ ref: ref })=>{
                    return trigger({
                        ref: !(0, $fHpHg.fg)('platform-design-system-popup-ref') ? getMergedTriggerRef(ref, setTriggerRef, isOpen) : getMergedTriggerRefNew(ref, setTriggerRef),
                        'aria-controls': isOpen ? id : undefined,
                        'aria-expanded': isOpen,
                        'aria-haspopup': role === 'dialog' && (0, $fHpHg.fg)('platform_dst_popup-disable-focuslock') ? 'dialog' : true
                    });
                }
            }),
            isOpen && (shouldRenderToParent || shouldFitContainer ? renderPopperWrapper : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5g2iQ.default), {
                zIndex: zIndex,
                children: renderPopperWrapper
            }))
        ]
    });
    if (shouldFitContainer) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        xcss: $cdf08cf3424fe318$var$wrapperStyles.root,
        children: popupContent
    });
    return popupContent;
});

});
parcelRegister("gS2FY", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab38b858e8ef6176$export$2e2bcd8739ae039);
/* popper-wrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $aLUgv = parcelRequire("aLUgv");

var $fHpHg = parcelRequire("fHpHg");

var $e5neF = parcelRequire("e5neF");

var $aLf11 = parcelRequire("aLf11");

var $3aBV4 = parcelRequire("3aBV4");

var $5ufrr = parcelRequire("5ufrr");
const $ab38b858e8ef6176$var$LOCAL_CURRENT_SURFACE_CSS_VAR = '--ds-elevation-surface-current';
const $ab38b858e8ef6176$var$fullWidthStyles = null;
const $ab38b858e8ef6176$var$wrapperStyles = {
    root: "_2rkoglpi _1e0c1ule _vchhusvi _1pby1nn1 _bfhk1bhr _16qs1cd0 _syaz1fxt _1q1l1bhr _nt751r31 _49pcglyw _1hvw1o36"
};
const $ab38b858e8ef6176$var$scrollableStyles = null;
const $ab38b858e8ef6176$var$blanketStyles = null;
const $ab38b858e8ef6176$var$modalStyles = null;
const $ab38b858e8ef6176$var$focusRingStyles = {
    root: "_mizu194a _1ah31bk5 _ra3xnqa1 _128m1bk5 _1cvmnqa1 _4davt94y"
};
const $ab38b858e8ef6176$var$DefaultPopupComponent = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { shouldRenderToParent: shouldRenderToParent, shouldFitContainer: shouldFitContainer, children: children, appearance: appearance, className: className, ...htmlAttributes } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: (0, $bwpsq.default)([
            $ab38b858e8ef6176$var$wrapperStyles.root,
            appearance === 'UNSAFE_modal-below-sm' && "_dk5d1b66 _c71ldtre _kqsw1n9t _152t1b66",
            !shouldRenderToParent && "_1reo1wug _18m91wug",
            shouldFitContainer && "_1bsb1osq",
            className
        ]),
        ...htmlAttributes,
        ref: ref,
        children: children
    });
});
function $ab38b858e8ef6176$var$PopperWrapper({ xcss: xcss, isOpen: isOpen, id: id, offset: offset, testId: testId, content: content, fallbackPlacements: fallbackPlacements, onClose: onClose, boundary: boundary, rootBoundary: rootBoundary, shouldFlip: shouldFlip, placement: placement = 'auto', // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
popupComponent: PopupContainer = $ab38b858e8ef6176$var$DefaultPopupComponent, autoFocus: autoFocus = true, triggerRef: triggerRef, shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick, shouldRenderToParent: shouldRenderToParent, shouldFitContainer: shouldFitContainer, shouldDisableFocusLock: shouldDisableFocusLock, shouldReturnFocus: shouldReturnFocus = true, strategy: strategy, role: role, label: label, titleId: titleId, modifiers: modifiers, shouldFitViewport: shouldFitViewport, appearance: appearance = 'default' }) {
    const [popupRef, setPopupRef] = (0, $5uXOq.useState)(null);
    const [initialFocusRef, setInitialFocusRef] = (0, $5uXOq.useState)(null); // We have cases where we need to close the Popup on Tab press, e.g. DropdownMenu
    const shouldCloseOnTab = shouldRenderToParent && shouldDisableFocusLock;
    const shouldDisableFocusTrap = role !== 'dialog';
    (0, $5ufrr.useFocusManager)({
        initialFocusRef: initialFocusRef,
        popupRef: popupRef,
        shouldCloseOnTab: shouldCloseOnTab,
        triggerRef: triggerRef,
        autoFocus: autoFocus,
        shouldDisableFocusTrap: shouldDisableFocusTrap,
        shouldReturnFocus: shouldReturnFocus
    });
    (0, $3aBV4.useCloseManager)({
        isOpen: isOpen,
        onClose: onClose,
        popupRef: popupRef,
        triggerRef: triggerRef,
        shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
        shouldCloseOnTab: shouldCloseOnTab,
        autoFocus: autoFocus,
        shouldDisableFocusTrap: shouldDisableFocusTrap,
        shouldRenderToParent: shouldRenderToParent
    });
    const { currentLevel: currentLevel } = (0, $aLUgv.useLayering)();
    const mergedModifiers = (0, $5uXOq.useMemo)(()=>[
            {
                name: 'flip',
                enabled: shouldFlip,
                options: {
                    rootBoundary: rootBoundary,
                    boundary: boundary,
                    fallbackPlacements: fallbackPlacements
                }
            },
            ...modifiers || []
        ], [
        shouldFlip,
        rootBoundary,
        boundary,
        fallbackPlacements,
        modifiers
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $e5neF.Popper), {
        placement: placement,
        offset: offset,
        modifiers: mergedModifiers,
        strategy: strategy,
        shouldFitViewport: shouldFitViewport,
        children: ({ ref: ref, style: style, placement: placement, update: update })=>{
            const popupContainer = /*#__PURE__*/ (0, $2OMIu.jsx)(PopupContainer // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            , {
                className: (0, $bwpsq.default)([
                    xcss,
                    // @ts-expect-error: `ax` is not typed correctly
                    !initialFocusRef && // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
                    (0, $fHpHg.fg)('platform-design-system-apply-popup-wrapper-focus') && $ab38b858e8ef6176$var$focusRingStyles.root
                ]),
                appearance: appearance,
                id: id,
                "data-ds--level": currentLevel,
                "data-placement": placement,
                "data-testid": testId,
                role: role,
                "aria-label": label,
                "aria-labelledby": titleId,
                ref: (node)=>{
                    if (node) {
                        if (typeof ref === 'function') ref(node);
                        else ref.current = node;
                        setPopupRef(node);
                    }
                },
                style: appearance === 'UNSAFE_modal-below-sm' ? {} : style,
                // first on the browser address bar when using keyboard
                tabIndex: autoFocus ? 0 : undefined,
                shouldRenderToParent: shouldRenderToParent,
                shouldFitContainer: shouldFitContainer,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $aLf11.RepositionOnUpdate), {
                    update: update,
                    children: content({
                        update: update,
                        isOpen: isOpen,
                        onClose: onClose,
                        setInitialFocusRef: setInitialFocusRef
                    })
                })
            });
            return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
                children: [
                    popupContainer,
                    appearance === 'UNSAFE_modal-below-sm' && /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        className: (0, $bwpsq.default)([
                            "_1r04idpf _kqsw1n9t _bfhk10xm"
                        ])
                    })
                ]
            });
        }
    });
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$ab38b858e8ef6176$export$2e2bcd8739ae039 = $ab38b858e8ef6176$var$PopperWrapper;

});
parcelRegister("aLf11", function(module, exports) {

$parcel$export(module.exports, "RepositionOnUpdate", () => $d1a87f1de5cde89c$export$51eddd7655ca235a);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
const $d1a87f1de5cde89c$export$51eddd7655ca235a = ({ children: children, update: update })=>{
    // Ref used here to skip update on first render (when refs haven't been set)
    const isFirstRenderRef = (0, $5uXOq.useRef)(true);
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (isFirstRenderRef.current) {
            isFirstRenderRef.current = false;
            return;
        }
        // callback function from popper that repositions pop-up on content Update
        update();
    }, [
        update
    ]);
    // wrapping in fragment to make TS happy (known issue with FC returning children)
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Fragment), {
        children: children
    });
};

});

parcelRegister("3aBV4", function(module, exports) {

$parcel$export(module.exports, "useCloseManager", () => $f00daa8c6a511e78$export$92dae2778ae88f9d);

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");

var $bKnKN = parcelRequire("bKnKN");

var $aLUgv = parcelRequire("aLUgv");

var $fHpHg = parcelRequire("fHpHg");

var $9hgq5 = parcelRequire("9hgq5");

var $lHyiy = parcelRequire("lHyiy");
const $f00daa8c6a511e78$export$92dae2778ae88f9d = ({ isOpen: isOpen, onClose: onClose, popupRef: popupRef, triggerRef: triggerRef, autoFocus: autoFocus, shouldDisableFocusTrap: shouldDisableFocusTrap, shouldUseCaptureOnOutsideClick: capture, shouldCloseOnTab: shouldCloseOnTab, shouldRenderToParent: shouldRenderToParent })=>{
    const { isLayerDisabled: isLayerDisabled, currentLevel: currentLevel } = (0, $aLUgv.useLayering)();
    const { requestFrame: requestFrame, cancelAllFrames: cancelAllFrames } = (0, $lHyiy.useAnimationFrame)();
    (0, $5uXOq.useEffect)(()=>{
        if (!isOpen || !popupRef) return 0, $bKnKN.default;
        const inIframe = window && window.self !== window.top && (0, $fHpHg.fg)('fix-dropdown-close-outside-iframe');
        const closePopup = (event)=>{
            if (onClose) {
                if ((0, $fHpHg.fg)('sibling-dropdown-close-issue')) {
                    let currentLevel = null;
                    if (event.target instanceof HTMLElement) currentLevel = event.target.closest(`[data-ds--level]`)?.getAttribute('data-ds--level');
                    currentLevel ? onClose(event, Number(currentLevel)) : onClose(event);
                } else onClose(event);
            }
            if (shouldDisableFocusTrap && (0, $fHpHg.fg)('platform_dst_popup-disable-focuslock')) // Restoring the normal focus order for trigger.
            requestFrame(()=>{
                triggerRef?.setAttribute('tabindex', '0');
                if (popupRef && autoFocus) popupRef.setAttribute('tabindex', '0');
            });
        };
        // This check is required for cases where components like
        // Select or DDM are placed inside a Popup. A click
        // on a MenuItem or Option would close the Popup, without registering
        // a click on DDM/Select.
        // Users would have to call `onClose` manually to close the Popup in these cases.
        // You can see the bug in action here:
        // https://codesandbox.io/s/atlaskitpopup-default-forked-2eb87?file=/example.tsx:0-1788
        const onClick = (event)=>{
            const { target: target } = event;
            const doesDomNodeExist = document.body.contains(target);
            if (!doesDomNodeExist && !inIframe) return;
            if (isLayerDisabled()) {
                if ((0, $fHpHg.fg)('design-system-closed-all-when-click-outside')) {
                    if (target instanceof HTMLElement) {
                        const layeredElement = target.closest?.(`[data-ds--level]`);
                        if (layeredElement) {
                            const closeType = layeredElement.getAttribute('[data-ds--close--type]');
                            if (closeType === 'single') // if the close type is single, we won't close other disabled layers when clicking outside
                            return;
                            const levelOfClickedLayer = layeredElement.getAttribute('data-ds--level');
                            if (levelOfClickedLayer && Number(levelOfClickedLayer) > currentLevel) // won't trigger onClick event when we click in a higher layer.
                            return;
                        }
                    }
                } else return;
            }
            const isClickOnPopup = popupRef && popupRef.contains(target);
            const isClickOnTrigger = triggerRef && triggerRef.contains(target);
            if (!isClickOnPopup && !isClickOnTrigger) {
                closePopup(event);
                // If there was an outside click on a non-interactive element, the focus should be on the trigger.
                if (document.activeElement && !(0, $9hgq5.isInteractiveElement)(document.activeElement) && (0, $fHpHg.fg)('platform_dst_popup-disable-focuslock')) triggerRef?.focus();
            }
        };
        const onKeyDown = (event)=>{
            if ((0, $fHpHg.fg)('platform_dst_popup-disable-focuslock')) {
                const { key: key, shiftKey: shiftKey } = event;
                if (shiftKey && key === 'Tab' && !shouldRenderToParent) {
                    if (isLayerDisabled()) return;
                    // We need to move the focus to the popup trigger when the popup is displayed in React.Portal.
                    requestFrame(()=>{
                        const isPopupFocusOut = popupRef && !popupRef.contains(document.activeElement);
                        if (isPopupFocusOut) {
                            closePopup(event);
                            if (currentLevel === 1) triggerRef?.focus();
                        }
                    });
                    return;
                }
                if (key === 'Tab') {
                    // We have cases where we need to close the Popup on Tab press.
                    // Example: DropdownMenu
                    if (shouldCloseOnTab) {
                        if (isLayerDisabled()) return;
                        closePopup(event);
                        return;
                    }
                    if (isLayerDisabled() && document.activeElement?.closest('[aria-modal]')) return;
                    if (shouldDisableFocusTrap) {
                        if (shouldRenderToParent) // We need to move the focus to the previous interactive element before popup trigger
                        requestFrame(()=>{
                            const isPopupFocusOut = popupRef && !popupRef.contains(document.activeElement);
                            if (isPopupFocusOut) closePopup(event);
                        });
                        else requestFrame(()=>{
                            if (!document.hasFocus()) closePopup(event);
                        });
                        return;
                    }
                }
                if (isLayerDisabled()) return;
                if (key === 'Escape' || key === 'Esc') {
                    if (triggerRef && autoFocus) triggerRef.focus();
                    closePopup(event);
                }
            } else {
                if (isLayerDisabled()) return;
                const { key: key } = event;
                if (key === 'Escape' || key === 'Esc' || shouldCloseOnTab && key === 'Tab') closePopup(event);
            }
        };
        let parentUnbind;
        // if the popup is inside iframe, we want to listen to click events outside iframe,
        // to close the popup correctly in the iframe.
        if (inIframe && isOpen) parentUnbind = (0, $cBeZP.bind)(window.parent.window, {
            type: 'click',
            listener: onClick,
            options: {
                capture: capture
            }
        });
        let unbind = (0, $bKnKN.default);
        if ((0, $fHpHg.fg)('popup-onclose-fix')) setTimeout(()=>{
            unbind = (0, $cBeZP.bindAll)(window, [
                {
                    type: 'click',
                    listener: onClick,
                    options: {
                        capture: capture
                    }
                },
                {
                    type: 'keydown',
                    listener: onKeyDown
                }
            ]);
        }, 0);
        else unbind = (0, $cBeZP.bindAll)(window, [
            {
                type: 'click',
                listener: onClick,
                options: {
                    capture: capture
                }
            },
            {
                type: 'keydown',
                listener: onKeyDown
            }
        ]);
        // bind onBlur event listener to fix popup not close when clicking on iframe outside
        let unbindBlur = (0, $bKnKN.default);
        unbindBlur = (0, $cBeZP.bind)(window, {
            type: 'blur',
            listener: function onBlur(e) {
                if (isLayerDisabled() || !(document.activeElement instanceof HTMLIFrameElement)) return;
                closePopup(e);
            }
        });
        return ()=>{
            if ((0, $fHpHg.fg)('popup-onclose-fix')) setTimeout(()=>{
                unbind();
            }, 0);
            else unbind();
            cancelAllFrames();
            parentUnbind?.();
            unbindBlur();
        };
    }, [
        isOpen,
        onClose,
        popupRef,
        triggerRef,
        autoFocus,
        shouldDisableFocusTrap,
        capture,
        isLayerDisabled,
        shouldCloseOnTab,
        currentLevel,
        shouldRenderToParent,
        requestFrame,
        cancelAllFrames
    ]);
};

});
parcelRegister("9hgq5", function(module, exports) {

$parcel$export(module.exports, "isInteractiveElement", () => $f8ec3a5487fb3c1a$export$3dee5e4542c672d9);
const $f8ec3a5487fb3c1a$var$interactiveTags = [
    'button',
    'a',
    'input',
    'select',
    'textarea'
];
const $f8ec3a5487fb3c1a$export$3dee5e4542c672d9 = (element)=>{
    if ($f8ec3a5487fb3c1a$var$interactiveTags.includes(element.tagName.toLowerCase())) return true;
    if (element.getAttribute('tabindex') !== null || element.hasAttribute('contenteditable')) return true;
    return false;
};

});

parcelRegister("lHyiy", function(module, exports) {

$parcel$export(module.exports, "useAnimationFrame", () => $02da776f76bfa94a$export$641fa9c94086b46e);

var $5uXOq = parcelRequire("5uXOq");
const $02da776f76bfa94a$export$641fa9c94086b46e = ()=>{
    const animationsRef = (0, $5uXOq.useRef)([]);
    const requestFrame = (0, $5uXOq.useCallback)((callback)=>{
        const id = requestAnimationFrame(callback);
        animationsRef.current.push(id);
        return id;
    }, []);
    const cancelFrame = (0, $5uXOq.useCallback)((id)=>{
        cancelAnimationFrame(id);
        animationsRef.current = animationsRef.current.filter((frameId)=>frameId !== id);
    }, []);
    const cancelAllFrames = (0, $5uXOq.useCallback)(()=>{
        animationsRef.current.forEach((id)=>cancelAnimationFrame(id));
        animationsRef.current = [];
    }, []);
    return {
        requestFrame: requestFrame,
        cancelFrame: cancelFrame,
        cancelAllFrames: cancelAllFrames
    };
};

});


parcelRegister("5ufrr", function(module, exports) {

$parcel$export(module.exports, "useFocusManager", () => $fa925f557cf31901$export$10c5169755ce7bd7);

var $5uXOq = parcelRequire("5uXOq");

var $fGOj2 = parcelRequire("fGOj2");

var $bKnKN = parcelRequire("bKnKN");

var $aLUgv = parcelRequire("aLUgv");

var $fHpHg = parcelRequire("fHpHg");

var $lHyiy = parcelRequire("lHyiy");
const $fa925f557cf31901$export$10c5169755ce7bd7 = ({ initialFocusRef: initialFocusRef, popupRef: popupRef, triggerRef: triggerRef, autoFocus: autoFocus, shouldCloseOnTab: shouldCloseOnTab, shouldDisableFocusTrap: shouldDisableFocusTrap, shouldReturnFocus: shouldReturnFocus, shouldRenderToParent: shouldRenderToParent })=>{
    const { requestFrame: requestFrame, cancelAllFrames: cancelAllFrames } = (0, $lHyiy.useAnimationFrame)();
    const { currentLevel: currentLevel } = (0, $aLUgv.useLayering)();
    (0, $5uXOq.useEffect)(()=>{
        if (!popupRef || shouldCloseOnTab) return 0, $bKnKN.default;
        if (shouldDisableFocusTrap && (0, $fHpHg.fg)('platform_dst_popup-disable-focuslock')) {
            const isDropdown = popupRef.matches('[id^=ds--dropdown--]');
            const popups = document.querySelectorAll(`[data-ds--level="${currentLevel - 1}"]`);
            if (!(popups[popups.length - 1] && !shouldRenderToParent && isDropdown)) {
                // Plucking trigger & popup content container from the tab order so that
                // when we Shift+Tab, the focus moves to the element before trigger
                requestFrame(()=>{
                    triggerRef?.setAttribute('tabindex', '-1');
                    if (popupRef && autoFocus) popupRef.setAttribute('tabindex', '-1');
                    (initialFocusRef || popupRef).focus();
                });
                return 0, $bKnKN.default;
            }
        }
        const trapConfig = {
            clickOutsideDeactivates: true,
            escapeDeactivates: true,
            initialFocus: initialFocusRef || popupRef,
            fallbackFocus: popupRef,
            returnFocusOnDeactivate: shouldReturnFocus
        };
        const focusTrap = (0, (/*@__PURE__*/$parcel$interopDefault($fGOj2)))(popupRef, trapConfig);
        // Wait for the popup to reposition itself before we focus
        requestFrame(()=>{
            focusTrap.activate();
        });
        return ()=>{
            cancelAllFrames();
            focusTrap.deactivate();
        };
    }, [
        popupRef,
        triggerRef,
        autoFocus,
        initialFocusRef,
        shouldCloseOnTab,
        shouldDisableFocusTrap,
        requestFrame,
        cancelAllFrames,
        shouldReturnFocus,
        shouldRenderToParent,
        currentLevel
    ]);
};

});


parcelRegister("S4sWI", function(module, exports) {

$parcel$export(module.exports, "usePopupAppearance", () => $64ad53c31b419831$export$4065aef1d79a5730);

var $5uXOq = parcelRequire("5uXOq");

var $cNgF9 = parcelRequire("cNgF9");
function $64ad53c31b419831$export$4065aef1d79a5730({ appearance: _appearance, shouldRenderToParent: _shouldRenderToParent }) {
    const mq = (0, $cNgF9.UNSAFE_useMediaQuery)('below.sm', (e)=>{
        setIsSmallViewport(!!e.matches);
    });
    const [isSmallViewport, setIsSmallViewport] = (0, $5uXOq.useState)(!!mq?.matches);
    const appearance = _appearance === 'UNSAFE_modal-below-sm' && isSmallViewport ? 'UNSAFE_modal-below-sm' : 'default';
    const shouldRenderToParent = _shouldRenderToParent && appearance === 'default';
    return {
        appearance: appearance,
        shouldRenderToParent: shouldRenderToParent
    };
}

});
parcelRegister("cNgF9", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_useMediaQuery", () => $dbd99c0374b7bbcd$export$49e55ae2c03d6045);

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");

var $lk9aV = parcelRequire("lk9aV");
const $dbd99c0374b7bbcd$var$queries = {
    'above.xxs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $lk9aV.media).above.xxs.replace('@media ', '').trim()),
    'above.xs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $lk9aV.media).above.xs.replace('@media ', '').trim()),
    'above.sm': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $lk9aV.media).above.sm.replace('@media ', '').trim()),
    'above.md': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $lk9aV.media).above.md.replace('@media ', '').trim()),
    'above.lg': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $lk9aV.media).above.lg.replace('@media ', '').trim()),
    'above.xl': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $lk9aV.media).above.xl.replace('@media ', '').trim()),
    'below.xs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $lk9aV.media).below.xs.replace('@media ', '').trim()),
    'below.sm': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $lk9aV.media).below.sm.replace('@media ', '').trim()),
    'below.md': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $lk9aV.media).below.md.replace('@media ', '').trim()),
    'below.lg': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $lk9aV.media).below.lg.replace('@media ', '').trim()),
    'below.xl': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $lk9aV.media).below.xl.replace('@media ', '').trim())
};
const $dbd99c0374b7bbcd$export$49e55ae2c03d6045 = (queryString, listener)=>{
    const listenerRef = (0, $5uXOq.useRef)(listener);
    (0, $5uXOq.useEffect)(()=>{
        // Bind the listener if changed so it's called on the next change event; no guarantee on timing.
        listenerRef.current = listener;
    }, [
        listener
    ]);
    /**
	 * We explicitly only react to boolean changes for binding our listener
	 * Changes to the functional reference are ignored.
	 */ const hasListener = !!listener;
    /**
	 * The `matchMedia(…)` return value for our breakpoint query.
	 */ const mq = $dbd99c0374b7bbcd$var$queries[queryString];
    (0, $5uXOq.useLayoutEffect)(()=>{
        listenerRef.current = listener; // Bind the listener now in case the `useEffect` hasn't fired above yet
        if (!mq || !hasListener || !listenerRef.current) return;
        return (0, $cBeZP.bind)(mq, {
            type: 'change',
            listener: (event)=>{
                // We explicitly call the current version of the function
                return listenerRef.current(event);
            }
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- explicitly do not trigger the effect on `listener` reference change, only on a boolean representation of it.
    [
        mq,
        hasListener
    ]);
    return mq || null;
};

});
parcelRegister("lk9aV", function(module, exports) {

$parcel$export(module.exports, "media", () => $2fe55fd277ca65bc$export$987d49ffe1b0900f);
/**
 * This is an object of usable media query helpers using our internal breakpoints configuration.
 *
 * When using Compiled CSS-in-JS, please ensure that only a single declaration can take effect at a time.
 * This means that you should avoid multiple breakpoints taking effect at the same time,
 * eg. ```{ [media.above.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * Instead, make sure that only one breakpoint can take effect at a time,
 * e.g, ```{ [media.only.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * For more details, please see <https://compiledcssinjs.com/docs/atomic-css#selector-specificity>.
 */ const $2fe55fd277ca65bc$export$987d49ffe1b0900f = {
    above: {
        // TODO: Should this even exist, we don't want `css({ [media.above.xxs]: { … } })` because that just adds duplicates styles!
        xxs: '@media all',
        xs: '@media (min-width: 30rem)',
        sm: '@media (min-width: 48rem)',
        md: '@media (min-width: 64rem)',
        lg: '@media (min-width: 90rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    only: {
        xxs: '@media (min-width: 0rem) and (max-width: 29.99rem)',
        xs: '@media (min-width: 30rem) and (max-width: 47.99rem)',
        sm: '@media (min-width: 48rem) and (max-width: 63.99rem)',
        md: '@media (min-width: 64rem) and (max-width: 89.99rem)',
        lg: '@media (min-width: 90rem) and (max-width: 110.49rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    below: {
        xs: '@media not all and (min-width: 30rem)',
        sm: '@media not all and (min-width: 48rem)',
        md: '@media not all and (min-width: 64rem)',
        lg: '@media not all and (min-width: 90rem)',
        xl: '@media not all and (min-width: 110.5rem)'
    }
};

});



parcelRegister("iuqDB", function(module, exports) {

$parcel$export(module.exports, "useGetMemoizedMergedTriggerRef", () => $b580f98728b9873b$export$7cc5c058dd769dff);

var $5uXOq = parcelRequire("5uXOq");

var $8QpSo = parcelRequire("8QpSo");
const $b580f98728b9873b$export$7cc5c058dd769dff = ()=>{
    const [getMemoizedMergedTriggerRef] = (0, $5uXOq.useState)(()=>(0, $8QpSo.default)((ref, setTriggerRef, isOpen)=>{
            return (node)=>{
                if (node && isOpen) {
                    if (typeof ref === 'function') ref(node);
                    else if (ref) ref.current = node;
                    setTriggerRef(node);
                }
            };
        }));
    return getMemoizedMergedTriggerRef;
};

});

parcelRegister("f66MG", function(module, exports) {

$parcel$export(module.exports, "useGetMemoizedMergedTriggerRefNew", () => $e1a3249a33be29bc$export$5d3a2de79e07b376);

var $5uXOq = parcelRequire("5uXOq");

var $8QpSo = parcelRequire("8QpSo");
const $e1a3249a33be29bc$export$5d3a2de79e07b376 = ()=>{
    const [getMemoizedMergedTriggerRefNew] = (0, $5uXOq.useState)(()=>(0, $8QpSo.default)((ref, setTriggerRef)=>{
            return (node)=>{
                if (node) {
                    if (typeof ref === 'function') ref(node);
                    else if (ref) ref.current = node;
                    setTriggerRef(node);
                }
            };
        }));
    return getMemoizedMergedTriggerRefNew;
};

});



parcelRegister("bkS4F", function(module, exports) {

$parcel$export(module.exports, "default", () => $06affb39fcad8302$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bCNIx = parcelRequire("bCNIx");

var $inni2 = parcelRequire("inni2");
/**
 * __Spotlight__
 *
 * An onboarding spotlight introduces new features to users through focused messages or multi-step tours.
 *
 * - [Examples](https://atlassian.design/components/onboarding/examples)
 * - [Code](https://atlassian.design/components/onboarding/code)
 * - [Usage](https://atlassian.design/components/onboarding/usage)
 */ const $06affb39fcad8302$var$Spotlight = ({ actions: actions, actionsBeforeElement: actionsBeforeElement, children: children, dialogPlacement: dialogPlacement, dialogWidth: dialogWidth = 400, footer: footer, header: header, heading: heading, headingAfterElement: headingAfterElement, image: image, label: label, pulse: pulse = true, scrollPositionBlock: scrollPositionBlock, shouldWatchTarget: shouldWatchTarget = false, target: target, targetBgColor: targetBgColor, targetNode: targetNode, targetOnClick: targetOnClick, targetRadius: targetRadius, targetReplacement: targetReplacement, testId: testId = 'spotlight', titleId: titleId, ...rest })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $inni2.SpotlightConsumer), {
        children: ({ opened: opened, closed: closed, targets: targets })=>{
            // use the targetNode prop or try get the target from context targets using name
            const actualTargetNode = targetNode || (typeof target === 'string' ? targets[target] : undefined);
            return actualTargetNode ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bCNIx.default), {
                ...rest,
                actions: actions,
                actionsBeforeElement: actionsBeforeElement,
                children: children,
                dialogPlacement: dialogPlacement,
                dialogWidth: dialogWidth,
                footer: footer,
                header: header,
                heading: heading,
                headingAfterElement: headingAfterElement,
                image: image,
                label: label,
                onClosed: closed,
                onOpened: opened,
                pulse: pulse,
                scrollPositionBlock: scrollPositionBlock,
                shouldWatchTarget: shouldWatchTarget,
                target: target,
                targetBgColor: targetBgColor,
                targetNode: actualTargetNode,
                targetOnClick: targetOnClick,
                targetRadius: targetRadius,
                targetReplacement: targetReplacement,
                testId: testId,
                titleId: titleId
            }) : null;
        }
    });
var $06affb39fcad8302$export$2e2bcd8739ae039 = $06affb39fcad8302$var$Spotlight;

});
parcelRegister("bCNIx", function(module, exports) {

$parcel$export(module.exports, "default", () => $34a27059dd74103d$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $lv4Ny = parcelRequire("lv4Ny");

var $2alJM = parcelRequire("2alJM");

var $k9tnV = parcelRequire("k9tnV");

var $86D9T = parcelRequire("86D9T");

var $fHpHg = parcelRequire("fHpHg");

var $5g2iQ = parcelRequire("5g2iQ");

var $bR0Xj = parcelRequire("bR0Xj");

var $lNmQ7 = parcelRequire("lNmQ7");

var $chKky = parcelRequire("chKky");

var $jxb8w = parcelRequire("jxb8w");

var $bcSCo = parcelRequire("bcSCo");

var $98UVV = parcelRequire("98UVV");
/**
 * __Spotlight inner__
 *
 * Renders the spotlight target clone and dialog.
 *
 * @internal
 */ class $34a27059dd74103d$var$SpotlightInner extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    static{
        this.defaultProps = {
            dialogWidth: 400,
            pulse: true
        };
    }
    componentDidUpdate(prevProps) {
        if (prevProps.targetNode !== this.props.targetNode) (0, $k9tnV.default)(this.props.targetNode, {
            scrollMode: 'if-needed',
            block: this.props.scrollPositionBlock
        });
    }
    componentDidMount() {
        (0, $k9tnV.default)(this.props.targetNode, {
            scrollMode: 'if-needed',
            block: this.props.scrollPositionBlock
        });
        this.props.onOpened();
    }
    componentWillUnmount() {
        this.props.onClosed();
    }
    render() {
        const { pulse: pulse, shouldWatchTarget: shouldWatchTarget, target: target, targetNode: targetNode, targetBgColor: targetBgColor, targetOnClick: targetOnClick, targetRadius: targetRadius, testId: testId, targetReplacement: TargetReplacement } = this.props;
        const { replacementElement: replacementElement } = this.state;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $98UVV.SpotlightTransitionConsumer), {
            children: ({ isOpen: isOpen, onExited: onExited })=>/*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5g2iQ.default), {
                    zIndex: 701,
                    children: [
                        TargetReplacement ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jxb8w.default), {
                            hasNodeResolver: !(0, $fHpHg.fg)('platform_design_system_team_onboarding_noderesolve'),
                            innerRef: (elem)=>this.setState({
                                    replacementElement: elem
                                }),
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bR0Xj.ElementBox), {
                                element: targetNode,
                                resizeUpdateMethod: shouldWatchTarget ? 'polling' : undefined,
                                children: (box)=>/*#__PURE__*/ (0, $2OMIu.jsx)(TargetReplacement, {
                                        "data-testid": `${testId}--target`,
                                        ...this.getTargetNodeStyle(box)
                                    })
                            })
                        }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bR0Xj.ElementBox), {
                            element: targetNode,
                            resizeUpdateMethod: shouldWatchTarget ? 'polling' : undefined,
                            children: (box)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $chKky.default), {
                                    shouldWatch: shouldWatchTarget,
                                    testId: `${testId}--target`,
                                    pulse: pulse,
                                    target: target,
                                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                                    style: this.getTargetNodeStyle(box),
                                    targetBgColor: targetBgColor,
                                    targetNode: targetNode,
                                    targetOnClick: targetOnClick,
                                    targetRadius: targetRadius
                                })
                        }),
                        TargetReplacement && !replacementElement ? null : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lNmQ7.Fade), {
                            hasEntered: isOpen,
                            onExited: onExited,
                            children: (animationStyles)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $86D9T.Layering), {
                                    isDisabled: false,
                                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bcSCo.default), {
                                        testId: `${testId}--dialog`,
                                        actions: this.props.actions,
                                        actionsBeforeElement: this.props.actionsBeforeElement,
                                        children: this.props.children,
                                        dialogPlacement: this.props.dialogPlacement,
                                        dialogWidth: this.props.dialogWidth,
                                        footer: this.props.footer,
                                        header: this.props.header,
                                        heading: this.props.heading,
                                        titleId: this.props.titleId,
                                        label: this.props.label,
                                        headingAfterElement: this.props.headingAfterElement,
                                        image: this.props.image,
                                        targetNode: replacementElement || targetNode,
                                        animationStyles: animationStyles
                                    })
                                })
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2alJM))), {})
                    ]
                })
        });
    }
    constructor(...args){
        super(...args), this.state = {
            // This is only used when targetReplacement is specified.
            // In this case, we have to render the targetReplacement component,
            // get a dom reference from that component, then render again passing
            // that reference into SpotlightDialog (Popper).
            replacementElement: null
        }, this.getTargetNodeStyle = (box)=>{
            if (!(0, $lv4Ny.canUseDOM)) return {};
            const { height: height, left: left, top: top, width: width, ...rest } = box;
            return {
                // Handling this just in case there are invalid elements being sent in to
                // the `box` arg
                ...rest,
                height: height,
                left: left,
                top: top,
                width: width,
                position: 'fixed',
                // when width is 0, set visibility hidden to avoid the target flashing issue
                ...width === 0 && (0, $fHpHg.fg)('scroll-lock-replacement') && {
                    visibility: 'hidden'
                }
            };
        };
    }
}
var $34a27059dd74103d$export$2e2bcd8739ae039 = $34a27059dd74103d$var$SpotlightInner;

});
parcelRegister("bR0Xj", function(module, exports) {

$parcel$export(module.exports, "ElementBox", () => $17eabb0ea22a01b7$export$1b6719bd7aff3c00);

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");

var $fHpHg = parcelRequire("fHpHg");
// The minimum interval between position updates in milliseconds
const $17eabb0ea22a01b7$var$POSITION_UPDATE_INTERVAL = 200;
const $17eabb0ea22a01b7$var$getElementRect = (element)=>{
    const { height: height, left: left, top: top, width: width } = element.getBoundingClientRect();
    return {
        height: height,
        left: left,
        top: top,
        width: width
    };
};
const $17eabb0ea22a01b7$var$useResizeAwareElementBox = (element, updateMethod)=>{
    const [box, setBox] = (0, $5uXOq.useState)({
        width: 0,
        height: 0,
        left: 0,
        top: 0
    });
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (updateMethod === 'resizeListener') {
            if ((0, $fHpHg.fg)('scroll-lock-replacement')) // use setTimeout 0 to defer the state update to avoid content shifting when pages have scrollbars
            // more details are https://www.loom.com/share/96a5d7c2afd74146a3c005bf20a8c69e?sid=968b00c1-e5ab-4ea0-9fe4-e534fe7088e4
            setTimeout(()=>{
                setBox($17eabb0ea22a01b7$var$getElementRect(element));
            }, 0);
            else setBox($17eabb0ea22a01b7$var$getElementRect(element));
        }
    }, [
        element,
        updateMethod
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const onResize = ()=>{
            requestAnimationFrame(()=>{
                setBox($17eabb0ea22a01b7$var$getElementRect(element));
            });
        };
        if (updateMethod === 'resizeListener') return (0, $cBeZP.bind)(window, {
            type: 'resize',
            listener: onResize
        });
    }, [
        element,
        updateMethod
    ]);
    return box;
};
const $17eabb0ea22a01b7$var$usePollingElementBox = (element, updateMethod)=>{
    // These are intentionally tracked as number primitives rather than as a shared `box` object.
    // Since the requestAnimationFrame code below updates this often, we want to avoid re-renders
    // when the values are the same.  React uses `Object.is` to figure out if the state changed after a setState.
    // If we represent this as a shared `box` object, this will re-render even if the two objects have identical contents.
    const [width, setWidth] = (0, $5uXOq.useState)(0);
    const [height, setHeight] = (0, $5uXOq.useState)(0);
    const [left, setLeft] = (0, $5uXOq.useState)(0);
    const [top, setTop] = (0, $5uXOq.useState)(0);
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (updateMethod === 'polling') {
            if ((0, $fHpHg.fg)('scroll-lock-replacement')) // use setTimeout 0 to defer the state update to avoid content shifting when pages have scrollbars
            // more details are https://www.loom.com/share/96a5d7c2afd74146a3c005bf20a8c69e?sid=968b00c1-e5ab-4ea0-9fe4-e534fe7088e4
            setTimeout(()=>{
                const newBox = $17eabb0ea22a01b7$var$getElementRect(element);
                setWidth(newBox.width);
                setHeight(newBox.height);
                setLeft(newBox.left);
                setTop(newBox.top);
            }, 0);
            else {
                const newBox = $17eabb0ea22a01b7$var$getElementRect(element);
                setWidth(newBox.width);
                setHeight(newBox.height);
                setLeft(newBox.left);
                setTop(newBox.top);
            }
        }
    }, [
        element,
        updateMethod
    ]);
    // Souce: https://css-tricks.com/using-requestanimationframe-with-react-hooks/
    // Use useRef for mutable variables that we want to persist
    // without triggering a re-render on their change
    const requestRef = (0, $5uXOq.useRef)();
    const previousUpdateTimeRef = (0, $5uXOq.useRef)();
    const animate = (0, $5uXOq.useCallback)((time)=>{
        if (previousUpdateTimeRef.current !== undefined) {
            const timeSinceLastUpdate = time - previousUpdateTimeRef.current;
            if (timeSinceLastUpdate > $17eabb0ea22a01b7$var$POSITION_UPDATE_INTERVAL) {
                const newBox = $17eabb0ea22a01b7$var$getElementRect(element);
                setWidth(newBox.width);
                setHeight(newBox.height);
                setLeft(newBox.left);
                setTop(newBox.top);
                previousUpdateTimeRef.current = time;
            }
        } else // Initialize previousUpdateTimeRef
        previousUpdateTimeRef.current = time;
        requestRef.current = requestAnimationFrame(animate);
    }, [
        element
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (updateMethod === 'polling') requestRef.current = requestAnimationFrame(animate);
        return ()=>{
            if (requestRef.current !== undefined) cancelAnimationFrame(requestRef.current);
        };
    // This useEffect should only run on mount and when `element` or `updateMethod` changes.
    }, [
        animate,
        element,
        updateMethod
    ]);
    const box = (0, $5uXOq.useMemo)(()=>({
            width: width,
            height: height,
            left: left,
            top: top
        }), [
        width,
        height,
        left,
        top
    ]);
    return box;
};
/**
 * Will listen to the document resizing to see if an element has moved positions.
 * Not using ResizeObserver because of IE11 support.
 * @param element HTMLElement to watch when resizing.
 */ const $17eabb0ea22a01b7$var$useElementBox = (element, resizeUpdateMethod)=>{
    const updateMethod = resizeUpdateMethod || 'resizeListener';
    const boxViaResizeListener = $17eabb0ea22a01b7$var$useResizeAwareElementBox(element, updateMethod);
    const boxViaPolling = $17eabb0ea22a01b7$var$usePollingElementBox(element, updateMethod);
    return updateMethod === 'resizeListener' ? boxViaResizeListener : boxViaPolling;
};
const $17eabb0ea22a01b7$export$1b6719bd7aff3c00 = (props)=>{
    const box = $17eabb0ea22a01b7$var$useElementBox(props.element, props.resizeUpdateMethod);
    return props.children(box);
};

});

parcelRegister("lNmQ7", function(module, exports) {

$parcel$export(module.exports, "Fade", () => $18a7a5ee5480dcb6$export$c983850c6c9d8b0e);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ahdj0 = parcelRequire("ahdj0");

var $fHpHg = parcelRequire("fHpHg");
const $18a7a5ee5480dcb6$var$duration = {
    enter: 0,
    exit: 100
};
const $18a7a5ee5480dcb6$export$c983850c6c9d8b0e = ({ hasEntered: hasEntered, children: children, onExited: onExited })=>{
    const nodeRef = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef(null);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ahdj0.default), {
        in: hasEntered,
        timeout: $18a7a5ee5480dcb6$var$duration,
        onExited: onExited,
        unmountOnExit: true,
        appear: true,
        ...(0, $fHpHg.fg)('platform_design_system_team_transition_group_r18') && {
            nodeRef: nodeRef
        },
        children: (status)=>{
            const anim = {
                entered: {
                    opacity: 1
                },
                exiting: {
                    opacity: 0
                }
            };
            return children({
                transition: `opacity ${$18a7a5ee5480dcb6$var$duration.exit}ms`,
                opacity: 0,
                ...status in anim ? anim[status] : {}
            });
        }
    });
};

});

parcelRegister("chKky", function(module, exports) {

$parcel$export(module.exports, "default", () => $759c227a032e016c$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $cOGPo = parcelRequire("cOGPo");

var $hWpgD = parcelRequire("hWpgD");
const $759c227a032e016c$var$computedStyleAttributesToClone = [
    'fontSize',
    'fontWeight',
    'lineHeight',
    'padding',
    'color',
    'textOverflow'
];
function $759c227a032e016c$var$cloneAndOverrideStyles(node) {
    const shouldCloneChildren = true;
    const clonedNode = node.cloneNode(shouldCloneChildren);
    const computedStyles = getComputedStyle(node);
    $759c227a032e016c$var$computedStyleAttributesToClone.forEach((attribute)=>{
        clonedNode.style[attribute] = computedStyles[attribute];
    });
    clonedNode.style.margin = '0';
    clonedNode.style.position = 'static';
    // The target may have other transforms applied. Avoid unintended side effects
    // by zeroing out "translate" rather than applying a value of "none".
    clonedNode.style.transform = 'translate(0, 0) translate3d(0, 0, 0)';
    return clonedNode;
}
/**
 * __Clone__
 *
 * Used for cloning spotlight targets. The clone is positioned on top of the spotlight target with
 * a pulsing animation.
 *
 * @internal
 */ const $759c227a032e016c$var$Clone = (props)=>{
    const { pulse: pulse, style: style, shouldWatch: shouldWatch, target: target, targetBgColor: targetBgColor, targetOnClick: targetOnClick, targetNode: targetNode, targetRadius: targetRadius, testId: testId } = props;
    const contentVersion = (0, $hWpgD.useElementObserver)(targetNode, {
        disableWatch: !shouldWatch
    });
    const contentHTML = (0, $5uXOq.useMemo)(()=>$759c227a032e016c$var$cloneAndOverrideStyles(targetNode).outerHTML, // eslint-disable-next-line react-hooks/exhaustive-deps -- We only want to update when the content changes
    [
        contentVersion,
        targetNode
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $cOGPo.TargetInner), {
        "data-testid": testId,
        pulse: pulse,
        bgColor: targetBgColor,
        radius: targetRadius,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                dangerouslySetInnerHTML: {
                    __html: contentHTML
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: {
                    height: '100%',
                    pointerEvents: 'none'
                }
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cOGPo.TargetOverlay), {
                onClick: targetOnClick ? (event)=>targetOnClick({
                        event: event,
                        target: target
                    }) : undefined
            })
        ]
    });
};
var $759c227a032e016c$export$2e2bcd8739ae039 = $759c227a032e016c$var$Clone;

});
parcelRegister("cOGPo", function(module, exports) {

$parcel$export(module.exports, "TargetInner", () => $0390ba0ae80ebb6b$export$b1542cc928b93af);
$parcel$export(module.exports, "TargetOverlay", () => $0390ba0ae80ebb6b$export$a28a07e0025d709d);
$parcel$export(module.exports, "Pulse", () => $0390ba0ae80ebb6b$export$927d63e2511364c0);
/* target.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $0390ba0ae80ebb6b$var$reduceMotionAsPerUserPreference = null;
// NOTE:
// Pulse color "rgb(101, 84, 192)" derived from "colors.P300"
const $0390ba0ae80ebb6b$var$baseShadow = `0 0 0 2px ${"var(--ds-border-discovery, #8270DB)"}`;
const $0390ba0ae80ebb6b$var$easing = 'cubic-bezier(0.55, 0.055, 0.675, 0.19)';
const $0390ba0ae80ebb6b$var$pulseKeyframes = null;
const $0390ba0ae80ebb6b$var$animationStyles = null;
const $0390ba0ae80ebb6b$var$Base = ({ bgColor: bgColor, children: children, className: className, radius: radius, testId: testId, style: style, // The rest of these props are from `HTMLDivElement`
...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: className,
        "data-testid": testId,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Pass-through style is not allowed at the moment
            ...style,
            backgroundColor: bgColor,
            borderRadius: radius ? `${radius}px` : undefined
        },
        ...props,
        children: children
    });
const $0390ba0ae80ebb6b$export$b1542cc928b93af = ({ bgColor: bgColor, children: children, className: className, pulse: pulse, radius: radius, testId: testId, // Thes rest of these are from `HTMLDivElement`
...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)($0390ba0ae80ebb6b$var$Base, {
        bgColor: bgColor,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            pulse && "",
            pulse && "_y44v1si8 _16qs1wx8",
            "_1bumglyw _sedtglyw",
            className
        ]),
        radius: radius,
        testId: testId,
        ...props,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: props.style,
        children: children
    });
const $0390ba0ae80ebb6b$var$targetOverlayStyles = null;
const $0390ba0ae80ebb6b$export$a28a07e0025d709d = ({ onClick: onClick, ...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        onClick: onClick,
        ...props,
        style: {
            cursor: onClick ? 'pointer' : 'auto'
        },
        className: (0, $bwpsq.default)([
            "_1bsb1osq _4t3i1osq _kqswstnw _152tze3t _1e02ze3t"
        ])
    });
const $0390ba0ae80ebb6b$export$927d63e2511364c0 = ({ bgColor: bgColor, children: children, className: className, radius: radius, pulse: pulse = true, testId: testId, ...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)($0390ba0ae80ebb6b$var$Base, {
        bgColor: bgColor,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            pulse && "",
            pulse && "_y44v1si8 _16qs1wx8",
            "_1bumglyw _sedtglyw",
            className
        ]),
        radius: radius,
        testId: testId,
        ...props,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: props.style,
        children: children
    });

});

parcelRegister("hWpgD", function(module, exports) {

$parcel$export(module.exports, "useElementObserver", () => $a8d5cd9f7eb62305$export$729bafd4e621fba0);

var $5uXOq = parcelRequire("5uXOq");
function $a8d5cd9f7eb62305$export$729bafd4e621fba0(element, opts = {}) {
    const { onChange: onChange, disableWatch: disableWatch = false } = opts;
    // This state is used to force a re-render when the target changes
    const [targetContentVersion, setTargetContentVersion] = (0, $5uXOq.useState)(0);
    const mutationObserver = (0, $5uXOq.useRef)(undefined);
    const cancelIdleCallback1 = (0, $5uXOq.useRef)(undefined);
    const disposer = (0, $5uXOq.useCallback)(()=>{
        cancelIdleCallback1.current?.();
        cancelIdleCallback1.current = undefined;
        mutationObserver.current?.disconnect();
        mutationObserver.current = undefined;
    }, []);
    const onMutation = (0, $5uXOq.useCallback)(()=>{
        // MutationObserver can make multiple calls to the callback in quick succession so debounce when idle
        cancelIdleCallback1.current?.();
        cancelIdleCallback1.current = $a8d5cd9f7eb62305$var$callWhenIdle(()=>setTargetContentVersion((v)=>{
                const version = v + 1;
                onChange?.(version);
                return version;
            }));
    }, [
        onChange
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // Clean up any existing observer in the case that the target node has changed
        disposer();
        if (!disableWatch && element) {
            mutationObserver.current = new MutationObserver(onMutation);
            mutationObserver.current.observe(element, {
                attributes: true,
                childList: true,
                subtree: true
            });
        }
        return disposer;
    }, [
        disableWatch,
        disposer,
        element,
        onMutation
    ]);
    return targetContentVersion;
}
/**
 * When the browser is idle call the callback.
 *
 * This function will use `requestIdleCallback` if available, otherwise it will fallback to `setTimeout`.
 *
 * @param callback The function to call when the browser is idle.
 * @param [opts] Options for the idle callback.
 * @param [opts.timeout=100] The maximum time to wait for the browser to be idle.
 *
 * @returns A function that can be called to cancel the idle callback.
 *
 * @internal
 */ function $a8d5cd9f7eb62305$var$callWhenIdle(callback, opts = {}) {
    const { timeout: timeout = 100 } = opts;
    if (typeof window.requestIdleCallback === 'function') {
        const idleHandle = window.requestIdleCallback(callback, {
            timeout: timeout
        });
        return ()=>cancelIdleCallback(idleHandle);
    }
    // Fallback to setTimeout if requestIdleCallback is not available
    const timeoutHandle = setTimeout(callback, timeout);
    return ()=>clearTimeout(timeoutHandle);
}

});


parcelRegister("jxb8w", function(module, exports) {

$parcel$export(module.exports, "default", () => $277d81988b19f5f3$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $dI393 = parcelRequire("dI393");
/**
 * A wrapper component that conditionally applies a NodeResolver to its children.
 *
 * Note: NodeResolver should not be used in React 18 concurrent mode. This component
 * is intended to be removed once the feature flag  is removed.
 * @param {boolean} props.hasNodeResolver - Determines whether to apply the NodeResolver.
 * @param {ReactElement} props.children - The child elements to be wrapped.
 * @param {(instance: HTMLDivElement) => void} props.innerRef - A ref callback to get the instance of the HTMLDivElement.
 * @returns {ReactElement} The children wrapped with NodeResolver if hasNodeResolver is true, wrape the children in a div setting innerRef with ref to the div.
 */ const $277d81988b19f5f3$var$NodeResolverSpotlightInner = ({ hasNodeResolver: hasNodeResolver, children: children, innerRef: innerRef })=>{
    const divRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        if (!hasNodeResolver) innerRef(divRef.current?.firstElementChild);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        hasNodeResolver
    ]);
    if (hasNodeResolver) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dI393))), {
        innerRef: innerRef,
        children: children
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ref: divRef,
        children: children
    });
};
var $277d81988b19f5f3$export$2e2bcd8739ae039 = $277d81988b19f5f3$var$NodeResolverSpotlightInner;

});

parcelRegister("bcSCo", function(module, exports) {

$parcel$export(module.exports, "default", () => $7489d0820d6182b8$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ao4Ml = parcelRequire("ao4Ml");

var $e5neF = parcelRequire("e5neF");

var $5sRpy = parcelRequire("5sRpy");

var $hLfPK = parcelRequire("hLfPK");

var $aiSlh = parcelRequire("aiSlh");

var $jPtB0 = parcelRequire("jPtB0");
/**
 * __Spotlight dialog__
 *
 * An onboarding spotlight introduces new features to users through focused messages or multi-step tours.
 *
 * - [Examples](https://atlassian.design/components/onboarding/examples)
 * - [Code](https://atlassian.design/components/onboarding/code)
 * - [Usage](https://atlassian.design/components/onboarding/usage)
 */ // eslint-disable-next-line @repo/internal/react/no-class-components
class $7489d0820d6182b8$var$SpotlightDialogComponent extends (0, $5uXOq.Component) {
    componentDidMount() {
        this.focusLockTimeoutId = window.setTimeout(()=>{
            // we delay the enabling of the focus lock to avoid the scroll position
            // jumping around in some situations
            this.setState({
                focusLockDisabled: false
            });
        }, 200);
    }
    componentWillUnmount() {
        window.clearTimeout(this.focusLockTimeoutId);
    }
    render() {
        const { actions: actions, actionsBeforeElement: actionsBeforeElement, animationStyles: animationStyles, children: children, dialogPlacement: dialogPlacement, dialogWidth: dialogWidth, footer: footer, header: header, heading: heading, headingAfterElement: headingAfterElement, image: image, label: label = 'Introducing new feature', titleId: titleId, targetNode: targetNode, testId: testId } = this.props;
        const { focusLockDisabled: focusLockDisabled } = this.state;
        const dialogLabel = !heading && !titleId ? label : undefined;
        const dialogLabelledBy = titleId || (heading ? 'spotlight-dialog-label' : undefined);
        const translatedPlacement = dialogPlacement ? ({
            'top left': 'top-start',
            'top center': 'top',
            'top right': 'top-end',
            'right top': 'right-start',
            'right middle': 'right',
            'right bottom': 'right-end',
            'bottom left': 'bottom-start',
            'bottom center': 'bottom',
            'bottom right': 'bottom-end',
            'left top': 'left-start',
            'left middle': 'left',
            'left bottom': 'left-end'
        })[dialogPlacement] : undefined;
        // If there's no room on either side of the popper, it will extend off-screen.
        //  This looks buggy when scroll-lock and focus is placed on the dialog, so we
        //  customise popper so it overflows the spotlight instead with altAxis=true.
        const modifiers = [
            {
                name: 'preventOverflow',
                options: {
                    padding: 5,
                    rootBoundary: 'document',
                    altAxis: true,
                    tether: false
                }
            }
        ];
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $e5neF.Popper), {
            modifiers: modifiers,
            referenceElement: targetNode,
            placement: translatedPlacement,
            children: ({ ref: ref, style: style, update: update })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $jPtB0.default), {
                    value: dialogWidth,
                    onChange: update,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ao4Ml.default), {
                        disabled: focusLockDisabled,
                        returnFocus: false,
                        autoFocus: true,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                            style: {
                                ...style,
                                ...animationStyles
                            },
                            ref: ref,
                            "aria-modal": true,
                            role: "dialog",
                            "aria-label": dialogLabel,
                            "aria-labelledby": dialogLabelledBy,
                            testId: `${testId}-container`,
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $aiSlh.default), {
                                testId: testId,
                                width: dialogWidth,
                                actions: actions,
                                actionsBeforeElement: actionsBeforeElement,
                                image: image && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hLfPK.DialogImage), {
                                    alt: heading,
                                    src: image
                                }),
                                components: {
                                    Header: header,
                                    Footer: footer
                                },
                                heading: heading,
                                headingId: "spotlight-dialog-label",
                                headingAfterElement: headingAfterElement,
                                // This should be heading level 1 since this is technically a modal, including a focus lock on the modal window.
                                // But because it is not a _true_ modal, we are setting it to `2` until that is fixed.
                                headingLevel: 2,
                                children: children
                            })
                        })
                    })
                })
        });
    }
    constructor(...args){
        super(...args), this.state = {
            focusLockDisabled: true
        };
    }
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$7489d0820d6182b8$export$2e2bcd8739ae039 = $7489d0820d6182b8$var$SpotlightDialogComponent;

});
parcelRegister("hLfPK", function(module, exports) {

$parcel$export(module.exports, "DialogImage", () => $23e4f6023f062369$export$855e1a47874d6b81);
$parcel$export(module.exports, "DialogActionItemContainer", () => $23e4f6023f062369$export$ed9b6b50bbed5f27);
$parcel$export(module.exports, "DialogActionItem", () => $23e4f6023f062369$export$6ae54e00f59e1f33);
/* dialog.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $5sRpy = parcelRequire("5sRpy");
const $23e4f6023f062369$var$imageStyles = null;
const $23e4f6023f062369$var$actionItemContainerStyles = {
    root: "_1e0c1txw _2lx21sbv _6rthze3t _1pfhze3t _12l2r5cr _ahbqr5cr"
};
const $23e4f6023f062369$var$actionItemStyles = {
    root: "_6rthze3t _1pfhze3t _12l21b66 _ahbq1b66"
};
const $23e4f6023f062369$export$855e1a47874d6b81 = ({ alt: alt, ...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)("img", {
        alt: alt,
        ...props,
        className: (0, $bwpsq.default)([
            "_p12f1osq _4t3i1wug"
        ])
    });
const $23e4f6023f062369$export$ed9b6b50bbed5f27 = ({ children: children })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        xcss: $23e4f6023f062369$var$actionItemContainerStyles.root,
        children: children
    });
const $23e4f6023f062369$export$6ae54e00f59e1f33 = ({ children: children })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        xcss: $23e4f6023f062369$var$actionItemStyles.root,
        children: children
    });

});

parcelRegister("aiSlh", function(module, exports) {

$parcel$export(module.exports, "default", () => $03a104f5df1598e8$export$2e2bcd8739ae039);
/* spotlight-card.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $1nSOt = parcelRequire("1nSOt");
var $ep3GE = parcelRequire("ep3GE");

var $6tzHJ = parcelRequire("6tzHJ");

var $bWfiu = parcelRequire("bWfiu");

var $aLUgv = parcelRequire("aLUgv");

var $5sRpy = parcelRequire("5sRpy");
var $k9nuy = parcelRequire("k9nuy");

var $hLfPK = parcelRequire("hLfPK");

var $65PNM = parcelRequire("65PNM");
const $03a104f5df1598e8$var$bodyStyles = null;
const $03a104f5df1598e8$var$imageStyles = null;
const $03a104f5df1598e8$var$defaultHeaderStyles = null;
const $03a104f5df1598e8$var$DefaultHeader = ({ children: children })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1q9y _1bah1yb4 _85i5u2gc"
        ]),
        children: children
    });
const $03a104f5df1598e8$var$defaultFooterStyles = null;
const $03a104f5df1598e8$var$DefaultFooter = ({ children: children })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": "spotlight--dialog-footer",
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _1bah1yb4 _1q51u2gc"
        ]),
        children: children
    });
const $03a104f5df1598e8$var$containerStyles = {
    root: "_2rkoglpi _1reo1wug _18m91wug _4t3i1ns9 _syaz15cr _1ul91lit _p12f1ogm"
};
const $03a104f5df1598e8$var$containerShadowStyles = {
    root: "_16qszucj"
};
/**
 * __Spotlight card__
 *
 * A spotlight card is for onboarding messages that need a more flexible layout, or don't require a dialog.
 *
 * - [Examples](https://atlassian.design/components/onboarding/spotlight-card/examples)
 * - [Code](https://atlassian.design/components/onboarding/spotlight-card/code)
 * - [Usage](https://atlassian.design/components/onboarding/spotlight-card/usage)
 */ const $03a104f5df1598e8$var$SpotlightCard = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { actions: actions = [], actionsBeforeElement: actionsBeforeElement, children: children, components: components = {}, heading: heading, headingLevel: headingLevel = 4, headingAfterElement: headingAfterElement, image: image, innerRef: innerRef, isFlat: isFlat, testId: testId, width: width = 400, headingId: headingId } = props;
    const { Header: Header = $03a104f5df1598e8$var$DefaultHeader, Footer: Footer = $03a104f5df1598e8$var$DefaultFooter } = components;
    const { currentLevel: currentLevel } = (0, $aLUgv.useLayering)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ep3GE.default).Provider, {
        value: (0, $65PNM.spotlightButtonTheme),
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5sRpy.default), {
            backgroundColor: "color.background.discovery.bold",
            xcss: (0, $6tzHJ.cx)($03a104f5df1598e8$var$containerStyles.root, !isFlat && $03a104f5df1598e8$var$containerShadowStyles.root),
            style: {
                width: width
            },
            ref: ref || innerRef,
            testId: testId,
            "data-ds--level": currentLevel,
            // temporarily use this data attribute to prevent clicking outside won't close spotlight correctly issue
            "data-ds--close--type": "single",
            children: [
                typeof image === 'string' ? /*#__PURE__*/ (0, $2OMIu.jsx)("img", {
                    src: image,
                    alt: "",
                    className: (0, $bwpsq.default)([
                        "_1e0c1ule"
                    ])
                }) : image,
                /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
                    className: (0, $bwpsq.default)([
                        "_1e0c1txw _2lx21bp4 _85i5pxbi _1q51pxbi _y4tiv47k _bozgv47k"
                    ]),
                    children: [
                        heading || headingAfterElement ? /*#__PURE__*/ (0, $2OMIu.jsxs)(Header, {
                            children: [
                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bWfiu.default), {
                                    id: headingId,
                                    size: "medium",
                                    as: `h${headingLevel}`,
                                    color: "color.text.inverse",
                                    children: heading
                                }),
                                headingAfterElement
                            ]
                        }) : null,
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k9nuy.default), {
                            children: children
                        }),
                        actions.length > 0 || actionsBeforeElement ? /*#__PURE__*/ (0, $2OMIu.jsxs)(Footer, {
                            children: [
                                actionsBeforeElement || /*#__PURE__*/ (0, $2OMIu.jsx)("span", {}),
                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hLfPK.DialogActionItemContainer), {
                                    children: actions.map(({ text: text, key: key, ...rest }, idx)=>{
                                        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hLfPK.DialogActionItem), {
                                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1nSOt.default), {
                                                ...rest,
                                                children: text
                                            })
                                        }, key || (typeof text === 'string' ? text : `${idx}`));
                                    })
                                })
                            ]
                        }) : null
                    ]
                })
            ]
        })
    });
});
$03a104f5df1598e8$var$SpotlightCard.displayName = 'SpotlightCard';
var $03a104f5df1598e8$export$2e2bcd8739ae039 = $03a104f5df1598e8$var$SpotlightCard;

});
parcelRegister("65PNM", function(module, exports) {

$parcel$export(module.exports, "spotlightButtonTheme", () => $6ad32ae113c5746f$export$39a36121076ca24);
$parcel$export(module.exports, "modalButtonTheme", () => $6ad32ae113c5746f$export$d131eb21ba4cbd16);
const $6ad32ae113c5746f$var$spotlightTheme = {
    default: {
        background: {
            default: "var(--ds-background-inverse-subtle, #00000029)",
            hover: "var(--ds-background-inverse-subtle-hovered, #0000003D)",
            active: "var(--ds-background-inverse-subtle-pressed, #00000052)",
            disabled: "var(--ds-background-disabled, #091E4208)",
            selected: "var(--ds-background-inverse-subtle-pressed, #00000052)",
            focus: "var(--ds-background-inverse-subtle, #00000029)"
        },
        color: {
            default: "var(--ds-text-inverse, #FFFFFF)",
            hover: "var(--ds-text-inverse, #FFFFFF)",
            active: "var(--ds-text-inverse, #FFFFFF)",
            disabled: {
                light: "var(--ds-text-disabled, #091E424F)",
                dark: "var(--ds-text-disabled, #091E424F)"
            },
            selected: "var(--ds-text-inverse, #FFFFFF)",
            focus: "var(--ds-text-inverse, #FFFFFF)"
        }
    },
    subtle: {
        background: {
            default: 'none',
            hover: "var(--ds-background-inverse-subtle-hovered, #0000003D)",
            active: "var(--ds-background-inverse-subtle-pressed, #00000052)",
            disabled: 'none',
            selected: {
                light: "var(--ds-background-selected-hovered, #CCE0FF)",
                dark: "var(--ds-background-selected-hovered, #CCE0FF)"
            },
            focusSelected: {
                light: "var(--ds-background-selected-hovered, #CCE0FF)",
                dark: "var(--ds-background-selected-hovered, #CCE0FF)"
            }
        },
        color: {
            default: "var(--ds-text-inverse, #FFFFFF)",
            hover: "var(--ds-text-inverse, #FFFFFF)",
            active: "var(--ds-text-inverse, #FFFFFF)",
            disabled: "var(--ds-text-disabled, #091E424F)",
            selected: "var(--ds-text-inverse, #FFFFFF)",
            focus: "var(--ds-text-inverse, #FFFFFF)"
        }
    },
    'subtle-link': {
        textDecoration: {
            hover: `underline ${"var(--ds-text-inverse, #FFFFFF)"}`
        },
        textDecorationLine: {
            active: 'none'
        },
        color: {
            default: "var(--ds-text-inverse, #FFFFFF)",
            hover: "var(--ds-text-inverse, #FFFFFF)",
            active: "var(--ds-text-inverse, #FFFFFF)",
            disabled: "var(--ds-text-discovery, #5E4DB2)",
            selected: "var(--ds-text-selected, #0C66E4)",
            focus: "var(--ds-text-inverse, #FFFFFF)"
        }
    }
};
const $6ad32ae113c5746f$var$modalTheme = {
    primary: {
        background: {
            default: "var(--ds-background-discovery-bold, #6E5DC6)",
            hover: "var(--ds-background-discovery-bold-hovered, #5E4DB2)",
            active: "var(--ds-background-discovery-bold-pressed, #352C63)",
            disabled: {
                light: "var(--ds-background-disabled, #091E4208)",
                dark: "var(--ds-background-disabled, #091E4208)"
            },
            selected: "var(--ds-background-selected-hovered, #CCE0FF)",
            focus: "var(--ds-background-discovery-bold-hovered, #5E4DB2)"
        },
        color: {
            default: "var(--ds-text-inverse, #FFFFFF)",
            disabled: {
                light: "var(--ds-text-disabled, #091E424F)",
                dark: "var(--ds-text-disabled, #091E424F)"
            },
            selected: "var(--ds-text-selected, #0C66E4)",
            focus: "var(--ds-text-inverse, #FFFFFF)"
        }
    }
};
function $6ad32ae113c5746f$var$extract(newTheme, { mode: mode, appearance: appearance, state: state }) {
    if (!newTheme[appearance]) return undefined;
    const root = newTheme[appearance];
    return Object.keys(root).reduce((acc, val)=>{
        let node = root;
        [
            val,
            state,
            mode
        ].forEach((item)=>{
            if (!node[item]) return undefined;
            if (typeof node[item] !== 'object') {
                acc[val] = node[item];
                return undefined;
            }
            node = node[item];
            return undefined;
        });
        return acc;
    }, {});
}
const $6ad32ae113c5746f$export$39a36121076ca24 = (current, themeProps)=>{
    const { buttonStyles: buttonStyles, ...rest } = current(themeProps);
    return {
        buttonStyles: {
            ...buttonStyles,
            ...$6ad32ae113c5746f$var$extract($6ad32ae113c5746f$var$spotlightTheme, themeProps)
        },
        ...rest
    };
};
const $6ad32ae113c5746f$export$d131eb21ba4cbd16 = (current, themeProps)=>{
    const { buttonStyles: buttonStyles, ...rest } = current(themeProps);
    return {
        buttonStyles: {
            ...buttonStyles,
            ...$6ad32ae113c5746f$var$extract($6ad32ae113c5746f$var$modalTheme, themeProps)
        },
        ...rest
    };
};

});


parcelRegister("jPtB0", function(module, exports) {

$parcel$export(module.exports, "default", () => $93d0612681908b22$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
class $93d0612681908b22$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    componentDidUpdate(prevProps) {
        if (prevProps.value !== this.props.value) this.props.onChange();
    }
    render() {
        return this.props.children;
    }
}

});


parcelRegister("98UVV", function(module, exports) {

$parcel$export(module.exports, "SpotlightTransitionConsumer", () => $0d0d0ae54c51b308$export$7d63b19b854c2fe8);
$parcel$export(module.exports, "default", () => $0d0d0ae54c51b308$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bKnKN = parcelRequire("bKnKN");
const $0d0d0ae54c51b308$var$SpotlightTransitionContext = /*#__PURE__*/ (0, $5uXOq.createContext)({
    isOpen: true,
    onExited: (0, $bKnKN.default)
});
// checks if children exist and are truthy
const $0d0d0ae54c51b308$var$hasChildren = (children)=>(0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.count(children) > 0 && ((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(children || false, (child)=>!!child)?.filter(Boolean)?.length || 0) > 0;
/**
 * __Spotlight transition__
 *
 * A spotlight transition holds onto spotlights so they can fade out when exiting the viewport.
 *
 * - [Examples](https://atlassian.design/components/onboarding/examples)
 * - [Code](https://atlassian.design/components/onboarding/code)
 * - [Usage](https://atlassian.design/components/onboarding/usage)
 */ class $0d0d0ae54c51b308$var$SpotlightTransition extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    static getDerivedStateFromProps(props, state) {
        const { currentChildren: previousChildren } = state;
        const exiting = $0d0d0ae54c51b308$var$hasChildren(previousChildren) && !$0d0d0ae54c51b308$var$hasChildren(props.children);
        return {
            currentChildren: exiting ? previousChildren : props.children
        };
    }
    render() {
        return /*#__PURE__*/ (0, $2OMIu.jsx)($0d0d0ae54c51b308$var$SpotlightTransitionContext.Provider, {
            value: {
                onExited: this.onExited,
                isOpen: $0d0d0ae54c51b308$var$hasChildren(this.props.children)
            },
            children: this.state.currentChildren
        });
    }
    constructor(...args){
        super(...args), this.state = {
            currentChildren: undefined
        }, this.onExited = ()=>{
            this.setState({
                currentChildren: this.props.children
            });
        };
    }
}
const $0d0d0ae54c51b308$export$7d63b19b854c2fe8 = $0d0d0ae54c51b308$var$SpotlightTransitionContext.Consumer;
var $0d0d0ae54c51b308$export$2e2bcd8739ae039 = $0d0d0ae54c51b308$var$SpotlightTransition;

});


parcelRegister("inni2", function(module, exports) {

$parcel$export(module.exports, "TargetConsumer", () => $33ab911c0ff0f636$export$f643dd64c1952cc8);
$parcel$export(module.exports, "SpotlightContext", () => $33ab911c0ff0f636$export$7b5aa0f5b37a336d);
$parcel$export(module.exports, "SpotlightConsumer", () => $33ab911c0ff0f636$export$3503199acd121708);
$parcel$export(module.exports, "default", () => $33ab911c0ff0f636$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8QpSo = parcelRequire("8QpSo");

var $bKnKN = parcelRequire("bKnKN");

var $fHpHg = parcelRequire("fHpHg");

var $5g2iQ = parcelRequire("5g2iQ");

var $dP90U = parcelRequire("dP90U");

var $lNmQ7 = parcelRequire("lNmQ7");

var $6cAn5 = parcelRequire("6cAn5");
const { Consumer: $33ab911c0ff0f636$export$f643dd64c1952cc8, Provider: $33ab911c0ff0f636$var$TargetProvider } = /*#__PURE__*/ (0, $5uXOq.createContext)(undefined);
const $33ab911c0ff0f636$export$7b5aa0f5b37a336d = /*#__PURE__*/ (0, $5uXOq.createContext)({
    opened: (0, $bKnKN.default),
    closed: (0, $bKnKN.default),
    targets: {}
});
const { Consumer: $33ab911c0ff0f636$export$3503199acd121708, Provider: $33ab911c0ff0f636$var$SpotlightStateProvider } = $33ab911c0ff0f636$export$7b5aa0f5b37a336d;
const $33ab911c0ff0f636$var$Container = ({ component: Wrapper, children: children })=>/*#__PURE__*/ (0, $2OMIu.jsx)(Wrapper, {
        children: children
    });
class $33ab911c0ff0f636$export$2e2bcd8739ae039 extends (0, $5uXOq.PureComponent) {
    static{
        this.defaultProps = {
            blanketIsTinted: true
        };
    }
    componentDidMount() {
        typeof $6cAn5;
    }
    render() {
        const { blanketIsTinted: blanketIsTinted, children: children, component: Tag, onBlanketClicked: onBlanketClicked } = this.props;
        return /*#__PURE__*/ (0, $2OMIu.jsx)($33ab911c0ff0f636$var$SpotlightStateProvider, {
            value: this.getStateProviderValue(this.state.targets),
            children: /*#__PURE__*/ (0, $2OMIu.jsx)($33ab911c0ff0f636$var$TargetProvider, {
                value: this.getTargetRef,
                children: /*#__PURE__*/ (0, $2OMIu.jsxs)($33ab911c0ff0f636$var$Container, {
                    component: Tag || (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment,
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lNmQ7.Fade), {
                            hasEntered: this.state.spotlightCount > 0,
                            children: (animationStyles)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $5g2iQ.default), {
                                    zIndex: 700,
                                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dP90U.default), {
                                        /* eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766 */ style: animationStyles,
                                        isTinted: blanketIsTinted,
                                        onBlanketClicked: onBlanketClicked
                                    })
                                })
                        }),
                        children
                    ]
                })
            })
        });
    }
    constructor(...args){
        super(...args), this.state = {
            spotlightCount: 0,
            targets: {}
        }, /*
	 * When enabling React Streaming in Confluence, a
	 * "This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering"
	 * error happens.
	 * This is to fix this error by wrapping the state update in startTransition as suggested by React: https://react.dev/errors/421?invariant=421
	 */ this.getTargetRef = (0, $fHpHg.fg)('platform_fix_component_state_update_for_suspense') ? (name)=>(element)=>{
                (0, $5uXOq.startTransition)(()=>{
                    this.setState((state)=>({
                            targets: {
                                ...state.targets,
                                [name]: element || undefined
                            }
                        }));
                });
            } : (name)=>(element)=>{
                this.setState((state)=>({
                        targets: {
                            ...state.targets,
                            [name]: element || undefined
                        }
                    }));
            }, this.spotlightOpen = ()=>{
            this.setState((state)=>({
                    spotlightCount: state.spotlightCount + 1
                }));
        }, this.spotlightClose = ()=>{
            this.setState((state)=>({
                    spotlightCount: state.spotlightCount - 1
                }));
        }, this.getStateProviderValue = (0, $8QpSo.default)((targets)=>({
                opened: this.spotlightOpen,
                closed: this.spotlightClose,
                targets: targets
            }));
    }
}

});
parcelRegister("dP90U", function(module, exports) {

$parcel$export(module.exports, "default", () => $d45e9370a5372823$export$2e2bcd8739ae039);
/* blanket.tsx generated by @compiled/babel-plugin v0.36.1 */ // IE11 and Edge: z-index needed because fixed position calculates z-index relative
// to body instead of nearest stacking context (Portal in our case).

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $d45e9370a5372823$var$blanketStyles = null;
/**
 * __Blanket__
 *
 * A replacement for `@atlaskit/blanket`.
 *
 * We use this for spotlights instead of `@atlaskit/blanket`
 * because spotlights must sit on top of other layered elements,
 * such as modals, which have their own blankets.
 *
 * @internal
 */ const $d45e9370a5372823$var$Blanket = ({ isTinted: isTinted, onBlanketClicked: onBlanketClicked, style: style })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        role: "presentation",
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Pass-through style props are not allowed
            ...style,
            backgroundColor: isTinted ? "var(--ds-blanket, #091E427D)" : 'transparent'
        },
        onClick: onBlanketClicked,
        className: (0, $bwpsq.default)([
            "_1r04idpf _v56414ka _kqsw1n9t _1pby1fw0"
        ])
    });
};
var $d45e9370a5372823$export$2e2bcd8739ae039 = $d45e9370a5372823$var$Blanket;

});



parcelRegister("bEIgH", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f02e0b59436aa54$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $2s57o = parcelRequire("2s57o");

var $eWkgo = parcelRequire("eWkgo");
const $4f02e0b59436aa54$var$flexGrowMap = {
    hug: (0, $2s57o.xcss)({
        flexGrow: 0
    }),
    fill: (0, $2s57o.xcss)({
        width: '100%',
        flexGrow: 1
    })
};
/**
 * __Stack__
 *
 * Stack is a primitive component based on flexbox that manages the block layout of direct children.
 *
 * @example
 * ```tsx
 *  <Stack>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Stack>
 * ```
 *
 */ const $4f02e0b59436aa54$var$Stack = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: as, alignInline: alignItems, alignBlock: alignBlock = 'stretch', spread: spread, grow: grow, space: space, children: children, testId: testId, xcss: xcss, role: role }, ref)=>{
    const justifyContent = spread || alignBlock;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    const styles = grow ? [
        $4f02e0b59436aa54$var$flexGrowMap[grow],
        ...Array.isArray(xcss) ? xcss : [
            xcss
        ]
    ] : xcss;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $eWkgo.default), {
        as: as,
        role: role,
        gap: space,
        direction: "column",
        alignItems: alignItems,
        justifyContent: justifyContent,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$4f02e0b59436aa54$var$Stack.displayName = 'Stack';
var $4f02e0b59436aa54$export$2e2bcd8739ae039 = $4f02e0b59436aa54$var$Stack;

});

parcelRegister("6eFvr", function(module, exports) {

$parcel$export(module.exports, "default", () => $f551475736a55519$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $3joPi = parcelRequire("3joPi");

var $gHPOa = parcelRequire("gHPOa");

var $a2Xlh = parcelRequire("a2Xlh");

var $avgEF = parcelRequire("avgEF");
function $f551475736a55519$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $f551475736a55519$var$asAllowlist = [
    'span',
    'p',
    'strong',
    'em'
];
// We're doing this because our CSS reset can add top margins to elements such as `p` which is totally insane.
// Long term we should remove those instances from the reset - it should be a reset to 0.
// For now, at least we know <Text> will be unaffected by this.
const $f551475736a55519$var$resetStyles = {
    name: "eb2bs7",
    styles: "margin:0;overflow-wrap:anywhere"
};
const $f551475736a55519$var$strongStyles = {
    name: "zh3azs",
    styles: "font-weight:var(--ds-font-weight-bold, 700)"
};
const $f551475736a55519$var$emStyles = {
    name: "1jwcxx3",
    styles: "font-style:italic"
};
const $f551475736a55519$var$textAlignMap = {
    center: {
        name: "1azakc",
        styles: "text-align:center"
    },
    end: {
        name: "va2k03",
        styles: "text-align:end"
    },
    start: {
        name: "9kuh93",
        styles: "text-align:start"
    }
};
const $f551475736a55519$var$truncationStyles = {
    name: "478gwf",
    styles: "display:-webkit-box;overflow:hidden;-webkit-box-orient:vertical"
};
const $f551475736a55519$var$wordBreakMap = {
    breakAll: {
        name: "1m5hyg0",
        styles: "word-break:break-all"
    }
};
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ const $f551475736a55519$var$useColor = (colorProp, hasTextAncestor)=>{
    const surface = (0, $a2Xlh.useSurface)();
    if (colorProp === 'inherit') return undefined;
    if (colorProp) return colorProp;
    if (hasTextAncestor) return undefined;
    if ((0, $avgEF.inverseColorMap).hasOwnProperty(surface)) return (0, $avgEF.inverseColorMap)[surface];
    return 'color.text';
};
/**
 * __Text__
 *
 * Text is a primitive component that has the Atlassian Design System's design guidelines baked in.
 * This includes considerations for text attributes such as color, font size, font weight, and line height.
 * It renders a `span` by default.
 *
 * @internal
 */ const $f551475736a55519$var$Text = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: Component = 'span', color: colorProp, align: align, testId: testId, id: id, size: size, weight: weight, maxLines: maxLines, children: children }, ref)=>{
    (0, $3joPi.default)($f551475736a55519$var$asAllowlist.includes(Component), `@atlaskit/primitives: Text received an invalid "as" value of "${Component}"`);
    const hasTextAncestor = (0, $gHPOa.useHasTextAncestor)();
    const color = $f551475736a55519$var$useColor(colorProp, hasTextAncestor);
    if (!size && !hasTextAncestor) size = 'medium';
    const component = /*#__PURE__*/ (0, $f8Sb3.jsx)(Component, {
        ref: ref,
        css: [
            $f551475736a55519$var$resetStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            size && (0, $avgEF.textSizeStylesMap)[size],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            color && (0, $avgEF.textColorStylesMap)[color],
            maxLines && $f551475736a55519$var$truncationStyles,
            maxLines === 1 && $f551475736a55519$var$wordBreakMap.breakAll,
            align && $f551475736a55519$var$textAlignMap[align],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            weight && (0, $avgEF.textWeightStylesMap)[weight],
            Component === 'em' && $f551475736a55519$var$emStyles,
            Component === 'strong' && $f551475736a55519$var$strongStyles
        ],
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        id: id
    }, children);
    return hasTextAncestor ? // no need to re-apply context if the text is already wrapped
    component : /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $gHPOa.HasTextAncestorProvider), {
        value: true
    }, component);
});
var $f551475736a55519$export$2e2bcd8739ae039 = $f551475736a55519$var$Text;

});

parcelRegister("bMFGq", function(module, exports) {

$parcel$export(module.exports, "default", () => $bfda2d562793f557$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $2ifdJ = parcelRequire("2ifdJ");

var $4gHTL = parcelRequire("4gHTL");

var $153Gb = parcelRequire("153Gb");
/**
 * __Button__
 *
 * A button triggers an event or action.
 *
 * - [Examples](https://atlassian.design/components/button/examples)
 * - [Code](https://atlassian.design/components/button/code)
 * - [Usage](https://atlassian.design/components/button/usage)
 */ const $bfda2d562793f557$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef(function Button({ analyticsContext: analyticsContext, appearance: appearance, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, autoFocus: autoFocus, children: children, iconAfter: iconAfter, iconBefore: iconBefore, interactionName: interactionName, isDisabled: isDisabled, isLoading: isLoading = false, isSelected: isSelected, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, shouldFitContainer: shouldFitContainer, spacing: spacing, testId: testId, type: type = 'button', ...unsafeRest }, ref) {
    // @ts-expect-error
    const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2ifdJ.default), {
        analyticsContext: analyticsContext,
        ref: ref,
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        hasIconBefore: Boolean(iconBefore),
        hasIconAfter: Boolean(iconAfter),
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        ariaLabel: ariaLabel,
        ariaLabelledBy: ariaLabelledBy,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        testId: testId,
        componentName: "Button",
        type: type,
        interactionName: interactionName,
        ...saferRest,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
            children: [
                iconBefore && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4gHTL.default), {
                    type: "icon",
                    position: "before",
                    isLoading: isLoading,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $153Gb.default), {
                        icon: iconBefore
                    })
                }),
                children && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4gHTL.default), {
                    isLoading: isLoading,
                    children: children
                }),
                iconAfter && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4gHTL.default), {
                    type: "icon",
                    position: "after",
                    isLoading: isLoading,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $153Gb.default), {
                        icon: iconAfter
                    })
                })
            ]
        })
    });
}));
$bfda2d562793f557$var$Button.displayName = 'Button';
var $bfda2d562793f557$export$2e2bcd8739ae039 = $bfda2d562793f557$var$Button;

});

parcelRegister("2SY35", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f45692e8463b006$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $4KSLR = parcelRequire("4KSLR");

var $3a7Um = parcelRequire("3a7Um");
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $5f45692e8463b006$var$svgStyles = /*#__PURE__*/ (0, $f8Sb3.css)((0, $3a7Um.commonSVGStyles));
/**
 * __SVG__
 *
 * An icon is used as a visual representation of common actions and commands to provide context.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-svgs)
 */ const $5f45692e8463b006$var$SVG = /*#__PURE__*/ (0, $5uXOq.memo)(function SVG({ size: size = 'medium', label: label, primaryColor: primaryColor = 'currentColor', secondaryColor: secondaryColor, testId: testId, children: children }) {
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("svg", {
        viewBox: "0 0 24 24",
        style: {
            color: primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            fill: secondaryColor || (0, $4KSLR.getBackground)()
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: [
            $5f45692e8463b006$var$svgStyles,
            (0, $3a7Um.sizeStyleMap)[size]
        ],
        "data-testid": testId,
        "aria-label": label || undefined,
        role: label ? 'img' : 'presentation'
    }, children);
});
var $5f45692e8463b006$export$2e2bcd8739ae039 = $5f45692e8463b006$var$SVG;

});

parcelRegister("gM4B1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::53f91109de7c85ca6ae82f80e81ebfee>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c364b1bf4f226447$var$_react = $c364b1bf4f226447$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c364b1bf4f226447$var$_checkCircle = $c364b1bf4f226447$var$_interopRequireDefault((parcelRequire("buWlV")));

var $c364b1bf4f226447$var$_checkCircle2 = $c364b1bf4f226447$var$_interopRequireDefault((parcelRequire("jDpWv")));
function $c364b1bf4f226447$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CheckCircleIcon.
 * This component is CheckCircleIcon, with `UNSAFE_fallbackIcon` set to "CheckCircleIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: completed items, productivity emoji category. Completed task issue status in JSM Calendar view.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c364b1bf4f226447$var$CheckCircleIcon = (props)=>/*#__PURE__*/ $c364b1bf4f226447$var$_react.default.createElement($c364b1bf4f226447$var$_checkCircle.default, Object.assign({
        LEGACY_fallbackIcon: $c364b1bf4f226447$var$_checkCircle2.default
    }, props));
$c364b1bf4f226447$var$CheckCircleIcon.Name = 'CheckCircleIconMigration';
var $c364b1bf4f226447$var$_default = module.exports.default = $c364b1bf4f226447$var$CheckCircleIcon;

});
parcelRegister("buWlV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::748f85337bfdc39189d1ccb0fbfec926>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $85efc2a9a3041420$var$_react = $85efc2a9a3041420$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $85efc2a9a3041420$var$_baseNew = $85efc2a9a3041420$var$_interopRequireDefault((parcelRequire("enEmH")));
function $85efc2a9a3041420$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: completed items, productivity emoji category. Completed task issue status in JSM Calendar view.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $85efc2a9a3041420$var$CheckCircleIcon = (props)=>/*#__PURE__*/ $85efc2a9a3041420$var$_react.default.createElement($85efc2a9a3041420$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-6.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13m4.326 3.98-5 6a.75.75 0 0 1-1.152 0l-2.5-3 1.152-.96L6.75 9.828l4.424-5.308z" clip-rule="evenodd"/>`
    }, props));
$85efc2a9a3041420$var$CheckCircleIcon.displayName = 'CheckCircleIcon';
var $85efc2a9a3041420$var$_default = module.exports.default = $85efc2a9a3041420$var$CheckCircleIcon;

});


parcelRegister("44cng", function(module, exports) {

$parcel$export(module.exports, "default", () => $2047c5cc7abd90b7$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");

var $ew55A = parcelRequire("ew55A");


var $bKnKN = parcelRequire("bKnKN");

var $1tPGU = parcelRequire("1tPGU");

var $70rf1 = parcelRequire("70rf1");

var $vCqQa = parcelRequire("vCqQa");

var $5KCCi = parcelRequire("5KCCi");

var $lI4Q4 = parcelRequire("lI4Q4");

var $4RXsT = parcelRequire("4RXsT");

var $AD1bq = parcelRequire("AD1bq");

var $67dPA = parcelRequire("67dPA");

var $1Tpnh = parcelRequire("1Tpnh");

var $1XUgS = parcelRequire("1XUgS");

var $i3aMR = parcelRequire("i3aMR");
const $2047c5cc7abd90b7$var$MAX_COUNT = {
    grid: 11,
    stack: 5
};
function $2047c5cc7abd90b7$var$getOverrides(overrides) {
    return {
        AvatarGroupItem: {
            render: (Component, props, index)=>/*#__PURE__*/ (0, $5uXOq.createElement)(Component, {
                    ...props,
                    key: (0, $i3aMR.composeUniqueKey)(props.avatar, index)
                }),
            ...overrides && overrides.AvatarGroupItem
        },
        Avatar: {
            render: (Component, props, index)=>/*#__PURE__*/ (0, $5uXOq.createElement)(Component, {
                    ...props,
                    key: (0, $i3aMR.composeUniqueKey)(props, index)
                }),
            ...overrides && overrides.Avatar
        },
        MoreIndicator: {
            render: (Component, props)=>/*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
                    ...props
                }),
            ...overrides && overrides.MoreIndicator
        }
    };
}
/**
 * __Avatar group__
 *
 * An avatar group displays a number of avatars grouped together in a stack or grid.
 *
 * - [Examples](https://atlassian.design/components/avatar-group/examples)
 * - [Code](https://atlassian.design/components/avatar-group/code)
 * - [Usage](https://atlassian.design/components/avatar-group/usage)
 */ const $2047c5cc7abd90b7$var$AvatarGroup = ({ appearance: appearance = 'stack', avatar: avatar = (0, $ew55A.default), borderColor: borderColor, boundariesElement: boundariesElement, data: data, isTooltipDisabled: isTooltipDisabled, maxCount: maxCount, onAvatarClick: onAvatarClick, onMoreClick: onMoreClick, overrides: overrides, showMoreButtonProps: showMoreButtonProps = {}, size: size = 'medium', testId: testId, label: label = 'avatar group', tooltipPosition: tooltipPosition = 'bottom', shouldPopupRenderToParent: shouldPopupRenderToParent = false })=>{
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $5uXOq.useState)(false);
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const onClose = (0, $5uXOq.useCallback)(()=>setIsOpen(false), []);
    const handleTriggerClicked = (0, $5uXOq.useCallback)((event)=>{
        const { clientX: clientX, clientY: clientY, type: type } = event;
        // Hitting enter/space is registered as a click with both clientX and clientY === 0
        if (type === 'keydown' || clientX === 0 || clientY === 0) setTriggeredUsingKeyboard(true);
        setIsOpen((isOpen)=>!isOpen);
    }, []);
    const { isFocused: isFocused, bindFocus: bindFocus } = (0, $1tPGU.default)();
    // When a trigger is focused, we want to open the popup
    // the user presses the DownArrow
    (0, $5uXOq.useEffect)(()=>{
        // Set initial value if popup is closed
        if (!isOpen) setTriggeredUsingKeyboard(false);
        // Only need to listen for keydown when focused
        if (!isFocused) return 0, $bKnKN.default;
        // Being safe: we don't want to open the popup if it is already open
        // Note: This shouldn't happen as the trigger should not be able to get focus
        if (isOpen) return 0, $bKnKN.default;
        (0, $cBeZP.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                if (e.key === (0, $f13eec7fa1d5338f$export$a80636c6f41931fe)) {
                    // prevent page scroll
                    e.preventDefault();
                    handleTriggerClicked(e);
                }
            }
        });
        const unbind = ()=>{
            (0, $cBeZP.bind)(window, {
                type: 'keydown',
                listener: function openOnKeyDown(e) {
                    if (e.key === (0, $f13eec7fa1d5338f$export$a80636c6f41931fe)) {
                        // prevent page scroll
                        e.preventDefault();
                        handleTriggerClicked(e);
                    }
                }
            });
        };
        return unbind;
    }, [
        isFocused,
        isOpen,
        handleTriggerClicked
    ]);
    function renderMoreDropdown(max, total) {
        if (total <= max) return null;
        const renderMoreButton = ({ 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, onClick: onClick, ...props })=>$2047c5cc7abd90b7$var$getOverrides(overrides).MoreIndicator.render((0, $1Tpnh.default), {
                buttonProps: showMoreButtonProps,
                borderColor: borderColor,
                count: total - max,
                size: size,
                testId: testId && `${testId}--overflow-menu--trigger`,
                isActive: isOpen,
                'aria-controls': ariaControls,
                'aria-expanded': ariaExpanded,
                'aria-haspopup': ariaHasPopup,
                onClick: onClick,
                ...props
            });
        // bail if the consumer wants to handle onClick
        if (typeof onMoreClick === 'function') return renderMoreButton({
            onClick: onMoreClick
        });
        // split boundariesElement into `boundary` and `rootBoundary` props for Popup
        const boundary = boundariesElement === 'scrollParent' ? 'clippingParents' : undefined;
        const rootBoundary = (()=>{
            if (boundariesElement === 'scrollParent') return undefined;
            return boundariesElement === 'window' ? 'document' : 'viewport';
        })();
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $vCqQa.default), {
            isOpen: isOpen,
            onClose: onClose,
            placement: "bottom-end",
            boundary: boundary,
            rootBoundary: rootBoundary,
            shouldFlip: true,
            zIndex: 510,
            shouldRenderToParent: shouldPopupRenderToParent,
            content: ({ setInitialFocusRef: setInitialFocusRef })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $AD1bq.default), {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $67dPA.default), {
                        onClick: (e)=>e.stopPropagation(),
                        minWidth: 250,
                        maxHeight: 300,
                        setInitialFocusRef: isTriggeredUsingKeyboard ? setInitialFocusRef : undefined,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $70rf1.default), {
                            children: data.slice(max).map((avatar, index)=>$2047c5cc7abd90b7$var$getOverrides(overrides).AvatarGroupItem.render((0, $lI4Q4.default), {
                                    avatar: avatar,
                                    onAvatarClick: onAvatarClick,
                                    testId: testId && `${testId}--avatar-group-item-${index + max}`,
                                    index: index + max
                                }, // This index holds the true index,
                                // adding up the index of non-overflowed avatars and overflowed avatars.
                                index + max))
                        })
                    })
                }),
            trigger: (triggerProps)=>renderMoreButton({
                    ...triggerProps,
                    ...bindFocus,
                    onClick: handleTriggerClicked
                }),
            testId: testId && `${testId}--overflow-menu`
        });
    }
    const max = maxCount === undefined || maxCount === 0 ? $2047c5cc7abd90b7$var$MAX_COUNT[appearance] : maxCount;
    const total = data.length;
    const maxAvatar = total > max ? max - 1 : max;
    const Group = appearance === 'stack' ? (0, $1XUgS.default) : (0, $4RXsT.default);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)(Group, {
        testId: testId && `${testId}--avatar-group`,
        "aria-label": label,
        children: [
            data.slice(0, maxAvatar).map((avatarData, idx)=>{
                const callback = avatarData.onClick || onAvatarClick;
                const finalAvatar = $2047c5cc7abd90b7$var$getOverrides(overrides).Avatar.render(avatar, {
                    ...avatarData,
                    size: size,
                    borderColor: borderColor || avatarData.borderColor,
                    testId: testId && `${testId}--avatar-${idx}`,
                    onClick: callback ? (event, analyticsEvent)=>{
                        callback(event, analyticsEvent, idx);
                    } : undefined,
                    stackIndex: max - idx
                }, idx);
                return !isTooltipDisabled && !avatarData.isDisabled ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5KCCi.default), {
                    content: avatarData.name,
                    testId: testId && `${testId}--tooltip-${idx}`,
                    position: tooltipPosition,
                    children: finalAvatar
                }, (0, $i3aMR.composeUniqueKey)(avatarData, idx)) : finalAvatar;
            }),
            renderMoreDropdown(+maxAvatar, total)
        ]
    });
};
var $2047c5cc7abd90b7$export$2e2bcd8739ae039 = $2047c5cc7abd90b7$var$AvatarGroup;

});
parcelRegister("ew55A", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b02343e0e7c3f09$export$2e2bcd8739ae039);
/* avatar.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $bngFq = parcelRequire("bngFq");

var $jJsBW = parcelRequire("jJsBW");

var $cnu9t = parcelRequire("cnu9t");

var $l0Vn1 = parcelRequire("l0Vn1");

var $hlAzS = parcelRequire("hlAzS");

var $4yi9b = parcelRequire("4yi9b");

var $9fzbz = parcelRequire("9fzbz");

var $9dmHS = parcelRequire("9dmHS");
const $3b02343e0e7c3f09$var$packageName = "platform-pkg";
const $3b02343e0e7c3f09$var$packageVersion = "0.0.0-use.local";
const $3b02343e0e7c3f09$var$containerStyles = null; // eslint-disable-next-line @repo/internal/react/consistent-types-definitions
/**
 * __Avatar__
 *
 * An avatar is a visual representation of a user or entity.
 *
 * - [Examples](https://atlassian.design/components/avatar/examples)
 * - [Code](https://atlassian.design/components/avatar/code)
 * - [Usage](https://atlassian.design/components/avatar/usage)
 */ const $3b02343e0e7c3f09$var$Avatar = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ analyticsContext: analyticsContext, appearance: appearance = 'circle', label: label, borderColor: borderColor, children: children, href: href, isDisabled: isDisabled, name: name, onClick: onClick, presence: presence, size: sizeProp, src: src, stackIndex: stackIndex, status: status, target: target, testId: testId, as: AvatarContainer = 'div' }, ref)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const context = (0, $l0Vn1.useAvatarContext)();
    const size = sizeProp || context?.size || 'medium';
    const customPresenceNode = /*#__PURE__*/ (0, $5uXOq.isValidElement)(presence) ? presence : null;
    const customStatusNode = /*#__PURE__*/ (0, $5uXOq.isValidElement)(status) ? status : null;
    const isValidIconSize = size !== 'xxlarge' && size !== 'xsmall';
    const lastAnalytics = (0, $5uXOq.useRef)(analyticsContext);
    const labelId = (0, $jJsBW.useId)();
    (0, $5uXOq.useEffect)(()=>{
        lastAnalytics.current = analyticsContext;
    }, [
        analyticsContext
    ]);
    const onClickHandler = (0, $5uXOq.useCallback)((event)=>{
        if (isDisabled || typeof onClick !== 'function') return;
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'avatar',
            attributes: {
                componentName: 'avatar',
                packageName: $3b02343e0e7c3f09$var$packageName,
                packageVersion: $3b02343e0e7c3f09$var$packageVersion
            }
        }); /**
         * To avoid wrapping this component in AnalyticsContext we manually
         * push the parent context's meta data into the context.
         */ 
        const context = {
            componentName: 'avatar',
            packageName: $3b02343e0e7c3f09$var$packageName,
            packageVersion: $3b02343e0e7c3f09$var$packageVersion,
            ...lastAnalytics.current
        };
        analyticsEvent.context.push(context); /**
                                           * Replicating the logic in the `withAnalyticsEvents` HOC.
                                           */ 
        const clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        onClick(event, analyticsEvent);
    }, [
        createAnalyticsEvent,
        isDisabled,
        onClick
    ]);
    const isPresence = isValidIconSize && presence && !status;
    const isStatus = isValidIconSize && status; // add presence or status to the label by default if presence and status are passed as a string
    // if status or presence are nodes this is not added to the label by default
    const defaultLabel = [
        name,
        isStatus && !customStatusNode && `(${status})`,
        isPresence && !customPresenceNode && `(${presence})`
    ].filter(Boolean).join(' ');
    const isInteractive = onClick || href || isDisabled;
    const containerShouldBeImage = Boolean(!isInteractive && defaultLabel);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l0Vn1.EnsureIsInsideAvatarContext).Provider, {
        value: true,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)(AvatarContainer, {
            "data-testid": testId,
            role: containerShouldBeImage ? 'img' : undefined,
            "aria-labelledby": containerShouldBeImage ? labelId : undefined,
            style: {
                zIndex: stackIndex
            },
            className: (0, $bwpsq.default)([
                "_12ji1r31 _1qu2glyw _12y3idpf _1e0c1o8l _kqswh2mm"
            ]),
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l0Vn1.AvatarContentContext).Provider, {
                    value: {
                        as: (0, $9dmHS.getCustomElement)(isDisabled, href, onClick),
                        appearance: appearance,
                        borderColor: borderColor,
                        href: href,
                        isDisabled: isDisabled,
                        label: label || defaultLabel,
                        onClick: isInteractive ? onClickHandler : undefined,
                        ref: ref,
                        size: size,
                        stackIndex: stackIndex,
                        target: target,
                        testId: testId ? `${testId}--inner` : undefined,
                        avatarImage: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hlAzS.default), {
                            alt: !containerShouldBeImage && src ? name : undefined,
                            src: src,
                            appearance: appearance,
                            size: size,
                            testId: testId
                        })
                    },
                    children: children || /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cnu9t.AvatarContent), {})
                }),
                isPresence && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4yi9b.PresenceWrapper), {
                    appearance: appearance,
                    size: size,
                    presence: typeof presence === 'string' ? presence : undefined,
                    testId: testId,
                    children: customPresenceNode
                }),
                isStatus && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9fzbz.StatusWrapper), {
                    appearance: appearance,
                    size: size,
                    borderColor: borderColor,
                    status: typeof status === 'string' ? status : undefined,
                    testId: testId,
                    children: customStatusNode
                }),
                containerShouldBeImage ? /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                    "data-testid": testId && `${testId}--label`,
                    id: labelId,
                    hidden: true,
                    children: defaultLabel
                }) : undefined
            ]
        })
    });
});
$3b02343e0e7c3f09$var$Avatar.displayName = 'Avatar';
var $3b02343e0e7c3f09$export$2e2bcd8739ae039 = $3b02343e0e7c3f09$var$Avatar;

});
parcelRegister("cnu9t", function(module, exports) {

$parcel$export(module.exports, "AvatarContent", () => $42f07635ce4e2ceb$export$47fbc0b44cae5559);
/* avatar-content.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fHpHg = parcelRequire("fHpHg");

var $l0Vn1 = parcelRequire("l0Vn1");
const $42f07635ce4e2ceb$var$boxShadowCssVar = '--avatar-box-shadow';
const $42f07635ce4e2ceb$var$bgColorCssVar = '--avatar-bg-color';
const $42f07635ce4e2ceb$var$styles = {
    root: "_19itglyw _12ji1r31 _1qu2glyw _12y31o36 _1reo15vq _18m915vq _v564ieh6 _1e0c1txw _kqswpfqs _4cvr1fhb _1bah1h6o _2lx21bp4 _80om1kw7 _6rthv77o _1pfhv77o _12l2v77o _ahbqv77o _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t _t9ec1aqe _9v7aze3t _qc5o1p41 _z0ai1osq _18postnw _1hfk18uv _aetrf705 _1peqidpf _11fnglyw _1ejjglyw _mizu194a _1ah3v77o _ra3xnqa1 _128m1bk5 _4dave4h9",
    circle: "_2rko1q5u _14mj1q5u",
    positionRelative: "_kqswh2mm",
    disabled: "_80om13gf _1hfkvuon _1peqs237"
};
const $42f07635ce4e2ceb$var$unboundStyles = {
    root: "_vchh18uv _bfhkcxp3 _16qs1nhn",
    interactive: "_80omtlke _4tpuw83z _ez1ykb7n _gcm11et6 _eeh8kb7n _jlxit94y"
};
const $42f07635ce4e2ceb$var$widthHeightMap = {
    xsmall: "_1bsb7vkz _4t3i7vkz",
    small: "_1bsb1tcg _4t3i1tcg",
    medium: "_1bsbzwfg _4t3izwfg",
    large: "_1bsb1ylp _4t3i1ylp",
    xlarge: "_1bsb16xz _4t3i16xz",
    xxlarge: "_1bsb1qr7 _4t3i1qr7"
};
const $42f07635ce4e2ceb$var$borderRadiusMap = {
    xsmall: "_2rkoyh40 _14mjyh40",
    small: "_2rkoyh40 _14mjyh40",
    medium: "_2rko1l7b _14mj1l7b",
    large: "_2rko1l7b _14mj1l7b",
    xlarge: "_2rkoi2wt _14mji2wt",
    xxlarge: "_2rko1crf _14mj1crf"
};
const $42f07635ce4e2ceb$export$47fbc0b44cae5559 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children }, ref)=>{
    (0, $l0Vn1.useEnsureIsInsideAvatar)();
    const { as: Container, appearance: appearance, avatarImage: avatarImage, borderColor: // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    borderColor = (0, $fHpHg.fg)('platform-component-visual-refresh') ? "var(--ds-surface, #FFFFFF)" : "var(--ds-surface-overlay, #FFFFFF)", href: href, isDisabled: isDisabled, label: label, onClick: onClick, ref: contextRef, tabIndex: tabIndex, target: target, testId: testId, size: size, stackIndex: stackIndex } = (0, $l0Vn1.useAvatarContent)();
    const isInteractive = Boolean(onClick || href || isDisabled);
    return /*#__PURE__*/ (0, $2OMIu.jsx)(Container, {
        style: {
            [$42f07635ce4e2ceb$var$bgColorCssVar]: borderColor,
            [$42f07635ce4e2ceb$var$boxShadowCssVar]: `0 0 0 2px ${borderColor}`
        },
        ref: ref || contextRef,
        "aria-label": isInteractive ? label : undefined,
        onClick: onClick,
        tabIndex: tabIndex,
        "data-testid": testId,
        disabled: isDisabled,
        type: Container === 'button' ? 'button' : undefined,
        ...href && {
            href: href,
            target: target,
            rel: target === '_blank' ? 'noopener noreferrer' : undefined
        },
        className: (0, $bwpsq.default)([
            $42f07635ce4e2ceb$var$unboundStyles.root,
            $42f07635ce4e2ceb$var$styles.root,
            $42f07635ce4e2ceb$var$borderRadiusMap[size],
            appearance === 'circle' && $42f07635ce4e2ceb$var$styles.circle,
            $42f07635ce4e2ceb$var$widthHeightMap[size],
            stackIndex !== undefined && $42f07635ce4e2ceb$var$styles.positionRelative,
            isInteractive && !isDisabled && $42f07635ce4e2ceb$var$unboundStyles.interactive,
            isDisabled && $42f07635ce4e2ceb$var$styles.disabled
        ]),
        children: children || avatarImage
    });
});

});
parcelRegister("l0Vn1", function(module, exports) {

$parcel$export(module.exports, "AvatarContext", () => $0ac4d643d98df6be$export$a20dad690e1279e2);
$parcel$export(module.exports, "useAvatarContext", () => $0ac4d643d98df6be$export$b50b87a1c4086b23);
$parcel$export(module.exports, "AvatarContentContext", () => $0ac4d643d98df6be$export$b983474ddd0b6d28);
$parcel$export(module.exports, "useAvatarContent", () => $0ac4d643d98df6be$export$79d078b69b7e4842);
$parcel$export(module.exports, "EnsureIsInsideAvatarContext", () => $0ac4d643d98df6be$export$6b4cbd90d24955ad);
$parcel$export(module.exports, "useEnsureIsInsideAvatar", () => $0ac4d643d98df6be$export$7db5c57474082dd9);

var $5uXOq = parcelRequire("5uXOq");
const $0ac4d643d98df6be$export$a20dad690e1279e2 = /*#__PURE__*/ (0, $5uXOq.createContext)(undefined);
const $0ac4d643d98df6be$export$b50b87a1c4086b23 = ()=>(0, $5uXOq.useContext)($0ac4d643d98df6be$export$a20dad690e1279e2);
const $0ac4d643d98df6be$var$defaultAvatarContentProps = {
    as: 'span',
    appearance: 'circle',
    avatarImage: null,
    ref: null,
    size: 'medium'
};
const $0ac4d643d98df6be$export$b983474ddd0b6d28 = /*#__PURE__*/ (0, $5uXOq.createContext)($0ac4d643d98df6be$var$defaultAvatarContentProps);
const $0ac4d643d98df6be$export$79d078b69b7e4842 = ()=>(0, $5uXOq.useContext)($0ac4d643d98df6be$export$b983474ddd0b6d28);
const $0ac4d643d98df6be$export$6b4cbd90d24955ad = /*#__PURE__*/ (0, $5uXOq.createContext)(false);
const $0ac4d643d98df6be$export$7db5c57474082dd9 = ()=>{
    const context = (0, $5uXOq.useContext)($0ac4d643d98df6be$export$6b4cbd90d24955ad);
    if (!context) throw new Error('Avatar sub-components must be used within a Avatar component.');
};

});


parcelRegister("hlAzS", function(module, exports) {

$parcel$export(module.exports, "default", () => $0479aaf5cb1f8744$export$2e2bcd8739ae039);
/* avatar-image.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $g8n3v = parcelRequire("g8n3v");

var $2MieS = parcelRequire("2MieS");

var $3cwUp = parcelRequire("3cwUp");

var $6rsly = parcelRequire("6rsly");

var $fHpHg = parcelRequire("fHpHg");

const $0479aaf5cb1f8744$var$styles = {
    image: "_16jlkb7n _1o9zkb7n _i0dl1osq _1e0c1txw _1bsb1osq _4t3i1osq",
    icon: "_1e0c1txw _1bsb1osq _4t3i1osq",
    iconBg: "_bfhkr4aa",
    iconBGVisualRefresh: "_bfhk1v33",
    circle: "_2rko1q5u"
};
const $0479aaf5cb1f8744$var$borderRadiusMap = {
    xsmall: "_2rkogqwt",
    small: "_2rkogqwt",
    medium: "_2rko1l7b",
    large: "_2rko1l7b",
    xlarge: "_2rkoi2wt",
    xxlarge: "_2rkob7nn"
};
const $0479aaf5cb1f8744$var$nestedSvgStylesMap = {
    xsmall: "_w8l57vkz _17527vkz",
    small: "_w8l51tcg _17521tcg",
    medium: "_w8l5zwfg _1752zwfg",
    large: "_w8l51ylp _17521ylp",
    xlarge: "_w8l516xz _175216xz",
    xxlarge: "_w8l51qr7 _17521qr7"
};
/**
 * __Avatar image__
 *
 * An avatar image is an internal component used to control the rendering phases of an image.
 */ const $0479aaf5cb1f8744$var$AvatarImage = ({ alt: alt = '', src: src, appearance: appearance, size: size, testId: testId })=>{
    const [hasImageErrored, setHasImageErrored] = (0, $5uXOq.useState)(false);
    // If src changes, reset state
    (0, $5uXOq.useEffect)(()=>{
        setHasImageErrored(false);
    }, [
        src
    ]);
    if (!src || hasImageErrored) return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        className: (0, $bwpsq.default)([
            $0479aaf5cb1f8744$var$styles.icon,
            (0, $fHpHg.fg)('platform-component-visual-refresh') ? $0479aaf5cb1f8744$var$styles.iconBGVisualRefresh : $0479aaf5cb1f8744$var$styles.iconBg,
            $0479aaf5cb1f8744$var$nestedSvgStylesMap[size]
        ]),
        children: appearance === 'circle' ? (0, $fHpHg.fg)('platform-component-visual-refresh') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3cwUp))), {
            label: alt,
            color: "var(--ds-icon-subtle, #626F86)",
            testId: testId && `${testId}--person`,
            spacing: "spacious"
        }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($g8n3v))), {
            label: alt,
            color: `var(--ds-icon-inverse, ${(0, $a7f8c6b391092279$export$29a4f05edc054374)})`,
            LEGACY_secondaryColor: `var(--ds-icon-subtle, ${(0, $a7f8c6b391092279$export$7c87d337fb91a97d)})`,
            testId: testId && `${testId}--person`,
            spacing: "spacious"
        }) : (0, $fHpHg.fg)('platform-component-visual-refresh') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6rsly))), {
            label: alt,
            color: "var(--ds-icon-subtle, #626F86)",
            testId: testId && `${testId}--ship`,
            spacing: "spacious"
        }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2MieS))), {
            label: alt,
            color: `var(--ds-icon-inverse, ${(0, $a7f8c6b391092279$export$29a4f05edc054374)})`,
            LEGACY_secondaryColor: `var(--ds-icon-subtle, ${(0, $a7f8c6b391092279$export$7c87d337fb91a97d)})`,
            testId: testId && `${testId}--ship`,
            spacing: "spacious"
        })
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("img", {
        src: src,
        alt: alt,
        "data-testid": testId && `${testId}--image`,
        onError: ()=>setHasImageErrored(true),
        "aria-hidden": !alt ? true : undefined,
        "data-vc": testId ? `${testId}--image` : 'avatar-image',
        "data-ssr-placeholder-ignored": true,
        className: (0, $bwpsq.default)([
            $0479aaf5cb1f8744$var$styles.image,
            $0479aaf5cb1f8744$var$borderRadiusMap[size],
            appearance === 'circle' && $0479aaf5cb1f8744$var$styles.circle
        ])
    });
};
var $0479aaf5cb1f8744$export$2e2bcd8739ae039 = $0479aaf5cb1f8744$var$AvatarImage;

});
parcelRegister("g8n3v", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::325d0bc066f2b42d61e7c5ff0e093014>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bbef4706c0a033bf$var$_react = $bbef4706c0a033bf$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $bbef4706c0a033bf$var$_person = $bbef4706c0a033bf$var$_interopRequireDefault((parcelRequire("3cwUp")));

var $bbef4706c0a033bf$var$_person2 = $bbef4706c0a033bf$var$_interopRequireDefault((parcelRequire("akQrW")));
function $bbef4706c0a033bf$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for PersonIcon.
 * This component is PersonIcon, with `UNSAFE_fallbackIcon` set to "PersonIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a person or user, owner, contributor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bbef4706c0a033bf$var$PersonIcon = (props)=>/*#__PURE__*/ $bbef4706c0a033bf$var$_react.default.createElement($bbef4706c0a033bf$var$_person.default, Object.assign({
        LEGACY_fallbackIcon: $bbef4706c0a033bf$var$_person2.default
    }, props));
$bbef4706c0a033bf$var$PersonIcon.Name = 'PersonIconMigration';
var $bbef4706c0a033bf$var$_default = module.exports.default = $bbef4706c0a033bf$var$PersonIcon;

});

parcelRegister("2MieS", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::df09611fb9f343ce3ed015b37269b5a3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $205e365418f7c963$var$_react = $205e365418f7c963$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $205e365418f7c963$var$_release = $205e365418f7c963$var$_interopRequireDefault((parcelRequire("6rsly")));

var $205e365418f7c963$var$_ship = $205e365418f7c963$var$_interopRequireDefault((parcelRequire("flOXi")));
function $205e365418f7c963$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ReleaseIcon.
 * This component is ReleaseIcon, with `UNSAFE_fallbackIcon` set to "ShipIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for releases in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $205e365418f7c963$var$ReleaseIcon = (props)=>/*#__PURE__*/ $205e365418f7c963$var$_react.default.createElement($205e365418f7c963$var$_release.default, Object.assign({
        LEGACY_fallbackIcon: $205e365418f7c963$var$_ship.default
    }, props));
$205e365418f7c963$var$ReleaseIcon.Name = 'ReleaseIconMigration';
var $205e365418f7c963$var$_default = module.exports.default = $205e365418f7c963$var$ReleaseIcon;

});


parcelRegister("4yi9b", function(module, exports) {

$parcel$export(module.exports, "PresenceWrapper", () => $071c2be27f0d279a$export$972c5e90200fa0ef);
/* presence.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");


var $kNRZz = parcelRequire("kNRZz");
const $071c2be27f0d279a$var$BusyIndicator = /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
    children: [
        /*#__PURE__*/ (0, $2OMIu.jsx)("circle", {
            fill: `var(--ds-icon-danger, ${(0, $a7f8c6b391092279$export$4a7404f376229999)})`,
            cx: "4",
            cy: "4",
            r: "4"
        }),
        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            fill: `var(--ds-surface-overlay, ${(0, $a7f8c6b391092279$export$29a4f05edc054374)})`,
            d: "M3.3,1.9l2.8,2.8c0.2,0.2,0.2,0.5,0,0.7L5.4,6.1c-0.2,0.2-0.5,0.2-0.7,0L1.9,3.3c-0.2-0.2-0.2-0.5,0-0.7l0.7-0.7C2.8,1.7,3.1,1.7,3.3,1.9z"
        })
    ]
});
const $071c2be27f0d279a$var$FocusIndicator = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Fragment), {
    children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
        fill: `var(--ds-icon-discovery, ${(0, $a7f8c6b391092279$export$b48405b95304b5a1)})`,
        d: "M4,8 C1.790861,8 0,6.209139 0,4 C0,1.790861 1.790861,0 4,0 C6.209139,0 8,1.790861 8,4 C8,6.209139 6.209139,8 4,8 Z M4,6.66666667 C5.47275933,6.66666667 6.66666667,5.47275933 6.66666667,4 C6.66666667,2.52724067 5.47275933,1.33333333 4,1.33333333 C2.52724067,1.33333333 1.33333333,2.52724067 1.33333333,4 C1.33333333,5.47275933 2.52724067,6.66666667 4,6.66666667 Z M4,5.33333333 C3.26362033,5.33333333 2.66666667,4.73637967 2.66666667,4 C2.66666667,3.26362033 3.26362033,2.66666667 4,2.66666667 C4.73637967,2.66666667 5.33333333,3.26362033 5.33333333,4 C5.33333333,4.73637967 4.73637967,5.33333333 4,5.33333333 Z"
    })
});
const $071c2be27f0d279a$var$OfflineIndicator = /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
    children: [
        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            fill: `var(--ds-text-subtlest, ${(0, $a7f8c6b391092279$export$f563ee71e9ee74cd)})`,
            d: "M4,8 C6.209139,8 8,6.209139 8,4 C8,1.790861 6.209139,0 4,0 C1.790861,0 0,1.790861 0,4 C0,6.209139 1.790861,8 4,8 Z M4,6 C5.1045695,6 6,5.1045695 6,4 C6,2.8954305 5.1045695,2 4,2 C2.8954305,2 2,2.8954305 2,4 C2,5.1045695 2.8954305,6 4,6 Z"
        }),
        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            fill: `var(--ds-surface-overlay, ${(0, $a7f8c6b391092279$export$1ce2d1575d444ceb)})`,
            d: "M4,6 C5.1045695,6 6,5.1045695 6,4 C6,2.8954305 5.1045695,2 4,2 C2.8954305,2 2,2.8954305 2,4 C2,5.1045695 2.8954305,6 4,6 Z"
        })
    ]
});
const $071c2be27f0d279a$var$OnlineIndicator = /*#__PURE__*/ (0, $2OMIu.jsx)("circle", {
    fill: `var(--ds-icon-success, ${(0, $a7f8c6b391092279$export$940e1f69e873f202)})`,
    cx: "4",
    cy: "4",
    r: "4"
});
function $071c2be27f0d279a$var$getPresence(presence) {
    switch(presence){
        case 'busy':
            return $071c2be27f0d279a$var$BusyIndicator;
        case 'focus':
            return $071c2be27f0d279a$var$FocusIndicator;
        case 'offline':
            return $071c2be27f0d279a$var$OfflineIndicator;
        case 'online':
            return $071c2be27f0d279a$var$OnlineIndicator;
    }
}
/**
 * __Avatar presence__
 *
 * A presence shows an avatar’s availability.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-presence/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-presence/code)
 * - [Usage](https://atlassian.design/components/avatar/avatar-presence/usage)
 */ const $071c2be27f0d279a$var$AvatarPresence = ({ borderColor: borderColor, children: children, presence: presence })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $kNRZz.default), {
        bgColor: borderColor,
        children: presence ? /*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
            height: "100%",
            version: "1.1",
            viewBox: "0 0 8 8",
            width: "100%",
            xmlns: "http://www.w3.org/2000/svg",
            children: $071c2be27f0d279a$var$getPresence(presence)
        }) : children
    });
var $071c2be27f0d279a$export$2e2bcd8739ae039 = $071c2be27f0d279a$var$AvatarPresence;
const $071c2be27f0d279a$var$styles = {
    root: "_kqswstnw _lcxvglyw"
};
const $071c2be27f0d279a$var$iconSizeMap = {
    small: "_4t3i1crf _1bsb1crf",
    medium: "_4t3idlk8 _1bsbdlk8",
    large: "_4t3io7ao _1bsbo7ao",
    xlarge: "_4t3if6fq _1bsbf6fq"
};
const $071c2be27f0d279a$var$iconOffsetMap = {
    square: "_94n5myb0 _1xi2myb0",
    small: "_94n5idpf _1xi2idpf",
    medium: "_94n5idpf _1xi2idpf",
    large: "_94n5t94y _1xi2t94y",
    xlarge: "_94n51v6z _1xi21v6z"
};
const $071c2be27f0d279a$export$972c5e90200fa0ef = ({ size: size, appearance: appearance, children: children, borderColor: borderColor, presence: presence, testId: testId })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "aria-hidden": "true",
        "data-testid": testId && `${testId}--presence`,
        className: (0, $bwpsq.default)([
            $071c2be27f0d279a$var$styles.root,
            $071c2be27f0d279a$var$iconSizeMap[size],
            $071c2be27f0d279a$var$iconOffsetMap[size],
            appearance === 'square' && $071c2be27f0d279a$var$iconOffsetMap['square']
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($071c2be27f0d279a$var$AvatarPresence, {
            borderColor: borderColor,
            presence: !children ? presence : undefined,
            children: children
        })
    });
};

});
parcelRegister("kNRZz", function(module, exports) {

$parcel$export(module.exports, "default", () => $2096007a0dca6f35$export$2e2bcd8739ae039);
/* icon-wrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $2096007a0dca6f35$var$styles = {
    root: "_2rko1q5u _1reo15vq _18m915vq _189e1bk5 _1dqonqa1 _1e0c1txw _vchhusvi _1bsb1osq _4t3i1osq _4cvr1h6o _ae4v1h6o _bfhk1bhr"
};
const $2096007a0dca6f35$var$unboundStyles = {
    root: "_1h6d1bhr"
};
/**
 * __Icon wrapper__
 *
 * An icon wrapper is used internally only.
 */ const $2096007a0dca6f35$var$IconWrapper = ({ bgColor: bgColor, children: children })=>/*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        role: "presentation",
        style: {
            borderColor: bgColor,
            backgroundColor: bgColor
        },
        className: (0, $bwpsq.default)([
            $2096007a0dca6f35$var$styles.root,
            $2096007a0dca6f35$var$unboundStyles.root
        ]),
        children: children
    });
var $2096007a0dca6f35$export$2e2bcd8739ae039 = $2096007a0dca6f35$var$IconWrapper;

});


parcelRegister("9fzbz", function(module, exports) {

$parcel$export(module.exports, "StatusWrapper", () => $1f36c6553d0ba5df$export$8045894f255f9726);
/* status.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");


var $kNRZz = parcelRequire("kNRZz");
const $1f36c6553d0ba5df$var$styles = {
    root: "_kqswstnw"
};
const $1f36c6553d0ba5df$var$iconSizeMap = {
    small: "_4t3i1crf _1bsb1crf",
    medium: "_4t3idlk8 _1bsbdlk8",
    large: "_4t3io7ao _1bsbo7ao",
    xlarge: "_4t3if6fq _1bsbf6fq"
};
const $1f36c6553d0ba5df$var$iconOffsetMap = {
    square: "_1xi2idpf _154iidpf",
    small: "_1xi2idpf _154iidpf",
    medium: "_1xi2idpf _154iidpf",
    large: "_1xi2t94y _154it94y",
    xlarge: "_1xi21v6z _154i1v6z"
};
const $1f36c6553d0ba5df$var$ApprovedIndicator = /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
    children: [
        /*#__PURE__*/ (0, $2OMIu.jsx)("circle", {
            fill: `var(--ds-icon-success, ${(0, $a7f8c6b391092279$export$a49394138f7b8e85)})`,
            cx: "4",
            cy: "4",
            r: "4"
        }),
        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            fill: `var(--ds-surface-overlay, ${(0, $a7f8c6b391092279$export$29a4f05edc054374)})`,
            d: "M2.47140452,3.52859548 C2.21105499,3.26824595 1.78894501,3.26824595 1.52859548,3.52859548 C1.26824595,3.78894501 1.26824595,4.21105499 1.52859548,4.47140452 L2.86192881,5.80473785 C3.12227834,6.06508738 3.54438833,6.06508738 3.80473785,5.80473785 L6.47140452,3.13807119 C6.73175405,2.87772166 6.73175405,2.45561167 6.47140452,2.19526215 C6.21105499,1.93491262 5.78894501,1.93491262 5.52859548,2.19526215 L3.33333333,4.39052429 L2.47140452,3.52859548 Z"
        })
    ]
});
const $1f36c6553d0ba5df$var$DeclinedIndicator = /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
    children: [
        /*#__PURE__*/ (0, $2OMIu.jsx)("circle", {
            fill: `var(--ds-icon-danger, ${(0, $a7f8c6b391092279$export$2010d0fb4295b346)})`,
            cx: "4",
            cy: "4",
            r: "4"
        }),
        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            fill: `var(--ds-surface-overlay, ${(0, $a7f8c6b391092279$export$29a4f05edc054374)})`,
            d: "M4.890661,4.0088336 L5.81806461,3.07802178 C6.06167933,2.83351177 6.06048933,2.43826992 5.81540668,2.19522442 C5.57032402,1.95217891 5.17415651,1.95336612 4.93054179,2.19787613 L4.00765946,3.12415007 L3.06906871,2.18377143 C2.82523777,1.93947602 2.42906937,1.93863765 2.18420182,2.18189887 C1.93933427,2.42516008 1.93849394,2.82040282 2.18232488,3.06469822 L3.12544091,4.00961077 L2.20275024,4.93569234 C1.95913552,5.18020236 1.96032551,5.5754442 2.20540817,5.81848971 C2.45049083,6.06153521 2.84665833,6.060348 3.09027306,5.81583799 L4.00844245,4.89429431 L4.9092123,5.79678001 C5.15304324,6.04107541 5.54921164,6.04191379 5.79407919,5.79865257 C6.03894674,5.55539135 6.03978708,5.16014862 5.79595614,4.91585321 L4.890661,4.0088336 Z"
        })
    ]
});
const $1f36c6553d0ba5df$var$LockedIndicator = /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
    children: [
        /*#__PURE__*/ (0, $2OMIu.jsx)("circle", {
            fill: `var(--ds-text-subtlest, ${(0, $a7f8c6b391092279$export$1ce2d1575d444ceb)})`,
            cx: "4",
            cy: "4",
            r: "4"
        }),
        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            fill: `var(--ds-surface-overlay, ${(0, $a7f8c6b391092279$export$c39c0fe0f26207ae)})`,
            d: "M4.13074827,1.21766493 L4.10368158,1.21766493 C3.36340745,1.21766493 2.76388015,1.80793503 2.76388015,2.5367787 L2.76388015,3.21632216 L3.44054754,3.21632216 L3.44054754,2.54344089 C3.44054754,2.17901906 3.74031119,1.88388401 4.11044825,1.88388401 L4.1239816,1.88388401 C4.49411866,1.88388401 4.79388232,2.17901906 4.79388232,2.54344089 L4.79388232,3.21632216 L5.47054971,3.21632216 L5.47054971,2.5367787 C5.47054971,1.80793503 4.8710224,1.21766493 4.13074827,1.21766493 M2.76388015,3.21632216 L3.44054754,3.21632216 L3.44054754,3.88254123 L2.76388015,3.88254123 L2.76388015,3.21632216 Z M4.79388232,3.21632216 L5.47054971,3.21632216 L5.47054971,3.88254123 L4.79388232,3.88254123 L4.79388232,3.21632216 Z M4.79401765,3.88254123 L3.44068287,3.88254123 L2.76401548,3.88254123 C2.39049508,3.88254123 2.08734809,4.18100738 2.08734809,4.54876031 L2.08734809,5.54808892 C2.08734809,6.10000287 2.53735205,6.54741753 3.09094491,6.54741753 L5.14375561,6.54741753 C5.69802683,6.54741753 6.14735243,6.10385072 6.14735243,5.54808892 L6.14735243,4.54876031 C6.14735243,4.18100738 5.84420544,3.88254123 5.47068504,3.88254123 L4.79401765,3.88254123 Z"
        })
    ]
});
function $1f36c6553d0ba5df$var$getStatus(status) {
    switch(status){
        case 'approved':
            return $1f36c6553d0ba5df$var$ApprovedIndicator;
        case 'declined':
            return $1f36c6553d0ba5df$var$DeclinedIndicator;
        case 'locked':
            return $1f36c6553d0ba5df$var$LockedIndicator;
    }
}
/**
 * __Avatar status__
 *
 * An avatar status shows contextual information, such as if someone approves or declines something.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-status/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-status/code)
 */ const $1f36c6553d0ba5df$var$AvatarStatus = ({ borderColor: borderColor, children: children, status: status })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $kNRZz.default), {
        bgColor: borderColor,
        children: status ? /*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
            height: "100%",
            version: "1.1",
            viewBox: "0 0 8 8",
            width: "100%",
            xmlns: "http://www.w3.org/2000/svg",
            children: $1f36c6553d0ba5df$var$getStatus(status)
        }) : children
    });
var $1f36c6553d0ba5df$export$2e2bcd8739ae039 = $1f36c6553d0ba5df$var$AvatarStatus;
const $1f36c6553d0ba5df$export$8045894f255f9726 = ({ size: size, status: status, appearance: appearance, borderColor: borderColor, children: children, testId: testId })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "aria-hidden": "true",
        "data-testid": testId && `${testId}--status`,
        className: (0, $bwpsq.default)([
            $1f36c6553d0ba5df$var$styles.root,
            $1f36c6553d0ba5df$var$iconSizeMap[size],
            $1f36c6553d0ba5df$var$iconOffsetMap[size],
            appearance === 'square' && $1f36c6553d0ba5df$var$iconOffsetMap['square']
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($1f36c6553d0ba5df$var$AvatarStatus, {
            borderColor: borderColor,
            status: !children ? status : undefined,
            children: children
        })
    });
};

});

parcelRegister("9dmHS", function(module, exports) {

$parcel$export(module.exports, "getCustomElement", () => $a27aeeb81006f23d$export$83ee468102cdf04c);
const $a27aeeb81006f23d$export$83ee468102cdf04c = (isDisabled, href, onClick)=>{
    if (href && !isDisabled) return 'a';
    if (onClick || isDisabled) return 'button';
    return 'span';
};

});


parcelRegister("1tPGU", function(module, exports) {

$parcel$export(module.exports, "default", () => $e9381934060f0f43$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $e9381934060f0f43$export$2e2bcd8739ae039() {
    const [isFocused, setIsFocused] = (0, $5uXOq.useState)(false);
    // ensure bindFocus has a stable ref
    const bindFocus = (0, $5uXOq.useRef)({
        onFocus: ()=>setIsFocused(true),
        onBlur: ()=>setIsFocused(false)
    });
    (0, $5uXOq.useEffect)(()=>{
        // handle the case where a component might
        // unmount while being focused.
        return ()=>setIsFocused(false);
    }, []);
    return {
        isFocused: isFocused,
        bindFocus: bindFocus.current
    };
}

});

parcelRegister("70rf1", function(module, exports) {

$parcel$export(module.exports, "default", () => $f753fc0df0511587$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $lGEY5 = parcelRequire("lGEY5");


var $d6a7c = parcelRequire("d6a7c");
function $f753fc0df0511587$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $f753fc0df0511587$var$gridSize = 8;
const $f753fc0df0511587$var$itemHeadingTopMargin = $f753fc0df0511587$var$gridSize * 2.5;
const $f753fc0df0511587$var$itemHeadingBottomMargin = $f753fc0df0511587$var$gridSize * 0.75;
// Skeleton content is slightly shorter than the real content.
// Because of that we slightly increase the top margin to offset this so the
// containing size both real and skeleton always equal approx 30px.
const $f753fc0df0511587$var$itemHeadingContentHeight = 16; // Originally headingSizes.h100.lineHeight from '@atlaskit/theme/typography'
const $f753fc0df0511587$var$skeletonHeadingHeight = $f753fc0df0511587$var$gridSize;
const $f753fc0df0511587$var$skeletonHeadingMarginOffset = 3;
const $f753fc0df0511587$var$skeletonHeadingTopMargin = $f753fc0df0511587$var$itemHeadingTopMargin + ($f753fc0df0511587$var$itemHeadingContentHeight - $f753fc0df0511587$var$skeletonHeadingHeight) - $f753fc0df0511587$var$skeletonHeadingMarginOffset;
// We want to move the entire body up by 3px without affecting the height of the skeleton container.
const $f753fc0df0511587$var$skeletonHeadingBottomMargin = $f753fc0df0511587$var$itemHeadingBottomMargin + $f753fc0df0511587$var$skeletonHeadingMarginOffset;
const $f753fc0df0511587$var$sectionPaddingTopBottom = $f753fc0df0511587$var$gridSize * 0.75;
const $f753fc0df0511587$var$VAR_SEPARATOR_COLOR = '--ds-menu-seperator-color';
const $f753fc0df0511587$var$sectionStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    '&::before, &::after': {
        display: 'block',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: $f753fc0df0511587$var$sectionPaddingTopBottom,
        content: '""'
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& [data-ds--menu--heading-item]': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        marginBlockEnd: $f753fc0df0511587$var$itemHeadingBottomMargin,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        marginBlockStart: $f753fc0df0511587$var$itemHeadingTopMargin,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:first-of-type': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            marginBlockStart: $f753fc0df0511587$var$itemHeadingTopMargin - $f753fc0df0511587$var$sectionPaddingTopBottom
        }
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& [data-ds--menu--skeleton-heading-item]': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        marginBlockEnd: $f753fc0df0511587$var$skeletonHeadingBottomMargin,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        marginBlockStart: $f753fc0df0511587$var$skeletonHeadingTopMargin,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:first-of-type': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            marginBlockStart: $f753fc0df0511587$var$skeletonHeadingTopMargin - $f753fc0df0511587$var$sectionPaddingTopBottom
        }
    },
    '&:focus': {
        // NOTE: Firefox allows elements that have "overflow: auto" to gain focus (as if it had tab-index="0")
        // We have made a deliberate choice to leave this behaviour as is.
        // This makes the outline go inside by 1px so it can actually be displayed
        // else it gets cut off from the overflow: scroll from the parent menu group.
        outlineOffset: -1
    }
});
const $f753fc0df0511587$var$scrollableStyles = {
    name: "qji62u",
    styles: "flex-shrink:1;overflow:auto"
};
const $f753fc0df0511587$var$unscrollableStyles = {
    name: "ozd7xs",
    styles: "flex-shrink:0"
};
const $f753fc0df0511587$var$thinSeparatorStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    borderBlockStart: `1px solid var(${$f753fc0df0511587$var$VAR_SEPARATOR_COLOR}, ${`var(--ds-border, ${(0, $a7f8c6b391092279$export$920c0d5c49070351)})`})`
});
const $f753fc0df0511587$var$noSeparatorStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // this is to ensure that adjacent sections without separators don't get additional margins.
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '[data-section] + &': {
        marginBlockStart: -6
    }
});
/**
 * __Section__
 *
 * A section includes related actions or items in a menu.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/section)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ const $f753fc0df0511587$var$Section = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, overrides: overrides, title: title, titleId: titleId, testId: testId, isScrollable: isScrollable, hasSeparator: hasSeparator, id: id, isList: isList = false, // Although this isn't defined on props it is available because we've used
// Spread props below and on the jsx element. To forcibly block usage I've
// picked it out and supressed the expected type error.
// @ts-expect-error
className: UNSAFE_className, ...rest }, ref)=>{
    (0, $lGEY5.propDeprecationWarning)("platform-pkg", 'overrides', overrides !== undefined, '' // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    const UNSAFE_headingOverrides = overrides && overrides.HeadingItem && overrides.HeadingItem.cssFn;
    const content = isList ? /*#__PURE__*/ (0, $f8Sb3.jsx)("ul", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            margin: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            padding: 0
        }
    }, (0, $5uXOq.Children).map((0, $5uXOq.Children).toArray(children), (child, index)=>/*#__PURE__*/ (0, $f8Sb3.jsx)("li", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                listStyleType: 'none',
                margin: 0,
                padding: 0
            },
            key: index
        }, child))) : children;
    const childrenMarkup = title !== undefined ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $d6a7c.default), {
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        cssFn: UNSAFE_headingOverrides,
        testId: testId && `${testId}--heading`,
        "aria-hidden": true
    }, title), content) : /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, content);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...rest,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: UNSAFE_className,
        id: id,
        // NOTE: Firefox allows elements that have "overflow: auto" to gain focus (as if it had tab-index="0")
        // We have made a deliberate choice to leave this behaviour as is.
        css: [
            $f753fc0df0511587$var$sectionStyles,
            isScrollable ? $f753fc0df0511587$var$scrollableStyles : $f753fc0df0511587$var$unscrollableStyles,
            hasSeparator ? $f753fc0df0511587$var$thinSeparatorStyles : $f753fc0df0511587$var$noSeparatorStyles
        ],
        "aria-label": title,
        "aria-labelledby": titleId,
        "data-testid": testId,
        role: "group",
        "data-section": true,
        ref: ref
    }, childrenMarkup);
});
var $f753fc0df0511587$export$2e2bcd8739ae039 = $f753fc0df0511587$var$Section;

});
parcelRegister("d6a7c", function(module, exports) {

$parcel$export(module.exports, "default", () => $a2108c8482b7ae8f$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $lGEY5 = parcelRequire("lGEY5");

var $bKnKN = parcelRequire("bKnKN");

const $a2108c8482b7ae8f$var$headingStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    color: `var(--ds-text-subtle, ${(0, $a7f8c6b391092279$export$e2ef2124cf4024b1)})`,
    font: "var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    paddingBlock: "var(--ds-space-0, 0px)",
    paddingInline: "var(--ds-space-200, 16px)"
});
/**
 * __Heading item__
 *
 * A heading item is used to describe sibling menu items.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/heading-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ const $a2108c8482b7ae8f$var$HeadingItem = /*#__PURE__*/ (0, $5uXOq.memo)(({ children: children, testId: testId, headingLevel: headingLevel = 2, id: id, cssFn: cssFn = (0, $bKnKN.default), // Although this isn't defined on props it is available because we've used
// Spread props below and on the jsx element. To forcibly block usage I've
// picked it out and supressed the expected type error.
// @ts-expect-error
className: UNSAFE_className, ...rest })=>{
    (0, $lGEY5.propDeprecationWarning)("platform-pkg", 'cssFn', cssFn !== (0, $bKnKN.default), '' // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    const UNSAFE_overrides = /*#__PURE__*/ (0, $f8Sb3.css)(cssFn(undefined));
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            $a2108c8482b7ae8f$var$headingStyles,
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            UNSAFE_overrides
        ],
        role: "heading",
        "aria-level": headingLevel,
        "data-testid": testId,
        "data-ds--menu--heading-item": true,
        id: id,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: UNSAFE_className,
        ...rest
    }, children);
});
var $a2108c8482b7ae8f$export$2e2bcd8739ae039 = $a2108c8482b7ae8f$var$HeadingItem;

});


parcelRegister("lI4Q4", function(module, exports) {

$parcel$export(module.exports, "default", () => $150747d72d6d5287$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ew55A = parcelRequire("ew55A");

var $cD7p8 = parcelRequire("cD7p8");

var $7H980 = parcelRequire("7H980");
var $2COCu = parcelRequire("2COCu");
var $44qT7 = parcelRequire("44qT7");

var $844GK = parcelRequire("844GK");
const $150747d72d6d5287$var$AvatarGroupItem = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { avatar: avatar, index: index, onAvatarClick: onAvatarClick, testId: testId } = props;
    const { analyticsContext: analyticsContext, appearance: appearance, as: as, borderColor: borderColor, children: children, href: href, isDisabled: isDisabled, key: key, label: label, name: name, onClick: onClick, presence: presence, size: size, src: src, stackIndex: stackIndex, status: status, tabIndex: tabIndex, target: target, testId: groupItemTestId, ...rest } = avatar;
    const itemRef = (0, $844GK.default)();
    const CustomComponent = ({ children: children, className: className, disabled: disabled, draggable: draggable, onClick: onClick, onDragStart: onDragStart, onMouseDown: onMouseDown, ref: ref, tabIndex: tabIndex, 'data-testid': testId, ...props })=>{
        return /*#__PURE__*/ (0, $2OMIu.jsx)("button", {
            type: "button",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: className,
            disabled: disabled,
            draggable: draggable,
            onClick: onClick,
            // eslint-disable-next-line @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop
            onDragStart: onDragStart,
            onMouseDown: onMouseDown,
            ref: ref,
            tabIndex: tabIndex,
            "data-testid": testId,
            ...props,
            children: children
        });
    };
    const AvatarIcon = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ew55A.default), {
        ...rest,
        analyticsContext: analyticsContext,
        appearance: appearance,
        as: as,
        borderColor: "transparent",
        children: children,
        isDisabled: isDisabled,
        label: label,
        name: "",
        presence: presence,
        size: "small",
        src: src,
        stackIndex: stackIndex,
        status: status,
        tabIndex: tabIndex,
        testId: testId && `${testId}--avatar`
    });
    // onClick handler provided with avatar data takes precedence, same as with the normal avatar item
    const callback = onClick || onAvatarClick;
    if (href) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $44qT7.default), {
        ref: (0, $cD7p8.default)([
            ref,
            itemRef
        ]),
        href: href,
        target: target,
        rel: target === '_blank' ? 'noopener noreferrer' : undefined,
        iconBefore: AvatarIcon,
        testId: testId,
        onClick: (event)=>callback && callback(event, undefined, index),
        children: name
    });
    if (typeof callback === 'function') return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7H980.default), {
        ref: (0, $cD7p8.default)([
            ref,
            itemRef
        ]),
        onClick: (event)=>callback && callback(event, undefined, index),
        iconBefore: AvatarIcon,
        testId: testId,
        children: name
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2COCu.default), {
        iconBefore: AvatarIcon,
        component: CustomComponent,
        testId: testId,
        children: name
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$150747d72d6d5287$export$2e2bcd8739ae039 = $150747d72d6d5287$var$AvatarGroupItem;

});
parcelRegister("7H980", function(module, exports) {

$parcel$export(module.exports, "default", () => $1293970d29fed4e8$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $lGEY5 = parcelRequire("lGEY5");

var $bKnKN = parcelRequire("bKnKN");

var $9ewsv = parcelRequire("9ewsv");

var $fHpHg = parcelRequire("fHpHg");

var $kztDO = parcelRequire("kztDO");
/**
 * __Button item__
 *
 * A button item is used to populate a menu with items that are buttons.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/button-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ const $1293970d29fed4e8$var$ButtonItem = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(// Type needed on props to extract types with extract react types.
(props, ref)=>{
    const { children: children, cssFn: cssFn = (0, $bKnKN.default), description: description, iconAfter: iconAfter, iconBefore: iconBefore, isDisabled: isDisabled = false, isSelected: isSelected = false, onClick: onClick, testId: testId, overrides: overrides, onMouseDown: onMouseDown, shouldTitleWrap: shouldTitleWrap, shouldDescriptionWrap: shouldDescriptionWrap, className: UNSAFE_className, interactionName: interactionName, ...rest } = props;
    const onMouseDownHandler = onMouseDown;
    const interactionContext = (0, $5uXOq.useContext)((0, $9ewsv.default));
    const handleClick = (0, $5uXOq.useCallback)((e)=>{
        interactionContext?.tracePress(interactionName, e.timeStamp);
        onClick?.(e);
    }, [
        onClick,
        interactionContext,
        interactionName
    ]);
    if (!children) return null;
    (0, $lGEY5.propDeprecationWarning)("platform-pkg", 'cssFn', cssFn !== (0, $bKnKN.default), '' // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $kztDO.default), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: UNSAFE_className,
        ...rest,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        overrides: overrides,
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        isDisabled: isDisabled,
        isSelected: isSelected,
        description: description,
        title: children,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        css: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        cssFn({
            isSelected: isSelected,
            isDisabled: isDisabled
        }),
        testId: testId && `${testId}--primitive`
    }, ({ children: children, className: className })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("button", {
            "data-testid": testId,
            ...rest,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            ref: ref,
            disabled: isDisabled,
            onClick: (0, $fHpHg.fg)('platform_button_item-add-ufo-metrics') ? handleClick : onClick,
            onMouseDown: onMouseDownHandler,
            type: "button"
        }, children));
}));
var $1293970d29fed4e8$export$2e2bcd8739ae039 = $1293970d29fed4e8$var$ButtonItem;

});
parcelRegister("kztDO", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a7e9f928e38bccb$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $lGEY5 = parcelRequire("lGEY5");

var $6fV04 = parcelRequire("6fV04");

var $fHpHg = parcelRequire("fHpHg");

var $2Eqc8 = parcelRequire("2Eqc8");
var $bEIgH = parcelRequire("bEIgH");
var $2s57o = parcelRequire("2s57o");


var $8ZVfC = parcelRequire("8ZVfC");
function $7a7e9f928e38bccb$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7a7e9f928e38bccb$var$defaultRender = (Component, props)=>// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $f8Sb3.jsx)(Component, props);
const $7a7e9f928e38bccb$var$beforeAfterElementStylesOld = {
    name: "sjfyf",
    styles: "display:flex;align-items:center;justify-content:center;flex-shrink:0"
};
const $7a7e9f928e38bccb$var$beforeAfterElementStyles = {
    name: "a10fmi",
    styles: "display:flex;min-width:24px;min-height:24px;align-items:center;justify-content:center;flex-shrink:0"
};
const $7a7e9f928e38bccb$var$contentStyles = (0, $2s57o.xcss)({
    outline: 'none',
    overflow: 'hidden',
    textAlign: 'left'
});
const $7a7e9f928e38bccb$var$truncateStyles = {
    name: "hdknak",
    styles: "display:block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap"
};
const $7a7e9f928e38bccb$var$titleStyles = {
    name: "1th4nak",
    styles: "font:var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
const $7a7e9f928e38bccb$var$wordBreakStyles = {
    name: "1sdjnkx",
    styles: "word-break:break-word"
};
const $7a7e9f928e38bccb$var$descriptionStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    color: `var(--ds-text-subtlest, ${(0, $a7f8c6b391092279$export$f563ee71e9ee74cd)})`,
    font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});
const $7a7e9f928e38bccb$var$disabledDescriptionStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    color: `var(--ds-text-disabled, ${(0, $a7f8c6b391092279$export$f563ee71e9ee74cd)})`
});
const $7a7e9f928e38bccb$var$positionRelativeStyles = {
    name: "bjn8wh",
    styles: "position:relative"
};
const $7a7e9f928e38bccb$var$primitiveStyles = {
    name: "vfenhj",
    styles: "display:flex;box-sizing:border-box;width:100%;min-height:40px;margin:var(--ds-space-0, 0px);align-items:center;border:0;outline:0;text-decoration:none;user-select:none;&::-moz-focus-inner{border:0;}&:hover{text-decoration:none;}"
};
const $7a7e9f928e38bccb$var$spacingMapStyles = {
    cozy: {
        name: "1x13z0k",
        styles: "padding-block:var(--ds-space-100, 8px);padding-inline:var(--ds-space-200, 16px)"
    },
    compact: {
        name: "1xdhs5i",
        styles: "min-height:32px;padding-block:var(--ds-space-050, 4px);padding-inline:var(--ds-space-150, 12px)"
    }
};
const $7a7e9f928e38bccb$var$interactiveStyles = {
    name: "e0dnmk",
    styles: "cursor:pointer"
};
const $7a7e9f928e38bccb$var$unselectedStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    backgroundColor: "var(--ds-background-neutral-subtle, transparent)",
    color: 'currentColor',
    '&:visited': {
        color: 'currentColor'
    },
    '&:hover': {
        backgroundColor: `var(--ds-background-neutral-subtle-hovered, ${(0, $a7f8c6b391092279$export$9fdfb749e33cdf97)})`,
        color: 'currentColor'
    },
    '&:active': {
        backgroundColor: `var(--ds-background-neutral-subtle-pressed, ${(0, $a7f8c6b391092279$export$3e51e8f1440314ba)})`,
        boxShadow: 'none',
        color: 'currentColor'
    }
});
const $7a7e9f928e38bccb$var$disabledStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    cursor: 'not-allowed',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&, :hover, :active': {
        backgroundColor: "var(--ds-background-neutral-subtle, transparent)",
        color: `var(--ds-text-disabled, ${(0, $a7f8c6b391092279$export$f563ee71e9ee74cd)})`
    }
});
const $7a7e9f928e38bccb$var$selectedBorderStyles = {
    name: "1dgy7ry",
    styles: "&::before{width:2px;position:absolute;background:var(--ds-border-selected, transparent);content:\"\";inset-block-end:0;inset-block-start:0;inset-inline-start:0;}"
};
const $7a7e9f928e38bccb$var$selectedNotchStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    '&::before': {
        width: 4,
        position: 'absolute',
        background: "var(--ds-border-selected, transparent)",
        borderRadius: `0 ${"var(--ds-border-radius, 4px)"} ${"var(--ds-border-radius, 4px)"} 0`,
        content: '""',
        insetBlockEnd: "var(--ds-space-150, 12px)",
        insetBlockStart: "var(--ds-space-150, 12px)",
        insetInlineStart: 0
    }
});
const $7a7e9f928e38bccb$var$selectedStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    backgroundColor: `var(--ds-background-selected, ${(0, $a7f8c6b391092279$export$9fdfb749e33cdf97)})`,
    // Fallback set as babel plugin inserts one otherwise
    color: "var(--ds-text-selected, currentColor)",
    '&:visited': {
        color: "var(--ds-text-selected, currentColor)"
    },
    '&:hover': {
        backgroundColor: `var(--ds-background-selected-hovered, ${(0, $a7f8c6b391092279$export$9fdfb749e33cdf97)})`,
        color: "var(--ds-text-selected, currentColor)"
    },
    '&:active': {
        backgroundColor: `var(--ds-background-selected-pressed, ${(0, $a7f8c6b391092279$export$3e51e8f1440314ba)})`,
        color: "var(--ds-text-selected, currentColor)"
    }
});
const $7a7e9f928e38bccb$var$gapMap = {
    compact: 'space.100',
    cozy: 'space.150'
};
/**
 * __Menu item primitive__
 *
 * Menu item primitive contains all the styles for menu items,
 * including support for selected, disabled, and interaction states.
 *
 * Using children as function prop you wire up this to your own host element.
 *
 * ```jsx
 * <MenuItemPrimitive>
 *   {({ children, ...props }) => <button {...props}>{children}</button>}
 * </MenuItemPrimitive>
 * ```
 */ const $7a7e9f928e38bccb$var$MenuItemPrimitive = ({ children: children, title: title, description: description, iconAfter: iconAfter, iconBefore: iconBefore, overrides: overrides, className: UNSAFE_externalClassName, shouldTitleWrap: shouldTitleWrap = false, shouldDescriptionWrap: shouldDescriptionWrap = false, isDisabled: isDisabled = false, isSelected: isSelected = false, testId: testId })=>{
    (0, $lGEY5.propDeprecationWarning)("platform-pkg", 'overrides', overrides !== undefined, '' // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    const spacing = (0, $5uXOq.useContext)((0, $8ZVfC.SpacingContext));
    const selectionStyle = (0, $5uXOq.useContext)((0, $8ZVfC.SELECTION_STYLE_CONTEXT_DO_NOT_USE));
    const renderTitle = overrides && overrides.Title && overrides.Title.render || $7a7e9f928e38bccb$var$defaultRender;
    const UNSAFE_className = UNSAFE_externalClassName;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $f8Sb3.ClassNames), null, ({ css: cn, cx: cx })=>{
        return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $6fV04.default), {
            isInset: true
        }, children({
            className: cx([
                cn([
                    $7a7e9f928e38bccb$var$positionRelativeStyles,
                    $7a7e9f928e38bccb$var$primitiveStyles,
                    $7a7e9f928e38bccb$var$spacingMapStyles[spacing],
                    !isDisabled && !isSelected && $7a7e9f928e38bccb$var$unselectedStyles,
                    !isDisabled && isSelected && [
                        $7a7e9f928e38bccb$var$selectedStyles,
                        [
                            selectionStyle === 'border' && $7a7e9f928e38bccb$var$selectedBorderStyles,
                            selectionStyle === 'notch' && $7a7e9f928e38bccb$var$selectedNotchStyles
                        ]
                    ],
                    isDisabled ? $7a7e9f928e38bccb$var$disabledStyles : $7a7e9f928e38bccb$var$interactiveStyles
                ]),
                UNSAFE_className
            ]),
            children: /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $2Eqc8.default), {
                as: "span",
                spread: "space-between",
                alignBlock: "center",
                space: $7a7e9f928e38bccb$var$gapMap[spacing],
                grow: "fill",
                testId: testId && `${testId}--container`
            }, iconBefore && /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
                "data-item-elem-before": true,
                css: (0, $fHpHg.fg)('platform_ads_component_no_icon_spacing_support') ? $7a7e9f928e38bccb$var$beforeAfterElementStyles : $7a7e9f928e38bccb$var$beforeAfterElementStylesOld,
                "data-testid": testId && `${testId}--icon-before`
            }, iconBefore), title && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $bEIgH.default), {
                alignBlock: "center",
                grow: "fill",
                xcss: $7a7e9f928e38bccb$var$contentStyles
            }, renderTitle('span', {
                children: title,
                className: cn($7a7e9f928e38bccb$var$titleStyles, shouldTitleWrap ? $7a7e9f928e38bccb$var$wordBreakStyles : $7a7e9f928e38bccb$var$truncateStyles),
                'data-item-title': true
            }), description && /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
                "data-item-description": true,
                css: [
                    $7a7e9f928e38bccb$var$descriptionStyles,
                    isDisabled && $7a7e9f928e38bccb$var$disabledDescriptionStyles,
                    shouldDescriptionWrap ? $7a7e9f928e38bccb$var$wordBreakStyles : $7a7e9f928e38bccb$var$truncateStyles
                ]
            }, description)), iconAfter && /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
                "data-item-elem-after": true,
                css: (0, $fHpHg.fg)('platform_ads_component_no_icon_spacing_support') ? $7a7e9f928e38bccb$var$beforeAfterElementStyles : $7a7e9f928e38bccb$var$beforeAfterElementStylesOld,
                "data-testid": testId && `${testId}--icon-after`
            }, iconAfter))
        }));
    });
};
var $7a7e9f928e38bccb$export$2e2bcd8739ae039 = $7a7e9f928e38bccb$var$MenuItemPrimitive;

});
parcelRegister("2Eqc8", function(module, exports) {

$parcel$export(module.exports, "default", () => $1188aa156380c8e1$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $2s57o = parcelRequire("2s57o");

var $eWkgo = parcelRequire("eWkgo");
const $1188aa156380c8e1$var$flexGrowMap = {
    hug: (0, $2s57o.xcss)({
        flexGrow: 0
    }),
    fill: (0, $2s57o.xcss)({
        width: '100%',
        flexGrow: 1
    })
};
const $1188aa156380c8e1$var$separatorStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    color: "var(--ds-text-subtle, #42526E)",
    marginBlock: "var(--ds-space-0, 0px)",
    marginInline: `${"var(--ds-space-negative-025, -2px)"}`,
    pointerEvents: 'none',
    userSelect: 'none'
});
const $1188aa156380c8e1$var$Separator = ({ children: children })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $1188aa156380c8e1$var$separatorStyles
    }, children);
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ const $1188aa156380c8e1$var$Inline = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: as, alignInline: alignInline, alignBlock: alignItems = 'start', shouldWrap: shouldWrap = false, spread: spread, grow: grow, space: space, rowSpace: rowSpace, separator: separator, xcss: xcss, testId: testId, role: role, children: rawChildren }, ref)=>{
    const separatorComponent = typeof separator === 'string' ? /*#__PURE__*/ (0, $f8Sb3.jsx)($1188aa156380c8e1$var$Separator, null, separator) : separator;
    const children = separatorComponent ? (0, $5uXOq.Children).toArray(rawChildren).filter(Boolean).map((child, index)=>{
        return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    const justifyContent = spread || alignInline;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    const styles = grow ? [
        $1188aa156380c8e1$var$flexGrowMap[grow],
        ...Array.isArray(xcss) ? xcss : [
            xcss
        ]
    ] : xcss;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $eWkgo.default), {
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: justifyContent,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? 'wrap' : undefined,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$1188aa156380c8e1$var$Inline.displayName = 'Inline';
var $1188aa156380c8e1$export$2e2bcd8739ae039 = $1188aa156380c8e1$var$Inline;

});

parcelRegister("8ZVfC", function(module, exports) {

$parcel$export(module.exports, "SpacingContext", () => $8234d08347285f83$export$443076ec7ebce042);
$parcel$export(module.exports, "SELECTION_STYLE_CONTEXT_DO_NOT_USE", () => $8234d08347285f83$export$9ca534b70725964d);

var $5uXOq = parcelRequire("5uXOq");
const $8234d08347285f83$export$443076ec7ebce042 = /*#__PURE__*/ (0, $5uXOq.createContext)('cozy');
const $8234d08347285f83$export$9ca534b70725964d = /*#__PURE__*/ (0, $5uXOq.createContext)('border');

});



parcelRegister("2COCu", function(module, exports) {

$parcel$export(module.exports, "default", () => $aebc6ff3cecce4df$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $lGEY5 = parcelRequire("lGEY5");

var $bKnKN = parcelRequire("bKnKN");

var $9ewsv = parcelRequire("9ewsv");

var $fHpHg = parcelRequire("fHpHg");

var $kztDO = parcelRequire("kztDO");
const $aebc6ff3cecce4df$var$preventEvent = (e)=>{
    e.preventDefault();
};
/**
 * __Custom item__
 *
 * A custom item is used to populate a menu with items that can be any element.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/custom-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ const $aebc6ff3cecce4df$var$CustomItem = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(({ component: Component, cssFn: cssFn = (0, $bKnKN.default), isDisabled: isDisabled = false, isSelected: isSelected = false, onClick: onClick, testId: testId, children: children, description: description, iconAfter: iconAfter, iconBefore: iconBefore, overrides: overrides, onMouseDown: onMouseDown, shouldTitleWrap: shouldTitleWrap, shouldDescriptionWrap: shouldDescriptionWrap, className: UNSAFE_className, UNSAFE_isDraggable: UNSAFE_isDraggable, interactionName: interactionName, ...rest }, ref)=>{
    const onMouseDownHandler = onMouseDown;
    const interactionContext = (0, $5uXOq.useContext)((0, $9ewsv.default));
    const handleClick = (0, $5uXOq.useCallback)((e)=>{
        interactionContext?.tracePress(interactionName, e.timeStamp);
        onClick?.(e);
    }, [
        onClick,
        interactionContext,
        interactionName
    ]);
    if (!Component) return null;
    (0, $lGEY5.propDeprecationWarning)("platform-pkg", 'cssFn', cssFn !== (0, $bKnKN.default), '' // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $kztDO.default), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: UNSAFE_className,
        ...rest,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        overrides: overrides,
        description: description,
        iconAfter: iconAfter,
        title: children,
        iconBefore: iconBefore,
        isSelected: isSelected,
        isDisabled: isDisabled,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: (0, $f8Sb3.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        cssFn({
            isDisabled: isDisabled,
            isSelected: isSelected
        })),
        testId: testId && `${testId}--primitive`
    }, ({ children: children, className: className })=>/*#__PURE__*/ (0, $f8Sb3.jsx)(Component, {
            "data-testid": testId,
            ...rest,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            ref: ref,
            ...UNSAFE_isDraggable ? {} : {
                draggable: false,
                onDragStart: $aebc6ff3cecce4df$var$preventEvent
            },
            onMouseDown: isDisabled ? $aebc6ff3cecce4df$var$preventEvent : onMouseDownHandler,
            onClick: isDisabled ? $aebc6ff3cecce4df$var$preventEvent : (0, $fHpHg.fg)('platform_button_item-add-ufo-metrics') ? handleClick : onClick,
            tabIndex: isDisabled ? -1 : undefined,
            "aria-disabled": isDisabled
        }, children));
}));
var $aebc6ff3cecce4df$export$2e2bcd8739ae039 = $aebc6ff3cecce4df$var$CustomItem;

});

parcelRegister("44qT7", function(module, exports) {

$parcel$export(module.exports, "default", () => $0356de7f13c81f3d$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $3BT8o = parcelRequire("3BT8o");

var $lGEY5 = parcelRequire("lGEY5");

var $bKnKN = parcelRequire("bKnKN");

var $9ewsv = parcelRequire("9ewsv");

var $fHpHg = parcelRequire("fHpHg");

var $kztDO = parcelRequire("kztDO");
const $0356de7f13c81f3d$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
const $0356de7f13c81f3d$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms):)|(#))/;
const $0356de7f13c81f3d$var$preventEvent = (e)=>{
    e.preventDefault();
};
/**
 * __Link item__
 *
 * A link item is used to populate a menu with items that are links.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/link-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ const $0356de7f13c81f3d$var$LinkItem = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(// Type needed on props to extract types with extract react types.
(props, ref)=>{
    const { children: children, href: href, cssFn: cssFn = (0, $bKnKN.default), description: description, iconAfter: iconAfter, iconBefore: iconBefore, isDisabled: isDisabled = false, isSelected: isSelected = false, onClick: onClick, testId: testId, overrides: overrides, onMouseDown: onMouseDown, shouldTitleWrap: shouldTitleWrap, shouldDescriptionWrap: shouldDescriptionWrap, className: UNSAFE_className, UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink, UNSAFE_isDraggable: UNSAFE_isDraggable, interactionName: interactionName, ...rest } = props;
    const onMouseDownHandler = onMouseDown;
    const RouterLink = (0, $3BT8o.default)();
    const interactionContext = (0, $5uXOq.useContext)((0, $9ewsv.default));
    const handleClick = (0, $5uXOq.useCallback)((e)=>{
        interactionContext?.tracePress(interactionName, e.timeStamp);
        onClick?.(e);
    }, [
        onClick,
        interactionContext,
        interactionName
    ]);
    if (!children) return null;
    const isExternal = typeof href === 'string' && $0356de7f13c81f3d$var$IS_EXTERNAL_LINK_REGEX.test(href);
    const isNonHttpBased = typeof href === 'string' && $0356de7f13c81f3d$var$IS_NON_HTTP_BASED.test(href);
    const isEmptyHref = href == null || href === '';
    /**
   * Renders a router link if:
   *
   * - a link component is set in the app provider
   * - it's not an external link (starting with `http://` or `https://`)
   * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.)
   * - it doesn't have an empty href (e.g. href="" or href={undefined})
   */ const isRouterLink = !UNSAFE_shouldDisableRouterLink && RouterLink && !isExternal && !isNonHttpBased && !isEmptyHref;
    const Component = isRouterLink ? RouterLink : 'a';
    (0, $lGEY5.propDeprecationWarning)("platform-pkg", 'cssFn', cssFn !== (0, $bKnKN.default), '' // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $kztDO.default), {
        ...rest,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: UNSAFE_className,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        overrides: overrides,
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        isSelected: isSelected,
        isDisabled: isDisabled,
        description: description,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        css: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        cssFn({
            isSelected: isSelected,
            isDisabled: isDisabled
        }),
        title: children,
        testId: testId && `${testId}--primitive`
    }, ({ children: children, className: className })=>/*#__PURE__*/ (0, $f8Sb3.jsx)(Component, {
            "data-testid": testId,
            "data-is-router-link": testId ? isRouterLink ? 'true' : 'false' : undefined,
            "data-vc": "link-item",
            ...rest,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            // @ts-expect-error
            href: isDisabled ? undefined : href,
            ...UNSAFE_isDraggable ? {} : {
                draggable: false,
                onDragStart: $0356de7f13c81f3d$var$preventEvent
            },
            onMouseDown: isDisabled ? $0356de7f13c81f3d$var$preventEvent : onMouseDownHandler,
            onClick: isDisabled ? $0356de7f13c81f3d$var$preventEvent : (0, $fHpHg.fg)('platform_button_item-add-ufo-metrics') ? handleClick : onClick,
            "aria-current": isSelected ? 'page' : undefined,
            "aria-disabled": isDisabled,
            ref: ref
        }, children));
}));
var $0356de7f13c81f3d$export$2e2bcd8739ae039 = $0356de7f13c81f3d$var$LinkItem;

});

parcelRegister("844GK", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1a266fb77fa7263$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $AD1bq = parcelRequire("AD1bq");
// The refs stored in the context are used to programatically
// control focus on a user navigates using the keyboard.
function $f1a266fb77fa7263$var$useRegisterItemWithFocusManager() {
    const { registerRef: registerRef } = (0, $5uXOq.useContext)((0, $AD1bq.FocusManagerContext));
    const itemRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        if (itemRef.current !== null) registerRef(itemRef.current);
    }, [
        registerRef
    ]);
    return itemRef;
}
var $f1a266fb77fa7263$export$2e2bcd8739ae039 = $f1a266fb77fa7263$var$useRegisterItemWithFocusManager;

});
parcelRegister("AD1bq", function(module, exports) {

$parcel$export(module.exports, "FocusManagerContext", () => $a7526fa7b402d1a8$export$f18c1d4fc7326096);
$parcel$export(module.exports, "default", () => $a7526fa7b402d1a8$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");

var $bKnKN = parcelRequire("bKnKN");

var $dkjwE = parcelRequire("dkjwE");
const $a7526fa7b402d1a8$export$f18c1d4fc7326096 = /*#__PURE__*/ (0, $5uXOq.createContext)({
    menuItemRefs: [],
    registerRef: (0, $bKnKN.default)
});
/**
 * Focus manager logic
 */ const $a7526fa7b402d1a8$var$FocusManager = ({ children: children })=>{
    const menuItemRefs = (0, $5uXOq.useRef)([]);
    const registerRef = (0, $5uXOq.useCallback)((ref)=>{
        if (ref && !menuItemRefs.current.includes(ref)) menuItemRefs.current.push(ref);
    }, []);
    // set focus and intentionally rebinding listener and clean up listener on each render
    (0, $5uXOq.useEffect)(()=>{
        (0, $cBeZP.bind)(window, {
            type: 'keydown',
            listener: (0, $dkjwE.default)(menuItemRefs.current)
        });
        const unbind = ()=>{
            (0, $cBeZP.bind)(window, {
                type: 'keydown',
                listener: (0, $dkjwE.default)(menuItemRefs.current)
            });
        };
        return unbind;
    }, []);
    const contextValue = {
        menuItemRefs: menuItemRefs.current,
        registerRef: registerRef
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)($a7526fa7b402d1a8$export$f18c1d4fc7326096.Provider, {
        value: contextValue,
        children: children
    });
};
var $a7526fa7b402d1a8$export$2e2bcd8739ae039 = $a7526fa7b402d1a8$var$FocusManager;

});
parcelRegister("dkjwE", function(module, exports) {

$parcel$export(module.exports, "default", () => $8257043e8dcf218a$export$2e2bcd8739ae039);

const $8257043e8dcf218a$var$actionMap = {
    [(0, $f13eec7fa1d5338f$export$a80636c6f41931fe)]: 'next',
    [(0, $f13eec7fa1d5338f$export$390330c10ff2b9a1)]: 'prev',
    [(0, $f13eec7fa1d5338f$export$4af703091671bc)]: 'first',
    [(0, $f13eec7fa1d5338f$export$e2bc30913faa5db7)]: 'last'
};
/**
 * currentFocusedIdx + 1 will not work if the next focusable element
 * is disabled. So, we need to iterate through the following menu items
 * to find one that isn't disabled. If all following elements are disabled,
 * return undefined.
 */ const $8257043e8dcf218a$var$getNextFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx + 1 < refs.length){
        const isDisabled = refs[currentFocusedIdx + 1].getAttribute('disabled') !== null;
        if (!isDisabled) return refs[currentFocusedIdx + 1];
        currentFocusedIdx++;
    }
};
/**
 * currentFocusedIdx - 1 will not work if the prev focusable element
 * is disabled. So, we need to iterate through the previous menu items
 * to find one that isn't disabled. If all previous elements are disabled,
 * return undefined.
 */ const $8257043e8dcf218a$var$getPrevFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx > 0){
        const isDisabled = refs[currentFocusedIdx - 1].getAttribute('disabled') !== null;
        if (!isDisabled) return refs[currentFocusedIdx - 1];
        currentFocusedIdx--;
    }
};
function $8257043e8dcf218a$export$2e2bcd8739ae039(refs) {
    return (e)=>{
        const currentFocusedIdx = refs.findIndex((el)=>document.activeElement?.isSameNode(el));
        const action = $8257043e8dcf218a$var$actionMap[e.key];
        switch(action){
            case 'next':
                if (currentFocusedIdx < refs.length - 1) {
                    e.preventDefault();
                    const nextFocusableElement = $8257043e8dcf218a$var$getNextFocusableElement(refs, currentFocusedIdx);
                    nextFocusableElement?.focus();
                }
                break;
            case 'prev':
                if (currentFocusedIdx > 0) {
                    e.preventDefault();
                    const prevFocusableElement = $8257043e8dcf218a$var$getPrevFocusableElement(refs, currentFocusedIdx);
                    prevFocusableElement?.focus();
                }
                break;
            case 'first':
                e.preventDefault();
                // Search for first non-disabled element if first element is disabled
                const nextFocusableElement = $8257043e8dcf218a$var$getNextFocusableElement(refs, -1);
                nextFocusableElement?.focus();
                break;
            case 'last':
                e.preventDefault();
                // Search for last non-disabled element if last element is disabled
                const prevFocusableElement = $8257043e8dcf218a$var$getPrevFocusableElement(refs, refs.length);
                prevFocusableElement?.focus();
                break;
            default:
                return;
        }
    };
}

});




parcelRegister("4RXsT", function(module, exports) {

$parcel$export(module.exports, "default", () => $803cf2753bdab883$export$2e2bcd8739ae039);
/* grid.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $803cf2753bdab883$var$gutter = "var(--ds-space-negative-050, -4px)";
const $803cf2753bdab883$var$listStyles = null;
const $803cf2753bdab883$var$listItemStyles = null;
const $803cf2753bdab883$var$Grid = ({ children: children, testId: testId, 'aria-label': label })=>/*#__PURE__*/ (0, $2OMIu.jsx)("ul", {
        "data-testid": testId,
        "aria-label": label,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bah1y6m _1n261g80 _19121cl4 _vwz4kb7n _2mzuagmp _6rthze3t _1pfhze3t _12l2r5cr _ahbqr5cr _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t"
        ]),
        children: (0, $5uXOq.Children).map(children, (child)=>child && /*#__PURE__*/ (0, $2OMIu.jsx)("li", {
                className: (0, $bwpsq.default)([
                    "_6rthu2gc _1pfhze3t _12l2ze3t _ahbqze3t _y4ti1b66 _bozg1b66"
                ]),
                children: child
            }))
    });
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$803cf2753bdab883$export$2e2bcd8739ae039 = $803cf2753bdab883$var$Grid;

});

parcelRegister("67dPA", function(module, exports) {

$parcel$export(module.exports, "default", () => $e89188487388fbb2$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $aOrxC = parcelRequire("aOrxC");

var $AD1bq = parcelRequire("AD1bq");
/**
 * It sets focus to the first avatar when popup is open.
 */ const $e89188487388fbb2$var$PopupAvatarGroup = ({ children: children, isLoading: isLoading, maxHeight: maxHeight, maxWidth: maxWidth = 800, minHeight: minHeight, minWidth: minWidth = 320, onClick: onClick, role: role, setInitialFocusRef: setInitialFocusRef, spacing: spacing, testId: testId, ...rest })=>{
    const { menuItemRefs: menuItemRefs } = (0, $5uXOq.useContext)((0, $AD1bq.FocusManagerContext));
    (0, $5uXOq.useEffect)(()=>{
        setInitialFocusRef?.(menuItemRefs[0]);
    }, [
        menuItemRefs,
        setInitialFocusRef
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $aOrxC.default), {
        isLoading: isLoading,
        maxHeight: maxHeight,
        maxWidth: maxWidth,
        minHeight: minHeight,
        minWidth: minWidth,
        onClick: onClick,
        role: role,
        spacing: spacing,
        testId: testId,
        ...rest,
        children: children
    });
};
var $e89188487388fbb2$export$2e2bcd8739ae039 = $e89188487388fbb2$var$PopupAvatarGroup;

});
parcelRegister("aOrxC", function(module, exports) {

$parcel$export(module.exports, "default", () => $93cdf2b96692c237$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $8ZVfC = parcelRequire("8ZVfC");
function $93cdf2b96692c237$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $93cdf2b96692c237$var$baseStyles = {
    name: "1u0qf12",
    styles: "display:flex;position:static;flex-direction:column;overflow:auto"
};
/**
 * __Menu group__
 *
 * A menu group includes all the actions or items in a menu.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/menu-group)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ const $93cdf2b96692c237$var$MenuGroup = ({ isLoading: isLoading, maxWidth: maxWidth, minWidth: minWidth, minHeight: minHeight, maxHeight: maxHeight, testId: testId, role: role, spacing: spacing = 'cozy', // Although this isn't defined on props it is available because we've used
// Spread props below and on the jsx element. To forcibly block usage I've
// picked it out and supressed the expected type error.
// @ts-expect-error
className: UNSAFE_className, ...rest })=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $8ZVfC.SpacingContext).Provider, {
        value: spacing
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $8ZVfC.SELECTION_STYLE_CONTEXT_DO_NOT_USE).Provider, {
        value: "border"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        "aria-busy": isLoading,
        style: {
            minWidth: minWidth,
            maxWidth: maxWidth,
            minHeight: minHeight,
            maxHeight: maxHeight
        },
        css: $93cdf2b96692c237$var$baseStyles,
        "data-testid": testId,
        role: role,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: UNSAFE_className,
        ...rest
    })));
var $93cdf2b96692c237$export$2e2bcd8739ae039 = $93cdf2b96692c237$var$MenuGroup;

});


parcelRegister("1Tpnh", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca75e3a0c8f90e0b$export$2e2bcd8739ae039);
/* more-indicator.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fHpHg = parcelRequire("fHpHg");
const $ca75e3a0c8f90e0b$var$boxShadowCssVar = '--avatar-box-shadow';
const $ca75e3a0c8f90e0b$var$styles = {
    root: "_19itglyw _12ji1r31 _1qu2glyw _12y31o36 _1reo15vq _18m915vq _v564ieh6 _1e0c1txw _vchh18uv _19pkv77o _2hwxv77o _otyrv77o _18u0v77o _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _4cvr1fhb _1bah1h6o _2lx21bp4 _80omtlke _bfhkm7j4 _syaz1fxt _16qs1nhn _t9ec1aqe _1ejjglyw _mizu194a _ra3xnqa1 _1ah3yh40 _128myh40 _irr315ej _30l31fxt _1di6ip91 _9h8h1fxt _1q8w1np6 _jlxit94y",
    circle: "_2rko1q5u",
    active: "_bfhkfg4m _16qsqz53 _syazaqb7 _t9ec1np6 _irr3i1yw _30l3aqb7 _1di619ru _9h8haqb7",
    disabled: "_80om13gf _1peqs237 _1hfkvuon"
};
const $ca75e3a0c8f90e0b$var$widthHeightMap = {
    xsmall: "_1bsb7vkz _4t3i7vkz",
    small: "_1bsb1tcg _4t3i1tcg",
    medium: "_1bsbzwfg _4t3izwfg",
    large: "_1bsb1ylp _4t3i1ylp",
    xlarge: "_1bsb16xz _4t3i16xz",
    xxlarge: "_1bsb1qr7 _4t3i1qr7"
};
const $ca75e3a0c8f90e0b$var$borderRadiusMap = {
    xsmall: "_2rkoyh40 _14mjyh40",
    small: "_2rkoyh40 _14mjyh40",
    medium: "_2rko1l7b _14mj1l7b",
    large: "_2rko1l7b _14mj1l7b",
    xlarge: "_2rkoi2wt _14mji2wt",
    xxlarge: "_2rko1crf _14mj1crf"
};
const $ca75e3a0c8f90e0b$var$fontMap = {
    small: "_11c81o8v",
    medium: "_11c81o8v",
    large: "_11c8dcr7",
    xlarge: "_11c81ixg",
    xxlarge: "_11c81ixg"
};
const $ca75e3a0c8f90e0b$var$MAX_DISPLAY_COUNT = 99;
const $ca75e3a0c8f90e0b$var$MoreIndicator = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ appearance: appearance = 'circle', borderColor: // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
borderColor = (0, $fHpHg.fg)('platform-component-visual-refresh') ? "var(--ds-surface, #FFFFFF)" : "var(--ds-border-inverse, #FFFFFF)", size: size = 'medium', count: count = 0, testId: testId, onClick: onClick, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHaspopup, buttonProps: buttonProps = {}, isActive: isActive }, ref)=>{
    const onClickHander = (0, $5uXOq.useCallback)((event, analyticsEvent)=>{
        if (buttonProps.onClick) buttonProps.onClick(event);
        onClick(event, analyticsEvent);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        buttonProps.onClick,
        onClick
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("button", {
        type: "submit",
        ...buttonProps,
        onClick: onClickHander,
        ref: ref,
        "data-testid": testId,
        "aria-controls": ariaControls,
        "aria-expanded": ariaExpanded,
        "aria-haspopup": ariaHaspopup,
        style: {
            [$ca75e3a0c8f90e0b$var$boxShadowCssVar]: `0 0 0 2px ${borderColor}`
        },
        className: (0, $bwpsq.default)([
            $ca75e3a0c8f90e0b$var$styles.root,
            $ca75e3a0c8f90e0b$var$borderRadiusMap[size],
            appearance === 'circle' && $ca75e3a0c8f90e0b$var$styles.circle,
            $ca75e3a0c8f90e0b$var$widthHeightMap[size],
            $ca75e3a0c8f90e0b$var$fontMap[size],
            isActive && $ca75e3a0c8f90e0b$var$styles.active
        ]),
        children: [
            "+",
            count > $ca75e3a0c8f90e0b$var$MAX_DISPLAY_COUNT ? $ca75e3a0c8f90e0b$var$MAX_DISPLAY_COUNT : count
        ]
    });
});
$ca75e3a0c8f90e0b$var$MoreIndicator.displayName = 'MoreIndicator';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$ca75e3a0c8f90e0b$export$2e2bcd8739ae039 = $ca75e3a0c8f90e0b$var$MoreIndicator;

});

parcelRegister("1XUgS", function(module, exports) {

$parcel$export(module.exports, "default", () => $055af5215efc720c$export$2e2bcd8739ae039);
/* stack.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $055af5215efc720c$var$listStyles = null;
const $055af5215efc720c$var$listItemStyles = null;
const $055af5215efc720c$var$Stack = ({ children: children, testId: testId, 'aria-label': label })=>/*#__PURE__*/ (0, $2OMIu.jsx)("ul", {
        "data-testid": testId,
        "aria-label": label,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _19121cl4 _vwz4kb7n _2mzuagmp _6rthze3t _1pfhze3t _12l2u2gc _ahbqze3t _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t"
        ]),
        children: (0, $5uXOq.Children).map(children, (child)=>child && /*#__PURE__*/ (0, $2OMIu.jsx)("li", {
                className: (0, $bwpsq.default)([
                    "_6rthze3t _1pfhze3t _12l2x0bf _ahbqze3t"
                ]),
                children: child
            }))
    });
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$055af5215efc720c$export$2e2bcd8739ae039 = $055af5215efc720c$var$Stack;

});

parcelRegister("i3aMR", function(module, exports) {

$parcel$export(module.exports, "composeUniqueKey", () => $ea764c38a889f051$export$b067756944994c79);
const $ea764c38a889f051$export$b067756944994c79 = (props, index)=>{
    if (props.key) return props.key;
    return index;
};

});


parcelRegister("7a4uG", function(module, exports) {

$parcel$export(module.exports, "AVATAR_SIZES", () => $a0a39ec9dc65de96$export$9a270941bcff7e77);
$parcel$export(module.exports, "AVATAR_RADIUS", () => $a0a39ec9dc65de96$export$e6da6efe4d1a5c9b);
$parcel$export(module.exports, "BORDER_WIDTH", () => $a0a39ec9dc65de96$export$e2bd4c1faded7921);
// eslint-disable-next-line @atlaskit/design-system/no-deprecated-imports

var $b4a3S = parcelRequire("b4a3S");
const $a0a39ec9dc65de96$export$9a270941bcff7e77 = {
    xsmall: (0, $b4a3S.gridSize)() * 2,
    small: (0, $b4a3S.gridSize)() * 3,
    medium: (0, $b4a3S.gridSize)() * 4,
    large: (0, $b4a3S.gridSize)() * 5,
    xlarge: (0, $b4a3S.gridSize)() * 12,
    xxlarge: (0, $b4a3S.gridSize)() * 16
};
const $a0a39ec9dc65de96$export$e6da6efe4d1a5c9b = {
    xsmall: 2,
    small: 2,
    medium: 3,
    large: 3,
    xlarge: 6,
    xxlarge: 12
};
const $a0a39ec9dc65de96$export$e2bd4c1faded7921 = 2;
const $a0a39ec9dc65de96$export$89a980dfdf90df51 = 0.9;
const $a0a39ec9dc65de96$export$3c061e31594ebabe = '--avatar-background-color';
const $a0a39ec9dc65de96$export$fdc820179f1f9be4 = {
    small: 12,
    medium: 14,
    large: 15,
    xlarge: 18
};
const $a0a39ec9dc65de96$export$382610e783aa2ae8 = {
    small: 0,
    medium: 0,
    large: 1,
    xlarge: 7
};

});

parcelRegister("2GZKW", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ae16862c9faad67$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $avgEF = parcelRequire("avgEF");

var $2s57o = parcelRequire("2s57o");
function $0ae16862c9faad67$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $0ae16862c9faad67$var$gridTemplateAreasVar = '--ds-grid--grid-template-areas';
const $0ae16862c9faad67$var$gridTemplateColumnsVar = '--ds-grid--grid-template-columns';
const $0ae16862c9faad67$var$gridTemplateRowsVar = '--ds-grid--grid-template-rows';
const $0ae16862c9faad67$var$justifyContentMap = {
    start: {
        name: "j1lm6p",
        styles: "justify-content:start"
    },
    center: {
        name: "f7ay7b",
        styles: "justify-content:center"
    },
    end: {
        name: "jab4lt",
        styles: "justify-content:end"
    },
    'space-between': {
        name: "2o6p8u",
        styles: "justify-content:space-between"
    },
    'space-around': {
        name: "46cjum",
        styles: "justify-content:space-around"
    },
    'space-evenly': {
        name: "16166rn",
        styles: "justify-content:space-evenly"
    },
    stretch: {
        name: "11z2bqs",
        styles: "justify-content:stretch"
    }
};
const $0ae16862c9faad67$var$justifyItemsMap = {
    start: {
        name: "lno2ya",
        styles: "justify-items:start"
    },
    center: {
        name: "1wg53za",
        styles: "justify-items:center"
    },
    end: {
        name: "3f7lhf",
        styles: "justify-items:end"
    },
    stretch: {
        name: "16hnylu",
        styles: "justify-items:stretch"
    }
};
const $0ae16862c9faad67$var$alignContentMap = {
    start: {
        name: "iqu4as",
        styles: "align-content:start"
    },
    center: {
        name: "13vy23x",
        styles: "align-content:center"
    },
    end: {
        name: "1fj2toh",
        styles: "align-content:end"
    },
    'space-between': {
        name: "1pem0lx",
        styles: "align-content:space-between"
    },
    'space-around': {
        name: "127p7gk",
        styles: "align-content:space-around"
    },
    'space-evenly': {
        name: "kcqjal",
        styles: "align-content:space-evenly"
    },
    stretch: {
        name: "1f8yzab",
        styles: "align-content:stretch"
    }
};
const $0ae16862c9faad67$var$alignItemsMap = {
    start: {
        name: "yvwru5",
        styles: "align-items:start"
    },
    center: {
        name: "1h3rtzg",
        styles: "align-items:center"
    },
    baseline: {
        name: "fzr848",
        styles: "align-items:baseline"
    },
    end: {
        name: "uj5xqj",
        styles: "align-items:end"
    }
};
const $0ae16862c9faad67$var$baseStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'grid',
    boxSizing: 'border-box',
    gridTemplateAreas: `var(${$0ae16862c9faad67$var$gridTemplateAreasVar})`,
    gridTemplateColumns: `var(${$0ae16862c9faad67$var$gridTemplateColumnsVar})`,
    gridTemplateRows: `var(${$0ae16862c9faad67$var$gridTemplateRowsVar})`
});
const $0ae16862c9faad67$var$gridAutoFlowMap = {
    row: {
        name: "k3yepi",
        styles: "grid-auto-flow:row"
    },
    column: {
        name: "qu4z1d",
        styles: "grid-auto-flow:column"
    },
    dense: {
        name: "mgx7bc",
        styles: "grid-auto-flow:dense"
    },
    'row dense': {
        name: "1u50cee",
        styles: "grid-auto-flow:row dense"
    },
    'column dense': {
        name: "5ak4pc",
        styles: "grid-auto-flow:column dense"
    }
};
/**
 * __Grid__
 *
 * `Grid` is a primitive component that implements the CSS Grid API.
 *
 * - [Examples](https://atlassian.design/components/primitives/grid/examples)
 * - [Code](https://atlassian.design/components/primitives/grid/code)
 *
 * @example
 * ```tsx
 * import { Grid, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Grid gap="space.100" gridColumns="1fr 1fr">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Grid>
 * )
 * ```
 */ const $0ae16862c9faad67$var$Grid = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: as, alignItems: alignItems, alignContent: alignContent, justifyContent: justifyContent, gap: gap, columnGap: columnGap, rowGap: rowGap, children: children, id: id, role: role, testId: testId, autoFlow: autoFlow, templateAreas: gridTemplateAreas, templateRows: gridTemplateRows, templateColumns: gridTemplateColumns, xcss: xcss }, ref)=>{
    const Component = as || 'div';
    const resolvedStyles = (0, $2s57o.parseXcss)(xcss);
    /**
   * We use CSS variables to allow for dynamic grid templates instead of dynamically setting to `props.style`
   * This allows `props.xcss` to override them as `style={{ gridTemplateAreas }}` would have higher specificity.
   *
   * This must be reset to `initial` if `gridTemplateAreas` is not set, otherwise nested grids will break!
   *
   * NOTE: If we disallow `grid-template-areas` (etc) to be set via `props.xcss`, we can remove this.
   */ const style = (0, $5uXOq.useMemo)(()=>({
            [$0ae16862c9faad67$var$gridTemplateAreasVar]: gridTemplateAreas ? gridTemplateAreas.map((str)=>`"${str}"`).join('\n') || 'initial' : 'initial',
            [$0ae16862c9faad67$var$gridTemplateColumnsVar]: gridTemplateColumns || 'initial',
            [$0ae16862c9faad67$var$gridTemplateRowsVar]: gridTemplateRows || 'initial'
        }), [
        gridTemplateAreas,
        gridTemplateColumns,
        gridTemplateRows
    ]);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)(Component, {
        id: id,
        role: role,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        css: [
            $0ae16862c9faad67$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            gap && (0, $avgEF.spaceStylesMap).gap[gap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            columnGap && (0, $avgEF.spaceStylesMap).columnGap[columnGap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            rowGap && (0, $avgEF.spaceStylesMap).rowGap[rowGap],
            alignItems && $0ae16862c9faad67$var$alignItemsMap[alignItems],
            alignContent && $0ae16862c9faad67$var$alignContentMap[alignContent],
            justifyContent && $0ae16862c9faad67$var$justifyContentMap[justifyContent],
            autoFlow && $0ae16862c9faad67$var$gridAutoFlowMap[autoFlow],
            resolvedStyles.emotion
        ],
        "data-testid": testId,
        ref: ref
    }, children);
}));
$0ae16862c9faad67$var$Grid.displayName = 'Grid';
var $0ae16862c9faad67$export$2e2bcd8739ae039 = $0ae16862c9faad67$var$Grid;

});

parcelRegister("5FmWx", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c1c8f2bcc01b08c$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $4FiSH = parcelRequire("4FiSH");

var $6VxGE = parcelRequire("6VxGE");
const $1c1c8f2bcc01b08c$var$baseImageStyles = null; /**
                               * __Image__
                               *
                               * This component can be used interchangeably with the native `img` element. It includes additional functionality, such as theme support.
                               *
                               * - [Examples](https://atlassian.design/components/image/examples)
                               * - [Code](https://atlassian.design/components/image/code)
                               * - [Usage](https://atlassian.design/components/image/usage)
                               */ 
function $1c1c8f2bcc01b08c$export$2e2bcd8739ae039({ src: src, srcDark: srcDark, alt: alt, testId: testId, className: className, ...props }) {
    const imgRef = (0, $5uXOq.useRef)(null);
    const providedColorMode = (0, $4FiSH.UNSAFE_useColorModeForMigration)();
    const { colorMode: observedColorMode } = (0, $6VxGE.default)();
    const colorMode = providedColorMode || observedColorMode;
    (0, $5uXOq.useEffect)(()=>{
        if (imgRef === null || imgRef.current === null) return;
        if (srcDark && colorMode === 'dark') imgRef.current.src = srcDark;
        else if (src) imgRef.current.src = src;
    }, [
        src,
        srcDark,
        colorMode
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("img", {
        alt: alt,
        "data-testid": testId,
        src: src,
        className: (0, $bwpsq.default)([
            "_p12f1osq _4t3i1wug",
            className
        ]),
        ref: imgRef,
        ...props
    });
}

});
parcelRegister("4FiSH", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_useColorModeForMigration", () => $ac9d0e1b38561ff1$export$ce91654eb9fea460);
$parcel$export(module.exports, "default", () => $ac9d0e1b38561ff1$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");

var $fHpHg = parcelRequire("fHpHg");

var $8dUOv = parcelRequire("8dUOv");
var $4VEQo = parcelRequire("4VEQo");
var $griCX = parcelRequire("griCX");
const $ac9d0e1b38561ff1$var$defaultThemeSettings = ()=>({
        dark: 'dark',
        light: 'light',
        spacing: 'spacing',
        typography: (0, $fHpHg.fg)('platform-default-typography-modernized') ? 'typography-modernized' : undefined
    });
const $ac9d0e1b38561ff1$var$ColorModeContext = /*#__PURE__*/ (0, $5uXOq.createContext)(undefined);
const $ac9d0e1b38561ff1$var$SetColorModeContext = /*#__PURE__*/ (0, $5uXOq.createContext)(undefined);
const $ac9d0e1b38561ff1$var$ThemeContext = /*#__PURE__*/ (0, $5uXOq.createContext)(undefined);
const $ac9d0e1b38561ff1$var$SetThemeContext = /*#__PURE__*/ (0, $5uXOq.createContext)(undefined);
function $ac9d0e1b38561ff1$export$ce91654eb9fea460() {
    const value = (0, $5uXOq.useContext)($ac9d0e1b38561ff1$var$ColorModeContext);
    return value;
}
function $ac9d0e1b38561ff1$export$20f3076712c8dfa() {
    const value = (0, $5uXOq.useContext)($ac9d0e1b38561ff1$var$ColorModeContext);
    if (!value) throw new Error('useColorMode must be used within AppProvider.');
    return value;
}
function $ac9d0e1b38561ff1$export$e2afe7397c3d11c7() {
    const value = (0, $5uXOq.useContext)($ac9d0e1b38561ff1$var$SetColorModeContext);
    if (!value) throw new Error('useSetColorMode must be used within AppProvider.');
    return value;
}
function $ac9d0e1b38561ff1$export$93d4e7f90805808f() {
    const theme = (0, $5uXOq.useContext)($ac9d0e1b38561ff1$var$ThemeContext);
    const [resolvedTheme, setResolvedTheme] = (0, $5uXOq.useState)(theme || (0, $8dUOv.default)());
    (0, $5uXOq.useEffect)(()=>{
        // We are using theme from context so no need to reference the DOM
        if (theme) return;
        const observer = new (0, $griCX.default)(setResolvedTheme);
        observer.observe();
        return ()=>observer.disconnect();
    }, [
        theme
    ]);
    return resolvedTheme;
}
function $ac9d0e1b38561ff1$export$501aa0dcd5527a48() {
    const value = (0, $5uXOq.useContext)($ac9d0e1b38561ff1$var$SetThemeContext);
    if (!value) throw new Error('useSetTheme must be used within AppProvider.');
    return value;
}
const $ac9d0e1b38561ff1$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
const $ac9d0e1b38561ff1$var$prefersDarkModeMql = $ac9d0e1b38561ff1$var$isMatchMediaAvailable ? window.matchMedia('(prefers-color-scheme: dark)') : undefined;
// TODO: currently 'auto' color mode will always return 'light' in SSR.
// Additional work required: https://product-fabric.atlassian.net/browse/DSP-9781
function $ac9d0e1b38561ff1$var$getReconciledColorMode(colorMode) {
    if (colorMode === 'auto') return $ac9d0e1b38561ff1$var$prefersDarkModeMql?.matches ? 'dark' : 'light';
    return colorMode;
}
/**
 * __Theme provider__
 *
 * Provides global theming configuration.
 *
 * @internal
 */ function $ac9d0e1b38561ff1$var$ThemeProvider({ children: children, defaultColorMode: defaultColorMode, defaultTheme: defaultTheme }) {
    const [chosenColorMode, setChosenColorMode] = (0, $5uXOq.useState)(defaultColorMode);
    const [reconciledColorMode, setReconciledColorMode] = (0, $5uXOq.useState)($ac9d0e1b38561ff1$var$getReconciledColorMode(defaultColorMode));
    const [theme, setTheme] = (0, $5uXOq.useState)(()=>({
            ...$ac9d0e1b38561ff1$var$defaultThemeSettings(),
            ...defaultTheme
        }));
    const setColorMode = (0, $5uXOq.useCallback)((colorMode)=>{
        setChosenColorMode(colorMode);
        setReconciledColorMode($ac9d0e1b38561ff1$var$getReconciledColorMode(colorMode));
    }, []);
    const setPartialTheme = (0, $5uXOq.useCallback)((nextTheme)=>{
        setTheme((theme)=>({
                ...theme,
                ...nextTheme
            }));
    }, []);
    const lastSetGlobalThemePromiseRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        /**
     * We need to wait for any previous `setGlobalTheme` calls to finish before calling it again.
     * This is to prevent race conditions as `setGlobalTheme` is async and mutates the DOM (e.g. sets the
     * `data-color-mode` attribute on the root element).
     *
     * Since we can't safely abort the `setGlobalTheme` execution, we need to wait for it to properly finish before
     * applying the new theme.
     *
     * Without this, we can end up in the following scenario:
     * 1. app loads with the default 'light' theme, kicking off `setGlobalTheme`
     * 2. app switches to 'dark' theme after retrieving value persisted in local storage, calling `setGlobalTheme` again
     * 3. `setGlobalTheme` function execution for `dark` finishes before the initial `light` execution
     * 4. `setGlobalTheme` function execution for `light` then finishes, resulting in the 'light' theme being applied.
     */ const cleanupLastFnCall = async ()=>{
            if (lastSetGlobalThemePromiseRef.current) {
                const unbindFn = await lastSetGlobalThemePromiseRef.current;
                unbindFn();
                lastSetGlobalThemePromiseRef.current = null;
            }
        };
        const safelySetGlobalTheme = async ()=>{
            await cleanupLastFnCall();
            const promise = (0, $4VEQo.default)({
                ...theme,
                colorMode: reconciledColorMode
            });
            lastSetGlobalThemePromiseRef.current = promise;
        };
        safelySetGlobalTheme();
        return function cleanup() {
            cleanupLastFnCall();
        };
    }, [
        theme,
        reconciledColorMode
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!$ac9d0e1b38561ff1$var$prefersDarkModeMql) return;
        const unbindListener = (0, $cBeZP.bind)($ac9d0e1b38561ff1$var$prefersDarkModeMql, {
            type: 'change',
            listener: (event)=>{
                if (chosenColorMode === 'auto') setReconciledColorMode(event.matches ? 'dark' : 'light');
            }
        });
        return unbindListener;
    }, [
        chosenColorMode
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($ac9d0e1b38561ff1$var$ColorModeContext.Provider, {
        value: reconciledColorMode,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($ac9d0e1b38561ff1$var$SetColorModeContext.Provider, {
            value: setColorMode,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)($ac9d0e1b38561ff1$var$ThemeContext.Provider, {
                value: theme,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)($ac9d0e1b38561ff1$var$SetThemeContext.Provider, {
                    value: setPartialTheme,
                    children: children
                })
            })
        })
    });
}
var $ac9d0e1b38561ff1$export$2e2bcd8739ae039 = $ac9d0e1b38561ff1$var$ThemeProvider;

});
parcelRegister("4VEQo", function(module, exports) {

$parcel$export(module.exports, "default", () => $20672b0489e64708$export$2e2bcd8739ae039);

var $fHpHg = parcelRequire("fHpHg");

var $g0l9Y = parcelRequire("g0l9Y");

var $9pyiD = parcelRequire("9pyiD");

var $32uJh = parcelRequire("32uJh");

var $dgTsQ = parcelRequire("dgTsQ");

var $9OnAz = parcelRequire("9OnAz");

var $iiK23 = parcelRequire("iiK23");

/**
 * Sets the theme globally at runtime. This updates the `data-theme` and `data-color-mode` attributes on your page's <html> tag.
 *
 * @param {Object<string, string>} themeState The themes and color mode that should be applied.
 * @param {string} themeState.colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.contrastMode The contrast mode theme to be applied. If set to `auto`, the theme applied will be determined by the OS setting.set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.dark The color theme to be applied when the color mode resolves to 'dark'.
 * @param {string} themeState.light The color theme to be applied when the color mode resolves to 'light'.
 * @param {string} themeState.shape The shape theme to be applied.
 * @param {string} themeState.spacing The spacing theme to be applied.
 * @param {string} themeState.typography The typography theme to be applied.
 * @param {Object} themeState.UNSAFE_themeOptions The custom branding options to be used for custom theme generation
 * @param {function} themeLoader Callback function used to override the default theme loading functionality.
 *
 * @returns A Promise of an unbind function, that can be used to stop listening for changes to system theme.
 *
 * @example
 * ```
 * setGlobalTheme({colorMode: 'auto', light: 'light', dark: 'dark', spacing: 'spacing'});
 * ```
 */ const $20672b0489e64708$var$setGlobalTheme = async ({ colorMode: colorMode = (0, $g0l9Y.themeStateDefaults)['colorMode'], contrastMode: contrastMode = (0, $g0l9Y.themeStateDefaults)['contrastMode'], dark: dark = (0, $g0l9Y.themeStateDefaults)['dark'], light: light = (0, $g0l9Y.themeStateDefaults)['light'], shape: shape = (0, $g0l9Y.themeStateDefaults)['shape'], spacing: spacing = (0, $g0l9Y.themeStateDefaults)['spacing'], typography: typography = (0, $g0l9Y.themeStateDefaults)['typography'](), UNSAFE_themeOptions: UNSAFE_themeOptions = (0, $g0l9Y.themeStateDefaults)['UNSAFE_themeOptions'] } = {}, themeLoader)=>{
    // CLEANUP: Remove. This blocks application of increased contrast themes
    // without the feature flag enabled.
    if (!(0, $fHpHg.fg)('platform_increased-contrast-themes')) {
        if (light === 'light-increased-contrast') light = 'light';
        if (dark === 'dark-increased-contrast') dark = 'dark';
    }
    const themeState = {
        colorMode: colorMode,
        contrastMode: contrastMode,
        dark: dark,
        light: light,
        shape: shape,
        spacing: spacing,
        typography: typography,
        UNSAFE_themeOptions: themeLoader ? undefined : UNSAFE_themeOptions
    };
    // Determine what to load and loading strategy
    let themePreferences = (0, $9OnAz.getThemePreferences)(themeState);
    const loadingStrategy = themeLoader ? themeLoader : (0, $iiK23.loadAndAppendThemeCss);
    // Load standard themes
    const loadingTasks = themePreferences.map(async (themeId)=>await loadingStrategy(themeId));
    // Load custom themes if needed
    if (!themeLoader && UNSAFE_themeOptions && (0, $9pyiD.isValidBrandHex)(UNSAFE_themeOptions?.brandColor)) {
        const mode = colorMode || (0, $g0l9Y.themeStateDefaults)['colorMode'];
        const attrOfMissingCustomStyles = (0, $dgTsQ.findMissingCustomStyleElements)(UNSAFE_themeOptions, mode);
        if (attrOfMissingCustomStyles.length > 0) // Load custom theme styles
        loadingTasks.push((async ()=>{
            const { loadAndAppendCustomThemeCss: loadAndAppendCustomThemeCss } = await (parcelRequire("73Bsz"));
            loadAndAppendCustomThemeCss({
                colorMode: attrOfMissingCustomStyles.length === 2 ? 'auto' : attrOfMissingCustomStyles[0],
                UNSAFE_themeOptions: UNSAFE_themeOptions
            });
        })());
    }
    await Promise.all(loadingTasks);
    // Load override themes after standard themes
    const themeOverridePreferences = (0, $9OnAz.getThemeOverridePreferences)(themeState);
    for (const themeId of themeOverridePreferences)await loadingStrategy(themeId);
    const autoUnbind = (0, $32uJh.default)(themeState);
    return autoUnbind;
};
var $20672b0489e64708$export$2e2bcd8739ae039 = $20672b0489e64708$var$setGlobalTheme;

});
parcelRegister("9pyiD", function(module, exports) {

$parcel$export(module.exports, "isValidBrandHex", () => $fffba3ac3e61a704$export$53031ac1ecb71f44);
$parcel$export(module.exports, "rgbToHex", () => $fffba3ac3e61a704$export$34d09c4a771c46ef);
$parcel$export(module.exports, "hexToRgbA", () => $fffba3ac3e61a704$export$b36dbdb4f463f05c);
$parcel$export(module.exports, "hexToRgb", () => $fffba3ac3e61a704$export$5a544e13ad4e1fa5);
$parcel$export(module.exports, "hexToHSL", () => $fffba3ac3e61a704$export$47ea145a83f50dc0);
$parcel$export(module.exports, "HSLToRGB", () => $fffba3ac3e61a704$export$1ff93e992dd58bec);
$parcel$export(module.exports, "relativeLuminanceW3C", () => $fffba3ac3e61a704$export$e770b01b744f3745);
$parcel$export(module.exports, "getContrastRatio", () => $fffba3ac3e61a704$export$d061e26956a60b0a);
$parcel$export(module.exports, "deltaE", () => $fffba3ac3e61a704$export$e8ddad763b4bebf9);
// valid hex color with 6 digits
const $fffba3ac3e61a704$export$53031ac1ecb71f44 = (hex)=>/^#[0-9A-F]{6}$/i.test(hex);
// valid hex color with 4, 6 or 8 digits
const $fffba3ac3e61a704$var$isValidHex = (hex)=>/^#([A-Fa-f0-9]{3,4}){1,2}$/.test(hex);
function $fffba3ac3e61a704$export$34d09c4a771c46ef(r, g, b) {
    return '#' + (16777216 + (r << 16) + (g << 8) + b).toString(16).slice(1);
}
function $fffba3ac3e61a704$export$1212645cf40ebf71(hex) {
    if (hex.length === 9) {
        const int = parseInt(hex.slice(7, 9), 16) / 255;
        return Number(parseFloat(int.toString()).toFixed(2));
    }
    return 1;
}
function $fffba3ac3e61a704$export$b36dbdb4f463f05c(hex) {
    if (!$fffba3ac3e61a704$var$isValidHex(hex)) throw new Error('Invalid HEX');
    let c;
    c = hex.substring(1).split('');
    if (c.length === 3) c = [
        c[0],
        c[0],
        c[1],
        c[1],
        c[2],
        c[2]
    ];
    c = '0x' + c.join('');
    return [
        c >> 16 & 255,
        c >> 8 & 255,
        c & 255,
        $fffba3ac3e61a704$export$1212645cf40ebf71(hex)
    ];
}
function $fffba3ac3e61a704$export$5a544e13ad4e1fa5(hex) {
    if (!$fffba3ac3e61a704$var$isValidHex(hex)) throw new Error('Invalid HEX');
    let c;
    c = hex.substring(1).split('');
    if (c.length === 3) c = [
        c[0],
        c[0],
        c[1],
        c[1],
        c[2],
        c[2]
    ];
    c = '0x' + c.join('');
    return [
        c >> 16 & 255,
        c >> 8 & 255,
        c & 255
    ];
}
function $fffba3ac3e61a704$export$47ea145a83f50dc0(hex) {
    if (!$fffba3ac3e61a704$var$isValidHex(hex)) throw new Error('Invalid HEX');
    let r = 0, g = 0, b = 0;
    if (hex.length === 4) {
        r = '0x' + hex[1] + hex[1];
        g = '0x' + hex[2] + hex[2];
        b = '0x' + hex[3] + hex[3];
    } else if (hex.length === 7) {
        r = '0x' + hex[1] + hex[2];
        g = '0x' + hex[3] + hex[4];
        b = '0x' + hex[5] + hex[6];
    }
    // Then to HSL
    r /= 255;
    g /= 255;
    b /= 255;
    let cmin = Math.min(r, g, b), cmax = Math.max(r, g, b), delta = cmax - cmin, h = 0, s = 0, l = 0;
    if (delta === 0) h = 0;
    else if (cmax === r) h = (g - b) / delta % 6;
    else if (cmax === g) h = (b - r) / delta + 2;
    else h = (r - g) / delta + 4;
    h = Math.round(h * 60);
    if (h < 0) h += 360;
    l = (cmax + cmin) / 2;
    s = delta === 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));
    s = +(s * 100).toFixed(1);
    l = +(l * 100).toFixed(1);
    return [
        h,
        s,
        l
    ];
}
function $fffba3ac3e61a704$export$1ff93e992dd58bec(h, s, l) {
    s /= 100;
    l /= 100;
    const k = (n)=>(n + h / 30) % 12;
    const a = s * Math.min(l, 1 - l);
    const f = (n)=>l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)));
    return [
        255 * f(0),
        255 * f(8),
        255 * f(4)
    ];
}
function $fffba3ac3e61a704$export$e770b01b744f3745(r, g, b) {
    const RsRGB = r / 255;
    const GsRGB = g / 255;
    const BsRGB = b / 255;
    const R = RsRGB <= 0.03928 ? RsRGB / 12.92 : Math.pow((RsRGB + 0.055) / 1.055, 2.4);
    const G = GsRGB <= 0.03928 ? GsRGB / 12.92 : Math.pow((GsRGB + 0.055) / 1.055, 2.4);
    const B = BsRGB <= 0.03928 ? BsRGB / 12.92 : Math.pow((BsRGB + 0.055) / 1.055, 2.4);
    // For the sRGB colorspace, the relative luminance of a color is defined as:
    const L = 0.2126 * R + 0.7152 * G + 0.0722 * B;
    return L;
}
function $fffba3ac3e61a704$export$d061e26956a60b0a(foreground, background) {
    if (!$fffba3ac3e61a704$var$isValidHex(foreground) || !$fffba3ac3e61a704$var$isValidHex(background)) throw new Error('Invalid HEX');
    const foregroundRgb = $fffba3ac3e61a704$export$5a544e13ad4e1fa5(foreground);
    const backgroundRgb = $fffba3ac3e61a704$export$5a544e13ad4e1fa5(background);
    const foregroundLuminance = $fffba3ac3e61a704$export$e770b01b744f3745(foregroundRgb[0], foregroundRgb[1], foregroundRgb[2]);
    const backgroundLuminance = $fffba3ac3e61a704$export$e770b01b744f3745(backgroundRgb[0], backgroundRgb[1], backgroundRgb[2]);
    // calculate the color contrast ratio
    var brightest = Math.max(foregroundLuminance, backgroundLuminance);
    var darkest = Math.min(foregroundLuminance, backgroundLuminance);
    return (brightest + 0.05) / (darkest + 0.05);
}
function $fffba3ac3e61a704$export$e8ddad763b4bebf9(rgbA, rgbB) {
    let labA = $fffba3ac3e61a704$var$rgbToLab(rgbA);
    let labB = $fffba3ac3e61a704$var$rgbToLab(rgbB);
    let deltaL = labA[0] - labB[0];
    let deltaA = labA[1] - labB[1];
    let deltaB = labA[2] - labB[2];
    let c1 = Math.sqrt(labA[1] * labA[1] + labA[2] * labA[2]);
    let c2 = Math.sqrt(labB[1] * labB[1] + labB[2] * labB[2]);
    let deltaC = c1 - c2;
    let deltaH = deltaA * deltaA + deltaB * deltaB - deltaC * deltaC;
    deltaH = deltaH < 0 ? 0 : Math.sqrt(deltaH);
    let sc = 1.0 + 0.045 * c1;
    let sh = 1.0 + 0.015 * c1;
    let deltaLKlsl = deltaL / 1.0;
    let deltaCkcsc = deltaC / sc;
    let deltaHkhsh = deltaH / sh;
    let i = deltaLKlsl * deltaLKlsl + deltaCkcsc * deltaCkcsc + deltaHkhsh * deltaHkhsh;
    return i < 0 ? 0 : Math.sqrt(i);
}
function $fffba3ac3e61a704$var$rgbToLab(rgb) {
    let r = rgb[0] / 255, g = rgb[1] / 255, b = rgb[2] / 255, x, y, z;
    r = r > 0.04045 ? Math.pow((r + 0.055) / 1.055, 2.4) : r / 12.92;
    g = g > 0.04045 ? Math.pow((g + 0.055) / 1.055, 2.4) : g / 12.92;
    b = b > 0.04045 ? Math.pow((b + 0.055) / 1.055, 2.4) : b / 12.92;
    x = (r * 0.4124 + g * 0.3576 + b * 0.1805) / 0.95047;
    y = (r * 0.2126 + g * 0.7152 + b * 0.0722) / 1.0;
    z = (r * 0.0193 + g * 0.1192 + b * 0.9505) / 1.08883;
    x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
    y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
    z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
    return [
        116 * y - 16,
        500 * (x - y),
        200 * (y - z)
    ];
}

});

parcelRegister("32uJh", function(module, exports) {

$parcel$export(module.exports, "default", () => $4475a5324cae6f53$export$2e2bcd8739ae039);

var $fHpHg = parcelRequire("fHpHg");

var $cEiXz = parcelRequire("cEiXz");

var $kh6sv = parcelRequire("kh6sv");

var $aItNG = parcelRequire("aItNG");
function $4475a5324cae6f53$export$2e2bcd8739ae039(themeState) {
    if (themeState.colorMode === 'auto') {
        // Set colorMode based on the user preference
        themeState.colorMode = (0, $kh6sv.default).getColorMode();
        // Bind a listener (if one doesn't already exist) to keep colorMode updated
        (0, $kh6sv.default).bind();
    } else (0, $kh6sv.default).unbind();
    if ((0, $fHpHg.fg)('platform_increased-contrast-themes')) {
        if (themeState.contrastMode === 'auto') {
            // Set contrastMode based on the user preference
            themeState.contrastMode = (0, $aItNG.default).getContrastMode();
            // Bind a listener (if one doesn't already exist) to keep contrastMode updated
            (0, $aItNG.default).bind();
        } else (0, $aItNG.default).unbind();
    }
    const themeAttributes = (0, $cEiXz.default)(themeState);
    Object.entries(themeAttributes).forEach(([key, value])=>{
        document.documentElement.setAttribute(key, value);
    });
    return ()=>{
        (0, $kh6sv.default).unbind();
        if ((0, $fHpHg.fg)('platform_increased-contrast-themes')) (0, $aItNG.default).unbind();
    };
}

});
parcelRegister("cEiXz", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ba648bb1686a709$export$2e2bcd8739ae039);

var $fHpHg = parcelRequire("fHpHg");

var $d5aOx = parcelRequire("d5aOx");

var $g0l9Y = parcelRequire("g0l9Y");

var $6nvuU = parcelRequire("6nvuU");

var $9pyiD = parcelRequire("9pyiD");

var $a2o2Q = parcelRequire("a2o2Q");
const $0ba648bb1686a709$var$defaultColorMode = 'light';
const $0ba648bb1686a709$var$defaultContrastMode = 'no-preference';
/**
 * Server-side rendering utility. Generates the valid HTML attributes for a given theme.
 * Note: this utility does not handle automatic theme switching.
 *
 * @param {Object<string, string>} themeOptions - Theme options object
 * @param {string} themeState.colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.dark The color theme to be applied when the color mode resolves to 'dark'.
 * @param {string} themeState.light The color theme to be applied when the color mode resolves to 'light'.
 * @param {string} themeState.spacing The spacing theme to be applied.
 * @param {string} themeState.typography The typography theme to be applied.
 * @param {Object} themeState.UNSAFE_themeOptions The custom branding options to be used for custom theme generation
 *
 * @returns {Object} Object of HTML attributes to be applied to the document root
 */ const $0ba648bb1686a709$var$getThemeHtmlAttrs = ({ colorMode: colorMode = (0, $g0l9Y.themeStateDefaults)['colorMode'], dark: dark = (0, $g0l9Y.themeStateDefaults)['dark'], light: light = (0, $g0l9Y.themeStateDefaults)['light'], contrastMode: contrastMode = (0, $g0l9Y.themeStateDefaults)['contrastMode'], shape: shape = (0, $g0l9Y.themeStateDefaults)['shape'], spacing: spacing = (0, $g0l9Y.themeStateDefaults)['spacing'], typography: typography = (0, $g0l9Y.themeStateDefaults)['typography'](), UNSAFE_themeOptions: UNSAFE_themeOptions = (0, $g0l9Y.themeStateDefaults)['UNSAFE_themeOptions'] } = {})=>{
    const themeAttribute = (0, $6nvuU.themeObjectToString)({
        dark: dark,
        light: light,
        shape: shape,
        spacing: spacing,
        typography: typography
    });
    let result = {
        [(0, $d5aOx.THEME_DATA_ATTRIBUTE)]: themeAttribute,
        [(0, $d5aOx.COLOR_MODE_ATTRIBUTE)]: colorMode === 'auto' ? $0ba648bb1686a709$var$defaultColorMode : colorMode
    };
    if ((0, $fHpHg.fg)('platform_increased-contrast-themes')) result = {
        ...result,
        // CLEANUP: Move this to the initial `result` assignment above
        [(0, $d5aOx.CONTRAST_MODE_ATTRIBUTE)]: contrastMode === 'auto' ? $0ba648bb1686a709$var$defaultContrastMode : contrastMode
    };
    if (UNSAFE_themeOptions && (0, $9pyiD.isValidBrandHex)(UNSAFE_themeOptions.brandColor)) {
        const optionString = JSON.stringify(UNSAFE_themeOptions);
        const uniqueId = (0, $a2o2Q.hash)(optionString);
        result[0, $d5aOx.CUSTOM_THEME_ATTRIBUTE] = uniqueId;
    }
    return result;
};
var $0ba648bb1686a709$export$2e2bcd8739ae039 = $0ba648bb1686a709$var$getThemeHtmlAttrs;

});
parcelRegister("a2o2Q", function(module, exports) {

$parcel$export(module.exports, "hash", () => $741e563d866156ae$export$d6af199866bfb566);
const $741e563d866156ae$export$d6af199866bfb566 = (str)=>{
    let hash = 0;
    for(let i = 0; i < str.length; i++){
        const char = str.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash &= hash; // Convert to 32bit integer
    }
    return new Uint32Array([
        hash
    ])[0].toString(36);
};

});


parcelRegister("kh6sv", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c21e290044137b0$export$2e2bcd8739ae039);

var $cBeZP = parcelRequire("cBeZP");

var $d5aOx = parcelRequire("d5aOx");

var $iiK23 = parcelRequire("iiK23");
const $1c21e290044137b0$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
/**
 * Updates the current theme when the system theme changes. Should be bound
 * to an event listener listening on the '(prefers-color-scheme: dark)' query
 * @param e The event representing a change in system theme.
 */ function $1c21e290044137b0$var$checkNativeListener(e) {
    const element = document.documentElement;
    element.setAttribute((0, $d5aOx.COLOR_MODE_ATTRIBUTE), e.matches ? 'dark' : 'light');
}
const $1c21e290044137b0$var$darkModeMql = $1c21e290044137b0$var$isMatchMediaAvailable && window.matchMedia((0, $iiK23.darkModeMediaQuery));
class $1c21e290044137b0$var$ColorModeObserver {
    getColorMode() {
        if (!$1c21e290044137b0$var$darkModeMql) return 'light';
        return $1c21e290044137b0$var$darkModeMql?.matches ? 'dark' : 'light';
    }
    bind() {
        if ($1c21e290044137b0$var$darkModeMql && this.unbindThemeChangeListener === null) this.unbindThemeChangeListener = (0, $cBeZP.bind)($1c21e290044137b0$var$darkModeMql, {
            type: 'change',
            listener: $1c21e290044137b0$var$checkNativeListener
        });
    }
    unbind() {
        if (this.unbindThemeChangeListener) {
            this.unbindThemeChangeListener();
            this.unbindThemeChangeListener = null;
        }
    }
    constructor(){
        this.unbindThemeChangeListener = null;
    }
}
/**
 * A singleton color mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ const $1c21e290044137b0$var$SingletonColorModeObserver = new $1c21e290044137b0$var$ColorModeObserver();
var $1c21e290044137b0$export$2e2bcd8739ae039 = $1c21e290044137b0$var$SingletonColorModeObserver;

});
parcelRegister("iiK23", function(module, exports) {

$parcel$export(module.exports, "loadAndAppendThemeCss", () => $ae52e25a1d849408$export$26cd7ae85c7144e5);
$parcel$export(module.exports, "loadThemeCss", () => $ae52e25a1d849408$export$8a48286ed7df6720);
$parcel$export(module.exports, "darkModeMediaQuery", () => $ae52e25a1d849408$export$bb1e815119d30f8b);
$parcel$export(module.exports, "moreContrastMediaQuery", () => $ae52e25a1d849408$export$8662df6937d86fcb);

var $fHpHg = parcelRequire("fHpHg");

var $5t8h3 = parcelRequire("5t8h3");

var $d5aOx = parcelRequire("d5aOx");
const $ae52e25a1d849408$export$26cd7ae85c7144e5 = async (themeId)=>{
    if (document.head.querySelector(`style[${(0, $d5aOx.THEME_DATA_ATTRIBUTE)}="${themeId}"]:not([${(0, $d5aOx.CUSTOM_THEME_ATTRIBUTE)}])`)) return;
    // Gracefully handles falsy values like `null` and `undefined` when maker ignore TS
    // to avoid loading default themes.
    if (!themeId) return;
    const themeCss = await $ae52e25a1d849408$export$8a48286ed7df6720(themeId);
    const style = document.createElement('style');
    style.textContent = themeCss;
    style.dataset.theme = themeId;
    document.head.appendChild(style);
};
const $ae52e25a1d849408$export$8a48286ed7df6720 = async (themeId)=>{
    if ((themeId === 'light' || themeId === 'dark') && (0, $fHpHg.fg)('platform-component-visual-refresh')) themeId += '-brand-refresh';
    const { default: themeCss } = await (0, $5t8h3.default)[themeId]();
    return themeCss;
};
const $ae52e25a1d849408$export$bb1e815119d30f8b = '(prefers-color-scheme: dark)';
const $ae52e25a1d849408$export$8662df6937d86fcb = '(prefers-contrast: more)';

});
parcelRegister("5t8h3", function(module, exports) {

$parcel$export(module.exports, "default", () => $588dbfaca14344cf$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * This file contains a dynamic import for each theme this package exports.
 * Themes are loaded asynchronously at runtime to minimise the amount of CSS we send to the client.
 * This allows users to compose their themes and only use the tokens that are requested.
 * When a new theme is created, the import should automatically be added to the map
 *
 * @codegen <<SignedSource::8352f41e09dfe9d45ead708661744456>>
 * @codegenCommand yarn build tokens
 */ 














const $588dbfaca14344cf$var$themeImportsMap = {
    'light': ()=>(parcelRequire("n0f6n")),
    'light-future': ()=>(parcelRequire("4TWOA")),
    'light-increased-contrast': ()=>(parcelRequire("9QPat")),
    'dark': ()=>(parcelRequire("53hlj")),
    'dark-future': ()=>(parcelRequire("2wYs0")),
    'dark-increased-contrast': ()=>(parcelRequire("fHJpQ")),
    'legacy-light': ()=>(parcelRequire("kdGME")),
    'legacy-dark': ()=>(parcelRequire("j0Ug3")),
    'spacing': ()=>(parcelRequire("7ANMq")),
    'typography-adg3': ()=>(parcelRequire("e1DSN")),
    'shape': ()=>(parcelRequire("5I9L0")),
    'typography-modernized': ()=>(parcelRequire("gnYr3")),
    'typography-refreshed': ()=>(parcelRequire("lEcXx")),
    'light-brand-refresh': ()=>(parcelRequire("8hYwE")),
    'dark-brand-refresh': ()=>(parcelRequire("jpLic"))
};
var $588dbfaca14344cf$export$2e2bcd8739ae039 = $588dbfaca14344cf$var$themeImportsMap;

});
parcelRegister("n0f6n", function(module, exports) {

let $04525644919754da$var$load = (parcelRequire("28QjX"))(4);
module.exports = $04525644919754da$var$load("gEQHL").then(()=>parcelRequire('aTZJB'));

});
parcelRegister("28QjX", function(module, exports) {
"use strict";


let $18f4e9fbd43d4c3b$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve(id), maxShards));
    };
module.exports = $18f4e9fbd43d4c3b$var$load;

});
parcelRegister("kPuw4", function(module, exports) {

$parcel$export(module.exports, "shardUrl", () => $f2a03df3e93d4e79$export$2bf9932c19d6a5d2, (v) => $f2a03df3e93d4e79$export$2bf9932c19d6a5d2 = v);
// TODO: convert this file to ESM once HMR issues are resolved
var $f2a03df3e93d4e79$export$2bf9932c19d6a5d2;
var $f2a03df3e93d4e79$export$1d37a31d51d1e3ed;
var $f2a03df3e93d4e79$export$b4cd98d62f81485f;
var $f2a03df3e93d4e79$export$108ff8fc702e621f;
var $f2a03df3e93d4e79$export$f6f4188f9108e61;
"use strict";
let $f2a03df3e93d4e79$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 *
 * @param {string} pathname
 * @returns {string}
 */ function $f2a03df3e93d4e79$var$getFilenameFromUrlPath(pathname) {
    let lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 *
 * @param {string} str
 * @param {number} maxShards
 * @returns {number}
 */ function $f2a03df3e93d4e79$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    let totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        let n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
let $f2a03df3e93d4e79$var$trailingShardRegex = /-\d+$/;
/**
 * @param {string} subdomain
 */ function $f2a03df3e93d4e79$var$removeTrailingShard(subdomain) {
    if (!$f2a03df3e93d4e79$var$trailingShardRegex.test(subdomain)) return subdomain;
    let shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 *
 * @param {string} domain
 * @param {number} shard
 */ function $f2a03df3e93d4e79$var$applyShardToDomain(domain, shard) {
    let i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    let shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$f2a03df3e93d4e79$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    let firstSubdomain = $f2a03df3e93d4e79$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $f2a03df3e93d4e79$var$shardUrlUnchecked(url, maxShards) {
    let parsedUrl = new URL(url);
    let fileName = $f2a03df3e93d4e79$var$getFilenameFromUrlPath(parsedUrl.pathname);
    let shardNumber = $f2a03df3e93d4e79$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $f2a03df3e93d4e79$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $f2a03df3e93d4e79$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$f2a03df3e93d4e79$var$globalKeyName]) return url;
    return $f2a03df3e93d4e79$var$shardUrlUnchecked(url, maxShards);
}
$f2a03df3e93d4e79$export$2bf9932c19d6a5d2 = $f2a03df3e93d4e79$var$shardUrl;
$f2a03df3e93d4e79$export$1d37a31d51d1e3ed = $f2a03df3e93d4e79$var$shardUrlUnchecked;
$f2a03df3e93d4e79$export$b4cd98d62f81485f = $f2a03df3e93d4e79$var$getDomainShardIndex;
$f2a03df3e93d4e79$export$108ff8fc702e621f = $f2a03df3e93d4e79$var$applyShardToDomain;
$f2a03df3e93d4e79$export$f6f4188f9108e61 = $f2a03df3e93d4e79$var$globalKeyName;

});

parcelRegister("dy9lH", function(module, exports) {

$parcel$export(module.exports, "register", () => $9dd5b3e06d7b5702$export$6503ec6e8aabbaf, (v) => $9dd5b3e06d7b5702$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $9dd5b3e06d7b5702$export$f7ad0328861e2f03, (v) => $9dd5b3e06d7b5702$export$f7ad0328861e2f03 = v);
var $9dd5b3e06d7b5702$export$6503ec6e8aabbaf;
var $9dd5b3e06d7b5702$export$f7ad0328861e2f03;
"use strict";
var $9dd5b3e06d7b5702$var$mapping = new Map();
function $9dd5b3e06d7b5702$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$9dd5b3e06d7b5702$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $9dd5b3e06d7b5702$var$resolve(id) {
    var resolved = $9dd5b3e06d7b5702$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$9dd5b3e06d7b5702$export$6503ec6e8aabbaf = $9dd5b3e06d7b5702$var$register;
$9dd5b3e06d7b5702$export$f7ad0328861e2f03 = $9dd5b3e06d7b5702$var$resolve;

});



parcelRegister("4TWOA", function(module, exports) {

let $3919ebe782acb836$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3919ebe782acb836$var$load("bPJN2").then(()=>parcelRequire('jx0tK'));

});

parcelRegister("9QPat", function(module, exports) {

let $72c0a9489f387392$var$load = (parcelRequire("28QjX"))(4);
module.exports = $72c0a9489f387392$var$load("hl8lH").then(()=>parcelRequire('foN6H'));

});

parcelRegister("53hlj", function(module, exports) {

let $3adaaf774ffbf64f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3adaaf774ffbf64f$var$load("daAG3").then(()=>parcelRequire('1WGJQ'));

});

parcelRegister("2wYs0", function(module, exports) {

let $1d7d76307dbf6c75$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1d7d76307dbf6c75$var$load("bXEKJ").then(()=>parcelRequire('7somK'));

});

parcelRegister("fHJpQ", function(module, exports) {

let $b6ee19d5ad3b4cd4$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b6ee19d5ad3b4cd4$var$load("cNb6z").then(()=>parcelRequire('2V5gE'));

});

parcelRegister("kdGME", function(module, exports) {

let $eb863583b6273220$var$load = (parcelRequire("28QjX"))(4);
module.exports = $eb863583b6273220$var$load("jg28y").then(()=>parcelRequire('3OvVE'));

});

parcelRegister("j0Ug3", function(module, exports) {

let $dd79a8111bc60374$var$load = (parcelRequire("28QjX"))(4);
module.exports = $dd79a8111bc60374$var$load("8i4lj").then(()=>parcelRequire('bFtyU'));

});

parcelRegister("7ANMq", function(module, exports) {

let $587282785206b7b4$var$load = (parcelRequire("28QjX"))(4);
module.exports = $587282785206b7b4$var$load("hXkhg").then(()=>parcelRequire('kh4hZ'));

});

parcelRegister("e1DSN", function(module, exports) {

let $a3601894b138b4de$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a3601894b138b4de$var$load("5z019").then(()=>parcelRequire('7o6kj'));

});

parcelRegister("5I9L0", function(module, exports) {

let $4288a163b1933e7f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4288a163b1933e7f$var$load("hCyxS").then(()=>parcelRequire('h9J5A'));

});

parcelRegister("gnYr3", function(module, exports) {

let $beddac8748f43150$var$load = (parcelRequire("28QjX"))(4);
module.exports = $beddac8748f43150$var$load("d9485").then(()=>parcelRequire('j6egZ'));

});

parcelRegister("lEcXx", function(module, exports) {

let $fc2762dd765ea793$var$load = (parcelRequire("28QjX"))(4);
module.exports = $fc2762dd765ea793$var$load("6fbhv").then(()=>parcelRequire('3JqYA'));

});

parcelRegister("8hYwE", function(module, exports) {

let $608edc60d3130304$var$load = (parcelRequire("28QjX"))(4);
module.exports = $608edc60d3130304$var$load("7Tj3m").then(()=>parcelRequire('eH99p'));

});

parcelRegister("jpLic", function(module, exports) {

let $e2250974556faa26$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e2250974556faa26$var$load("fzIYN").then(()=>parcelRequire('iEbCF'));

});




parcelRegister("aItNG", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b13c04834a85cc5$export$2e2bcd8739ae039);

var $cBeZP = parcelRequire("cBeZP");

var $d5aOx = parcelRequire("d5aOx");

var $iiK23 = parcelRequire("iiK23");
const $6b13c04834a85cc5$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
/**
 * Updates the current theme when the system contrast preference changes. Should be bound
 * to an event listener listening on the '(prefers-contrast: more)' query
 * @param e The event representing a change in system theme.
 */ function $6b13c04834a85cc5$var$checkNativeListener(e) {
    const element = document.documentElement;
    element.setAttribute((0, $d5aOx.CONTRAST_MODE_ATTRIBUTE), e.matches ? 'more' : 'no-preference');
}
const $6b13c04834a85cc5$var$contrastModeMql = $6b13c04834a85cc5$var$isMatchMediaAvailable && window.matchMedia((0, $iiK23.moreContrastMediaQuery));
class $6b13c04834a85cc5$var$ContrastModeObserver {
    getContrastMode() {
        if (!$6b13c04834a85cc5$var$contrastModeMql) return 'no-preference';
        return $6b13c04834a85cc5$var$contrastModeMql?.matches ? 'more' : 'no-preference';
    }
    bind() {
        if ($6b13c04834a85cc5$var$contrastModeMql && this.unbindContrastChangeListener === null) this.unbindContrastChangeListener = (0, $cBeZP.bind)($6b13c04834a85cc5$var$contrastModeMql, {
            type: 'change',
            listener: $6b13c04834a85cc5$var$checkNativeListener
        });
    }
    unbind() {
        if (this.unbindContrastChangeListener) {
            this.unbindContrastChangeListener();
            this.unbindContrastChangeListener = null;
        }
    }
    constructor(){
        this.unbindContrastChangeListener = null;
    }
}
/**
 * A singleton contrast mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ const $6b13c04834a85cc5$var$SingletonContrastModeObserver = new $6b13c04834a85cc5$var$ContrastModeObserver();
var $6b13c04834a85cc5$export$2e2bcd8739ae039 = $6b13c04834a85cc5$var$SingletonContrastModeObserver;

});


parcelRegister("dgTsQ", function(module, exports) {

$parcel$export(module.exports, "findMissingCustomStyleElements", () => $061d414f8c6eb3f5$export$bd1ac9300b0e885a);
$parcel$export(module.exports, "limitSizeOfCustomStyleElements", () => $061d414f8c6eb3f5$export$e7ae172320e03461);
$parcel$export(module.exports, "reduceTokenMap", () => $061d414f8c6eb3f5$export$e673f367da2ff23e);

var $lA9j2 = parcelRequire("lA9j2");

var $d5aOx = parcelRequire("d5aOx");

var $a2o2Q = parcelRequire("a2o2Q");
function $061d414f8c6eb3f5$export$bd1ac9300b0e885a(UNSAFE_themeOptions, mode) {
    const optionString = JSON.stringify(UNSAFE_themeOptions);
    const uniqueId = (0, $a2o2Q.hash)(optionString);
    const attrOfMissingCustomStyles = [];
    (mode === 'auto' ? [
        'light',
        'dark'
    ] : [
        mode
    ]).forEach((themeId)=>{
        const element = document.head.querySelector(`style[${(0, $d5aOx.CUSTOM_THEME_ATTRIBUTE)}="${uniqueId}"][${(0, $d5aOx.THEME_DATA_ATTRIBUTE)}="${themeId}"]`);
        if (element) // Append the existing custom styles to take precedence over others
        document.head.appendChild(element);
        else attrOfMissingCustomStyles.push(themeId);
    });
    return attrOfMissingCustomStyles;
}
function $061d414f8c6eb3f5$export$e7ae172320e03461(sizeThreshold) {
    const styleTags = [
        ...Array.from(document.head.querySelectorAll(`style[${(0, $d5aOx.CUSTOM_THEME_ATTRIBUTE)}][${(0, $d5aOx.THEME_DATA_ATTRIBUTE)}]`))
    ];
    if (styleTags.length < sizeThreshold) return;
    styleTags.slice(0, styleTags.length - (sizeThreshold - 1)).forEach((element)=>element.remove());
}
function $061d414f8c6eb3f5$export$e673f367da2ff23e(tokenMap, themeRamp) {
    return Object.entries(tokenMap).reduce((acc, [key, value])=>{
        const cssVar = (0, $lA9j2.default)[key];
        return cssVar ? `${acc}\n  ${cssVar}: ${typeof value === 'string' ? value : themeRamp[value]};` : acc;
    }, '');
}

});
parcelRegister("lA9j2", function(module, exports) {

$parcel$export(module.exports, "default", () => $26bbdd8d6c110c7c$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::02412877f3dbfda4dbaee7a917f24b6c>>
 * @codegenCommand yarn build tokens
 */ const $26bbdd8d6c110c7c$var$tokens = {
    'color.text': '--ds-text',
    'color.text.accent.lime': '--ds-text-accent-lime',
    'color.text.accent.lime.bolder': '--ds-text-accent-lime-bolder',
    'color.text.accent.red': '--ds-text-accent-red',
    'color.text.accent.red.bolder': '--ds-text-accent-red-bolder',
    'color.text.accent.orange': '--ds-text-accent-orange',
    'color.text.accent.orange.bolder': '--ds-text-accent-orange-bolder',
    'color.text.accent.yellow': '--ds-text-accent-yellow',
    'color.text.accent.yellow.bolder': '--ds-text-accent-yellow-bolder',
    'color.text.accent.green': '--ds-text-accent-green',
    'color.text.accent.green.bolder': '--ds-text-accent-green-bolder',
    'color.text.accent.teal': '--ds-text-accent-teal',
    'color.text.accent.teal.bolder': '--ds-text-accent-teal-bolder',
    'color.text.accent.blue': '--ds-text-accent-blue',
    'color.text.accent.blue.bolder': '--ds-text-accent-blue-bolder',
    'color.text.accent.purple': '--ds-text-accent-purple',
    'color.text.accent.purple.bolder': '--ds-text-accent-purple-bolder',
    'color.text.accent.magenta': '--ds-text-accent-magenta',
    'color.text.accent.magenta.bolder': '--ds-text-accent-magenta-bolder',
    'color.text.accent.gray': '--ds-text-accent-gray',
    'color.text.accent.gray.bolder': '--ds-text-accent-gray-bolder',
    'color.text.disabled': '--ds-text-disabled',
    'color.text.inverse': '--ds-text-inverse',
    'color.text.selected': '--ds-text-selected',
    'color.text.brand': '--ds-text-brand',
    'color.text.danger': '--ds-text-danger',
    'color.text.warning': '--ds-text-warning',
    'color.text.warning.inverse': '--ds-text-warning-inverse',
    'color.text.success': '--ds-text-success',
    'color.text.discovery': '--ds-text-discovery',
    'color.text.information': '--ds-text-information',
    'color.text.subtlest': '--ds-text-subtlest',
    'color.text.subtle': '--ds-text-subtle',
    'color.link': '--ds-link',
    'color.link.pressed': '--ds-link-pressed',
    'color.link.visited': '--ds-link-visited',
    'color.link.visited.pressed': '--ds-link-visited-pressed',
    'color.icon': '--ds-icon',
    'color.icon.accent.lime': '--ds-icon-accent-lime',
    'color.icon.accent.red': '--ds-icon-accent-red',
    'color.icon.accent.orange': '--ds-icon-accent-orange',
    'color.icon.accent.yellow': '--ds-icon-accent-yellow',
    'color.icon.accent.green': '--ds-icon-accent-green',
    'color.icon.accent.teal': '--ds-icon-accent-teal',
    'color.icon.accent.blue': '--ds-icon-accent-blue',
    'color.icon.accent.purple': '--ds-icon-accent-purple',
    'color.icon.accent.magenta': '--ds-icon-accent-magenta',
    'color.icon.accent.gray': '--ds-icon-accent-gray',
    'color.icon.disabled': '--ds-icon-disabled',
    'color.icon.inverse': '--ds-icon-inverse',
    'color.icon.selected': '--ds-icon-selected',
    'color.icon.brand': '--ds-icon-brand',
    'color.icon.danger': '--ds-icon-danger',
    'color.icon.warning': '--ds-icon-warning',
    'color.icon.warning.inverse': '--ds-icon-warning-inverse',
    'color.icon.success': '--ds-icon-success',
    'color.icon.discovery': '--ds-icon-discovery',
    'color.icon.information': '--ds-icon-information',
    'color.icon.subtlest': '--ds-icon-subtlest',
    'color.icon.subtle': '--ds-icon-subtle',
    'color.border': '--ds-border',
    'color.border.accent.lime': '--ds-border-accent-lime',
    'color.border.accent.red': '--ds-border-accent-red',
    'color.border.accent.orange': '--ds-border-accent-orange',
    'color.border.accent.yellow': '--ds-border-accent-yellow',
    'color.border.accent.green': '--ds-border-accent-green',
    'color.border.accent.teal': '--ds-border-accent-teal',
    'color.border.accent.blue': '--ds-border-accent-blue',
    'color.border.accent.purple': '--ds-border-accent-purple',
    'color.border.accent.magenta': '--ds-border-accent-magenta',
    'color.border.accent.gray': '--ds-border-accent-gray',
    'color.border.disabled': '--ds-border-disabled',
    'color.border.focused': '--ds-border-focused',
    'color.border.input': '--ds-border-input',
    'color.border.inverse': '--ds-border-inverse',
    'color.border.selected': '--ds-border-selected',
    'color.border.brand': '--ds-border-brand',
    'color.border.danger': '--ds-border-danger',
    'color.border.warning': '--ds-border-warning',
    'color.border.success': '--ds-border-success',
    'color.border.discovery': '--ds-border-discovery',
    'color.border.information': '--ds-border-information',
    'color.border.bold': '--ds-border-bold',
    'color.background.accent.lime.subtlest': '--ds-background-accent-lime-subtlest',
    'color.background.accent.lime.subtlest.hovered': '--ds-background-accent-lime-subtlest-hovered',
    'color.background.accent.lime.subtlest.pressed': '--ds-background-accent-lime-subtlest-pressed',
    'color.background.accent.lime.subtler': '--ds-background-accent-lime-subtler',
    'color.background.accent.lime.subtler.hovered': '--ds-background-accent-lime-subtler-hovered',
    'color.background.accent.lime.subtler.pressed': '--ds-background-accent-lime-subtler-pressed',
    'color.background.accent.lime.subtle': '--ds-background-accent-lime-subtle',
    'color.background.accent.lime.subtle.hovered': '--ds-background-accent-lime-subtle-hovered',
    'color.background.accent.lime.subtle.pressed': '--ds-background-accent-lime-subtle-pressed',
    'color.background.accent.lime.bolder': '--ds-background-accent-lime-bolder',
    'color.background.accent.lime.bolder.hovered': '--ds-background-accent-lime-bolder-hovered',
    'color.background.accent.lime.bolder.pressed': '--ds-background-accent-lime-bolder-pressed',
    'color.background.accent.red.subtlest': '--ds-background-accent-red-subtlest',
    'color.background.accent.red.subtlest.hovered': '--ds-background-accent-red-subtlest-hovered',
    'color.background.accent.red.subtlest.pressed': '--ds-background-accent-red-subtlest-pressed',
    'color.background.accent.red.subtler': '--ds-background-accent-red-subtler',
    'color.background.accent.red.subtler.hovered': '--ds-background-accent-red-subtler-hovered',
    'color.background.accent.red.subtler.pressed': '--ds-background-accent-red-subtler-pressed',
    'color.background.accent.red.subtle': '--ds-background-accent-red-subtle',
    'color.background.accent.red.subtle.hovered': '--ds-background-accent-red-subtle-hovered',
    'color.background.accent.red.subtle.pressed': '--ds-background-accent-red-subtle-pressed',
    'color.background.accent.red.bolder': '--ds-background-accent-red-bolder',
    'color.background.accent.red.bolder.hovered': '--ds-background-accent-red-bolder-hovered',
    'color.background.accent.red.bolder.pressed': '--ds-background-accent-red-bolder-pressed',
    'color.background.accent.orange.subtlest': '--ds-background-accent-orange-subtlest',
    'color.background.accent.orange.subtlest.hovered': '--ds-background-accent-orange-subtlest-hovered',
    'color.background.accent.orange.subtlest.pressed': '--ds-background-accent-orange-subtlest-pressed',
    'color.background.accent.orange.subtler': '--ds-background-accent-orange-subtler',
    'color.background.accent.orange.subtler.hovered': '--ds-background-accent-orange-subtler-hovered',
    'color.background.accent.orange.subtler.pressed': '--ds-background-accent-orange-subtler-pressed',
    'color.background.accent.orange.subtle': '--ds-background-accent-orange-subtle',
    'color.background.accent.orange.subtle.hovered': '--ds-background-accent-orange-subtle-hovered',
    'color.background.accent.orange.subtle.pressed': '--ds-background-accent-orange-subtle-pressed',
    'color.background.accent.orange.bolder': '--ds-background-accent-orange-bolder',
    'color.background.accent.orange.bolder.hovered': '--ds-background-accent-orange-bolder-hovered',
    'color.background.accent.orange.bolder.pressed': '--ds-background-accent-orange-bolder-pressed',
    'color.background.accent.yellow.subtlest': '--ds-background-accent-yellow-subtlest',
    'color.background.accent.yellow.subtlest.hovered': '--ds-background-accent-yellow-subtlest-hovered',
    'color.background.accent.yellow.subtlest.pressed': '--ds-background-accent-yellow-subtlest-pressed',
    'color.background.accent.yellow.subtler': '--ds-background-accent-yellow-subtler',
    'color.background.accent.yellow.subtler.hovered': '--ds-background-accent-yellow-subtler-hovered',
    'color.background.accent.yellow.subtler.pressed': '--ds-background-accent-yellow-subtler-pressed',
    'color.background.accent.yellow.subtle': '--ds-background-accent-yellow-subtle',
    'color.background.accent.yellow.subtle.hovered': '--ds-background-accent-yellow-subtle-hovered',
    'color.background.accent.yellow.subtle.pressed': '--ds-background-accent-yellow-subtle-pressed',
    'color.background.accent.yellow.bolder': '--ds-background-accent-yellow-bolder',
    'color.background.accent.yellow.bolder.hovered': '--ds-background-accent-yellow-bolder-hovered',
    'color.background.accent.yellow.bolder.pressed': '--ds-background-accent-yellow-bolder-pressed',
    'color.background.accent.green.subtlest': '--ds-background-accent-green-subtlest',
    'color.background.accent.green.subtlest.hovered': '--ds-background-accent-green-subtlest-hovered',
    'color.background.accent.green.subtlest.pressed': '--ds-background-accent-green-subtlest-pressed',
    'color.background.accent.green.subtler': '--ds-background-accent-green-subtler',
    'color.background.accent.green.subtler.hovered': '--ds-background-accent-green-subtler-hovered',
    'color.background.accent.green.subtler.pressed': '--ds-background-accent-green-subtler-pressed',
    'color.background.accent.green.subtle': '--ds-background-accent-green-subtle',
    'color.background.accent.green.subtle.hovered': '--ds-background-accent-green-subtle-hovered',
    'color.background.accent.green.subtle.pressed': '--ds-background-accent-green-subtle-pressed',
    'color.background.accent.green.bolder': '--ds-background-accent-green-bolder',
    'color.background.accent.green.bolder.hovered': '--ds-background-accent-green-bolder-hovered',
    'color.background.accent.green.bolder.pressed': '--ds-background-accent-green-bolder-pressed',
    'color.background.accent.teal.subtlest': '--ds-background-accent-teal-subtlest',
    'color.background.accent.teal.subtlest.hovered': '--ds-background-accent-teal-subtlest-hovered',
    'color.background.accent.teal.subtlest.pressed': '--ds-background-accent-teal-subtlest-pressed',
    'color.background.accent.teal.subtler': '--ds-background-accent-teal-subtler',
    'color.background.accent.teal.subtler.hovered': '--ds-background-accent-teal-subtler-hovered',
    'color.background.accent.teal.subtler.pressed': '--ds-background-accent-teal-subtler-pressed',
    'color.background.accent.teal.subtle': '--ds-background-accent-teal-subtle',
    'color.background.accent.teal.subtle.hovered': '--ds-background-accent-teal-subtle-hovered',
    'color.background.accent.teal.subtle.pressed': '--ds-background-accent-teal-subtle-pressed',
    'color.background.accent.teal.bolder': '--ds-background-accent-teal-bolder',
    'color.background.accent.teal.bolder.hovered': '--ds-background-accent-teal-bolder-hovered',
    'color.background.accent.teal.bolder.pressed': '--ds-background-accent-teal-bolder-pressed',
    'color.background.accent.blue.subtlest': '--ds-background-accent-blue-subtlest',
    'color.background.accent.blue.subtlest.hovered': '--ds-background-accent-blue-subtlest-hovered',
    'color.background.accent.blue.subtlest.pressed': '--ds-background-accent-blue-subtlest-pressed',
    'color.background.accent.blue.subtler': '--ds-background-accent-blue-subtler',
    'color.background.accent.blue.subtler.hovered': '--ds-background-accent-blue-subtler-hovered',
    'color.background.accent.blue.subtler.pressed': '--ds-background-accent-blue-subtler-pressed',
    'color.background.accent.blue.subtle': '--ds-background-accent-blue-subtle',
    'color.background.accent.blue.subtle.hovered': '--ds-background-accent-blue-subtle-hovered',
    'color.background.accent.blue.subtle.pressed': '--ds-background-accent-blue-subtle-pressed',
    'color.background.accent.blue.bolder': '--ds-background-accent-blue-bolder',
    'color.background.accent.blue.bolder.hovered': '--ds-background-accent-blue-bolder-hovered',
    'color.background.accent.blue.bolder.pressed': '--ds-background-accent-blue-bolder-pressed',
    'color.background.accent.purple.subtlest': '--ds-background-accent-purple-subtlest',
    'color.background.accent.purple.subtlest.hovered': '--ds-background-accent-purple-subtlest-hovered',
    'color.background.accent.purple.subtlest.pressed': '--ds-background-accent-purple-subtlest-pressed',
    'color.background.accent.purple.subtler': '--ds-background-accent-purple-subtler',
    'color.background.accent.purple.subtler.hovered': '--ds-background-accent-purple-subtler-hovered',
    'color.background.accent.purple.subtler.pressed': '--ds-background-accent-purple-subtler-pressed',
    'color.background.accent.purple.subtle': '--ds-background-accent-purple-subtle',
    'color.background.accent.purple.subtle.hovered': '--ds-background-accent-purple-subtle-hovered',
    'color.background.accent.purple.subtle.pressed': '--ds-background-accent-purple-subtle-pressed',
    'color.background.accent.purple.bolder': '--ds-background-accent-purple-bolder',
    'color.background.accent.purple.bolder.hovered': '--ds-background-accent-purple-bolder-hovered',
    'color.background.accent.purple.bolder.pressed': '--ds-background-accent-purple-bolder-pressed',
    'color.background.accent.magenta.subtlest': '--ds-background-accent-magenta-subtlest',
    'color.background.accent.magenta.subtlest.hovered': '--ds-background-accent-magenta-subtlest-hovered',
    'color.background.accent.magenta.subtlest.pressed': '--ds-background-accent-magenta-subtlest-pressed',
    'color.background.accent.magenta.subtler': '--ds-background-accent-magenta-subtler',
    'color.background.accent.magenta.subtler.hovered': '--ds-background-accent-magenta-subtler-hovered',
    'color.background.accent.magenta.subtler.pressed': '--ds-background-accent-magenta-subtler-pressed',
    'color.background.accent.magenta.subtle': '--ds-background-accent-magenta-subtle',
    'color.background.accent.magenta.subtle.hovered': '--ds-background-accent-magenta-subtle-hovered',
    'color.background.accent.magenta.subtle.pressed': '--ds-background-accent-magenta-subtle-pressed',
    'color.background.accent.magenta.bolder': '--ds-background-accent-magenta-bolder',
    'color.background.accent.magenta.bolder.hovered': '--ds-background-accent-magenta-bolder-hovered',
    'color.background.accent.magenta.bolder.pressed': '--ds-background-accent-magenta-bolder-pressed',
    'color.background.accent.gray.subtlest': '--ds-background-accent-gray-subtlest',
    'color.background.accent.gray.subtlest.hovered': '--ds-background-accent-gray-subtlest-hovered',
    'color.background.accent.gray.subtlest.pressed': '--ds-background-accent-gray-subtlest-pressed',
    'color.background.accent.gray.subtler': '--ds-background-accent-gray-subtler',
    'color.background.accent.gray.subtler.hovered': '--ds-background-accent-gray-subtler-hovered',
    'color.background.accent.gray.subtler.pressed': '--ds-background-accent-gray-subtler-pressed',
    'color.background.accent.gray.subtle': '--ds-background-accent-gray-subtle',
    'color.background.accent.gray.subtle.hovered': '--ds-background-accent-gray-subtle-hovered',
    'color.background.accent.gray.subtle.pressed': '--ds-background-accent-gray-subtle-pressed',
    'color.background.accent.gray.bolder': '--ds-background-accent-gray-bolder',
    'color.background.accent.gray.bolder.hovered': '--ds-background-accent-gray-bolder-hovered',
    'color.background.accent.gray.bolder.pressed': '--ds-background-accent-gray-bolder-pressed',
    'color.background.disabled': '--ds-background-disabled',
    'color.background.input': '--ds-background-input',
    'color.background.input.hovered': '--ds-background-input-hovered',
    'color.background.input.pressed': '--ds-background-input-pressed',
    'color.background.inverse.subtle': '--ds-background-inverse-subtle',
    'color.background.inverse.subtle.hovered': '--ds-background-inverse-subtle-hovered',
    'color.background.inverse.subtle.pressed': '--ds-background-inverse-subtle-pressed',
    'color.background.neutral': '--ds-background-neutral',
    'color.background.neutral.hovered': '--ds-background-neutral-hovered',
    'color.background.neutral.pressed': '--ds-background-neutral-pressed',
    'color.background.neutral.subtle': '--ds-background-neutral-subtle',
    'color.background.neutral.subtle.hovered': '--ds-background-neutral-subtle-hovered',
    'color.background.neutral.subtle.pressed': '--ds-background-neutral-subtle-pressed',
    'color.background.neutral.bold': '--ds-background-neutral-bold',
    'color.background.neutral.bold.hovered': '--ds-background-neutral-bold-hovered',
    'color.background.neutral.bold.pressed': '--ds-background-neutral-bold-pressed',
    'color.background.selected': '--ds-background-selected',
    'color.background.selected.hovered': '--ds-background-selected-hovered',
    'color.background.selected.pressed': '--ds-background-selected-pressed',
    'color.background.selected.bold': '--ds-background-selected-bold',
    'color.background.selected.bold.hovered': '--ds-background-selected-bold-hovered',
    'color.background.selected.bold.pressed': '--ds-background-selected-bold-pressed',
    'color.background.brand.subtlest': '--ds-background-brand-subtlest',
    'color.background.brand.subtlest.hovered': '--ds-background-brand-subtlest-hovered',
    'color.background.brand.subtlest.pressed': '--ds-background-brand-subtlest-pressed',
    'color.background.brand.bold': '--ds-background-brand-bold',
    'color.background.brand.bold.hovered': '--ds-background-brand-bold-hovered',
    'color.background.brand.bold.pressed': '--ds-background-brand-bold-pressed',
    'color.background.brand.boldest': '--ds-background-brand-boldest',
    'color.background.brand.boldest.hovered': '--ds-background-brand-boldest-hovered',
    'color.background.brand.boldest.pressed': '--ds-background-brand-boldest-pressed',
    'color.background.danger': '--ds-background-danger',
    'color.background.danger.hovered': '--ds-background-danger-hovered',
    'color.background.danger.pressed': '--ds-background-danger-pressed',
    'color.background.danger.bold': '--ds-background-danger-bold',
    'color.background.danger.bold.hovered': '--ds-background-danger-bold-hovered',
    'color.background.danger.bold.pressed': '--ds-background-danger-bold-pressed',
    'color.background.warning': '--ds-background-warning',
    'color.background.warning.hovered': '--ds-background-warning-hovered',
    'color.background.warning.pressed': '--ds-background-warning-pressed',
    'color.background.warning.bold': '--ds-background-warning-bold',
    'color.background.warning.bold.hovered': '--ds-background-warning-bold-hovered',
    'color.background.warning.bold.pressed': '--ds-background-warning-bold-pressed',
    'color.background.success': '--ds-background-success',
    'color.background.success.hovered': '--ds-background-success-hovered',
    'color.background.success.pressed': '--ds-background-success-pressed',
    'color.background.success.bold': '--ds-background-success-bold',
    'color.background.success.bold.hovered': '--ds-background-success-bold-hovered',
    'color.background.success.bold.pressed': '--ds-background-success-bold-pressed',
    'color.background.discovery': '--ds-background-discovery',
    'color.background.discovery.hovered': '--ds-background-discovery-hovered',
    'color.background.discovery.pressed': '--ds-background-discovery-pressed',
    'color.background.discovery.bold': '--ds-background-discovery-bold',
    'color.background.discovery.bold.hovered': '--ds-background-discovery-bold-hovered',
    'color.background.discovery.bold.pressed': '--ds-background-discovery-bold-pressed',
    'color.background.information': '--ds-background-information',
    'color.background.information.hovered': '--ds-background-information-hovered',
    'color.background.information.pressed': '--ds-background-information-pressed',
    'color.background.information.bold': '--ds-background-information-bold',
    'color.background.information.bold.hovered': '--ds-background-information-bold-hovered',
    'color.background.information.bold.pressed': '--ds-background-information-bold-pressed',
    'color.blanket': '--ds-blanket',
    'color.blanket.selected': '--ds-blanket-selected',
    'color.blanket.danger': '--ds-blanket-danger',
    'color.interaction.hovered': '--ds-interaction-hovered',
    'color.interaction.pressed': '--ds-interaction-pressed',
    'color.skeleton': '--ds-skeleton',
    'color.skeleton.subtle': '--ds-skeleton-subtle',
    'color.chart.categorical.1': '--ds-chart-categorical-1',
    'color.chart.categorical.1.hovered': '--ds-chart-categorical-1-hovered',
    'color.chart.categorical.2': '--ds-chart-categorical-2',
    'color.chart.categorical.2.hovered': '--ds-chart-categorical-2-hovered',
    'color.chart.categorical.3': '--ds-chart-categorical-3',
    'color.chart.categorical.3.hovered': '--ds-chart-categorical-3-hovered',
    'color.chart.categorical.4': '--ds-chart-categorical-4',
    'color.chart.categorical.4.hovered': '--ds-chart-categorical-4-hovered',
    'color.chart.categorical.5': '--ds-chart-categorical-5',
    'color.chart.categorical.5.hovered': '--ds-chart-categorical-5-hovered',
    'color.chart.categorical.6': '--ds-chart-categorical-6',
    'color.chart.categorical.6.hovered': '--ds-chart-categorical-6-hovered',
    'color.chart.categorical.7': '--ds-chart-categorical-7',
    'color.chart.categorical.7.hovered': '--ds-chart-categorical-7-hovered',
    'color.chart.categorical.8': '--ds-chart-categorical-8',
    'color.chart.categorical.8.hovered': '--ds-chart-categorical-8-hovered',
    'color.chart.lime.bold': '--ds-chart-lime-bold',
    'color.chart.lime.bold.hovered': '--ds-chart-lime-bold-hovered',
    'color.chart.lime.bolder': '--ds-chart-lime-bolder',
    'color.chart.lime.bolder.hovered': '--ds-chart-lime-bolder-hovered',
    'color.chart.lime.boldest': '--ds-chart-lime-boldest',
    'color.chart.lime.boldest.hovered': '--ds-chart-lime-boldest-hovered',
    'color.chart.neutral': '--ds-chart-neutral',
    'color.chart.neutral.hovered': '--ds-chart-neutral-hovered',
    'color.chart.red.bold': '--ds-chart-red-bold',
    'color.chart.red.bold.hovered': '--ds-chart-red-bold-hovered',
    'color.chart.red.bolder': '--ds-chart-red-bolder',
    'color.chart.red.bolder.hovered': '--ds-chart-red-bolder-hovered',
    'color.chart.red.boldest': '--ds-chart-red-boldest',
    'color.chart.red.boldest.hovered': '--ds-chart-red-boldest-hovered',
    'color.chart.orange.bold': '--ds-chart-orange-bold',
    'color.chart.orange.bold.hovered': '--ds-chart-orange-bold-hovered',
    'color.chart.orange.bolder': '--ds-chart-orange-bolder',
    'color.chart.orange.bolder.hovered': '--ds-chart-orange-bolder-hovered',
    'color.chart.orange.boldest': '--ds-chart-orange-boldest',
    'color.chart.orange.boldest.hovered': '--ds-chart-orange-boldest-hovered',
    'color.chart.yellow.bold': '--ds-chart-yellow-bold',
    'color.chart.yellow.bold.hovered': '--ds-chart-yellow-bold-hovered',
    'color.chart.yellow.bolder': '--ds-chart-yellow-bolder',
    'color.chart.yellow.bolder.hovered': '--ds-chart-yellow-bolder-hovered',
    'color.chart.yellow.boldest': '--ds-chart-yellow-boldest',
    'color.chart.yellow.boldest.hovered': '--ds-chart-yellow-boldest-hovered',
    'color.chart.green.bold': '--ds-chart-green-bold',
    'color.chart.green.bold.hovered': '--ds-chart-green-bold-hovered',
    'color.chart.green.bolder': '--ds-chart-green-bolder',
    'color.chart.green.bolder.hovered': '--ds-chart-green-bolder-hovered',
    'color.chart.green.boldest': '--ds-chart-green-boldest',
    'color.chart.green.boldest.hovered': '--ds-chart-green-boldest-hovered',
    'color.chart.teal.bold': '--ds-chart-teal-bold',
    'color.chart.teal.bold.hovered': '--ds-chart-teal-bold-hovered',
    'color.chart.teal.bolder': '--ds-chart-teal-bolder',
    'color.chart.teal.bolder.hovered': '--ds-chart-teal-bolder-hovered',
    'color.chart.teal.boldest': '--ds-chart-teal-boldest',
    'color.chart.teal.boldest.hovered': '--ds-chart-teal-boldest-hovered',
    'color.chart.blue.bold': '--ds-chart-blue-bold',
    'color.chart.blue.bold.hovered': '--ds-chart-blue-bold-hovered',
    'color.chart.blue.bolder': '--ds-chart-blue-bolder',
    'color.chart.blue.bolder.hovered': '--ds-chart-blue-bolder-hovered',
    'color.chart.blue.boldest': '--ds-chart-blue-boldest',
    'color.chart.blue.boldest.hovered': '--ds-chart-blue-boldest-hovered',
    'color.chart.purple.bold': '--ds-chart-purple-bold',
    'color.chart.purple.bold.hovered': '--ds-chart-purple-bold-hovered',
    'color.chart.purple.bolder': '--ds-chart-purple-bolder',
    'color.chart.purple.bolder.hovered': '--ds-chart-purple-bolder-hovered',
    'color.chart.purple.boldest': '--ds-chart-purple-boldest',
    'color.chart.purple.boldest.hovered': '--ds-chart-purple-boldest-hovered',
    'color.chart.magenta.bold': '--ds-chart-magenta-bold',
    'color.chart.magenta.bold.hovered': '--ds-chart-magenta-bold-hovered',
    'color.chart.magenta.bolder': '--ds-chart-magenta-bolder',
    'color.chart.magenta.bolder.hovered': '--ds-chart-magenta-bolder-hovered',
    'color.chart.magenta.boldest': '--ds-chart-magenta-boldest',
    'color.chart.magenta.boldest.hovered': '--ds-chart-magenta-boldest-hovered',
    'color.chart.gray.bold': '--ds-chart-gray-bold',
    'color.chart.gray.bold.hovered': '--ds-chart-gray-bold-hovered',
    'color.chart.gray.bolder': '--ds-chart-gray-bolder',
    'color.chart.gray.bolder.hovered': '--ds-chart-gray-bolder-hovered',
    'color.chart.gray.boldest': '--ds-chart-gray-boldest',
    'color.chart.gray.boldest.hovered': '--ds-chart-gray-boldest-hovered',
    'color.chart.brand': '--ds-chart-brand',
    'color.chart.brand.hovered': '--ds-chart-brand-hovered',
    'color.chart.danger': '--ds-chart-danger',
    'color.chart.danger.hovered': '--ds-chart-danger-hovered',
    'color.chart.danger.bold': '--ds-chart-danger-bold',
    'color.chart.danger.bold.hovered': '--ds-chart-danger-bold-hovered',
    'color.chart.warning': '--ds-chart-warning',
    'color.chart.warning.hovered': '--ds-chart-warning-hovered',
    'color.chart.warning.bold': '--ds-chart-warning-bold',
    'color.chart.warning.bold.hovered': '--ds-chart-warning-bold-hovered',
    'color.chart.success': '--ds-chart-success',
    'color.chart.success.hovered': '--ds-chart-success-hovered',
    'color.chart.success.bold': '--ds-chart-success-bold',
    'color.chart.success.bold.hovered': '--ds-chart-success-bold-hovered',
    'color.chart.discovery': '--ds-chart-discovery',
    'color.chart.discovery.hovered': '--ds-chart-discovery-hovered',
    'color.chart.discovery.bold': '--ds-chart-discovery-bold',
    'color.chart.discovery.bold.hovered': '--ds-chart-discovery-bold-hovered',
    'color.chart.information': '--ds-chart-information',
    'color.chart.information.hovered': '--ds-chart-information-hovered',
    'color.chart.information.bold': '--ds-chart-information-bold',
    'color.chart.information.bold.hovered': '--ds-chart-information-bold-hovered',
    'elevation.surface': '--ds-surface',
    'elevation.surface.hovered': '--ds-surface-hovered',
    'elevation.surface.pressed': '--ds-surface-pressed',
    'elevation.surface.overlay': '--ds-surface-overlay',
    'elevation.surface.overlay.hovered': '--ds-surface-overlay-hovered',
    'elevation.surface.overlay.pressed': '--ds-surface-overlay-pressed',
    'elevation.surface.raised': '--ds-surface-raised',
    'elevation.surface.raised.hovered': '--ds-surface-raised-hovered',
    'elevation.surface.raised.pressed': '--ds-surface-raised-pressed',
    'elevation.surface.sunken': '--ds-surface-sunken',
    'elevation.shadow.overflow': '--ds-shadow-overflow',
    'elevation.shadow.overflow.perimeter': '--ds-shadow-overflow-perimeter',
    'elevation.shadow.overflow.spread': '--ds-shadow-overflow-spread',
    'elevation.shadow.overlay': '--ds-shadow-overlay',
    'elevation.shadow.raised': '--ds-shadow-raised',
    'opacity.disabled': '--ds-opacity-disabled',
    'opacity.loading': '--ds-opacity-loading',
    'utility.UNSAFE.textTransformUppercase': '--ds-UNSAFE-textTransformUppercase',
    'utility.UNSAFE.transparent': '--ds-UNSAFE-transparent',
    'utility.elevation.surface.current': '--ds-elevation-surface-current',
    'border.radius.050': '--ds-border-radius-050',
    'border.radius': '--ds-border-radius',
    'border.radius.100': '--ds-border-radius-100',
    'border.radius.200': '--ds-border-radius-200',
    'border.radius.300': '--ds-border-radius-300',
    'border.radius.400': '--ds-border-radius-400',
    'border.radius.circle': '--ds-border-radius-circle',
    'border.width': '--ds-border-width',
    'border.width.0': '--ds-border-width-0',
    'border.width.indicator': '--ds-border-width-indicator',
    'border.width.outline': '--ds-border-width-outline',
    'space.0': '--ds-space-0',
    'space.025': '--ds-space-025',
    'space.050': '--ds-space-050',
    'space.075': '--ds-space-075',
    'space.100': '--ds-space-100',
    'space.150': '--ds-space-150',
    'space.200': '--ds-space-200',
    'space.250': '--ds-space-250',
    'space.300': '--ds-space-300',
    'space.400': '--ds-space-400',
    'space.500': '--ds-space-500',
    'space.600': '--ds-space-600',
    'space.800': '--ds-space-800',
    'space.1000': '--ds-space-1000',
    'space.negative.025': '--ds-space-negative-025',
    'space.negative.050': '--ds-space-negative-050',
    'space.negative.075': '--ds-space-negative-075',
    'space.negative.100': '--ds-space-negative-100',
    'space.negative.150': '--ds-space-negative-150',
    'space.negative.200': '--ds-space-negative-200',
    'space.negative.250': '--ds-space-negative-250',
    'space.negative.300': '--ds-space-negative-300',
    'space.negative.400': '--ds-space-negative-400',
    'font.heading.xxlarge': '--ds-font-heading-xxlarge',
    'font.heading.xlarge': '--ds-font-heading-xlarge',
    'font.heading.large': '--ds-font-heading-large',
    'font.heading.medium': '--ds-font-heading-medium',
    'font.heading.small': '--ds-font-heading-small',
    'font.heading.xsmall': '--ds-font-heading-xsmall',
    'font.heading.xxsmall': '--ds-font-heading-xxsmall',
    'font.body.large': '--ds-font-body-large',
    'font.body': '--ds-font-body',
    'font.body.small': '--ds-font-body-small',
    'font.body.UNSAFE_small': '--ds-font-body-UNSAFE_small',
    'font.code': '--ds-font-code',
    'font.weight.regular': '--ds-font-weight-regular',
    'font.weight.medium': '--ds-font-weight-medium',
    'font.weight.semibold': '--ds-font-weight-semibold',
    'font.weight.bold': '--ds-font-weight-bold',
    'font.family.heading': '--ds-font-family-heading',
    'font.family.body': '--ds-font-family-body',
    'font.family.code': '--ds-font-family-code',
    'font.family.brand.heading': '--ds-font-family-brand-heading',
    'font.family.brand.body': '--ds-font-family-brand-body'
};
var $26bbdd8d6c110c7c$export$2e2bcd8739ae039 = $26bbdd8d6c110c7c$var$tokens;

});


parcelRegister("9OnAz", function(module, exports) {

$parcel$export(module.exports, "getThemePreferences", () => $7a5153d7edec7888$export$dd6aeb7c823fc03d);
$parcel$export(module.exports, "getThemeOverridePreferences", () => $7a5153d7edec7888$export$5d76d7014f4a5d08);

var $fHpHg = parcelRequire("fHpHg");

var $cbJKd = parcelRequire("cbJKd");
const $7a5153d7edec7888$export$dd6aeb7c823fc03d = (themeState)=>{
    const { colorMode: colorMode, contrastMode: contrastMode, dark: dark, light: light, shape: shape, spacing: spacing, typography: typography } = themeState;
    const autoColorModeThemes = [
        light,
        dark
    ];
    const themePreferences = [];
    if (colorMode === 'auto') {
        if (contrastMode !== 'no-preference' && (0, $fHpHg.fg)('platform_increased-contrast-themes')) autoColorModeThemes.forEach((normalTheme)=>{
            const increasedContrastTheme = (0, $cbJKd.default)(normalTheme);
            if (increasedContrastTheme) autoColorModeThemes.push(increasedContrastTheme);
        });
        themePreferences.push(...autoColorModeThemes);
    } else {
        themePreferences.push(themeState[colorMode]);
        if (contrastMode !== 'no-preference' && (0, $fHpHg.fg)('platform_increased-contrast-themes')) {
            const increasedContrastTheme = (0, $cbJKd.default)(themeState[colorMode]);
            if (increasedContrastTheme) themePreferences.push(increasedContrastTheme);
        }
    }
    [
        shape,
        spacing,
        typography
    ].forEach((themeId)=>{
        if (themeId) themePreferences.push(themeId);
    });
    return [
        ...new Set(themePreferences)
    ];
};
const $7a5153d7edec7888$export$5d76d7014f4a5d08 = (_themeState)=>{
    const themeOverridePreferences = [];
    return [
        ...new Set(themeOverridePreferences)
    ];
};

});
parcelRegister("cbJKd", function(module, exports) {

$parcel$export(module.exports, "default", () => $3379054973275c5d$export$2e2bcd8739ae039);

var $g0l9Y = parcelRequire("g0l9Y");
function $3379054973275c5d$export$2e2bcd8739ae039(themeId) {
    return Object.entries((0, $g0l9Y.default)).find(([, { increasesContrastFor: increasesContrastFor }])=>{
        return increasesContrastFor === themeId;
    })?.[1].id;
}

});


parcelRegister("73Bsz", function(module, exports) {

let $5235def563a82061$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5235def563a82061$var$load("27oU7").then(()=>parcelRequire('guTYc'));

});




parcelRegister("gANiX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::56f9c413d8fbf4deb11215ad83bf4b70>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c146410ae6766a4c$var$_react = $c146410ae6766a4c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c146410ae6766a4c$var$_baseNew = $c146410ae6766a4c$var$_interopRequireDefault((parcelRequire("enEmH")));
function $c146410ae6766a4c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Cross".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: remove tag.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c146410ae6766a4c$var$CrossIcon = (props)=>/*#__PURE__*/ $c146410ae6766a4c$var$_react.default.createElement($c146410ae6766a4c$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m7.06 6 3.47-3.47-1.06-1.06L6 4.94 2.53 1.47 1.47 2.53 4.94 6 1.47 9.47l1.06 1.06L6 7.06l3.47 3.47 1.06-1.06z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$c146410ae6766a4c$var$CrossIcon.displayName = 'CrossIcon';
var $c146410ae6766a4c$var$_default = module.exports.default = $c146410ae6766a4c$var$CrossIcon;

});

parcelRegister("liZ21", function(module, exports) {

$parcel$export(module.exports, "default", () => $30b96961efea779f$export$2e2bcd8739ae039);
/* link.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $6tzHJ = parcelRequire("6tzHJ");

var $cD7p8 = parcelRequire("cD7p8");

var $42A03 = parcelRequire("42A03");

var $fHpHg = parcelRequire("fHpHg");

var $3YyrB = parcelRequire("3YyrB");

var $4gHTL = parcelRequire("4gHTL");

var $153Gb = parcelRequire("153Gb");
const $30b96961efea779f$var$styles = {
    base: "_2rkosqtm _11c82smr _v5649dqc _189eidpf _1rjc12x7 _1e0c116y _vchhusvi _1bsb1wug _p12f1osq _kqswh2mm _4cvr1q9y _1bah1h6o _gy1p1b66 _1o9zidpf _4t3iviql _k48p1wq8 _y4tiutpp _bozgutpp _y3gn1h6o _s7n4nkob _14mj1kw7 _9v7aze3t _1tv3nqa1 _39yqe4h9 _11fnglyw _18postnw",
    linkDecorationUnset: "_4bfu1r81 _1hmsagmp _ajmmvv82 _1a3b18uv _4fprglyw _5goinqa1 _9oik18uv _1bnxglyw _jf4cnqa1 _1nrm18uv _c2waglyw _1iohnqa1",
    disabled: "_80om13gf _bfhksyzs _syaz1lh4 _aetrglyw _irr3syzs _30l31lh4 _1di6syzs _9h8h1lh4",
    spacingCompact: "_1rjcv77o _gy1p1b66 _4t3i1k8s _y4tiutpp _bozgutpp _s7n4nkob",
    buttonIconBefore: "_bozgu2gc",
    buttonIconAfter: "_y4tiu2gc",
    fullWidth: "_1bsb1osq"
};
const $30b96961efea779f$var$defaultStyles = {
    root: "_bfhkiw92 _syaz10s3 _105310s3 _f8pj10s3 _irr3yw9d _30l310s3 _1di6ip91 _9h8h10s3",
    rootRefreshed: "_bfhk1w7a _syaz1gjq _8l3mmuej _aetrb3bt _10531gjq _f8pj1gjq _irr3166n _30l31gjq _1di61dty _9h8h1gjq"
};
const $30b96961efea779f$var$primaryStyles = {
    root: "_bfhkomb0 _syaz15cr _105315cr _f8pj15cr _30l315cr _irr31wqm _9h8h15cr _1di617hq"
};
const $30b96961efea779f$var$warningStyles = {
    root: "_bfhk1ikc _syazal3n _1053al3n _f8pjal3n _30l3al3n _irr31j43 _9h8hal3n _1di6h4op"
};
const $30b96961efea779f$var$dangerStyles = {
    root: "_bfhk1v7l _syaz15cr _105315cr _f8pj15cr _30l315cr _irr31rwk _9h8h15cr _1di6yycf"
};
const $30b96961efea779f$var$discoveryStyles = {
    root: "_bfhk1vbi _syaz15cr _105315cr _f8pj15cr _30l315cr _irr37gr8 _9h8h15cr _1di61wu2"
};
const $30b96961efea779f$var$subtleStyles = {
    root: "_bfhk1w7a _syaz10s3 _105310s3 _f8pj10s3 _irr34mfv _30l310s3 _1di619qy _9h8h10s3",
    rootRefreshed: "_bfhk1w7a _syaz1gjq _10531gjq _f8pj1mjl _irr34mfv _30l31gjq _1di619qy _9h8h1gjq"
};
const $30b96961efea779f$var$selectedStyles = {
    root: "_bfhk7btw _syaz1pke _10531pke _f8pj1pke _irr3i1yw _30l31pke _1di619ru _9h8h1pke",
    rootRefreshed: "_bfhkfg4m _syaz1ldt _8l3mcoux _aetrb3bt _10531ldt _f8pj1ldt _30l31ldt _9h8h1ldt",
    warning: "_bfhkvdtc _syaz16q2 _30l31pke _irr3vdtc _9h8h1pke _1di6vdtc",
    danger: "_bfhkbeib _syaz1pke _30l31pke _irr3beib _9h8h1pke _1di6beib",
    discovery: "_bfhk1g49 _syaz1pke _30l31pke _irr31g49 _9h8h1pke _1di61g49"
};
/**
 * __Link Button__
 *
 * Renders a link in the style of a button.
 *
 * - [Examples](https://atlassian.design/components/link-button/examples)
 * - [Code](https://atlassian.design/components/link-button/code)
 * - [Usage](https://atlassian.design/components/link-button/usage)
 */ const $30b96961efea779f$var$LinkButtonBase = ({ analyticsContext: analyticsContext, appearance: appearance = 'default', 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, autoFocus: autoFocus = false, children: children, href: href, iconAfter: iconAfter, iconBefore: iconBefore, interactionName: interactionName, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, shouldFitContainer: shouldFitContainer, spacing: spacing, testId: testId, ...unsafeRest }, ref)=>{
    // @ts-expect-error
    const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
    const hasIconAfter = Boolean(iconAfter);
    const hasIconBefore = Boolean(iconBefore);
    const localRef = (0, $5uXOq.useRef)(null);
    (0, $42A03.default)(localRef, autoFocus);
    const combinedRef = (0, $cD7p8.default)([
        localRef,
        ref
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $3YyrB.default), {
        analyticsContext: analyticsContext,
        ref: combinedRef,
        /**
   * Disable link in an accessible way using `href`, `role`, and `aria-disabled`.
   * @see https://a11y-guidelines.orange.com/en/articles/disable-elements/#disable-a-link
   */ // @ts-expect-error (`href` is required, we could make it optional but don't want to encourage this pattern elsewhere)
        href: isDisabled ? undefined : href,
        role: isDisabled ? 'link' : undefined,
        "aria-disabled": isDisabled === true ? true : undefined,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchEndCapture: onTouchEndCapture,
        onTouchStartCapture: onTouchStartCapture,
        testId: testId,
        componentName: "LinkButton",
        interactionName: interactionName,
        ...saferRest,
        xcss: (0, $6tzHJ.cx)($30b96961efea779f$var$styles.base, appearance === 'default' && ((0, $fHpHg.fg)('platform-component-visual-refresh') ? $30b96961efea779f$var$defaultStyles.rootRefreshed : $30b96961efea779f$var$defaultStyles.root), appearance === 'primary' && $30b96961efea779f$var$primaryStyles.root, appearance === 'warning' && $30b96961efea779f$var$warningStyles.root, appearance === 'danger' && $30b96961efea779f$var$dangerStyles.root, appearance === 'discovery' && $30b96961efea779f$var$discoveryStyles.root, appearance === 'subtle' && ((0, $fHpHg.fg)('platform-component-visual-refresh') ? $30b96961efea779f$var$subtleStyles.rootRefreshed : $30b96961efea779f$var$subtleStyles.root), $30b96961efea779f$var$styles.linkDecorationUnset, isSelected && ((0, $fHpHg.fg)('platform-component-visual-refresh') ? $30b96961efea779f$var$selectedStyles.rootRefreshed : $30b96961efea779f$var$selectedStyles.root), // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'danger' && $30b96961efea779f$var$selectedStyles.danger, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'warning' && $30b96961efea779f$var$selectedStyles.warning, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'discovery' && $30b96961efea779f$var$selectedStyles.discovery, isDisabled && $30b96961efea779f$var$styles.disabled, spacing === 'compact' && $30b96961efea779f$var$styles.spacingCompact, hasIconBefore && $30b96961efea779f$var$styles.buttonIconBefore, hasIconAfter && $30b96961efea779f$var$styles.buttonIconAfter, shouldFitContainer && $30b96961efea779f$var$styles.fullWidth),
        children: [
            iconBefore && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4gHTL.default), {
                type: "icon",
                position: "before",
                isLoading: false,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $153Gb.default), {
                    icon: iconBefore
                })
            }),
            children && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4gHTL.default), {
                isLoading: false,
                children: children
            }),
            iconAfter && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4gHTL.default), {
                type: "icon",
                position: "after",
                isLoading: false,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $153Gb.default), {
                    icon: iconAfter
                })
            })
        ]
    });
};
// Workarounds to support generic types with forwardRef
/**
 * __Link Button__
 *
 * Renders a link in the style of a button.
 *
 * - [Examples](https://atlassian.design/components/link-button/examples)
 * - [Code](https://atlassian.design/components/link-button/code)
 * - [Usage](https://atlassian.design/components/link-button/usage)
 */ const $30b96961efea779f$var$LinkButton = /*#__PURE__*/ (0, $5uXOq.forwardRef)($30b96961efea779f$var$LinkButtonBase);
$30b96961efea779f$var$LinkButton.displayName = 'LinkButton';
var $30b96961efea779f$export$2e2bcd8739ae039 = $30b96961efea779f$var$LinkButton;

});

parcelRegister("j7m8K", function(module, exports) {

$parcel$export(module.exports, "default", () => $73a73f4444085441$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");

var $bMFGq = parcelRequire("bMFGq");


var $cD7p8 = parcelRequire("cD7p8");

var $bKnKN = parcelRequire("bKnKN");

var $8yr9w = parcelRequire("8yr9w");

var $1tPGU = parcelRequire("1tPGU");

var $dGKFs = parcelRequire("dGKFs");

var $fHpHg = parcelRequire("fHpHg");

var $vCqQa = parcelRequire("vCqQa");

var $b4a3S = parcelRequire("b4a3S");

var $9cy75 = parcelRequire("9cy75");

var $coUPf = parcelRequire("coUPf");

var $7eFf2 = parcelRequire("7eFf2");

var $9uB2U = parcelRequire("9uB2U");

var $cIICU = parcelRequire("cIICU");
const $73a73f4444085441$var$gridSize = (0, $b4a3S.gridSize)();
const $73a73f4444085441$var$MAX_HEIGHT = `calc(100vh - ${$73a73f4444085441$var$gridSize * 2}px)`;
const $73a73f4444085441$var$opposites = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left',
    start: 'end',
    auto: 'auto',
    end: 'start'
};
const $73a73f4444085441$var$getFallbackPlacements = (placement)=>{
    const placementPieces = placement.split('-');
    const mainAxis = placementPieces[0];
    // Left, right and auto placements can rely on standard popper sliding behaviour
    if (![
        'top',
        'bottom'
    ].includes(mainAxis)) return undefined;
    else if (placementPieces.length === 2 && [
        'start',
        'end'
    ].includes(placementPieces[1])) {
        const crossAxis = placementPieces[1];
        return [
            `${mainAxis}`,
            `${mainAxis}-${$73a73f4444085441$var$opposites[crossAxis]}`,
            `${$73a73f4444085441$var$opposites[mainAxis]}-${crossAxis}`,
            `${$73a73f4444085441$var$opposites[mainAxis]}`,
            `${$73a73f4444085441$var$opposites[mainAxis]}-${$73a73f4444085441$var$opposites[crossAxis]}`,
            'auto'
        ];
    } else return [
        `${mainAxis}-start`,
        `${mainAxis}-end`,
        `${$73a73f4444085441$var$opposites[mainAxis]}`,
        `${$73a73f4444085441$var$opposites[mainAxis]}-start`,
        `${$73a73f4444085441$var$opposites[mainAxis]}-end`,
        `auto`
    ];
};
function $73a73f4444085441$var$isKeyboardEvent(event) {
    return event !== null && (event instanceof KeyboardEvent || 'nativeEvent' in event && event.nativeEvent instanceof KeyboardEvent);
}
/**
 * __Dropdown menu__
 *
 * A dropdown menu displays a list of actions or options to a user.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/usage)
 */ const $73a73f4444085441$var$DropdownMenu = ({ autoFocus: autoFocus = false, children: children, defaultOpen: defaultOpen = false, isLoading: isLoading = false, isOpen: isOpen, onOpenChange: onOpenChange = (0, $bKnKN.default), placement: placement = 'bottom-start', shouldFitContainer: shouldFitContainer = false, shouldFlip: shouldFlip = true, shouldRenderToParent: shouldRenderToParent = false, returnFocusRef: returnFocusRef, spacing: spacing, statusLabel: statusLabel, testId: testId, trigger: trigger, zIndex: zIndex = (0, $b4a3S.layers).modal(), label: label, interactionName: interactionName, strategy: strategy })=>{
    const [isLocalOpen, setLocalIsOpen] = (0, $8yr9w.default)(isOpen, ()=>defaultOpen);
    const triggerRef = (0, $5uXOq.useRef)(null);
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $5uXOq.useState)(false);
    const id = (0, $cIICU.default)();
    const itemRef = (0, $9uB2U.default)();
    const fallbackPlacements = (0, $5uXOq.useMemo)(()=>$73a73f4444085441$var$getFallbackPlacements(placement), [
        placement
    ]);
    const handleTriggerClicked = (0, $5uXOq.useCallback)(// TODO: event is an `any` and is being cast incorrectly
    // This means that the public type for `onOpenChange` is incorrect
    // current: (event: React.MouseEvent | React.KeyboardEvent) => void;
    // correct: (event: React.MouseEvent | KeyboardEvent) => void;
    // https://product-fabric.atlassian.net/browse/DSP-4692
    (event)=>{
        const newValue = !isLocalOpen;
        const { clientX: clientX, clientY: clientY, type: type, detail: detail } = event;
        if (type === 'keydown') setTriggeredUsingKeyboard(true);
        else if (clientX === 0 || clientY === 0) // Hitting enter/space is registered as a click
        // with both clientX and clientY === 0
        setTriggeredUsingKeyboard(true);
        else if (detail === 0) // Fix for Safari. clientX and clientY !== 0 in Safari
        setTriggeredUsingKeyboard(true);
        else {
            // The trigger element must be focused to avoid problems with an incorrectly focused element after closing DropdownMenu
            itemRef?.current?.focus();
            setTriggeredUsingKeyboard(false);
        }
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        isLocalOpen,
        setLocalIsOpen,
        onOpenChange,
        itemRef
    ]);
    const handleOnClose = (0, $5uXOq.useCallback)((event, currentLevel)=>{
        const isTabOrEscapeKey = $73a73f4444085441$var$isKeyboardEvent(event) && (event.key === 'Tab' || event.key === 'Escape');
        if (event !== null && !isTabOrEscapeKey && event.target instanceof HTMLElement && event.target.closest?.(`[id^=${(0, $cIICU.PREFIX)}] [aria-haspopup]`)) {
            // Check if it is within dropdown and it is a trigger button
            // if it is a nested dropdown, clicking trigger won't close the dropdown
            // Dropdown can be closed by pressing Escape, Tab or Shift + Tab
            if (!currentLevel) return;
            // if currentLevel is provided, we will compare with the given item's level
            // when it is available and larger than currentLevel, we will proceed the close behavior
            const toCloseLevel = itemRef.current?.dataset['ds-Level'];
            if (toCloseLevel && Number(toCloseLevel) < currentLevel) return;
        }
        // transfer focus to the element specified by ref
        // if ref is not provided, use old behavior:
        // focus on trigger when <Esc> or <Shift+Tab> is pressed
        if (returnFocusRef) requestAnimationFrame(()=>{
            returnFocusRef.current?.focus();
        });
        else if ($73a73f4444085441$var$isKeyboardEvent(event) && (event.key === 'Tab' && event.shiftKey || event.key === 'Escape')) requestAnimationFrame(()=>{
            itemRef.current?.focus();
        });
        else if (triggerRef.current) requestAnimationFrame(()=>{
            triggerRef.current?.focus();
        });
        const newValue = false;
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        itemRef,
        onOpenChange,
        returnFocusRef,
        setLocalIsOpen
    ]);
    const { isFocused: isFocused, bindFocus: bindFocus } = (0, $1tPGU.default)();
    // When a trigger is focused, we want to open the dropdown if
    // the user presses the DownArrow
    (0, $5uXOq.useEffect)(()=>{
        // Only need to listen for keydown when focused
        if (!isFocused) return 0, $bKnKN.default;
        // Being safe: we don't want to open the dropdown if it is already open
        // Note: This shouldn't happen as the trigger should not be able to get focus
        if (isLocalOpen) return 0, $bKnKN.default;
        return (0, $cBeZP.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                let isNestedTriggerButton;
                if (e.target instanceof HTMLElement) isNestedTriggerButton = e.target.closest(`[id^=${(0, $cIICU.PREFIX)}] [aria-haspopup]`);
                if (e.key === (0, $f13eec7fa1d5338f$export$a80636c6f41931fe) && !isNestedTriggerButton) {
                    // prevent page scroll
                    e.preventDefault();
                    handleTriggerClicked(e);
                } else if ((e.code === (0, $f13eec7fa1d5338f$export$e51a3576c045c8d5) || e.key === (0, $f13eec7fa1d5338f$export$8152f929a25a0ff4)) && e.detail === 0) // This allows us to focus on the first element if the dropdown was triggered by a custom trigger with a custom onClick
                setTriggeredUsingKeyboard(true);
                else if (e.key === (0, $f13eec7fa1d5338f$export$10f6869ed0a7d75b) && isNestedTriggerButton) // This closes dropdown if it is a nested dropdown
                handleOnClose(e);
            }
        });
    }, [
        isFocused,
        isLocalOpen,
        handleTriggerClicked,
        handleOnClose
    ]);
    /*
	 * The Popup component requires either:
	 * - shouldFitContainer={true} and shouldRenderToParent={true | undefined}
	 * or
	 * - shouldFitContainer={false | undefined} and shouldRenderToParent={true | false | undefined}
	 *
	 * But not:
	 * - shouldFitContainer={true} and shouldRenderToParent={false}
	 *
	 * By only including either shouldFitContainer or shouldRenderToParent, we can ensure that the Popup component
	 * types are satisfied.
	 */ const conditionalProps = shouldFitContainer ? {
        shouldFitContainer: shouldFitContainer,
        // When shouldFitContainer is true, `fixed` positions are not allowed
        strategy: strategy !== 'fixed' ? strategy : undefined
    } : {
        shouldRenderToParent: shouldRenderToParent,
        strategy: strategy
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7eFf2.default), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $vCqQa.default), {
            id: isLocalOpen ? id : undefined,
            shouldFlip: shouldFlip,
            isOpen: isLocalOpen,
            shouldReturnFocus: // If returnFocusRef is provided, we **don't** want to return focus to the trigger.
            // Otherwise, Popup will focus on the dropdown trigger after the `returnFocusRef` element is focused.
            returnFocusRef === undefined,
            onClose: handleOnClose,
            zIndex: zIndex,
            placement: placement,
            fallbackPlacements: fallbackPlacements,
            testId: testId && `${testId}--content`,
            shouldUseCaptureOnOutsideClick: true,
            ...conditionalProps,
            shouldDisableFocusLock: true,
            trigger: ({ ref: ref, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, // DSP-13312 TODO: remove spread props in future major release
            ...rest })=>{
                if (typeof trigger === 'function') return trigger({
                    'aria-controls': ariaControls,
                    'aria-expanded': ariaExpanded,
                    'aria-haspopup': ariaHasPopup,
                    ...rest,
                    ...bindFocus,
                    triggerRef: (0, $cD7p8.default)([
                        ref,
                        triggerRef,
                        itemRef
                    ]),
                    isSelected: isLocalOpen,
                    onClick: handleTriggerClicked,
                    testId: testId && `${testId}--trigger`
                });
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bMFGq.default), {
                    ...bindFocus,
                    ref: (0, $cD7p8.default)([
                        ref,
                        triggerRef,
                        itemRef
                    ]),
                    "aria-controls": ariaControls,
                    "aria-expanded": ariaExpanded,
                    "aria-haspopup": ariaHasPopup,
                    isSelected: isLocalOpen,
                    iconAfter: (0, (/*@__PURE__*/$parcel$interopDefault($dGKFs))),
                    onClick: handleTriggerClicked,
                    testId: testId && `${testId}--trigger`,
                    "aria-label": label,
                    ...(0, $fHpHg.fg)('platform_button_item-add-ufo-metrics') && {
                        interactionName: interactionName
                    },
                    children: trigger
                });
            },
            content: ({ setInitialFocusRef: setInitialFocusRef, update: update })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $9cy75.default), {
                    onClose: handleOnClose,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $coUPf.default), {
                        spacing: spacing,
                        maxHeight: $73a73f4444085441$var$MAX_HEIGHT,
                        maxWidth: shouldFitContainer ? undefined : 800,
                        onClose: handleOnClose,
                        onUpdate: update,
                        isLoading: isLoading,
                        statusLabel: statusLabel,
                        setInitialFocusRef: isTriggeredUsingKeyboard || autoFocus ? setInitialFocusRef : undefined,
                        shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
                        isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
                        autoFocus: autoFocus,
                        testId: testId && `${testId}--menu-wrapper`,
                        children: children
                    })
                })
        })
    });
};
var $73a73f4444085441$export$2e2bcd8739ae039 = $73a73f4444085441$var$DropdownMenu;

});
parcelRegister("8yr9w", function(module, exports) {

$parcel$export(module.exports, "default", () => $e318990e554ae976$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $e318990e554ae976$export$2e2bcd8739ae039(propValue, getDefaultPropValue = ()=>propValue) {
    const isControlled = propValue !== undefined;
    const [valueState, setValue] = (0, $5uXOq.useState)(getDefaultPropValue);
    const isControlledRef = (0, $5uXOq.useRef)(isControlled);
    (0, $5uXOq.useEffect)(()=>{
        isControlledRef.current = isControlled;
    }, [
        isControlled
    ]);
    const value = isControlled ? propValue : valueState;
    const setValueIfUncontrolled = (0, $5uXOq.useCallback)((newValue)=>{
        if (!isControlledRef.current) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}

});

parcelRegister("dGKFs", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5a08e2cd9fd0eae78f18da4572f37370>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9f7365db22205ecc$var$_react = $9f7365db22205ecc$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $9f7365db22205ecc$var$_chevronDown = $9f7365db22205ecc$var$_interopRequireDefault((parcelRequire("jVpd1")));

var $9f7365db22205ecc$var$_chevronDown2 = $9f7365db22205ecc$var$_interopRequireDefault((parcelRequire("cUaD8")));
function $9f7365db22205ecc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronDownIcon.
 * This component is ChevronDownIcon, with `UNSAFE_fallbackIcon` set to "ChevronDownIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for dropdown menus, selects, accordions, and expands.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9f7365db22205ecc$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $9f7365db22205ecc$var$_react.default.createElement($9f7365db22205ecc$var$_chevronDown.default, Object.assign({
        LEGACY_fallbackIcon: $9f7365db22205ecc$var$_chevronDown2.default
    }, props));
$9f7365db22205ecc$var$ChevronDownIcon.Name = 'ChevronDownIconMigration';
var $9f7365db22205ecc$var$_default = module.exports.default = $9f7365db22205ecc$var$ChevronDownIcon;

});

parcelRegister("9cy75", function(module, exports) {

$parcel$export(module.exports, "FocusManagerContext", () => $95f254b5889baee3$export$f18c1d4fc7326096);
$parcel$export(module.exports, "default", () => $95f254b5889baee3$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");

var $bKnKN = parcelRequire("bKnKN");

var $aLUgv = parcelRequire("aLUgv");

var $eZpn4 = parcelRequire("eZpn4");
const $95f254b5889baee3$export$f18c1d4fc7326096 = /*#__PURE__*/ (0, $5uXOq.createContext)({
    menuItemRefs: [],
    registerRef: (0, $bKnKN.default)
});
/**
 * Focus manager logic.
 */ const $95f254b5889baee3$var$FocusManager = ({ children: children, onClose: onClose })=>{
    const menuItemRefs = (0, $5uXOq.useRef)([]);
    // Used to force a re-render only
    const [refresh, setRefresh] = (0, $5uXOq.useState)(0);
    const registerMode = (0, $5uXOq.useRef)('ordered');
    registerMode.current = 'ordered';
    const registerRef = (0, $5uXOq.useCallback)((ref)=>{
        if (menuItemRefs.current.includes(ref)) return;
        switch(registerMode.current){
            case 'ordered':
                menuItemRefs.current.push(ref);
                break;
            case 'unordered':
                // Reset and force a rerender
                registerMode.current = 'regenerate';
                menuItemRefs.current = [];
                setRefresh(refresh + 1);
                break;
            case 'regenerate':
                break;
            default:
                throw new Error(`Unexpected case of ${registerMode.current}`);
        }
    }, // Updating register ref on force reload will cause `useRegisterItemWithFocusManager` to re-register
    [
        refresh
    ]);
    const { isLayerDisabled: isLayerDisabled } = (0, $aLUgv.useLayering)();
    // Intentionally rebinding on each render
    (0, $5uXOq.useEffect)(()=>{
        if (registerMode.current === 'ordered') // Use effect is called after rendering is complete and useEffects of the children a called first
        registerMode.current = 'unordered';
    });
    (0, $5uXOq.useEffect)(()=>(0, $cBeZP.bind)(window, {
            type: 'keydown',
            listener: (0, $eZpn4.default)(menuItemRefs, isLayerDisabled, onClose)
        }), [
        isLayerDisabled,
        onClose
    ]);
    const contextValue = {
        menuItemRefs: menuItemRefs.current,
        registerRef: registerRef
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)($95f254b5889baee3$export$f18c1d4fc7326096.Provider, {
        value: contextValue,
        children: children
    });
};
var $95f254b5889baee3$export$2e2bcd8739ae039 = $95f254b5889baee3$var$FocusManager;

});
parcelRegister("eZpn4", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad5498eaa07c7617$export$2e2bcd8739ae039);


var $fHpHg = parcelRequire("fHpHg");

var $cIICU = parcelRequire("cIICU");
const $ad5498eaa07c7617$var$actionMap = {
    [(0, $f13eec7fa1d5338f$export$a80636c6f41931fe)]: 'next',
    [(0, $f13eec7fa1d5338f$export$390330c10ff2b9a1)]: 'prev',
    [(0, $f13eec7fa1d5338f$export$4af703091671bc)]: 'first',
    [(0, $f13eec7fa1d5338f$export$e2bc30913faa5db7)]: 'last'
};
/**
 * `currentFocusedIdx + 1` will not work if the next focusable element
 * is disabled. So, we need to iterate through the following menu items
 * to find one that isn't disabled. If all following elements are disabled,
 * return undefined.
 */ const $ad5498eaa07c7617$var$getNextFocusableElement = (refs, currentFocusedIdx)=>{
    if ((0, $fHpHg.fg)('dropdown-menu-disabled-navigation-fix')) for(let i = 0; i < refs.length - 1; i++){
        if (currentFocusedIdx + 1 === refs.length) currentFocusedIdx = 0;
        else currentFocusedIdx++;
        const { current: element } = refs[currentFocusedIdx];
        const isValid = !!element && !element.hasAttribute('disabled');
        if (isValid) return element;
    }
    else while(currentFocusedIdx + 1 < refs.length){
        const { current: element } = refs[++currentFocusedIdx];
        const isValid = !!element && !element.hasAttribute('disabled');
        if (isValid) return element;
    }
};
/**
 * `currentFocusedIdx - 1` will not work if the prev focusable element
 * is disabled. So, we need to iterate through the previous menu items
 * to find one that isn't disabled. If all previous elements are disabled,
 * return undefined.
 */ const $ad5498eaa07c7617$var$getPrevFocusableElement = (refs, currentFocusedIdx)=>{
    if ((0, $fHpHg.fg)('dropdown-menu-disabled-navigation-fix')) for(let i = 0; i < refs.length - 1; i++){
        if (currentFocusedIdx === 0) currentFocusedIdx = refs.length - 1;
        else currentFocusedIdx--;
        const { current: element } = refs[currentFocusedIdx];
        const isValid = !!element && !element.hasAttribute('disabled');
        if (isValid) return element;
    }
    else while(currentFocusedIdx > 0){
        const { current: element } = refs[--currentFocusedIdx];
        const isValid = !!element && !element.hasAttribute('disabled');
        if (isValid) return element;
    }
};
function $ad5498eaa07c7617$export$2e2bcd8739ae039(refs, isLayerDisabled, onClose) {
    return (e)=>{
        const currentRefs = refs.current ?? [];
        const currentFocusedIdx = currentRefs.findIndex(({ current: el })=>el && document.activeElement?.isSameNode(el));
        if ((0, $fHpHg.fg)('platform_dst_popup-disable-focuslock')) {
            // if we use a popup as a nested dropdown, we must prevent the dropdown from closing.
            const isNestedDropdown = !!document.activeElement?.closest(`[id^=${(0, $cIICU.PREFIX)}]`);
            if (isLayerDisabled() && isNestedDropdown) {
                if (e.key === (0, $f13eec7fa1d5338f$export$10f6869ed0a7d75b) && !e.shiftKey) onClose(e);
                // if it is a nested dropdown and the level of the given dropdown is not the current level,
                // we don't need to have focus on it
                return;
            }
        } else if (isLayerDisabled()) {
            if (e.key === (0, $f13eec7fa1d5338f$export$10f6869ed0a7d75b) && !e.shiftKey) onClose(e);
            // if it is a nested dropdown and the level of the given dropdown is not the current level,
            // we don't need to have focus on it
            return;
        }
        const action = $ad5498eaa07c7617$var$actionMap[e.key];
        switch(action){
            case 'next':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                if ((0, $fHpHg.fg)('dropdown-menu-disabled-navigation-fix')) {
                    const nextFocusableElement = $ad5498eaa07c7617$var$getNextFocusableElement(currentRefs, currentFocusedIdx);
                    nextFocusableElement?.focus();
                    break;
                }
                // Remove on FG cleanup dropdown-menu-disabled-navigation-fix
                if (currentFocusedIdx < currentRefs.length - 1) {
                    const nextFocusableElement = $ad5498eaa07c7617$var$getNextFocusableElement(currentRefs, currentFocusedIdx);
                    nextFocusableElement?.focus();
                } else {
                    const firstFocusableElement = $ad5498eaa07c7617$var$getNextFocusableElement(currentRefs, -1);
                    firstFocusableElement?.focus();
                }
                break;
            case 'prev':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                if ((0, $fHpHg.fg)('dropdown-menu-disabled-navigation-fix')) {
                    const prevFocusableElement = $ad5498eaa07c7617$var$getPrevFocusableElement(currentRefs, currentFocusedIdx);
                    prevFocusableElement?.focus();
                    break;
                }
                // Remove on FG cleanup dropdown-menu-disabled-navigation-fix
                if (currentFocusedIdx > 0) {
                    const prevFocusableElement = $ad5498eaa07c7617$var$getPrevFocusableElement(currentRefs, currentFocusedIdx);
                    prevFocusableElement?.focus();
                } else {
                    const lastFocusableElement = $ad5498eaa07c7617$var$getPrevFocusableElement(currentRefs, currentRefs.length);
                    lastFocusableElement?.focus();
                }
                break;
            case 'first':
                e.preventDefault();
                // Search for first non-disabled element if first element is disabled
                const nextFocusableElement = $ad5498eaa07c7617$var$getNextFocusableElement(currentRefs, -1);
                nextFocusableElement?.focus();
                break;
            case 'last':
                e.preventDefault();
                // Search for last non-disabled element if last element is disabled
                const prevFocusableElement = $ad5498eaa07c7617$var$getPrevFocusableElement(currentRefs, currentRefs.length);
                prevFocusableElement?.focus();
                break;
            default:
                return;
        }
    };
}

});
parcelRegister("cIICU", function(module, exports) {

$parcel$export(module.exports, "PREFIX", () => $c2da2580c12ac378$export$8a682ae47622dbb9);
$parcel$export(module.exports, "default", () => $c2da2580c12ac378$export$2e2bcd8739ae039);

var $jJsBW = parcelRequire("jJsBW");
const $c2da2580c12ac378$export$8a682ae47622dbb9 = 'ds--dropdown--';
function $c2da2580c12ac378$export$2e2bcd8739ae039() {
    const id = (0, $jJsBW.useId)();
    return `${$c2da2580c12ac378$export$8a682ae47622dbb9}${id}`;
}

});



parcelRegister("coUPf", function(module, exports) {

$parcel$export(module.exports, "default", () => $4468743a8a0a5fca$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $aOrxC = parcelRequire("aOrxC");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");

var $clxo5 = parcelRequire("clxo5");

var $cvXkW = parcelRequire("cvXkW");

var $i4zkX = parcelRequire("i4zkX");

var $9cy75 = parcelRequire("9cy75");
const $4468743a8a0a5fca$var$spinnerContainerStyles = (0, $2s57o.xcss)({
    display: 'flex',
    minWidth: '160px',
    padding: 'space.250',
    justifyContent: 'center'
});
const $4468743a8a0a5fca$var$LoadingIndicator = ({ statusLabel: statusLabel = 'Loading', testId: testId })=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $0yZbT.default), {
        xcss: $4468743a8a0a5fca$var$spinnerContainerStyles,
        role: "menuitem"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $clxo5.default), {
        size: "small",
        label: statusLabel,
        testId: testId
    }));
/**
 *
 * MenuWrapper wraps all the menu items.
 * It handles the logic to close the menu when a MenuItem is clicked, but leaves it open
 * if a CheckboxItem or RadioItem is clicked.
 * It also sets focus to the first menu item when opened.
 */ const $4468743a8a0a5fca$var$MenuWrapper = ({ children: children, isLoading: isLoading, maxHeight: maxHeight, maxWidth: maxWidth, onClose: onClose, onUpdate: onUpdate, statusLabel: statusLabel, setInitialFocusRef: setInitialFocusRef, shouldRenderToParent: shouldRenderToParent, spacing: spacing, testId: testId, isTriggeredUsingKeyboard: isTriggeredUsingKeyboard, autoFocus: autoFocus })=>{
    const { menuItemRefs: menuItemRefs } = (0, $5uXOq.useContext)((0, $9cy75.FocusManagerContext));
    const closeOnMenuItemClick = (e)=>{
        const isTargetMenuItemOrDescendant = menuItemRefs.some((menuItemRef)=>{
            const { current: menuItem } = menuItemRef;
            if (!menuItem) return false;
            const isCheckboxOrRadio = (0, $cvXkW.default)(menuItem) || (0, $i4zkX.default)(menuItem);
            return menuItem.contains(e.target) && !isCheckboxOrRadio;
        });
        // Close menu if the click is triggered from a MenuItem or
        // its descendant. Don't close the menu if the click is triggered
        // from a MenuItemRadio or MenuItemCheckbox so that the user can
        // select multiple items.
        if (isTargetMenuItemOrDescendant && onClose) onClose(e);
    };
    // Using useEffect here causes a flicker.
    // useLayoutEffect ensures that the update and render happen in the same
    // rAF tick.
    (0, $5uXOq.useLayoutEffect)(()=>{
        onUpdate();
    }, [
        isLoading,
        onUpdate
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const firstFocusableRef = menuItemRefs.map(({ current: current })=>current).find((el)=>!!el && !el.hasAttribute('disabled')) ?? null;
        if (shouldRenderToParent && (isTriggeredUsingKeyboard || autoFocus)) firstFocusableRef?.focus();
        setInitialFocusRef?.(firstFocusableRef);
    }, [
        menuItemRefs,
        setInitialFocusRef,
        autoFocus,
        shouldRenderToParent,
        isTriggeredUsingKeyboard
    ]);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $aOrxC.default), {
        isLoading: isLoading,
        maxHeight: maxHeight,
        maxWidth: maxWidth,
        onClick: closeOnMenuItemClick,
        role: "menu",
        spacing: spacing,
        testId: testId && `${testId}--menu-group`
    }, isLoading ? /*#__PURE__*/ (0, $f8Sb3.jsx)($4468743a8a0a5fca$var$LoadingIndicator, {
        statusLabel: statusLabel,
        testId: testId && `${testId}--loading-indicator`
    }) : children);
};
var $4468743a8a0a5fca$export$2e2bcd8739ae039 = $4468743a8a0a5fca$var$MenuWrapper;

});
parcelRegister("cvXkW", function(module, exports) {

$parcel$export(module.exports, "default", () => $85822779d80879fa$export$2e2bcd8739ae039);
function $85822779d80879fa$export$2e2bcd8739ae039(element) {
    const role = element.getAttribute('role');
    return role === 'checkbox' || role === 'menuitemcheckbox';
}

});

parcelRegister("i4zkX", function(module, exports) {

$parcel$export(module.exports, "default", () => $06c4bed79b48ee4c$export$2e2bcd8739ae039);
function $06c4bed79b48ee4c$export$2e2bcd8739ae039(element) {
    const role = element.getAttribute('role');
    return role === 'radio' || role === 'menuitemradio';
}

});


parcelRegister("7eFf2", function(module, exports) {

$parcel$export(module.exports, "SelectionStoreContext", () => $1de2d35c6288e8da$export$756f795847463ebd);
$parcel$export(module.exports, "default", () => $1de2d35c6288e8da$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bKnKN = parcelRequire("bKnKN");
const $1de2d35c6288e8da$export$756f795847463ebd = /*#__PURE__*/ (0, $5uXOq.createContext)({
    setItemState: (0, $bKnKN.default),
    getItemState: ()=>undefined,
    setGroupState: (0, $bKnKN.default),
    getGroupState: ()=>({})
});
/**
 * Selection store will persist data as long as it remains mounted.
 * It handles the uncontrolled story for dropdown menu when the menu
 * items can be mounted/unmounted depending if the menu is open or closed.
 */ const $1de2d35c6288e8da$var$SelectionStore = (props)=>{
    const { children: children } = props;
    const store = (0, $5uXOq.useRef)({});
    const context = (0, $5uXOq.useMemo)(()=>({
            setItemState: (group, id, value)=>{
                if (!store.current[group]) store.current[group] = {};
                store.current[group][id] = value;
            },
            getItemState: (group, id)=>{
                if (!store.current[group]) return undefined;
                return store.current[group][id];
            },
            setGroupState: (group, value)=>{
                store.current[group] = value;
            },
            getGroupState: (group)=>{
                return store.current[group] || {};
            }
        }), []);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($1de2d35c6288e8da$export$756f795847463ebd.Provider, {
        value: context,
        children: children
    });
};
var $1de2d35c6288e8da$export$2e2bcd8739ae039 = $1de2d35c6288e8da$var$SelectionStore;

});

parcelRegister("9uB2U", function(module, exports) {

$parcel$export(module.exports, "default", () => $5652af3ddf3a4757$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $fHpHg = parcelRequire("fHpHg");

var $9cy75 = parcelRequire("9cy75");
// This function is called whenever a MenuItem mounts.
// The refs stored in the context are used to programmatically
// control focus on a user navigates using the keyboard.
function $5652af3ddf3a4757$var$useRegisterItemWithFocusManager(hasPopup = false) {
    const { registerRef: registerRef } = (0, $5uXOq.useContext)((0, $9cy75.FocusManagerContext));
    const itemRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        if (hasPopup && (0, $fHpHg.fg)('select-avoid-duplicated-registered-ref')) return;
        registerRef(itemRef);
    }, [
        registerRef,
        hasPopup
    ]);
    return itemRef;
}
var $5652af3ddf3a4757$export$2e2bcd8739ae039 = $5652af3ddf3a4757$var$useRegisterItemWithFocusManager;

});


parcelRegister("1eETS", function(module, exports) {

$parcel$export(module.exports, "default", () => $71020946ef5a906e$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $cD7p8 = parcelRequire("cD7p8");

var $7H980 = parcelRequire("7H980");

var $2COCu = parcelRequire("2COCu");

var $44qT7 = parcelRequire("44qT7");

var $fHpHg = parcelRequire("fHpHg");

var $9uB2U = parcelRequire("9uB2U");
/**
 * __Dropdown menu item__
 *
 * A dropdown item populates the dropdown menu with items. Every item should be inside a dropdown item group.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/dropdown-item/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/dropdown-item/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/dropdown-item/usage)
 */ const $71020946ef5a906e$var$DropdownMenuItem = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, component: component, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, rel: rel, shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, target: target, testId: testId, UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink, returnFocusRef: returnFocusRef, interactionName: interactionName, role: role, ...rest }, ref)=>{
    // if the dropdown item has aria-haspopup, we won't register with focus manager
    // since it is a nested trigger, we have registered inside dropdown-menu
    const itemRef = (0, $9uB2U.default)(!!rest['aria-haspopup']);
    const handleItemClick = (0, $5uXOq.useCallback)((event)=>{
        if (returnFocusRef?.current) returnFocusRef.current.focus();
        if (onClick) onClick(event);
    }, [
        onClick,
        returnFocusRef
    ]);
    if (component) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2COCu.default), {
        component: component,
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $cD7p8.default)([
            ref,
            itemRef
        ]),
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        href: href,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        ...(0, $fHpHg.fg)('platform_button_item-add-ufo-metrics') && {
            interactionName: interactionName
        },
        ...rest,
        children: children
    });
    else if (href) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $44qT7.default), {
        description: description,
        href: href,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $cD7p8.default)([
            ref,
            itemRef
        ]),
        rel: rel,
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        target: target,
        testId: testId,
        UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink,
        ...(0, $fHpHg.fg)('platform_button_item-add-ufo-metrics') && {
            interactionName: interactionName
        },
        ...rest,
        children: children
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7H980.default), {
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $cD7p8.default)([
            ref,
            itemRef
        ]),
        role: role || 'menuitem',
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        ...(0, $fHpHg.fg)('platform_button_item-add-ufo-metrics') && {
            interactionName: interactionName
        },
        ...rest,
        children: children
    });
});
var $71020946ef5a906e$export$2e2bcd8739ae039 = $71020946ef5a906e$var$DropdownMenuItem;

});

parcelRegister("3jAdT", function(module, exports) {

$parcel$export(module.exports, "default", () => $a634616eedbbb354$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $jJsBW = parcelRequire("jJsBW");

var $70rf1 = parcelRequire("70rf1");

var $c320O = parcelRequire("c320O");
/**
 * __Dropdown item checkbox group__
 *
 * A wrapping element for dropdown menu items.
 *
 */ const $a634616eedbbb354$var$DropdownMenuItemGroup = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, id: id, isList: isList, isScrollable: isScrollable, title: title, testId: testId, hasSeparator: hasSeparator, overrides: overrides, ...rest }, ref)=>{
    const uid = (0, $jJsBW.useId)();
    const titleId = `dropdown-menu-item-group-title-${uid}`;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $70rf1.default), {
        id: id,
        ref: ref,
        isList: isList,
        isScrollable: isScrollable,
        hasSeparator: hasSeparator,
        testId: testId,
        titleId: title ? titleId : undefined,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides, @atlaskit/design-system/no-deprecated-apis
        overrides: overrides,
        ...rest,
        children: [
            title && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $c320O.default), {
                id: titleId,
                title: title
            }),
            children
        ]
    });
});
var $a634616eedbbb354$export$2e2bcd8739ae039 = $a634616eedbbb354$var$DropdownMenuItemGroup;

});
parcelRegister("c320O", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c72deebd8bbb30f$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");
const $5c72deebd8bbb30f$var$headingStyles = (0, $2s57o.xcss)({
    color: 'color.text.subtle',
    font: 'font.heading.xxsmall',
    paddingBlock: 'space.0',
    paddingInline: 'space.200'
});
/**
 * __Group title__
 *
 * Used to visually represent the title for DropdownMenu groups
 *
 * @internal
 */ const $5c72deebd8bbb30f$var$GroupTitle = ({ id: id, title: title })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $0yZbT.default), {
        "data-ds--menu--heading-item": true,
        role: "menuitem",
        id: id,
        "aria-hidden": "true",
        xcss: $5c72deebd8bbb30f$var$headingStyles,
        children: title
    });
var $5c72deebd8bbb30f$export$2e2bcd8739ae039 = $5c72deebd8bbb30f$var$GroupTitle;

});


parcelRegister("elaEw", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9b775822095ff11ff1cfe3f316db8614>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a70b4a38865b344e$var$_react = $a70b4a38865b344e$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $a70b4a38865b344e$var$_showMoreHorizontal = $a70b4a38865b344e$var$_interopRequireDefault((parcelRequire("c8rIN")));

var $a70b4a38865b344e$var$_more = $a70b4a38865b344e$var$_interopRequireDefault((parcelRequire("f6ajG")));
function $a70b4a38865b344e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ShowMoreHorizontalIcon.
 * This component is ShowMoreHorizontalIcon, with `UNSAFE_fallbackIcon` set to "MoreIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for more action menus.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a70b4a38865b344e$var$ShowMoreHorizontalIcon = (props)=>/*#__PURE__*/ $a70b4a38865b344e$var$_react.default.createElement($a70b4a38865b344e$var$_showMoreHorizontal.default, Object.assign({
        LEGACY_fallbackIcon: $a70b4a38865b344e$var$_more.default
    }, props));
$a70b4a38865b344e$var$ShowMoreHorizontalIcon.Name = 'ShowMoreHorizontalIconMigration';
var $a70b4a38865b344e$var$_default = module.exports.default = $a70b4a38865b344e$var$ShowMoreHorizontalIcon;

});

parcelRegister("acmVr", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::271d2db9eb5cbaef3f993286190920ae>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $76cccee3927cb0e3$var$_react = $76cccee3927cb0e3$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $76cccee3927cb0e3$var$_clock = $76cccee3927cb0e3$var$_interopRequireDefault((parcelRequire("5purl")));

var $76cccee3927cb0e3$var$_recent = $76cccee3927cb0e3$var$_interopRequireDefault((parcelRequire("6PZTp")));
function $76cccee3927cb0e3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ClockIcon.
 * This component is ClockIcon, with `UNSAFE_fallbackIcon` set to "RecentIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: recent, time input, sprint time remaining. Overdue task issue status in JSM Calendar view.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $76cccee3927cb0e3$var$ClockIcon = (props)=>/*#__PURE__*/ $76cccee3927cb0e3$var$_react.default.createElement($76cccee3927cb0e3$var$_clock.default, Object.assign({
        LEGACY_fallbackIcon: $76cccee3927cb0e3$var$_recent.default
    }, props));
$76cccee3927cb0e3$var$ClockIcon.Name = 'ClockIconMigration';
var $76cccee3927cb0e3$var$_default = module.exports.default = $76cccee3927cb0e3$var$ClockIcon;

});

parcelRegister("iItCF", function(module, exports) {

$parcel$export(module.exports, "AtlassianIcon", () => $09671325a7499652$export$8a485e2e7ed91e8f);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $6VxGE = parcelRequire("6VxGE");

var $kpt43 = parcelRequire("kpt43");

var $2uZGe = parcelRequire("2uZGe");

var $j62qJ = parcelRequire("j62qJ");
const $09671325a7499652$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $2uZGe.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M27.545 24.378 16.96 3.208c-.208-.458-.417-.541-.667-.541-.208 0-.458.083-.708.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.042 13.795.334.666.584.791 1.167.791h7.335c.541 0 .833-.208.833-.625 0-.208-.042-.333-.25-.75M12.168 14.377c-.834-1.25-1.084-1.334-1.292-1.334s-.333.083-.708.834L4.875 24.46c-.167.334-.208.459-.208.625 0 .334.291.667.916.667h7.46c.5 0 .875-.416 1.083-1.208.25-1 .334-1.876.334-2.917 0-2.917-1.292-5.751-2.292-7.251"/>
    </svg>`;
};
const $09671325a7499652$export$8a485e2e7ed91e8f = ({ appearance: appearance, label: label = 'Atlassian', size: size = (0, $kpt43.defaultLogoParams).size, iconColor: iconColor = (0, $kpt43.defaultLogoParams).iconColor, textColor: textColor = (0, $kpt43.defaultLogoParams).textColor, testId: testId })=>{
    const { colorMode: colorMode } = (0, $6VxGE.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $j62qJ.default), {
        appearance: appearance,
        label: label,
        svg: $09671325a7499652$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        textColor: textColor,
        size: size,
        testId: testId
    });
};

});

parcelRegister("4CMbn", function(module, exports) {

$parcel$export(module.exports, "default", () => $c7b63138ab7dbbc1$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $c7b63138ab7dbbc1$var$shimmerKeyframes = null;
const $c7b63138ab7dbbc1$var$skeletonStyles = null;
const $c7b63138ab7dbbc1$var$activeShimmerStyles = null;
/**
 * __Skeleton__
 *
 * A skeleton acts as a placeholder for content, usually while the content loads.
 *
 * - [Examples](https://atlassian.design/components/skeleton/examples)
 * - [Code](https://atlassian.design/components/skeleton/code)
 */ const $c7b63138ab7dbbc1$var$Skeleton = ({ width: width, height: height, borderRadius: borderRadius = '100px', color: color, ShimmeringEndColor: ShimmeringEndColor, isShimmering: isShimmering = false, groupName: groupName, testId: testId })=>{
    const groupDataAttribute = groupName && `data-${groupName}`;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": testId,
        style: {
            width: width,
            height: height,
            borderRadius: borderRadius,
            backgroundColor: color,
            // Override the keyframes if both colors are provided, otherwise use the CSS variable fallbacks in our keyframes
            '--ds-skeleton-from-color': color && ShimmeringEndColor ? color : undefined,
            '--ds-skeleton-to-color': color && ShimmeringEndColor ? ShimmeringEndColor : undefined
        },
        ...groupDataAttribute && {
            [groupDataAttribute]: 'true'
        },
        className: (0, $bwpsq.default)([
            "_7hjf1yy8 _5sag12o8 _tip812c5 _1pglp3kn _bfhkn82g",
            isShimmering && "",
            isShimmering && "_j7hq1y0p"
        ])
    });
};
var $c7b63138ab7dbbc1$export$2e2bcd8739ae039 = $c7b63138ab7dbbc1$var$Skeleton;

});

parcelRegister("1fvKj", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::52af1617dddfd09530e8f62747e987f3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0e8fd14112e39634$var$_react = $0e8fd14112e39634$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $0e8fd14112e39634$var$_baseNew = $0e8fd14112e39634$var$_interopRequireDefault((parcelRequire("enEmH")));
function $0e8fd14112e39634$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StarUnstarred".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for starring or favoriting objects as a secondary/tertiary action.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0e8fd14112e39634$var$StarUnstarredIcon = (props)=>/*#__PURE__*/ $0e8fd14112e39634$var$_react.default.createElement($0e8fd14112e39634$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6 0a.75.75 0 0 1 .7.48l1.288 3.35 3.32.256a.75.75 0 0 1 .422 1.324L9.182 7.533l.945 3.523a.75.75 0 0 1-1.148.813L6 9.825l-2.979 2.042a.75.75 0 0 1-1.148-.812l.945-3.523L.27 5.41a.75.75 0 0 1 .422-1.324l3.32-.256L5.3.48A.75.75 0 0 1 6 0m0 2.84-.928 2.413-2.423.186 1.866 1.556-.667 2.488L6 8.007l2.152 1.476-.667-2.488L9.35 5.439l-2.423-.186z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$0e8fd14112e39634$var$StarUnstarredIcon.displayName = 'StarUnstarredIcon';
var $0e8fd14112e39634$var$_default = module.exports.default = $0e8fd14112e39634$var$StarUnstarredIcon;

});

parcelRegister("eCE62", function(module, exports) {

$parcel$export(module.exports, "default", () => $55e27bce957d3cd1$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $lGEY5 = parcelRequire("lGEY5");

var $bKnKN = parcelRequire("bKnKN");


var $b4a3S = parcelRequire("b4a3S");

var $8rw4v = parcelRequire("8rw4v");
function $55e27bce957d3cd1$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $55e27bce957d3cd1$var$gridSize = (0, $b4a3S.gridSize)();
const $55e27bce957d3cd1$var$borderRadius = (0, $b4a3S.borderRadius)();
const $55e27bce957d3cd1$var$itemElemSpacing = $55e27bce957d3cd1$var$gridSize * 1.5;
const $55e27bce957d3cd1$var$itemExpectedElemSize = $55e27bce957d3cd1$var$gridSize * 3;
const $55e27bce957d3cd1$var$itemMinHeight = $55e27bce957d3cd1$var$gridSize * 5;
const $55e27bce957d3cd1$var$skeletonItemElemSize = $55e27bce957d3cd1$var$gridSize * 2.5;
const $55e27bce957d3cd1$var$itemElemSkeletonOffset = ($55e27bce957d3cd1$var$itemExpectedElemSize - $55e27bce957d3cd1$var$skeletonItemElemSize) / 2;
const $55e27bce957d3cd1$var$skeletonTextBorderRadius = 100;
const $55e27bce957d3cd1$var$skeletonContentHeight = 9;
const $55e27bce957d3cd1$var$skeletonColor = `var(--ds-skeleton, ${(0, $a7f8c6b391092279$export$8d43898f60b96a82)})`;
const $55e27bce957d3cd1$var$skeletonStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'flex',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    minHeight: $55e27bce957d3cd1$var$itemMinHeight,
    padding: `0 ${"var(--ds-space-250, 20px)"}`,
    alignItems: 'center',
    pointerEvents: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '::after': {
        height: $55e27bce957d3cd1$var$skeletonContentHeight,
        backgroundColor: $55e27bce957d3cd1$var$skeletonColor,
        borderRadius: $55e27bce957d3cd1$var$skeletonTextBorderRadius,
        content: '""',
        // This is a little bespoke but we need to push everything down 1px
        // because the skeleton content should align to the bottom of the text.
        // Confirm VR test failures before accepting a change.
        marginBlockStart: 1
    }
});
const $55e27bce957d3cd1$var$defaultWidthStyles = {
    name: "sljcv5",
    styles: ":nth-of-type(1n)::after{flex-basis:70%;}:nth-of-type(2n)::after{flex-basis:50%;}:nth-of-type(3n)::after{flex-basis:60%;}:nth-of-type(4n)::after{flex-basis:90%;}:nth-of-type(5n)::after{flex-basis:35%;}:nth-of-type(6n)::after{flex-basis:77%;}"
};
const $55e27bce957d3cd1$var$customWidthStyles = {
    name: "nsk3fe",
    styles: "::after{flex-basis:var(--width);}"
};
const $55e27bce957d3cd1$var$beforeElementStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '::before': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: $55e27bce957d3cd1$var$skeletonItemElemSize,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: $55e27bce957d3cd1$var$skeletonItemElemSize,
        flexShrink: 0,
        backgroundColor: $55e27bce957d3cd1$var$skeletonColor,
        content: '""',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        marginInlineEnd: $55e27bce957d3cd1$var$itemElemSpacing + $55e27bce957d3cd1$var$itemElemSkeletonOffset,
        marginInlineStart: "var(--ds-space-025, 2px)"
    }
});
const $55e27bce957d3cd1$var$avatarStyles = {
    name: "lz1zvf",
    styles: "::before{border-radius:100%;}"
};
const $55e27bce957d3cd1$var$iconStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '::before': {
        borderRadius: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        $55e27bce957d3cd1$var$borderRadius
    }
});
/**
 * __Skeleton item__
 *
 * A skeleton item is used in place of an item when its contents it not ready.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/skeleton-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ const $55e27bce957d3cd1$var$SkeletonItem = ({ hasAvatar: hasAvatar, hasIcon: hasIcon, isShimmering: isShimmering = false, testId: testId, width: width, cssFn: cssFn = (0, $bKnKN.default) })=>{
    (0, $lGEY5.propDeprecationWarning)("platform-pkg", 'cssFn', cssFn !== (0, $bKnKN.default), '' // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    const UNSAFE_overrides = /*#__PURE__*/ (0, $f8Sb3.css)(cssFn());
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $8rw4v.default), {
        isShimmering: isShimmering
    }, ({ className: className })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            style: {
                '--width': width
            },
            css: [
                $55e27bce957d3cd1$var$skeletonStyles,
                (hasAvatar || hasIcon) && $55e27bce957d3cd1$var$beforeElementStyles,
                hasAvatar && $55e27bce957d3cd1$var$avatarStyles,
                hasIcon && $55e27bce957d3cd1$var$iconStyles,
                width ? $55e27bce957d3cd1$var$customWidthStyles : $55e27bce957d3cd1$var$defaultWidthStyles,
                // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
                UNSAFE_overrides
            ],
            "data-testid": testId
        }));
};
var $55e27bce957d3cd1$export$2e2bcd8739ae039 = $55e27bce957d3cd1$var$SkeletonItem;

});
parcelRegister("8rw4v", function(module, exports) {

$parcel$export(module.exports, "default", () => $765f07f7b867a65c$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

/**
 * These keyframes are mirrored in:
 * packages/design-system/theme/src/constants.tsx
 *
 * Please update both.
 */ const $765f07f7b867a65c$var$shimmerKeyframes = (0, $f8Sb3.keyframes)({
    from: {
        backgroundColor: `var(--ds-skeleton, ${(0, $a7f8c6b391092279$export$8d43898f60b96a82)})`
    },
    to: {
        backgroundColor: `var(--ds-skeleton-subtle, ${(0, $a7f8c6b391092279$export$920c0d5c49070351)})`
    }
});
/**
 * These styles are mirrored in:
 * packages/design-system/theme/src/constants.tsx
 *
 * Please update both.
 */ const $765f07f7b867a65c$var$shimmerStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '::before, ::after': {
        animationDirection: 'alternate',
        animationDuration: '1.5s',
        animationIterationCount: 'infinite',
        animationName: `${$765f07f7b867a65c$var$shimmerKeyframes}`,
        animationTimingFunction: 'linear',
        backgroundColor: `var(--ds-skeleton, ${(0, $a7f8c6b391092279$export$8d43898f60b96a82)})`
    }
});
/**
 * __Skeleton shimmer__
 *
 * A skeleton shimmer is the animation shown on loading skeletons for
 * perceived performance and user satisfaction.
 *
 * This component provides a `className` through render props. This value will
 * have type:
 * + `string`, when `isShimmering={true}`.
 * + `undefined`, when `isShimmering={false}`.
 *
 * @internal
 */ const $765f07f7b867a65c$var$SkeletonShimmer = ({ children: children, isShimmering: isShimmering = false })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $f8Sb3.ClassNames), null, ({ css: css })=>children({
            className: isShimmering ? css($765f07f7b867a65c$var$shimmerStyles) : undefined
        }));
};
var $765f07f7b867a65c$export$2e2bcd8739ae039 = $765f07f7b867a65c$var$SkeletonShimmer;

});


parcelRegister("Pxnvj", function(module, exports) {

$parcel$export(module.exports, "default", () => $781ef8d957ad0014$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $fHpHg = parcelRequire("fHpHg");

var $l8L8W = parcelRequire("l8L8W");

var $inni2 = parcelRequire("inni2");
/**
 * __Spotlight target__
 *
 * A spotlight target marks a component to be used for introducing new features to users through focused messages or multi-step tours.
 *
 * - [Examples](https://atlassian.design/components/onboarding/examples)
 * - [Code](https://atlassian.design/components/onboarding/code)
 * - [Usage](https://atlassian.design/components/onboarding/usage)
 */ const $781ef8d957ad0014$var$SpotlightTarget = ({ children: children, name: name })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $inni2.TargetConsumer), {
        children: (getTargetRef)=>{
            if (typeof children === 'function') return children({
                targetRef: getTargetRef?.(name)
            });
            return getTargetRef ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l8L8W.default), {
                name: name,
                hasNodeResolver: !(0, $fHpHg.fg)('platform_design_system_team_onboarding_noderesolve'),
                getTargetRef: getTargetRef,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
                    children: children
                })
            }) : children;
        }
    });
var $781ef8d957ad0014$export$2e2bcd8739ae039 = $781ef8d957ad0014$var$SpotlightTarget;

});
parcelRegister("l8L8W", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ddd0bfd582d578c$export$2e2bcd8739ae039);
/* node-resolver-spotlight-target.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dI393 = parcelRequire("dI393");
const $2ddd0bfd582d578c$var$spanStyles = null;
/**
 * A wrapper component that conditionally applies a NodeResolver to its children.
 *
 * Note: NodeResolver should not be used in React 18 concurrent mode. This component
 * is intended to be removed once the feature flag  is removed.
 * @param {boolean} props.hasNodeResolver - Determines whether to apply the NodeResolver.
 * @param {ReactElement} props.children - The child elements to be wrapped.
 * @param {string} props.name - The name to reference from Spotlight.
 * @param {ReactElement} props.getTargetRef - Setting up Target Node in Spotlight Manager.
 * @returns {ReactElement} The children wrapped with NodeResolver if hasNodeResolver is true, wrape the children in a div setting innerRef with ref to the div.
 */ const $2ddd0bfd582d578c$var$NodeResolverSpotlightTarget = ({ hasNodeResolver: hasNodeResolver, children: children, getTargetRef: getTargetRef, name: name })=>{
    const divRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        const targetRef = getTargetRef(name);
        if (!hasNodeResolver) targetRef(divRef.current?.firstElementChild);
        return ()=>{
            !hasNodeResolver && targetRef(undefined);
        };
    }, [
        hasNodeResolver,
        name,
        getTargetRef
    ]);
    if (hasNodeResolver) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dI393))), {
        innerRef: getTargetRef(name),
        children: children
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ref: divRef,
        className: (0, $bwpsq.default)([
            "_1e0c1bgi"
        ]),
        children: children
    });
};
var $2ddd0bfd582d578c$export$2e2bcd8739ae039 = $2ddd0bfd582d578c$var$NodeResolverSpotlightTarget;

});


parcelRegister("dDsAl", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f0f6dceac3b1541133f5e1afe0b271c5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9ed517514bb2be90$var$_react = $9ed517514bb2be90$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $9ed517514bb2be90$var$_baseNew = $9ed517514bb2be90$var$_interopRequireDefault((parcelRequire("enEmH")));
function $9ed517514bb2be90$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "RoadmapsPlan".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for roadmaps plan.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9ed517514bb2be90$var$RoadmapsPlanIcon = (props)=>/*#__PURE__*/ $9ed517514bb2be90$var$_react.default.createElement($9ed517514bb2be90$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3.5 2.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2M1 3.5a2.5 2.5 0 0 1 4.886-.75h4.864a3 3 0 1 1 0 6h-5.5a1.5 1.5 0 1 0 0 3h4.865a2.501 2.501 0 1 1 0 1.5H5.25a3 3 0 1 1 0-6h5.5a1.5 1.5 0 0 0 0-3H5.886A2.501 2.501 0 0 1 1 3.5m11.5 8a1 1 0 1 0 0 2 1 1 0 0 0 0-2" clip-rule="evenodd"/>`
    }, props));
$9ed517514bb2be90$var$RoadmapsPlanIcon.displayName = 'RoadmapsPlanIcon';
var $9ed517514bb2be90$var$_default = module.exports.default = $9ed517514bb2be90$var$RoadmapsPlanIcon;

});

parcelRegister("6YfOV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::552918135e976d59647ada829319b3a6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $51349e49fbe2a99c$var$_react = $51349e49fbe2a99c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $51349e49fbe2a99c$var$_baseNew = $51349e49fbe2a99c$var$_interopRequireDefault((parcelRequire("enEmH")));
function $51349e49fbe2a99c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Apps".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for adding or viewing apps.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $51349e49fbe2a99c$var$AppsIcon = (props)=>/*#__PURE__*/ $51349e49fbe2a99c$var$_react.default.createElement($51349e49fbe2a99c$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM9 3a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM1 11a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5zm8.25.75V9h1.5v2.25H15v1.5h-2.25V15h-1.5v-2.25H9v-1.5z" clip-rule="evenodd"/>`
    }, props));
$51349e49fbe2a99c$var$AppsIcon.displayName = 'AppsIcon';
var $51349e49fbe2a99c$var$_default = module.exports.default = $51349e49fbe2a99c$var$AppsIcon;

});

parcelRegister("7uikU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3ecb88d563448af87338c1287afbb1bf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $57398eea886311a8$var$_react = $57398eea886311a8$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $57398eea886311a8$var$_baseNew = $57398eea886311a8$var$_interopRequireDefault((parcelRequire("enEmH")));
function $57398eea886311a8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AssetsGraph".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for representing Assets graph
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $57398eea886311a8$var$AssetsGraphIcon = (props)=>/*#__PURE__*/ $57398eea886311a8$var$_react.default.createElement($57398eea886311a8$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3.28 2.22a.75.75 0 1 0-1.06 1.06.75.75 0 0 0 1.06-1.06M1.16 1.159A2.25 2.25 0 0 1 4.781 3.72l1.695 1.695a3 3 0 0 1 3.048 0l1.695-1.695a2.251 2.251 0 1 1 1.06 1.06l-1.694 1.696a3 3 0 0 1 0 3.048l1.695 1.695a2.251 2.251 0 1 1-1.06 1.06l-1.696-1.694a3 3 0 0 1-3.048 0L4.78 12.28a2.251 2.251 0 1 1-1.06-1.06l1.694-1.696a3 3 0 0 1 0-3.048L3.72 4.78a2.25 2.25 0 0 1-2.56-3.621m12.621 1.06a.75.75 0 1 0-1.06 1.061.75.75 0 0 0 1.06-1.06M9.06 6.94a1.5 1.5 0 1 0-2.12 2.122A1.5 1.5 0 0 0 9.06 6.94m-5.78 5.78a.75.75 0 1 0-1.06 1.061.75.75 0 0 0 1.06-1.06m10.5 0a.75.75 0 1 0-1.06 1.061.75.75 0 0 0 1.06-1.06" clip-rule="evenodd"/>`
    }, props));
$57398eea886311a8$var$AssetsGraphIcon.displayName = 'AssetsGraphIcon';
var $57398eea886311a8$var$_default = module.exports.default = $57398eea886311a8$var$AssetsGraphIcon;

});

parcelRegister("3pK7p", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::04422a31fe921661fd3c15a462bdcae0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $27c77b17e642e02c$var$_react = $27c77b17e642e02c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $27c77b17e642e02c$var$_baseNew = $27c77b17e642e02c$var$_interopRequireDefault((parcelRequire("enEmH")));
function $27c77b17e642e02c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Globe".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: public link in Confluence share dialog, global rules in Automation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $27c77b17e642e02c$var$GlobeIcon = (props)=>/*#__PURE__*/ $27c77b17e642e02c$var$_react.default.createElement($27c77b17e642e02c$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1.543 7.25h2.722c.073-1.784.403-3.413.92-4.663q.123-.294.26-.566A6.5 6.5 0 0 0 1.544 7.25M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m0 1.5c-.151 0-.364.07-.632.344-.27.276-.547.714-.796 1.316-.432 1.043-.733 2.47-.805 4.09h4.466c-.072-1.62-.373-3.047-.805-4.09-.249-.602-.526-1.04-.796-1.316C8.364 1.571 8.15 1.5 8 1.5m3.735 5.75c-.073-1.784-.403-3.413-.92-4.663a8 8 0 0 0-.26-.566 6.5 6.5 0 0 1 3.902 5.229zm-1.502 1.5H5.767c.072 1.62.373 3.047.805 4.09.249.602.526 1.04.796 1.316.268.273.481.344.632.344s.364-.07.632-.344c.27-.276.547-.714.796-1.316.432-1.043.733-2.47.805-4.09m.321 5.229q.14-.272.26-.566c.518-1.25.848-2.879.92-4.663h2.723a6.5 6.5 0 0 1-3.903 5.229m-5.108 0q-.14-.272-.26-.566c-.518-1.25-.848-2.879-.92-4.663H1.542a6.5 6.5 0 0 0 3.903 5.229" clip-rule="evenodd"/>`
    }, props));
$27c77b17e642e02c$var$GlobeIcon.displayName = 'GlobeIcon';
var $27c77b17e642e02c$var$_default = module.exports.default = $27c77b17e642e02c$var$GlobeIcon;

});

parcelRegister("dncoP", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::62b2367dcefa534d3cc5e1a7e205b220>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9bc70a9f76491090$var$_react = $9bc70a9f76491090$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $9bc70a9f76491090$var$_baseNew = $9bc70a9f76491090$var$_interopRequireDefault((parcelRequire("enEmH")));
function $9bc70a9f76491090$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Goal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for goals in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9bc70a9f76491090$var$GoalIcon = (props)=>/*#__PURE__*/ $9bc70a9f76491090$var$_react.default.createElement($9bc70a9f76491090$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-2.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4 8a4 4 0 1 1 8 0 4 4 0 0 1-8 0" clip-rule="evenodd"/>`
    }, props));
$9bc70a9f76491090$var$GoalIcon.displayName = 'GoalIcon';
var $9bc70a9f76491090$var$_default = module.exports.default = $9bc70a9f76491090$var$GoalIcon;

});

parcelRegister("15tSY", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6ed07350d21c7e2ad94ff4198361d506>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0cad70b97d918b65$var$_react = $0cad70b97d918b65$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $0cad70b97d918b65$var$_baseNew = $0cad70b97d918b65$var$_interopRequireDefault((parcelRequire("enEmH")));
function $0cad70b97d918b65$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Marketplace".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for Atlassian Marketplace.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0cad70b97d918b65$var$MarketplaceIcon = (props)=>/*#__PURE__*/ $0cad70b97d918b65$var$_react.default.createElement($0cad70b97d918b65$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1.789 1.513A.75.75 0 0 1 2.5 1h11a.75.75 0 0 1 .711.513l1.502 4.5a.8.8 0 0 1 .038.237A3.08 3.08 0 0 1 14 9.032V13a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9.031A3.08 3.08 0 0 1 .25 6.25q0-.12.038-.237zM3.5 9.329V13a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V9.33a3.08 3.08 0 0 1-2.166-1.064A3.08 3.08 0 0 1 8 9.334a3.08 3.08 0 0 1-2.334-1.068A3.08 3.08 0 0 1 3.5 9.329M4.916 6.25v.03a1.584 1.584 0 0 1-3.163.08l.037-.11zm1.5.038.005-.038h3.158l.004.038a1.584 1.584 0 0 1-3.166 0M9.413 4.75H6.588l.25-2.25h2.324zm1.672 1.5a1.584 1.584 0 0 0 3.164.11l-.037-.11zm2.626-1.5h-2.788l-.25-2.25h2.288zM5.33 2.5l-.25 2.25H2.29l.75-2.25z" clip-rule="evenodd"/>`
    }, props));
$0cad70b97d918b65$var$MarketplaceIcon.displayName = 'MarketplaceIcon';
var $0cad70b97d918b65$var$_default = module.exports.default = $0cad70b97d918b65$var$MarketplaceIcon;

});

parcelRegister("hkaoh", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e48f30ce66033de9bc11d4e39ddc845f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c9cc5d4435ed2416$var$_react = $c9cc5d4435ed2416$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c9cc5d4435ed2416$var$_baseNew = $c9cc5d4435ed2416$var$_interopRequireDefault((parcelRequire("enEmH")));
function $c9cc5d4435ed2416$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Headphones".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: music, audio.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c9cc5d4435ed2416$var$HeadphonesIcon = (props)=>/*#__PURE__*/ $c9cc5d4435ed2416$var$_react.default.createElement($c9cc5d4435ed2416$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5A5.5 5.5 0 0 0 2.5 7v.208A2.5 2.5 0 0 1 6 9.5v3.72A1.78 1.78 0 0 1 4.22 15 3.22 3.22 0 0 1 1 11.78V7a7 7 0 0 1 14 0v4.78A3.22 3.22 0 0 1 11.78 15 1.78 1.78 0 0 1 10 13.22V9.5a2.5 2.5 0 0 1 3.5-2.292V7A5.5 5.5 0 0 0 8 1.5m5.5 8a1 1 0 1 0-2 0v3.72c0 .155.125.28.28.28.95 0 1.72-.77 1.72-1.72zm-11 0v2.28c0 .95.77 1.72 1.72 1.72a.28.28 0 0 0 .28-.28V9.5a1 1 0 1 0-2 0" clip-rule="evenodd"/>`
    }, props));
$c9cc5d4435ed2416$var$HeadphonesIcon.displayName = 'HeadphonesIcon';
var $c9cc5d4435ed2416$var$_default = module.exports.default = $c9cc5d4435ed2416$var$HeadphonesIcon;

});

parcelRegister("7PkLr", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::dc58ff4eb916aa4715fd29d4da19740a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5b2d6722a94942ad$var$_react = $5b2d6722a94942ad$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $5b2d6722a94942ad$var$_baseNew = $5b2d6722a94942ad$var$_interopRequireDefault((parcelRequire("enEmH")));
function $5b2d6722a94942ad$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Project".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for projects in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5b2d6722a94942ad$var$ProjectIcon = (props)=>/*#__PURE__*/ $5b2d6722a94942ad$var$_react.default.createElement($5b2d6722a94942ad$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M13.5 3a.5.5 0 0 0-.5-.5h-2.482a.5.5 0 0 0-.354.146L7.78 5.03a.75.75 0 0 1-.53.22H3.018a.5.5 0 0 0-.354.146l-.353.354 1.72 1.72a.75.75 0 0 1 0 1.06l-2.25 2.25L.72 9.72 2.44 8 .72 6.28a.75.75 0 0 1 0-1.06l.884-.884a2 2 0 0 1 1.414-.586h3.921l2.165-2.164A2 2 0 0 1 10.518 1H13a2 2 0 0 1 2 2v2.482a2 2 0 0 1-.586 1.414L12.25 9.061v3.921a2 2 0 0 1-.586 1.415l-.884.883a.75.75 0 0 1-1.06 0L8 13.56l-1.72 1.72-1.06-1.06 2.25-2.25a.75.75 0 0 1 1.06 0l1.72 1.72.354-.354a.5.5 0 0 0 .146-.354V8.75a.75.75 0 0 1 .22-.53l2.384-2.384a.5.5 0 0 0 .146-.354zm-6.72 7.28-5 5-1.06-1.06 5-5z" clip-rule="evenodd"/><path fill="currentcolor" d="M12.5 4.625a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0"/>`
    }, props));
$5b2d6722a94942ad$var$ProjectIcon.displayName = 'ProjectIcon';
var $5b2d6722a94942ad$var$_default = module.exports.default = $5b2d6722a94942ad$var$ProjectIcon;

});

parcelRegister("3kZDu", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::045b0e6f318b6cb40cf896c360eca820>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $26e30cfb5711981d$var$_react = $26e30cfb5711981d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $26e30cfb5711981d$var$_baseNew = $26e30cfb5711981d$var$_interopRequireDefault((parcelRequire("enEmH")));
function $26e30cfb5711981d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Teams".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for teams in Atlassian.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $26e30cfb5711981d$var$TeamsIcon = (props)=>/*#__PURE__*/ $26e30cfb5711981d$var$_react.default.createElement($26e30cfb5711981d$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4 2.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M1 4a3 3 0 1 1 6 0 3 3 0 0 1-6 0m11-1.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M9 4a3 3 0 1 1 6 0 3 3 0 0 1-6 0M3.75 9.5a2.25 2.25 0 0 0-2.25 2.25V13a.5.5 0 0 0 .5.5h4V15H2a2 2 0 0 1-2-2v-1.25A3.75 3.75 0 0 1 3.75 8h1.149a3.75 3.75 0 0 1 3.524 2.469l.564 1.55A2.25 2.25 0 0 0 11.1 13.5H14a.5.5 0 0 0 .5-.5v-1.25a2.25 2.25 0 0 0-2.25-2.25H12c-.775 0-1.258.06-1.531.112-.137.026-.22.05-.26.062l-.027.01.007-.003.01-.004.005-.003.003-.002h.002c.001-.001.001-.001-.334-.672l-.335-.671h.001l.002-.002.004-.001.008-.004.018-.008a1 1 0 0 1 .174-.066q.156-.053.44-.11C10.572 8.065 11.15 8 12 8h.25A3.75 3.75 0 0 1 16 11.75V13a2 2 0 0 1-2 2h-2.899a3.75 3.75 0 0 1-3.524-2.469l-.564-1.55A2.25 2.25 0 0 0 4.9 9.5z" clip-rule="evenodd"/>`
    }, props));
$26e30cfb5711981d$var$TeamsIcon.displayName = 'TeamsIcon';
var $26e30cfb5711981d$var$_default = module.exports.default = $26e30cfb5711981d$var$TeamsIcon;

});

parcelRegister("g95pD", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0d4a862ad906af43648c20a01ac989d3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bc11af659c0d71a3$var$_react = $bc11af659c0d71a3$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $bc11af659c0d71a3$var$_baseNew = $bc11af659c0d71a3$var$_interopRequireDefault((parcelRequire("enEmH")));
function $bc11af659c0d71a3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChartTrend".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: charts, reports in Jira, and sprint insights.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bc11af659c0d71a3$var$ChartTrendIcon = (props)=>/*#__PURE__*/ $bc11af659c0d71a3$var$_react.default.createElement($bc11af659c0d71a3$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 1h1.5v7.94l3.22-3.22a.75.75 0 0 1 1.06 0L8.5 7.44l3.94-3.94H10V2h4.25a.75.75 0 0 1 .75.75V7h-1.5V4.56L9.03 9.03a.75.75 0 0 1-1.06 0L6.25 7.31 2.5 11.06V13a.5.5 0 0 0 .5.5h12V15H3a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$bc11af659c0d71a3$var$ChartTrendIcon.displayName = 'ChartTrendIcon';
var $bc11af659c0d71a3$var$_default = module.exports.default = $bc11af659c0d71a3$var$ChartTrendIcon;

});

parcelRegister("hivz8", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::30e149500cf1a05a183dbc43511b361c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c97c9a66a984d779$var$_react = $c97c9a66a984d779$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c97c9a66a984d779$var$_baseNew = $c97c9a66a984d779$var$_interopRequireDefault((parcelRequire("enEmH")));
function $c97c9a66a984d779$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Operations".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for IT Operations.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c97c9a66a984d779$var$OperationsIcon = (props)=>/*#__PURE__*/ $c97c9a66a984d779$var$_react.default.createElement($c97c9a66a984d779$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12.036 2.904A6.501 6.501 0 1 0 8 14.5V16a8 8 0 1 1 5.657-13.657l.53.53L8.28 8.78 7.22 7.72l2.304-2.305A3.001 3.001 0 1 0 8 11v1.5a4.5 4.5 0 1 1 2.608-8.168z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M14.58 4.862a.75.75 0 0 1 .959.454l.008.025a.75.75 0 1 1-1.414.499l-.007-.02a.75.75 0 0 1 .454-.958m-2.798 2.573a.75.75 0 0 1 .713.786l-.001.015-.001.014a.75.75 0 1 1-1.498-.083v-.01l.001-.01a.75.75 0 0 1 .786-.712m3.497.184a.75.75 0 0 1 .71.787v.026a.75.75 0 1 1-1.498-.081V8.33a.75.75 0 0 1 .788-.711m-4.205 2.656a.75.75 0 0 1-.052 1.06l-.022.019a.75.75 0 1 1-1-1.118l.015-.013a.75.75 0 0 1 1.059.052m3.799.16a.75.75 0 0 1 .355.999l-.011.023a.75.75 0 0 1-1.353-.649l.01-.019a.75.75 0 0 1 .999-.355m-1.457 2.442a.75.75 0 0 1-.053 1.06l-.02.017a.75.75 0 0 1-1.001-1.117l.015-.014a.75.75 0 0 1 1.06.054m-2.278 1.703a.75.75 0 0 1-.454.959l-.025.008a.75.75 0 0 1-.499-1.414l.02-.007a.75.75 0 0 1 .958.454" clip-rule="evenodd"/>`
    }, props));
$c97c9a66a984d779$var$OperationsIcon.displayName = 'OperationsIcon';
var $c97c9a66a984d779$var$_default = module.exports.default = $c97c9a66a984d779$var$OperationsIcon;

});

parcelRegister("e7Klx", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::052aa506253b4fa39b1a73c5776ea203>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a485ab8f5be9a8df$var$_react = $a485ab8f5be9a8df$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $a485ab8f5be9a8df$var$_baseNew = $a485ab8f5be9a8df$var$_interopRequireDefault((parcelRequire("enEmH")));
function $a485ab8f5be9a8df$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Shield".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: classifications in Enterprise Trust, security in Jira (Spork)
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a485ab8f5be9a8df$var$ShieldIcon = (props)=>/*#__PURE__*/ $a485ab8f5be9a8df$var$_react.default.createElement($a485ab8f5be9a8df$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.53.22a.75.75 0 0 0-1.06 0C6.172 1.518 4.686 2.41 3.515 2.982a16 16 0 0 1-1.434.615 11 11 0 0 1-.51.174l-.023.007-.005.001A.75.75 0 0 0 1 4.5c0 4.338 1.651 7.176 3.334 8.926.836.87 1.672 1.463 2.304 1.842a9 9 0 0 0 .999.519l.066.027.02.008.006.002.003.001a.76.76 0 0 0 .535 0h.004l.006-.003.02-.008.066-.027q.083-.035.227-.103c.19-.09.456-.226.772-.416a11.3 11.3 0 0 0 2.304-1.842C13.349 11.676 15 8.838 15 4.5a.75.75 0 0 0-.544-.721l-.004-.001-.024-.007-.103-.033a11 11 0 0 1-.406-.141c-.35-.13-.85-.33-1.434-.615C11.314 2.412 9.828 1.518 8.53.22M8 1.783C6.69 2.963 5.286 3.788 4.172 4.33a17 17 0 0 1-1.663.707c.128 3.604 1.532 5.92 2.907 7.35a9.8 9.8 0 0 0 1.993 1.595c.24.144.443.25.591.322.148-.072.35-.178.59-.322a9.8 9.8 0 0 0 1.994-1.596c1.375-1.43 2.779-3.745 2.907-7.349l-.09-.032a17 17 0 0 1-1.573-.675C10.714 3.788 9.31 2.963 8 1.783" clip-rule="evenodd"/>`
    }, props));
$a485ab8f5be9a8df$var$ShieldIcon.displayName = 'ShieldIcon';
var $a485ab8f5be9a8df$var$_default = module.exports.default = $a485ab8f5be9a8df$var$ShieldIcon;

});

parcelRegister("i9F5t", function(module, exports) {

$parcel$export(module.exports, "CommonActions", () => $54b5645ae3468209$export$deb4c0713194b9f5);
/* common-actions.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");
parcelRequire("5uXOq");

var $fHpHg = parcelRequire("fHpHg");
const $54b5645ae3468209$var$styles = {
    root: "_zulpu2gc _yyhycs5v _1bsb1osq _4cvr1h6o",
    oldLayoutStyles: "_1e0c1txw _1bahh9n0 _1odf1h6o",
    newLayoutStyles: "_1e0c1txw _1bahh9n0 _181n11p5 _1j8b15b0 _lagd1bp4 _1t4c1ris _12e8h9n0"
};
const $54b5645ae3468209$export$deb4c0713194b9f5 = ({ children: children })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            $54b5645ae3468209$var$styles.root,
            (0, $fHpHg.fg)('platform_design_system_nav4_top_nav_columns') ? $54b5645ae3468209$var$styles.newLayoutStyles : $54b5645ae3468209$var$styles.oldLayoutStyles
        ]),
        children: children
    });

});

parcelRegister("3TeMH", function(module, exports) {

$parcel$export(module.exports, "HomeActions", () => $d329c9ffe99a6958$export$ae2177c1f0d2b72c);
/* home-actions.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $fHpHg = parcelRequire("fHpHg");

var $ic23Y = parcelRequire("ic23Y");
const $d329c9ffe99a6958$var$styles = {
    root: "_zulp1b66 _yyhykb7n _4t3i1osq _4cvr1h6o _1e0c1txw",
    logoPaddingStyles: "_pwyo12x7",
    contentMinWidthStyles: "_glte1ris _15ri1mjv _1gs5usvi"
};
const $d329c9ffe99a6958$export$ae2177c1f0d2b72c = ({ children: children, testId: testId })=>{
    const ref = (0, $5uXOq.useContext)((0, $ic23Y.HomeActionsAttachRef));
    const elementRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        if ((0, $fHpHg.fg)('platform_fix_component_state_update_for_suspense')) ref(elementRef.current);
    }, [
        elementRef,
        ref
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ref: (0, $fHpHg.fg)('platform_fix_component_state_update_for_suspense') ? elementRef : ref,
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            $d329c9ffe99a6958$var$styles.root,
            (0, $fHpHg.fg)('platform_design_system_nav4_top_nav_min_widths') ? $d329c9ffe99a6958$var$styles.contentMinWidthStyles : // Removing the extra logo padding when applying the content min width
            $d329c9ffe99a6958$var$styles.logoPaddingStyles
        ]),
        children: children
    });
};

});
parcelRegister("ic23Y", function(module, exports) {

$parcel$export(module.exports, "HomeActionsElement", () => $e8a9314c5db6afbc$export$4128169e0878a41d);
$parcel$export(module.exports, "HomeActionsAttachRef", () => $e8a9314c5db6afbc$export$762fcfeaa67873eb);

var $5uXOq = parcelRequire("5uXOq");

var $bKnKN = parcelRequire("bKnKN");
const $e8a9314c5db6afbc$export$4128169e0878a41d = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $e8a9314c5db6afbc$export$762fcfeaa67873eb = /*#__PURE__*/ (0, $5uXOq.createContext)((0, $bKnKN.default));

});


parcelRegister("axa9g", function(module, exports) {

$parcel$export(module.exports, "SideNavToggleButton", () => $e5a7bffbf67e382b$export$8bd77667631fec25);
/* toggle-button.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");

var $lTodL = parcelRequire("lTodL");

var $cFmXJ = parcelRequire("cFmXJ");

var $fHpHg = parcelRequire("fHpHg");

var $3926G = parcelRequire("3926G");

var $cugaz = parcelRequire("cugaz");

var $e3mEE = parcelRequire("e3mEE");

var $dDr3w = parcelRequire("dDr3w");
const $e5a7bffbf67e382b$var$toggleButtonTooltipOptions = {
    // We're disabling pointer events on the tooltip to prevent it from blocking mouse events, so that the side nav flyout stays open
    // when moving the mouse from the top bar to the side nav.
    ignoreTooltipPointerEvents: true
};
// For duplicate "mouseenter" issue when changing icons (see below)
const $e5a7bffbf67e382b$var$silentIconStyles = null;
const $e5a7bffbf67e382b$export$8bd77667631fec25 = ({ defaultCollapsed: defaultCollapsed = false, expandLabel: expandLabel, collapseLabel: collapseLabel, testId: testId, interactionName: interactionName, onClick: onClick })=>{
    const { isExpandedOnDesktop: isSideNavExpandedOnDesktop, isExpandedOnMobile: isSideNavExpandedOnMobile } = (0, $e3mEE.useSideNavVisibility)({
        defaultCollapsed: defaultCollapsed
    });
    const [isSideNavExpanded, setIsSideNavExpanded] = (0, $5uXOq.useState)(!defaultCollapsed);
    const ref = (0, $5uXOq.useContext)((0, $cugaz.SideNavToggleButtonAttachRef));
    const elementRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        if ((0, $fHpHg.fg)('platform_fix_component_state_update_for_suspense')) ref(elementRef.current);
    }, [
        elementRef,
        ref
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const { matches: matches } = window.matchMedia('(min-width: 64rem)');
        setIsSideNavExpanded(matches ? isSideNavExpandedOnDesktop : isSideNavExpandedOnMobile);
    }, [
        isSideNavExpandedOnDesktop,
        isSideNavExpandedOnMobile
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // When screen size changes, ensure we use the correct visibility state
        const mediaQueryList = window.matchMedia('(min-width: 64rem)');
        return (0, $cBeZP.bind)(mediaQueryList, {
            type: 'change',
            listener () {
                setIsSideNavExpanded(mediaQueryList.matches ? isSideNavExpandedOnDesktop : isSideNavExpandedOnMobile);
            }
        });
    }, [
        isSideNavExpandedOnDesktop,
        isSideNavExpandedOnMobile
    ]);
    const toggleVisibility = (0, $dDr3w.useToggleSideNav)();
    const handleClick = (0, $5uXOq.useCallback)((event, analyticsEvent)=>{
        onClick?.(event, analyticsEvent, {
            isSideNavVisible: isSideNavExpanded
        });
        toggleVisibility();
    }, [
        onClick,
        toggleVisibility,
        isSideNavExpanded
    ]);
    /**
   * ## Behaviour
   * It is intentional that collapse icon will be used while the flyout is open.
   * The icon is tied to the expanded / collapse state, and not the flyout state.
   *
   * ## Why a function?
   * Unfortunately, changing the icon inside an <IconButton> when the user is over
   * the button will cause the svg element to be replaced, which can trigger a
   * "mouseenter" event. This is problematic when the user is already over the button,
   * as it can result in a "mouseenter" event after the user manually entered the button.
   *
   * `icon` accepts a function for the `icon` prop (ie a render prop), so we don't need to
   * memoize it, or pull it out into a new function
   */ const icon = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)("span", {
            className: (0, $bwpsq.default)([
                "_1e0c1bgi _lcxvglyw"
            ]),
            children: isSideNavExpanded ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lTodL))), {
                ...props
            }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cFmXJ))), {
                ...props
            })
        });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3926G.IconButton), {
        appearance: "subtle",
        label: isSideNavExpanded ? collapseLabel : expandLabel,
        icon: icon,
        onClick: handleClick,
        testId: testId,
        isTooltipDisabled: false,
        interactionName: interactionName,
        ref: (0, $fHpHg.fg)('platform_fix_component_state_update_for_suspense') ? elementRef : ref,
        tooltip: $e5a7bffbf67e382b$var$toggleButtonTooltipOptions
    });
};

});
parcelRegister("lTodL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::abc8b5d03c24733db4f330a1621745d6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ff0185cbeaa5fcd3$var$_react = $ff0185cbeaa5fcd3$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $ff0185cbeaa5fcd3$var$_baseNew = $ff0185cbeaa5fcd3$var$_interopRequireDefault((parcelRequire("enEmH")));
function $ff0185cbeaa5fcd3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "SidebarCollapse".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for collapsing the navigation sidebar.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ff0185cbeaa5fcd3$var$SidebarCollapseIcon = (props)=>/*#__PURE__*/ $ff0185cbeaa5fcd3$var$_react.default.createElement($ff0185cbeaa5fcd3$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 2.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h2v-11zm3.5 0v11H14a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM0 3a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm7.97 4.47 2.5-2.5 1.06 1.06L9.56 8l1.97 1.97-1.06 1.06-2.5-2.5a.75.75 0 0 1 0-1.06" clip-rule="evenodd"/>`
    }, props));
$ff0185cbeaa5fcd3$var$SidebarCollapseIcon.displayName = 'SidebarCollapseIcon';
var $ff0185cbeaa5fcd3$var$_default = module.exports.default = $ff0185cbeaa5fcd3$var$SidebarCollapseIcon;

});

parcelRegister("cFmXJ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5f4e0f9a7acbecae432a6a2607234087>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $938b203d6509966e$var$_react = $938b203d6509966e$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $938b203d6509966e$var$_baseNew = $938b203d6509966e$var$_interopRequireDefault((parcelRequire("enEmH")));
function $938b203d6509966e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "SidebarExpand".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for expanding the navigation sidebar.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $938b203d6509966e$var$SidebarExpandIcon = (props)=>/*#__PURE__*/ $938b203d6509966e$var$_react.default.createElement($938b203d6509966e$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14 2.5a.5.5 0 0 1 .5.5v10a.5.5 0 0 1-.5.5h-2v-11zm-3.5 0v11H2a.5.5 0 0 1-.5-.5V3a.5.5 0 0 1 .5-.5zM16 3a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2zM8.03 7.47l-2.5-2.5-1.06 1.06L6.44 8 4.47 9.97l1.06 1.06 2.5-2.5a.75.75 0 0 0 0-1.06" clip-rule="evenodd"/>`
    }, props));
$938b203d6509966e$var$SidebarExpandIcon.displayName = 'SidebarExpandIcon';
var $938b203d6509966e$var$_default = module.exports.default = $938b203d6509966e$var$SidebarExpandIcon;

});

parcelRegister("3926G", function(module, exports) {

$parcel$export(module.exports, "IconButton", () => $12f6195d26188df0$export$c25acd513dcc8062);
$parcel$export(module.exports, "Button", () => $12f6195d26188df0$export$353f5b6fc5456de1);
$parcel$export(module.exports, "LinkButton", () => $12f6195d26188df0$export$29d11c0fe2fc51d8);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bMFGq = parcelRequire("bMFGq");
var $1Seuh = parcelRequire("1Seuh");
var $liZ21 = parcelRequire("liZ21");
var $620fp = parcelRequire("620fp");

var $14ccF = parcelRequire("14ccF");

var $bRH8U = parcelRequire("bRH8U");
// Explicitly typed to use only the themed button API,
// which is a subset of the normal button API
const $12f6195d26188df0$export$c25acd513dcc8062 = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const hasCustomTheme = (0, $bRH8U.useHasCustomTheme)();
    const Component = hasCustomTheme ? (0, $14ccF.ThemedIconButton) : (0, $1Seuh.default);
    return /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
        ref: ref,
        ...props
    });
});
// Explicitly typed to use only the themed button API,
// which is a subset of the normal button API
const $12f6195d26188df0$export$edad7fca51b767e1 = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const hasCustomTheme = (0, $bRH8U.useHasCustomTheme)();
    const Component = hasCustomTheme ? (0, $14ccF.ThemedLinkIconButton) : (0, $620fp.default);
    return /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
        ref: ref,
        ...props
    });
});
// Explicitly typed to use only the themed button API,
// which is a subset of the normal button API
const $12f6195d26188df0$export$353f5b6fc5456de1 = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const hasCustomTheme = (0, $bRH8U.useHasCustomTheme)();
    const Component = hasCustomTheme ? (0, $14ccF.ThemedButton) : (0, $bMFGq.default);
    return /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
        ref: ref,
        ...props
    });
});
// Explicitly typed to use only the themed button API,
// which is a subset of the normal button API
const $12f6195d26188df0$export$29d11c0fe2fc51d8 = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const hasCustomTheme = (0, $bRH8U.useHasCustomTheme)();
    const Component = hasCustomTheme ? (0, $14ccF.ThemedLinkButton) : (0, $liZ21.default);
    return /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
        ref: ref,
        ...props
    });
});

});
parcelRegister("620fp", function(module, exports) {

$parcel$export(module.exports, "default", () => $afd214f83cdad762$export$2e2bcd8739ae039);
/* link.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $6tzHJ = parcelRequire("6tzHJ");

var $cD7p8 = parcelRequire("cD7p8");

var $42A03 = parcelRequire("42A03");

var $fHpHg = parcelRequire("fHpHg");

var $3YyrB = parcelRequire("3YyrB");

var $5KCCi = parcelRequire("5KCCi");

var $cBCgC = parcelRequire("cBCgC");

var $4gHTL = parcelRequire("4gHTL");

var $153Gb = parcelRequire("153Gb");
const $afd214f83cdad762$var$styles = {
    base: "_2rkosqtm _11c82smr _v5649dqc _189eidpf _1rjc12x7 _1e0c116y _vchhusvi _1bsb1wug _p12f1osq _kqswh2mm _4cvr1q9y _1bah1h6o _gy1p1b66 _1o9zidpf _4t3iviql _k48p1wq8 _y4tiutpp _bozgutpp _y3gn1h6o _s7n4nkob _14mj1kw7 _9v7aze3t _1tv3nqa1 _39yqe4h9 _11fnglyw _18postnw",
    linkDecorationUnset: "_4bfu1r81 _1hmsagmp _ajmmvv82 _1a3b18uv _4fprglyw _5goinqa1 _9oik18uv _1bnxglyw _jf4cnqa1 _1nrm18uv _c2waglyw _1iohnqa1",
    disabled: "_80om13gf _bfhksyzs _syaz1lh4 _aetrglyw _irr3syzs _30l31lh4 _1di6syzs _9h8h1lh4",
    spacingCompact: "_1rjcv77o _gy1p1b66 _y4tiutpp _bozgutpp _s7n4nkob _4t3i1k8s _1bsb1k8s",
    iconButton: "_4t3iviql _1bsbviql _y4tize3t _bozgze3t",
    circle: "_2rko14q2"
};
const $afd214f83cdad762$var$defaultStyles = {
    root: "_bfhkiw92 _syaz10s3 _105310s3 _f8pj10s3 _irr3yw9d _30l310s3 _1di6ip91 _9h8h10s3",
    rootRefreshed: "_bfhk1w7a _syaz1gjq _8l3mmuej _aetrb3bt _10531gjq _f8pj1gjq _irr3166n _30l31gjq _1di61dty _9h8h1gjq"
};
const $afd214f83cdad762$var$primaryStyles = {
    root: "_bfhkomb0 _syaz15cr _105315cr _30l315cr _irr31wqm _9h8h15cr _1di617hq"
};
const $afd214f83cdad762$var$discoveryStyles = {
    root: "_bfhk1vbi _syaz15cr _105315cr _30l315cr _irr37gr8 _9h8h15cr _1di61wu2"
};
const $afd214f83cdad762$var$subtleStyles = {
    root: "_bfhk1w7a _syaz10s3 _105310s3 _f8pj10s3 _irr34mfv _30l310s3 _1di619qy _9h8h10s3",
    rootRefreshed: "_bfhk1w7a _syaz1gjq _10531gjq _f8pj1mjl _irr34mfv _30l31gjq _1di619qy _9h8h1gjq"
};
const $afd214f83cdad762$var$selectedStyles = {
    root: "_bfhk7btw _syaz1pke _10531pke _f8pj1pke _irr3i1yw _30l3aqb7 _1di619ru _9h8haqb7",
    rootRefreshed: "_bfhkfg4m _syaz1ldt _8l3mcoux _aetrb3bt _10531ldt _f8pj1ldt _30l31ldt _9h8h1ldt",
    discovery: "_bfhk1g49 _syaz1pke _30l31pke _irr31g49 _9h8h1pke _1di61g49"
};
const $afd214f83cdad762$var$LinkIconButtonBase = ({ // Prevent duplicate labels being added.
'aria-label': preventedAriaLabel, 'aria-labelledby': ariaLabelledBy, analyticsContext: analyticsContext, appearance: appearance = 'default', autoFocus: autoFocus = false, href: href, icon: icon, interactionName: interactionName, isDisabled: isDisabled, isSelected: isSelected, isTooltipDisabled: isTooltipDisabled = true, label: label, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, shape: shape, spacing: spacing, testId: testId, tooltip: tooltip, ...unsafeRest }, ref)=>{
    // @ts-expect-error
    const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
    const localRef = (0, $5uXOq.useRef)(null);
    (0, $42A03.default)(localRef, autoFocus);
    if (!isTooltipDisabled) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5KCCi.default), {
        content: tooltip?.content ?? label,
        testId: tooltip?.testId,
        position: tooltip?.position,
        delay: tooltip?.delay,
        onShow: tooltip?.onShow,
        onHide: tooltip?.onHide,
        mousePosition: tooltip?.mousePosition,
        analyticsContext: tooltip?.analyticsContext,
        strategy: tooltip?.strategy,
        tag: tooltip?.tag,
        truncate: tooltip?.truncate,
        component: tooltip?.component,
        hideTooltipOnClick: tooltip?.hideTooltipOnClick,
        hideTooltipOnMouseDown: tooltip?.hideTooltipOnMouseDown,
        ignoreTooltipPointerEvents: tooltip?.ignoreTooltipPointerEvents,
        children: (triggerProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $3YyrB.default), {
                ...saferRest,
                "aria-labelledby": ariaLabelledBy,
                testId: testId,
                componentName: "LinkIconButton",
                analyticsContext: analyticsContext,
                interactionName: interactionName,
                // Shared between tooltip and native props
                onMouseOver: (e)=>{
                    triggerProps.onMouseOver?.(e);
                    saferRest.onMouseOver?.(e);
                },
                onMouseOut: (e)=>{
                    triggerProps.onMouseOut?.(e);
                    saferRest.onMouseOut?.(e);
                },
                onMouseMove: (e)=>{
                    triggerProps.onMouseMove?.(e);
                    saferRest.onMouseMove?.(e);
                },
                onMouseDown: (e)=>{
                    triggerProps.onMouseDown?.(e);
                    saferRest.onMouseDown?.(e);
                },
                onFocus: (e)=>{
                    triggerProps.onFocus?.(e);
                    saferRest.onFocus?.(e);
                },
                onBlur: (e)=>{
                    triggerProps.onBlur?.(e);
                    saferRest.onBlur?.(e);
                },
                // Shared between tooltip and base props
                onClick: (event, analyticsEvent)=>{
                    onClick?.(event, analyticsEvent);
                    triggerProps?.onClick?.(event);
                },
                ref: (0, $cD7p8.default)([
                    localRef,
                    ref,
                    triggerProps.ref
                ].filter(Boolean)),
                // Base props only
                xcss: (0, $6tzHJ.cx)($afd214f83cdad762$var$styles.base, appearance === 'default' && ((0, $fHpHg.fg)('platform-component-visual-refresh') ? $afd214f83cdad762$var$defaultStyles.rootRefreshed : $afd214f83cdad762$var$defaultStyles.root), appearance === 'primary' && $afd214f83cdad762$var$primaryStyles.root, appearance === 'discovery' && $afd214f83cdad762$var$discoveryStyles.root, appearance === 'subtle' && ((0, $fHpHg.fg)('platform-component-visual-refresh') ? $afd214f83cdad762$var$subtleStyles.rootRefreshed : $afd214f83cdad762$var$subtleStyles.root), $afd214f83cdad762$var$styles.linkDecorationUnset, isSelected && ((0, $fHpHg.fg)('platform-component-visual-refresh') ? $afd214f83cdad762$var$selectedStyles.rootRefreshed : $afd214f83cdad762$var$selectedStyles.root), // TODO: remove me once we kill color fallbacks
                isSelected && appearance === 'discovery' && $afd214f83cdad762$var$selectedStyles.discovery, isDisabled && $afd214f83cdad762$var$styles.disabled, spacing === 'compact' && $afd214f83cdad762$var$styles.spacingCompact, $afd214f83cdad762$var$styles.iconButton, shape === 'circle' && $afd214f83cdad762$var$styles.circle),
                onMouseDownCapture: onMouseDownCapture,
                onMouseUpCapture: onMouseUpCapture,
                onKeyDownCapture: onKeyDownCapture,
                onKeyUpCapture: onKeyUpCapture,
                onTouchStartCapture: onTouchStartCapture,
                onTouchEndCapture: onTouchEndCapture,
                onPointerDownCapture: onPointerDownCapture,
                onPointerUpCapture: onPointerUpCapture,
                onClickCapture: onClickCapture,
                /**
       * Disable link in an accessible way using `href`, `role`, and `aria-disabled`.
       * @see https://a11y-guidelines.orange.com/en/articles/disable-elements/#disable-a-link
       */ // @ts-expect-error (`href` is required, we could make it optional but don't want to encourage this pattern elsewhere)
                href: isDisabled ? undefined : href,
                role: isDisabled ? 'link' : undefined,
                "aria-disabled": isDisabled === true ? true : undefined,
                children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $4gHTL.default), {
                    type: "icon",
                    isLoading: false,
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $153Gb.default), {
                            icon: icon
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cBCgC.default), {
                            children: label
                        })
                    ]
                })
            })
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3YyrB.default), {
        ...saferRest,
        // aria-label={preventedAriaLabel}
        "aria-labelledby": ariaLabelledBy,
        ref: (0, $cD7p8.default)([
            localRef,
            ref
        ]),
        xcss: (0, $6tzHJ.cx)($afd214f83cdad762$var$styles.base, appearance === 'default' && ((0, $fHpHg.fg)('platform-component-visual-refresh') ? $afd214f83cdad762$var$defaultStyles.rootRefreshed : $afd214f83cdad762$var$defaultStyles.root), appearance === 'primary' && $afd214f83cdad762$var$primaryStyles.root, appearance === 'discovery' && $afd214f83cdad762$var$discoveryStyles.root, appearance === 'subtle' && ((0, $fHpHg.fg)('platform-component-visual-refresh') ? $afd214f83cdad762$var$subtleStyles.rootRefreshed : $afd214f83cdad762$var$subtleStyles.root), $afd214f83cdad762$var$styles.linkDecorationUnset, isSelected && ((0, $fHpHg.fg)('platform-component-visual-refresh') ? $afd214f83cdad762$var$selectedStyles.rootRefreshed : $afd214f83cdad762$var$selectedStyles.root), // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'discovery' && $afd214f83cdad762$var$selectedStyles.discovery, isDisabled && $afd214f83cdad762$var$styles.disabled, $afd214f83cdad762$var$styles.iconButton, spacing === 'compact' && $afd214f83cdad762$var$styles.spacingCompact, shape === 'circle' && $afd214f83cdad762$var$styles.circle),
        onClick: onClick,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture,
        testId: testId,
        /**
   * Disable link in an accessible way using `href`, `role`, and `aria-disabled`.
   * @see https://a11y-guidelines.orange.com/en/articles/disable-elements/#disable-a-link
   */ // @ts-expect-error (`href` is required, we could make it optional but don't want to encourage this pattern elsewhere)
        href: isDisabled ? undefined : href,
        role: isDisabled ? 'link' : undefined,
        "aria-disabled": isDisabled === true ? true : undefined,
        componentName: "LinkIconButton",
        analyticsContext: analyticsContext,
        interactionName: interactionName,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $4gHTL.default), {
            type: "icon",
            isLoading: false,
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $153Gb.default), {
                    icon: icon
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cBCgC.default), {
                    children: label
                })
            ]
        })
    });
};
// Workarounds to support generic types with forwardRef + memo
const $afd214f83cdad762$var$WithRef = /*#__PURE__*/ (0, $5uXOq.forwardRef)($afd214f83cdad762$var$LinkIconButtonBase);
/**
 * __Link Icon Button__
 *
 * Renders a link in the style of an icon button.
 *
 * - [Examples](https://atlassian.design/components/button/link-icon-button/examples)
 * - [Code](https://atlassian.design/components/button/link-icon-button/code)
 * - [Usage](https://atlassian.design/components/button/link-icon-button/usage)
 */ const $afd214f83cdad762$var$LinkIconButton = /*#__PURE__*/ (0, $5uXOq.memo)($afd214f83cdad762$var$WithRef);
var $afd214f83cdad762$export$2e2bcd8739ae039 = $afd214f83cdad762$var$LinkIconButton;

});

parcelRegister("14ccF", function(module, exports) {

$parcel$export(module.exports, "themedButtonBackground", () => $8c884cbcd42e3261$export$b93b81aa41a8061a);
$parcel$export(module.exports, "themedButtonBackgroundHovered", () => $8c884cbcd42e3261$export$96a2312c81489aa1);
$parcel$export(module.exports, "themedButtonBackgroundPressed", () => $8c884cbcd42e3261$export$9db7a918ddfed23e);
$parcel$export(module.exports, "themedButtonBorder", () => $8c884cbcd42e3261$export$2b00bded80635cbb);
$parcel$export(module.exports, "themedButtonPrimaryText", () => $8c884cbcd42e3261$export$eca746d7c1a9cd6e);
$parcel$export(module.exports, "themedButtonPrimaryBackground", () => $8c884cbcd42e3261$export$2c2bc298cddb8aca);
$parcel$export(module.exports, "themedButtonPrimaryBackgroundHovered", () => $8c884cbcd42e3261$export$6b28e650669cd3c7);
$parcel$export(module.exports, "themedButtonPrimaryBackgroundPressed", () => $8c884cbcd42e3261$export$1656be06aad539b9);
$parcel$export(module.exports, "themedButtonSelectedText", () => $8c884cbcd42e3261$export$c26a897d419ef487);
$parcel$export(module.exports, "themedButtonSelectedBackground", () => $8c884cbcd42e3261$export$4e50e625ccffdb13);
$parcel$export(module.exports, "themedButtonSelectedBackgroundHovered", () => $8c884cbcd42e3261$export$55c84c90f36bda4d);
$parcel$export(module.exports, "themedButtonSelectedBackgroundPressed", () => $8c884cbcd42e3261$export$c5c0213472126c08);
$parcel$export(module.exports, "themedButtonSelectedBorder", () => $8c884cbcd42e3261$export$22928007ff541429);
$parcel$export(module.exports, "themedButtonDisabledText", () => $8c884cbcd42e3261$export$787ad93d0f2276af);
$parcel$export(module.exports, "themedButtonDisabledBackground", () => $8c884cbcd42e3261$export$5e774f44b77335d6);
$parcel$export(module.exports, "ThemedButton", () => $8c884cbcd42e3261$export$f67fb575035cc7d0);
$parcel$export(module.exports, "ThemedLinkButton", () => $8c884cbcd42e3261$export$b0b5aeed52623827);
$parcel$export(module.exports, "ThemedIconButton", () => $8c884cbcd42e3261$export$d9c2d067feb61447);
$parcel$export(module.exports, "ThemedLinkIconButton", () => $8c884cbcd42e3261$export$a1ab08e79d264ec8);
/* button.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $DEWI6 = parcelRequire("DEWI6");

var $cD7p8 = parcelRequire("cD7p8");

var $3YyrB = parcelRequire("3YyrB");
var $7rJgC = parcelRequire("7rJgC");

var $5KCCi = parcelRequire("5KCCi");

var $cBCgC = parcelRequire("cBCgC");

var $aoFID = parcelRequire("aoFID");
/**
 * Returns the spread props to pass through to underlying primitive components.
 *
 * It removes the props which apply styles.
 */ function $8c884cbcd42e3261$var$getPrimitiveSpreadProps({ style: style, xcss: xcss, backgroundColor: backgroundColor, padding: padding, paddingBlock: paddingBlock, paddingBlockStart: paddingBlockStart, paddingBlockEnd: paddingBlockEnd, paddingInline: paddingInline, paddingInlineStart: paddingInlineStart, paddingInlineEnd: paddingInlineEnd, ...props }) {
    return props;
}
const $8c884cbcd42e3261$export$b93b81aa41a8061a = '--ds-top-bar-button-background';
const $8c884cbcd42e3261$export$96a2312c81489aa1 = '--ds-top-bar-button-background-hovered';
const $8c884cbcd42e3261$export$9db7a918ddfed23e = '--ds-top-bar-button-background-pressed';
const $8c884cbcd42e3261$export$2b00bded80635cbb = '--ds-top-bar-button-border';
const $8c884cbcd42e3261$export$eca746d7c1a9cd6e = '--ds-top-bar-button-primary-text';
const $8c884cbcd42e3261$export$2c2bc298cddb8aca = '--ds-top-bar-button-primary-background';
const $8c884cbcd42e3261$export$6b28e650669cd3c7 = '--ds-top-bar-button-primary-background-hovered';
const $8c884cbcd42e3261$export$1656be06aad539b9 = '--ds-top-bar-button-primary-background-pressed';
const $8c884cbcd42e3261$export$c26a897d419ef487 = '--ds-top-bar-button-selected-text';
const $8c884cbcd42e3261$export$4e50e625ccffdb13 = '--ds-top-bar-button-selected-background';
const $8c884cbcd42e3261$export$55c84c90f36bda4d = '--ds-top-bar-button-selected-background-hovered';
const $8c884cbcd42e3261$export$c5c0213472126c08 = '--ds-top-bar-button-selected-background-pressed';
const $8c884cbcd42e3261$export$22928007ff541429 = '--ds-top-bar-button-selected-border';
const $8c884cbcd42e3261$export$787ad93d0f2276af = '--ds-top-bar-button-disabled-text';
const $8c884cbcd42e3261$export$5e774f44b77335d6 = '--ds-top-bar-button-disabled-background';
const $8c884cbcd42e3261$var$styles = {
    root: "_zulp12x7 _11c82smr _2rkosqtm _v5649dqc _4bfu18uv _1hmsglyw _ajmmnqa1 _1rjcze3t _1e0c1txw _4cvr1h6o _1bah1h6o _4t3i5r7u _kqswh2mm _1nrm18uv _1a3b18uv _9oik18uv _c2waglyw _4fprglyw _1bnxglyw _1iohnqa1 _5goinqa1 _jf4cnqa1",
    border: "_14mj1kw7 _9v7aze3t _1tv3nqa1 _39yqe4h9 _aetrb3bt _18postnw",
    selected: "_11q71qds _syazw5ct _8l3m15jn _f8pjw5ct _1053w5ct _19lcjrv1 _30l3w5ct _j6xtnh62 _9h8hw5ct",
    disabled: "_11q71c9b _syaz1i3i _8l3m3acm _f8pj1i3i _10531i3i _19lc1c9b _30l31i3i _j6xt1c9b _9h8h1i3i"
};
const $8c884cbcd42e3261$var$shapeStyles = {
    default: "_18zrutpp",
    square: "_18zrze3t _1bsb5r7u _vwz4idpf"
};
const $8c884cbcd42e3261$var$appearanceStyles = {
    default: "_11q7pkxg _syaz1r31 _8l3maykr _f8pj1r31 _10531r31 _19lc1rps _30l31r31 _j6xtqtgh _9h8h1r31",
    subtle: "_11q7pkxg _syaz1r31 _f8pj1r31 _10531r31 _19lc1rps _30l31r31 _j6xtqtgh _9h8h1r31",
    primary: "_11q7esko _syaz15o7 _f8pj15o7 _105315o7 _19lcp6hf _30l315o7 _j6xt5sko _9h8h15o7"
};
/**
 * Intentionally an almost-duplicate of `ThemedAnchor` - make sure to update both.
 *
 * See `ThemedAnchor` for more context.
 */ const $8c884cbcd42e3261$var$ThemedPressable = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function ThemedPressable({ appearance: appearance = 'default', shape: shape = 'default', isSelected: isSelected, isDisabled: isDisabled, ...props }, ref) {
    const hasBorder = appearance === 'default' || isSelected;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7rJgC.default), {
        ...$8c884cbcd42e3261$var$getPrimitiveSpreadProps(props),
        ref: ref,
        type: "button",
        /**
   * We are using some style values that are outside of the strict
   * `@atlaskit/css` types.
   */ // @ts-expect-error
        // eslint-disable-next-line @compiled/no-suppress-xcss
        xcss: (0, $DEWI6.cx)($8c884cbcd42e3261$var$styles.root, $8c884cbcd42e3261$var$shapeStyles[shape], hasBorder && $8c884cbcd42e3261$var$styles.border, $8c884cbcd42e3261$var$appearanceStyles[appearance], isSelected && $8c884cbcd42e3261$var$styles.selected, isDisabled && $8c884cbcd42e3261$var$styles.disabled),
        isDisabled: isDisabled
    });
});
/**
 * Intentionally an almost-duplicate of `ThemedPressable` - make sure to update both.
 *
 * More 'clever' solutions were tried but I couldn't get them working in an acceptable state.
 *
 * Polymorphism had many typing issues and required sacrificing type safety.
 *
 * Render props had problems passing down styles through `xcss` to the `children` function.
 */ const $8c884cbcd42e3261$var$ThemedAnchor = (0, $aoFID.forwardRefWithGeneric)(function ThemedAnchor({ appearance: appearance = 'default', shape: shape = 'default', isSelected: isSelected, isDisabled: isDisabled, ...props }, ref) {
    const hasBorder = appearance === 'default' || isSelected;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3YyrB.default), {
        ...$8c884cbcd42e3261$var$getPrimitiveSpreadProps(props),
        ref: ref,
        /**
   * We are using some style values that are outside of the strict
   * `@atlaskit/css` types.
   */ // @ts-expect-error
        // eslint-disable-next-line @compiled/no-suppress-xcss
        xcss: (0, $DEWI6.cx)($8c884cbcd42e3261$var$styles.root, $8c884cbcd42e3261$var$shapeStyles[shape], hasBorder && $8c884cbcd42e3261$var$styles.border, $8c884cbcd42e3261$var$appearanceStyles[appearance], isSelected && $8c884cbcd42e3261$var$styles.selected, isDisabled && $8c884cbcd42e3261$var$styles.disabled)
    });
});
const $8c884cbcd42e3261$var$textButtonStyles = {
    iconBefore: "_vwz4idpf",
    text: "_k48p1wq8"
};
const $8c884cbcd42e3261$export$f67fb575035cc7d0 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function ThemedButton({ iconBefore: IconBefore, children: children, ...props }, ref) {
    return /*#__PURE__*/ (0, $2OMIu.jsxs)($8c884cbcd42e3261$var$ThemedPressable, {
        ...props,
        ref: ref,
        children: [
            IconBefore && /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                className: (0, $bwpsq.default)([
                    $8c884cbcd42e3261$var$textButtonStyles.iconBefore
                ]),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)(IconBefore, {
                    label: "",
                    color: "currentColor"
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                className: (0, $bwpsq.default)([
                    $8c884cbcd42e3261$var$textButtonStyles.text
                ]),
                children: children
            })
        ]
    });
});
const $8c884cbcd42e3261$export$b0b5aeed52623827 = (0, $aoFID.forwardRefWithGeneric)(function ThemedLinkButton({ iconBefore: IconBefore, children: children, ...props }, ref) {
    return /*#__PURE__*/ (0, $2OMIu.jsxs)($8c884cbcd42e3261$var$ThemedAnchor, {
        ...props,
        ref: ref,
        children: [
            IconBefore && /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                className: (0, $bwpsq.default)([
                    $8c884cbcd42e3261$var$textButtonStyles.iconBefore
                ]),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)(IconBefore, {
                    label: "",
                    color: "currentColor"
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                className: (0, $bwpsq.default)([
                    $8c884cbcd42e3261$var$textButtonStyles.text
                ]),
                children: children
            })
        ]
    });
});
const $8c884cbcd42e3261$export$d9c2d067feb61447 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function ThemedIconButton({ icon: Icon, label: label, tooltip: tooltip, ...props }, ref) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5KCCi.default), {
        ...tooltip,
        content: tooltip?.content ?? label,
        children: (triggerProps)=>/**
     * The `aria-describedby` from `triggerProps` is intentionally not passed down,
     * because it would cause double announcements with the `VisuallyHidden` label.
     *
     * The `@atlaskit/button` IconButton uses the same approach.
     */ /*#__PURE__*/ (0, $2OMIu.jsxs)($8c884cbcd42e3261$var$ThemedPressable, {
                ...props,
                shape: "square",
                ref: (0, $cD7p8.default)([
                    ref,
                    triggerProps.ref
                ]),
                onClick: (event, analyticsEvent)=>{
                    props.onClick?.(event, analyticsEvent);
                    triggerProps?.onClick?.(event);
                },
                onMouseOver: (e)=>{
                    triggerProps.onMouseOver?.(e);
                    props.onMouseOver?.(e);
                },
                onMouseOut: (e)=>{
                    triggerProps.onMouseOut?.(e);
                    props.onMouseOut?.(e);
                },
                onMouseMove: (e)=>{
                    triggerProps.onMouseMove?.(e);
                    props.onMouseMove?.(e);
                },
                onMouseDown: (e)=>{
                    triggerProps.onMouseDown?.(e);
                    props.onMouseDown?.(e);
                },
                onFocus: (e)=>{
                    triggerProps.onFocus?.(e);
                    props.onFocus?.(e);
                },
                onBlur: (e)=>{
                    triggerProps.onBlur?.(e);
                    props.onBlur?.(e);
                },
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)(Icon, {
                        label: "",
                        color: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cBCgC.default), {
                        children: label
                    })
                ]
            })
    });
});
const $8c884cbcd42e3261$export$a1ab08e79d264ec8 = (0, $aoFID.forwardRefWithGeneric)(function ThemedLinkIconButton({ icon: Icon, label: label, tooltip: tooltip, ...props }, ref) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5KCCi.default), {
        ...tooltip,
        content: tooltip?.content ?? label,
        children: (triggerProps)=>/**
     * The `aria-describedby` from `triggerProps` is intentionally not passed down,
     * because it would cause double announcements with the `VisuallyHidden` label.
     *
     * The `@atlaskit/button` IconButton uses the same approach.
     */ /*#__PURE__*/ (0, $2OMIu.jsxs)($8c884cbcd42e3261$var$ThemedAnchor, {
                ...props,
                shape: "square",
                ref: (0, $cD7p8.default)([
                    ref,
                    triggerProps.ref
                ]),
                onClick: (event, analyticsEvent)=>{
                    props.onClick?.(event, analyticsEvent);
                    triggerProps?.onClick?.(event);
                },
                onMouseOver: (e)=>{
                    triggerProps.onMouseOver?.(e);
                    props.onMouseOver?.(e);
                },
                onMouseOut: (e)=>{
                    triggerProps.onMouseOut?.(e);
                    props.onMouseOut?.(e);
                },
                onMouseMove: (e)=>{
                    triggerProps.onMouseMove?.(e);
                    props.onMouseMove?.(e);
                },
                onMouseDown: (e)=>{
                    triggerProps.onMouseDown?.(e);
                    props.onMouseDown?.(e);
                },
                onFocus: (e)=>{
                    triggerProps.onFocus?.(e);
                    props.onFocus?.(e);
                },
                onBlur: (e)=>{
                    triggerProps.onBlur?.(e);
                    props.onBlur?.(e);
                },
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)(Icon, {
                        label: "",
                        color: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cBCgC.default), {
                        children: label
                    })
                ]
            })
    });
});

});
parcelRegister("aoFID", function(module, exports) {

$parcel$export(module.exports, "forwardRefWithGeneric", () => $839de52f6f7d6afd$export$8ab756e06c5d9001);

var $5uXOq = parcelRequire("5uXOq");
const $839de52f6f7d6afd$export$8ab756e06c5d9001 = (0, $5uXOq.forwardRef);

});


parcelRegister("bRH8U", function(module, exports) {

$parcel$export(module.exports, "HasCustomThemeContext", () => $ac9673de3d45f82c$export$d158fa15757a1890);
$parcel$export(module.exports, "useHasCustomTheme", () => $ac9673de3d45f82c$export$abfcaeeca4ae7a55);

var $5uXOq = parcelRequire("5uXOq");
const $ac9673de3d45f82c$export$d158fa15757a1890 = /*#__PURE__*/ (0, $5uXOq.createContext)(false);
function $ac9673de3d45f82c$export$abfcaeeca4ae7a55() {
    return (0, $5uXOq.useContext)($ac9673de3d45f82c$export$d158fa15757a1890);
}

});


parcelRegister("cugaz", function(module, exports) {

$parcel$export(module.exports, "SideNavToggleButtonElement", () => $2b466b4d9c369ddb$export$9c1768094bef896);
$parcel$export(module.exports, "SideNavToggleButtonAttachRef", () => $2b466b4d9c369ddb$export$fb8fa9a80240785e);

var $5uXOq = parcelRequire("5uXOq");

var $bKnKN = parcelRequire("bKnKN");
const $2b466b4d9c369ddb$export$9c1768094bef896 = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $2b466b4d9c369ddb$export$fb8fa9a80240785e = /*#__PURE__*/ (0, $5uXOq.createContext)((0, $bKnKN.default));

});

parcelRegister("e3mEE", function(module, exports) {

$parcel$export(module.exports, "useSideNavVisibility", () => $ca889ad353ba28f6$export$4a602ad7e09bdb2c);

var $5uXOq = parcelRequire("5uXOq");

var $8t2il = parcelRequire("8t2il");
const $ca889ad353ba28f6$export$4a602ad7e09bdb2c = ({ defaultCollapsed: defaultCollapsed = false } = {})=>{
    const sideNavState = (0, $5uXOq.useContext)((0, $8t2il.SideNavVisibilityState));
    // If the context value is `null`, it means we are still in SSR, and should use the default values.
    // For desktop, it comes from the `defaultCollapsed` prop, and for mobile, it is always `false`.
    if (sideNavState === null) return {
        isExpandedOnDesktop: !defaultCollapsed,
        isExpandedOnMobile: false
    };
    return {
        isExpandedOnDesktop: sideNavState.desktop === 'expanded',
        isExpandedOnMobile: sideNavState.mobile === 'expanded'
    };
};

});
parcelRegister("8t2il", function(module, exports) {

$parcel$export(module.exports, "SideNavVisibilityState", () => $eb3942e8fb2c17b2$export$eb04201bb6dd1e4e);
$parcel$export(module.exports, "SetSideNavVisibilityState", () => $eb3942e8fb2c17b2$export$f6b496b07d1ea493);

var $5uXOq = parcelRequire("5uXOq");

var $bKnKN = parcelRequire("bKnKN");
const $eb3942e8fb2c17b2$export$eb04201bb6dd1e4e = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $eb3942e8fb2c17b2$export$f6b496b07d1ea493 = /*#__PURE__*/ (0, $5uXOq.createContext)((0, $bKnKN.default));

});


parcelRegister("dDr3w", function(module, exports) {

$parcel$export(module.exports, "useToggleSideNav", () => $a9d23613a3f1c481$export$477ee35601a0a8ce);

var $5uXOq = parcelRequire("5uXOq");

var $3joPi = parcelRequire("3joPi");

var $8t2il = parcelRequire("8t2il");
function $a9d23613a3f1c481$export$477ee35601a0a8ce() {
    const setSideNavState = (0, $5uXOq.useContext)((0, $8t2il.SetSideNavVisibilityState));
    const toggleSideNav = (0, $5uXOq.useCallback)(()=>{
        const { matches: matches } = window.matchMedia('(min-width: 64rem)');
        if (matches) setSideNavState((currentState)=>{
            (0, $3joPi.default)(currentState, 'Side nav state should not be null');
            return {
                mobile: currentState.mobile,
                desktop: currentState.desktop === 'expanded' ? 'collapsed' : 'expanded',
                flyout: 'closed'
            };
        });
        else setSideNavState((currentState)=>{
            (0, $3joPi.default)(currentState, 'Side nav state should not be null');
            return {
                desktop: currentState.desktop,
                mobile: currentState.mobile === 'expanded' ? 'collapsed' : 'expanded',
                flyout: 'closed'
            };
        });
    }, [
        setSideNavState
    ]);
    return toggleSideNav;
}

});


parcelRegister("2wunj", function(module, exports) {

$parcel$export(module.exports, "UserActions", () => $d76e01a4559dadc2$export$2fb70d5e506c6bc2);
/* user-actions.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $DEWI6 = parcelRequire("DEWI6");

var $1SIzn = parcelRequire("1SIzn");

var $c8rIN = parcelRequire("c8rIN");

var $fHpHg = parcelRequire("fHpHg");

var $vCqQa = parcelRequire("vCqQa");

var $cNgF9 = parcelRequire("cNgF9");

var $baVkR = parcelRequire("baVkR");

var $bRH8U = parcelRequire("bRH8U");

var $3926G = parcelRequire("3926G");
const $d76e01a4559dadc2$var$containerStyles = {
    root: "_yyhy11wp _1e0c1txw _1bahh9n0 _1ul9zwfg",
    newLayoutStyles: "_1d2y1ris",
    contentMinWidthStyles: "_glte1ris _15ri1mjv _1gs5usvi _ndwch9n0"
};
const $d76e01a4559dadc2$var$listStyles = {
    root: "_zulp1b66 _4cvr1h6o _1e0c1txw",
    hideOnSmallViewport: "_1e0cglyw _181n1txw",
    popupContainer: "_1yt4u2gc"
};
const $d76e01a4559dadc2$export$2fb70d5e506c6bc2 = ({ children: children, label: label = 'Actions', showMoreButtonLabel: showMoreButtonLabel = 'Show more' })=>{
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    // Always setting to `false` for the initial render (will flip in an effect for mobile)
    const [isMobile, setIsMobile] = (0, $5uXOq.useState)(false);
    // Note: `query` is a stable value between renders
    const query = (0, $cNgF9.UNSAFE_useMediaQuery)('below.sm', function onChange(event) {
        setIsMobile(event.matches);
        // Any time we shift between mobile and desktop
        // We always close the popup
        setIsOpen(false);
    });
    (0, $1SIzn.useLayoutEffect)(()=>{
        // The default is `false`, and desktop will remain as `false` (no re-render).
        // Mobile will flip from `false` to `true`.
        setIsMobile(query?.matches ?? false);
    }, [
        query
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("nav", {
        "aria-label": label,
        className: (0, $bwpsq.default)([
            $d76e01a4559dadc2$var$containerStyles.root,
            (0, $fHpHg.fg)('platform_design_system_nav4_top_nav_columns') && $d76e01a4559dadc2$var$containerStyles.newLayoutStyles,
            (0, $fHpHg.fg)('platform_design_system_nav4_top_nav_min_widths') && $d76e01a4559dadc2$var$containerStyles.contentMinWidthStyles
        ]),
        children: isMobile ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $vCqQa.default), {
            isOpen: isOpen,
            onClose: ()=>setIsOpen(false),
            placement: "bottom-start",
            shouldRenderToParent: true,
            content: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $bRH8U.HasCustomThemeContext).Provider, {
                    value: false,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $baVkR.List), {
                        xcss: (0, $DEWI6.cx)($d76e01a4559dadc2$var$listStyles.root, $d76e01a4559dadc2$var$listStyles.popupContainer),
                        children: children
                    })
                }),
            trigger: (triggerProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $3926G.IconButton), {
                    ...triggerProps,
                    label: showMoreButtonLabel,
                    isSelected: isOpen,
                    onClick: ()=>setIsOpen(!isOpen),
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($c8rIN))),
                    isTooltipDisabled: false
                })
        }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $baVkR.List), {
            xcss: (0, $DEWI6.cx)($d76e01a4559dadc2$var$listStyles.root, $d76e01a4559dadc2$var$listStyles.hideOnSmallViewport),
            children: children
        })
    });
};

});
parcelRegister("1SIzn", function(module, exports) {

$parcel$export(module.exports, "useLayoutEffect", () => $ef80b2d852a77772$export$e5c5a5f917a5871c);

var $5uXOq = parcelRequire("5uXOq");
const $ef80b2d852a77772$export$e5c5a5f917a5871c = typeof window === 'undefined' ? (0, $5uXOq.useEffect) : (0, $5uXOq.useLayoutEffect);

});

parcelRegister("baVkR", function(module, exports) {

$parcel$export(module.exports, "List", () => $d0e983210771d46b$export$54c2e3dc7acea9f5);
/* list.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
function $d0e983210771d46b$var$_List({ children: children, testId: testId, xcss: xcss }, forwardedRef) {
    return(/**
     * We are using `role="list"` instead of a `ul` element to enable more flexible
     * composition. By using ARIA roles we can validly have elements between a list
     * and list items, as long as those in-between elements have no semantics.
     */ /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        role: "list",
        ref: forwardedRef,
        className: xcss,
        "data-testid": testId,
        children: children
    }));
}
const $d0e983210771d46b$export$54c2e3dc7acea9f5 = /*#__PURE__*/ (0, $5uXOq.forwardRef)($d0e983210771d46b$var$_List);

});


parcelRegister("2Xq9Q", function(module, exports) {

$parcel$export(module.exports, "Profile", () => $aeba4f44a3e66665$export$5120f2d0b8d4cab8);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $2JYdg = parcelRequire("2JYdg");
const $aeba4f44a3e66665$export$5120f2d0b8d4cab8 = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { component: component, href: href, icon: icon, id: id, isDisabled: isDisabled, isSelected: isSelected, label: labelProp, onBlur: onBlur, onClick: onClick, onFocus: onFocus, onMouseDown: onMouseDown, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, target: target, testId: testId, theme: theme, tooltip: tooltip, ...rest } = props;
    const label = labelProp || (typeof tooltip === 'string' ? tooltip : 'Your profile and settings');
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        role: "listitem",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2JYdg.IconButton), {
            component: component,
            href: href,
            icon: icon,
            id: id,
            isDisabled: isDisabled,
            isSelected: isSelected,
            label: label,
            onBlur: onBlur,
            onClick: onClick,
            onFocus: onFocus,
            onMouseDown: onMouseDown,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            onMouseUp: onMouseUp,
            ref: ref,
            target: target,
            testId: testId,
            // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
            theme: theme,
            tooltip: tooltip,
            isTooltipAnnouncementDisabled: true,
            ...rest
        })
    });
});
var // This exists only to extract props.
// eslint-disable-next-line import/no-anonymous-default-export
$aeba4f44a3e66665$export$2e2bcd8739ae039 = (props)=>{};

});
parcelRegister("2JYdg", function(module, exports) {

$parcel$export(module.exports, "IconButton", () => $789e66e6ffbfcc88$export$c25acd513dcc8062);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $1nSOt = parcelRequire("1nSOt");

var $5KCCi = parcelRequire("5KCCi");

var $h4hQR = parcelRequire("h4hQR");

var $4gvwp = parcelRequire("4gvwp");
const $789e66e6ffbfcc88$export$c25acd513dcc8062 = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { icon: icon, label: label, testId: testId, tooltip: tooltip, component: component, href: href, id: id, isDisabled: isDisabled, isSelected: isSelected, onBlur: onBlur, onClick: onClick, onFocus: onFocus, onMouseDown: onMouseDown, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, target: target, theme: theme, isTooltipAnnouncementDisabled: isTooltipAnnouncementDisabled = false, ...rest } = props;
    const themeFromContext = (0, $h4hQR.useTheme)();
    const button = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1nSOt.default), {
        appearance: "primary",
        "aria-label": label,
        component: component,
        href: href,
        iconBefore: icon,
        id: id,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onMouseUp: onMouseUp,
        ref: ref,
        target: target,
        testId: testId,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides, @atlaskit/design-system/no-unsafe-style-overrides
        theme: theme || (0, $4gvwp.getIconButtonTheme)(themeFromContext),
        ...rest
    });
    if (tooltip) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5KCCi.default), {
        content: tooltip,
        hideTooltipOnClick: true,
        isScreenReaderAnnouncementDisabled: isTooltipAnnouncementDisabled,
        children: button
    });
    return button;
});

});
parcelRegister("h4hQR", function(module, exports) {

$parcel$export(module.exports, "useTheme", () => $865ceae5c301d213$export$93d4e7f90805808f);

var $5uXOq = parcelRequire("5uXOq");

var $C4qHS = parcelRequire("C4qHS");
const $865ceae5c301d213$export$93d4e7f90805808f = ()=>(0, $5uXOq.useContext)((0, $C4qHS.ThemeContext));

});
parcelRegister("C4qHS", function(module, exports) {

$parcel$export(module.exports, "ThemeContext", () => $9dc3403f07de635d$export$2c657da244d00bd6);
$parcel$export(module.exports, "ThemeProvider", () => $9dc3403f07de635d$export$d8964aec282183a3);

var $5uXOq = parcelRequire("5uXOq");

var $4ZDdq = parcelRequire("4ZDdq");
const $9dc3403f07de635d$export$2c657da244d00bd6 = /*#__PURE__*/ (0, $5uXOq.createContext)((0, $4ZDdq.defaultTheme));
const $9dc3403f07de635d$export$d8964aec282183a3 = $9dc3403f07de635d$export$2c657da244d00bd6.Provider;

});
parcelRegister("4ZDdq", function(module, exports) {

$parcel$export(module.exports, "defaultTheme", () => $17a3e383b91e0526$export$164de7ab8df77ef0);


var $2pvyh = parcelRequire("2pvyh");

var $ltsrX = parcelRequire("ltsrX");
const $17a3e383b91e0526$export$eeee8619e1b91cb0 = (0, $ltsrX.generateTheme)({
    name: (0, $2pvyh.DEFAULT_THEME_NAME),
    backgroundColor: (0, $a7f8c6b391092279$export$29a4f05edc054374),
    highlightColor: (0, $a7f8c6b391092279$export$b3de0ae08da2ce64)
});
const $17a3e383b91e0526$export$164de7ab8df77ef0 = $17a3e383b91e0526$export$eeee8619e1b91cb0;

});
parcelRegister("2pvyh", function(module, exports) {

$parcel$export(module.exports, "defaultThemeBrandRefresh", () => $4ab59258d565db74$export$77823bc9863eaa03);
$parcel$export(module.exports, "DEFAULT_THEME_NAME", () => $4ab59258d565db74$export$2491e13b198e597d);
$parcel$export(module.exports, "default", () => $4ab59258d565db74$export$2e2bcd8739ae039);


var $bKFpw = parcelRequire("bKFpw");
const $4ab59258d565db74$var$defaultTheme = {
    mode: {
        create: {
            active: {
                color: `var(--ds-text-inverse, ${(0, $a7f8c6b391092279$export$29a4f05edc054374)})`,
                backgroundColor: `var(--ds-background-brand-bold-pressed, ${(0, $bKFpw.hexToRGBA)((0, $a7f8c6b391092279$export$b3de0ae08da2ce64), 0.8)})`,
                boxShadow: ''
            },
            default: {
                color: `var(--ds-text-inverse, ${(0, $a7f8c6b391092279$export$29a4f05edc054374)})`,
                backgroundColor: `var(--ds-background-brand-bold, ${(0, $a7f8c6b391092279$export$b3de0ae08da2ce64)})`,
                boxShadow: ''
            },
            focus: {
                color: `var(--ds-text-inverse, ${(0, $a7f8c6b391092279$export$29a4f05edc054374)})`,
                backgroundColor: '',
                boxShadow: ''
            },
            hover: {
                color: `var(--ds-text-inverse, ${(0, $a7f8c6b391092279$export$29a4f05edc054374)})`,
                backgroundColor: `var(--ds-background-brand-bold-hovered, ${(0, $bKFpw.hexToRGBA)((0, $a7f8c6b391092279$export$b3de0ae08da2ce64), 0.9)})`,
                boxShadow: ''
            },
            selected: {
                color: '',
                backgroundColor: '',
                boxShadow: ''
            }
        },
        iconButton: {
            active: {
                color: `var(--ds-text-subtle, ${(0, $a7f8c6b391092279$export$b3de0ae08da2ce64)})`,
                backgroundColor: `var(--ds-background-neutral-pressed, ${(0, $bKFpw.hexToRGBA)((0, $a7f8c6b391092279$export$226de0355ed012f8), 0.6)})`,
                boxShadow: ''
            },
            default: {
                color: `var(--ds-text-subtle, ${(0, $a7f8c6b391092279$export$7090862dc3038a9f)})`,
                backgroundColor: 'transparent',
                boxShadow: ''
            },
            focus: {
                color: `var(--ds-text-subtle, ${(0, $a7f8c6b391092279$export$7090862dc3038a9f)})`,
                backgroundColor: '',
                boxShadow: ''
            },
            hover: {
                color: `var(--ds-text-subtle, ${(0, $a7f8c6b391092279$export$b3de0ae08da2ce64)})`,
                backgroundColor: `var(--ds-background-neutral-hovered, ${(0, $bKFpw.hexToRGBA)((0, $a7f8c6b391092279$export$226de0355ed012f8), 0.9)})`,
                boxShadow: ''
            },
            selected: {
                color: `var(--ds-text-selected, ${(0, $a7f8c6b391092279$export$b3de0ae08da2ce64)})`,
                backgroundColor: `var(--ds-background-selected, ${(0, $bKFpw.hexToRGBA)((0, $a7f8c6b391092279$export$226de0355ed012f8), 0.6)})`,
                boxShadow: ''
            },
            selectedHover: {
                color: `var(--ds-text-selected, ${(0, $a7f8c6b391092279$export$b3de0ae08da2ce64)})`,
                backgroundColor: `var(--ds-background-selected-hovered, ${(0, $bKFpw.hexToRGBA)((0, $a7f8c6b391092279$export$226de0355ed012f8), 0.6)})`,
                boxShadow: ''
            }
        },
        navigation: {
            backgroundColor: `var(--ds-surface, ${(0, $a7f8c6b391092279$export$29a4f05edc054374)})`,
            color: `var(--ds-text-subtlest, ${(0, $a7f8c6b391092279$export$f563ee71e9ee74cd)})`
        },
        productHome: {
            backgroundColor: `var(--ds-text-brand, ${(0, $a7f8c6b391092279$export$b3de0ae08da2ce64)})`,
            color: `var(--ds-text, ${(0, $a7f8c6b391092279$export$ad0bacf983b7ddaa)})`,
            borderRight: `1px solid ${`var(--ds-border, ${(0, $bKFpw.hexToRGBA)((0, $a7f8c6b391092279$export$f563ee71e9ee74cd), 0.3)})`}`,
            // TODO: replace with token after brand refresh
            iconColor: '#357DE8',
            textColor: `var(--ds-text, ${(0, $a7f8c6b391092279$export$ad0bacf983b7ddaa)})`
        },
        primaryButton: {
            active: {
                color: `var(--ds-text-subtle, ${(0, $a7f8c6b391092279$export$b3de0ae08da2ce64)})`,
                backgroundColor: `var(--ds-background-neutral-pressed, ${(0, $bKFpw.hexToRGBA)((0, $a7f8c6b391092279$export$226de0355ed012f8), 0.7)})`,
                boxShadow: ''
            },
            default: {
                color: `var(--ds-text-subtle, ${(0, $a7f8c6b391092279$export$7090862dc3038a9f)})`,
                backgroundColor: 'transparent',
                boxShadow: ''
            },
            focus: {
                color: `var(--ds-text-subtle, ${(0, $a7f8c6b391092279$export$7090862dc3038a9f)})`,
                backgroundColor: '',
                boxShadow: ''
            },
            hover: {
                color: `var(--ds-text-subtle, ${(0, $a7f8c6b391092279$export$b3de0ae08da2ce64)})`,
                backgroundColor: `var(--ds-background-neutral-hovered, ${(0, $bKFpw.hexToRGBA)((0, $a7f8c6b391092279$export$226de0355ed012f8), 0.9)})`,
                boxShadow: ''
            },
            selected: {
                color: `var(--ds-text-selected, ${(0, $a7f8c6b391092279$export$b3de0ae08da2ce64)})`,
                backgroundColor: `var(--ds-background-selected, ${(0, $bKFpw.hexToRGBA)((0, $a7f8c6b391092279$export$226de0355ed012f8), 0.7)})`,
                boxShadow: '',
                borderColor: `var(--ds-border-selected, ${(0, $a7f8c6b391092279$export$b3de0ae08da2ce64)})`
            },
            selectedHover: {
                color: `var(--ds-text-selected, ${(0, $a7f8c6b391092279$export$b3de0ae08da2ce64)})`,
                backgroundColor: `var(--ds-background-selected-hovered, ${(0, $bKFpw.hexToRGBA)((0, $a7f8c6b391092279$export$226de0355ed012f8), 0.6)})`,
                boxShadow: '',
                borderColor: `var(--ds-border-selected, ${(0, $a7f8c6b391092279$export$b3de0ae08da2ce64)})`
            }
        },
        search: {
            default: {
                backgroundColor: `var(--ds-background-input, ${(0, $a7f8c6b391092279$export$29a4f05edc054374)})`,
                color: `var(--ds-text-subtlest, ${(0, $a7f8c6b391092279$export$f563ee71e9ee74cd)})`,
                borderColor: `var(--ds-border-input, ${(0, $a7f8c6b391092279$export$d6447c357493214f)})`
            },
            focus: {
                borderColor: `var(--ds-border-focused, ${(0, $a7f8c6b391092279$export$215b7063051591f1)})`
            },
            hover: {
                backgroundColor: `var(--ds-background-input-hovered, ${(0, $a7f8c6b391092279$export$29a4f05edc054374)})`
            }
        },
        skeleton: {
            backgroundColor: `var(--ds-background-neutral, ${(0, $a7f8c6b391092279$export$9fdfb749e33cdf97)})`,
            opacity: 1
        }
    }
};
// Create deep copy of defaultTheme
const $4ab59258d565db74$var$defaultThemeCopy = JSON.parse(JSON.stringify($4ab59258d565db74$var$defaultTheme));
// Update iconColor and textColor in defaultThemeBrandRefresh
$4ab59258d565db74$var$defaultThemeCopy.mode.productHome.iconColor = undefined;
$4ab59258d565db74$var$defaultThemeCopy.mode.productHome.textColor = undefined;
const $4ab59258d565db74$export$77823bc9863eaa03 = $4ab59258d565db74$var$defaultThemeCopy;
const $4ab59258d565db74$export$2491e13b198e597d = 'atlassian';
var $4ab59258d565db74$export$2e2bcd8739ae039 = $4ab59258d565db74$var$defaultTheme;

});
parcelRegister("bKFpw", function(module, exports) {

$parcel$export(module.exports, "hexToRGBA", () => $f4936ee9ac6215e0$export$7229be6d7219ee6a);
$parcel$export(module.exports, "getBoxShadow", () => $f4936ee9ac6215e0$export$bba5a971afe05444);
$parcel$export(module.exports, "generateTextColor", () => $f4936ee9ac6215e0$export$10a10e7cd1193377);
$parcel$export(module.exports, "getContrastColor", () => $f4936ee9ac6215e0$export$77a1051494882576);

var $dBl98 = parcelRequire("dBl98");
const $f4936ee9ac6215e0$export$7229be6d7219ee6a = (hex, opacity = 1)=>{
    const rgba = {
        ...(0, $dBl98.default).convert(hex).rgb,
        a: opacity
    };
    return `rgba(${Object.values(rgba).join(', ')})`;
};
const $f4936ee9ac6215e0$export$bba5a971afe05444 = (color)=>`0 0 0 2px ${color}`;
const $f4936ee9ac6215e0$var$hex = '[a-z0-9]';
const $f4936ee9ac6215e0$var$shortHandHexColorPattern = new RegExp(`#(${$f4936ee9ac6215e0$var$hex})(${$f4936ee9ac6215e0$var$hex})(${$f4936ee9ac6215e0$var$hex})`, 'i');
const $f4936ee9ac6215e0$var$repeat = (str, times)=>[
        ...Array(times)
    ].map(()=>str).join('');
const $f4936ee9ac6215e0$var$isShortHexColor = (color)=>color && color.length === 4;
const $f4936ee9ac6215e0$var$completeHexColor = (colors)=>{
    const hex = colors.map((color)=>$f4936ee9ac6215e0$var$repeat(color, 2)).join('');
    return `#${hex}`;
};
const $f4936ee9ac6215e0$var$completeTriplet = (colors)=>`#${$f4936ee9ac6215e0$var$repeat(colors[1], 6)}`;
const $f4936ee9ac6215e0$var$isTriplet = (colors)=>colors[0] === colors[1] && colors[1] === colors[2];
const $f4936ee9ac6215e0$export$db8d2130677f868c = (color)=>{
    if ($f4936ee9ac6215e0$var$isShortHexColor(color)) {
        // when color = '#ccc', matches is structured as ['#ccc', 'c', 'c', 'c', ...]
        const matches = color.match($f4936ee9ac6215e0$var$shortHandHexColorPattern);
        if (matches) {
            const colors = matches.slice(1, 4);
            if ($f4936ee9ac6215e0$var$isTriplet(colors)) return $f4936ee9ac6215e0$var$completeTriplet(colors);
            else return $f4936ee9ac6215e0$var$completeHexColor(colors);
        }
    }
    // return the color as is when it's not hex color shorthand
    return color;
};
const $f4936ee9ac6215e0$export$10a10e7cd1193377 = (color)=>{
    const converted = $f4936ee9ac6215e0$export$db8d2130677f868c(color);
    return (0, $dBl98.default).contrastRatio(converted).hex;
};
const $f4936ee9ac6215e0$export$77a1051494882576 = (contrastValue, opacityValue, color)=>$f4936ee9ac6215e0$export$7229be6d7219ee6a((0, $dBl98.default).contrast(contrastValue, color).hex, opacityValue);

});


parcelRegister("ltsrX", function(module, exports) {

$parcel$export(module.exports, "generateTheme", () => $c9d7f93ad27145a6$export$2e4ecffaca289a18);

var $fHpHg = parcelRequire("fHpHg");

var $2pvyh = parcelRequire("2pvyh");

var $bKFpw = parcelRequire("bKFpw");
const $c9d7f93ad27145a6$var$generateOpacityValue = (color)=>color === '#000000' ? 0.3 : 0.6;
const $c9d7f93ad27145a6$var$generateButtonCSSStates = (colors, buttonType)=>{
    const { backgroundColor: backgroundColor, color: color, highlightColor: highlightColor } = colors;
    // Add less opacity for white text so it is still legible.
    const opacityValue = $c9d7f93ad27145a6$var$generateOpacityValue(color);
    const isCreateButton = buttonType === 'create';
    return {
        active: {
            backgroundColor: isCreateButton ? (0, $bKFpw.hexToRGBA)(backgroundColor, 0.65) : (0, $bKFpw.getContrastColor)(0.3, opacityValue, backgroundColor),
            boxShadow: (0, $bKFpw.getBoxShadow)('transparent'),
            color: color
        },
        default: {
            backgroundColor: backgroundColor,
            boxShadow: (0, $bKFpw.getBoxShadow)('transparent'),
            color: color
        },
        focus: {
            boxShadow: 'none',
            color: color,
            backgroundColor: backgroundColor
        },
        hover: {
            backgroundColor: isCreateButton ? (0, $bKFpw.hexToRGBA)(backgroundColor, 0.8) : (0, $bKFpw.getContrastColor)(0.1, opacityValue, backgroundColor),
            boxShadow: (0, $bKFpw.getBoxShadow)('transparent'),
            color: color
        },
        selected: {
            color: color,
            backgroundColor: (0, $bKFpw.getContrastColor)(0.3, opacityValue, backgroundColor),
            borderColor: highlightColor,
            boxShadow: (0, $bKFpw.getBoxShadow)('transparent')
        },
        selectedHover: {
            color: color,
            backgroundColor: (0, $bKFpw.getContrastColor)(0.3, opacityValue, backgroundColor),
            borderColor: highlightColor,
            boxShadow: (0, $bKFpw.getBoxShadow)('transparent')
        }
    };
};
const $c9d7f93ad27145a6$var$generateCreateButtonColors = (themeBackground, themeHighlight)=>({
        backgroundColor: themeHighlight,
        color: (0, $bKFpw.generateTextColor)(themeHighlight),
        highlightColor: themeHighlight
    });
const $c9d7f93ad27145a6$export$2e4ecffaca289a18 = (themeColors)=>{
    const { backgroundColor: backgroundColor, highlightColor: highlightColor, name: name } = themeColors;
    const color = (0, $bKFpw.generateTextColor)(backgroundColor);
    const colors = {
        ...themeColors,
        color: color
    };
    if (name === (0, $2pvyh.DEFAULT_THEME_NAME)) return (0, $fHpHg.fg)('platform-team25-app-icon-tiles') ? (0, $2pvyh.defaultThemeBrandRefresh) : (0, $2pvyh.default);
    return {
        mode: {
            create: $c9d7f93ad27145a6$var$generateButtonCSSStates($c9d7f93ad27145a6$var$generateCreateButtonColors(backgroundColor, highlightColor), 'create'),
            iconButton: $c9d7f93ad27145a6$var$generateButtonCSSStates(colors, 'iconButton'),
            primaryButton: $c9d7f93ad27145a6$var$generateButtonCSSStates(colors, 'primaryButton'),
            navigation: {
                backgroundColor: backgroundColor,
                color: color
            },
            productHome: {
                color: color,
                iconColor: (0, $fHpHg.fg)('platform-team25-app-icon-tiles') ? color : undefined,
                textColor: (0, $fHpHg.fg)('platform-team25-app-icon-tiles') ? color : undefined,
                backgroundColor: highlightColor,
                borderRight: `1px solid ${(0, $bKFpw.hexToRGBA)(color, 0.5)}`
            },
            search: {
                default: {
                    backgroundColor: backgroundColor,
                    color: color,
                    borderColor: (0, $bKFpw.hexToRGBA)(color, 0.5)
                },
                focus: {
                    borderColor: (0, $bKFpw.hexToRGBA)(highlightColor, 0.8),
                    boxShadow: (0, $bKFpw.getBoxShadow)((0, $bKFpw.hexToRGBA)(highlightColor, 0.5))
                },
                hover: {
                    backgroundColor: (0, $bKFpw.getContrastColor)(0.1, $c9d7f93ad27145a6$var$generateOpacityValue(color), backgroundColor),
                    color: color
                }
            },
            skeleton: {
                backgroundColor: color,
                opacity: 0.08
            }
        }
    };
};

});




parcelRegister("4gvwp", function(module, exports) {

$parcel$export(module.exports, "getIconButtonTheme", () => $a4d21daeaf997cd9$export$f32bddcb857301f3);
const $a4d21daeaf997cd9$export$f32bddcb857301f3 = ({ mode: { iconButton: iconButton } })=>(current, props)=>{
        const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = current(props);
        return {
            buttonStyles: {
                ...buttonStyles,
                borderRadius: "var(--ds-border-radius-circle, 100%)",
                display: 'flex',
                margin: `0 ${"var(--ds-space-025, 2px)"}`,
                // TODO Delete this comment after verifying space token -> previous value `4`
                padding: "var(--ds-space-050, 4px)",
                height: 'auto',
                fontWeight: "var(--ds-font-weight-medium, 500)",
                ...iconButton.default,
                ':hover': iconButton.hover,
                ':focus': iconButton.focus,
                // :active doesn't work in FF, because we do a
                // e.preventDefault() on mouse down in Button.
                // '&&' is required to add more CSS specificity
                // && it not a valid CSSObject property
                // @ts-ignore
                '&&': {
                    ...props.state === 'active' && iconButton.active
                },
                ...props.state === 'selected' && iconButton.selected,
                '> span': {
                    margin: 0
                }
            },
            spinnerStyles: spinnerStyles
        };
    };

});



parcelRegister("etfHb", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::87e7af881897ed302561350d986556a5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a88ff2f137222c7d$var$_react = $a88ff2f137222c7d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $a88ff2f137222c7d$var$_personAvatar = $a88ff2f137222c7d$var$_interopRequireDefault((parcelRequire("l1s8i")));

var $a88ff2f137222c7d$var$_userAvatarCircle = $a88ff2f137222c7d$var$_interopRequireDefault((parcelRequire("6K1uI")));
function $a88ff2f137222c7d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for PersonAvatarIcon.
 * This component is PersonAvatarIcon, with `UNSAFE_fallbackIcon` set to "UserAvatarCircleIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for user avatar.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a88ff2f137222c7d$var$PersonAvatarIcon = (props)=>/*#__PURE__*/ $a88ff2f137222c7d$var$_react.default.createElement($a88ff2f137222c7d$var$_personAvatar.default, Object.assign({
        LEGACY_fallbackIcon: $a88ff2f137222c7d$var$_userAvatarCircle.default
    }, props));
$a88ff2f137222c7d$var$PersonAvatarIcon.Name = 'PersonAvatarIconMigration';
var $a88ff2f137222c7d$var$_default = module.exports.default = $a88ff2f137222c7d$var$PersonAvatarIcon;

});

parcelRegister("8vMe2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0b0ad8e82692fcbf05d6af098ca724db>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6326a08ea093ab4e$var$_react = $6326a08ea093ab4e$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $6326a08ea093ab4e$var$_baseNew = $6326a08ea093ab4e$var$_interopRequireDefault((parcelRequire("enEmH")));
function $6326a08ea093ab4e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LogOut".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for log out.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6326a08ea093ab4e$var$LogOutIcon = (props)=>/*#__PURE__*/ $6326a08ea093ab4e$var$_react.default.createElement($6326a08ea093ab4e$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 2.5h5V1H3a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h5v-1.5H3a.5.5 0 0 1-.5-.5V3a.5.5 0 0 1 .5-.5m11.78 4.97-3.5-3.5-1.06 1.06 2.22 2.22H6v1.5h6.44l-2.22 2.22 1.06 1.06 3.5-3.5a.75.75 0 0 0 0-1.06" clip-rule="evenodd"/>`
    }, props));
$6326a08ea093ab4e$var$LogOutIcon.displayName = 'LogOutIcon';
var $6326a08ea093ab4e$var$_default = module.exports.default = $6326a08ea093ab4e$var$LogOutIcon;

});

parcelRegister("dnGcR", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::95792f9115c7157853016297128836bc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $02839551407abfa7$var$_react = $02839551407abfa7$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $02839551407abfa7$var$_settings = $02839551407abfa7$var$_interopRequireDefault((parcelRequire("51oeD")));

var $02839551407abfa7$var$_settings2 = $02839551407abfa7$var$_interopRequireDefault((parcelRequire("6sQcY")));
function $02839551407abfa7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for SettingsIcon.
 * This component is SettingsIcon, with `UNSAFE_fallbackIcon` set to "SettingsIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for any object or user settings.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $02839551407abfa7$var$SettingsIcon = (props)=>/*#__PURE__*/ $02839551407abfa7$var$_react.default.createElement($02839551407abfa7$var$_settings.default, Object.assign({
        LEGACY_fallbackIcon: $02839551407abfa7$var$_settings2.default
    }, props));
$02839551407abfa7$var$SettingsIcon.Name = 'SettingsIconMigration';
var $02839551407abfa7$var$_default = module.exports.default = $02839551407abfa7$var$SettingsIcon;

});

parcelRegister("gnVb6", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a6cc9a6d9d7d0d0$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ltBcH = parcelRequire("ltBcH");
const $7a6cc9a6d9d7d0d0$var$PeopleIconGlyph = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.className,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            fill: "currentColor",
            d: "M10.523 11.3a4.5 4.5 0 0 1 4.5 4.5v2.5a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2v-2.5a4.5 4.5 0 0 1 4.5-4.5h3Zm6 0 .212.005a4.5 4.5 0 0 1 4.283 4.277l.005.218v2.5l-.005.15a2 2 0 0 1-1.838 1.844l-.157.006h-2l-.116-.007a1 1 0 0 1 0-1.986l.116-.007h2v-2.5l-.005-.165a2.5 2.5 0 0 0-2.33-2.33l-.165-.005h-.5l-.116-.007a1 1 0 0 1 0-1.986l.116-.007h.5Zm-6 2h-3a2.5 2.5 0 0 0-2.5 2.5v2.5h8v-2.5a2.5 2.5 0 0 0-2.5-2.5Zm-1.5-10a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7Zm4.61.294a3.5 3.5 0 1 1 0 6.412 1 1 0 0 1 .694-1.872l.24.09a1.5 1.5 0 1 0 .012-2.852l-.252.094a1 1 0 0 1-.693-1.872ZM9.024 5.3a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z"
        })
    });
/**
 * __PeopleIcon__
 */ const $7a6cc9a6d9d7d0d0$var$PeopleIcon = ({ label: label, primaryColor: primaryColor, secondaryColor: secondaryColor, size: size, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $ltBcH.default), {
        label: label,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        size: size,
        testId: testId,
        glyph: $7a6cc9a6d9d7d0d0$var$PeopleIconGlyph
    });
var $7a6cc9a6d9d7d0d0$export$2e2bcd8739ae039 = $7a6cc9a6d9d7d0d0$var$PeopleIcon;

});

parcelRegister("iEqeu", function(module, exports) {

$parcel$export(module.exports, "default", () => $d7f607d1a5416081$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ltBcH = parcelRequire("ltBcH");
const $d7f607d1a5416081$var$PersonIconGlyph = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.className,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            fill: "currentColor",
            d: "M13.523 11.3a4.504 4.504 0 0 1 4.478 4.063l.017.218.005.219v2.5c0 .964-.685 1.78-1.66 1.966l-.165.025-.175.009h-8c-.964 0-1.78-.686-1.966-1.66l-.025-.166-.009-.174v-2.5a4.504 4.504 0 0 1 4.064-4.478l.217-.017.22-.005h3Zm0 2H10.55l-.165.003a2.5 2.5 0 0 0-2.356 2.332l-.006.165-.001 2.442.001.058 7.943.002.057-.002v-2.473l-.003-.165a2.5 2.5 0 0 0-2.332-2.357l-.165-.005Zm-1.5-10a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7Zm0 2a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z"
        })
    });
/**
 * __PersonIcon__
 */ const $d7f607d1a5416081$var$PersonIcon = ({ label: label, primaryColor: primaryColor, secondaryColor: secondaryColor, size: size, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $ltBcH.default), {
        label: label,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        size: size,
        testId: testId,
        glyph: $d7f607d1a5416081$var$PersonIconGlyph
    });
var $d7f607d1a5416081$export$2e2bcd8739ae039 = $d7f607d1a5416081$var$PersonIcon;

});

parcelRegister("9pMJy", function(module, exports) {

$parcel$export(module.exports, "default", () => $8bee5e0cb0194633$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ltBcH = parcelRequire("ltBcH");
const $8bee5e0cb0194633$var$SignOutIconGlyph = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.className,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            fill: "currentColor",
            d: "m6.023 4.3-.149.005A2 2 0 0 0 4.024 6.3v12l.005.15a2 2 0 0 0 1.994 1.85h5l.117-.007a1 1 0 0 0-.117-1.993h-5v-12h5l.117-.007a1 1 0 0 0-.117-1.993h-5Zm9.293 4.293a1 1 0 0 0-.083 1.32l.084.094 1.292 1.292H9.023a1 1 0 0 0-.125 1.993l.125.008 7.586-.001-1.293 1.294a1 1 0 0 0-.083 1.32l.084.094a1 1 0 0 0 1.32.083l.094-.083 2.974-2.975c.096-.09.175-.198.23-.32l.011-.028a.757.757 0 0 0 .031-.083l.008-.027a.767.767 0 0 0 .02-.08l.007-.042a.767.767 0 0 0 .011-.133v-.039c0-.024-.002-.05-.004-.074l.004.094a1 1 0 0 0-.022-.215l-.008-.031a.807.807 0 0 0-.021-.074l-.018-.046a.64.64 0 0 0-.025-.062l-.019-.035a.64.64 0 0 0-.049-.083.667.667 0 0 0-.047-.07l-.084-.093-3-2.998a1 1 0 0 0-1.414 0Z"
        })
    });
/**
 * __SignOutIcon__
 */ const $8bee5e0cb0194633$var$SignOutIcon = ({ label: label, primaryColor: primaryColor, secondaryColor: secondaryColor, size: size, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $ltBcH.default), {
        label: label,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        size: size,
        testId: testId,
        glyph: $8bee5e0cb0194633$var$SignOutIconGlyph
    });
var $8bee5e0cb0194633$export$2e2bcd8739ae039 = $8bee5e0cb0194633$var$SignOutIcon;

});

parcelRegister("e7iqc", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c0554be23de64fc$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bKnKN = parcelRequire("bKnKN");

var $8ZVfC = parcelRequire("8ZVfC");

var $7H980 = parcelRequire("7H980");

var $fHpHg = parcelRequire("fHpHg");

var $60DYg = parcelRequire("60DYg");

var $1mKKh = parcelRequire("1mKKh");

var $9uB2U = parcelRequire("9uB2U");

var $91MH6 = parcelRequire("91MH6");

var $6cAn5 = parcelRequire("6cAn5");
/**
 * __Dropdown item radio__
 *
 * A dropdown item radio displays groups that have a single selection.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/dropdown-item-radio/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/dropdown-item-radio/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/dropdown-item-radio/usage)
 */ const $1c0554be23de64fc$var$DropdownItemRadio = ({ children: children, defaultSelected: defaultSelected, testId: testId, id: id, title: title, description: description, isDisabled: isDisabled, isSelected: isSelected, onClick: providedOnClick = (0, $bKnKN.default), shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, interactionName: interactionName, // DSP-13312 TODO: remove spread props in future major release
...rest })=>{
    typeof $6cAn5;
    const [selected, setSelected] = (0, $1mKKh.default)({
        id: id,
        isSelected: isSelected,
        defaultSelected: defaultSelected
    });
    const onClickHandler = (0, $5uXOq.useCallback)((event)=>{
        setSelected((selected)=>!selected);
        providedOnClick(event);
    }, [
        providedOnClick,
        setSelected
    ]);
    const itemRef = (0, $9uB2U.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8ZVfC.SELECTION_STYLE_CONTEXT_DO_NOT_USE).Provider, {
        value: "none",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7H980.default), {
            "aria-checked": selected,
            description: description,
            iconBefore: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $60DYg.default), {
                checked: selected
            }),
            id: id,
            isDisabled: isDisabled,
            isSelected: selected,
            onClick: onClickHandler,
            ref: itemRef,
            role: (0, $91MH6.default)() ? 'radio' : 'menuitemradio',
            shouldDescriptionWrap: shouldDescriptionWrap,
            shouldTitleWrap: shouldTitleWrap,
            testId: testId,
            // Thanks to spread props, this attribute are passed to ButtonItem, even though
            // it's not in the component's prop types.
            // @ts-expect-error
            title: title,
            ...(0, $fHpHg.fg)('platform_button_item-add-ufo-metrics') && {
                interactionName: interactionName
            },
            ...rest,
            children: children
        })
    });
};
var $1c0554be23de64fc$export$2e2bcd8739ae039 = $1c0554be23de64fc$var$DropdownItemRadio;

});
parcelRegister("60DYg", function(module, exports) {

$parcel$export(module.exports, "default", () => $25ee7c6b9623421b$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $2SY35 = parcelRequire("2SY35");

var $fHpHg = parcelRequire("fHpHg");

/**
 * __Radio icon__
 *
 * Used to visually represent the selected state in DropdownItemRadio
 *
 * @internal
 */ const $25ee7c6b9623421b$var$RadioIcon = ({ checked: checked })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2SY35.default), {
        label: "",
        size: "medium",
        primaryColor: checked ? `var(--ds-background-selected-bold, ${0, $a7f8c6b391092279$export$b3de0ae08da2ce64})` : `var(--ds-background-input, ${0, $a7f8c6b391092279$export$e655ef011c4aa1a2})`,
        secondaryColor: checked ? `var(--ds-icon-inverse, ${0, $a7f8c6b391092279$export$e655ef011c4aa1a2})` : 'transparent',
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("g", {
            fillRule: "evenodd",
            children: // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
            (0, $fHpHg.fg)('platform-visual-refresh-icons') ? /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)("circle", {
                        cx: "12",
                        cy: "12",
                        r: "7.5",
                        fill: "currentColor",
                        stroke: checked ? `var(--ds-border-selected, ${0, $a7f8c6b391092279$export$b3de0ae08da2ce64})` : `var(--ds-border-input, ${0, $a7f8c6b391092279$export$d6447c357493214f})`,
                        strokeWidth: "1"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("circle", {
                        cx: "12",
                        cy: "12",
                        r: "3",
                        fill: "inherit"
                    })
                ]
            }) : /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)("circle", {
                        fill: "currentColor",
                        cx: "12",
                        cy: "12",
                        r: "6",
                        stroke: checked ? `var(--ds-border-selected, ${0, $a7f8c6b391092279$export$b3de0ae08da2ce64})` : `var(--ds-border-input, ${0, $a7f8c6b391092279$export$d6447c357493214f})`,
                        strokeWidth: 1
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("circle", {
                        fill: "inherit",
                        cx: "12",
                        cy: "12",
                        r: "2"
                    })
                ]
            })
        })
    });
};
var $25ee7c6b9623421b$export$2e2bcd8739ae039 = $25ee7c6b9623421b$var$RadioIcon;

});

parcelRegister("1mKKh", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c996c2c8fa4bf57$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5Ow4A = parcelRequire("5Ow4A");

var $7eFf2 = parcelRequire("7eFf2");

var $e6S04 = parcelRequire("e6S04");
function $4c996c2c8fa4bf57$var$useRadioState({ id: id, isSelected: isSelected, defaultSelected: defaultSelected }) {
    const { setGroupState: setGroupState, getGroupState: getGroupState } = (0, $5uXOq.useContext)((0, $7eFf2.SelectionStoreContext));
    const { id: group, radioGroupState: radioGroupState, selectRadioItem: selectRadioItem } = (0, $5uXOq.useContext)((0, $5Ow4A.RadioGroupContext));
    const persistedIsSelected = radioGroupState[id];
    const [localIsSelected, setLocalIsSelected] = (0, $5uXOq.useState)(()=>persistedIsSelected !== undefined ? persistedIsSelected : defaultSelected || false);
    const setLocalState = (0, $5uXOq.useCallback)((newValue)=>{
        if (!persistedIsSelected) {
            const nextValue = newValue(persistedIsSelected);
            selectRadioItem(id, nextValue);
            setLocalIsSelected(nextValue);
        }
    }, [
        persistedIsSelected,
        id,
        selectRadioItem
    ]);
    /**
	 * - radio state changes any time a radio child is changed
	 * - when it changes we want all radio buttons to update their local state
	 * - it takes the value from radio group state and applies it locally if it exists which it will only exist, if it is selected
	 */ (0, $5uXOq.useEffect)(()=>{
        setLocalIsSelected(()=>{
            const existing = radioGroupState[id];
            return existing !== undefined ? existing : defaultSelected || false;
        });
    }, [
        radioGroupState,
        group,
        id,
        defaultSelected
    ]);
    if (typeof isSelected === 'boolean') return [
        isSelected,
        ()=>false
    ];
    if (persistedIsSelected === undefined) {
        const existing = getGroupState(group);
        setGroupState(group, {
            ...(0, $e6S04.default)(existing || {}),
            [id]: defaultSelected || false
        });
    }
    return [
        localIsSelected,
        setLocalState
    ];
}
var $4c996c2c8fa4bf57$export$2e2bcd8739ae039 = $4c996c2c8fa4bf57$var$useRadioState;

});
parcelRegister("5Ow4A", function(module, exports) {

$parcel$export(module.exports, "RadioGroupContext", () => $33b13274e9f03cad$export$a79eda4ff50e30b6);
$parcel$export(module.exports, "default", () => $33b13274e9f03cad$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bKnKN = parcelRequire("bKnKN");

var $jJsBW = parcelRequire("jJsBW");

var $70rf1 = parcelRequire("70rf1");

var $c320O = parcelRequire("c320O");

var $7eFf2 = parcelRequire("7eFf2");

var $e6S04 = parcelRequire("e6S04");
const $33b13274e9f03cad$export$a79eda4ff50e30b6 = /*#__PURE__*/ (0, $5uXOq.createContext)({
    id: '',
    radioGroupState: {},
    selectRadioItem: (0, $bKnKN.default)
});
/**
 * __Dropdown item radio group__
 *  Store which manages the selection state for each DropdownItemRadio
 *  across mount and unmounts.
 *
 */ const $33b13274e9f03cad$var$DropdownItemRadioGroup = ({ children: children, hasSeparator: hasSeparator, id: id, isList: isList, isScrollable: isScrollable, overrides: overrides, testId: testId, title: title, // DSP-13312 TODO: remove spread props in future major release
...rest })=>{
    const { setGroupState: setGroupState, getGroupState: getGroupState } = (0, $5uXOq.useContext)((0, $7eFf2.SelectionStoreContext));
    const uid = (0, $jJsBW.useId)();
    const titleId = `dropdown-menu-item-radio-group-title-${uid}`;
    /**
	 *  - initially `radioGroupState` is from selection store, so it's safe to update without re-rendering
	 *  - we flush a render by updating this local radio group state
	 */ const [radioGroupState, setRadioGroupState] = (0, $5uXOq.useState)(()=>getGroupState(id));
    const selectRadioItem = (childId, value)=>{
        const newValue = {
            ...(0, $e6S04.default)(getGroupState(id)),
            [childId]: value
        };
        setRadioGroupState(newValue);
        setGroupState(id, newValue);
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)($33b13274e9f03cad$export$a79eda4ff50e30b6.Provider, {
        value: {
            id: id,
            radioGroupState: radioGroupState,
            selectRadioItem: selectRadioItem
        },
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $70rf1.default), {
            hasSeparator: hasSeparator,
            id: id,
            isList: isList,
            isScrollable: isScrollable,
            // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides, @atlaskit/design-system/no-deprecated-apis
            overrides: overrides,
            testId: testId,
            titleId: title ? titleId : undefined,
            ...rest,
            children: [
                title && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $c320O.default), {
                    id: titleId,
                    title: title
                }),
                children
            ]
        })
    });
};
var $33b13274e9f03cad$export$2e2bcd8739ae039 = $33b13274e9f03cad$var$DropdownItemRadioGroup;

});
parcelRegister("e6S04", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f06646192f8f825$export$2e2bcd8739ae039);
const $2f06646192f8f825$var$resetOptionsInGroup = (group)=>{
    return Object.keys(group || {}).reduce((accumulator, current)=>({
            ...accumulator,
            [current]: typeof group[current] === 'undefined' ? undefined : false
        }), {});
};
var $2f06646192f8f825$export$2e2bcd8739ae039 = $2f06646192f8f825$var$resetOptionsInGroup;

});



parcelRegister("91MH6", function(module, exports) {

$parcel$export(module.exports, "default", () => $058d32b7112bef48$export$2e2bcd8739ae039);
const $058d32b7112bef48$var$canUseDOM = ()=>Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
/*
 * Making sure we can fallback to browsers doesn't support voice over -
 * we would using menuitemcheckbox / menuitemradio for these that supports voice over, and
 * will fallback to checkbox / radio for these doesn't
 */ const $058d32b7112bef48$var$isVoiceOverSupported = ()=>/Mac OS X/.test($058d32b7112bef48$var$canUseDOM() ? navigator.userAgent : '');
var $058d32b7112bef48$export$2e2bcd8739ae039 = $058d32b7112bef48$var$isVoiceOverSupported;

});


parcelRegister("jAyL0", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e16f3e8522976fe7001db436c90d9bf8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e42c572fa64a17e5$var$_react = $e42c572fa64a17e5$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $e42c572fa64a17e5$var$_baseNew = $e42c572fa64a17e5$var$_interopRequireDefault((parcelRequire("enEmH")));
function $e42c572fa64a17e5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Theme".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for representing themes and theme switching.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e42c572fa64a17e5$var$ThemeIcon = (props)=>/*#__PURE__*/ $e42c572fa64a17e5$var$_react.default.createElement($e42c572fa64a17e5$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m7.25-5H8a5 5 0 0 1 0 10h-.75z" clip-rule="evenodd"/>`
    }, props));
$e42c572fa64a17e5$var$ThemeIcon.displayName = 'ThemeIcon';
var $e42c572fa64a17e5$var$_default = module.exports.default = $e42c572fa64a17e5$var$ThemeIcon;

});

parcelRegister("cwX8H", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::202475837f81ea9047d0b06aafdb41ad>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $91f659060ab39392$var$_react = $91f659060ab39392$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $91f659060ab39392$var$_chevronRight = $91f659060ab39392$var$_interopRequireDefault((parcelRequire("LD2gx")));

var $91f659060ab39392$var$_chevronRight2 = $91f659060ab39392$var$_interopRequireDefault((parcelRequire("GYj5l")));
function $91f659060ab39392$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronRightIcon.
 * This component is ChevronRightIcon, with `UNSAFE_fallbackIcon` set to "ChevronRightIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for menu fly outs and to indicate next in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $91f659060ab39392$var$ChevronRightIcon = (props)=>/*#__PURE__*/ $91f659060ab39392$var$_react.default.createElement($91f659060ab39392$var$_chevronRight.default, Object.assign({
        LEGACY_fallbackIcon: $91f659060ab39392$var$_chevronRight2.default
    }, props));
$91f659060ab39392$var$ChevronRightIcon.Name = 'ChevronRightIconMigration';
var $91f659060ab39392$var$_default = module.exports.default = $91f659060ab39392$var$ChevronRightIcon;

});

parcelRegister("f0xyT", function(module, exports) {

$parcel$export(module.exports, "default", () => $8db3669fa3901b1a$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ltBcH = parcelRequire("ltBcH");
const $8db3669fa3901b1a$var$ThemeIconGlyph = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.className,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 20V4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
            fill: "currentColor"
        })
    });
/**
 * __ThemeIcon__
 */ const $8db3669fa3901b1a$var$ThemeIcon = ({ label: label, primaryColor: primaryColor, secondaryColor: secondaryColor, size: size, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $ltBcH.default), {
        label: label,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        size: size,
        testId: testId,
        glyph: $8db3669fa3901b1a$var$ThemeIconGlyph
    });
var $8db3669fa3901b1a$export$2e2bcd8739ae039 = $8db3669fa3901b1a$var$ThemeIcon;

});

parcelRegister("lKJPg", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b8757186054f9d759a1f776986ffd32d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fd6170ee300a8674$var$_react = $fd6170ee300a8674$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $fd6170ee300a8674$var$_backlog = $fd6170ee300a8674$var$_interopRequireDefault((parcelRequire("2wG4I")));

var $fd6170ee300a8674$var$_backlog2 = $fd6170ee300a8674$var$_interopRequireDefault((parcelRequire("7nSZB")));
function $fd6170ee300a8674$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for BacklogIcon.
 * This component is BacklogIcon, with `UNSAFE_fallbackIcon` set to "BacklogIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for backlogs in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fd6170ee300a8674$var$BacklogIcon = (props)=>/*#__PURE__*/ $fd6170ee300a8674$var$_react.default.createElement($fd6170ee300a8674$var$_backlog.default, Object.assign({
        LEGACY_fallbackIcon: $fd6170ee300a8674$var$_backlog2.default
    }, props));
$fd6170ee300a8674$var$BacklogIcon.Name = 'BacklogIconMigration';
var $fd6170ee300a8674$var$_default = module.exports.default = $fd6170ee300a8674$var$BacklogIcon;

});

parcelRegister("aqJO7", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2d6de69f6e8d23d80c647d0a6d3ecd7a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $797fdd7892a0b1a6$var$_react = $797fdd7892a0b1a6$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $797fdd7892a0b1a6$var$_board = $797fdd7892a0b1a6$var$_interopRequireDefault((parcelRequire("bPaTh")));

var $797fdd7892a0b1a6$var$_board2 = $797fdd7892a0b1a6$var$_interopRequireDefault((parcelRequire("2ix7K")));
function $797fdd7892a0b1a6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for BoardIcon.
 * This component is BoardIcon, with `UNSAFE_fallbackIcon` set to "BoardIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for boards in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $797fdd7892a0b1a6$var$BoardIcon = (props)=>/*#__PURE__*/ $797fdd7892a0b1a6$var$_react.default.createElement($797fdd7892a0b1a6$var$_board.default, Object.assign({
        LEGACY_fallbackIcon: $797fdd7892a0b1a6$var$_board2.default
    }, props));
$797fdd7892a0b1a6$var$BoardIcon.Name = 'BoardIconMigration';
var $797fdd7892a0b1a6$var$_default = module.exports.default = $797fdd7892a0b1a6$var$BoardIcon;

});

parcelRegister("044lR", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e406a416cb0a4f8d2c2370983b384961>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $00c3bffd1cbec75d$var$_react = $00c3bffd1cbec75d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $00c3bffd1cbec75d$var$_listBulleted = $00c3bffd1cbec75d$var$_interopRequireDefault((parcelRequire("ll5rh")));

var $00c3bffd1cbec75d$var$_bulletList = $00c3bffd1cbec75d$var$_interopRequireDefault((parcelRequire("6nxkb")));
function $00c3bffd1cbec75d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ListBulletedIcon.
 * This component is ListBulletedIcon, with `UNSAFE_fallbackIcon` set to "BulletListIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: bulleted lists, view all.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $00c3bffd1cbec75d$var$ListBulletedIcon = (props)=>/*#__PURE__*/ $00c3bffd1cbec75d$var$_react.default.createElement($00c3bffd1cbec75d$var$_listBulleted.default, Object.assign({
        LEGACY_fallbackIcon: $00c3bffd1cbec75d$var$_bulletList.default
    }, props));
$00c3bffd1cbec75d$var$ListBulletedIcon.Name = 'ListBulletedIconMigration';
var $00c3bffd1cbec75d$var$_default = module.exports.default = $00c3bffd1cbec75d$var$ListBulletedIcon;

});

parcelRegister("cQJCJ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::540b588acaf0422e358accf8cfb04725>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $95adbb4d7492ef87$var$_react = $95adbb4d7492ef87$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $95adbb4d7492ef87$var$_issues = $95adbb4d7492ef87$var$_interopRequireDefault((parcelRequire("bY4ef")));

var $95adbb4d7492ef87$var$_issues2 = $95adbb4d7492ef87$var$_interopRequireDefault((parcelRequire("aKav4")));
function $95adbb4d7492ef87$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for IssuesIcon.
 * This component is IssuesIcon, with `UNSAFE_fallbackIcon` set to "IssuesIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for representing multiple work items.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $95adbb4d7492ef87$var$IssuesIcon = (props)=>/*#__PURE__*/ $95adbb4d7492ef87$var$_react.default.createElement($95adbb4d7492ef87$var$_issues.default, Object.assign({
        LEGACY_fallbackIcon: $95adbb4d7492ef87$var$_issues2.default
    }, props));
$95adbb4d7492ef87$var$IssuesIcon.Name = 'IssuesIconMigration';
var $95adbb4d7492ef87$var$_default = module.exports.default = $95adbb4d7492ef87$var$IssuesIcon;

});

parcelRegister("fVgSt", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::478474977414af6f20354d0841ac3249>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b979456e78dcc40f$var$_react = $b979456e78dcc40f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $b979456e78dcc40f$var$_roadmap = $b979456e78dcc40f$var$_interopRequireDefault((parcelRequire("aCAjf")));

var $b979456e78dcc40f$var$_roadmap2 = $b979456e78dcc40f$var$_interopRequireDefault((parcelRequire("lKjAS")));
function $b979456e78dcc40f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for RoadmapIcon.
 * This component is RoadmapIcon, with `UNSAFE_fallbackIcon` set to "RoadmapIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for roadmaps in Jira or Trello.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b979456e78dcc40f$var$RoadmapIcon = (props)=>/*#__PURE__*/ $b979456e78dcc40f$var$_react.default.createElement($b979456e78dcc40f$var$_roadmap.default, Object.assign({
        LEGACY_fallbackIcon: $b979456e78dcc40f$var$_roadmap2.default
    }, props));
$b979456e78dcc40f$var$RoadmapIcon.Name = 'RoadmapIconMigration';
var $b979456e78dcc40f$var$_default = module.exports.default = $b979456e78dcc40f$var$RoadmapIcon;

});

parcelRegister("gVM6m", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d10dbc7e1f024d4$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $eNCZ4 = parcelRequire("eNCZ4");

var $bKnKN = parcelRequire("bKnKN");

var $9ewsv = parcelRequire("9ewsv");

var $avgEF = parcelRequire("avgEF");

var $2s57o = parcelRequire("2s57o");
function $3d10dbc7e1f024d4$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// This duplicates FocusRing styles from `@atlaskit/focus-ring`.
const $3d10dbc7e1f024d4$var$focusRingStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    '&:focus, &:focus-visible': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineColor: (0, $avgEF.borderColorMap)['color.border.focused'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineOffset: (0, $avgEF.positiveSpaceMap)['space.025'],
        outlineStyle: 'solid',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineWidth: (0, $avgEF.borderWidthMap)['border.width.outline']
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: '1px solid'
        }
    }
});
const $3d10dbc7e1f024d4$var$baseStyles = {
    name: "1b8qmvl",
    styles: "box-sizing:border-box;appearance:none;border:none"
};
const $3d10dbc7e1f024d4$var$enabledStyles = {
    name: "e0dnmk",
    styles: "cursor:pointer"
};
const $3d10dbc7e1f024d4$var$disabledStyles = {
    name: "1sfig4b",
    styles: "cursor:not-allowed"
};
/**
 * __Pressable__
 *
 * A primitive for building custom buttons.
 *
 * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
 * - [Code](https://atlassian.design/components/primitives/pressable/code)
 * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
 */ const $3d10dbc7e1f024d4$var$Pressable = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, backgroundColor: backgroundColor, padding: padding, paddingBlock: paddingBlock, paddingBlockStart: paddingBlockStart, paddingBlockEnd: paddingBlockEnd, paddingInline: paddingInline, paddingInlineStart: paddingInlineStart, paddingInlineEnd: paddingInlineEnd, isDisabled: isDisabled, type: type = 'button', onClick: providedOnClick = (0, $bKnKN.default), interactionName: interactionName, componentName: componentName, analyticsContext: analyticsContext, style: style, testId: testId, xcss: xcss, ...htmlAttributes }, ref)=>{
    const interactionContext = (0, $5uXOq.useContext)((0, $9ewsv.default));
    const handleClick = (0, $5uXOq.useCallback)((e, analyticsEvent)=>{
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    const onClick = (0, $eNCZ4.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Pressable',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local",
        analyticsData: analyticsContext,
        actionSubject: 'button'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    const resolvedStyles = (0, $2s57o.parseXcss)(xcss);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("button", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        ...safeHtmlAttributes,
        // eslint-disable-next-line react/button-has-type
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        css: [
            $3d10dbc7e1f024d4$var$baseStyles,
            $3d10dbc7e1f024d4$var$focusRingStyles,
            isDisabled ? $3d10dbc7e1f024d4$var$disabledStyles : $3d10dbc7e1f024d4$var$enabledStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $avgEF.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $avgEF.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $avgEF.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $avgEF.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $avgEF.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $avgEF.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $avgEF.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $avgEF.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }, children);
});
var $3d10dbc7e1f024d4$export$2e2bcd8739ae039 = $3d10dbc7e1f024d4$var$Pressable;

});

parcelRegister("39GG1", function(module, exports) {

$parcel$export(module.exports, "WidthObserver", () => $2112cc25326b4ec6$export$b2ad68b9bc407b80);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $aKqn5 = parcelRequire("aKqn5");
const $2112cc25326b4ec6$export$b2ad68b9bc407b80 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo((props)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $aKqn5.WidthDetectorObserver), {
        setWidth: props.setWidth,
        offscreen: props.offscreen
    });
});
var $2112cc25326b4ec6$export$2e2bcd8739ae039 = $2112cc25326b4ec6$export$b2ad68b9bc407b80;

});
parcelRegister("aKqn5", function(module, exports) {

$parcel$export(module.exports, "WidthDetectorObserver", () => $cccf046c9acb1be1$export$ff983d2a2b6112ea);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $47ILY = parcelRequire("47ILY");
const $cccf046c9acb1be1$export$ff983d2a2b6112ea = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo(({ setWidth: setWidth, offscreen: offscreen })=>{
    const [inViewRef, inView, target] = (0, $47ILY.useInView)({
        /* Optional options */ threshold: 0
    });
    const observer = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef(()=>{
        if (typeof window === 'undefined') return null;
        // https://github.com/DefinitelyTyped/DefinitelyTyped/pull/40909
        // @ts-ignore
        return new ResizeObserver((entries)=>{
            if (!Array.isArray(entries) || !entries.length) return;
            const { width: width } = entries[0].contentRect;
            setWidth(Math.round(width));
        });
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useEffect(()=>{
        const { current: currentObserver } = observer;
        const resizeObserver = currentObserver();
        if (resizeObserver === null) return;
        if (target) {
            if (inView || offscreen) resizeObserver.observe(target);
            else resizeObserver.unobserve(target);
        }
        return ()=>{
            resizeObserver.disconnect();
        };
    }, [
        target,
        inView,
        offscreen
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'block',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: '100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute'
        },
        ref: inViewRef
    });
});

});
parcelRegister("47ILY", function(module, exports) {

$parcel$export(module.exports, "useInView", () => $5b7e65ef5fcba1a5$export$2f62ee6831462844);

var $5uXOq = parcelRequire("5uXOq");
function $5b7e65ef5fcba1a5$export$2f62ee6831462844(options = {}) {
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef();
    const observerInstance = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef();
    const [state, setState] = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useState({
        inView: false,
        entry: undefined,
        target: undefined
    });
    const { threshold: threshold, root: root, rootMargin: rootMargin } = options;
    const setRef = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((node)=>{
        observerInstance.current = new IntersectionObserver((entries)=>{
            if (entries && entries.length) {
                const intersection = entries[0];
                const { isIntersecting: isIntersecting, intersectionRatio: intersectionRatio } = intersection;
                if (intersectionRatio >= 0) {
                    // Note: `0` will be used here when an array of numbers is passed as the threshold, which doesn't feel right
                    const numericThreshold = typeof threshold === 'number' ? threshold : 0;
                    let inView = intersectionRatio >= numericThreshold;
                    if (isIntersecting !== undefined) inView = inView && isIntersecting;
                    setState({
                        inView: inView,
                        entry: intersection,
                        target: node
                    });
                }
            }
        }, {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin
        });
        if (ref.current) observerInstance.current.unobserve(ref.current);
        if (node) observerInstance.current.observe(node);
        // Store a reference to the node
        ref.current = node;
    }, [
        threshold,
        root,
        rootMargin
    ]);
    /**
	 * Unsubscribe IntersectionObserver before unmounting a component.
	 */ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useEffect(()=>{
        return ()=>{
            if (observerInstance.current && ref.current) observerInstance.current.unobserve(ref.current);
        };
    }, []);
    return [
        setRef,
        state.inView,
        state.target,
        state.entry
    ];
}

});



parcelRegister("kU1q1", function(module, exports) {

$parcel$export(module.exports, "media", () => $e988263de1eef7cc$export$987d49ffe1b0900f);
$parcel$export(module.exports, "UNSAFE_media", () => $e988263de1eef7cc$export$c881183ca713c214);
/**
 * This is an object of usable media query helpers using our internal breakpoints configuration.
 *
 * When using Compiled CSS-in-JS, please ensure that only a single declaration can take effect at a time.
 * This means that you should avoid multiple breakpoints taking effect at the same time,
 * eg. ```{ [media.above.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * Instead, make sure that only one breakpoint can take effect at a time,
 * e.g, ```{ [media.only.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * For more details, please see <https://compiledcssinjs.com/docs/atomic-css#selector-specificity>.
 */ const $e988263de1eef7cc$export$987d49ffe1b0900f = {
    above: {
        xxs: '@media all',
        xs: '@media (min-width: 30rem)',
        sm: '@media (min-width: 48rem)',
        md: '@media (min-width: 64rem)',
        lg: '@media (min-width: 90rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    only: {
        xxs: '@media (min-width: 0rem) and (max-width: 29.99rem)',
        xs: '@media (min-width: 30rem) and (max-width: 47.99rem)',
        sm: '@media (min-width: 48rem) and (max-width: 63.99rem)',
        md: '@media (min-width: 64rem) and (max-width: 89.99rem)',
        lg: '@media (min-width: 90rem) and (max-width: 110.49rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    below: {
        xs: '@media not all and (min-width: 30rem)',
        sm: '@media not all and (min-width: 48rem)',
        md: '@media not all and (min-width: 64rem)',
        lg: '@media not all and (min-width: 90rem)',
        xl: '@media not all and (min-width: 110.5rem)'
    }
};
const $e988263de1eef7cc$export$c881183ca713c214 = $e988263de1eef7cc$export$987d49ffe1b0900f;

});

parcelRegister("98YGb", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9a6526ba72ad9bbb4f9b91ad0dbd2f69>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6a83ee0d8a524ca4$var$_react = $6a83ee0d8a524ca4$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $6a83ee0d8a524ca4$var$_appSwitcher = $6a83ee0d8a524ca4$var$_interopRequireDefault((parcelRequire("hbr4z")));

var $6a83ee0d8a524ca4$var$_appSwitcher2 = $6a83ee0d8a524ca4$var$_interopRequireDefault((parcelRequire("h0b1c")));
function $6a83ee0d8a524ca4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for AppSwitcherIcon.
 * This component is AppSwitcherIcon, with `UNSAFE_fallbackIcon` set to "AppSwitcherIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for app switcher in global product navigation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6a83ee0d8a524ca4$var$AppSwitcherIcon = (props)=>/*#__PURE__*/ $6a83ee0d8a524ca4$var$_react.default.createElement($6a83ee0d8a524ca4$var$_appSwitcher.default, Object.assign({
        LEGACY_fallbackIcon: $6a83ee0d8a524ca4$var$_appSwitcher2.default
    }, props));
$6a83ee0d8a524ca4$var$AppSwitcherIcon.Name = 'AppSwitcherIconMigration';
var $6a83ee0d8a524ca4$var$_default = module.exports.default = $6a83ee0d8a524ca4$var$AppSwitcherIcon;

});

parcelRegister("j7leM", function(module, exports) {

$parcel$export(module.exports, "JiraProductDiscoveryIcon", () => $405ed74c1d0205ac$export$21bfbeb62fdcce8d);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $6VxGE = parcelRequire("6VxGE");

var $kpt43 = parcelRequire("kpt43");

var $2uZGe = parcelRequire("2uZGe");

var $j62qJ = parcelRequire("j62qJ");
const $405ed74c1d0205ac$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $2uZGe.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M17.655 5.884a15.3 15.3 0 0 0 8.75 0c.257-.056.428.114.37.37-.826 2.985-.826 5.742 0 8.727.058.228-.113.427-.37.342a16.33 16.33 0 0 0-8.75 0c-.228.085-.428-.114-.342-.342.77-2.985.77-5.742 0-8.727-.086-.256.114-.426.342-.37m1.169 10.576v.483c0 2.246-1.568 3.894-3.506 3.894a3.474 3.474 0 0 1-3.477-3.496c0-1.933 1.567-3.468 3.762-3.468h.57V7.078c-.285-.028-.57-.028-.855-.028C9.618 7.05 5 11.655 5 17.37c0 5.713 4.617 10.29 10.318 10.29s10.346-4.605 10.346-10.29v-.91z"/>
    </svg>`;
};
const $405ed74c1d0205ac$export$21bfbeb62fdcce8d = ({ appearance: appearance, label: label = 'Jira Product Discovery', size: size = (0, $kpt43.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $kpt43.defaultLogoParams).iconColor, textColor: textColor = (0, $kpt43.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $6VxGE.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $j62qJ.default), {
        appearance: appearance,
        label: label,
        svg: $405ed74c1d0205ac$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("ds5Yo", function(module, exports) {

$parcel$export(module.exports, "JiraServiceManagementIcon", () => $7413b9b63f109471$export$3c6158790f5e01c4);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $6VxGE = parcelRequire("6VxGE");

var $kpt43 = parcelRequire("kpt43");

var $2uZGe = parcelRequire("2uZGe");

var $j62qJ = parcelRequire("j62qJ");
const $7413b9b63f109471$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $2uZGe.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill=${colors.iconColor} d="M18.79 13.257h7.325c1.1 0 1.476 1.046.805 1.878L15.464 29.274c-3.702-2.951-3.353-7.62-.644-11.027zm-5.66 5.634H5.806c-1.1 0-1.476-1.046-.805-1.878L16.457 2.874c3.702 2.951 3.3 7.566.617 11z"/>
    </svg>`;
};
const $7413b9b63f109471$export$3c6158790f5e01c4 = ({ appearance: appearance, label: label = 'Jira Service Management', size: size = (0, $kpt43.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $kpt43.defaultLogoParams).iconColor, textColor: textColor = (0, $kpt43.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $6VxGE.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $j62qJ.default), {
        appearance: appearance,
        label: label,
        svg: $7413b9b63f109471$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("gWVyJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $04bfbc4c5d50f443$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");


var $503JR = parcelRequire("503JR");

var $bjf1T = parcelRequire("bjf1T");
var $b6xD2 = parcelRequire("b6xD2");

var $2pQ0W = parcelRequire("2pQ0W");

var $gHNHO = parcelRequire("gHNHO");
const $04bfbc4c5d50f443$var$bannerStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: (0, $62b79b702763d93f$export$ed7cc0d417ee89e),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridArea: (0, $62b79b702763d93f$export$238d30785c4bca84)
});
const $04bfbc4c5d50f443$var$bannerFixedStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    position: 'fixed',
    zIndex: 2,
    insetBlockStart: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetInlineEnd: (0, $62b79b702763d93f$export$750459958906793),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetInlineStart: (0, $62b79b702763d93f$export$f963aecf2d4465bd)
});
/**
 * __Banner__
 *
 * Provides a slot for a Banner within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $04bfbc4c5d50f443$var$Banner = (props)=>{
    const { children: children, height: height = (0, $62b79b702763d93f$export$be83e7118304b28e), isFixed: isFixed = true, shouldPersistHeight: shouldPersistHeight, testId: testId, skipLinkTitle: skipLinkTitle, id: id } = props;
    const bannerHeight = (0, $503JR.resolveDimension)((0, $62b79b702763d93f$export$bcd94a6a792e7f96), height, shouldPersistHeight);
    (0, $5uXOq.useEffect)(()=>{
        (0, $bjf1T.default)({
            [(0, $62b79b702763d93f$export$bcd94a6a792e7f96)]: bannerHeight
        });
        return ()=>{
            (0, $bjf1T.default)({
                [(0, $62b79b702763d93f$export$bcd94a6a792e7f96)]: 0
            });
        };
    }, [
        bannerHeight
    ]);
    (0, $b6xD2.useSkipLink)(id, skipLinkTitle);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $2pQ0W.default), null, ({ className: className })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: [
                $04bfbc4c5d50f443$var$bannerStyles,
                isFixed && $04bfbc4c5d50f443$var$bannerFixedStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            "data-testid": testId,
            id: id,
            ...(0, $503JR.getPageLayoutSlotSelector)('banner')
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $gHNHO.default), {
            variableName: (0, $62b79b702763d93f$export$bcd94a6a792e7f96),
            value: bannerHeight
        }), children));
};
var $04bfbc4c5d50f443$export$2e2bcd8739ae039 = $04bfbc4c5d50f443$var$Banner;

});
// dimension vars
const $62b79b702763d93f$export$cbfb0f5b2869b17b = 'leftPanelWidth';
const $62b79b702763d93f$export$a30f2e00489a8957 = 'leftSidebarWidth';
const $62b79b702763d93f$export$c103b605cd368aed = 'rightSidebarWidth';
const $62b79b702763d93f$export$fa34f417972d6341 = 'rightPanelWidth';
const $62b79b702763d93f$export$3a6a779d9181047c = 'topNavigationHeight';
const $62b79b702763d93f$export$bcd94a6a792e7f96 = 'bannerHeight';
const $62b79b702763d93f$export$b6744d31294864fd = 'leftSidebarFlyoutWidth';
const $62b79b702763d93f$export$344062f7cfc9528e = 'left-panel';
const $62b79b702763d93f$export$c7139cc2d6110b5f = 'right-panel';
const $62b79b702763d93f$export$238d30785c4bca84 = 'banner';
const $62b79b702763d93f$export$bec6dca2e63de4ae = 'top-navigation';
const $62b79b702763d93f$export$d1213e82613ff4df = 'content';
const $62b79b702763d93f$export$be83e7118304b28e = 56;
const $62b79b702763d93f$export$4a98ee0bd1ae362 = 56;
const $62b79b702763d93f$export$539e68c09584883a = 240;
const $62b79b702763d93f$export$b92df8810d2fcd01 = 280;
const $62b79b702763d93f$export$c3e41153b9288bcf = 368;
const $62b79b702763d93f$export$c4d6152f86ea28f6 = 368;
const $62b79b702763d93f$export$46acf8758e9e2636 = 20;
const $62b79b702763d93f$export$70740f5ad8360a78 = 16;
const $62b79b702763d93f$export$991d5285ad765a3d = 240;
const $62b79b702763d93f$export$6949d4f32b161684 = 200;
const $62b79b702763d93f$export$d6e7e8af042815bb = 350;
const $62b79b702763d93f$export$3749e1104328fde4 = 300;
const $62b79b702763d93f$export$1074d925b0b82be5 = 200;
const $62b79b702763d93f$export$451e84a45a9e4a75 = 'DS_PAGE_LAYOUT_UI_STATE';
const $62b79b702763d93f$export$802bb2c050f3db5c = 'data-is-sidebar-dragging';
const $62b79b702763d93f$export$5e5e1875c3fd8f4f = 'data-is-sidebar-collapsing';
const $62b79b702763d93f$export$70c702a8c5895f03 = 'data-grab-area-line';
const $62b79b702763d93f$export$48a43f91e4becf4e = 'data-grab-area';
const $62b79b702763d93f$export$dac2fb31a9f6844d = 'data-resize-button';
const $62b79b702763d93f$export$9ecd22db14e6c70e = 'data-resize-control';
const $62b79b702763d93f$export$5253dd9707b8c3ba = 'data-ds--page-layout--slot';
const $62b79b702763d93f$export$206a08f7f8beb554 = 'Skip to:';
const $62b79b702763d93f$export$659ee746b31b360d = 'data-layout-container';
const $62b79b702763d93f$export$f963aecf2d4465bd = `var(--${$62b79b702763d93f$export$cbfb0f5b2869b17b}, 0px)`;
const $62b79b702763d93f$export$750459958906793 = `var(--${$62b79b702763d93f$export$fa34f417972d6341}, 0px)`;
const $62b79b702763d93f$export$f897e1ed9f8ed251 = `var(--${$62b79b702763d93f$export$a30f2e00489a8957}, 0px)`;
const $62b79b702763d93f$export$b44ab66843c05a69 = `var(--${$62b79b702763d93f$export$c103b605cd368aed}, 0px)`;
const $62b79b702763d93f$export$aeff86a16f13529 = `var(--${$62b79b702763d93f$export$3a6a779d9181047c}, 0px)`;
const $62b79b702763d93f$export$ed7cc0d417ee89e = `var(--${$62b79b702763d93f$export$bcd94a6a792e7f96}, 0px)`;
const $62b79b702763d93f$export$d2fa14f05b61e66 = `var(--${$62b79b702763d93f$export$b6744d31294864fd}, ${$62b79b702763d93f$export$991d5285ad765a3d}px)`;

parcelRegister("503JR", function(module, exports) {

$parcel$export(module.exports, "mergeGridStateIntoStorage", () => $4b3fbc91f1bb66d3$export$f8355a2df0f4a946);
$parcel$export(module.exports, "getGridStateFromStorage", () => $4b3fbc91f1bb66d3$export$d95e99d8116d17dc);
$parcel$export(module.exports, "removeFromGridStateInStorage", () => $4b3fbc91f1bb66d3$export$17e3760e0b35f1cd);
$parcel$export(module.exports, "resolveDimension", () => $4b3fbc91f1bb66d3$export$74732e47915c7839);
$parcel$export(module.exports, "getLeftPanelWidth", () => $4b3fbc91f1bb66d3$export$b089e01213f07bd);
$parcel$export(module.exports, "getLeftSidebarPercentage", () => $4b3fbc91f1bb66d3$export$2bca58b6ee823bf7);
$parcel$export(module.exports, "getPageLayoutSlotSelector", () => $4b3fbc91f1bb66d3$export$e895e3e8b708ae2a);
$parcel$export(module.exports, "getPageLayoutSlotCSSSelector", () => $4b3fbc91f1bb66d3$export$218ece2c32b7db0e);


var $66ZKd = parcelRequire("66ZKd");
const $4b3fbc91f1bb66d3$export$f8355a2df0f4a946 = (key, value)=>{
    const storageValue = JSON.parse((0, $66ZKd.default)().getItem((0, $62b79b702763d93f$export$451e84a45a9e4a75)) || '{}');
    if (value !== null && typeof value === 'object') storageValue[key] = {
        ...storageValue[key],
        ...value
    };
    else storageValue[key] = value;
    (0, $66ZKd.default)().setItem((0, $62b79b702763d93f$export$451e84a45a9e4a75), JSON.stringify(storageValue));
};
const $4b3fbc91f1bb66d3$export$d95e99d8116d17dc = (key)=>{
    const storageValue = JSON.parse((0, $66ZKd.default)().getItem((0, $62b79b702763d93f$export$451e84a45a9e4a75)) || '{}');
    return storageValue[key];
};
const $4b3fbc91f1bb66d3$export$17e3760e0b35f1cd = (key, secondKey)=>{
    const storageValue = JSON.parse((0, $66ZKd.default)().getItem((0, $62b79b702763d93f$export$451e84a45a9e4a75)) || '{}');
    if (secondKey && storageValue[key]) delete storageValue[key][secondKey];
    else delete storageValue[key];
    (0, $66ZKd.default)().setItem((0, $62b79b702763d93f$export$451e84a45a9e4a75), JSON.stringify(storageValue));
};
const $4b3fbc91f1bb66d3$export$74732e47915c7839 = (key, dimension = 0, shouldPersist = false)=>{
    if (shouldPersist) {
        const cachedGridState = $4b3fbc91f1bb66d3$export$d95e99d8116d17dc('gridState');
        return cachedGridState && Object.keys(cachedGridState).length > 0 && cachedGridState[key] ? cachedGridState[key] : dimension;
    }
    return dimension;
};
const $4b3fbc91f1bb66d3$export$b089e01213f07bd = ()=>{
    if (typeof window === 'undefined') return 0;
    return parseInt(window.getComputedStyle(document.documentElement).getPropertyValue(`--${(0, $62b79b702763d93f$export$f963aecf2d4465bd)}`), 10) || 0;
};
const $4b3fbc91f1bb66d3$export$2bca58b6ee823bf7 = (currentWidth, maxWidth)=>{
    const total = (currentWidth - (0, $62b79b702763d93f$export$539e68c09584883a)) / (maxWidth - (0, $62b79b702763d93f$export$539e68c09584883a));
    if (total < 0) return 0;
    if (total > 1) return 100;
    return Math.floor(total * 100);
};
const $4b3fbc91f1bb66d3$export$e895e3e8b708ae2a = (slotName)=>({
        [(0, $62b79b702763d93f$export$5253dd9707b8c3ba)]: slotName
    });
const $4b3fbc91f1bb66d3$export$218ece2c32b7db0e = (slotName)=>`[${0, $62b79b702763d93f$export$5253dd9707b8c3ba}='${slotName}']`;

});
parcelRegister("66ZKd", function(module, exports) {

$parcel$export(module.exports, "default", () => $3aad0722e8036c94$export$2e2bcd8739ae039);
// Reliably test against conditions like
// localStorage being full or private mode in Safari being a .
// https://gist.github.com/paulirish/5558557
const $3aad0722e8036c94$var$isLocalStorageSupported = ()=>{
    try {
        // use an random key to test
        // eslint-disable-next-line @repo/internal/react/disallow-unstable-values
        const testKey = `__test_${Date.now()}__`;
        localStorage.setItem(testKey, testKey);
        localStorage.removeItem(testKey);
        return true;
    } catch (e) {
        return false;
    }
};
const $3aad0722e8036c94$var$safeLocalStorage = ()=>{
    if ($3aad0722e8036c94$var$isLocalStorageSupported()) return localStorage;
    // Returning a mock object here in the case that this is run in SSR mode
    if (typeof window === 'undefined') return {
        getItem: (_key)=>null,
        setItem: (_key, _value)=>null,
        removeItem: (_key)=>null,
        clear: ()=>null,
        key: (_index)=>null,
        get length () {
            return 0;
        }
    };
    if (window.__localStorageFallback && Object.keys(window.__localStorageFallback).length !== 0) return window.__localStorageFallback;
    const storageAPI = {
        getItem: (key)=>{
            if (window.__localStorageFallback.hasOwnProperty(key)) return window.__localStorageFallback[key];
            return null;
        },
        setItem: (key, value)=>{
            window.__localStorageFallback[key] = String(value);
        },
        removeItem: (key)=>{
            delete window.__localStorageFallback[key];
        },
        clear: ()=>{
            for(const key in window.__localStorageFallback)if (window.__localStorageFallback.hasOwnProperty(key)) delete window.__localStorageFallback[key];
        },
        get length () {
            if (!window.__localStorageFallback) return 0;
            return Object.keys(window.__localStorageFallback).length;
        }
    };
    window.__localStorageFallback = Object.create(storageAPI);
    return window.__localStorageFallback;
};
var $3aad0722e8036c94$export$2e2bcd8739ae039 = $3aad0722e8036c94$var$safeLocalStorage;

});


parcelRegister("bjf1T", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd6019910ab9e6c3$export$2e2bcd8739ae039);

var $503JR = parcelRequire("503JR");
const $fd6019910ab9e6c3$var$publishGridState = (gridState)=>{
    Object.entries(gridState).forEach(([slotName, value])=>{
        if (!value) {
            document.documentElement.style.removeProperty(`--${slotName}`);
            (0, $503JR.removeFromGridStateInStorage)('gridState', slotName);
            return;
        }
        //Update the css variable
        document.documentElement.style.setProperty(`--${slotName}`, `${value}px`);
        // also update state in local storage so that
        // it persists across page refresh, across tabs etc
        (0, $503JR.mergeGridStateIntoStorage)('gridState', {
            [slotName]: value
        });
    });
};
var $fd6019910ab9e6c3$export$2e2bcd8739ae039 = $fd6019910ab9e6c3$var$publishGridState;

});

parcelRegister("b6xD2", function(module, exports) {

$parcel$export(module.exports, "SkipLinksContext", () => $1272ecbd2d42073a$export$4c5cc3b14c7678a);
$parcel$export(module.exports, "useSkipLinks", () => $1272ecbd2d42073a$export$c9d9cb2ee9590f87);
$parcel$export(module.exports, "useSkipLink", () => $1272ecbd2d42073a$export$89d9323301efc7d6);

var $5uXOq = parcelRequire("5uXOq");

var $bKnKN = parcelRequire("bKnKN");
const $1272ecbd2d42073a$export$4c5cc3b14c7678a = /*#__PURE__*/ (0, $5uXOq.createContext)({
    skipLinksData: [],
    registerSkipLink: (0, $bKnKN.default),
    unregisterSkipLink: (0, $bKnKN.default)
});
const $1272ecbd2d42073a$export$c9d9cb2ee9590f87 = ()=>(0, $5uXOq.useContext)($1272ecbd2d42073a$export$4c5cc3b14c7678a);
const $1272ecbd2d42073a$export$89d9323301efc7d6 = (id, skipLinkTitle)=>{
    const { registerSkipLink: registerSkipLink, unregisterSkipLink: unregisterSkipLink } = $1272ecbd2d42073a$export$c9d9cb2ee9590f87();
    (0, $5uXOq.useEffect)(()=>{
        if (id && skipLinkTitle) registerSkipLink({
            id: id,
            skipLinkTitle: skipLinkTitle
        });
        return ()=>{
            unregisterSkipLink(id);
        };
    }, [
        id,
        skipLinkTitle,
        registerSkipLink,
        unregisterSkipLink
    ]);
};

});

parcelRegister("2pQ0W", function(module, exports) {

$parcel$export(module.exports, "default", () => $272972a89609ef0b$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

const $272972a89609ef0b$var$focusStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':focus': {
        outline: 'none',
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> div': {
            boxShadow: `0px 0px 0px 2px inset ${`var(--ds-border-focused, ${(0, $a7f8c6b391092279$export$ecfc1dff386a3e7a)})`}`,
            outline: 'none'
        }
    }
});
/**
 * Sidebars have an outer and inner component,
 * so the nested selector needs to target an extra level deeper.
 */ const $272972a89609ef0b$var$sidebarFocusStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':focus': {
        outline: 'none',
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> div > div': {
            boxShadow: `0px 0px 0px 2px inset ${`var(--ds-border-focused, ${(0, $a7f8c6b391092279$export$ecfc1dff386a3e7a)})`}`,
            outline: 'none'
        }
    }
});
/**
 * We don't use `@atlaskit/focus-ring` here,
 * because we need inset focus styles and:
 *
 * 1. If we set them directly to the layout element,
 *    then any child element's background will cover the shadow.
 * 2. We cannot wrap `children` in `FocusRing`,
 *    because there's no guarantee the passed child takes `className`.
 */ const $272972a89609ef0b$var$SlotFocusRing = ({ children: children, isSidebar: isSidebar = false })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $f8Sb3.ClassNames), null, ({ css: css })=>children({
            className: isSidebar ? css($272972a89609ef0b$var$sidebarFocusStyles) : css($272972a89609ef0b$var$focusStyles)
        }));
};
var $272972a89609ef0b$export$2e2bcd8739ae039 = $272972a89609ef0b$var$SlotFocusRing;

});

parcelRegister("gHNHO", function(module, exports) {

$parcel$export(module.exports, "default", () => $efb7cfbee2803a87$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $kU1q1 = parcelRequire("kU1q1");
/**
 * Hoists slot dimension styles to the root element.
 */ const $efb7cfbee2803a87$var$SlotDimensions = ({ variableName: variableName, value: value, mobileValue: mobileValue })=>{
    /**
	 * Note don't put multiple variables in multiple lines. eg
	 * <style>
	 *   {css1}
	 *   {css2}
	 * </style>
	 *
	 * React will insert an empty HTML comment in between the text in SSR.
	 * This is not a valid tag and will break the page.
	 * <style>foo<!-- -->bar</style>
	 */ let style = `:root{--${variableName}:${value}px;}`;
    if (mobileValue) style += ` ${(0, $kU1q1.UNSAFE_media).below.sm} { :root{--${variableName}:${mobileValue}px;} }`;
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $2OMIu.jsx)("style", {
        children: style
    }));
};
var $efb7cfbee2803a87$export$2e2bcd8739ae039 = $efb7cfbee2803a87$var$SlotDimensions;

});


parcelRegister("l2AH9", function(module, exports) {

$parcel$export(module.exports, "default", () => $5efb2483d6145079$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

const $5efb2483d6145079$var$contentStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'flex',
    height: '100%',
    position: 'relative',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridArea: (0, $62b79b702763d93f$export$d1213e82613ff4df)
});
/**
 * __Content__
 *
 * Provides a slot for your application content within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $5efb2483d6145079$var$Content = (props)=>{
    const { children: children, testId: testId } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        "data-testid": testId,
        css: $5efb2483d6145079$var$contentStyles
    }, children);
};
var $5efb2483d6145079$export$2e2bcd8739ae039 = $5efb2483d6145079$var$Content;

});

parcelRegister("iCvLW", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb93d23681de7144$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");


var $503JR = parcelRequire("503JR");

var $bjf1T = parcelRequire("bjf1T");
var $b6xD2 = parcelRequire("b6xD2");

var $2pQ0W = parcelRequire("2pQ0W");

var $gHNHO = parcelRequire("gHNHO");
const $cb93d23681de7144$var$leftPanelStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridArea: (0, $62b79b702763d93f$export$344062f7cfc9528e)
});
const $cb93d23681de7144$var$leftPanelFixedStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $62b79b702763d93f$export$f963aecf2d4465bd),
    position: 'fixed',
    insetBlockEnd: 0,
    insetBlockStart: 0,
    insetInlineStart: 0
});
/**
 * __Left panel__
 *
 * Provides a slot for a left panel within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $cb93d23681de7144$var$LeftPanel = (props)=>{
    const { children: children, isFixed: isFixed, width: width = (0, $62b79b702763d93f$export$c4d6152f86ea28f6), shouldPersistWidth: shouldPersistWidth, testId: testId, id: id, skipLinkTitle: skipLinkTitle } = props;
    const leftPanelWidth = (0, $503JR.resolveDimension)((0, $62b79b702763d93f$export$cbfb0f5b2869b17b), width, shouldPersistWidth);
    (0, $5uXOq.useEffect)(()=>{
        (0, $bjf1T.default)({
            [(0, $62b79b702763d93f$export$cbfb0f5b2869b17b)]: leftPanelWidth
        });
        return ()=>{
            (0, $bjf1T.default)({
                [(0, $62b79b702763d93f$export$cbfb0f5b2869b17b)]: 0
            });
        };
    }, [
        leftPanelWidth
    ]);
    (0, $b6xD2.useSkipLink)(id, skipLinkTitle);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $2pQ0W.default), null, ({ className: className })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: [
                $cb93d23681de7144$var$leftPanelStyles,
                isFixed && $cb93d23681de7144$var$leftPanelFixedStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            "data-testid": testId,
            id: id,
            ...(0, $503JR.getPageLayoutSlotSelector)('left-panel')
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $gHNHO.default), {
            variableName: (0, $62b79b702763d93f$export$cbfb0f5b2869b17b),
            value: leftPanelWidth
        }), children));
};
var $cb93d23681de7144$export$2e2bcd8739ae039 = $cb93d23681de7144$var$LeftPanel;

});

parcelRegister("56fJj", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c836dc1e23c5f3a$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $2rNTw = parcelRequire("2rNTw");


var $fHpHg = parcelRequire("fHpHg");

var $gZkTp = parcelRequire("gZkTp");



var $503JR = parcelRequire("503JR");

var $bjf1T = parcelRequire("bjf1T");
var $02o6B = parcelRequire("02o6B");
var $b6xD2 = parcelRequire("b6xD2");

var $1jOQg = parcelRequire("1jOQg");

var $e5XmT = parcelRequire("e5XmT");

var $9Q3Cp = parcelRequire("9Q3Cp");

var $jHPcL = parcelRequire("jHPcL");

var $gHNHO = parcelRequire("gHNHO");
const $0c836dc1e23c5f3a$var$openBackdropStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    width: '100%',
    height: '100%',
    position: 'absolute',
    background: `var(--ds-blanket, ${(0, $a7f8c6b391092279$export$486ab785e4bac3c6)})`,
    opacity: 1
});
const $0c836dc1e23c5f3a$var$hiddenBackdropStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    opacity: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transition: `opacity ${(0, $62b79b702763d93f$export$3749e1104328fde4)}ms ${(0, $99bc8d2d71e909fb$export$57636bb43b1ccbb0)} 0s`
});
/**
 * __Left sidebar__
 *
 * Provides a slot for a left sidebar within the PageLayout.
 *
 * On smaller viewports, the left sidebar can no longer be expanded.  Instead, expanding it will
 * put it into our "flyout mode" to lay overtop (which in desktop is explicitly a hover state).
 * This ensures the contents behind do not reflow oddly and allows for a better experience
 * resizing between mobile and desktop.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $0c836dc1e23c5f3a$var$LeftSidebar = (props)=>{
    const { children: children, width: width, isFixed: isFixed = true, valueTextLabel: valueTextLabel, resizeButtonLabel: resizeButtonLabel, resizeGrabAreaLabel: resizeGrabAreaLabel, overrides: overrides, onResizeStart: onResizeStart, onResizeEnd: onResizeEnd, onFlyoutExpand: onFlyoutExpand, onFlyoutCollapse: onFlyoutCollapse, testId: testId, id: id, skipLinkTitle: skipLinkTitle, collapsedState: collapsedState } = props;
    const flyoutTimerRef = (0, $5uXOq.useRef)();
    const mouseOverEventRef = (0, $5uXOq.useRef)();
    const leftSideBarRef = (0, $5uXOq.useRef)(null);
    const { leftSidebarState: leftSidebarState, setLeftSidebarState: setLeftSidebarState } = (0, $5uXOq.useContext)((0, $02o6B.SidebarResizeContext));
    const { isFlyoutOpen: isFlyoutOpen, isResizing: isResizing, flyoutLockCount: flyoutLockCount, isLeftSidebarCollapsed: isLeftSidebarCollapsed, leftSidebarWidth: leftSidebarWidth, lastLeftSidebarWidth: lastLeftSidebarWidth, hasInit: hasInit } = leftSidebarState;
    const isLocked = flyoutLockCount > 0;
    const isLockedRef = (0, $5uXOq.useRef)(isLocked);
    const mouseXRef = (0, $5uXOq.useRef)(0);
    const handlerRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        isLockedRef.current = isLocked;
        // I tried a one-time `mousemove` handler that gets attached
        // when the lock releases. This is not robust because
        // the mouse can stay still after release (e.g. using keyboard)
        // and the sidebar will erroneously stay open.
        //
        // The following solution is likely less performant but more robust.
        if (isLocked && !handlerRef.current) {
            handlerRef.current = (event)=>{
                mouseXRef.current = event.clientX;
            };
            document.addEventListener('mousemove', handlerRef.current);
        }
        if (!isLocked && handlerRef.current) {
            if (mouseXRef.current >= lastLeftSidebarWidth) setLeftSidebarState((current)=>({
                    ...current,
                    isFlyoutOpen: false
                }));
            document.removeEventListener('mousemove', handlerRef.current);
            handlerRef.current = null;
        }
        return ()=>{
            if (handlerRef.current) document.removeEventListener('mousemove', handlerRef.current);
        };
    }, [
        isLocked,
        lastLeftSidebarWidth,
        setLeftSidebarState
    ]);
    const _width = Math.max(width || 0, (0, $62b79b702763d93f$export$539e68c09584883a));
    const collapsedStateOverrideOpen = collapsedState === 'expanded';
    let leftSidebarWidthOnMount;
    if (collapsedStateOverrideOpen) leftSidebarWidthOnMount = (0, $503JR.resolveDimension)((0, $62b79b702763d93f$export$b6744d31294864fd), _width, !width);
    else if (isLeftSidebarCollapsed || collapsedState === 'collapsed') leftSidebarWidthOnMount = (0, $62b79b702763d93f$export$46acf8758e9e2636);
    else leftSidebarWidthOnMount = (0, $503JR.resolveDimension)((0, $62b79b702763d93f$export$a30f2e00489a8957), _width, !width || !collapsedStateOverrideOpen && (0, $503JR.getGridStateFromStorage)('isLeftSidebarCollapsed'));
    // Update state from cache on mount
    (0, $5uXOq.useEffect)(()=>{
        const cachedCollapsedState = !collapsedStateOverrideOpen && (collapsedState === 'collapsed' || (0, $503JR.getGridStateFromStorage)('isLeftSidebarCollapsed') || false);
        const cachedGridState = (0, $503JR.getGridStateFromStorage)('gridState') || {};
        let leftSidebarWidth = !width && cachedGridState[0, $62b79b702763d93f$export$b6744d31294864fd] ? Math.max(cachedGridState[0, $62b79b702763d93f$export$b6744d31294864fd], (0, $62b79b702763d93f$export$539e68c09584883a)) : _width;
        const lastLeftSidebarWidth = !width && cachedGridState[0, $62b79b702763d93f$export$b6744d31294864fd] ? Math.max(cachedGridState[0, $62b79b702763d93f$export$b6744d31294864fd], (0, $62b79b702763d93f$export$539e68c09584883a)) : _width;
        if (cachedCollapsedState) leftSidebarWidth = (0, $62b79b702763d93f$export$46acf8758e9e2636);
        setLeftSidebarState({
            isFlyoutOpen: false,
            isResizing: isResizing,
            isLeftSidebarCollapsed: cachedCollapsedState,
            leftSidebarWidth: leftSidebarWidth,
            lastLeftSidebarWidth: lastLeftSidebarWidth,
            flyoutLockCount: 0,
            isFixed: isFixed,
            hasInit: true
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // Every time other than mount,
    // update the local storage and css variables.
    const notFirstRun = (0, $5uXOq.useRef)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (notFirstRun.current) {
            (0, $bjf1T.default)({
                [(0, $62b79b702763d93f$export$a30f2e00489a8957)]: leftSidebarWidth || leftSidebarWidthOnMount,
                [(0, $62b79b702763d93f$export$b6744d31294864fd)]: lastLeftSidebarWidth
            });
            (0, $503JR.mergeGridStateIntoStorage)('isLeftSidebarCollapsed', isLeftSidebarCollapsed);
        }
        if (!notFirstRun.current) notFirstRun.current = true;
        return ()=>{
            removeMouseOverListener();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isLeftSidebarCollapsed,
        leftSidebarWidth,
        id
    ]);
    const onMouseOver = (event)=>{
        const isMouseOnResizeButton = event.target.matches(`[${(0, $62b79b702763d93f$export$dac2fb31a9f6844d)}]`) || event.target.matches(`[${(0, $62b79b702763d93f$export$dac2fb31a9f6844d)}] *`);
        if (isFlyoutOpen || isMouseOnResizeButton || !isLeftSidebarCollapsed) return;
        event.persist();
        flyoutTimerRef.current && clearTimeout(flyoutTimerRef.current);
        if (!mouseOverEventRef.current) mouseOverEventRef.current = (event)=>{
            const leftSidebar = leftSideBarRef.current;
            if (leftSidebar === null || isLockedRef.current) return;
            if (!leftSidebar.contains(event.target)) {
                flyoutTimerRef.current && clearTimeout(flyoutTimerRef.current);
                onFlyoutCollapse && onFlyoutCollapse();
                setLeftSidebarState((current)=>({
                        ...current,
                        isFlyoutOpen: false
                    }));
                removeMouseOverListener();
            }
        };
        document.addEventListener('mouseover', mouseOverEventRef.current, {
            capture: true,
            passive: true
        });
        flyoutTimerRef.current = setTimeout(()=>{
            setLeftSidebarState((current)=>({
                    ...current,
                    isFlyoutOpen: true
                }));
            onFlyoutExpand && onFlyoutExpand();
        }, (0, $62b79b702763d93f$export$1074d925b0b82be5));
    };
    const removeMouseOverListener = ()=>{
        mouseOverEventRef.current && document.removeEventListener('mouseover', mouseOverEventRef.current, {
            capture: true,
            passive: true
        });
    };
    (0, $b6xD2.useSkipLink)(id, skipLinkTitle);
    const onMouseLeave = (event)=>{
        const isMouseOnResizeButton = event.target.matches(`[${(0, $62b79b702763d93f$export$dac2fb31a9f6844d)}]`) || event.target.matches(`[${(0, $62b79b702763d93f$export$dac2fb31a9f6844d)}] *`);
        if (isMouseOnResizeButton || !isLeftSidebarCollapsed || flyoutLockCount > 0) return;
        onFlyoutCollapse && onFlyoutCollapse();
        setTimeout(()=>{
            setLeftSidebarState((current)=>({
                    ...current,
                    isFlyoutOpen: false
                }));
        }, (0, $62b79b702763d93f$export$1074d925b0b82be5));
    };
    const mobileMediaQuery = (0, $gZkTp.UNSAFE_useMediaQuery)('below.sm');
    const openMobileFlyout = (0, $5uXOq.useCallback)(()=>{
        if (!mobileMediaQuery?.matches) return;
        setLeftSidebarState((current)=>{
            if (current.isFlyoutOpen) return current;
            return {
                ...current,
                isFlyoutOpen: true
            };
        });
    }, [
        setLeftSidebarState,
        mobileMediaQuery
    ]);
    const closeMobileFlyout = (0, $5uXOq.useCallback)(()=>{
        if (!mobileMediaQuery?.matches) return;
        setLeftSidebarState((current)=>{
            if (!current.isFlyoutOpen) return current;
            return {
                ...current,
                isFlyoutOpen: false
            };
        });
    }, [
        setLeftSidebarState,
        mobileMediaQuery
    ]);
    (0, $gZkTp.UNSAFE_useMediaQuery)('below.sm', (event)=>{
        setLeftSidebarState((current)=>{
            if (event.matches && !current.isLeftSidebarCollapsed) // Sidebar was previously open when resizing downwards, convert the sidebar being open to a flyout being open
            return {
                ...current,
                isResizing: false,
                isLeftSidebarCollapsed: true,
                leftSidebarWidth: (0, $62b79b702763d93f$export$46acf8758e9e2636),
                lastLeftSidebarWidth: current.leftSidebarWidth,
                isFlyoutOpen: true
            };
            else if (!event.matches && current.isFlyoutOpen) // The user is resizing "upwards", eg. going from mobile to desktop.
            // Flyout was previously open, let's keep it open by moving to the un-collapsed sidebar instead
            return {
                ...current,
                isResizing: false,
                isLeftSidebarCollapsed: false,
                leftSidebarWidth: Math.max(current.lastLeftSidebarWidth, (0, $62b79b702763d93f$export$539e68c09584883a)),
                isFlyoutOpen: false
            };
            return current;
        });
    });
    // Close the flyout when the "escape" key is pressed.
    (0, $2rNTw.default)({
        onClose: closeMobileFlyout,
        isDisabled: !isFlyoutOpen
    });
    // We use both the state and our effect-based ref to protect animation until initialized fully
    const isReady = (0, $fHpHg.fg)('platform_dst_concurrent_left_sidebar_width') ? hasInit && notFirstRun.current : notFirstRun.current;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, mobileMediaQuery?.matches && /**
     * On desktop, the `onClick` handlers controls the temporary flyout behavior.
     * This is an intentionally mouse-only experience, it may even be disruptive with keyboard navigation.
     *
     * On mobile, the `onClick` handler controls the toggled flyout behaviour.
     * This is not intended to be how you use this with a keyboard, there is a ResizeButton for this intentionally instead.
     */ // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            $0c836dc1e23c5f3a$var$hiddenBackdropStyles,
            isFlyoutOpen && $0c836dc1e23c5f3a$var$openBackdropStyles
        ],
        onClick: closeMobileFlyout
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $9Q3Cp.default), {
        ref: leftSideBarRef,
        testId: testId,
        onMouseOver: !mobileMediaQuery?.matches ? onMouseOver : undefined,
        onMouseLeave: !mobileMediaQuery?.matches ? onMouseLeave : undefined,
        onClick: mobileMediaQuery?.matches ? openMobileFlyout : undefined,
        id: id,
        isFixed: isFixed
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $gHNHO.default), {
        variableName: (0, $62b79b702763d93f$export$a30f2e00489a8957),
        value: isReady ? leftSidebarWidth : leftSidebarWidthOnMount,
        mobileValue: (0, $62b79b702763d93f$export$70740f5ad8360a78)
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $e5XmT.default), {
        isFixed: isFixed,
        isFlyoutOpen: isFlyoutOpen
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $jHPcL.default), {
        isFlyoutOpen: isFlyoutOpen,
        isLeftSidebarCollapsed: isLeftSidebarCollapsed,
        hasCollapsedState: !isReady && collapsedState === 'collapsed',
        testId: testId && `${testId}-resize-children-wrapper`
    }, children), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $1jOQg.default), {
        testId: testId,
        valueTextLabel: valueTextLabel,
        resizeGrabAreaLabel: resizeGrabAreaLabel,
        resizeButtonLabel: resizeButtonLabel,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        overrides: overrides,
        onResizeStart: onResizeStart,
        onResizeEnd: onResizeEnd
    }))));
};
var $0c836dc1e23c5f3a$export$2e2bcd8739ae039 = $0c836dc1e23c5f3a$var$LeftSidebar;

});
parcelRegister("gZkTp", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_useMediaQuery", () => $44b03abd2e26f5c1$export$49e55ae2c03d6045);

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");

var $1SIzn = parcelRequire("1SIzn");

var $kU1q1 = parcelRequire("kU1q1");
const $44b03abd2e26f5c1$var$queries = {
    'above.xxs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $kU1q1.UNSAFE_media).above.xxs.replace('@media ', '').trim()),
    'above.xs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $kU1q1.UNSAFE_media).above.xs.replace('@media ', '').trim()),
    'above.sm': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $kU1q1.UNSAFE_media).above.sm.replace('@media ', '').trim()),
    'above.md': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $kU1q1.UNSAFE_media).above.md.replace('@media ', '').trim()),
    'above.lg': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $kU1q1.UNSAFE_media).above.lg.replace('@media ', '').trim()),
    'above.xl': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $kU1q1.UNSAFE_media).above.xl.replace('@media ', '').trim()),
    'below.xs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $kU1q1.UNSAFE_media).below.xs.replace('@media ', '').trim()),
    'below.sm': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $kU1q1.UNSAFE_media).below.sm.replace('@media ', '').trim()),
    'below.md': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $kU1q1.UNSAFE_media).below.md.replace('@media ', '').trim()),
    'below.lg': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $kU1q1.UNSAFE_media).below.lg.replace('@media ', '').trim()),
    'below.xl': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $kU1q1.UNSAFE_media).below.xl.replace('@media ', '').trim())
};
const $44b03abd2e26f5c1$export$49e55ae2c03d6045 = (queryString, listener)=>{
    const listenerRef = (0, $5uXOq.useRef)(listener);
    (0, $5uXOq.useEffect)(()=>{
        // Bind the listener if changed so it's called on the next change event; no guarantee on timing.
        listenerRef.current = listener;
    }, [
        listener
    ]);
    /**
	 * We explicitly only react to boolean changes for binding our listener
	 * Changes to the functional reference are ignored.
	 */ const hasListener = !!listener;
    /**
	 * The `matchMedia(…)` return value for our breakpoint query.
	 */ const mq = $44b03abd2e26f5c1$var$queries[queryString];
    (0, $1SIzn.useLayoutEffect)(()=>{
        listenerRef.current = listener; // Bind the listener now in case the `useEffect` hasn't fired above yet
        if (!mq || !hasListener || !listenerRef.current) return;
        return (0, $cBeZP.bind)(mq, {
            type: 'change',
            listener: (event)=>{
                // We explicitly call the current version of the function
                return listenerRef.current(event);
            }
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- explicitly do not trigger the effect on `listener` reference change, only on a boolean representation of it.
    [
        mq,
        hasListener
    ]);
    return mq || null;
};

});

parcelRegister("02o6B", function(module, exports) {

$parcel$export(module.exports, "SidebarResizeContext", () => $7cec7abf760fd819$export$aa5a712eea4c2ae8);
$parcel$export(module.exports, "usePageLayoutResize", () => $7cec7abf760fd819$export$10c7104037a7af62);
$parcel$export(module.exports, "useLeftSidebarFlyoutLock", () => $7cec7abf760fd819$export$94561f6055639ef7);

var $5uXOq = parcelRequire("5uXOq");

var $bKnKN = parcelRequire("bKnKN");
const $7cec7abf760fd819$var$leftSidebarState = {
    isFlyoutOpen: false,
    isResizing: false,
    isLeftSidebarCollapsed: false,
    leftSidebarWidth: 0,
    lastLeftSidebarWidth: 0,
    flyoutLockCount: 0,
    isFixed: true,
    hasInit: false
};
const $7cec7abf760fd819$export$aa5a712eea4c2ae8 = /*#__PURE__*/ (0, $5uXOq.createContext)({
    isLeftSidebarCollapsed: false,
    expandLeftSidebar: (0, $bKnKN.default),
    collapseLeftSidebar: (0, $bKnKN.default),
    leftSidebarState: $7cec7abf760fd819$var$leftSidebarState,
    setLeftSidebarState: (0, $bKnKN.default),
    toggleLeftSidebar: (0, $bKnKN.default)
});
const $7cec7abf760fd819$export$10c7104037a7af62 = ()=>{
    const { setLeftSidebarState: setLeftSidebarState, ...context } = (0, $5uXOq.useContext)($7cec7abf760fd819$export$aa5a712eea4c2ae8);
    return context;
};
const $7cec7abf760fd819$export$94561f6055639ef7 = ()=>{
    const { setLeftSidebarState: setLeftSidebarState } = (0, $5uXOq.useContext)($7cec7abf760fd819$export$aa5a712eea4c2ae8);
    (0, $5uXOq.useEffect)(()=>{
        setLeftSidebarState((current)=>({
                ...current,
                flyoutLockCount: current.flyoutLockCount + 1
            }));
        return ()=>{
            setLeftSidebarState((current)=>({
                    ...current,
                    flyoutLockCount: current.flyoutLockCount - 1
                }));
        };
    }, [
        setLeftSidebarState
    ]);
};

});

parcelRegister("1jOQg", function(module, exports) {

$parcel$export(module.exports, "default", () => $c49df7fdb072f090$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $cBeZP = parcelRequire("cBeZP");

var $7nRxN = parcelRequire("7nRxN");

var $gZkTp = parcelRequire("gZkTp");


var $503JR = parcelRequire("503JR");

var $02o6B = parcelRequire("02o6B");

var $1HB4o = parcelRequire("1HB4o");

var $3B10b = parcelRequire("3B10b");

var $iJ5UH = parcelRequire("iJ5UH");
function $c49df7fdb072f090$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $c49df7fdb072f090$var$cssSelector = {
    [(0, $62b79b702763d93f$export$9ecd22db14e6c70e)]: true
};
const $c49df7fdb072f090$var$resizeControlStyles = {
    name: "ow3ovp",
    styles: "position:absolute;inset-block-end:0;inset-block-start:0;inset-inline-start:100%;outline:none"
};
const $c49df7fdb072f090$var$showResizeButtonStyles = {
    name: "1a6byq5",
    styles: "--ds--resize-button--opacity:1"
};
// @ts-expect-error adding `!important` to style rules is currently a type error
const $c49df7fdb072f090$var$globalResizingStyles = {
    name: "e4avm6",
    styles: "*{cursor:ew-resize !important;user-select:none !important;}iframe{pointer-events:none !important;}"
};
const $c49df7fdb072f090$var$ResizeControl = ({ testId: testId, overrides: overrides, resizeButtonLabel: resizeButtonLabel = 'Current project sidebar', valueTextLabel: valueTextLabel = 'Width', resizeGrabAreaLabel: resizeGrabAreaLabel = 'Resize Current Project Sidebar', onResizeStart: onResizeStart, onResizeEnd: onResizeEnd })=>{
    const { toggleLeftSidebar: toggleLeftSidebar, collapseLeftSidebar: collapseLeftSidebar, leftSidebarState: leftSidebarState, setLeftSidebarState: setLeftSidebarState } = (0, $5uXOq.useContext)((0, $02o6B.SidebarResizeContext));
    const { isLeftSidebarCollapsed: isLeftSidebarCollapsed } = leftSidebarState;
    const sidebarWidth = (0, $5uXOq.useRef)(leftSidebarState[0, $62b79b702763d93f$export$a30f2e00489a8957]);
    // Distance of mouse from left sidebar onMouseDown
    const offset = (0, $5uXOq.useRef)(0);
    const keyboardEventTimeout = (0, $5uXOq.useRef)();
    const [isGrabAreaFocused, setIsGrabAreaFocused] = (0, $5uXOq.useState)(false);
    const unbindEvents = (0, $5uXOq.useRef)(null);
    const mobileMediaQuery = (0, $gZkTp.UNSAFE_useMediaQuery)('below.sm');
    // Used in some cases to ensure function references don't have to change
    // TODO: more functions could use `stableSidebarState` rather than `leftSidebarState`
    const stableSidebarState = (0, $5uXOq.useRef)(leftSidebarState);
    (0, $5uXOq.useEffect)(()=>{
        stableSidebarState.current = leftSidebarState;
    }, [
        leftSidebarState
    ]);
    const toggleSideBar = (0, $5uXOq.useCallback)((event)=>{
        // don't cascade down to the LeftSidebarOuter
        event?.stopPropagation();
        toggleLeftSidebar();
    }, [
        toggleLeftSidebar
    ]);
    const onMouseDown = (event)=>{
        if (isLeftSidebarCollapsed) return;
        // Only allow left (primary) clicks to trigger resize as we've received
        // bug reports about right click unexpectedly beginning a resize.
        if (event.button !== 0) return;
        // It is possible for a mousedown to fire during a resize
        // Example: the user presses another pointer button while dragging
        if (leftSidebarState.isResizing) // the resize will be cancelled by our global event listeners
        return;
        offset.current = event.clientX - leftSidebarState[0, $62b79b702763d93f$export$a30f2e00489a8957] - (0, $503JR.getLeftPanelWidth)();
        unbindEvents.current = (0, $cBeZP.bindAll)(window, [
            {
                type: 'mousemove',
                listener: function(event) {
                    onUpdateResize({
                        clientX: event.clientX
                    });
                }
            },
            {
                type: 'mouseup',
                listener: onFinishResizing
            },
            {
                type: 'mousedown',
                // this mousedown event listener is being added in the bubble phase
                // on a higher event target than the resize handle.
                // This means that the original mousedown event that triggers a resize
                // can hit this mousedown handler. To get around that, we only call
                // `onFinishResizing` after an animation frame so we don't pick up the original event
                // Alternatives:
                // 1. Add the window 'mousedown' event listener in the capture phase
                // 👎 A 'mousedown' during a resize would trigger a new resize to start
                // 2. Do 1. and call `event.preventDefault()`, then check for `event.defaultPrevented` inside
                // the grab handle `onMouseDown`
                // 👎 Not ideal to cancel events if we don't have to
                listener: (()=>{
                    let hasFramePassed = false;
                    requestAnimationFrame(()=>{
                        hasFramePassed = true;
                    });
                    return function listener() {
                        if (hasFramePassed) onFinishResizing();
                    };
                })()
            },
            {
                type: 'visibilitychange',
                listener: onFinishResizing
            },
            // A 'click' event should never be hit as the 'mouseup' will come first and cause
            // these event listeners to be unbound. I just added 'click' for extreme safety (paranoia)
            {
                type: 'click',
                listener: onFinishResizing
            },
            {
                type: 'keydown',
                listener: (event)=>{
                    // Can cancel resizing by pressing "Escape"
                    // Will return sidebar to the same size it was before the resizing started
                    if (event.key === 'Escape') {
                        sidebarWidth.current = Math.max(leftSidebarState.lastLeftSidebarWidth, (0, $62b79b702763d93f$export$46acf8758e9e2636));
                        document.documentElement.style.setProperty(`--${(0, $62b79b702763d93f$export$a30f2e00489a8957)}`, `${sidebarWidth.current}px`);
                        onFinishResizing();
                    }
                }
            }
        ]);
        document.documentElement.setAttribute((0, $62b79b702763d93f$export$802bb2c050f3db5c), 'true');
        const newLeftbarState = {
            ...leftSidebarState,
            isResizing: true
        };
        setLeftSidebarState(newLeftbarState);
        onResizeStart && onResizeStart(newLeftbarState);
    };
    const onResizeOffLeftOfScreen = ()=>{
        onUpdateResize.cancel();
        unbindEvents.current?.();
        unbindEvents.current = null;
        document.documentElement.removeAttribute((0, $62b79b702763d93f$export$802bb2c050f3db5c));
        offset.current = 0;
        collapseLeftSidebar(undefined, true);
    };
    // It is important that `onUpdateResize` is a stable function reference, so that:
    // 1. we ensure we are correctly throttling with `requestAnimationFrame`
    // 2. that a `onUpdateResize` will cancel the one and only pending frame
    // To help ensure `onUpdateResize` is stable, we are putting the last state into a ref
    const [onUpdateResize] = (0, $5uXOq.useState)(()=>(0, $7nRxN.default)(({ clientX: clientX })=>{
            // Allow the sidebar to be 50% of the available page width
            const maxWidth = Math.round(window.innerWidth / 2);
            const leftPanelWidth = (0, $503JR.getLeftPanelWidth)();
            const leftSidebarWidth = stableSidebarState.current.leftSidebarWidth;
            const hasResizedOffLeftOfScreen = clientX < 0;
            if (hasResizedOffLeftOfScreen) {
                onResizeOffLeftOfScreen();
                return;
            }
            const delta = Math.max(Math.min(clientX - leftSidebarWidth - leftPanelWidth, maxWidth - leftSidebarWidth - leftPanelWidth), (0, $62b79b702763d93f$export$46acf8758e9e2636) - leftSidebarWidth - leftPanelWidth);
            sidebarWidth.current = Math.max(leftSidebarWidth + delta - offset.current, (0, $62b79b702763d93f$export$46acf8758e9e2636));
            document.documentElement.style.setProperty(`--${(0, $62b79b702763d93f$export$a30f2e00489a8957)}`, `${sidebarWidth.current}px`);
        }));
    const onFinishResizing = ()=>{
        if (isLeftSidebarCollapsed) return;
        document.documentElement.removeAttribute((0, $62b79b702763d93f$export$802bb2c050f3db5c));
        // TODO: the control flow is pretty strange as the first codepath which calls `collapseLeftSidebar()`
        // does not return an updated state snapshot.
        let updatedLeftSidebarState = null;
        // If it is dragged to below the threshold,
        // collapse the navigation
        if (sidebarWidth.current < (0, $62b79b702763d93f$export$6949d4f32b161684)) {
            // TODO: for this codepath, `onCollapse` occurs before `onResizeEnd` which seems wrong
            document.documentElement.style.setProperty(`--${(0, $62b79b702763d93f$export$a30f2e00489a8957)}`, `${(0, $62b79b702763d93f$export$46acf8758e9e2636)}px`);
            collapseLeftSidebar(undefined, true);
        } else if (sidebarWidth.current > (0, $62b79b702763d93f$export$6949d4f32b161684) && sidebarWidth.current < (0, $62b79b702763d93f$export$539e68c09584883a)) {
            document.documentElement.style.setProperty(`--${(0, $62b79b702763d93f$export$a30f2e00489a8957)}`, `${(0, $62b79b702763d93f$export$539e68c09584883a)}px`);
            updatedLeftSidebarState = {
                ...leftSidebarState,
                isResizing: false,
                [(0, $62b79b702763d93f$export$a30f2e00489a8957)]: (0, $62b79b702763d93f$export$539e68c09584883a),
                lastLeftSidebarWidth: (0, $62b79b702763d93f$export$539e68c09584883a)
            };
            setLeftSidebarState(updatedLeftSidebarState);
        } else {
            // otherwise resize it to the desired width
            updatedLeftSidebarState = {
                ...leftSidebarState,
                isResizing: false,
                [(0, $62b79b702763d93f$export$a30f2e00489a8957)]: sidebarWidth.current,
                lastLeftSidebarWidth: sidebarWidth.current
            };
            setLeftSidebarState(updatedLeftSidebarState);
        }
        unbindEvents.current?.();
        unbindEvents.current = null;
        onUpdateResize.cancel();
        sidebarWidth.current = 0;
        offset.current = 0;
        // TODO: no idea why this is in an animation frame
        requestAnimationFrame(()=>{
            setIsGrabAreaFocused(false);
            // Note: the `collapseSidebar` codepath does not return state, so we need to pull it from the ref
            onResizeEnd?.(updatedLeftSidebarState ?? stableSidebarState.current);
        });
    };
    const onKeyDown = (event)=>{
        if (isLeftSidebarCollapsed || !isGrabAreaFocused) return false;
        const { key: key } = event;
        const isLeftOrTopArrow = key === 'ArrowLeft' || key === 'ArrowUp' || key === 'Left' || key === 'Up';
        const isRightOrBottomArrow = key === 'ArrowRight' || key === 'ArrowDown' || key === 'Right' || key === 'Down';
        const isSpaceOrEnter = key === 'Enter' || key === 'Spacebar' || key === ' ';
        if (isSpaceOrEnter) {
            toggleSideBar(event);
            event.preventDefault();
        }
        if (isLeftOrTopArrow || isRightOrBottomArrow) {
            event.preventDefault(); // prevent content scroll
            onResizeStart && onResizeStart(leftSidebarState);
            const step = 10;
            const stepValue = isLeftOrTopArrow ? -step : step;
            const { leftSidebarWidth: leftSidebarWidth } = leftSidebarState;
            const maxWidth = Math.round(window.innerWidth / 2) - (0, $503JR.getLeftPanelWidth)();
            const hasModifierKey = event.metaKey || event.altKey || event.ctrlKey || event.shiftKey;
            let width = leftSidebarWidth + stepValue;
            if (width <= (0, $62b79b702763d93f$export$539e68c09584883a)) {
                width = (0, $62b79b702763d93f$export$539e68c09584883a);
                document.documentElement.style.setProperty(`--${(0, $62b79b702763d93f$export$a30f2e00489a8957)}`, `${(0, $62b79b702763d93f$export$539e68c09584883a) - 20}px`);
            } else if (width > maxWidth) {
                width = maxWidth;
                document.documentElement.style.setProperty(`--${(0, $62b79b702763d93f$export$a30f2e00489a8957)}`, `${maxWidth + 20}px`);
            } else if (hasModifierKey) width = isRightOrBottomArrow ? maxWidth : (0, $62b79b702763d93f$export$539e68c09584883a);
            // Nesting the setTimeout within requestAnimationFrame helps
            // the browser schedule the setTimeout call in an efficient manner
            requestAnimationFrame(()=>{
                keyboardEventTimeout.current = window.setTimeout(()=>{
                    keyboardEventTimeout.current && clearTimeout(keyboardEventTimeout.current);
                    document.documentElement.style.setProperty(`--${(0, $62b79b702763d93f$export$a30f2e00489a8957)}`, `${width}px`);
                    const updatedLeftSidebarState = {
                        ...leftSidebarState,
                        [(0, $62b79b702763d93f$export$a30f2e00489a8957)]: width,
                        lastLeftSidebarWidth: width
                    };
                    setLeftSidebarState(updatedLeftSidebarState);
                    onResizeEnd && onResizeEnd(updatedLeftSidebarState);
                }, 50);
            });
        }
    };
    const onFocus = (0, $5uXOq.useCallback)(()=>{
        setIsGrabAreaFocused(true);
    }, []);
    const onBlur = (0, $5uXOq.useCallback)(()=>{
        setIsGrabAreaFocused(false);
    }, []);
    const resizeButton = {
        render: (Component, props)=>/*#__PURE__*/ (0, $f8Sb3.jsx)(Component, props),
        ...overrides && overrides.ResizeButton
    };
    // This width is calculated once only on mount.
    // This means resizing the window will cause this value to be incorrect for screen reader users,
    // however this comes with a substantial performance gain and so is considered acceptable.
    const maxAriaWidth = (0, $5uXOq.useMemo)(()=>{
        const innerWidth = typeof window === 'undefined' ? 0 : window.innerWidth;
        return Math.round(innerWidth / 2) - (0, $503JR.getLeftPanelWidth)();
    }, []);
    const leftSidebarPercentageExpanded = (0, $503JR.getLeftSidebarPercentage)(leftSidebarState.leftSidebarWidth, maxAriaWidth);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...$c49df7fdb072f090$var$cssSelector,
        css: [
            $c49df7fdb072f090$var$resizeControlStyles,
            (isGrabAreaFocused || isLeftSidebarCollapsed) && $c49df7fdb072f090$var$showResizeButtonStyles
        ]
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $iJ5UH.default), {
        testId: testId && `${testId}-shadow`
    }), // Only show the GrabArea if we're not on the mobile viewport
    !mobileMediaQuery?.matches && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $1HB4o.default), {
        isDisabled: isLeftSidebarCollapsed,
        isLeftSidebarCollapsed: isLeftSidebarCollapsed,
        label: resizeGrabAreaLabel,
        valueTextLabel: valueTextLabel,
        leftSidebarPercentageExpanded: leftSidebarPercentageExpanded,
        onBlur: onBlur,
        onFocus: onFocus,
        onKeyDown: onKeyDown,
        onMouseDown: onMouseDown,
        testId: testId && `${testId}-grab-area`
    }), resizeButton.render((0, $3B10b.default), {
        isLeftSidebarCollapsed: mobileMediaQuery?.matches ? !leftSidebarState.isFlyoutOpen : isLeftSidebarCollapsed,
        label: resizeButtonLabel,
        onClick: toggleSideBar,
        testId: testId && `${testId}-resize-button`
    })), leftSidebarState.isResizing ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $f8Sb3.Global), {
        styles: $c49df7fdb072f090$var$globalResizingStyles
    }) : null);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$c49df7fdb072f090$export$2e2bcd8739ae039 = $c49df7fdb072f090$var$ResizeControl;

});
parcelRegister("1HB4o", function(module, exports) {

$parcel$export(module.exports, "default", () => $b843ede612effe09$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");


function $b843ede612effe09$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/**
 * Determines the color of the grab line.
 *
 * Used on internal leaf node, so naming collisions won't matter.
 */ const $b843ede612effe09$var$varLineColor = '--ds-line';
const $b843ede612effe09$var$grabAreaStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    width: "var(--ds-space-200, 16px)",
    height: '100%',
    padding: 0,
    backgroundColor: 'transparent',
    border: 0,
    cursor: 'ew-resize',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&::-moz-focus-inner': {
        border: 0
    },
    '&:focus': {
        outline: 0
    },
    '&:enabled:hover, &:enabled:focus, &:enabled:active': {
        [$b843ede612effe09$var$varLineColor]: `var(--ds-border-selected, ${(0, $a7f8c6b391092279$export$215b7063051591f1)})`
    }
});
const $b843ede612effe09$var$grabAreaCollapsedStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    height: `calc(100% - ${"var(--ds-space-600, 3rem)"} * 2)`,
    padding: 0,
    position: 'absolute',
    backgroundColor: 'transparent',
    border: 0,
    cursor: 'default',
    insetBlockEnd: 0
});
const $b843ede612effe09$var$lineStyles = {
    name: "w4swnc",
    styles: "display:block;width:var(--ds-border-width-outline, 2px);height:100%;background-color:var(--ds-line);transition:background-color 200ms"
};
const $b843ede612effe09$var$grabAreaLineSelector = {
    [(0, $62b79b702763d93f$export$70c702a8c5895f03)]: true
};
const $b843ede612effe09$var$grabAreaSelector = {
    [(0, $62b79b702763d93f$export$48a43f91e4becf4e)]: true
};
const $b843ede612effe09$var$GrabArea = ({ testId: testId, valueTextLabel: valueTextLabel = 'Width', isDisabled: isDisabled, isLeftSidebarCollapsed: isLeftSidebarCollapsed, label: label, leftSidebarPercentageExpanded: leftSidebarPercentageExpanded, onKeyDown: onKeyDown, onMouseDown: onMouseDown, onBlur: onBlur, onFocus: onFocus, ref: ref, ...rest })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("button", {
        ...$b843ede612effe09$var$grabAreaSelector,
        "aria-label": label,
        "data-testid": testId,
        disabled: isDisabled,
        "aria-hidden": isLeftSidebarCollapsed,
        type: "button",
        // The slider role is applied to a button to utilize the native
        // interactive and disabled functionality on the resize slider. While a
        // range input would be more semantically accurate, it does not affect
        // usability.
        role: "slider",
        css: [
            $b843ede612effe09$var$grabAreaStyles,
            isLeftSidebarCollapsed && $b843ede612effe09$var$grabAreaCollapsedStyles
        ],
        "aria-orientation": "vertical",
        "aria-valuenow": leftSidebarPercentageExpanded,
        "aria-valuemin": 0,
        "aria-valuemax": 100,
        "aria-valuetext": `${valueTextLabel} ${leftSidebarPercentageExpanded}%`,
        onKeyDown: onKeyDown,
        onMouseDown: onMouseDown,
        onFocus: onFocus,
        onBlur: onBlur,
        ...rest
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $b843ede612effe09$var$lineStyles,
        ...$b843ede612effe09$var$grabAreaLineSelector
    }));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$b843ede612effe09$export$2e2bcd8739ae039 = $b843ede612effe09$var$GrabArea;

});

parcelRegister("3B10b", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a4d530cd291cd0d$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /**
                                                                                                                                                 * @jsxRuntime classic
                                                                                                                                                 * @jsx jsx
                                                                                                                                                 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $cwX8H = parcelRequire("cwX8H");


var $471WD = parcelRequire("471WD");

var $kU1q1 = parcelRequire("kU1q1");


function $8a4d530cd291cd0d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $8a4d530cd291cd0d$var$increaseHitAreaStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    position: 'absolute',
    insetBlockEnd: `${"var(--ds-space-negative-300, -24px)"}`,
    insetBlockStart: `${"var(--ds-space-negative-300, -24px)"}`,
    insetInlineEnd: `${"var(--ds-space-negative-150, -12px)"}`,
    insetInlineStart: `${"var(--ds-space-negative-100, -8px)"}`
});
const $8a4d530cd291cd0d$var$mobileStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles -- Ignored via go/DSP-18766
    [(0, $kU1q1.UNSAFE_media).below.sm]: {
        opacity: 1
    }
});
const $8a4d530cd291cd0d$var$resizeIconButtonStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    width: 24,
    height: 24,
    padding: "var(--ds-space-0, 0px)",
    position: 'absolute',
    backgroundColor: `var(--ds-surface-overlay, ${(0, $a7f8c6b391092279$export$29a4f05edc054374)})`,
    border: 0,
    borderRadius: "var(--ds-border-radius-circle, 50%)",
    boxShadow: `0 0 0 1px ${(0, $a7f8c6b391092279$export$920c0d5c49070351)}, 0 2px 4px 1px ${(0, $a7f8c6b391092279$export$920c0d5c49070351)}`,
    color: `var(--ds-text-subtle, ${(0, $a7f8c6b391092279$export$f563ee71e9ee74cd)})`,
    cursor: 'pointer',
    insetBlockStart: "var(--ds-space-400, 32px)",
    insetInlineStart: 0,
    /**
   * The fallback value of 0 ensures that the button is hidden by default,
   * unless some parent (or the button itself) overrides it.
   */ opacity: `var(--ds--resize-button--opacity,0)`,
    outline: 0,
    transform: 'translateX(-50%)',
    transition: `
    background-color ${(0, $471WD.durations).small}ms linear,
    color ${(0, $471WD.durations).small}ms linear,
    opacity ${(0, $471WD.durations).medium}ms ${(0, $99bc8d2d71e909fb$export$57636bb43b1ccbb0)}
  `,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':hover': {
        backgroundColor: `var(--ds-background-selected-bold, ${(0, $a7f8c6b391092279$export$ecfc1dff386a3e7a)})`,
        color: `var(--ds-text-inverse, ${(0, $a7f8c6b391092279$export$29a4f05edc054374)})`,
        opacity: 1
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':active, :focus': {
        backgroundColor: `var(--ds-background-selected-bold-hovered, ${(0, $a7f8c6b391092279$export$215b7063051591f1)})`,
        color: `var(--ds-text-inverse, ${(0, $a7f8c6b391092279$export$29a4f05edc054374)})`,
        opacity: 1
    }
});
const $8a4d530cd291cd0d$var$resizeIconButtonExpandedStyles = {
    name: "1bl2513",
    styles: "transform:rotate(180deg);transform-origin:7px"
};
const $8a4d530cd291cd0d$var$preventDefault = (event)=>event.preventDefault();
const $8a4d530cd291cd0d$var$cssSelector = {
    [(0, $62b79b702763d93f$export$dac2fb31a9f6844d)]: true
};
const $8a4d530cd291cd0d$var$ResizeButton = ({ isLeftSidebarCollapsed: isLeftSidebarCollapsed, label: label, testId: testId, ...props })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("button", {
        ...$8a4d530cd291cd0d$var$cssSelector,
        "aria-expanded": !isLeftSidebarCollapsed,
        "aria-label": label,
        type: "button",
        // The error goes away when we remove the spread ...props
        css: [
            $8a4d530cd291cd0d$var$resizeIconButtonStyles,
            $8a4d530cd291cd0d$var$mobileStyles,
            !isLeftSidebarCollapsed && $8a4d530cd291cd0d$var$resizeIconButtonExpandedStyles
        ],
        "data-testid": testId,
        // Prevents focus staying attached to the button when pressed
        onMouseDown: $8a4d530cd291cd0d$var$preventDefault,
        ...props
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cwX8H))), {
        label: "",
        color: "currentColor"
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $8a4d530cd291cd0d$var$increaseHitAreaStyles
    }));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$8a4d530cd291cd0d$export$2e2bcd8739ae039 = $8a4d530cd291cd0d$var$ResizeButton;

});

parcelRegister("iJ5UH", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d133ccf90cea365$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");


var $lSXy9 = parcelRequire("lSXy9");
const $9d133ccf90cea365$var$colorStops = `
    rgba(0, 0, 0, 0.2) 0px,
    rgba(0, 0, 0, 0.2) 1px,
    rgba(0, 0, 0, 0.1) 1px,
    rgba(0, 0, 0, 0) 100%
  `;
const $9d133ccf90cea365$var$direction = 'to left';
const $9d133ccf90cea365$var$transitionDuration = '0.22s';
const $9d133ccf90cea365$var$shadowStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    width: 3,
    position: 'absolute',
    background: `var(--ds-border, ${`linear-gradient(${$9d133ccf90cea365$var$direction}, ${$9d133ccf90cea365$var$colorStops})`})`,
    insetBlockEnd: 0,
    insetBlockStart: 0,
    insetInlineStart: -1,
    opacity: 0.5,
    pointerEvents: 'none',
    transitionDuration: $9d133ccf90cea365$var$transitionDuration,
    transitionProperty: 'left, opacity, width',
    transitionTimingFunction: (0, $99bc8d2d71e909fb$export$57636bb43b1ccbb0)
});
const $9d133ccf90cea365$var$draggingStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    width: 6,
    background: `var(--ds-background-neutral-subtle, ${`linear-gradient(${$9d133ccf90cea365$var$direction}, ${$9d133ccf90cea365$var$colorStops})`})`,
    insetInlineStart: "var(--ds-space-negative-075, -6px)",
    opacity: 0.8
});
const $9d133ccf90cea365$var$Shadow = ({ testId: testId })=>{
    const isDragging = (0, $lSXy9.default)();
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        "data-testid": testId,
        css: [
            $9d133ccf90cea365$var$shadowStyles,
            isDragging && $9d133ccf90cea365$var$draggingStyles
        ]
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$9d133ccf90cea365$export$2e2bcd8739ae039 = $9d133ccf90cea365$var$Shadow;

});
parcelRegister("lSXy9", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ad6b555780b28ae$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

const $7ad6b555780b28ae$var$getIsDragging = ()=>{
    // SSR bail-out because document is undefined on the server
    if (typeof document === 'undefined') return false;
    return document.documentElement.getAttribute((0, $62b79b702763d93f$export$802bb2c050f3db5c)) === 'true';
};
// TODO: I think this should be derived from the sidebar state,
// and not indirectly from observing an attribute change
const $7ad6b555780b28ae$var$useIsSidebarDragging = ()=>{
    const [isDragging, setIsDragging] = (0, $5uXOq.useState)($7ad6b555780b28ae$var$getIsDragging);
    (0, $5uXOq.useEffect)(()=>{
        const observer = new MutationObserver(()=>{
            setIsDragging($7ad6b555780b28ae$var$getIsDragging);
        });
        observer.observe(document.documentElement, {
            attributeFilter: [
                (0, $62b79b702763d93f$export$802bb2c050f3db5c)
            ]
        });
        return ()=>{
            observer.disconnect();
        };
    }, []);
    return isDragging;
};
var $7ad6b555780b28ae$export$2e2bcd8739ae039 = $7ad6b555780b28ae$var$useIsSidebarDragging;

});



parcelRegister("e5XmT", function(module, exports) {

$parcel$export(module.exports, "default", () => $4fefdd86f9bce1a8$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $eXGNC = parcelRequire("eXGNC");

var $kU1q1 = parcelRequire("kU1q1");


var $lSXy9 = parcelRequire("lSXy9");
function $4fefdd86f9bce1a8$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $4fefdd86f9bce1a8$var$prefersReducedMotionStyles = /*#__PURE__*/ (0, $f8Sb3.css)((0, $eXGNC.prefersReducedMotion)());
const $4fefdd86f9bce1a8$var$mobileStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [(0, $kU1q1.UNSAFE_media).below.sm]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `${(0, $62b79b702763d93f$export$70740f5ad8360a78)}px`,
        position: 'fixed',
        insetBlockEnd: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        insetBlockStart: `calc(${(0, $62b79b702763d93f$export$ed7cc0d417ee89e)} + ${(0, $62b79b702763d93f$export$aeff86a16f13529)})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        insetInlineStart: `${(0, $62b79b702763d93f$export$f963aecf2d4465bd)}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        transition: `width ${(0, $62b79b702763d93f$export$3749e1104328fde4)}ms ${(0, $99bc8d2d71e909fb$export$57636bb43b1ccbb0)} 0s`
    }
});
const $4fefdd86f9bce1a8$var$mobileInnerFlyoutStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [(0, $kU1q1.UNSAFE_media).below.sm]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `min(90vw, ${(0, $62b79b702763d93f$export$d6e7e8af042815bb)}px)`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: (0, $62b79b702763d93f$export$d6e7e8af042815bb),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        transition: `width ${(0, $62b79b702763d93f$export$3749e1104328fde4)}ms ${(0, $99bc8d2d71e909fb$export$57636bb43b1ccbb0)} 0s, box-shadow ${(0, $62b79b702763d93f$export$3749e1104328fde4)}ms ${(0, $99bc8d2d71e909fb$export$57636bb43b1ccbb0)} 0s`
    }
});
/**
 * This inner wrapper is required to allow the sidebar to be `position: fixed`.
 *
 * If we were to apply `position: fixed` to the outer wrapper, it will be popped
 * out of its flex container and Main would stretch to occupy all the space.
 */ const $4fefdd86f9bce1a8$var$fixedInnerStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${(0, $62b79b702763d93f$export$f897e1ed9f8ed251)}`,
    position: 'fixed',
    insetBlockEnd: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetBlockStart: `calc(${(0, $62b79b702763d93f$export$ed7cc0d417ee89e)} + ${(0, $62b79b702763d93f$export$aeff86a16f13529)})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetInlineStart: `${(0, $62b79b702763d93f$export$f963aecf2d4465bd)}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transition: `width ${(0, $62b79b702763d93f$export$3749e1104328fde4)}ms ${(0, $99bc8d2d71e909fb$export$57636bb43b1ccbb0)} 0s`
});
const $4fefdd86f9bce1a8$var$fixedInnerFlyoutStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $62b79b702763d93f$export$d2fa14f05b61e66)
});
/**
 * Static in the sense of `position: static`.
 *
 * It will expand the page height to fit its content.
 */ const $4fefdd86f9bce1a8$var$staticInnerStyles = {
    name: "13udsys",
    styles: "height:100%"
};
const $4fefdd86f9bce1a8$var$draggingStyles = {
    name: "jlx54q",
    styles: "cursor:ew-resize;transition:none"
};
const $4fefdd86f9bce1a8$var$LeftSidebarInner = ({ children: children, isFixed: isFixed = false, isFlyoutOpen: isFlyoutOpen = false })=>{
    const isDragging = (0, $lSXy9.default)();
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            // mobile viewport styles
            $4fefdd86f9bce1a8$var$mobileStyles,
            isFlyoutOpen && $4fefdd86f9bce1a8$var$mobileInnerFlyoutStyles,
            // generic styles
            !isFixed && $4fefdd86f9bce1a8$var$staticInnerStyles,
            isFixed && $4fefdd86f9bce1a8$var$fixedInnerStyles,
            isFixed && isFlyoutOpen && $4fefdd86f9bce1a8$var$fixedInnerFlyoutStyles,
            isDragging && $4fefdd86f9bce1a8$var$draggingStyles,
            $4fefdd86f9bce1a8$var$prefersReducedMotionStyles
        ]
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$4fefdd86f9bce1a8$export$2e2bcd8739ae039 = $4fefdd86f9bce1a8$var$LeftSidebarInner;

});

parcelRegister("9Q3Cp", function(module, exports) {

$parcel$export(module.exports, "default", () => $e04a85286cafdcfd$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $eXGNC = parcelRequire("eXGNC");

var $kU1q1 = parcelRequire("kU1q1");


var $lSXy9 = parcelRequire("lSXy9");

var $503JR = parcelRequire("503JR");

var $02o6B = parcelRequire("02o6B");

var $2pQ0W = parcelRequire("2pQ0W");
function $e04a85286cafdcfd$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $e04a85286cafdcfd$var$prefersReducedMotionStyles = /*#__PURE__*/ (0, $f8Sb3.css)((0, $eXGNC.prefersReducedMotion)());
const $e04a85286cafdcfd$var$mobileStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [(0, $kU1q1.UNSAFE_media).below.sm]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: (0, $62b79b702763d93f$export$70740f5ad8360a78),
        cursor: 'pointer',
        opacity: 1,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        transition: `width ${(0, $62b79b702763d93f$export$3749e1104328fde4)}ms ${(0, $99bc8d2d71e909fb$export$57636bb43b1ccbb0)} 0s`,
        '&::after': {
            display: 'inline-block',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            maxWidth: (0, $62b79b702763d93f$export$d6e7e8af042815bb),
            content: "''"
        }
    }
});
const $e04a85286cafdcfd$var$mobileFlyoutStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [(0, $kU1q1.UNSAFE_media).below.sm]: {
        cursor: 'revert'
    }
});
const $e04a85286cafdcfd$var$outerStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $62b79b702763d93f$export$f897e1ed9f8ed251),
    position: 'relative',
    zIndex: 1,
    marginInlineStart: "var(--ds-space-0, 0px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transition: `width ${(0, $62b79b702763d93f$export$3749e1104328fde4)}ms ${(0, $99bc8d2d71e909fb$export$57636bb43b1ccbb0)} 0s`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':hover': {
        '--ds--resize-button--opacity': 1
    }
});
const $e04a85286cafdcfd$var$draggingStyles = {
    name: "jlx54q",
    styles: "cursor:ew-resize;transition:none"
};
/**
 * In fixed mode this element's child is taken out of the document flow.
 * It doesn't take up the width as expected,
 * so the pseudo element forces it to take up the necessary width.
 */ const $e04a85286cafdcfd$var$fixedStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '::after': {
        display: 'inline-block',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `${(0, $62b79b702763d93f$export$f897e1ed9f8ed251)}`,
        content: "''"
    }
});
const $e04a85286cafdcfd$var$flyoutStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $62b79b702763d93f$export$d2fa14f05b61e66)
});
const $e04a85286cafdcfd$var$flyoutFixedStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $62b79b702763d93f$export$46acf8758e9e2636)
});
const $e04a85286cafdcfd$var$selector = (0, $503JR.getPageLayoutSlotSelector)('left-sidebar');
const $e04a85286cafdcfd$var$LeftSidebarOuterComponent = ({ children: children, isFixed: isFixed = false, testId: // NOTE: We explicitly require this via props because of `LeftSidebarWithoutResize`
testId, onMouseLeave: onMouseLeave, onMouseOver: onMouseOver, onClick: onClick, id: id }, ref)=>{
    const isDragging = (0, $lSXy9.default)();
    const { leftSidebarState: { isFlyoutOpen: isFlyoutOpen } } = (0, $5uXOq.useContext)((0, $02o6B.SidebarResizeContext));
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $2pQ0W.default), {
        isSidebar: true
    }, ({ className: className })=>/**
     * On desktop, the `onMouseOver|onMouseLeave` handlers controls the temporary flyout behavior.
     * This is an intentionally mouse-only experience, it may even be disruptive with keyboard navigation.
     *
     * On mobile, the `onClick` handler controls the toggled flyout behaviour.
     * This is not intended to be how you use this with a keyboard, there is a ResizeButton for this intentionally instead.
     */ // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
        /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: [
                // mobile viewport styles
                $e04a85286cafdcfd$var$mobileStyles,
                isFlyoutOpen && $e04a85286cafdcfd$var$mobileFlyoutStyles,
                // generic styles
                $e04a85286cafdcfd$var$outerStyles,
                isFixed && $e04a85286cafdcfd$var$fixedStyles,
                isFlyoutOpen && $e04a85286cafdcfd$var$flyoutStyles,
                isFlyoutOpen && isFixed && $e04a85286cafdcfd$var$flyoutFixedStyles,
                isDragging && $e04a85286cafdcfd$var$draggingStyles,
                $e04a85286cafdcfd$var$prefersReducedMotionStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            "data-testid": testId,
            id: id,
            // We are adding additional functionality for hover, so this should
            // not have associated key events.
            // eslint-disable-next-line jsx-a11y/mouse-events-have-key-events
            onMouseOver: onMouseOver,
            onMouseLeave: onMouseLeave,
            onClick: onClick,
            ref: ref,
            ...$e04a85286cafdcfd$var$selector
        }, children));
};
const $e04a85286cafdcfd$var$LeftSidebarOuter = /*#__PURE__*/ (0, $5uXOq.forwardRef)($e04a85286cafdcfd$var$LeftSidebarOuterComponent);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$e04a85286cafdcfd$export$2e2bcd8739ae039 = $e04a85286cafdcfd$var$LeftSidebarOuter;

});

parcelRegister("jHPcL", function(module, exports) {

$parcel$export(module.exports, "default", () => $69d2ff1d20857e8f$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $eXGNC = parcelRequire("eXGNC");


var $gA3Ny = parcelRequire("gA3Ny");
function $69d2ff1d20857e8f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $69d2ff1d20857e8f$var$prefersReducedMotionStyles = /*#__PURE__*/ (0, $f8Sb3.css)((0, $eXGNC.prefersReducedMotion)());
/**
 * The transition duration is intentionally set to 0ms.
 *
 * A transition is being used here to delay the setting of
 * opacity and visibility so that it syncs collapsing sidebar.
 */ const $69d2ff1d20857e8f$var$hideLeftSidebarContentsStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    opacity: 0,
    transition: 'opacity 0ms linear, visibility 0ms linear',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transitionDelay: `${(0, $62b79b702763d93f$export$3749e1104328fde4) - 100}ms`,
    visibility: 'hidden'
});
const $69d2ff1d20857e8f$var$resizableChildrenWrapperStyles = {
    name: "xz78rr",
    styles: "height:100%;opacity:1;overflow:hidden auto;transition:none;visibility:visible"
};
const $69d2ff1d20857e8f$var$fixedChildrenWrapperStyles = {
    name: "ax3w45",
    styles: "min-width:240px;height:100%"
};
const $69d2ff1d20857e8f$var$ResizableChildrenWrapper = ({ children: children, isLeftSidebarCollapsed: isLeftSidebarCollapsed = false, hasCollapsedState: hasCollapsedState = false, isFlyoutOpen: isFlyoutOpen = false, testId: testId })=>{
    const isCollapsing = (0, $gA3Ny.default)();
    const isCollapsed = isLeftSidebarCollapsed || hasCollapsedState;
    const isHidden = isCollapsing || isCollapsed && !isFlyoutOpen;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            $69d2ff1d20857e8f$var$resizableChildrenWrapperStyles,
            isHidden && $69d2ff1d20857e8f$var$hideLeftSidebarContentsStyles,
            $69d2ff1d20857e8f$var$prefersReducedMotionStyles
        ],
        "aria-hidden": isHidden,
        "data-testid": testId,
        tabIndex: isHidden ? -1 : 0
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $69d2ff1d20857e8f$var$fixedChildrenWrapperStyles
    }, children));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$69d2ff1d20857e8f$export$2e2bcd8739ae039 = $69d2ff1d20857e8f$var$ResizableChildrenWrapper;

});
parcelRegister("gA3Ny", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca627847b0f62221$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

const $ca627847b0f62221$var$getIsCollapsing = ()=>{
    // SSR bail-out because document is undefined on the server
    if (typeof document === 'undefined') return false;
    return document.documentElement.getAttribute((0, $62b79b702763d93f$export$5e5e1875c3fd8f4f)) === 'true';
};
const $ca627847b0f62221$var$useIsSidebarCollapsing = ()=>{
    const [isCollapsing, setIsCollapsing] = (0, $5uXOq.useState)($ca627847b0f62221$var$getIsCollapsing);
    (0, $5uXOq.useEffect)(()=>{
        const observer = new MutationObserver(()=>{
            setIsCollapsing($ca627847b0f62221$var$getIsCollapsing);
        });
        observer.observe(document.documentElement, {
            attributeFilter: [
                (0, $62b79b702763d93f$export$5e5e1875c3fd8f4f)
            ]
        });
        return ()=>{
            observer.disconnect();
        };
    }, []);
    return isCollapsing;
};
var $ca627847b0f62221$export$2e2bcd8739ae039 = $ca627847b0f62221$var$useIsSidebarCollapsing;

});



parcelRegister("by9S8", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f717ca202e191b4$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");


var $503JR = parcelRequire("503JR");

var $bjf1T = parcelRequire("bjf1T");
var $b6xD2 = parcelRequire("b6xD2");

var $e5XmT = parcelRequire("e5XmT");

var $9Q3Cp = parcelRequire("9Q3Cp");

var $gHNHO = parcelRequire("gHNHO");
/**
 * __Left sidebar without resize__
 *
 * Provides a slot for a left sidebar without resize within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $5f717ca202e191b4$var$LeftSidebarWithoutResize = (props)=>{
    const { children: children, id: id, width: width, isFixed: isFixed, shouldPersistWidth: shouldPersistWidth, testId: testId, skipLinkTitle: skipLinkTitle } = props;
    const leftSidebarWidth = (0, $503JR.resolveDimension)((0, $62b79b702763d93f$export$a30f2e00489a8957), width, shouldPersistWidth);
    (0, $5uXOq.useEffect)(()=>{
        (0, $bjf1T.default)({
            [(0, $62b79b702763d93f$export$a30f2e00489a8957)]: leftSidebarWidth
        });
        return ()=>{
            (0, $bjf1T.default)({
                [(0, $62b79b702763d93f$export$a30f2e00489a8957)]: 0
            });
        };
    }, [
        leftSidebarWidth
    ]);
    (0, $b6xD2.useSkipLink)(id, skipLinkTitle);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $9Q3Cp.default), {
        id: id,
        testId: testId,
        isFixed: isFixed
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $gHNHO.default), {
        variableName: (0, $62b79b702763d93f$export$a30f2e00489a8957),
        value: leftSidebarWidth
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $e5XmT.default), {
        isFixed: isFixed
    }, children));
};
var $5f717ca202e191b4$export$2e2bcd8739ae039 = $5f717ca202e191b4$var$LeftSidebarWithoutResize;

});

parcelRegister("7Stls", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d341b36e4c9bb73$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $eXGNC = parcelRequire("eXGNC");



var $lSXy9 = parcelRequire("lSXy9");

var $503JR = parcelRequire("503JR");

var $02o6B = parcelRequire("02o6B");
var $b6xD2 = parcelRequire("b6xD2");

var $2pQ0W = parcelRequire("2pQ0W");
function $7d341b36e4c9bb73$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $7d341b36e4c9bb73$var$prefersReducedMotionStyles = /*#__PURE__*/ (0, $f8Sb3.css)((0, $eXGNC.prefersReducedMotion)());
const $7d341b36e4c9bb73$var$mainStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    minWidth: 0,
    flexGrow: 1,
    marginInlineStart: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transition: `margin-left ${(0, $62b79b702763d93f$export$3749e1104328fde4)}ms ${(0, $99bc8d2d71e909fb$export$57636bb43b1ccbb0)} 0s`
});
const $7d341b36e4c9bb73$var$draggingStyles = {
    name: "1wx2bp",
    styles: "transition:none"
};
/**
 * Adds a negative left margin to main,
 * which transitions at the same speed as the left sidebar's width increase.
 * This give an illusion that the flyout is appearing on top of the main content,
 * while main remains in place.
 */ const $7d341b36e4c9bb73$var$flyoutStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginInlineStart: `calc(-1 * var(--${(0, $62b79b702763d93f$export$b6744d31294864fd)}, ${(0, $62b79b702763d93f$export$991d5285ad765a3d)}px) + ${(0, $62b79b702763d93f$export$46acf8758e9e2636)}px)`
});
/**
 * __Main__
 *
 * Provides a slot for main content within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $7d341b36e4c9bb73$var$Main = (props)=>{
    const { children: children, testId: testId, id: id, skipLinkTitle: skipLinkTitle } = props;
    (0, $b6xD2.useSkipLink)(id, skipLinkTitle);
    const isDragging = (0, $lSXy9.default)();
    const { leftSidebarState: { isFlyoutOpen: isFlyoutOpen, isFixed: isFixed } } = (0, $5uXOq.useContext)((0, $02o6B.SidebarResizeContext));
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $2pQ0W.default), null, ({ className: className })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("main", {
            "data-testid": testId,
            css: [
                $7d341b36e4c9bb73$var$mainStyles,
                isDragging && $7d341b36e4c9bb73$var$draggingStyles,
                isFlyoutOpen && !isFixed && $7d341b36e4c9bb73$var$flyoutStyles,
                $7d341b36e4c9bb73$var$prefersReducedMotionStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            id: id,
            ...(0, $503JR.getPageLayoutSlotSelector)('main')
        }, children));
};
var $7d341b36e4c9bb73$export$2e2bcd8739ae039 = $7d341b36e4c9bb73$var$Main;

});

parcelRegister("33D3Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $26570b005abc39d9$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $kU1q1 = parcelRequire("kU1q1");


var $E9Q3p = parcelRequire("E9Q3p");
var $cpV27 = parcelRequire("cpV27");

var $4Kl9h = parcelRequire("4Kl9h");
const $26570b005abc39d9$var$pageLayoutSelector = {
    [(0, $62b79b702763d93f$export$659ee746b31b360d)]: true
};
const $26570b005abc39d9$var$gridTemplateAreasMobile = `
${''}
  "${(0, $62b79b702763d93f$export$344062f7cfc9528e)} ${(0, $62b79b702763d93f$export$238d30785c4bca84)}"
  ${''}
  "${(0, $62b79b702763d93f$export$344062f7cfc9528e)} ${(0, $62b79b702763d93f$export$bec6dca2e63de4ae)}"
  ${''}
  "${(0, $62b79b702763d93f$export$344062f7cfc9528e)} ${(0, $62b79b702763d93f$export$d1213e82613ff4df)}"
 `;
const $26570b005abc39d9$var$gridTemplateAreas = `
${''}
  "${(0, $62b79b702763d93f$export$344062f7cfc9528e)} ${(0, $62b79b702763d93f$export$238d30785c4bca84)} ${(0, $62b79b702763d93f$export$c7139cc2d6110b5f)}"
  ${''}
  "${(0, $62b79b702763d93f$export$344062f7cfc9528e)} ${(0, $62b79b702763d93f$export$bec6dca2e63de4ae)} ${(0, $62b79b702763d93f$export$c7139cc2d6110b5f)}"
${''}
  "${(0, $62b79b702763d93f$export$344062f7cfc9528e)} ${(0, $62b79b702763d93f$export$d1213e82613ff4df)} ${(0, $62b79b702763d93f$export$c7139cc2d6110b5f)}"
 `;
const $26570b005abc39d9$var$gridStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'grid',
    height: '100%',
    gridTemplateAreas: $26570b005abc39d9$var$gridTemplateAreas,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridTemplateColumns: `${(0, $62b79b702763d93f$export$f963aecf2d4465bd)} minmax(0, 1fr) ${(0, $62b79b702763d93f$export$750459958906793)}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridTemplateRows: `${(0, $62b79b702763d93f$export$ed7cc0d417ee89e)} ${(0, $62b79b702763d93f$export$aeff86a16f13529)} auto`,
    outline: 'none'
});
const $26570b005abc39d9$var$gridStylesMobileStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [(0, $kU1q1.UNSAFE_media).below.sm]: {
        gridTemplateAreas: $26570b005abc39d9$var$gridTemplateAreasMobile,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        gridTemplateColumns: `${(0, $62b79b702763d93f$export$f963aecf2d4465bd)} minmax(0, 1fr)`
    }
});
/**
 * __Page layout__
 *
 * A collection of components which let you compose an application's page layout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $26570b005abc39d9$var$PageLayout = ({ skipLinksLabel: skipLinksLabel = (0, $62b79b702763d93f$export$206a08f7f8beb554), children: children, testId: testId, onLeftSidebarExpand: onLeftSidebarExpand, onLeftSidebarCollapse: onLeftSidebarCollapse })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $cpV27.SkipLinksController), null, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $4Kl9h.SkipLinkWrapper), {
        skipLinksLabel: skipLinksLabel
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...$26570b005abc39d9$var$pageLayoutSelector,
        "data-testid": testId,
        css: [
            $26570b005abc39d9$var$gridStyles,
            $26570b005abc39d9$var$gridStylesMobileStyles
        ],
        tabIndex: -1,
        "data-vc": "page-layout"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $E9Q3p.SidebarResizeController), {
        onLeftSidebarCollapse: onLeftSidebarCollapse,
        onLeftSidebarExpand: onLeftSidebarExpand
    }, children))));
};
var $26570b005abc39d9$export$2e2bcd8739ae039 = $26570b005abc39d9$var$PageLayout;

});
parcelRegister("E9Q3p", function(module, exports) {

$parcel$export(module.exports, "SidebarResizeController", () => $ad9262f42778eb73$export$850bd1bba41f1448);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");

var $bKnKN = parcelRequire("bKnKN");

var $eXGNC = parcelRequire("eXGNC");

var $gZkTp = parcelRequire("gZkTp");


var $503JR = parcelRequire("503JR");

var $02o6B = parcelRequire("02o6B");
const $ad9262f42778eb73$var$handleDataAttributesAndCb = (callback = (0, $bKnKN.default), leftSidebarState)=>{
    document.documentElement.removeAttribute((0, $62b79b702763d93f$export$5e5e1875c3fd8f4f));
    callback(leftSidebarState);
};
const $ad9262f42778eb73$var$leftSidebarSelector = (0, $503JR.getPageLayoutSlotCSSSelector)('left-sidebar');
const $ad9262f42778eb73$export$850bd1bba41f1448 = ({ children: children, onLeftSidebarExpand: onExpand, onLeftSidebarCollapse: onCollapse })=>{
    const [leftSidebarState, setLeftSidebarState] = (0, $5uXOq.useState)({
        isFlyoutOpen: false,
        isResizing: false,
        isLeftSidebarCollapsed: false,
        leftSidebarWidth: 0,
        lastLeftSidebarWidth: 0,
        flyoutLockCount: 0,
        isFixed: true,
        hasInit: false
    });
    const { leftSidebarWidth: leftSidebarWidth, lastLeftSidebarWidth: lastLeftSidebarWidth, isResizing: isResizing, flyoutLockCount: flyoutLockCount, isFixed: isFixed, isLeftSidebarCollapsed: isLeftSidebarCollapsed, isFlyoutOpen: isFlyoutOpen, hasInit: hasInit } = leftSidebarState;
    // We put the latest callbacks into a ref so we can always have the latest
    // functions in our transitionend listeners
    const stableRef = (0, $5uXOq.useRef)({
        onExpand: onExpand,
        onCollapse: onCollapse
    });
    (0, $5uXOq.useEffect)(()=>{
        stableRef.current = {
            onExpand: onExpand,
            onCollapse: onCollapse
        };
    }, [
        onExpand,
        onCollapse
    ]);
    const transition = (0, $5uXOq.useRef)(null);
    const mobileMediaQuery = (0, $gZkTp.UNSAFE_useMediaQuery)('below.sm');
    const isOpen = mobileMediaQuery?.matches ? isFlyoutOpen : !isLeftSidebarCollapsed;
    const expandLeftSidebar = (0, $5uXOq.useCallback)(()=>{
        if (isOpen) return;
        // If the user is at a mobile viewport when this runs, we handle it differently
        // We don't expand at mobile widths; instead we use a flyout which is treated the same otherwise
        if (mobileMediaQuery?.matches) {
            const flyoutOpenSidebarState = {
                isResizing: false,
                isLeftSidebarCollapsed: true,
                leftSidebarWidth: (0, $62b79b702763d93f$export$46acf8758e9e2636),
                lastLeftSidebarWidth: leftSidebarWidth,
                isFlyoutOpen: true,
                flyoutLockCount: 0,
                isFixed: isFixed,
                hasInit: hasInit
            };
            setLeftSidebarState(flyoutOpenSidebarState);
            // Flush the desktop transitions, cleanup, and call the `onExpand` still
            transition.current?.complete();
            $ad9262f42778eb73$var$handleDataAttributesAndCb(stableRef.current.onExpand, flyoutOpenSidebarState);
            return;
        }
        if (isResizing || !isLeftSidebarCollapsed || // already expanding
        transition.current?.action === 'expand') return;
        // flush existing transition
        transition.current?.complete();
        const width = Math.max(lastLeftSidebarWidth, (0, $62b79b702763d93f$export$539e68c09584883a));
        const updatedLeftSidebarState = {
            isLeftSidebarCollapsed: false,
            isFlyoutOpen: false,
            leftSidebarWidth: width,
            lastLeftSidebarWidth: lastLeftSidebarWidth,
            isResizing: isResizing,
            flyoutLockCount: flyoutLockCount,
            isFixed: isFixed,
            hasInit: hasInit
        };
        setLeftSidebarState(updatedLeftSidebarState);
        function finish() {
            $ad9262f42778eb73$var$handleDataAttributesAndCb(stableRef.current.onExpand, updatedLeftSidebarState);
        }
        const sidebar = document.querySelector($ad9262f42778eb73$var$leftSidebarSelector);
        // onTransitionEnd isn't triggered when a user prefers reduced motion
        if ((0, $eXGNC.isReducedMotion)() || !sidebar) {
            finish();
            return;
        }
        const unbindEvent = (0, $cBeZP.bind)(sidebar, {
            type: 'transitionend',
            listener (event) {
                if (event.target === sidebar && event.propertyName === 'width') transition.current?.complete();
            }
        });
        const value = {
            action: 'expand',
            complete: ()=>{
                value.abort();
                finish();
            },
            abort: ()=>{
                unbindEvent();
                transition.current = null;
            }
        };
        transition.current = value;
    }, [
        isOpen,
        mobileMediaQuery,
        isResizing,
        isLeftSidebarCollapsed,
        lastLeftSidebarWidth,
        flyoutLockCount,
        isFixed,
        leftSidebarWidth,
        hasInit
    ]);
    const collapseLeftSidebar = (0, $5uXOq.useCallback)((event, collapseWithoutTransition)=>{
        if (!isOpen) return;
        // If the user is at a mobile viewport when this runs, we handle it differently
        // We don't collapse at mobile widths; instead we close the flyout.
        if (mobileMediaQuery?.matches) {
            const flyoutCloseSidebarState = {
                isResizing: false,
                isLeftSidebarCollapsed: true,
                leftSidebarWidth: (0, $62b79b702763d93f$export$46acf8758e9e2636),
                lastLeftSidebarWidth: lastLeftSidebarWidth,
                isFlyoutOpen: false,
                flyoutLockCount: 0,
                isFixed: isFixed,
                hasInit: hasInit
            };
            setLeftSidebarState(flyoutCloseSidebarState);
            // Flush the desktop transitions, cleanup, and call the `onCollapse` still
            transition.current?.complete();
            $ad9262f42778eb73$var$handleDataAttributesAndCb(stableRef.current.onCollapse, flyoutCloseSidebarState);
            return;
        }
        if (isResizing || isLeftSidebarCollapsed || // already collapsing
        transition.current?.action === 'collapse') return;
        // flush existing transition
        transition.current?.complete();
        // data-attribute is used as a CSS selector to sync the hiding/showing
        // of the nav contents with expand/collapse animation
        document.documentElement.setAttribute((0, $62b79b702763d93f$export$5e5e1875c3fd8f4f), 'true');
        const updatedLeftSidebarState = {
            isLeftSidebarCollapsed: true,
            isFlyoutOpen: false,
            leftSidebarWidth: (0, $62b79b702763d93f$export$46acf8758e9e2636),
            lastLeftSidebarWidth: leftSidebarWidth,
            isResizing: isResizing,
            flyoutLockCount: flyoutLockCount,
            isFixed: isFixed,
            hasInit: hasInit
        };
        setLeftSidebarState(updatedLeftSidebarState);
        function finish() {
            $ad9262f42778eb73$var$handleDataAttributesAndCb(stableRef.current.onCollapse, updatedLeftSidebarState);
        }
        const sidebar = document.querySelector($ad9262f42778eb73$var$leftSidebarSelector);
        // onTransitionEnd isn't triggered when a user prefers reduced motion
        if (collapseWithoutTransition || (0, $eXGNC.isReducedMotion)() || !sidebar) {
            finish();
            return;
        }
        const unbindEvent = (0, $cBeZP.bind)(sidebar, {
            type: 'transitionend',
            listener (event) {
                if (sidebar === event.target && event.propertyName === 'width') transition.current?.complete();
            }
        });
        const value = {
            action: 'collapse',
            complete: ()=>{
                value.abort();
                finish();
            },
            abort: ()=>{
                unbindEvent();
                transition.current = null;
            }
        };
        transition.current = value;
    }, [
        isOpen,
        mobileMediaQuery,
        isResizing,
        isLeftSidebarCollapsed,
        leftSidebarWidth,
        flyoutLockCount,
        isFixed,
        lastLeftSidebarWidth,
        hasInit
    ]);
    /**
	 * Conditionally toggle the expanding or collapsing the sidebars.
	 * This supports our mobile flyout mode as well.
	 */ const toggleLeftSidebar = (0, $5uXOq.useCallback)((event, collapseWithoutTransition)=>{
        if (isOpen) collapseLeftSidebar(event, collapseWithoutTransition);
        else expandLeftSidebar();
    }, [
        isOpen,
        expandLeftSidebar,
        collapseLeftSidebar
    ]);
    // Make sure we finish any lingering transitions when unmounting
    (0, $5uXOq.useEffect)(function mount() {
        return function unmount() {
            transition.current?.abort();
        };
    }, []);
    const context = (0, $5uXOq.useMemo)(()=>({
            isLeftSidebarCollapsed: !isOpen,
            expandLeftSidebar: expandLeftSidebar,
            collapseLeftSidebar: collapseLeftSidebar,
            leftSidebarState: leftSidebarState,
            setLeftSidebarState: setLeftSidebarState,
            toggleLeftSidebar: toggleLeftSidebar
        }), [
        isOpen,
        expandLeftSidebar,
        collapseLeftSidebar,
        leftSidebarState,
        toggleLeftSidebar
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $02o6B.SidebarResizeContext).Provider, {
        value: context,
        children: children
    });
};

});

parcelRegister("cpV27", function(module, exports) {

$parcel$export(module.exports, "SkipLinksController", () => $3996a5d05ee2ff9c$export$da7be99d6a868f3d);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");


var $b6xD2 = parcelRequire("b6xD2");
const $3996a5d05ee2ff9c$var$byDOMOrder = (a, b)=>{
    const elems = Array.from(document.querySelectorAll(`[${(0, $62b79b702763d93f$export$5253dd9707b8c3ba)}]`));
    const elemA = document.getElementById(a.id);
    const elemB = document.getElementById(b.id);
    const indexA = a.listIndex ?? elems.indexOf(elemA);
    const indexB = b.listIndex ?? elems.indexOf(elemB);
    /**
	 * If they are tied it is because one (or both) is
	 * a custom skiplink with a set index.
	 *
	 * Give the custom skiplink priority.
	 */ if (indexA === indexB) {
        if (a.listIndex !== undefined) return -1;
        else return 1;
    }
    return indexA - indexB;
};
const $3996a5d05ee2ff9c$export$da7be99d6a868f3d = ({ children: children })=>{
    const [links, setLinks] = (0, $5uXOq.useState)([]);
    const registerSkipLink = (0, $5uXOq.useRef)((skipLinkData)=>{
        // Don't add duplicate SkipLinks
        setLinks((oldLinks)=>{
            if (oldLinks.some(({ id: id })=>id === skipLinkData.id)) return oldLinks;
            return [
                ...oldLinks,
                skipLinkData
            ].sort($3996a5d05ee2ff9c$var$byDOMOrder);
        });
    });
    const unregisterSkipLink = (0, $5uXOq.useRef)((id)=>{
        setLinks((links)=>links.filter((link)=>link.id !== id));
    });
    const context = {
        registerSkipLink: registerSkipLink.current,
        skipLinksData: links,
        unregisterSkipLink: unregisterSkipLink.current
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $b6xD2.SkipLinksContext).Provider, {
        value: context,
        children: children
    });
};

});

parcelRegister("4Kl9h", function(module, exports) {

$parcel$export(module.exports, "SkipLinkWrapper", () => $738fef3444d091db$export$4241a460557ba901);
/* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners */ /**
                                                                          * @jsxRuntime classic
                                                                          * @jsx jsx
                                                                          */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $8zIDr = parcelRequire("8zIDr");

var $eXGNC = parcelRequire("eXGNC");



var $b6xD2 = parcelRequire("b6xD2");
function $738fef3444d091db$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $738fef3444d091db$var$prefersReducedMotionStyles = /*#__PURE__*/ (0, $f8Sb3.css)((0, $eXGNC.prefersReducedMotion)());
const $738fef3444d091db$var$skipLinkStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    margin: "var(--ds-space-250, 10px)",
    padding: '0.8rem 1rem',
    position: 'fixed',
    zIndex: -1,
    background: "var(--ds-surface-overlay, white)",
    border: 'none',
    borderRadius: "var(--ds-border-radius, 3px)",
    boxShadow: `var(--ds-shadow-overlay, ${`0 0 0 1px ${(0, $a7f8c6b391092279$export$920c0d5c49070351)}, 0 2px 10px ${(0, $a7f8c6b391092279$export$920c0d5c49070351)}, 0 0 20px -4px ${(0, $a7f8c6b391092279$export$d2d3bedfb276cac0)}`})`,
    insetInlineStart: -999999,
    opacity: 0,
    transform: 'translateY(-50%)',
    transition: `transform 0.3s ${(0, $99bc8d2d71e909fb$export$57636bb43b1ccbb0)}`,
    '&:focus-within': {
        zIndex: 2147483640,
        insetInlineStart: 0,
        opacity: 1,
        transform: 'translateY(0%)'
    }
});
const $738fef3444d091db$var$skipLinkHeadingStyles = {
    name: "1blmyc0",
    styles: "font-weight:var(--ds-font-weight-semibold, 600)"
};
const $738fef3444d091db$var$skipLinkListStyles = {
    name: "1xay72g",
    styles: "list-style-position:outside;list-style-type:none;margin-block-start:var(--ds-space-050, 4px);padding-inline-start:0"
};
const $738fef3444d091db$var$skipLinkListItemStyles = {
    name: "19m435s",
    styles: "margin-block-start:0"
};
const $738fef3444d091db$var$assignIndex = (num, arr)=>{
    if (!arr.includes(num)) return num;
    return $738fef3444d091db$var$assignIndex(num + 1, arr);
};
const $738fef3444d091db$export$4241a460557ba901 = ({ skipLinksLabel: skipLinksLabel })=>{
    const { skipLinksData: skipLinksData } = (0, $b6xD2.useSkipLinks)();
    if (skipLinksData.length === 0) return null;
    const sortSkipLinks = (arr)=>{
        const customLinks = arr.filter((link)=>Number.isInteger(link.listIndex));
        if (customLinks.length === 0) return arr;
        const usedIndexes = customLinks.map((a)=>a.listIndex);
        const regularLinksWithIdx = arr.filter((link)=>link.listIndex === undefined).map((link, idx, currArr)=>{
            const listIndex = $738fef3444d091db$var$assignIndex(idx, usedIndexes);
            usedIndexes.push(listIndex);
            return {
                ...link,
                listIndex: listIndex
            };
        });
        return [
            ...customLinks,
            ...regularLinksWithIdx
        ].sort((a, b)=>a.listIndex - b.listIndex);
    };
    const escapeHandler = (event)=>{
        if (event.keyCode === 27) {
            const container = document.querySelector(`[${(0, $62b79b702763d93f$export$659ee746b31b360d)}="true"]`);
            if (container !== null) container.focus();
        }
    };
    const attachEscHandler = ()=>window.addEventListener('keydown', escapeHandler, false);
    const removeEscHandler = ()=>window.removeEventListener('keydown', escapeHandler, false);
    const emptyLabelOverride = !!skipLinksLabel?.match(/^\s+$/);
    const label = skipLinksLabel || (0, $62b79b702763d93f$export$206a08f7f8beb554);
    return(// eslint-disable-next-line jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        onFocus: attachEscHandler,
        onBlur: removeEscHandler,
        css: [
            $738fef3444d091db$var$skipLinkStyles,
            $738fef3444d091db$var$prefersReducedMotionStyles
        ],
        "data-skip-link-wrapper": true
    }, emptyLabelOverride ? null : /*#__PURE__*/ (0, $f8Sb3.jsx)("p", {
        css: $738fef3444d091db$var$skipLinkHeadingStyles
    }, label), /*#__PURE__*/ (0, $f8Sb3.jsx)("ol", {
        css: $738fef3444d091db$var$skipLinkListStyles
    }, sortSkipLinks(skipLinksData).map(({ id: id, skipLinkTitle: skipLinkTitle })=>/*#__PURE__*/ (0, $f8Sb3.jsx)($738fef3444d091db$export$ef95c37428582a65, {
            key: id,
            href: `#${id}`,
            isFocusable: true
        }, skipLinkTitle)))));
};
const $738fef3444d091db$var$handleBlur = (event)=>{
    // @ts-ignore
    event.target.removeAttribute('tabindex');
    // @ts-ignore
    event.target.removeEventListener('blur', $738fef3444d091db$var$handleBlur);
};
const $738fef3444d091db$var$focusTargetRef = (href)=>(event)=>{
        event.preventDefault();
        const targetRef = document.querySelector(href);
        // @ts-ignore
        const key = event.which || event.keycode;
        // if it is a keypress and the key is not
        // space or enter, just ignore it.
        if (key && key !== 13 && key !== 32) return;
        if (targetRef) {
            targetRef.setAttribute('tabindex', '-1');
            // @ts-ignore
            targetRef.addEventListener('blur', $738fef3444d091db$var$handleBlur);
            // @ts-ignore
            targetRef.focus();
            document.activeElement && document.activeElement.scrollIntoView({
                behavior: 'smooth'
            });
            window.scrollTo(0, 0);
        }
        return false;
    };
const $738fef3444d091db$export$ef95c37428582a65 = ({ href: href, children: children, isFocusable: isFocusable })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("li", {
        css: $738fef3444d091db$var$skipLinkListItemStyles
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $8zIDr.default), {
        tabIndex: isFocusable ? 0 : -1,
        href: href,
        onClick: $738fef3444d091db$var$focusTargetRef(href)
    }, children));
};

});


parcelRegister("jreT6", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ad47c2bab231ef3$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");


var $503JR = parcelRequire("503JR");

var $bjf1T = parcelRequire("bjf1T");
var $b6xD2 = parcelRequire("b6xD2");

var $2pQ0W = parcelRequire("2pQ0W");

var $gHNHO = parcelRequire("gHNHO");
const $7ad47c2bab231ef3$var$baseStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridArea: (0, $62b79b702763d93f$export$c7139cc2d6110b5f)
});
const $7ad47c2bab231ef3$var$fixedStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $62b79b702763d93f$export$750459958906793),
    position: 'fixed',
    insetBlockEnd: 0,
    insetBlockStart: 0,
    insetInlineEnd: 0
});
/**
 * __Right panel__
 *
 * Provides a slot for a right panel within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $7ad47c2bab231ef3$var$RightPanel = (props)=>{
    const { children: children, isFixed: isFixed, width: width = (0, $62b79b702763d93f$export$c3e41153b9288bcf), shouldPersistWidth: shouldPersistWidth, testId: testId, id: id, skipLinkTitle: skipLinkTitle } = props;
    const rightPanelWidth = (0, $503JR.resolveDimension)((0, $62b79b702763d93f$export$fa34f417972d6341), width, shouldPersistWidth);
    (0, $5uXOq.useEffect)(()=>{
        (0, $bjf1T.default)({
            [(0, $62b79b702763d93f$export$fa34f417972d6341)]: rightPanelWidth
        });
        return ()=>{
            (0, $bjf1T.default)({
                [(0, $62b79b702763d93f$export$fa34f417972d6341)]: 0
            });
        };
    }, [
        rightPanelWidth
    ]);
    (0, $b6xD2.useSkipLink)(id, skipLinkTitle);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $2pQ0W.default), null, ({ className: className })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: [
                $7ad47c2bab231ef3$var$baseStyles,
                isFixed && $7ad47c2bab231ef3$var$fixedStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            "data-testid": testId,
            id: id,
            ...(0, $503JR.getPageLayoutSlotSelector)('right-panel')
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $gHNHO.default), {
            variableName: (0, $62b79b702763d93f$export$fa34f417972d6341),
            value: rightPanelWidth
        }), children));
};
var $7ad47c2bab231ef3$export$2e2bcd8739ae039 = $7ad47c2bab231ef3$var$RightPanel;

});

parcelRegister("3IHID", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc6ca7291de11945$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");


var $503JR = parcelRequire("503JR");

var $bjf1T = parcelRequire("bjf1T");
var $b6xD2 = parcelRequire("b6xD2");

var $2pQ0W = parcelRequire("2pQ0W");

var $gHNHO = parcelRequire("gHNHO");
function $cc6ca7291de11945$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/**
 * This inner wrapper is required to allow the sidebar to be `position: fixed`.
 *
 * If we were to apply `position: fixed` to the outer wrapper, it will be popped
 * out of its flex container and Main would stretch to occupy all the space.
 */ const $cc6ca7291de11945$var$fixedInnerStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $62b79b702763d93f$export$b44ab66843c05a69),
    position: 'fixed',
    insetBlockEnd: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetBlockStart: `calc(${(0, $62b79b702763d93f$export$ed7cc0d417ee89e)} + ${(0, $62b79b702763d93f$export$aeff86a16f13529)})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetInlineEnd: `calc(${(0, $62b79b702763d93f$export$750459958906793)})`
});
const $cc6ca7291de11945$var$staticInnerStyles = {
    name: "13udsys",
    styles: "height:100%"
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $cc6ca7291de11945$var$outerStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    width: (0, $62b79b702763d93f$export$b44ab66843c05a69)
});
/**
 * In fixed mode this element's child is taken out of the document flow.
 * It doesn't take up the width as expected,
 * so the pseudo element forces it to take up the necessary width.
 */ const $cc6ca7291de11945$var$fixedOuterStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    '&::after': {
        display: 'inline-block',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: (0, $62b79b702763d93f$export$b44ab66843c05a69),
        content: "''"
    }
});
/**
 * __Right sidebar__
 *
 * Provides a slot for a right sidebar within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $cc6ca7291de11945$var$RightSidebar = (props)=>{
    const { children: children, width: width = (0, $62b79b702763d93f$export$b92df8810d2fcd01), isFixed: isFixed, shouldPersistWidth: shouldPersistWidth, testId: testId, id: id, skipLinkTitle: skipLinkTitle } = props;
    const rightSidebarWidth = (0, $503JR.resolveDimension)((0, $62b79b702763d93f$export$c103b605cd368aed), width, shouldPersistWidth);
    (0, $5uXOq.useEffect)(()=>{
        (0, $bjf1T.default)({
            [(0, $62b79b702763d93f$export$c103b605cd368aed)]: rightSidebarWidth
        });
        return ()=>{
            (0, $bjf1T.default)({
                [(0, $62b79b702763d93f$export$c103b605cd368aed)]: 0
            });
        };
    }, [
        rightSidebarWidth,
        id
    ]);
    (0, $b6xD2.useSkipLink)(id, skipLinkTitle);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $2pQ0W.default), {
        isSidebar: true
    }, ({ className: className })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            "data-testid": testId,
            css: [
                $cc6ca7291de11945$var$outerStyles,
                isFixed && $cc6ca7291de11945$var$fixedOuterStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            id: id,
            ...(0, $503JR.getPageLayoutSlotSelector)('right-sidebar')
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $gHNHO.default), {
            variableName: (0, $62b79b702763d93f$export$c103b605cd368aed),
            value: rightSidebarWidth
        }), /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: [
                isFixed && $cc6ca7291de11945$var$fixedInnerStyles,
                !isFixed && $cc6ca7291de11945$var$staticInnerStyles
            ]
        }, children)));
};
var $cc6ca7291de11945$export$2e2bcd8739ae039 = $cc6ca7291de11945$var$RightSidebar;

});

parcelRegister("7EYXE", function(module, exports) {

$parcel$export(module.exports, "default", () => $7901b50334f68bb2$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");


var $503JR = parcelRequire("503JR");

var $bjf1T = parcelRequire("bjf1T");
var $b6xD2 = parcelRequire("b6xD2");

var $2pQ0W = parcelRequire("2pQ0W");

var $gHNHO = parcelRequire("gHNHO");
const $7901b50334f68bb2$var$topNavigationStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: (0, $62b79b702763d93f$export$aeff86a16f13529),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridArea: (0, $62b79b702763d93f$export$bec6dca2e63de4ae)
});
const $7901b50334f68bb2$var$fixedStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    position: 'fixed',
    zIndex: 2,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetBlockStart: (0, $62b79b702763d93f$export$ed7cc0d417ee89e),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetInlineEnd: (0, $62b79b702763d93f$export$750459958906793),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetInlineStart: (0, $62b79b702763d93f$export$f963aecf2d4465bd)
});
/**
 * __Top navigation__
 *
 * Provides a slot for top navigation within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $7901b50334f68bb2$var$TopNavigation = (props)=>{
    const { children: children, height: height = (0, $62b79b702763d93f$export$4a98ee0bd1ae362), isFixed: isFixed = true, shouldPersistHeight: shouldPersistHeight, testId: testId, id: id, skipLinkTitle: skipLinkTitle } = props;
    const topNavigationHeight = (0, $503JR.resolveDimension)((0, $62b79b702763d93f$export$3a6a779d9181047c), height, shouldPersistHeight);
    (0, $5uXOq.useEffect)(()=>{
        (0, $bjf1T.default)({
            [(0, $62b79b702763d93f$export$3a6a779d9181047c)]: topNavigationHeight
        });
        return ()=>{
            (0, $bjf1T.default)({
                [(0, $62b79b702763d93f$export$3a6a779d9181047c)]: 0
            });
        };
    }, [
        topNavigationHeight
    ]);
    (0, $b6xD2.useSkipLink)(id, skipLinkTitle);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $2pQ0W.default), null, ({ className: className })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: [
                $7901b50334f68bb2$var$topNavigationStyles,
                isFixed && $7901b50334f68bb2$var$fixedStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            "data-testid": testId,
            id: id,
            ...(0, $503JR.getPageLayoutSlotSelector)('top-navigation')
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $gHNHO.default), {
            variableName: (0, $62b79b702763d93f$export$3a6a779d9181047c),
            value: topNavigationHeight
        }), children));
};
var $7901b50334f68bb2$export$2e2bcd8739ae039 = $7901b50334f68bb2$var$TopNavigation;

});

parcelRegister("3fzVB", function(module, exports) {

$parcel$export(module.exports, "useCustomSkipLink", () => $e58d5adbed39f94c$export$ee6b12c2613bdf8e);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $b6xD2 = parcelRequire("b6xD2");
const $e58d5adbed39f94c$export$ee6b12c2613bdf8e = (id, skipLinkTitle, listIndex = 0)=>{
    const { registerSkipLink: registerSkipLink, unregisterSkipLink: unregisterSkipLink } = (0, $b6xD2.useSkipLinks)();
    (0, $5uXOq.useEffect)(()=>{
        registerSkipLink({
            id: id,
            skipLinkTitle: skipLinkTitle,
            listIndex: listIndex
        });
        return ()=>{
            unregisterSkipLink(id);
        };
    }, [
        id,
        listIndex,
        skipLinkTitle,
        registerSkipLink,
        unregisterSkipLink
    ]);
};

});

parcelRegister("geqKu", function(module, exports) {

$parcel$export(module.exports, "Aside", () => $bd1f69e1ec0e88d8$export$ac3bdfe4cb17f64e);
/* aside.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $jOvxk = parcelRequire("jOvxk");

var $fHpHg = parcelRequire("fHpHg");

var $kU1q1 = parcelRequire("kU1q1");

var $6bvKu = parcelRequire("6bvKu");

var $aKoCG = parcelRequire("aKoCG");

var $4q7g7 = parcelRequire("4q7g7");

var $9qobs = parcelRequire("9qobs");

var $7KMzu = parcelRequire("7KMzu");

var $w2vcN = parcelRequire("w2vcN");
const $bd1f69e1ec0e88d8$var$panelSplitterResizingVar = '--n_asdRsz';
/**
 * The bounds for Aside and Panel are purposely set to support the current usage in Jira.
 *
 * Jira sets the slot's width to `0px` when there is no active content to display in it.
 *   - This means the min width needs to support `0px`.
 * The Conversation Assistant component in Jira (rendered in a nav3 RightSidebar, or a nav4 Aside) has a custom resizing
 * implementation, which has a maximum width of `50vw`.
 *   - This means the max width needs to support `50vw`.
 *
 * This is not the final implementation and will be updated once Jira's usage has been fixed.
 * Ticket to track this is: https://jplat.atlassian.net/browse/BLU-3951
 *
 * We're using two different bounds for each slot here, to support the `0px` min width when programatically set using the
 * `defaultWidth` prop, and another one that is used when resizing the slots which has a sensible min width.
 */ const $bd1f69e1ec0e88d8$var$asideWidthSlotBounds = {
    min: '0px',
    max: '50vw'
};
const $bd1f69e1ec0e88d8$var$asideWidthResizeBounds = {
    min: '120px',
    max: '50vw'
};
function $bd1f69e1ec0e88d8$var$getResizeBounds() {
    return $bd1f69e1ec0e88d8$var$asideWidthResizeBounds;
}
const $bd1f69e1ec0e88d8$var$styles = {
    root: "_nd5lns35 _vchhusvi _kqswh2mm _glte1kzp _ndwch9n0",
    fixedContentArea: "_1reo1wug _18m91wug _152t1l7u _165t1run _13wn1if8",
    fullHeight: "_4t3i1osq"
};
function $bd1f69e1ec0e88d8$export$ac3bdfe4cb17f64e({ children: children, xcss: xcss, isFixed: isFixed, defaultWidth: defaultWidth = 330, label: label = 'Aside', skipLinkLabel: skipLinkLabel = label, testId: testId, id: providedId }) {
    const dangerouslyHoistSlotSizes = (0, $5uXOq.useContext)((0, $4q7g7.DangerouslyHoistSlotSizes));
    const id = (0, $7KMzu.useLayoutId)({
        providedId: providedId
    });
    /**
   * Don't show the skip link if the slot has 0 width.
   *
   * Remove `isHidden` usage after https://jplat.atlassian.net/browse/BLU-3951
   */ (0, $6bvKu.useSkipLinkInternal)({
        id: id,
        label: skipLinkLabel,
        isHidden: defaultWidth === 0 && (0, $fHpHg.fg)('platform_design_system_nav4_hide_empty_skip_links')
    });
    const ref = (0, $5uXOq.useRef)(null);
    const [width, setWidth] = (0, $5uXOq.useState)(defaultWidth);
    // Used to track the previous value of the `defaultWidth` prop, for logging dev warnings when it changes.
    const previousWidthProp = (0, $jOvxk.default)(defaultWidth);
    /**
   * Updates the width state based on changes to `defaultWidth`.
   * This is temporary and needed to support the current usage in Jira, and will be removed once it is no longer needed.
   * https://jplat.atlassian.net/browse/BLU-3951
   */ (0, $5uXOq.useEffect)(()=>{
        setWidth(defaultWidth);
    }, [
        defaultWidth
    ]);
    // Putting the warning in a separate effect to avoid adding `previousWidthProp` as an effect dependency when updating width.
    (0, $5uXOq.useEffect)(()=>{}, [
        defaultWidth,
        previousWidthProp
    ]);
    const asideVariableWidth = `clamp(${$bd1f69e1ec0e88d8$var$asideWidthSlotBounds.min}, ${width}px, ${$bd1f69e1ec0e88d8$var$asideWidthSlotBounds.max})`;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("aside", {
        id: id,
        "data-layout-slot": true,
        "aria-label": label,
        className: (0, $bwpsq.default)([
            $bd1f69e1ec0e88d8$var$styles.root,
            xcss
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values
        style: {
            [(0, $aKoCG.asideVar)]: asideVariableWidth
        },
        "data-testid": testId,
        ref: ref,
        children: [
            dangerouslyHoistSlotSizes && // ------ START UNSAFE STYLES ------
            // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
            // When they aren't needed anymore we can delete them wholesale.
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9qobs.DangerouslyHoistCssVarToDocumentRoot), {
                variableName: (0, $aKoCG.UNSAFE_asideLayoutVar),
                value: "0px",
                mediaQuery: (0, $kU1q1.media).above.md,
                responsiveValue: asideVariableWidth
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $w2vcN.PanelSplitterProvider), {
                panelRef: ref,
                panelWidth: width,
                onCompleteResize: setWidth,
                getResizeBounds: $bd1f69e1ec0e88d8$var$getResizeBounds,
                resizingCssVar: $bd1f69e1ec0e88d8$var$panelSplitterResizingVar,
                position: "start",
                children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    className: (0, $bwpsq.default)([
                        $bd1f69e1ec0e88d8$var$styles.fullHeight,
                        isFixed && $bd1f69e1ec0e88d8$var$styles.fixedContentArea
                    ]),
                    children: children
                })
            })
        ]
    });
}

});
parcelRegister("6bvKu", function(module, exports) {

$parcel$export(module.exports, "SkipLinksContext", () => $da79d52672c93574$export$4c5cc3b14c7678a);
$parcel$export(module.exports, "useSkipLinkInternal", () => $da79d52672c93574$export$707b94c26b8b75aa);
$parcel$export(module.exports, "useSkipLink", () => $da79d52672c93574$export$89d9323301efc7d6);

var $5uXOq = parcelRequire("5uXOq");

var $bKnKN = parcelRequire("bKnKN");
const $da79d52672c93574$export$4c5cc3b14c7678a = /*#__PURE__*/ (0, $5uXOq.createContext)({
    registerSkipLink: (0, $bKnKN.default),
    unregisterSkipLink: (0, $bKnKN.default)
});
const $da79d52672c93574$var$useSkipLinks = ()=>(0, $5uXOq.useContext)($da79d52672c93574$export$4c5cc3b14c7678a);
const $da79d52672c93574$export$707b94c26b8b75aa = ({ id: id, label: label, listIndex: listIndex, onBeforeNavigate: onBeforeNavigate, isHidden: isHidden })=>{
    const { registerSkipLink: registerSkipLink, unregisterSkipLink: unregisterSkipLink } = $da79d52672c93574$var$useSkipLinks();
    (0, $5uXOq.useEffect)(()=>{
        if (isHidden) /**
			 * Skip links are hidden for slots with 0 height or width.
			 * They should not be registered.
			 */ return;
        registerSkipLink({
            id: id,
            label: label,
            listIndex: listIndex,
            onBeforeNavigate: onBeforeNavigate,
            isHidden: isHidden
        });
        return ()=>{
            unregisterSkipLink(id);
        };
    }, [
        id,
        isHidden,
        label,
        listIndex,
        onBeforeNavigate,
        registerSkipLink,
        unregisterSkipLink
    ]);
};
const $da79d52672c93574$export$89d9323301efc7d6 = (id, label, listIndex)=>{
    $da79d52672c93574$export$707b94c26b8b75aa({
        id: id,
        label: label,
        listIndex: listIndex
    });
};

});

parcelRegister("aKoCG", function(module, exports) {

$parcel$export(module.exports, "sideNavVar", () => $871511282052907b$export$951bf5156e86d974);
$parcel$export(module.exports, "asideVar", () => $871511282052907b$export$594e6a30db7c057e);
$parcel$export(module.exports, "panelVar", () => $871511282052907b$export$db0c2e1d744fb281);
$parcel$export(module.exports, "bannerMountedVar", () => $871511282052907b$export$515a0b1baafe906c);
$parcel$export(module.exports, "topBarMountedVar", () => $871511282052907b$export$a96e934b2a1eeee);
$parcel$export(module.exports, "sideNavLiveWidthVar", () => $871511282052907b$export$1216dacffd1e9e65);
$parcel$export(module.exports, "sideNavPanelSplitterId", () => $871511282052907b$export$5db28b16b6e686bc);
$parcel$export(module.exports, "UNSAFE_topBarVar", () => $871511282052907b$export$f4afb213f937404c);
$parcel$export(module.exports, "UNSAFE_bannerVar", () => $871511282052907b$export$26354f9814213292);
$parcel$export(module.exports, "UNSAFE_sideNavLayoutVar", () => $871511282052907b$export$6bfc931a04ec5741);
$parcel$export(module.exports, "UNSAFE_asideLayoutVar", () => $871511282052907b$export$bbbace2ff0c7ae1b);
$parcel$export(module.exports, "UNSAFE_panelLayoutVar", () => $871511282052907b$export$753bf7651b25db91);
$parcel$export(module.exports, "UNSAFE_MAIN_BLOCK_START_FOR_LEGACY_PAGES_ONLY", () => $871511282052907b$export$6460bd6a2446260);
$parcel$export(module.exports, "UNSAFE_MAIN_INLINE_START_FOR_LEGACY_PAGES_ONLY", () => $871511282052907b$export$3055529fab2b4edf);
$parcel$export(module.exports, "UNSAFE_MAIN_INLINE_END_FOR_LEGACY_PAGES_ONLY", () => $871511282052907b$export$166d8fd766c3eb92);
/**
 * These variables are shared across the different page layout slots.
 * This violates the [UI styling standard](https://atlassian.design/components/eslint-plugin-ui-styling-standard/no-imported-style-values/usage).
 * We have chosen to ignore this rule to prevent duplicating them across the different slots, and to provide a high level view of them and how they relate.
 */ // These are "compressed" to discourage usage.
const $871511282052907b$export$951bf5156e86d974 = '--n_sNvw';
const $871511282052907b$export$594e6a30db7c057e = '--n_asDw';
const $871511282052907b$export$db0c2e1d744fb281 = '--n_pnlW';
const $871511282052907b$export$515a0b1baafe906c = '--n_bnrM';
const $871511282052907b$export$a96e934b2a1eeee = '--n_tbrM';
const $871511282052907b$export$1216dacffd1e9e65 = '--n_sNvlw';
const $871511282052907b$export$5db28b16b6e686bc = Symbol('SideNav PanelSplitter');
const $871511282052907b$export$2874e68531ce3163 = `calc(100vh - var(--n_bnrM, 0px) - var(--n_tbrM, 0px))`;
const $871511282052907b$export$bfabd8c2c572ad29 = `calc(var(--n_bnrM, 0px) + var(--n_tbrM, 0px))`;
const $871511282052907b$export$f4afb213f937404c = '--topNavigationHeight';
const $871511282052907b$export$26354f9814213292 = '--bannerHeight';
const $871511282052907b$export$6bfc931a04ec5741 = '--leftSidebarWidth';
const $871511282052907b$export$bbbace2ff0c7ae1b = '--rightSidebarWidth';
const $871511282052907b$export$753bf7651b25db91 = '--rightPanelWidth';
const $871511282052907b$export$6460bd6a2446260 = `calc(var(${$871511282052907b$export$26354f9814213292}, 0px) + var(${$871511282052907b$export$f4afb213f937404c}, 0px))`;
const $871511282052907b$export$3055529fab2b4edf = `var(${$871511282052907b$export$6bfc931a04ec5741}, 0px)`;
const $871511282052907b$export$166d8fd766c3eb92 = `calc(var(${$871511282052907b$export$bbbace2ff0c7ae1b}, 0px) + var(${$871511282052907b$export$753bf7651b25db91}, 0px))`;
const $871511282052907b$export$61156ceb1a99f6a0 = {
    topBar: 4,
    banner: 4,
    topBarBorder: 3,
    sideNav: 2,
    contentBlockBorder: 2,
    contentInlineBorder: 1,
    panelSmallViewports: 1
};

});

parcelRegister("4q7g7", function(module, exports) {

$parcel$export(module.exports, "DangerouslyHoistSlotSizes", () => $1db0e2ef65749867$export$66e2c1a0115af861);

var $5uXOq = parcelRequire("5uXOq");
const $1db0e2ef65749867$export$66e2c1a0115af861 = /*#__PURE__*/ (0, $5uXOq.createContext)(false);

});

parcelRegister("9qobs", function(module, exports) {

$parcel$export(module.exports, "HoistCssVarToLocalGrid", () => $02c1cf818ce5ea3a$export$cfa3cd08d675e56e);
$parcel$export(module.exports, "DangerouslyHoistCssVarToDocumentRoot", () => $02c1cf818ce5ea3a$export$9f45a1325e3cdfb8);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $dkD6V = parcelRequire("dkD6V");
const $02c1cf818ce5ea3a$export$cfa3cd08d675e56e = ({ variableName: variableName, value: value })=>/*#__PURE__*/ (0, $2OMIu.jsx)("style", {
        children: `#${(0, $dkD6V.gridRootId)} { ${variableName}: ${value}px }`
    });
const $02c1cf818ce5ea3a$var$getCssStringValue = (value)=>typeof value === 'number' ? `${value}px` : value;
const $02c1cf818ce5ea3a$export$9f45a1325e3cdfb8 = ({ variableName: variableName, value: value, mediaQuery: mediaQuery, responsiveValue: responsiveValue })=>{
    /**
	 * Note don't put multiple variables in multiple lines. eg
	 * <style>
	 *   {css1}
	 *   {css2}
	 * </style>
	 *
	 * React will insert an empty HTML comment in between the text in SSR.
	 * This is not a valid tag and will break the page.
	 * <style>foo<!-- -->bar</style>
	 */ let style = `:root { ${variableName}: ${$02c1cf818ce5ea3a$var$getCssStringValue(value)} }`;
    if (mediaQuery && responsiveValue) style += ` ${mediaQuery} { :root { ${variableName}: ${$02c1cf818ce5ea3a$var$getCssStringValue(responsiveValue)} } }`;
    return(// Using a global style is required for SSR, as we can't use React hooks
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles
    /*#__PURE__*/ (0, $2OMIu.jsx)("style", {
        children: style
    }));
};

});
parcelRegister("dkD6V", function(module, exports) {

$parcel$export(module.exports, "gridRootId", () => $ad7d0fe4bdeabdf6$export$a6d827031bcb31d1);
$parcel$export(module.exports, "Root", () => $ad7d0fe4bdeabdf6$export$be92b6f5f03c0fe9);
/* root.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $kwtKM = parcelRequire("kwtKM");

var $fHpHg = parcelRequire("fHpHg");

var $6LECY = parcelRequire("6LECY");

var $2kwAN = parcelRequire("2kwAN");

var $cCKcc = parcelRequire("cCKcc");

var $4q7g7 = parcelRequire("4q7g7");

var $dGGJ2 = parcelRequire("dGGJ2");

var $8cEUW = parcelRequire("8cEUW");

var $l0qZ6 = parcelRequire("l0qZ6");
const $ad7d0fe4bdeabdf6$export$a6d827031bcb31d1 = 'unsafe-design-system-page-layout-root';
const $ad7d0fe4bdeabdf6$var$styles = {
    root: "_1e0c11p5 _1tke1kxc _1lmcq9em _yv0ei47z _2z0516ab _1ciragmp _12fkuz0r _12qzrxre _1rqt70if _xkmgbaui _jbc7rxre _tyve1jg8"
};
function $ad7d0fe4bdeabdf6$export$be92b6f5f03c0fe9({ children: children, xcss: xcss, UNSAFE_dangerouslyHoistSlotSizes: UNSAFE_dangerouslyHoistSlotSizes = false, skipLinksLabel: skipLinksLabel = 'Skip to:', testId: testId }) {
    const ref = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        var child;
    }, []);
    // OpenLayerObserver is only added when the feature flag is enabled. When disabled, it is only around `SideNav`.
    const OpenLayerObserverIfEnabled = (0, $fHpHg.fg)('platform_dst_open_layer_observer_close_layers') ? (0, $kwtKM.OpenLayerObserver) : (0, $5uXOq.Fragment);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l0qZ6.SideNavVisibilityProvider), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8cEUW.SideNavToggleButtonProvider), {
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dGGJ2.SideNavElementProvider), {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2kwAN.HomeActionsProvider), {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)(OpenLayerObserverIfEnabled, {
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4q7g7.DangerouslyHoistSlotSizes).Provider, {
                            value: UNSAFE_dangerouslyHoistSlotSizes,
                            children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $cCKcc.SkipLinksProvider), {
                                children: [
                                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6LECY.SkipLinksContainer), {
                                        label: skipLinksLabel,
                                        testId: testId
                                    }),
                                    /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                                        ref: ref,
                                        className: (0, $bwpsq.default)([
                                            $ad7d0fe4bdeabdf6$var$styles.root,
                                            xcss
                                        ]),
                                        id: $ad7d0fe4bdeabdf6$export$a6d827031bcb31d1,
                                        "data-testid": testId,
                                        children: children
                                    })
                                ]
                            })
                        })
                    })
                })
            })
        })
    });
}

});
parcelRegister("kwtKM", function(module, exports) {

$parcel$export(module.exports, "OpenLayerObserver", () => $b69be41da71b75cf$export$97afddda23bcd287);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $3joPi = parcelRequire("3joPi");

var $fHpHg = parcelRequire("fHpHg");

var $90wDB = parcelRequire("90wDB");
/**
 * Layers that are registered without a namespace are grouped under this fallback namespace.
 */ const $b69be41da71b75cf$var$noNamespaceSymbol = Symbol('no-namespace');
/**
 * Returns the number of open layers across all namespaces.
 * It calculates the sum of the set sizes in the map, which corresponds to the number of open layers.
 */ function $b69be41da71b75cf$var$getTotalOpenLayerCount(registry) {
    return Array.from(registry.values()).reduce((acc, listeners)=>acc + listeners.size, 0);
}
/**
 * Returns the layer count change listeners set for the namespace.
 * If there are no listeners registered for the namespace yet, it creates a new set
 * and adds it to the registry, then returns the new set.
 */ function $b69be41da71b75cf$var$getListeners({ registry: registry, namespace: namespace }) {
    // 1. If there are existing listeners for this namespace, return the existing set.
    const existingListeners = registry.get(namespace);
    if (existingListeners) return existingListeners;
    // 2. If there are no existing listeners for this namespace, create a new set for this namespace
    // and add it to the registry, then return the new set.
    const newSet = new Set();
    registry.set(namespace, newSet);
    return newSet;
}
/**
 * Returns an instance of the open layer observer API. It internally keeps track of the number of open layers and
 * exposes methods to get the current count, increment/decrement the count, and subscribe to changes.
 */ function $b69be41da71b75cf$var$createInternalAPI() {
    /**
	 * The previous data structures are still used if fg('platform_dst_open_layer_observer_close_layers')
	 * is disabled.
	 */ let openLayerCountLegacy = 0;
    const changeListenerRegistryLegacy = new Set();
    /**
	 * These are the new data structures that will be used if fg('platform_dst_open_layer_observer_close_layers')
	 * is enabled.
	 */ /**
	 * The layer count change listeners for each namespace.
	 */ const namespaceToChangeListenerRegistry = new Map();
    /**
	 * The `onClose` listeners for each namespace.
	 * Each layer provides an `onClose` callback. **When the layer is open**, its `onClose`
	 * callback is registered in this set.
	 *
	 * This data structure is also used determine the number of open layers.
	 */ const namespaceToLayerCloseListenerRegistry = new Map();
    /**
	 * Calls the appropriate layer count change listeners after the number of open layers has changed.
	 */ function callChangeListeners({ namespace: namespace, newCount: newCount }) {
        // 1. Call listeners registered to the specific namespace
        if (namespace) {
            const listenersForNamespace = namespaceToChangeListenerRegistry.get(namespace);
            // Using `Array.from` to ensure we iterate over a stable list - e.g. in case a listener adds to the registry while we are
            // iterating over it.
            Array.from(listenersForNamespace ?? []).forEach((listener)=>listener({
                    count: newCount
                }));
        }
        // 2. Call listeners registered without a specific namespace
        const noNamespaceListeners = namespaceToChangeListenerRegistry.get($b69be41da71b75cf$var$noNamespaceSymbol);
        // Return early if no listeners
        if (!noNamespaceListeners) return;
        // For the listeners without a specific namespace, we need to provide the sum of all namespace counts
        // as the callback `count` arg.
        const totalCount = $b69be41da71b75cf$var$getTotalOpenLayerCount(namespaceToLayerCloseListenerRegistry);
        Array.from(noNamespaceListeners).forEach((listener)=>listener({
                count: totalCount
            }));
    }
    /**
	 * Returns the current count of open layers.
	 *
	 * If a namespace is provided, the count for that namespace is returned.
	 * Otherwise, the sum of all namespace counts is returned.
	 */ function getCount({ namespace: namespace } = {}) {
        if (!(0, $fHpHg.fg)('platform_dst_open_layer_observer_close_layers')) return openLayerCountLegacy;
        if (namespace) return namespaceToLayerCloseListenerRegistry.get(namespace)?.size ?? 0;
        // A specific namespace was not requested, so we return the sum across all namespaces.
        return $b69be41da71b75cf$var$getTotalOpenLayerCount(namespaceToLayerCloseListenerRegistry);
    }
    /**
	 * Adds a listener that will be called when the number of open layers changes.
	 *
	 * @returns a cleanup function to unsubscribe, which should be called when the component unmounts.
	 */ function onChange(listener, { namespace: providedNamespace } = {}) {
        /**
		 * We are wrapping the passed listener in a function to ensure that each call to `onChange` creates a unique
		 * function reference. This is to handle scenarios where the same function is provided to several different `onChange`
		 * calls - we want to ensure that each call to `unsubscribe` only removes the specific listener registration that was added.
		 */ function wrapped(...args) {
            listener(...args);
        }
        if (!(0, $fHpHg.fg)('platform_dst_open_layer_observer_close_layers')) {
            changeListenerRegistryLegacy.add(wrapped);
            return function unsubscribe() {
                changeListenerRegistryLegacy.delete(wrapped);
            };
        }
        const namespace = providedNamespace ?? $b69be41da71b75cf$var$noNamespaceSymbol;
        const listenersForNamespace = $b69be41da71b75cf$var$getListeners({
            namespace: namespace,
            registry: namespaceToChangeListenerRegistry
        });
        listenersForNamespace.add(wrapped);
        return function unsubscribe() {
            listenersForNamespace.delete(wrapped);
            // If there are no listeners for this namespace, remove the registry entry.
            if (listenersForNamespace.size === 0) namespaceToChangeListenerRegistry.delete(namespace);
        };
    }
    /**
	 * This function will be removed with fg('platform_dst_open_layer_observer_close_layers')
	 */ function increment() {
        if (!(0, $fHpHg.fg)('platform_dst_open_layer_observer_close_layers')) {
            openLayerCountLegacy += 1;
            // Using `Array.from` to ensure we iterate over a stable list - e.g. in case a listener adds to the registry while we are
            // iterating over it.
            Array.from(changeListenerRegistryLegacy).forEach((listener)=>listener({
                    count: openLayerCountLegacy
                }));
            return;
        }
    }
    /**
	 * This function will be removed with fg('platform_dst_open_layer_observer_close_layers')
	 */ function decrement() {
        if (!(0, $fHpHg.fg)('platform_dst_open_layer_observer_close_layers')) {
            openLayerCountLegacy -= 1;
            // Using `Array.from` to ensure we iterate over a stable list - e.g. in case a listener adds to the registry while we are
            // iterating over it.
            Array.from(changeListenerRegistryLegacy).forEach((listener)=>listener({
                    count: openLayerCountLegacy
                }));
            return;
        }
    }
    /**
	 * Adds a listener to the registry that tells the observer how to close the layer component.
	 * The listener should only be added if the layer is open. This is handled by `useNotifyOpenLayerObserver`.
	 *
	 * All close listeners will be called by the observer when `closeLayers` is called.
	 *
	 * @returns a cleanup function to unsubscribe, which should be called when the component unmounts.
	 */ function onClose(listener, { namespace: providedNamespace }) {
        /**
		 * We are wrapping the passed listener in a function to ensure that each call to `onClose` creates a unique
		 * function reference. This is to handle scenarios where the same function is provided to several different `onClose`
		 * calls - we want to ensure that each call to `unsubscribe` only removes the specific listener registration that was added.
		 */ function wrapped() {
            listener();
        }
        const namespace = providedNamespace ?? $b69be41da71b75cf$var$noNamespaceSymbol;
        const listenersForNamespace = $b69be41da71b75cf$var$getListeners({
            namespace: namespace,
            registry: namespaceToLayerCloseListenerRegistry
        });
        listenersForNamespace.add(wrapped);
        callChangeListeners({
            namespace: providedNamespace,
            newCount: listenersForNamespace.size
        });
        return function unsubscribe() {
            listenersForNamespace.delete(wrapped);
            callChangeListeners({
                namespace: providedNamespace,
                newCount: listenersForNamespace.size
            });
            // If there are no listeners for this namespace, remove the registry entry.
            if (listenersForNamespace.size === 0) namespaceToLayerCloseListenerRegistry.delete(namespace);
        };
    }
    /**
	 * Closes all open layers registered across all namespaces.
	 */ function closeLayers() {
        // Using `Array.from` to ensure we iterate over a stable list - e.g. in case a listener adds to the registry while we are
        // iterating over it.
        Array.from(namespaceToLayerCloseListenerRegistry.values()).forEach((listeners)=>{
            Array.from(listeners).forEach((listener)=>listener());
        });
    }
    const internalAPI = {
        getCount: getCount,
        onChange: onChange,
        increment: increment,
        decrement: decrement,
        onClose: onClose,
        closeLayers: closeLayers
    };
    return internalAPI;
}
function $b69be41da71b75cf$export$97afddda23bcd287({ children: children }) {
    // Using state to ensure a stable reference to a single instance.
    const [internalAPI] = (0, $5uXOq.useState)(()=>$b69be41da71b75cf$var$createInternalAPI());
    const parentContext = (0, $5uXOq.useContext)((0, $90wDB.OpenLayerObserverContext));
    // We don't expect a parent context. If there is one, that means this component is nested within another `OpenLayerObserver`
    // - which we don't support.
    (0, $3joPi.default)(parentContext === null, '`OpenLayerObserver` cannot be nested within another `OpenLayerObserver`.');
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $90wDB.OpenLayerObserverContext).Provider, {
        value: internalAPI,
        children: children
    });
}

});

parcelRegister("6LECY", function(module, exports) {

$parcel$export(module.exports, "SkipLinksContainer", () => $d04342e4c2a5fe98$export$fce25a0c32fbc1e1);
/* skip-links-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fHpHg = parcelRequire("fHpHg");

var $6eFvr = parcelRequire("6eFvr");

var $LryRZ = parcelRequire("LryRZ");

var $2llTc = parcelRequire("2llTc");
const $d04342e4c2a5fe98$var$styles = {
    root: "_2rkoglpi _1rjcu2gc _18zr12x7 _kqsw1n9t _1e02v47k _152tv47k _bfhk1bhr _16qs1cd0 _1pby1mrw _tzy4idpf _lcxvglyw _1digjh3g _1mygkb7n _18eu1wug",
    rootToAdd: "_zulp1b66 _1rjcutpp _18zrutpp _1e0c1txw _2lx21bp4",
    skipLinkList: "_1x8w11lx _2mzuglyw _1pfh1b66 _bozgze3t",
    skipLinkListToAdd: "_zulp1b66 _1e0c1txw _2lx21bp4 _1pfhze3t"
};
/**
 * Keydown handler to hide the skip links when escape is pressed.
 *
 * TODO: consider removing this, it doesn't make a lot of sense.
 * The skip links look like a popup but in reality they aren't.
 * Even though we hide them if you press TAB it will reopen the list and move to the next one...
 */ const $d04342e4c2a5fe98$var$closeOnEscape = (event)=>{
    if (event.key !== 'Escape') return;
    const activeElement = document.activeElement;
    if (activeElement instanceof HTMLElement) activeElement.blur();
};
const $d04342e4c2a5fe98$var$isOnlyWhitespaceRegex = /^\s*$/;
const $d04342e4c2a5fe98$export$fce25a0c32fbc1e1 = ({ label: label, testId: testId })=>{
    const sortedSkipLinks = (0, $LryRZ.useSortedSkipLinks)();
    if (sortedSkipLinks.length === 0) return null;
    const isEmptyLabel = $d04342e4c2a5fe98$var$isOnlyWhitespaceRegex.test(label);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        onKeyDown: $d04342e4c2a5fe98$var$closeOnEscape,
        "data-testid": testId ? `${testId}--skip-links-container` : undefined,
        className: (0, $bwpsq.default)([
            $d04342e4c2a5fe98$var$styles.root,
            (0, $fHpHg.fg)('platform_design_system_nav4_skip_link_styling') && $d04342e4c2a5fe98$var$styles.rootToAdd
        ]),
        children: [
            !isEmptyLabel && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6eFvr.default), {
                weight: (0, $fHpHg.fg)('platform_design_system_nav4_skip_link_styling') ? 'bold' : 'medium',
                testId: testId ? `${testId}--skip-links-container--label` : undefined,
                children: label
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("ol", {
                className: (0, $bwpsq.default)([
                    $d04342e4c2a5fe98$var$styles.skipLinkList,
                    (0, $fHpHg.fg)('platform_design_system_nav4_skip_link_styling') && $d04342e4c2a5fe98$var$styles.skipLinkListToAdd
                ]),
                children: sortedSkipLinks.map(({ id: id, label: label, onBeforeNavigate: onBeforeNavigate })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $2llTc.SkipLink), {
                        id: id,
                        onBeforeNavigate: onBeforeNavigate,
                        children: label
                    }, id))
            })
        ]
    });
};

});
parcelRegister("LryRZ", function(module, exports) {

$parcel$export(module.exports, "SkipLinksDataContext", () => $1d23f9e1ad63c09f$export$e9ab38ce6147d3d2);
$parcel$export(module.exports, "useSortedSkipLinks", () => $1d23f9e1ad63c09f$export$b0b0d4fc1b356759);

var $5uXOq = parcelRequire("5uXOq");
const $1d23f9e1ad63c09f$export$e9ab38ce6147d3d2 = /*#__PURE__*/ (0, $5uXOq.createContext)([]);
const $1d23f9e1ad63c09f$var$assignIndex = (num, arr)=>{
    if (!arr.includes(num)) return num;
    return $1d23f9e1ad63c09f$var$assignIndex(num + 1, arr);
};
const $1d23f9e1ad63c09f$var$sortSkipLinks = (arr)=>{
    const customLinks = arr.filter((link)=>Number.isInteger(link.listIndex));
    if (customLinks.length === 0) return arr;
    const usedIndexes = customLinks.map((a)=>a.listIndex);
    const regularLinksWithIdx = arr.filter((link)=>link.listIndex === undefined).map((link, idx)=>{
        const listIndex = $1d23f9e1ad63c09f$var$assignIndex(idx, usedIndexes);
        usedIndexes.push(listIndex);
        return {
            ...link,
            listIndex: listIndex
        };
    });
    return [
        ...customLinks,
        ...regularLinksWithIdx
    ].sort((a, b)=>a.listIndex - b.listIndex);
};
const $1d23f9e1ad63c09f$export$b0b0d4fc1b356759 = ()=>{
    const skipLinksData = (0, $5uXOq.useContext)($1d23f9e1ad63c09f$export$e9ab38ce6147d3d2);
    return (0, $5uXOq.useMemo)(()=>{
        return $1d23f9e1ad63c09f$var$sortSkipLinks(skipLinksData);
    }, [
        skipLinksData
    ]);
};

});

parcelRegister("2llTc", function(module, exports) {

$parcel$export(module.exports, "SkipLink", () => $f0a62c4fcc777644$export$ef95c37428582a65);
/* skip-link.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");

var $gHU1R = parcelRequire("gHU1R");
const $f0a62c4fcc777644$var$styles = {
    skipLinkListItem: "_1pfhze3t"
};
/**
 * Used for moving focus to the corresponding slot or custom target after clicking on a skip link.
 */ function $f0a62c4fcc777644$var$focusElement(element) {
    /**
   * Elements without an explicit `tabindex` attribute are not guaranteed to be focusable:
   * https://html.spec.whatwg.org/multipage/interaction.html#attr-tabindex
   *
   * Our slots are not interactive, so this is required.
   *
   * In the future we may want to check if there is an existing `tabindex` attribute,
   * as custom skip linked elements might already have one.
   */ element.setAttribute('tabindex', '-1');
    /**
   * Cleanup the `tabindex` attribute we set when the slot or custom target loses focus.
   */ (0, $cBeZP.bind)(element, {
        type: 'blur',
        listener () {
            element.removeAttribute('tabindex');
        },
        options: {
            // Using a one-time listener so it cleans itself up
            once: true
        }
    });
    /**
   * Move focus to the slot or custom target.
   *
   * Calling `.focus()` will also scroll the element into view:
   * https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/focus
   */ element.focus({
        // Forces the focus ring to appear after moving focus to the slot
        // https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/focus#focusvisible
        // @ts-expect-error - new and not in types yet
        focusVisible: true
    });
}
const $f0a62c4fcc777644$export$ef95c37428582a65 = ({ id: id, children: children, onBeforeNavigate: onBeforeNavigate })=>{
    const href = `#${id}`;
    const onClick = (0, $5uXOq.useCallback)((event)=>{
        event.preventDefault();
        // Intentionally not using `document.querySelector` because many valid IDs are not valid selectors.
        const target = document.getElementById(id);
        if (!target) return;
        /**
     * Internal slots can attach an `onBeforeNavigate` callback.
     *
     * Side nav uses this to ensure it is expanded.
     */ onBeforeNavigate?.();
        $f0a62c4fcc777644$var$focusElement(target);
        /**
     * We should look into removing this, or only calling it in specific cases.
     *
     * It means if the skip link element is in the window scroll container
     * then it might not get scrolled into view properly.
     *
     * This is not an issue for the default slots on desktop, but could break custom skip links or
     * even `Aside` on mobile.
     *
     * Keeping existing behavior for now because resetting the window scroll is actually good for some cases.
     * E.g. jumping to main / aside it makes sense to look at the start of the content.
     */ window.scrollTo(0, 0);
    }, [
        id,
        onBeforeNavigate
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("li", {
        className: (0, $bwpsq.default)([
            $f0a62c4fcc777644$var$styles.skipLinkListItem
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gHU1R.default), {
            /**
     * It looks like Safari handles link clicks during `pointerdown` unless it has an explicit `tabIndex={0}` :/
     *
     * Adding this explicitly makes the behavior consistent between browsers and lets us `event.preventDefault()`
     * in the `onClick` handler.
     */ tabIndex: 0,
            href: href,
            onClick: onClick,
            children: children
        })
    });
};

});
parcelRegister("gHU1R", function(module, exports) {

$parcel$export(module.exports, "default", () => $66031721b254fac1$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $3joPi = parcelRequire("3joPi");

var $eNCZ4 = parcelRequire("eNCZ4");

var $3BT8o = parcelRequire("3BT8o");

var $bKnKN = parcelRequire("bKnKN");

var $jJsBW = parcelRequire("jJsBW");

var $9ewsv = parcelRequire("9ewsv");

var $cBCgC = parcelRequire("cBCgC");

var $avgEF = parcelRequire("avgEF");

var $2s57o = parcelRequire("2s57o");
function $66031721b254fac1$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// TODO: duplicates FocusRing styles from `@atlaskit/focus-ring`.
const $66031721b254fac1$var$focusRingStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    '&:focus, &:focus-visible': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineColor: (0, $avgEF.borderColorMap)['color.border.focused'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineOffset: (0, $avgEF.positiveSpaceMap)['space.025'],
        outlineStyle: 'solid',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineWidth: (0, $avgEF.borderWidthMap)['border.width.outline']
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: '1px solid'
        }
    }
});
const $66031721b254fac1$var$baseStyles = {
    name: "9ge06c",
    styles: "box-sizing:border-box;text-decoration:underline"
};
const $66031721b254fac1$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
const $66031721b254fac1$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms|blob):)|(#))/;
// Comma is added here to add a slight pause between announcing the anchor label and "opens in new window"
const $66031721b254fac1$var$OPENS_NEW_WINDOW_LABEL = '(opens new window)';
/**
 * __Anchor__
 *
 * A primitive for building custom anchor links.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ const $66031721b254fac1$var$AnchorNoRef = ({ href: href, children: children, backgroundColor: backgroundColor, newWindowLabel: newWindowLabel, padding: padding, paddingBlock: paddingBlock, paddingBlockStart: paddingBlockStart, paddingBlockEnd: paddingBlockEnd, paddingInline: paddingInline, paddingInlineStart: paddingInlineStart, paddingInlineEnd: paddingInlineEnd, onClick: providedOnClick = (0, $bKnKN.default), interactionName: interactionName, componentName: componentName, analyticsContext: analyticsContext, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, style: style, target: target, testId: testId, xcss: xcss, ...htmlAttributes }, ref)=>{
    const interactionContext = (0, $5uXOq.useContext)((0, $9ewsv.default));
    const handleClick = (0, $5uXOq.useCallback)((e, analyticsEvent)=>{
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    const opensNewWindowLabelId = (0, $jJsBW.useId)();
    const onClick = (0, $eNCZ4.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Anchor',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local",
        analyticsData: analyticsContext,
        actionSubject: 'link'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    const resolvedStyles = (0, $2s57o.parseXcss)(xcss);
    const RouterLink = (0, $3BT8o.default)();
    const isExternal = typeof href === 'string' && $66031721b254fac1$var$IS_EXTERNAL_LINK_REGEX.test(href);
    const isNonHttpBased = typeof href === 'string' && $66031721b254fac1$var$IS_NON_HTTP_BASED.test(href);
    /**
   * Renders a router link if:
   *
   * - a link component is set in the app provider
   * - it's not an external link (starting with `http://` or `https://`)
   * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.).
   */ const isRouterLink = RouterLink && !isExternal && !isNonHttpBased;
    const hrefObjectUsedWithoutRouterLink = RouterLink === undefined && typeof href === 'object';
    (0, $3joPi.default)(!hrefObjectUsedWithoutRouterLink, `@atlaskit/primitives: Anchor primitive cannot pass an object to 'href' unless a router link is configured in the AppProvider`);
    const Component = isRouterLink ? RouterLink : 'a';
    return /*#__PURE__*/ (0, $f8Sb3.jsx)(Component, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        ...safeHtmlAttributes,
        // @ts-expect-error
        href: !isRouterLink && typeof href !== 'string' ? undefined : href,
        target: target,
        onClick: onClick,
        "aria-label": ariaLabel && target === '_blank' && !ariaLabelledBy ? //`${ariaLabel} ${OPENS_NEW_WINDOW_LABEL}`
        `${ariaLabel} , ${newWindowLabel ? newWindowLabel : $66031721b254fac1$var$OPENS_NEW_WINDOW_LABEL}` : ariaLabel,
        "aria-labelledby": ariaLabelledBy && target === '_blank' ? `${ariaLabelledBy} ${opensNewWindowLabelId}` : ariaLabelledBy,
        css: [
            $66031721b254fac1$var$baseStyles,
            $66031721b254fac1$var$focusRingStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $avgEF.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $avgEF.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $avgEF.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $avgEF.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $avgEF.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $avgEF.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $avgEF.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $avgEF.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            resolvedStyles.emotion
        ],
        "data-testid": testId,
        "data-is-router-link": testId ? isRouterLink ? 'true' : 'false' : undefined
    }, children, target === '_blank' && (children && !ariaLabel && !ariaLabelledBy || ariaLabelledBy) && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $cBCgC.default), {
        id: opensNewWindowLabelId
    }, `, ${newWindowLabel ? newWindowLabel : $66031721b254fac1$var$OPENS_NEW_WINDOW_LABEL}`));
};
// Workarounds to support generic types with forwardRef
/**
 * __Anchor__
 *
 * Anchor is a primitive for building custom anchor links. It's a wrapper around the HTML `<a>` element that provides a consistent API for handling client-side routing and Atlassian Design System styling.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ const $66031721b254fac1$var$Anchor = /*#__PURE__*/ (0, $5uXOq.forwardRef)($66031721b254fac1$var$AnchorNoRef);
var $66031721b254fac1$export$2e2bcd8739ae039 = $66031721b254fac1$var$Anchor;

});



parcelRegister("2kwAN", function(module, exports) {

$parcel$export(module.exports, "HomeActionsProvider", () => $f299d88dffe1d206$export$8b9089606266983e);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ic23Y = parcelRequire("ic23Y");
const $f299d88dffe1d206$export$8b9089606266983e = ({ children: children })=>{
    const [element, setElement] = (0, $5uXOq.useState)(null);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ic23Y.HomeActionsElement).Provider, {
        value: element,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ic23Y.HomeActionsAttachRef).Provider, {
            value: setElement,
            children: children
        })
    });
};

});

parcelRegister("cCKcc", function(module, exports) {

$parcel$export(module.exports, "SkipLinksProvider", () => $c950ecf7bf894e69$export$fe514f9f7b03d46f);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $6bvKu = parcelRequire("6bvKu");

var $LryRZ = parcelRequire("LryRZ");
const $c950ecf7bf894e69$var$getByDomOrderSortFunction = ()=>{
    const layoutSlots = Array.from(document.querySelectorAll(`[data-layout-slot]`));
    return (a, b)=>{
        const indexA = a.listIndex ?? layoutSlots.indexOf(document.getElementById(a.id));
        const indexB = b.listIndex ?? layoutSlots.indexOf(document.getElementById(b.id));
        /**
		 * If they are tied it is because one (or both) is
		 * a custom skiplink with a set index.
		 *
		 * Give the custom skiplink priority.
		 */ if (indexA === indexB) {
            if (a.listIndex !== undefined) return -1;
            else return 1;
        }
        return indexA - indexB;
    };
};
const $c950ecf7bf894e69$export$fe514f9f7b03d46f = ({ children: children })=>{
    const [links, setLinks] = (0, $5uXOq.useState)([]);
    const registerSkipLink = (0, $5uXOq.useCallback)((skipLinkData)=>{
        // Don't add duplicate skip links
        setLinks((oldLinks)=>{
            if (oldLinks.some(({ id: id })=>id === skipLinkData.id)) return oldLinks;
            return [
                ...oldLinks,
                skipLinkData
            ].sort($c950ecf7bf894e69$var$getByDomOrderSortFunction());
        });
    }, []);
    const unregisterSkipLink = (0, $5uXOq.useCallback)((id)=>{
        setLinks((links)=>links.filter((link)=>link.id !== id));
    }, []);
    const contextValue = (0, $5uXOq.useMemo)(()=>{
        const data = {
            registerSkipLink: registerSkipLink,
            unregisterSkipLink: unregisterSkipLink
        };
        return data;
    }, [
        registerSkipLink,
        unregisterSkipLink
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6bvKu.SkipLinksContext).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $LryRZ.SkipLinksDataContext).Provider, {
            value: links,
            children: children
        })
    });
};

});

parcelRegister("dGGJ2", function(module, exports) {

$parcel$export(module.exports, "SideNavElementProvider", () => $2f397d83ca80570f$export$85c1ff84bbf6e6dc);
$parcel$export(module.exports, "useSideNavRef", () => $2f397d83ca80570f$export$fa4d0cff03b1ea4f);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
const $2f397d83ca80570f$var$SideNavRefContext = /*#__PURE__*/ (0, $5uXOq.createContext)({
    current: null
});
function $2f397d83ca80570f$export$85c1ff84bbf6e6dc({ children: children }) {
    const sideNavRef = (0, $5uXOq.useRef)(null);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($2f397d83ca80570f$var$SideNavRefContext.Provider, {
        value: sideNavRef,
        children: children
    });
}
function $2f397d83ca80570f$export$fa4d0cff03b1ea4f() {
    return (0, $5uXOq.useContext)($2f397d83ca80570f$var$SideNavRefContext);
}

});

parcelRegister("8cEUW", function(module, exports) {

$parcel$export(module.exports, "SideNavToggleButtonProvider", () => $bbb4dc68bcf8a886$export$ceb8e60e9790fc0f);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $cugaz = parcelRequire("cugaz");
const $bbb4dc68bcf8a886$export$ceb8e60e9790fc0f = ({ children: children })=>{
    const [element, setElement] = (0, $5uXOq.useState)(null);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cugaz.SideNavToggleButtonElement).Provider, {
        value: element,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cugaz.SideNavToggleButtonAttachRef).Provider, {
            value: setElement,
            children: children
        })
    });
};

});

parcelRegister("l0qZ6", function(module, exports) {

$parcel$export(module.exports, "SideNavVisibilityProvider", () => $a8d3ba985aa93ee3$export$aac8e996360f6ad9);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8t2il = parcelRequire("8t2il");
const $a8d3ba985aa93ee3$export$aac8e996360f6ad9 = ({ children: children })=>{
    // Defaults to null so we can determine if the value has been set yet (for SSR)
    const [sideNavState, setSideNavState] = (0, $5uXOq.useState)(null);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8t2il.SideNavVisibilityState).Provider, {
        value: sideNavState,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8t2il.SetSideNavVisibilityState).Provider, {
            value: setSideNavState,
            children: children
        })
    });
};

});



parcelRegister("7KMzu", function(module, exports) {

$parcel$export(module.exports, "usePrefixedUID", () => $b6952487275a20e4$export$86433d4fd18455f4);
$parcel$export(module.exports, "useLayoutId", () => $b6952487275a20e4$export$110c3550c7c1c9aa);

var $jJsBW = parcelRequire("jJsBW");

var $fHpHg = parcelRequire("fHpHg");
function $b6952487275a20e4$export$86433d4fd18455f4(prefix = 'element') {
    const uniqueId = (0, $jJsBW.useId)();
    if ((0, $fHpHg.fg)('platform_dst_skip_link_id_remove_prefix')) return uniqueId;
    return `${prefix}-${uniqueId}`;
}
function $b6952487275a20e4$export$110c3550c7c1c9aa({ providedId: providedId } = {}) {
    const uniqueId = $b6952487275a20e4$export$86433d4fd18455f4();
    const id = providedId ? providedId : uniqueId;
    return id;
}

});

parcelRegister("w2vcN", function(module, exports) {

$parcel$export(module.exports, "PanelSplitterProvider", () => $c0936550512cc687$export$f662bfb764348932);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $6XZE5 = parcelRequire("6XZE5");
const $c0936550512cc687$export$f662bfb764348932 = ({ panelId: panelId, panelWidth: panelWidth, onCompleteResize: onCompleteResize, getResizeBounds: getResizeBounds, resizingCssVar: resizingCssVar, panelRef: panelRef, position: position = 'end', isEnabled: isEnabled = true, children: children })=>{
    const portalRef = (0, $5uXOq.useRef)(null);
    const context = (0, $5uXOq.useMemo)(()=>({
            panelId: panelId,
            panelWidth: panelWidth,
            onCompleteResize: onCompleteResize,
            getResizeBounds: getResizeBounds,
            portalRef: portalRef,
            resizingCssVar: resizingCssVar,
            position: position,
            panelRef: panelRef,
            isEnabled: isEnabled
        }), [
        panelId,
        panelWidth,
        onCompleteResize,
        getResizeBounds,
        resizingCssVar,
        position,
        panelRef,
        isEnabled
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6XZE5.PanelSplitterContext).Provider, {
                value: context,
                children: children
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                ref: portalRef
            })
        ]
    });
};

});
parcelRegister("6XZE5", function(module, exports) {

$parcel$export(module.exports, "PanelSplitterContext", () => $c87bf0cdbea5c772$export$7a4054f2c546f2cd);

var $5uXOq = parcelRequire("5uXOq");
const $c87bf0cdbea5c772$export$7a4054f2c546f2cd = /*#__PURE__*/ (0, $5uXOq.createContext)(null);

});



parcelRegister("7YDkZ", function(module, exports) {

$parcel$export(module.exports, "Banner", () => $be384a99a7fd84d9$export$3b4e64e77073e307);
/* banner.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fHpHg = parcelRequire("fHpHg");

var $6bvKu = parcelRequire("6bvKu");

var $aKoCG = parcelRequire("aKoCG");

var $4q7g7 = parcelRequire("4q7g7");

var $9qobs = parcelRequire("9qobs");

var $7KMzu = parcelRequire("7KMzu");
const $be384a99a7fd84d9$var$styles = {
    root: "_nd5ldkfm _1reo15vq _18m915vq _4t3iutvi _152tidpf _kqsw1if8 _1pbyegat"
};
function $be384a99a7fd84d9$export$3b4e64e77073e307({ children: children, xcss: xcss, UNSAFE_height: UNSAFE_height = 64, skipLinkLabel: skipLinkLabel = 'Banner', testId: testId, id: providedId }) {
    const dangerouslyHoistSlotSizes = (0, $5uXOq.useContext)((0, $4q7g7.DangerouslyHoistSlotSizes));
    const id = (0, $7KMzu.useLayoutId)({
        providedId: providedId
    });
    /**
   * Don't show the skip link if the slot has 0 height.
   */ (0, $6bvKu.useSkipLinkInternal)({
        id: id,
        label: skipLinkLabel,
        isHidden: UNSAFE_height === 0 && (0, $fHpHg.fg)('platform_design_system_nav4_hide_empty_skip_links')
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        id: id,
        "data-layout-slot": true,
        className: (0, $bwpsq.default)([
            $be384a99a7fd84d9$var$styles.root,
            xcss
        ]),
        "data-testid": testId,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9qobs.HoistCssVarToLocalGrid), {
                variableName: (0, $aKoCG.bannerMountedVar),
                value: UNSAFE_height
            }),
            dangerouslyHoistSlotSizes && // ------ START UNSAFE STYLES ------
            // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
            // When they aren't needed anymore we can delete them wholesale.
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9qobs.DangerouslyHoistCssVarToDocumentRoot), {
                variableName: (0, $aKoCG.UNSAFE_bannerVar),
                value: UNSAFE_height
            }),
            children
        ]
    });
}

});

parcelRegister("gXjR2", function(module, exports) {

$parcel$export(module.exports, "Main", () => $1fcda1668aa457cd$export$861edd1ccea2f746);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $6bvKu = parcelRequire("6bvKu");

var $7KMzu = parcelRequire("7KMzu");

var $bEedQ = parcelRequire("bEedQ");
const $1fcda1668aa457cd$var$mainElementStyles = {
    root: "_nd5l1gzg _19121cl4 _qwfh1wug",
    fixedContentArea: "_1reo1wug _18m91wug _152t1l7u _165t1run _13wn1if8"
};
function $1fcda1668aa457cd$export$861edd1ccea2f746({ children: children, isFixed: isFixed, xcss: xcss, skipLinkLabel: skipLinkLabel = 'Main Content', testId: testId, id: providedId }) {
    const id = (0, $7KMzu.useLayoutId)({
        providedId: providedId
    });
    (0, $6bvKu.useSkipLink)(id, skipLinkLabel);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Fragment), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            id: id,
            "data-layout-slot": true,
            className: (0, $bwpsq.default)([
                $1fcda1668aa457cd$var$mainElementStyles.root,
                isFixed && $1fcda1668aa457cd$var$mainElementStyles.fixedContentArea,
                xcss
            ]),
            role: "main",
            "data-testid": testId,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bEedQ.MainStickyContext).Provider, {
                value: Boolean(isFixed),
                children: children
            })
        })
    });
}

});
parcelRegister("bEedQ", function(module, exports) {

$parcel$export(module.exports, "MainStickyContext", () => $a4ac45e21a501618$export$3b369e2c6c1ec840);

var $5uXOq = parcelRequire("5uXOq");
const $a4ac45e21a501618$export$3b369e2c6c1ec840 = /*#__PURE__*/ (0, $5uXOq.createContext)(false);

});


parcelRegister("ehQHm", function(module, exports) {

$parcel$export(module.exports, "Panel", () => $5e003176e44f49c4$export$2ddb90ad54e5f587);
/* panel.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fHpHg = parcelRequire("fHpHg");

var $kU1q1 = parcelRequire("kU1q1");

var $6bvKu = parcelRequire("6bvKu");

var $aKoCG = parcelRequire("aKoCG");

var $4q7g7 = parcelRequire("4q7g7");

var $9qobs = parcelRequire("9qobs");

var $7KMzu = parcelRequire("7KMzu");

var $w2vcN = parcelRequire("w2vcN");

var $dGGJ2 = parcelRequire("dGGJ2");
const $5e003176e44f49c4$var$panelSplitterResizingVar = '--n_pnlRsz';
/**
 * The bounds for Aside and Panel are purposely set to support the current usage in Jira.
 *
 * Jira sets the slot's width to `0px` when there is no active content to display in it.
 *   - This means the min width needs to support `0px`.
 * The Conversation Assistant component in Jira (rendered in a nav3 RightSidebar, or a nav4 Aside) has a custom resizing
 * implementation, which has a maximum width of `50vw`.
 *   - This means the max width needs to support `50vw`.
 *
 * This is not the final implementation and will be updated once Jira's usage has been fixed.
 * Ticket to track this is: https://jplat.atlassian.net/browse/BLU-3951
 *
 * We're using two different bounds for each slot here, to support the `0px` min width when programatically set using the
 * `defaultWidth` prop, and another one that is used when resizing the slots which has a sensible min width.
 */ const $5e003176e44f49c4$var$oldPanelWidthSlotBounds = {
    min: '0px',
    max: '50vw'
};
const $5e003176e44f49c4$var$oldPanelWidthResizeBounds = {
    min: '120px',
    max: '50vw'
};
function $5e003176e44f49c4$var$getOldResizeBounds() {
    return $5e003176e44f49c4$var$oldPanelWidthResizeBounds;
}
/**
 * We typically use the `defaultWidth` as the minimum resizing width,
 * but for large default widths we fallback to a standard value.
 *
 * This standard value of `400px` is to align with the Global Preview Panels.
 */ const $5e003176e44f49c4$var$fallbackResizeMinWidth = 400;
const $5e003176e44f49c4$var$styles = {
    root: "_nd5l1b6c _10fph9n0 _vchhusvi _1pbykb7n _4t3i1run _kqsw1if8 _152t1l7u _1bsb1adv _14b54rrg _1dhy1c6w _9sns1wug",
    border: "_191woyrj _16qs1cd0 _z8dmmuej _scbpglyw",
    scrollContainer: "_1reo1wug _18m91wug _4t3i1osq",
    hidden: "_1e0cglyw"
};
function $5e003176e44f49c4$export$2ddb90ad54e5f587({ children: children, defaultWidth: defaultWidth = 365, label: label = 'Panel', skipLinkLabel: skipLinkLabel = label, testId: testId, id: providedId, xcss: xcss, hasBorder: hasBorder = (0, $fHpHg.fg)('platform_design_system_nav4_panel_default_border') }) {
    const dangerouslyHoistSlotSizes = (0, $5uXOq.useContext)((0, $4q7g7.DangerouslyHoistSlotSizes));
    const id = (0, $7KMzu.useLayoutId)({
        providedId: providedId
    });
    /**
   * Don't show the skip link if the slot has 0 width.
   *
   * Remove `isHidden` usage after https://jplat.atlassian.net/browse/BLU-3951
   */ (0, $6bvKu.useSkipLinkInternal)({
        id: id,
        label: skipLinkLabel,
        isHidden: defaultWidth === 0 && (0, $fHpHg.fg)('platform_design_system_nav4_hide_empty_skip_links')
    });
    const ref = (0, $5uXOq.useRef)(null);
    const [width, setWidth] = (0, $5uXOq.useState)(defaultWidth);
    // Used to track the previous value of the `defaultWidth` prop, for logging dev warnings when it changes.
    const defaultWidthRef = (0, $5uXOq.useRef)(defaultWidth);
    /**
   * TODO: Remove this useEffect once the `width: 0` usage is removed from Jira.
   * It updates the width state based on changes to `defaultWidth`, as a temporary stopgap to support Jira's current usage.
   * https://jplat.atlassian.net/browse/BLU-3951
   */ (0, $5uXOq.useEffect)(()=>{
        if (defaultWidthRef.current === defaultWidth) return;
        defaultWidthRef.current = defaultWidth;
        setWidth(defaultWidth);
    }, [
        defaultWidth
    ]);
    const sideNavRef = (0, $dGGJ2.useSideNavRef)();
    /**
   * The minimum width that the panel can be resized to by the user.
   *
   * We only use the `defaultWidth` up to a point to avoid huge panels.
   */ const minWidth = Math.min(defaultWidth, $5e003176e44f49c4$var$fallbackResizeMinWidth);
    const getNewResizeBounds = (0, $5uXOq.useCallback)(()=>{
        const sideNavWidth = sideNavRef.current?.offsetWidth ?? 0;
        /**
     * The panel should not resize larger than the page content, equivalent to the `Main` + `Aside` slots.
     *
     * This maximum width is equivalent to half the viewport width, after removing the sidebar width.
     */ const maxWidth = Math.round((window.innerWidth - sideNavWidth) / 2);
        return {
            min: `${minWidth}px`,
            max: `${maxWidth}px`
        };
    }, [
        minWidth,
        sideNavRef
    ]);
    const panelWidthSlotBounds = (0, $fHpHg.fg)('platform_design_system_nav4_preview_panel_support') ? {
        min: `${minWidth}px`,
        // `sideNavLiveWidthVar` is not defined if the `SideNav` is not mounted, so we fallback to `0px`.
        max: `round(nearest, calc((100vw - var(${0, $aKoCG.sideNavLiveWidthVar}, 0px)) / 2), 1px)`
    } : $5e003176e44f49c4$var$oldPanelWidthSlotBounds;
    const panelVariableWidth = `clamp(${panelWidthSlotBounds.min}, ${width}px, ${panelWidthSlotBounds.max})`;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("section", {
        id: id,
        "data-layout-slot": true,
        "aria-label": label,
        className: (0, $bwpsq.default)([
            $5e003176e44f49c4$var$styles.root,
            defaultWidth === 0 && $5e003176e44f49c4$var$styles.hidden,
            hasBorder && $5e003176e44f49c4$var$styles.border,
            xcss
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values
        style: {
            [(0, $aKoCG.panelVar)]: panelVariableWidth
        },
        "data-testid": testId,
        ref: ref,
        children: [
            dangerouslyHoistSlotSizes && // ------ START UNSAFE STYLES ------
            // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
            // When they aren't needed anymore we can delete them wholesale.
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9qobs.DangerouslyHoistCssVarToDocumentRoot), {
                variableName: (0, $aKoCG.UNSAFE_panelLayoutVar),
                value: "0px",
                mediaQuery: (0, $kU1q1.media).above.lg,
                responsiveValue: panelVariableWidth
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $w2vcN.PanelSplitterProvider), {
                panelRef: ref,
                panelWidth: width,
                onCompleteResize: setWidth,
                getResizeBounds: (0, $fHpHg.fg)('platform_design_system_nav4_preview_panel_support') ? getNewResizeBounds : $5e003176e44f49c4$var$getOldResizeBounds,
                resizingCssVar: $5e003176e44f49c4$var$panelSplitterResizingVar,
                position: "start",
                children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    className: (0, $bwpsq.default)([
                        $5e003176e44f49c4$var$styles.scrollContainer
                    ]),
                    children: children
                })
            })
        ]
    });
}

});

parcelRegister("jN4ko", function(module, exports) {

$parcel$export(module.exports, "SideNav", () => $581ab436f0c86e53$export$1a35787d6353cf6a);
/* side-nav.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $cBeZP = parcelRequire("cBeZP");

var $7nsd3 = parcelRequire("7nsd3");

var $cD7p8 = parcelRequire("cD7p8");

var $kwtKM = parcelRequire("kwtKM");
var $6wsVC = parcelRequire("6wsVC");
var $9cPKo = parcelRequire("9cPKo");

var $fHpHg = parcelRequire("fHpHg");

var $l5MhD = parcelRequire("l5MhD");

var $4nayr = parcelRequire("4nayr");

var $kU1q1 = parcelRequire("kU1q1");

var $ic23Y = parcelRequire("ic23Y");

var $6bvKu = parcelRequire("6bvKu");

var $aKoCG = parcelRequire("aKoCG");

var $4q7g7 = parcelRequire("4q7g7");

var $9qobs = parcelRequire("9qobs");

var $7KMzu = parcelRequire("7KMzu");

var $isowN = parcelRequire("isowN");

var $w2vcN = parcelRequire("w2vcN");

var $dGGJ2 = parcelRequire("dGGJ2");


var $cugaz = parcelRequire("cugaz");

var $1Qlos = parcelRequire("1Qlos");

var $e3mEE = parcelRequire("e3mEE");

var $cI131 = parcelRequire("cI131");

var $dDr3w = parcelRequire("dDr3w");

var $8t2il = parcelRequire("8t2il");
const $581ab436f0c86e53$var$panelSplitterResizingVar = '--n_snvRsz';
const $581ab436f0c86e53$var$widthResizeBounds = {
    min: '240px',
    max: '50vw'
};
function $581ab436f0c86e53$var$getResizeBounds() {
    return $581ab436f0c86e53$var$widthResizeBounds;
}
const $581ab436f0c86e53$var$openLayerObserverSideNavNamespace = 'side-nav';
const $581ab436f0c86e53$var$styles = {
    root: "_nd5l1b6c _bfhk1bhr _16qs1cd0 _vchhusvi _4t3i1run _152t1l7u _kqsw1if8 _1bsb1ego _1pbycs5v _14b5hc79 _qilnk0mc _4ap3vuon _scbpglyw",
    oldBorder: "_t51zzgxb",
    newBorder: "_t51zoyrj _z8dmmuej",
    newBorderFlyoutOpen: "_z8dm3acm",
    flyoutOpen: "_qiln1gzg _4ap31bhr _scbp1cd0 _139f8iot _1tpvfnf5 _sylc1a5r _oyeijq3t",
    flyoutAnimateClosed: "_1e0cglyw _qiln1gzg _139f8iot _1tpvfnf5 _sylc1a5r _1uwsjq3t",
    flexContainer: "_4t3i1osq _1e0c1txw _2lx21bp4 _1bah1yb4",
    hiddenMobileAndDesktop: "_1e0cglyw",
    hiddenMobileOnly: "_1e0cglyw _dm2518uv",
    hiddenDesktopOnly: "_dm25glyw"
};
/**
 * We need an additional component layer so we can wrap the side nav in a `OpenLayerObserver` and have access to the
 * context value.
 */ function $581ab436f0c86e53$var$SideNavInternal({ children: children, defaultCollapsed: defaultCollapsed, defaultWidth: defaultWidth = 320, testId: testId, label: label = 'Sidebar', skipLinkLabel: skipLinkLabel = label, onExpand: onExpand, onCollapse: onCollapse, id: providedId }) {
    const id = (0, $7KMzu.useLayoutId)({
        providedId: providedId
    });
    const expandSideNav = (0, $1Qlos.useExpandSideNav)();
    /**
   * Called after clicking on the side nav skip link, and ensures the side nav is expanded so that it is focusable.
   *
   * We need to update the DOM synchronously because `.focus()` is called synchronously after this state update.
   */ const synchronouslyExpandSideNav = (0, $5uXOq.useCallback)(()=>{
        (0, $7nsd3.flushSync)(()=>{
            /**
       * Calling this unconditionally and relying on it to avoid no-op renders.
       *
       * We _could_ call it conditionally, but we'd be duplicating the screen size checks `expandSideNav` makes.
       */ expandSideNav();
        });
    }, [
        expandSideNav
    ]);
    (0, $6bvKu.useSkipLinkInternal)({
        id: id,
        label: skipLinkLabel,
        onBeforeNavigate: synchronouslyExpandSideNav
    });
    const sideNavState = (0, $5uXOq.useContext)((0, $8t2il.SideNavVisibilityState));
    const setSideNavState = (0, $5uXOq.useContext)((0, $8t2il.SetSideNavVisibilityState));
    const { isExpandedOnDesktop: isExpandedOnDesktop, isExpandedOnMobile: isExpandedOnMobile } = (0, $e3mEE.useSideNavVisibility)({
        defaultCollapsed: defaultCollapsed
    });
    // We are placing `defaultCollapsed` into a state container so we can have a stable reference to the initial value.
    // This is so we can use it in an effect _that only runs once_, after the initial render on the client,
    // to sync the side nav context (provided in `<Root>`) with the `defaultCollapsed` prop provided to `<SideNav>`.
    const [initialDefaultCollapsed] = (0, $5uXOq.useState)(defaultCollapsed);
    const [width, setWidth] = (0, $5uXOq.useState)(defaultWidth);
    const clampedWidth = `clamp(${$581ab436f0c86e53$var$widthResizeBounds.min}, ${width}px, ${$581ab436f0c86e53$var$widthResizeBounds.max})`;
    const dangerouslyHoistSlotSizes = (0, $5uXOq.useContext)((0, $4q7g7.DangerouslyHoistSlotSizes));
    const navRef = (0, $5uXOq.useRef)(null);
    /**
   * Used to share the side nav element with the `Panel`,
   * which observes the side nav to determine its maximum width.
   */ const sharedRef = (0, $dGGJ2.useSideNavRef)();
    const mergedRef = (0, $cD7p8.default)([
        navRef,
        sharedRef
    ]);
    const toggleButtonElement = (0, $5uXOq.useContext)((0, $cugaz.SideNavToggleButtonElement));
    const homeActionsElement = (0, $5uXOq.useContext)((0, $ic23Y.HomeActionsElement));
    const devTimeOnlyAttributes = {};
    const openLayerObserver = (0, $9cPKo.useOpenLayerObserver)();
    const flyoutStateRef = (0, $5uXOq.useRef)({
        type: 'not-active'
    });
    const isFlyoutVisible = sideNavState?.flyout === 'open';
    const updateFlyoutState = (0, $5uXOq.useMemo)(()=>{
        function tryAbortPendingClose() {
            if (flyoutStateRef.current.type === 'waiting-for-close') flyoutStateRef.current.abort();
        }
        function open() {
            tryAbortPendingClose();
            flyoutStateRef.current = {
                type: 'open'
            };
            setSideNavState((currentState)=>{
                if (currentState?.desktop === 'collapsed' && currentState?.flyout !== 'open') return {
                    desktop: currentState.desktop,
                    mobile: currentState.mobile,
                    flyout: 'open'
                };
                return currentState;
            });
        }
        function close() {
            tryAbortPendingClose();
            flyoutStateRef.current = {
                type: 'not-active'
            };
            setSideNavState((currentState)=>{
                if (currentState?.desktop === 'collapsed' && currentState?.flyout === 'open') return {
                    desktop: currentState.desktop,
                    mobile: currentState.mobile,
                    flyout: 'triggered-animate-close'
                };
                return currentState;
            });
        }
        return function onAction(action) {
            if (action === 'drag-from-flyout-started') {
                open();
                flyoutStateRef.current = {
                    type: 'is-dragging-from-flyout'
                };
                return;
            }
            if (action === 'drag-from-flyout-finished') {
                open();
                return;
            }
            // ignoring all actions until the drag is finished
            if (flyoutStateRef.current.type === 'is-dragging-from-flyout') return;
            if (action === 'open') {
                open();
                return;
            }
            if (action === 'waiting-for-close') {
                if (flyoutStateRef.current.type === 'waiting-for-close') return;
                // A timeout is used to close the flyout after a delay when the user mouses out of the flyout area, and to allow
                // us to cancel the close if the user mouses back in.
                const timeout = setTimeout(()=>{
                    updateFlyoutState('ready-to-close');
                }, (0, $5353fba28a8bf24a$export$a7801e29f563faad));
                flyoutStateRef.current = {
                    type: 'waiting-for-close',
                    abort () {
                        clearTimeout(timeout);
                    }
                };
                return;
            }
            if (action === 'ready-to-close') {
                // If there are no open layers, we can close the flyout.
                if (openLayerObserver.getCount({
                    namespace: $581ab436f0c86e53$var$openLayerObserverSideNavNamespace
                }) === 0) {
                    close();
                    return;
                }
                flyoutStateRef.current = {
                    type: 'ready-to-close'
                };
                return;
            }
            if (action === 'force-close') {
                close();
                return;
            }
        };
    }, [
        openLayerObserver,
        setSideNavState
    ]);
    const toggleVisibility = (0, $dDr3w.useToggleSideNav)();
    (0, $5uXOq.useEffect)(()=>{
        // Sync the visibility in context (provided in `<Root>`) with the local `defaultCollapsed` prop provided to `SideNav`
        // after SSR hydration. This should only run once, after the initial render on the client.
        setSideNavState({
            desktop: initialDefaultCollapsed ? 'collapsed' : 'expanded',
            mobile: 'collapsed',
            flyout: 'closed'
        });
    }, [
        initialDefaultCollapsed,
        setSideNavState
    ]);
    const handleExpand = (0, $5uXOq.useCallback)(({ screen: screen })=>{
        onExpand?.({
            screen: screen
        });
        // When the side nav gets expanded, we close the flyout to reset it.
        // This prevents the flyout from staying open and ensures we are respecting the user's intent to expand.
        updateFlyoutState('force-close');
    }, [
        onExpand,
        updateFlyoutState
    ]);
    const handleCollapse = (0, $5uXOq.useCallback)(({ screen: screen })=>{
        onCollapse?.({
            screen: screen
        });
        // When the side nav gets collapsed, we close the flyout to reset it.
        // This prevents the flyout from staying open and ensures we are respecting the user's intent to collapse.
        updateFlyoutState('force-close');
    }, [
        onCollapse,
        updateFlyoutState
    ]);
    (0, $cI131.useSideNavVisibilityCallbacks)({
        onExpand: handleExpand,
        onCollapse: handleCollapse,
        isExpandedOnDesktop: isExpandedOnDesktop,
        isExpandedOnMobile: isExpandedOnMobile
    });
    (0, $5uXOq.useEffect)(()=>{
        const mediaQueryList = window.matchMedia('(min-width: 64rem)');
        return (0, $cBeZP.bind)(mediaQueryList, {
            type: 'change',
            listener () {
                if (mediaQueryList.matches) // We're transitioning from tablet to desktop viewport size.
                // We forcibly show the side nav if it was shown on mobile.
                {
                    if (isExpandedOnMobile && !isExpandedOnDesktop) toggleVisibility();
                }
            }
        });
    }, [
        toggleVisibility,
        isExpandedOnDesktop,
        isExpandedOnMobile
    ]);
    /**
   * Close the mobile side nav if there is a click outside.
   *
   * Binding/unbinding on changes to `isExpandedOnMobile` instead of window size changes for simplicity.
   * If we listened to window size changes we'd need nested `bind()` calls.
   */ (0, $5uXOq.useEffect)(()=>{
        if (!isExpandedOnMobile) return;
        if (!(0, $fHpHg.fg)('platform_design_system_side_nav_click_out_to_close')) // Checking the gate quite early for the best safety + perf measurements
        return;
        return (0, $cBeZP.bind)(window, {
            type: 'click',
            listener (event) {
                if (window.matchMedia('(min-width: 64rem)').matches) // Clicks on desktop should do nothing
                return;
                const sideNav = navRef.current;
                if (!sideNav || !(event.target instanceof Node)) // Ignore if our element references are invalid
                return;
                if (sideNav.contains(event.target)) // Clicks inside the side nav should not close it
                return;
                if (toggleButtonElement?.contains(event.target)) // Clicks on the toggle button will already toggle the side nav,
                // so we need to ignore it or we end up doing a double toggle
                return;
                toggleVisibility();
            }
        });
    }, [
        isExpandedOnMobile,
        toggleButtonElement,
        toggleVisibility
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!toggleButtonElement) return;
        return (0, $cBeZP.bind)(toggleButtonElement, {
            type: 'mouseenter',
            listener () {
                // Only flyout the side nav if the user hovered while the side nav was collapsed
                if (isExpandedOnDesktop) return;
                // Only flyout the side nav on desktop viewports
                const { matches: matches } = window.matchMedia('(min-width: 64rem)');
                if (matches) updateFlyoutState('open');
            }
        });
    }, [
        updateFlyoutState,
        toggleButtonElement,
        isExpandedOnDesktop
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!toggleButtonElement) return;
        return (0, $cBeZP.bind)(toggleButtonElement, {
            type: 'mouseleave',
            listener () {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (!isFlyoutVisible) return;
                updateFlyoutState('waiting-for-close');
            }
        });
    }, [
        isFlyoutVisible,
        toggleButtonElement,
        updateFlyoutState
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!navRef.current) return;
        return (0, $cBeZP.bind)(navRef.current, {
            type: 'mouseenter',
            listener () {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (isExpandedOnDesktop || !isFlyoutVisible) return;
                // The user mouses has moused back over the side nav
                updateFlyoutState('open');
            }
        });
    }, [
        isFlyoutVisible,
        updateFlyoutState,
        isExpandedOnDesktop
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!navRef.current) return;
        return (0, $cBeZP.bind)(navRef.current, {
            type: 'mouseleave',
            listener () {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (!isFlyoutVisible) return;
                updateFlyoutState('waiting-for-close');
            }
        });
    }, [
        isFlyoutVisible,
        updateFlyoutState
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const nav = navRef.current;
        if (!nav) return;
        if (!isFlyoutVisible) return;
        // Using a monitor rather than a drop target. Rationale:
        // - We are not creating a drop target for the users to drop on,
        //   we are just interested in listening to events within an element
        // - We do not want to impact `location.{*}.dropTargets` in events
        return (0, $4nayr.monitorForElements)({
            canMonitor ({ source: source }) {
                return nav.contains(source.element);
            },
            onGenerateDragPreview () {
                updateFlyoutState('drag-from-flyout-started');
            },
            onDrop ({ location: location }) {
                // Always marking the drag and done
                updateFlyoutState('drag-from-flyout-finished');
                // If the user dropped outside of the flyout, we will close the flyout
                const underUsersPointer = document.elementFromPoint(location.current.input.clientX, location.current.input.clientY);
                if (!nav.contains(underUsersPointer)) updateFlyoutState('waiting-for-close');
            }
        });
    }, [
        isFlyoutVisible,
        updateFlyoutState
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!homeActionsElement || !toggleButtonElement) return;
        return (0, $cBeZP.bind)(homeActionsElement, {
            type: 'mouseover',
            listener (event) {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (isExpandedOnDesktop || !isFlyoutVisible) return;
                if (event.target === homeActionsElement) {
                    // The mouse is directly over the home actions container, so cancel any pending flyout closes.
                    updateFlyoutState('open');
                    return;
                }
                if (event.target instanceof Element && toggleButtonElement.contains(event.target)) // The mouse is over the toggle button or any of its children, so we don't want to close the flyout.
                // We also don't need to cancel any pending closes, as we have separate event listeners for the toggle button mouse events.
                return;
                // The user has moused over a child element of the home actions container that isn't the toggle button, e.g. the app switcher or nav logo,
                // so we should close the flyout (with a delay).
                updateFlyoutState('waiting-for-close');
            }
        });
    }, [
        homeActionsElement,
        isFlyoutVisible,
        toggleButtonElement,
        isExpandedOnDesktop,
        updateFlyoutState
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!homeActionsElement) return;
        return (0, $cBeZP.bind)(homeActionsElement, {
            type: 'mouseleave',
            listener () {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (!isFlyoutVisible) return;
                // The mouse has left the home actions container, so we should close the flyout with a delay.
                updateFlyoutState('waiting-for-close');
            }
        });
    }, [
        homeActionsElement,
        isFlyoutVisible,
        updateFlyoutState
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // Close the flyout if there are no more layers open and the user is not mousing over the
        // flyout areas (side nav, top bar home actions element)
        return openLayerObserver.onChange(({ count: count })=>{
            if (flyoutStateRef.current.type === 'ready-to-close' && count === 0) updateFlyoutState('force-close');
        }, {
            namespace: $581ab436f0c86e53$var$openLayerObserverSideNavNamespace
        });
    }, [
        openLayerObserver,
        updateFlyoutState
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // Clear flyout close timer if being unmounted
        return function cleanupPendingFlyoutClose() {
            if (flyoutStateRef.current.type === 'waiting-for-close') flyoutStateRef.current.abort();
        };
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        if (!(0, $fHpHg.fg)('platform_design_system_nav4_preview_panel_support')) return;
        return (0, $l5MhD.combine)((0, $4nayr.monitorForElements)({
            canMonitor ({ source: source }) {
                return source.data.panelId === (0, $aKoCG.sideNavPanelSplitterId);
            },
            onDrag ({ source: source }) {
                if (!(0, $isowN.isPanelSplitterDragData)(source.data)) return;
                /**
         * Copies the resizing width value to the `<html>` element.
         *
         * Required to reflect the live width of the side navigation.
         *
         * Used by:
         *   - Legacy `--leftSidebarWidth` variable
         *   - Panel slot max-width constraint
         *
         * When the legacy `--leftSidebarWidth` variable is no longer needed,
         * we could consider writing to the `Panel` element instead.
         */ document.documentElement.style.setProperty($581ab436f0c86e53$var$panelSplitterResizingVar, source.data.resizingWidth);
            },
            onDrop () {
                document.documentElement.style.removeProperty($581ab436f0c86e53$var$panelSplitterResizingVar);
            }
        }));
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        if (!(0, $fHpHg.fg)('platform_design_system_nav4_preview_panel_support')) return;
        /**
     * Ensures that the resizing CSS var on the `<html>` element is cleaned up properly
     * if the component unmounts during a drag.
     */ return function cleanupGlobalResizingCssVar() {
            document.documentElement.style.removeProperty($581ab436f0c86e53$var$panelSplitterResizingVar);
        };
    }, []);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("nav", {
        id: id,
        ...devTimeOnlyAttributes,
        "data-layout-slot": true,
        "aria-label": label,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/enforce-style-prop
            [(0, $aKoCG.sideNavVar)]: clampedWidth
        },
        ref: (0, $fHpHg.fg)('platform_design_system_nav4_preview_panel_support') ? mergedRef : navRef,
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            $581ab436f0c86e53$var$styles.root,
            (0, $fHpHg.fg)('platform_design_system_nav4_sidenav_border') ? $581ab436f0c86e53$var$styles.newBorder : $581ab436f0c86e53$var$styles.oldBorder,
            isExpandedOnDesktop && !isExpandedOnMobile && !isFlyoutVisible && $581ab436f0c86e53$var$styles.hiddenMobileOnly,
            !isExpandedOnDesktop && isExpandedOnMobile && !isFlyoutVisible && $581ab436f0c86e53$var$styles.hiddenDesktopOnly,
            !isExpandedOnDesktop && !isExpandedOnMobile && !isFlyoutVisible && $581ab436f0c86e53$var$styles.hiddenMobileAndDesktop,
            sideNavState?.flyout === 'open' && $581ab436f0c86e53$var$styles.flyoutOpen,
            sideNavState?.flyout === 'open' && (0, $fHpHg.fg)('platform_design_system_nav4_sidenav_border') && $581ab436f0c86e53$var$styles.newBorderFlyoutOpen,
            sideNavState?.flyout === 'triggered-animate-close' && $581ab436f0c86e53$var$styles.flyoutAnimateClosed
        ]),
        children: [
            (0, $fHpHg.fg)('platform_design_system_nav4_preview_panel_support') && // This CSS var is used by the `Panel` slot to enforce its maximum width constraint.
            // When we remove the UNSAFE legacy usage, we can change this to `HoistCssVarToLocalGrid`
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9qobs.DangerouslyHoistCssVarToDocumentRoot), {
                variableName: (0, $aKoCG.sideNavLiveWidthVar),
                value: "0px",
                mediaQuery: (0, $kU1q1.media).above.md,
                responsiveValue: isExpandedOnDesktop ? `var(${$581ab436f0c86e53$var$panelSplitterResizingVar}, ${clampedWidth})` : 0
            }),
            dangerouslyHoistSlotSizes && ((0, $fHpHg.fg)('platform_design_system_nav4_preview_panel_support') ? // ------ START UNSAFE STYLES ------
            // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
            // When they aren't needed anymore we can delete them wholesale.
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9qobs.DangerouslyHoistCssVarToDocumentRoot), {
                variableName: (0, $aKoCG.UNSAFE_sideNavLayoutVar),
                value: `var(${(0, $aKoCG.sideNavLiveWidthVar)})`
            }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9qobs.DangerouslyHoistCssVarToDocumentRoot), {
                variableName: (0, $aKoCG.UNSAFE_sideNavLayoutVar),
                value: "0px",
                mediaQuery: (0, $kU1q1.media).above.md,
                responsiveValue: isExpandedOnDesktop ? clampedWidth : 0
            })),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $w2vcN.PanelSplitterProvider), {
                panelId: (0, $aKoCG.sideNavPanelSplitterId),
                panelRef: navRef,
                panelWidth: width,
                onCompleteResize: setWidth,
                getResizeBounds: $581ab436f0c86e53$var$getResizeBounds,
                resizingCssVar: $581ab436f0c86e53$var$panelSplitterResizingVar,
                isEnabled: isExpandedOnDesktop && !isFlyoutVisible,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    className: (0, $bwpsq.default)([
                        $581ab436f0c86e53$var$styles.flexContainer
                    ]),
                    children: children
                })
            })
        ]
    });
}
function $581ab436f0c86e53$export$1a35787d6353cf6a({ children: children, defaultCollapsed: defaultCollapsed, defaultWidth: defaultWidth = 320, testId: testId, label: label, skipLinkLabel: // Default value is defined in `SideNavInternal`
skipLinkLabel = label, onExpand: // Default value is defined in `SideNavInternal`
onExpand, onCollapse: onCollapse, id: id }) {
    // OpenLayerObserver is moving to `Root` when the feature flag is enabled.
    const Wrapper = (0, $fHpHg.fg)('platform_dst_open_layer_observer_close_layers') ? (0, $5uXOq.Fragment) : (0, $kwtKM.OpenLayerObserver);
    return /*#__PURE__*/ (0, $2OMIu.jsx)(Wrapper, {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6wsVC.OpenLayerObserverNamespaceProvider), {
            namespace: $581ab436f0c86e53$var$openLayerObserverSideNavNamespace,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)($581ab436f0c86e53$var$SideNavInternal, {
                defaultCollapsed: defaultCollapsed,
                defaultWidth: defaultWidth,
                testId: testId,
                label: label,
                skipLinkLabel: skipLinkLabel,
                onExpand: onExpand,
                onCollapse: onCollapse,
                id: id,
                children: children
            })
        })
    });
}

});
parcelRegister("6wsVC", function(module, exports) {

$parcel$export(module.exports, "OpenLayerObserverNamespaceProvider", () => $3b3d21f2f60faf54$export$327d0d2a7ae6f7cc);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $3joPi = parcelRequire("3joPi");

var $koa4a = parcelRequire("koa4a");

var $ldsRA = parcelRequire("ldsRA");
function $3b3d21f2f60faf54$export$327d0d2a7ae6f7cc({ children: children, namespace: namespace }) {
    // If there is an existing namespace context being provided, throw an invariant.
    // This use case is not supported at this time.
    const parentContext = (0, $ldsRA.useOpenLayerObserverNamespace)();
    (0, $5uXOq.useEffect)(()=>{
        (0, $3joPi.default)(parentContext === null, `An OpenLayerObserver namespace already exists in this component tree: ${parentContext}. Nesting OpenLayerObserverNamespaceProvider is not supported.`);
    }, [
        parentContext
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $koa4a.OpenLayerObserverNamespaceContext).Provider, {
        value: namespace,
        children: children
    });
}

});

parcelRegister("9cPKo", function(module, exports) {

$parcel$export(module.exports, "useOpenLayerObserver", () => $ebd92e2a51f81376$export$750f5b0d6c51617e);
$parcel$export(module.exports, "useOpenLayerObserverBehindFG", () => $ebd92e2a51f81376$export$e9cbca62806a89c8);

var $5uXOq = parcelRequire("5uXOq");

var $3joPi = parcelRequire("3joPi");

var $fHpHg = parcelRequire("fHpHg");

var $90wDB = parcelRequire("90wDB");
function $ebd92e2a51f81376$export$750f5b0d6c51617e() {
    const context = (0, $5uXOq.useContext)((0, $90wDB.OpenLayerObserverContext));
    (0, $3joPi.default)(context, 'useOpenLayerObserver must be used within an OpenLayerObserver');
    const publicAPI = (0, $5uXOq.useMemo)(()=>({
            getCount: context.getCount,
            onChange: context.onChange,
            closeLayers: context.closeLayers
        }), [
        context.getCount,
        context.onChange,
        context.closeLayers
    ]);
    return publicAPI;
}
function $ebd92e2a51f81376$export$e9cbca62806a89c8() {
    const context = (0, $5uXOq.useContext)((0, $90wDB.OpenLayerObserverContext));
    const publicAPI = (0, $5uXOq.useMemo)(()=>{
        if (!(0, $fHpHg.fg)('platform_dst_open_layer_observer_close_layers')) return null;
        if (!context) return null;
        return {
            getCount: context.getCount,
            onChange: context.onChange,
            closeLayers: context.closeLayers
        };
    }, [
        context
    ]);
    return publicAPI;
}

});

parcelRegister("isowN", function(module, exports) {

$parcel$export(module.exports, "isPanelSplitterDragData", () => $4f3ca2da195da8a9$export$e239b3966b677000);
$parcel$export(module.exports, "PanelSplitter", () => $4f3ca2da195da8a9$export$db67e3f8d3d6da0f);
/* panel-splitter.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $cBeZP = parcelRequire("cBeZP");

var $7nsd3 = parcelRequire("7nsd3");

var $3joPi = parcelRequire("3joPi");

var $jJsBW = parcelRequire("jJsBW");

var $hGKXL = parcelRequire("hGKXL");

var $9cPKo = parcelRequire("9cPKo");

var $fHpHg = parcelRequire("fHpHg");

var $l5MhD = parcelRequire("l5MhD");

var $4nayr = parcelRequire("4nayr");

var $2AQVt = parcelRequire("2AQVt");

var $lRCxc = parcelRequire("lRCxc");

var $6YRGu = parcelRequire("6YRGu");

var $cBCgC = parcelRequire("cBCgC");

var $6XZE5 = parcelRequire("6XZE5");

var $a62u0 = parcelRequire("a62u0");

var $53Gc5 = parcelRequire("53Gc5");

var $fKD9L = parcelRequire("fKD9L");

var $fgnqW = parcelRequire("fgnqW");

var $kLfVv = parcelRequire("kLfVv");
const $4f3ca2da195da8a9$var$containerStyles = {
    root: "_12ji1r31 _1qu2glyw _12y31o36 _1e0cglyw _kqswstnw _u7coidpf _152tidpf _1pbykb7n _181n1ule",
    positionEnd: "_rjxpftgi",
    positionStart: "_1e02zeo2"
};
const $4f3ca2da195da8a9$var$grabAreaStyles = {
    root: "_1bsbl52n _4t3i1osq _kqswstnw _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _syaz3acm _bfhk18uv _k8m01ylx _1oec1yx9 _1lww5cps _d0aluf7j _1gavfnf5 _vp7gaqb7 _30l3aqb7 _1dr21ylx _1s5z1ylx _1cg4fnf5 _le1bfnf5 _1gglglyw _9h8h16c2"
};
const $4f3ca2da195da8a9$var$lineStyles = {
    root: "_kqswstnw _1e0c1ule _1bsbjfq9 _4t3i1osq _syaz1kw7 _bfhk1r31 _1e021v6z"
};
const $4f3ca2da195da8a9$var$panelSplitterDragDataSymbol = Symbol('panel-splitter-drag-data');
function $4f3ca2da195da8a9$var$signPanelSplitterDragData(data) {
    return {
        ...data,
        [$4f3ca2da195da8a9$var$panelSplitterDragDataSymbol]: true
    };
}
function $4f3ca2da195da8a9$export$e239b3966b677000(data) {
    return data[$4f3ca2da195da8a9$var$panelSplitterDragDataSymbol] === true;
}
const $4f3ca2da195da8a9$var$PortaledPanelSplitter = ({ label: label, onResizeStart: onResizeStart, onResizeEnd: onResizeEnd, testId: testId })=>{
    const splitterRef = (0, $5uXOq.useRef)(null);
    const panelSplitterContext = (0, $5uXOq.useContext)((0, $6XZE5.PanelSplitterContext));
    (0, $3joPi.default)(panelSplitterContext, 'Panel splitter context must be set');
    const { panelId: panelId, panelWidth: panelWidth, onCompleteResize: onCompleteResize, getResizeBounds: getResizeBounds, panelRef: panelRef, resizingCssVar: resizingCssVar, portalRef: portalRef, position: position, isEnabled: isEnabled } = panelSplitterContext;
    (0, $3joPi.default)(portalRef.current, 'Portal ref must be set');
    const direction = (0, $kLfVv.useTextDirection)(portalRef.current);
    const labelId = (0, $jJsBW.useId)();
    // Separate state used for the input range width to remove the UI's dependency on the "persisted" layout state value being updated
    const [rangeInputValue, setRangeInputValue] = (0, $5uXOq.useState)(panelWidth);
    /**
   * We are using state to store the resize bounds _converted into pixel units_, so that we can update them when the window is resized.
   * Otherwise they can become out of sync with the actual viewport size, and cause a broken experience (inaccurate width percentage)
   * when the user tries to resize using the keyboard.
   */ const [rangeInputBounds, setRangeInputBounds] = (0, $5uXOq.useState)({
        // Using placeholder values here for the initial render. These will be calculated and updated when the range input is focused.
        min: 200,
        max: 500
    });
    const openLayerObserver = (0, $9cPKo.useOpenLayerObserverBehindFG)();
    (0, $5uXOq.useEffect)(()=>{
        if (!isEnabled) return;
        const splitter = splitterRef.current;
        (0, $3joPi.default)(splitter, 'Splitter ref must be set');
        return (0, $l5MhD.combine)((0, $2AQVt.blockDraggingToIFrames)({
            element: splitter
        }), (0, $4nayr.draggable)({
            element: splitter,
            onGenerateDragPreview: ({ nativeSetDragImage: nativeSetDragImage })=>{
                // We will be moving the line to indicate a drag. We can disable the native drag preview
                (0, $lRCxc.disableNativeDragPreview)({
                    nativeSetDragImage: nativeSetDragImage
                });
                // We don't want any native drop animation for when the user does not drop on a drop target. We want the drag to finish immediately
                (0, $6YRGu.preventUnhandled).start();
            },
            getInitialData () {
                (0, $3joPi.default)(panelRef.current, 'Panel ref must be set');
                const initialWidth = (0, $fKD9L.getPixelWidth)(panelRef.current);
                /**
         * The drag calculations require the actual computed width of the element
         * For example, if the panel has loaded with a width of 2000px, but the max bound is 1000px and is visually 1000px (due to the CSS `clamp()`),
         * the drag calculations should use the actual width of 1000px, not the width in state of 2000px.
         */ return $4f3ca2da195da8a9$var$signPanelSplitterDragData({
                    panelId: panelId,
                    initialWidth: initialWidth,
                    resizingWidth: `${initialWidth}px`,
                    resizeBounds: getResizeBounds()
                });
            },
            onDragStart ({ source: source }) {
                (0, $3joPi.default)($4f3ca2da195da8a9$export$e239b3966b677000(source.data));
                onResizeStart?.({
                    initialWidth: source.data.initialWidth
                });
                // Close any open layers when the user starts resizing
                if ((0, $fHpHg.fg)('platform_dst_open_layer_observer_close_layers')) openLayerObserver?.closeLayers();
            },
            onDrag ({ location: location, source: source }) {
                (0, $3joPi.default)($4f3ca2da195da8a9$export$e239b3966b677000(source.data));
                const { initialWidth: initialWidth, resizeBounds: resizeBounds } = source.data;
                /**
         * How wide the element would be if there were no width constraints,
         * based on the pointer's position.
         */ const targetWidth = (0, $fKD9L.getWidthFromDragLocation)({
                    initialWidth: initialWidth,
                    location: location,
                    direction: direction,
                    position: position
                });
                const resizingWidth = `clamp(${resizeBounds.min}, ${targetWidth}px, ${resizeBounds.max})`;
                panelRef.current?.style.setProperty(resizingCssVar, resizingWidth);
                source.data.resizingWidth = resizingWidth;
            },
            onDrop ({ source: source }) {
                (0, $3joPi.default)($4f3ca2da195da8a9$export$e239b3966b677000(source.data));
                (0, $6YRGu.preventUnhandled).stop();
                (0, $3joPi.default)(panelRef.current, 'Panel ref must be set');
                (0, $3joPi.default)($4f3ca2da195da8a9$export$e239b3966b677000(source.data));
                const finalWidth = (0, $fKD9L.getPixelWidth)(panelRef.current);
                onCompleteResize(finalWidth);
                onResizeEnd?.({
                    initialWidth: source.data.initialWidth,
                    finalWidth: finalWidth
                });
                panelRef.current.style.removeProperty(resizingCssVar);
            }
        }));
    }, [
        onCompleteResize,
        onResizeStart,
        onResizeEnd,
        panelRef,
        resizingCssVar,
        panelWidth,
        direction,
        position,
        isEnabled,
        openLayerObserver,
        panelId,
        getResizeBounds
    ]);
    const onResizeStartStableRef = (0, $hGKXL.default)(onResizeStart);
    const onResizeEndStableRef = (0, $hGKXL.default)(onResizeEnd);
    const [keyboardResizeManager] = (0, $5uXOq.useState)(()=>(0, $fgnqW.createKeyboardResizeManager)({
            onResizeStart: (...args)=>{
                // Close any open layers when the user starts resizing with keyboard
                if ((0, $fHpHg.fg)('platform_dst_open_layer_observer_close_layers')) openLayerObserver?.closeLayers();
                onResizeStartStableRef.current?.(...args);
            },
            onResizeEnd: (...args)=>onResizeEndStableRef.current?.(...args)
        }));
    const handleSliderInputChange = (0, $5uXOq.useCallback)((event)=>{
        const value = parseInt(event.target.value);
        setRangeInputValue(value);
        /**
     * We are intentionally _not_ debouncing `onCompleteResize` as we want it to be called anytime the user changes the range input value.
     * It is an internal-only callback - it's provided by `PanelSplitterProvider`, and used by layout slots to update their layout width state.
     */ onCompleteResize(value);
        keyboardResizeManager.onResize({
            initialWidth: panelWidth,
            finalWidth: value
        });
    }, [
        onCompleteResize,
        panelWidth,
        keyboardResizeManager
    ]);
    const resizeEventListenerCleanupFn = (0, $5uXOq.useRef)(null);
    const handleSliderFocus = (0, $5uXOq.useCallback)(()=>{
        /**
     * We are only updating the range input's properties when the element is focused, as a performance optimisation.
     * It isn't necessary to recalculate these values until the element is going to be used.
     */ // Clean up any left over listeners in case `focus` was triggered again without `blur`.
        resizeEventListenerCleanupFn.current?.();
        // Update the range input value to match the current panel width.
        setRangeInputValue(panelWidth);
        const resizeBounds = getResizeBounds();
        // Update the range input bounds to ensure they are accurate (in case the viewport was previously resized)
        setRangeInputBounds({
            min: (0, $a62u0.convertResizeBoundToPixels)(resizeBounds.min),
            max: (0, $a62u0.convertResizeBoundToPixels)(resizeBounds.max)
        });
        /**
     * _While the slider element is focused_, add a window resize event listener to update the range input bounds
     * when the window is resized. This is needed to ensure the min and max widths accurately reflect the viewport
     * size - in case they are provided in vw units.
     *
     * This listener is cleaned up when the element is blurred.
     */ resizeEventListenerCleanupFn.current = (0, $cBeZP.bind)(window, {
            type: 'resize',
            listener: function updateState() {
                const resizeBounds = getResizeBounds();
                setRangeInputBounds({
                    min: (0, $a62u0.convertResizeBoundToPixels)(resizeBounds.min),
                    max: (0, $a62u0.convertResizeBoundToPixels)(resizeBounds.max)
                });
            }
        });
    }, [
        panelWidth,
        getResizeBounds
    ]);
    const handleSliderBlur = (0, $5uXOq.useCallback)(()=>{
        // Remove the resize event listener when the range input is blurred.
        resizeEventListenerCleanupFn.current?.();
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        return function cleanup() {
            // Cleanup the resize event listener when the component is unmounted.
            resizeEventListenerCleanupFn.current?.();
        };
    }, []);
    const ariaValueText = (0, $5uXOq.useMemo)(()=>`${(0, $53Gc5.getPercentageWithinPixelBounds)({
            currentWidth: rangeInputValue,
            resizeBounds: rangeInputBounds
        })}% width`, [
        rangeInputValue,
        rangeInputBounds
    ]);
    if (!isEnabled) return null;
    return /*#__PURE__*/ (0, $7nsd3.createPortal)(/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": testId ? `${testId}-container` : undefined,
        className: (0, $bwpsq.default)([
            $4f3ca2da195da8a9$var$containerStyles.root,
            position === 'start' && $4f3ca2da195da8a9$var$containerStyles.positionStart,
            position === 'end' && $4f3ca2da195da8a9$var$containerStyles.positionEnd
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
            ref: splitterRef,
            "data-testid": testId,
            className: (0, $bwpsq.default)([
                $4f3ca2da195da8a9$var$grabAreaStyles.root
            ]),
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $cBCgC.default), {
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)("input", {
                            type: "range",
                            value: rangeInputValue,
                            step: 20,
                            min: rangeInputBounds.min,
                            max: rangeInputBounds.max,
                            "aria-valuetext": ariaValueText,
                            "aria-labelledby": labelId,
                            onChange: handleSliderInputChange,
                            onFocus: handleSliderFocus,
                            onBlur: handleSliderBlur
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                            id: labelId,
                            children: label
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                    className: (0, $bwpsq.default)([
                        $4f3ca2da195da8a9$var$lineStyles.root
                    ])
                })
            ]
        })
    }), portalRef.current);
};
// Ensures that the component is only rendered on a client. Uses a `useEffect`, which is not run on servers.
const $4f3ca2da195da8a9$var$ClientOnly = ({ children: children })=>{
    const [hasMounted, setHasMounted] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        setHasMounted(true);
    }, []);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Fragment), {
        children: hasMounted ? children : null
    });
};
const $4f3ca2da195da8a9$export$db67e3f8d3d6da0f = ({ label: label, onResizeStart: onResizeStart, onResizeEnd: onResizeEnd, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)($4f3ca2da195da8a9$var$ClientOnly, {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($4f3ca2da195da8a9$var$PortaledPanelSplitter, {
            label: label,
            onResizeStart: onResizeStart,
            onResizeEnd: onResizeEnd,
            testId: testId
        })
    });

});
parcelRegister("a62u0", function(module, exports) {

$parcel$export(module.exports, "convertResizeBoundToPixels", () => $33f341ba639a611a$export$3d412b3011b66f82);
function $33f341ba639a611a$export$3d412b3011b66f82(resizeBound) {
    if (resizeBound.endsWith('vw')) {
        // Max width was provided in `vw` units, so is relative to the viewport width.
        // e.g. 50vw = 50% of the viewport width.
        // `parseInt` will remove the `vw` suffix.
        const maxWidthFraction = parseInt(resizeBound) / 100;
        return Math.floor(window.innerWidth * maxWidthFraction);
    }
    // Max width was provided in `px` units, so we can parse it directly.
    // `parseInt` will remove the `px` suffix.
    return Math.floor(parseInt(resizeBound));
}

});

parcelRegister("53Gc5", function(module, exports) {

$parcel$export(module.exports, "getPercentageWithinPixelBounds", () => $233bdf6185a388e4$export$b5423678cdf09f5);
function $233bdf6185a388e4$export$b5423678cdf09f5({ currentWidth: currentWidth, resizeBounds: resizeBounds }) {
    const resizeRange = resizeBounds.max - resizeBounds.min;
    const widthAsPercentage = (currentWidth - resizeBounds.min) / resizeRange * 100;
    if (widthAsPercentage < 0) return 0;
    if (widthAsPercentage > 100) return 100;
    return Math.floor(widthAsPercentage);
}

});

parcelRegister("fKD9L", function(module, exports) {

$parcel$export(module.exports, "getWidthFromDragLocation", () => $1f77da03c1c23958$export$e360234971cb95b8);
$parcel$export(module.exports, "getPixelWidth", () => $1f77da03c1c23958$export$d942790ad00c41f9);
const $1f77da03c1c23958$export$e360234971cb95b8 = ({ initialWidth: initialWidth, location: location, direction: direction, position: position })=>{
    const diffX = location.current.input.clientX - location.initial.input.clientX;
    // Resize line is positioned at the inline-end (right) of the element.
    // If the direction is left-to-right, the width will increase when the mouse is moved to the right, and vice versa.
    if (position === 'end') return direction === 'ltr' ? initialWidth + diffX : initialWidth - diffX;
    // Resize line is positioned at the inline-start (left) of the element.
    // If the direction is left-to-right, the width will decrease when the mouse is moved to the right, and vice versa.
    return direction === 'ltr' ? initialWidth - diffX : initialWidth + diffX;
};
const $1f77da03c1c23958$export$d942790ad00c41f9 = (element)=>{
    const { width: width } = window.getComputedStyle(element);
    return parseInt(width);
};

});

parcelRegister("fgnqW", function(module, exports) {

$parcel$export(module.exports, "createKeyboardResizeManager", () => $4ae38e8dfa859310$export$f7d3d5dae65f74aa);
/**
 * The debounce time for the PanelSplitter resize callback functions.
 *
 * - For `onResizeStart`, it will call the callback immediately, but not
 * again until the user stops resizing and this wait time has passed.
 * - For `onResizeEnd`, it will call the callback only after this time has
 * passed since the last resize event.
 */ const $4ae38e8dfa859310$var$resizeCallbackDebounceTimeMs = 500;
function $4ae38e8dfa859310$export$f7d3d5dae65f74aa({ onResizeStart: onResizeStart, onResizeEnd: onResizeEnd }) {
    let resizingState = {
        type: 'idle'
    };
    /**
	 * Starts a timer to reset the state to idle and call `onResizeEnd` after a wait time.
	 */ function startResizeEndTimer({ initialWidth: initialWidth, finalWidth: finalWidth }) {
        const markResizeAsEndedTimeout = setTimeout(()=>{
            onResizeEnd({
                initialWidth: initialWidth,
                finalWidth: finalWidth
            });
            resizingState = {
                type: 'idle'
            };
        }, $4ae38e8dfa859310$var$resizeCallbackDebounceTimeMs);
        resizingState = {
            type: 'resizing',
            initialWidth: initialWidth,
            abort () {
                clearTimeout(markResizeAsEndedTimeout);
            }
        };
    }
    function onResize({ initialWidth: initialWidth, finalWidth: finalWidth }) {
        if (resizingState.type === 'idle') {
            // If the state was idle, this counts as a resize start event.
            onResizeStart({
                initialWidth: initialWidth
            });
            startResizeEndTimer({
                initialWidth: initialWidth,
                finalWidth: finalWidth
            });
            return;
        }
        if (resizingState.type === 'resizing') {
            // If the state was already resizing, clear the existing timeout and start a new one.
            resizingState.abort();
            startResizeEndTimer({
                initialWidth: resizingState.initialWidth,
                finalWidth: finalWidth
            });
            return;
        }
    }
    return {
        onResize: onResize
    };
}

});

parcelRegister("kLfVv", function(module, exports) {

$parcel$export(module.exports, "useTextDirection", () => $2d32442f94ec60a6$export$cf24a79f32f45545);

var $5uXOq = parcelRequire("5uXOq");
const $2d32442f94ec60a6$export$cf24a79f32f45545 = (element)=>(0, $5uXOq.useMemo)(()=>{
        const { direction: direction } = window.getComputedStyle(element);
        return direction === 'rtl' ? 'rtl' : 'ltr';
    }, [
        element
    ]);

});


// Note: this value has been pulled into a separate file to better
// support testing with Playwright. Playwright did not like importing
// an exported value from `sidenav.tsx` which has `@jsxRuntime classic`.
//
// Error:
// > importSource cannot be set when runtime is classic.
/**
 * How long the flyout should remain open after the users
 * pointer has left the side nav flyout
 */ const $5353fba28a8bf24a$export$a7801e29f563faad = 400;

parcelRegister("1Qlos", function(module, exports) {

$parcel$export(module.exports, "useExpandSideNav", () => $2ee534ca2f81f058$export$e44b4744d8ff971a);

var $5uXOq = parcelRequire("5uXOq");

var $3joPi = parcelRequire("3joPi");

var $8t2il = parcelRequire("8t2il");
function $2ee534ca2f81f058$export$e44b4744d8ff971a() {
    const setSideNavState = (0, $5uXOq.useContext)((0, $8t2il.SetSideNavVisibilityState));
    const expandSideNav = (0, $5uXOq.useCallback)(()=>{
        const { matches: matches } = window.matchMedia('(min-width: 64rem)');
        if (matches) setSideNavState((currentState)=>{
            (0, $3joPi.default)(currentState, 'Side nav state should not be null');
            // Skip the re-render if it's a no-op change
            if (currentState.desktop === 'expanded' && currentState.flyout === 'closed') return currentState;
            return {
                mobile: currentState.mobile,
                desktop: 'expanded',
                flyout: 'closed'
            };
        });
        else setSideNavState((currentState)=>{
            (0, $3joPi.default)(currentState, 'Side nav state should not be null');
            // Skip the re-render if it's a no-op change
            if (currentState.mobile === 'expanded' && currentState.flyout === 'closed') return currentState;
            return {
                desktop: currentState.desktop,
                mobile: 'expanded',
                flyout: 'closed'
            };
        });
    }, [
        setSideNavState
    ]);
    return expandSideNav;
}

});

parcelRegister("cI131", function(module, exports) {

$parcel$export(module.exports, "useSideNavVisibilityCallbacks", () => $a0269d4165307a59$export$1904b8f2577aba9a);

var $5uXOq = parcelRequire("5uXOq");

var $jOvxk = parcelRequire("jOvxk");
function $a0269d4165307a59$export$1904b8f2577aba9a({ onExpand: onExpand, onCollapse: onCollapse, isExpandedOnDesktop: isExpandedOnDesktop, isExpandedOnMobile: isExpandedOnMobile }) {
    // Wrapping in refs so we can call them in `useEffect` without changes to them triggering the `useEffect`
    const onExpandRef = (0, $5uXOq.useRef)(onExpand);
    const onCollapseRef = (0, $5uXOq.useRef)(onCollapse);
    (0, $5uXOq.useEffect)(()=>{
        onExpandRef.current = onExpand;
        onCollapseRef.current = onCollapse;
    }, [
        onExpand,
        onCollapse
    ]);
    const previousIsExpandedOnDesktop = (0, $jOvxk.default)(isExpandedOnDesktop);
    (0, $5uXOq.useEffect)(()=>{
        if (previousIsExpandedOnDesktop === undefined || previousIsExpandedOnDesktop === isExpandedOnDesktop) /**
			 * The previous value is `undefined` on initialization, so if it is `undefined` then the value hasn't changed.
			 *
			 * The previous value can be equal to the current one if the component re-renders due to something else changing.
			 *
			 * In both cases the value hasn't changed and we don't want to notify consumers.
			 */ return;
        if (isExpandedOnDesktop) onExpandRef.current?.({
            screen: 'desktop'
        });
        else onCollapseRef.current?.({
            screen: 'desktop'
        });
    }, [
        previousIsExpandedOnDesktop,
        isExpandedOnDesktop
    ]);
    const previousIsExpandedOnMobile = (0, $jOvxk.default)(isExpandedOnMobile);
    (0, $5uXOq.useEffect)(()=>{
        if (previousIsExpandedOnMobile === undefined || previousIsExpandedOnMobile === isExpandedOnMobile) /**
			 * The previous value is `undefined` on initialization, so if it is `undefined` then the value hasn't changed.
			 *
			 * The previous value can be equal to the current one if the component re-renders due to something else changing.
			 *
			 * In both cases the value hasn't changed and we don't want to notify consumers.
			 */ return;
        if (isExpandedOnMobile) onExpandRef.current?.({
            screen: 'mobile'
        });
        else onCollapseRef.current?.({
            screen: 'mobile'
        });
    }, [
        previousIsExpandedOnMobile,
        isExpandedOnMobile
    ]);
}

});


parcelRegister("fZJPK", function(module, exports) {

$parcel$export(module.exports, "TopBar", () => $12dff1c2cb804642$export$c4e96258f3b6511);
/* top-bar.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fHpHg = parcelRequire("fHpHg");

var $6bvKu = parcelRequire("6bvKu");

var $bRH8U = parcelRequire("bRH8U");

var $lNj61 = parcelRequire("lNj61");

var $aKoCG = parcelRequire("aKoCG");

var $4q7g7 = parcelRequire("4q7g7");

var $9qobs = parcelRequire("9qobs");

var $7KMzu = parcelRequire("7KMzu");
const $12dff1c2cb804642$var$styles = {
    root: "_nd5l8cbt _zulpu2gc _18zrutpp _179rzgxb _1e0c11p5 _yv0e1mfv _4cvr1h6o _bfhkvuon _vchhusvi _4t3i2mmk _152t1nws _kqsw1if8 _1pbyegat _d6vu1bgi",
    oldLayoutStyles: "_1rqtc57g",
    newLayoutStyles: "_1j8b18ax"
};
function $12dff1c2cb804642$export$c4e96258f3b6511({ children: children, xcss: xcss, UNSAFE_height: UNSAFE_height = 48, skipLinkLabel: skipLinkLabel = 'Top Bar', testId: testId, id: providedId, UNSAFE_theme: UNSAFE_theme }) {
    const dangerouslyHoistSlotSizes = (0, $5uXOq.useContext)((0, $4q7g7.DangerouslyHoistSlotSizes));
    const id = (0, $7KMzu.useLayoutId)({
        providedId: providedId
    });
    (0, $6bvKu.useSkipLink)(id, skipLinkLabel);
    const customTheme = (0, $lNj61.useCustomTheme)(UNSAFE_theme);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bRH8U.HasCustomThemeContext).Provider, {
        value: customTheme.isEnabled,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)("header", {
            id: id,
            "data-layout-slot": true,
            className: (0, $bwpsq.default)([
                $12dff1c2cb804642$var$styles.root,
                (0, $fHpHg.fg)('platform_design_system_nav4_top_nav_columns') ? $12dff1c2cb804642$var$styles.newLayoutStyles : $12dff1c2cb804642$var$styles.oldLayoutStyles,
                xcss
            ]),
            "data-testid": testId,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            style: customTheme.isEnabled ? customTheme.style : undefined,
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9qobs.HoistCssVarToLocalGrid), {
                    variableName: (0, $aKoCG.topBarMountedVar),
                    value: UNSAFE_height
                }),
                dangerouslyHoistSlotSizes && // ------ START UNSAFE STYLES ------
                // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
                // When they aren't needed anymore we can delete them wholesale.
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9qobs.DangerouslyHoistCssVarToDocumentRoot), {
                    variableName: (0, $aKoCG.UNSAFE_topBarVar),
                    value: UNSAFE_height
                }),
                children
            ]
        })
    });
}

});
parcelRegister("lNj61", function(module, exports) {

$parcel$export(module.exports, "useCustomTheme", () => $d217379b2a7c42e7$export$c0c5f5b297b77726);

var $5uXOq = parcelRequire("5uXOq");

var $gaKON = parcelRequire("gaKON");
function $d217379b2a7c42e7$export$c0c5f5b297b77726(theme) {
    const value = (0, $5uXOq.useMemo)(()=>{
        if (!theme?.backgroundColor || !theme?.highlightColor) return {
            isEnabled: false
        };
        /**
			 * Re-creating the `theme` object from it's pieces.
			 *
			 * _Technically_ we could just use `theme`, but that would involve an eslint opt out
			 * as we would be leveraging a value (`theme`) not in the dependency array.
			 *
			 * The current approach is the most correct™️ and avoids foot guns.
			 * We are only using values in the effect that are defined in the dependency array 🙌
			 */ const value = {
            backgroundColor: theme.backgroundColor,
            highlightColor: theme.highlightColor
        };
        const style = (0, $gaKON.getCustomThemeStyles)(value);
        if (!style) // Either the `backgroundColor` or `highlightColor` could not be parsed
        return {
            isEnabled: false
        };
        return {
            isEnabled: true,
            style: style
        };
    }, // Using individual properties as keys for improved memoization.
    // Now this effect will only run if the values change rather than
    // the reference to the object (which might be new on every call)
    [
        theme?.backgroundColor,
        theme?.highlightColor
    ]);
    return value;
}

});
parcelRegister("gaKON", function(module, exports) {

$parcel$export(module.exports, "getCustomThemeStyles", () => $cb8f839578527569$export$3986d75fe2da3239);

var $kHBTM = parcelRequire("kHBTM");

var $14ccF = parcelRequire("14ccF");

var $wiKJc = parcelRequire("wiKJc");

var $5Vk5I = parcelRequire("5Vk5I");

var $lMlt0 = parcelRequire("lMlt0");

var $h3DPn = parcelRequire("h3DPn");
function $cb8f839578527569$var$toRGBString({ r: r, g: g, b: b }) {
    return `rgb(${r}, ${g}, ${b})`;
}
function $cb8f839578527569$var$toRGBAString({ r: r, g: g, b: b, a: a }) {
    return `rgba(${r}, ${g}, ${b}, ${a})`;
}
// Using raw hex codes because custom colors break out of the tokens model
// We will need to invert the colors based on backgroundColor independently of the app's color mode (dark/light)
// Values here are not final
const $cb8f839578527569$var$buttonStyles = {
    light: {
        [(0, $14ccF.themedButtonBackground)]: 'transparent',
        [(0, $14ccF.themedButtonBackgroundHovered)]: (0, $lMlt0.palette).Neutral200A,
        [(0, $14ccF.themedButtonBackgroundPressed)]: (0, $lMlt0.palette).Neutral300A,
        [(0, $14ccF.themedButtonBorder)]: (0, $lMlt0.palette).Neutral300A,
        [(0, $14ccF.themedButtonSelectedBackground)]: (0, $lMlt0.palette).Neutral300A,
        [(0, $14ccF.themedButtonSelectedBackgroundHovered)]: (0, $lMlt0.palette).Neutral400A,
        [(0, $14ccF.themedButtonSelectedBackgroundPressed)]: (0, $lMlt0.palette).Neutral500A,
        [(0, $14ccF.themedButtonDisabledText)]: (0, $lMlt0.palette).Neutral400A,
        [(0, $14ccF.themedButtonDisabledBackground)]: (0, $lMlt0.palette).Neutral100A
    },
    dark: {
        [(0, $14ccF.themedButtonBackground)]: 'transparent',
        [(0, $14ccF.themedButtonBackgroundHovered)]: (0, $lMlt0.palette).DarkNeutral200A,
        [(0, $14ccF.themedButtonBackgroundPressed)]: (0, $lMlt0.palette).DarkNeutral300A,
        [(0, $14ccF.themedButtonBorder)]: (0, $lMlt0.palette).DarkNeutral300A,
        [(0, $14ccF.themedButtonSelectedBackground)]: (0, $lMlt0.palette).DarkNeutral300A,
        [(0, $14ccF.themedButtonSelectedBackgroundHovered)]: (0, $lMlt0.palette).DarkNeutral400A,
        [(0, $14ccF.themedButtonSelectedBackgroundPressed)]: (0, $lMlt0.palette).DarkNeutral500A,
        [(0, $14ccF.themedButtonDisabledText)]: (0, $lMlt0.palette).DarkNeutral400A,
        [(0, $14ccF.themedButtonDisabledBackground)]: (0, $lMlt0.palette).DarkNeutral100A
    }
};
const $cb8f839578527569$var$logoStyles = {
    light: {
        [(0, $kHBTM.themedLogoIcon)]: (0, $lMlt0.palette).DarkNeutral0,
        [(0, $kHBTM.themedLogoText)]: (0, $lMlt0.palette).DarkNeutral0
    },
    dark: {
        [(0, $kHBTM.themedLogoIcon)]: (0, $lMlt0.palette).Neutral0,
        [(0, $kHBTM.themedLogoText)]: (0, $lMlt0.palette).Neutral0
    }
};
function $cb8f839578527569$export$3986d75fe2da3239({ backgroundColor: backgroundColor, highlightColor: highlightColor }) {
    const backgroundRgb = typeof backgroundColor === 'string' ? (0, $5Vk5I.parseHex)(backgroundColor) : backgroundColor;
    const highlightRgb = typeof highlightColor === 'string' ? (0, $5Vk5I.parseHex)(highlightColor) : highlightColor;
    if (!backgroundRgb || !highlightRgb) return null;
    const textColor = (0, $wiKJc.getTextColor)(backgroundRgb);
    const colorMode = (0, $wiKJc.getColorMode)(backgroundRgb);
    const highlightTextColor = (0, $wiKJc.getTextColor)(highlightRgb);
    return {
        backgroundColor: $cb8f839578527569$var$toRGBString(backgroundRgb),
        color: textColor.hex,
        ...$cb8f839578527569$var$buttonStyles[colorMode],
        ...$cb8f839578527569$var$logoStyles[colorMode],
        ...$cb8f839578527569$var$getSelectedStyles({
            backgroundColor: backgroundRgb,
            colorMode: colorMode
        }),
        /**
		 * Search colors are the same as Nav 3
		 */ [(0, $h3DPn.themedSearchBorder)]: $cb8f839578527569$var$toRGBAString({
            ...textColor.rgb,
            a: 0.5
        }),
        [(0, $h3DPn.themedSearchBorderFocused)]: $cb8f839578527569$var$toRGBAString({
            ...highlightRgb,
            a: 0.8
        }),
        /**
		 * Primary button colors are the same as Nav 3,
		 * except the text color which can sometimes differ because we're
		 * now following WCAG
		 */ [(0, $14ccF.themedButtonPrimaryBackground)]: $cb8f839578527569$var$toRGBString(highlightRgb),
        [(0, $14ccF.themedButtonPrimaryBackgroundHovered)]: $cb8f839578527569$var$toRGBAString({
            ...highlightRgb,
            a: 0.8
        }),
        [(0, $14ccF.themedButtonPrimaryBackgroundPressed)]: $cb8f839578527569$var$toRGBAString({
            ...highlightRgb,
            a: 0.65
        }),
        [(0, $14ccF.themedButtonPrimaryText)]: highlightTextColor.hex
    };
}
/**
 * Precomputed RGBA values for the selected backgrounds
 */ const $cb8f839578527569$var$selectedBackgroundRGBA = {
    light: (0, $lMlt0.paletteRgba).Neutral300A,
    dark: (0, $lMlt0.paletteRgba).DarkNeutral300A
};
function $cb8f839578527569$var$getSelectedStyles({ backgroundColor: backgroundColor, colorMode: colorMode }) {
    /**
	 * The background color of the selected button in its default state.
	 *
	 * We are referring to this as a foreground color because it is semi-transparent,
	 * so is not the actual color displayed when the button is on top of a background color.
	 */ const foregroundColor = $cb8f839578527569$var$selectedBackgroundRGBA[colorMode];
    /**
	 * The blended color seen when the selected background is over the top bar.
	 */ const blendedBackground = (0, $wiKJc.simpleAlphaComposite)({
        background: backgroundColor,
        foreground: foregroundColor
    });
    return {
        [(0, $14ccF.themedButtonSelectedText)]: (0, $wiKJc.getTextColor)(blendedBackground).hex,
        // Border colors are chosen to match the text, while remaining in the palette
        [(0, $14ccF.themedButtonSelectedBorder)]: (0, $wiKJc.isLight)(blendedBackground) ? (0, $lMlt0.palette).Neutral1100 : (0, $lMlt0.palette).DarkNeutral1100
    };
}

});
parcelRegister("kHBTM", function(module, exports) {

$parcel$export(module.exports, "themedLogoIcon", () => $abcc1b048e9190e0$export$24328117f1132113);
$parcel$export(module.exports, "themedLogoText", () => $abcc1b048e9190e0$export$91b0830f8f4ab279);
$parcel$export(module.exports, "NavLogo", () => $abcc1b048e9190e0$export$b6394419753329e);
/* nav-logo.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $fHpHg = parcelRequire("fHpHg");

var $gHU1R = parcelRequire("gHU1R");

var $bRH8U = parcelRequire("bRH8U");
const $abcc1b048e9190e0$export$24328117f1132113 = '--ds-top-bar-logo-icon';
const $abcc1b048e9190e0$export$91b0830f8f4ab279 = '--ds-top-bar-logo-text';
const $abcc1b048e9190e0$var$navLogoStyles = {
    root: "_2rkoiti9 _1e0c1txw _4cvr1h6o _4t3izwfg",
    icon: "_18zr1b66 _1e0c1txw _p12f1tcg _vchh18uv _10y4glyw",
    logo: "_18zru2gc _1e0cglyw _p12fnklw _vchh18uv _10y41txw",
    imageContainer: "_1reo15vq _18m915vq _bna71tcg _rtys1kw7 _1jpx1f51",
    iconLogoPaddingFlagged: "_18zr1b66"
};
const $abcc1b048e9190e0$export$b6394419753329e = ({ href: href, logo: logo, icon: icon, onClick: onClick, label: label })=>{
    const ref = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        return;
    }, []);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $gHU1R.default), {
        ref: ref,
        "aria-label": label,
        href: href,
        xcss: $abcc1b048e9190e0$var$navLogoStyles.root,
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                className: (0, $bwpsq.default)([
                    $abcc1b048e9190e0$var$navLogoStyles.imageContainer,
                    $abcc1b048e9190e0$var$navLogoStyles.icon,
                    (0, $fHpHg.fg)('platform-team25-app-icon-tiles') && $abcc1b048e9190e0$var$navLogoStyles.iconLogoPaddingFlagged
                ]),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)($abcc1b048e9190e0$var$NavLogoRenderer, {
                    logoOrIcon: icon
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                className: (0, $bwpsq.default)([
                    $abcc1b048e9190e0$var$navLogoStyles.imageContainer,
                    $abcc1b048e9190e0$var$navLogoStyles.logo,
                    (0, $fHpHg.fg)('platform-team25-app-icon-tiles') && $abcc1b048e9190e0$var$navLogoStyles.iconLogoPaddingFlagged
                ]),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)($abcc1b048e9190e0$var$NavLogoRenderer, {
                    logoOrIcon: logo
                })
            })
        ]
    });
};
function $abcc1b048e9190e0$var$NavLogoRenderer({ logoOrIcon: LogoOrIcon }) {
    const hasCustomTheme = (0, $bRH8U.useHasCustomTheme)();
    if (hasCustomTheme) return /*#__PURE__*/ (0, $2OMIu.jsx)(LogoOrIcon, {
        size: "small",
        label: "",
        iconColor: `var(${$abcc1b048e9190e0$export$24328117f1132113})`,
        textColor: `var(${$abcc1b048e9190e0$export$91b0830f8f4ab279})`
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)(LogoOrIcon, {
        size: "small",
        label: "",
        appearance: "brand"
    });
}

});

parcelRegister("wiKJc", function(module, exports) {

$parcel$export(module.exports, "isLight", () => $a6ebb40edbd318d1$export$44af652f4cca9039);
$parcel$export(module.exports, "getColorMode", () => $a6ebb40edbd318d1$export$5573a5bab3e074b5);
$parcel$export(module.exports, "getTextColor", () => $a6ebb40edbd318d1$export$5357fe757c335c0d);
$parcel$export(module.exports, "simpleAlphaComposite", () => $a6ebb40edbd318d1$export$e5e64c30bee1469b);
/**
 * Removes sRGB gamma correction from the provided channel.
 * The resulting linear channel directly corresponds to subpixel intensity.
 *
 * Expects a normalized sRGB value (between 0 and 1)
 *
 * This formula is derived from WCAG2 guidelines:
 * https://www.w3.org/WAI/WCAG22/Techniques/general/G18.html#tests
 */ function $a6ebb40edbd318d1$var$linearizeRGBChannel(channel) {
    return channel <= 0.04045 ? channel / 12.92 : Math.pow((channel + 0.055) / 1.055, 2.4);
}
/**
 * This formula is derived from WCAG2 guidelines:
 * https://www.w3.org/WAI/WCAG22/Techniques/general/G18.html#tests
 */ function $a6ebb40edbd318d1$var$relativeLuminanceW3C({ r: r, g: g, b: b }) {
    /**
	 * Normalized sRGB - each channel is between 0 and 1
	 */ const normal = {
        r: r / 255,
        g: g / 255,
        b: b / 255
    };
    /**
	 * linear RGB - the gamma correction of sRGB is removed and
	 * the channels correspond directly to subpixel intensity
	 */ const linear = {
        r: $a6ebb40edbd318d1$var$linearizeRGBChannel(normal.r),
        g: $a6ebb40edbd318d1$var$linearizeRGBChannel(normal.g),
        b: $a6ebb40edbd318d1$var$linearizeRGBChannel(normal.b)
    };
    // For linear RGB, the relative luminance of a color is defined as:
    const L = 0.2126 * linear.r + 0.7152 * linear.g + 0.0722 * linear.b;
    return L;
}
/**
 * This is the intersection point for W3C contrast ratio against:
 *
 * 1. black
 * 2. white
 *
 * In other words, the background luminance for which W3C contrast is equal
 * for both white and black text.
 *
 * Using a precomputed flip point means we can save a lot of calculations.
 *
 * This is only the theoretical flip point, and we can adjust it as needed.
 */ const $a6ebb40edbd318d1$var$flipLuminance = 0.179129;
function $a6ebb40edbd318d1$export$44af652f4cca9039(color) {
    return $a6ebb40edbd318d1$var$relativeLuminanceW3C(color) >= $a6ebb40edbd318d1$var$flipLuminance;
}
function $a6ebb40edbd318d1$export$5573a5bab3e074b5(backgroundColor) {
    if ($a6ebb40edbd318d1$var$relativeLuminanceW3C(backgroundColor) >= $a6ebb40edbd318d1$var$flipLuminance) return 'light';
    return 'dark';
}
const $a6ebb40edbd318d1$var$textColor = {
    light: {
        hex: '#000',
        rgb: {
            r: 0,
            g: 0,
            b: 0
        }
    },
    dark: {
        hex: '#FFF',
        rgb: {
            r: 255,
            g: 255,
            b: 255
        }
    }
};
function $a6ebb40edbd318d1$export$5357fe757c335c0d(backgroundColor) {
    const colorMode = $a6ebb40edbd318d1$export$5573a5bab3e074b5(backgroundColor);
    return $a6ebb40edbd318d1$var$textColor[colorMode];
}
function $a6ebb40edbd318d1$export$e5e64c30bee1469b({ background: background, foreground: foreground }) {
    return {
        r: foreground.a * foreground.r + background.r * (1 - foreground.a),
        g: foreground.a * foreground.g + background.g * (1 - foreground.a),
        b: foreground.a * foreground.b + background.b * (1 - foreground.a)
    };
}

});

parcelRegister("5Vk5I", function(module, exports) {

$parcel$export(module.exports, "parseHex", () => $017df95fca2e9143$export$103711ef09c6edec);
// valid hex color (optional alpha channel) - 3, 4, 6, or 8 digits after the #
const $017df95fca2e9143$var$isValidHex = (hex)=>// Not using `([a-f0-9]{3,4}){1,2}` because that allows 7 digits which is invalid
    /^#(([a-f0-9]{3,4})|([a-f0-9][a-f0-9]){3,4})$/i.test(hex);
function $017df95fca2e9143$export$103711ef09c6edec(color) {
    if (!$017df95fca2e9143$var$isValidHex(color)) return null;
    let channels;
    if (color.length <= 5) // Hex code is shorthand - RGB channels are one digit
    channels = {
        r: color[1].repeat(2),
        g: color[2].repeat(2),
        b: color[3].repeat(2)
    };
    else // Hex code is longhand - RGB channels are two digits
    channels = {
        r: color.slice(1, 3),
        g: color.slice(3, 5),
        b: color.slice(5, 7)
    };
    return {
        r: parseInt(channels.r, 16),
        g: parseInt(channels.g, 16),
        b: parseInt(channels.b, 16)
    };
}

});

parcelRegister("lMlt0", function(module, exports) {

$parcel$export(module.exports, "palette", () => $cfaf0ff530ba3423$export$eaad8caa32d2521d);
$parcel$export(module.exports, "paletteRgba", () => $cfaf0ff530ba3423$export$c9b84419dae66a82);
/**
 * Copied from the brand refresh palette.
 *
 * Ideally we'd codegen this but the brand refresh palette isn't exposed
 * through public API and we shouldn't use the private API of another package.
 */ const $cfaf0ff530ba3423$export$eaad8caa32d2521d = {
    'DarkNeutral-100': '#111213',
    'DarkNeutral-100A': '#01040475',
    DarkNeutral0: '#18191A',
    DarkNeutral100: '#1F1F21',
    DarkNeutral100A: '#BDBDBD0A',
    DarkNeutral200: '#242528',
    DarkNeutral200A: '#CECED912',
    DarkNeutral250: '#2B2C2F',
    DarkNeutral250A: '#D9DAE71A',
    DarkNeutral300: '#303134',
    DarkNeutral300A: '#E3E4F21F',
    DarkNeutral350: '#3D3F43',
    DarkNeutral350A: '#E8EDFD2E',
    DarkNeutral400: '#4B4D51',
    DarkNeutral400A: '#E5E9F640',
    DarkNeutral500: '#63666B',
    DarkNeutral500A: '#E9F0FB5C',
    DarkNeutral600: '#7E8188',
    DarkNeutral700: '#96999E',
    DarkNeutral800: '#A9ABAF',
    DarkNeutral900: '#BFC1C4',
    DarkNeutral1000: '#CECFD2',
    DarkNeutral1100: '#E2E3E4',
    Neutral0: '#FFFFFF',
    Neutral100: '#F8F8F8',
    Neutral100A: '#17171708',
    Neutral200: '#F0F1F2',
    Neutral200A: '#0515240F',
    Neutral300: '#DDDEE1',
    Neutral300A: '#0B120E24',
    Neutral400: '#B7B9BE',
    Neutral400A: '#080F214A',
    Neutral500: '#8C8F97',
    Neutral500A: '#050C1F75',
    Neutral600: '#7D818A',
    Neutral700: '#6B6E76',
    Neutral800: '#505258',
    Neutral900: '#3B3D42',
    Neutral1000: '#292A2E',
    Neutral1100: '#1E1F21'
};
const $cfaf0ff530ba3423$export$c9b84419dae66a82 = {
    DarkNeutral300A: {
        r: 0xe3,
        g: 0xe4,
        b: 0xf2,
        a: 0x1f / 255
    },
    Neutral300A: {
        r: 0x0b,
        g: 0x12,
        b: 0x0e,
        a: 0x24 / 255
    }
};

});

parcelRegister("h3DPn", function(module, exports) {

$parcel$export(module.exports, "themedSearchBorder", () => $352f68e12fd952a2$export$ae6fbf5ba3a7a784);
$parcel$export(module.exports, "themedSearchBorderFocused", () => $352f68e12fd952a2$export$ee42b8430f4c19bd);
$parcel$export(module.exports, "useLegacySearchTheme", () => $352f68e12fd952a2$export$18a29b1ed2212823);

var $14ccF = parcelRequire("14ccF");

var $bRH8U = parcelRequire("bRH8U");
const $352f68e12fd952a2$export$ae6fbf5ba3a7a784 = '--ds-top-bar-search-border';
const $352f68e12fd952a2$export$ee42b8430f4c19bd = '--ds-top-bar-search-border-focused';
/**
 * Theme object intended for use with Search Platform components while transitioning to nav4.
 *
 * This is for backwards compatibility with the legacy theming API that was designed for nav3.
 *
 * As nav4 matures we will ideally evolve the theming solution inside Search Platform,
 * at which point this legacy theme object will not be needed.
 */ const $352f68e12fd952a2$var$legacySearchTheme = {
    default: {
        backgroundColor: 'transparent',
        color: 'currentColor',
        borderColor: `var(${$352f68e12fd952a2$export$ae6fbf5ba3a7a784})`
    },
    focus: {
        /**
     * When expanded the input ignores the custom theme,
     * except for its border which is derived from the highlight color.
     */ color: "var(--ds-text, #172B4D)",
        backgroundColor: "var(--ds-background-input-pressed, #FFFFFF)",
        borderColor: `var(${$352f68e12fd952a2$export$ee42b8430f4c19bd})`,
        boxShadow: `inset 0px 0px 0px 1px var(${$352f68e12fd952a2$export$ee42b8430f4c19bd})`
    },
    hover: {
        /**
     * This is not actually used for the search bar input (at least by the Search Platform components).
     *
     * Instead it's used as the hover background color for a close button when on mobile.
     */ backgroundColor: `var(${(0, $14ccF.themedButtonBackgroundHovered)})`
    }
};
function $352f68e12fd952a2$export$18a29b1ed2212823() {
    const hasCustomTheme = (0, $bRH8U.useHasCustomTheme)();
    if (hasCustomTheme) return $352f68e12fd952a2$var$legacySearchTheme;
    return undefined;
}

});




parcelRegister("c6Cwb", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a5529c459ee2c2df402232a3b7b74525>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8d03ec7bd2416f71$var$_react = $8d03ec7bd2416f71$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $8d03ec7bd2416f71$var$_information = $8d03ec7bd2416f71$var$_interopRequireDefault((parcelRequire("9a675")));

var $8d03ec7bd2416f71$var$_panel = $8d03ec7bd2416f71$var$_interopRequireDefault((parcelRequire("51om6")));
function $8d03ec7bd2416f71$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for InformationIcon.
 * This component is InformationIcon, with `UNSAFE_fallbackIcon` set to "EditorPanelIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: information state in section messages or inline messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8d03ec7bd2416f71$var$InformationIcon = (props)=>/*#__PURE__*/ $8d03ec7bd2416f71$var$_react.default.createElement($8d03ec7bd2416f71$var$_information.default, Object.assign({
        LEGACY_fallbackIcon: $8d03ec7bd2416f71$var$_panel.default
    }, props));
$8d03ec7bd2416f71$var$InformationIcon.Name = 'InformationIconMigration';
var $8d03ec7bd2416f71$var$_default = module.exports.default = $8d03ec7bd2416f71$var$InformationIcon;

});

parcelRegister("3vNgn", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4b4f7ab8b5658b8ac17876b86421aa64>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $28ea7b0003d4a27f$var$_react = $28ea7b0003d4a27f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $28ea7b0003d4a27f$var$_questionCircle = $28ea7b0003d4a27f$var$_interopRequireDefault((parcelRequire("4vF4i")));

var $28ea7b0003d4a27f$var$_questionCircle2 = $28ea7b0003d4a27f$var$_interopRequireDefault((parcelRequire("6YheI")));
function $28ea7b0003d4a27f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for QuestionCircleIcon.
 * This component is QuestionCircleIcon, with `UNSAFE_fallbackIcon` set to "QuestionCircleIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: help, tip.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $28ea7b0003d4a27f$var$QuestionCircleIcon = (props)=>/*#__PURE__*/ $28ea7b0003d4a27f$var$_react.default.createElement($28ea7b0003d4a27f$var$_questionCircle.default, Object.assign({
        LEGACY_fallbackIcon: $28ea7b0003d4a27f$var$_questionCircle2.default
    }, props));
$28ea7b0003d4a27f$var$QuestionCircleIcon.Name = 'QuestionCircleIconMigration';
var $28ea7b0003d4a27f$var$_default = module.exports.default = $28ea7b0003d4a27f$var$QuestionCircleIcon;

});

parcelRegister("2esxr", function(module, exports) {

$parcel$export(module.exports, "default", () => $9262ed12bba31b43$export$2e2bcd8739ae039);
/* badge.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fHpHg = parcelRequire("fHpHg");

var $6eFvr = parcelRequire("6eFvr");

var $hBHOQ = parcelRequire("hBHOQ");
const $9262ed12bba31b43$var$boxStyles = {
    root: "_2rkopd34 _18zr12x7 _1e0c116y _1o9zidpf _1kz6184x",
    added: "_bfhk1bay",
    default: "_bfhklecj",
    important: "_bfhk1v7l",
    primary: "_bfhkomb0",
    primaryInverted: "_bfhkvuon",
    removed: "_bfhktaeo"
};
/**
 * Visual refresh colors.
 * Hardcoded hex colors are used as the they should not change based on theme, and there are no appropriate color tokens.
 *
 * Using separate variables as opposed to an object, to comply with UI styling standard
 * https://atlassian.design/components/eslint-plugin-ui-styling-standard/no-unsafe-values/usage#object-access
 */ const $9262ed12bba31b43$var$neutral300 = '#DDDEE1';
const $9262ed12bba31b43$var$red300 = '#FD9891';
const $9262ed12bba31b43$var$blue300 = '#8FB8F6';
const $9262ed12bba31b43$var$neutral1000 = '#292A2E';
const $9262ed12bba31b43$var$styles = {
    root: "_2rkogqwt _18zr1b66 _1e0c116y _vchhusvi _1ul91ejb _1bah1h6o _1o9zidpf _1kz6184x",
    added: "_bfhkmv6i _syaz1fxt",
    default: "_bfhk1fkg _syazwwip",
    important: "_bfhk1366 _syazwwip",
    primary: "_bfhk1ymo _syazwwip",
    primaryInverted: "_bfhkvuon _syaz1e6v",
    removed: "_bfhk1gly _syaz1fxt"
};
const $9262ed12bba31b43$var$badgeValueWithNegativeNumberSupported = (children, max)=>{
    // Use this flag for allowing negative values(numbers) in badge component when custom number field is used
    if ((0, $fHpHg.fg)('platform_ken_2029_negative_numbers_badge')) return typeof children === 'number' && typeof max === 'number' ? (0, $hBHOQ.formatValueWithNegativeSupport)(children, max) : children;
    return typeof children === 'number' && max ? (0, $hBHOQ.formatValue)(children, max) : children;
};
/**
 * __Badge__
 *
 * This component gives you the full badge functionality and automatically formats the number you provide in \`children\`.
 *
 * - [Examples](https://atlassian.design/components/badge/examples)
 * - [Code](https://atlassian.design/components/badge/code)
 * - [Usage](https://atlassian.design/components/badge/usage)
 */ const $9262ed12bba31b43$var$Badge = /*#__PURE__*/ (0, $5uXOq.memo)(function Badge({ appearance: appearance = 'default', children: children = 0, max: max = 99, style: style, testId: testId }) {
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if ((0, $fHpHg.fg)('platform-component-visual-refresh')) return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "data-testid": testId,
        style: {
            background: style?.backgroundColor,
            color: style?.color
        },
        className: (0, $bwpsq.default)([
            $9262ed12bba31b43$var$styles.root,
            $9262ed12bba31b43$var$styles[appearance]
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6eFvr.default), {
            size: "small",
            align: "center",
            color: "inherit",
            children: $9262ed12bba31b43$var$badgeValueWithNegativeNumberSupported(children, max)
        })
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "data-testid": testId,
        style: {
            backgroundColor: style?.backgroundColor,
            color: style?.color
        },
        className: (0, $bwpsq.default)([
            $9262ed12bba31b43$var$boxStyles.root,
            $9262ed12bba31b43$var$boxStyles[appearance]
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6eFvr.default), {
            size: "UNSAFE_small",
            align: "center",
            color: style?.color ? 'inherit' : $9262ed12bba31b43$var$textColors[appearance],
            children: $9262ed12bba31b43$var$badgeValueWithNegativeNumberSupported(children, max)
        })
    });
});
$9262ed12bba31b43$var$Badge.displayName = 'Badge';
var $9262ed12bba31b43$export$2e2bcd8739ae039 = $9262ed12bba31b43$var$Badge;
const $9262ed12bba31b43$var$textColors = {
    added: 'color.text.success',
    default: 'color.text',
    important: 'color.text.inverse',
    primary: 'color.text.inverse',
    primaryInverted: 'color.text.brand',
    removed: 'color.text.danger'
};

});
parcelRegister("hBHOQ", function(module, exports) {

$parcel$export(module.exports, "formatValueWithNegativeSupport", () => $72053ede513d2d84$export$4b844743568d5983);
$parcel$export(module.exports, "formatValue", () => $72053ede513d2d84$export$7c4d25c0c3217d8c);
function $72053ede513d2d84$var$getSafeValueWithNegativeSupport(value = 0) {
    const numericValue = +value;
    // NOTE: Changing below code as this causes custom fields -ve number to show up as zero in activity timeline.
    // This will ensure it renders correctly if it is a number otherwise renders 0
    // If the value is NaN, return it as is (assuming it's a non-numeric string)
    if (isNaN(numericValue)) return value;
    // Return the numeric value, allowing negative numbers
    return numericValue;
}
function $72053ede513d2d84$export$4b844743568d5983(value, max) {
    const safeValue = $72053ede513d2d84$var$getSafeValueWithNegativeSupport(value);
    const safeMax = $72053ede513d2d84$var$getSafeValueWithNegativeSupport(max);
    let hasSafeMaxValue = false;
    if (max !== undefined) hasSafeMaxValue = true;
    if (safeMax === Infinity && safeValue === Infinity) return "\u221E";
    if (hasSafeMaxValue && safeMax < safeValue) return `${safeMax}+`;
    if (safeValue === Infinity) return "\u221E";
    return safeValue.toString();
}
function $72053ede513d2d84$var$getSafeValue(value = 0) {
    const numericValue = +value;
    if (numericValue < 0) return 0;
    return value;
}
function $72053ede513d2d84$export$7c4d25c0c3217d8c(value, max) {
    const safeValue = $72053ede513d2d84$var$getSafeValue(value);
    const safeMax = $72053ede513d2d84$var$getSafeValue(max);
    if (safeMax && safeMax < safeValue) return `${safeMax}+`;
    if (safeValue === Infinity) return "\u221E";
    return safeValue.toString();
}

});


parcelRegister("fsi33", function(module, exports) {

$parcel$export(module.exports, "NestedContext", () => $1a6ec4dbb1bb6acd$export$46b2c2071c8c725a);
$parcel$export(module.exports, "useNestedContext", () => $1a6ec4dbb1bb6acd$export$f24166abe9ed712b);
$parcel$export(module.exports, "useShouldNestedElementRender", () => $1a6ec4dbb1bb6acd$export$37e8646a1abfc3e6);

var $5uXOq = parcelRequire("5uXOq");
const $1a6ec4dbb1bb6acd$export$46b2c2071c8c725a = /*#__PURE__*/ (0, $5uXOq.createContext)(undefined);
const $1a6ec4dbb1bb6acd$export$f24166abe9ed712b = ()=>{
    const context = (0, $5uXOq.useContext)($1a6ec4dbb1bb6acd$export$46b2c2071c8c725a);
    if (!context) {
        let error = '';
        throw new Error(error);
    }
    return context;
};
const $1a6ec4dbb1bb6acd$export$37e8646a1abfc3e6 = ()=>{
    const context = (0, $5uXOq.useContext)($1a6ec4dbb1bb6acd$export$46b2c2071c8c725a);
    if (!context) return {
        shouldRender: true
    };
    return {
        shouldRender: context.currentStackId === context.parentId
    };
};

});

parcelRegister("dnFM9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0ddb2a0e6c8a33d7611a427658d95f19>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9bddd41de5a4a0f0$var$_react = $9bddd41de5a4a0f0$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $9bddd41de5a4a0f0$var$_lightbulb = $9bddd41de5a4a0f0$var$_interopRequireDefault((parcelRequire("cu8LJ")));

var $9bddd41de5a4a0f0$var$_lightbulbFilled = $9bddd41de5a4a0f0$var$_interopRequireDefault((parcelRequire("lHo2L")));
function $9bddd41de5a4a0f0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for LightbulbIcon.
 * This component is LightbulbIcon, with `UNSAFE_fallbackIcon` set to "LightbulbFilledIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: learnings in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9bddd41de5a4a0f0$var$LightbulbIcon = (props)=>/*#__PURE__*/ $9bddd41de5a4a0f0$var$_react.default.createElement($9bddd41de5a4a0f0$var$_lightbulb.default, Object.assign({
        LEGACY_fallbackIcon: $9bddd41de5a4a0f0$var$_lightbulbFilled.default
    }, props));
$9bddd41de5a4a0f0$var$LightbulbIcon.Name = 'LightbulbIconMigration';
var $9bddd41de5a4a0f0$var$_default = module.exports.default = $9bddd41de5a4a0f0$var$LightbulbIcon;

});

parcelRegister("aO6RD", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a8dbd8d9850b83e4eb37f60fa877444d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7de3e5fad9f189bd$var$_react = $7de3e5fad9f189bd$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $7de3e5fad9f189bd$var$_crossCircle = $7de3e5fad9f189bd$var$_interopRequireDefault((parcelRequire("hvAON")));

var $7de3e5fad9f189bd$var$_crossCircle2 = $7de3e5fad9f189bd$var$_interopRequireDefault((parcelRequire("4y6Pt")));
function $7de3e5fad9f189bd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CrossCircleIcon.
 * This component is CrossCircleIcon, with `UNSAFE_fallbackIcon` set to "CrossCircleIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: clear text field, error status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7de3e5fad9f189bd$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $7de3e5fad9f189bd$var$_react.default.createElement($7de3e5fad9f189bd$var$_crossCircle.default, Object.assign({
        LEGACY_fallbackIcon: $7de3e5fad9f189bd$var$_crossCircle2.default
    }, props));
$7de3e5fad9f189bd$var$CrossCircleIcon.Name = 'CrossCircleIconMigration';
var $7de3e5fad9f189bd$var$_default = module.exports.default = $7de3e5fad9f189bd$var$CrossCircleIcon;

});

parcelRegister("2uT3N", function(module, exports) {

$parcel$export(module.exports, "OverflowProvider", () => $a61e088bb97b5ae0$export$a3a2def3937905a0);
$parcel$export(module.exports, "useOverflowStatus", () => $a61e088bb97b5ae0$export$3fcfc71fab3314f2);
$parcel$export(module.exports, "useOverflowController", () => $a61e088bb97b5ae0$export$705aa66a39c35bf7);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $34ck9 = parcelRequire("34ck9");

var $bKnKN = parcelRequire("bKnKN");
// Prevent width detector from triggering too many re-renders
const $a61e088bb97b5ae0$var$THROTTLE_INTERVAL = 64;
// Approx min width of items (based of "More" size)
const $a61e088bb97b5ae0$var$ITEM_APPROX_MINWIDTH = 70;
const $a61e088bb97b5ae0$var$calculateHash = (w, n)=>w + '#' + n;
const $a61e088bb97b5ae0$var$updateHashRef = (currentRef, value)=>{
    currentRef.unshift(value);
    currentRef.length = 3;
};
const $a61e088bb97b5ae0$var$OverflowContext = /*#__PURE__*/ (0, $5uXOq.createContext)({
    isVisible: true,
    openOverflowMenu: (0, $bKnKN.default),
    closeOverflowMenu: (0, $bKnKN.default)
});
const $a61e088bb97b5ae0$export$a3a2def3937905a0 = ({ children: children, isVisible: isVisible, openOverflowMenu: openOverflowMenu, closeOverflowMenu: closeOverflowMenu })=>{
    const { Provider: Provider } = $a61e088bb97b5ae0$var$OverflowContext;
    const value = (0, $5uXOq.useMemo)(()=>({
            isVisible: isVisible,
            openOverflowMenu: openOverflowMenu,
            closeOverflowMenu: closeOverflowMenu
        }), [
        isVisible,
        openOverflowMenu,
        closeOverflowMenu
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)(Provider, {
        value: value,
        children: children
    });
};
const $a61e088bb97b5ae0$export$3fcfc71fab3314f2 = ()=>(0, $5uXOq.useContext)($a61e088bb97b5ae0$var$OverflowContext);
const $a61e088bb97b5ae0$export$705aa66a39c35bf7 = (nodes)=>{
    const items = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.toArray(nodes);
    const [width, setWidth] = (0, $5uXOq.useState)(9999);
    const [itemsLimit, setItemsLimit] = (0, $5uXOq.useState)(items.length);
    const [forceEffectValue, triggerForceEffect] = (0, $5uXOq.useState)({});
    // Storing items approximate width so we can try expanding when there is enough room
    const itemsWidths = (0, $5uXOq.useRef)([]).current;
    // Storing a couple of width + items count in order to stabilize
    const hashRef = (0, $5uXOq.useRef)([]);
    // AFP-2511 TODO: Fix automatic suppressions below
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const throttleSetWidth = (0, $5uXOq.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($34ck9)))(setWidth, $a61e088bb97b5ae0$var$THROTTLE_INTERVAL), [
        setWidth
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const lastItemWidth = itemsWidths[itemsLimit] || 0;
        const wasJustLimited = lastItemWidth < 0;
        const currentHash = $a61e088bb97b5ae0$var$calculateHash(width, itemsLimit);
        if (hashRef.current[0] === currentHash) {
            // After removing an item, if width has not changed yet we schedule a force update
            // to handle case where removing an item does not actually trigger width change
            const t = setTimeout(()=>{
                $a61e088bb97b5ae0$var$updateHashRef(hashRef.current, '');
                triggerForceEffect({});
            }, $a61e088bb97b5ae0$var$THROTTLE_INTERVAL * 1.5);
            return ()=>clearTimeout(t);
        }
        if (wasJustLimited) {
            // Width was updated either via resize or after changing the limit
            // we cap the width between ITEM_APPROX_MINWIDTH and 2*ITEM_APPROX_MINWIDTH
            // because width is throttled as when fast expanding/resizing partialWidth
            // will not be reliable (edge case)
            const partialWidth = Math.max(Math.min(width + lastItemWidth, $a61e088bb97b5ae0$var$ITEM_APPROX_MINWIDTH * 2), $a61e088bb97b5ae0$var$ITEM_APPROX_MINWIDTH);
            itemsWidths[itemsLimit] = partialWidth;
        }
        if (width < $a61e088bb97b5ae0$var$ITEM_APPROX_MINWIDTH * 0.9 && itemsLimit) {
            // If current width is less than an item approx width we remove an item
            // marking the width as negative so we will calculate it on width update
            // plus we set the hash to stabilise and not removing more than one element
            // until we are sure width was updated
            const nextHash = $a61e088bb97b5ae0$var$calculateHash(width, itemsLimit - 1);
            if (hashRef.current.indexOf(nextHash) === -1) {
                setItemsLimit(itemsLimit - 1);
                itemsWidths[itemsLimit - 1] = -(width || 1);
                $a61e088bb97b5ae0$var$updateHashRef(hashRef.current, nextHash);
            }
            return;
        }
        /**
		 * This is not necessarily equal to `lastItemWidth` because the
		 * ```js
		 * if (wasJustLimited) {}
		 * ```
		 * branch above modifies `itemsWidths`.
		 *
		 * Using `lastItemWidth` here can cause collapsing behavior to fail,
		 * such as the issue reported in DSP-7329.
		 */ const currentLastItemWidth = itemsWidths[itemsLimit] || 0;
        if (width - currentLastItemWidth > $a61e088bb97b5ae0$var$ITEM_APPROX_MINWIDTH * 1.1 && itemsLimit < items.length) {
            // If we have enough room to accomodate next item width we increase the limit
            // unless it has been recently removed
            const nextHash = $a61e088bb97b5ae0$var$calculateHash(width, itemsLimit + 1);
            if (hashRef.current.indexOf(nextHash) === -1) {
                setItemsLimit(itemsLimit + 1);
                $a61e088bb97b5ae0$var$updateHashRef(hashRef.current, nextHash);
            }
            return;
        }
    }, [
        width,
        hashRef,
        itemsLimit,
        itemsWidths,
        forceEffectValue,
        items.length
    ]);
    return {
        visibleItems: items.slice(0, itemsLimit),
        overflowItems: items.slice(itemsLimit),
        updateWidth: throttleSetWidth
    };
};
var // Used to extract props for useOverflowStatus();
// eslint-disable-next-line import/no-anonymous-default-export
$a61e088bb97b5ae0$export$2e2bcd8739ae039 = (props)=>{};

});

parcelRegister("c4F0u", function(module, exports) {

$parcel$export(module.exports, "JiraLogo", () => $35cdbb027b648f73$export$17d3acb0b4379d02);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $6VxGE = parcelRequire("6VxGE");

var $kpt43 = parcelRequire("kpt43");

var $2uZGe = parcelRequire("2uZGe");

var $j62qJ = parcelRequire("j62qJ");
const $35cdbb027b648f73$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $2uZGe.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 77 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M7.967 21.323H5.748C2.401 21.323 0 19.273 0 16.271h11.933c.618 0 1.018.44 1.018 1.062V29.34c-2.983 0-4.984-2.416-4.984-5.784zm5.894-5.967h-2.22c-3.346 0-5.747-2.013-5.747-5.015h11.932c.618 0 1.055.402 1.055 1.025v12.007c-2.983 0-5.02-2.416-5.02-5.784zm5.93-5.93h-2.22c-3.347 0-5.748-2.05-5.748-5.052h11.933c.618 0 1.019.439 1.019 1.025v12.007c-2.983 0-4.984-2.416-4.984-5.784z"/>
      <path fill="${colors.textColor}" d="M65.023 17.874c0 3.68 1.472 5.52 4.202 5.52 2.36 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.932-4.906-4.17-4.906-2.975 0-4.509 1.962-4.509 5.52m8.679 7.666v-2.76c-.981 2.024-2.821 3.067-5.183 3.067-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006v-2.699h2.637V25.54zM55.91 16.493v9.047h-2.577V10.207h2.576v2.698c.89-1.809 2.423-3.097 5.428-2.913v2.576c-3.373-.337-5.428.675-5.428 3.925M46.224 6.159c0-1.165.767-1.84 1.84-1.84s1.84.675 1.84 1.84-.767 1.84-1.84 1.84-1.84-.675-1.84-1.84m.49 19.381V10.207h2.638V25.54zm-6.427-5.95V5.393h2.76v14.015c0 3.71-1.626 6.256-5.428 6.256-1.442 0-2.546-.246-3.312-.522v-2.668c.828.338 1.84.522 2.852.522 2.33 0 3.128-1.41 3.128-3.404"/>
    </svg>`;
};
const $35cdbb027b648f73$export$17d3acb0b4379d02 = ({ appearance: appearance, label: label = 'Jira', size: size = (0, $kpt43.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $kpt43.defaultLogoParams).iconColor, textColor: textColor = (0, $kpt43.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $6VxGE.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $j62qJ.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $35cdbb027b648f73$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("hshbs", function(module, exports) {

$parcel$export(module.exports, "JiraServiceManagementLogo", () => $53870b379ecc55f5$export$dabef2be6cd28c20);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $6VxGE = parcelRequire("6VxGE");

var $kpt43 = parcelRequire("kpt43");

var $2uZGe = parcelRequire("2uZGe");

var $j62qJ = parcelRequire("j62qJ");
const $53870b379ecc55f5$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $2uZGe.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 362 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill=${colors.iconColor} d="M14.124 13.257h7.325c1.1 0 1.475 1.046.804 1.878L10.798 29.274c-3.702-2.951-3.353-7.62-.644-11.027zm-5.66 5.634H1.138c-1.1 0-1.476-1.046-.805-1.878L11.79 2.874c3.703 2.951 3.3 7.566.617 11z" />
      <path fill=${colors.textColor} d="M357.074 20.787c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545c-.46.123-.981.245-1.778.245-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zm-7.327-4.231v8.985h-2.638V16.28c0-2.76-1.104-3.987-3.618-3.987-2.454 0-4.14 1.625-4.14 4.723v8.525h-2.638V10.208h2.638v2.514c.981-1.81 2.79-2.821 4.845-2.821 3.527 0 5.551 2.423 5.551 6.655m-22.921-4.263c-2.791 0-4.201 1.81-4.477 4.477h8.556c-.154-2.852-1.442-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.631 2.576-7.943 7.238-7.943 4.722 0 6.624 3.281 6.624 7.943v1.196h-11.194c.368 2.606 2.055 4.293 5.674 4.293 1.778 0 3.281-.337 4.661-.828zm-26.152-7.912v8.525h-2.637V16.28c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.625-4.14 4.723v8.525h-2.637V10.208h2.637v2.514c.981-1.81 2.79-2.821 4.845-2.821 2.607 0 4.385 1.319 5.152 3.741.859-2.361 2.913-3.741 5.459-3.741 3.434 0 5.336 2.33 5.336 6.655v8.985h-2.638v-8.525c0-3.16-1.104-4.723-3.618-4.723-2.454 0-4.14 1.625-4.14 4.723m-22.921-4.723c-2.79 0-4.201 1.81-4.477 4.477h8.556c-.153-2.852-1.441-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.631 2.577-7.943 7.238-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zm-18.638-.614v-1.533c-.982 2.024-2.822 3.067-5.183 3.067-4.048 0-6.072-3.466-6.072-7.974 0-4.324 2.116-7.973 6.379-7.973 2.238 0 3.956 1.012 4.876 3.005v-2.698h2.576V24.16c0 4.508-2.116 7.544-7.606 7.544-2.576 0-3.986-.337-5.458-.828V28.3c1.686.552 3.434.92 5.336.92 3.833 0 5.152-2.055 5.152-4.907m-8.679-6.44c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.975 0-4.508 1.963-4.508 5.52m-16.949.001c0 3.68 1.472 5.52 4.201 5.52 2.361 0 4.477-1.503 4.477-4.906V17.26c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.508 1.963-4.508 5.52m8.678 7.667v-2.76c-.981 2.024-2.821 3.066-5.182 3.066-4.079 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.638V25.54zm-14.073-8.984v8.985h-2.638V16.28c0-2.76-1.104-3.987-3.618-3.987-2.454 0-4.14 1.625-4.14 4.723v8.525h-2.638V10.208h2.638v2.514c.981-1.81 2.79-2.821 4.845-2.821 3.527 0 5.551 2.423 5.551 6.655m-28.327 1.318c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.974 0-4.508 1.963-4.508 5.52m8.679 7.667v-2.76c-.981 2.024-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.637V25.54zm-31.445-11.009-2.76-7.482V25.54h-2.76V5.393h4.784l4.569 11.56 1.871 5.552 1.87-5.551 4.6-11.561h4.447V25.54h-2.76V7.263l-2.361 7.268-4.447 11.01h-2.668zm-21.511-2.238c-2.791 0-4.202 1.81-4.478 4.477h8.556c-.153-2.852-1.441-4.477-4.078-4.477m5.888 12.635c-1.258.674-3.19.92-4.754.92-5.734 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.055 4.293 5.673 4.293 1.779 0 3.282-.337 4.662-.828zm-15.094-2.148v2.362c-.92.49-2.33.705-3.741.705-5.459 0-8.004-3.312-8.004-8.004 0-4.63 2.545-7.942 8.004-7.942 1.38 0 2.453.184 3.649.736v2.453c-.981-.46-2.024-.736-3.465-.736-3.987 0-5.612 2.515-5.612 5.49s1.656 5.489 5.673 5.489c1.564 0 2.546-.215 3.496-.552M140.124 6.16c0-1.166.766-1.84 1.84-1.84 1.073 0 1.84.674 1.84 1.84S143.037 8 141.964 8c-1.074 0-1.84-.675-1.84-1.84m.49 19.38V10.208h2.638v15.334zm-8.233 0h-3.527l-5.949-15.332h2.76l4.968 13.094 4.937-13.094h2.76zm-15.455-9.046v9.047h-2.576V10.207h2.576v2.699c.889-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925m-12.463-4.201c-2.791 0-4.202 1.81-4.478 4.477h8.556c-.153-2.852-1.441-4.477-4.078-4.477m5.888 12.635c-1.258.674-3.19.92-4.754.92-5.734 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.055 4.293 5.673 4.293 1.779 0 3.282-.337 4.662-.828zM95.024 19.99c0 3.496-2.085 5.857-7.084 5.857-3.894 0-5.704-.766-7.268-1.564v-2.821c1.87.981 4.754 1.687 7.422 1.687 3.036 0 4.17-1.196 4.17-2.975s-1.104-2.73-4.937-3.65c-4.539-1.103-6.563-2.667-6.563-5.98 0-3.127 2.392-5.458 7.084-5.458 2.914 0 4.784.705 6.164 1.472v2.76c-2.024-1.165-4.201-1.533-6.286-1.533-2.638 0-4.202.92-4.202 2.76 0 1.656 1.288 2.484 4.845 3.373 4.263 1.073 6.655 2.453 6.655 6.072m-34.001-2.116c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.906V17.26c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.509 1.963-4.509 5.52m8.679 7.667v-2.76c-.981 2.024-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.637V25.54zM51.91 16.494v9.047h-2.577V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925M42.224 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S45.137 8 44.064 8s-1.84-.675-1.84-1.84m.49 19.38V10.208h2.638v15.334zm-6.427-5.949V5.393h2.76v14.014c0 3.71-1.626 6.256-5.428 6.256-1.442 0-2.546-.245-3.312-.521v-2.668c.828.337 1.84.521 2.852.521 2.33 0 3.128-1.41 3.128-3.404" />
    </svg>`;
};
const $53870b379ecc55f5$export$dabef2be6cd28c20 = ({ appearance: appearance, label: label = 'Jira Service Management', size: size = (0, $kpt43.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $kpt43.defaultLogoParams).iconColor, textColor: textColor = (0, $kpt43.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $6VxGE.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $j62qJ.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $53870b379ecc55f5$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("fv0UR", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cc8d44dd44920ffd526686a9e2bd3636>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b48a7634d0c8faa1$var$_react = $b48a7634d0c8faa1$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $b48a7634d0c8faa1$var$_baseNew = $b48a7634d0c8faa1$var$_interopRequireDefault((parcelRequire("enEmH")));
function $b48a7634d0c8faa1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Editions".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for representing premium features and functionality. Editions may replace the current premium sparkle icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b48a7634d0c8faa1$var$EditionsIcon = (props)=>/*#__PURE__*/ $b48a7634d0c8faa1$var$_react.default.createElement($b48a7634d0c8faa1$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.614 1.353A.75.75 0 0 1 3.25 1h9.5a.75.75 0 0 1 .636.353l2.5 4a.75.75 0 0 1-.065.884l-7.25 8.5a.75.75 0 0 1-1.142 0l-7.25-8.5a.75.75 0 0 1-.065-.885zM3.666 2.5 2.103 5H4.7l.78-2.5zm3.385 0L6.271 5H9.73l-.781-2.5zm3.47 0L11.3 5h2.596l-1.563-2.5zm3.103 4h-2.328l-1.424 4.399zM8 11.813 9.72 6.5H6.28zM4.704 6.5l1.424 4.399L2.375 6.5z" clip-rule="evenodd"/>`
    }, props));
$b48a7634d0c8faa1$var$EditionsIcon.displayName = 'EditionsIcon';
var $b48a7634d0c8faa1$var$_default = module.exports.default = $b48a7634d0c8faa1$var$EditionsIcon;

});

parcelRegister("7VIfr", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7e4382cd4db66693d3c799807338c8cb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5c602e09511c97a8$var$_react = $5c602e09511c97a8$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $5c602e09511c97a8$var$_creditCard = $5c602e09511c97a8$var$_interopRequireDefault((parcelRequire("3f3VS")));

var $5c602e09511c97a8$var$_creditcardFilled = $5c602e09511c97a8$var$_interopRequireDefault((parcelRequire("9HHyy")));
function $5c602e09511c97a8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CreditCardIcon.
 * This component is CreditCardIcon, with `UNSAFE_fallbackIcon` set to "CreditcardFilledIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: billing in Admin, invoices in PPC, payments.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5c602e09511c97a8$var$CreditCardIcon = (props)=>/*#__PURE__*/ $5c602e09511c97a8$var$_react.default.createElement($5c602e09511c97a8$var$_creditCard.default, Object.assign({
        LEGACY_fallbackIcon: $5c602e09511c97a8$var$_creditcardFilled.default
    }, props));
$5c602e09511c97a8$var$CreditCardIcon.Name = 'CreditCardIconMigration';
var $5c602e09511c97a8$var$_default = module.exports.default = $5c602e09511c97a8$var$CreditCardIcon;

});

parcelRegister("c5zfI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::49812071d6f0a774fd1a4306f3d0718e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8cd14c15b06b58a9$var$_react = $8cd14c15b06b58a9$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $8cd14c15b06b58a9$var$_baseNew = $8cd14c15b06b58a9$var$_interopRequireDefault((parcelRequire("enEmH")));
function $8cd14c15b06b58a9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Warning".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8cd14c15b06b58a9$var$WarningIcon = (props)=>/*#__PURE__*/ $8cd14c15b06b58a9$var$_react.default.createElement($8cd14c15b06b58a9$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M11.702 9.137A1.25 1.25 0 0 1 10.612 11H1.388a1.25 1.25 0 0 1-1.09-1.863l4.614-8.2a1.25 1.25 0 0 1 2.178 0zM6.75 2.75V6.5h-1.5V2.75zm-.75 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$8cd14c15b06b58a9$var$WarningIcon.displayName = 'WarningIcon';
var $8cd14c15b06b58a9$var$_default = module.exports.default = $8cd14c15b06b58a9$var$WarningIcon;

});

parcelRegister("cii2t", function(module, exports) {

$parcel$export(module.exports, "JiraProductDiscoveryLogo", () => $2341d6d9d5706d2e$export$c49a2b642fe9eef4);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $6VxGE = parcelRequire("6VxGE");

var $kpt43 = parcelRequire("kpt43");

var $2uZGe = parcelRequire("2uZGe");

var $j62qJ = parcelRequire("j62qJ");
const $2341d6d9d5706d2e$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $2uZGe.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 318 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M12.655 5.218a15.3 15.3 0 0 0 8.75 0c.257-.057.428.114.37.37-.826 2.984-.826 5.742 0 8.727.058.227-.113.426-.37.341a16.33 16.33 0 0 0-8.75 0c-.228.085-.428-.114-.342-.341.77-2.985.77-5.743 0-8.727-.086-.256.114-.427.342-.37m1.169 10.575v.483c0 2.246-1.568 3.895-3.506 3.895a3.474 3.474 0 0 1-3.478-3.497c0-1.933 1.568-3.468 3.763-3.468h.57V6.412c-.285-.028-.57-.028-.855-.028C4.618 6.384 0 10.989 0 16.703s4.617 10.29 10.318 10.29 10.346-4.605 10.346-10.29v-.91z" />
      <path fill="${colors.textColor}" d="M308.551 24.559h-1.718l-5.55-14.352h2.821l4.907 13.125 4.906-13.125h2.822l-5.796 14.843c-1.718 4.385-2.699 6.654-6.594 6.654-1.318 0-2.054-.122-2.821-.429v-2.27c.889.277 1.901.369 2.668.369 2.147 0 3.097-1.472 4.355-4.815m-13.247-8.065v9.047h-2.576V10.207h2.576v2.699c.889-1.81 2.422-3.097 5.428-2.913v2.576c-3.374-.338-5.428.674-5.428 3.925m-12.464-4.202c-2.79 0-4.201 1.81-4.477 4.478h8.556c-.153-2.852-1.441-4.478-4.079-4.478m5.888 12.635c-1.257.675-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.63 2.576-7.943 7.237-7.943 4.723 0 6.624 3.282 6.624 7.943v1.196h-11.193c.368 2.607 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zm-19.717.613h-3.527l-5.949-15.333h2.76l4.968 13.095 4.937-13.095h2.76zm-17.462.307c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.943 7.299-7.943c4.569 0 7.237 3.343 7.237 7.943s-2.668 8.004-7.237 8.004m0-13.493c-3.281 0-4.723 2.576-4.723 5.49 0 2.912 1.442 5.55 4.723 5.55 3.251 0 4.661-2.638 4.661-5.55 0-2.914-1.41-5.49-4.661-5.49M242.16 22.78v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.943 8.004-7.943 1.38 0 2.454.184 3.65.736v2.454c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.514-5.612 5.49 0 2.974 1.656 5.488 5.674 5.488 1.564 0 2.545-.214 3.496-.552m-13.872-1.41c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.521-5.336-1.135v-2.79c1.319.766 3.527 1.502 5.459 1.502 2.024 0 3.066-.828 3.066-2.024 0-1.165-.889-1.84-3.802-2.545-3.404-.828-4.846-2.147-4.846-4.661 0-2.668 2.055-4.294 5.551-4.294 1.993 0 3.803.491 4.937 1.104v2.73c-1.84-.92-3.342-1.41-4.968-1.41-1.932 0-2.974.674-2.974 1.87 0 1.073.736 1.748 3.557 2.422 3.404.828 5.121 2.086 5.121 4.754M210.599 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84-.767 1.84-1.84 1.84-1.84-.675-1.84-1.84m.491 19.38V10.208h2.637v15.334zM198.344 8.03h-4.539v14.873h4.692c4.6 0 6.9-2.422 6.9-7.298 0-4.907-2.177-7.575-7.053-7.575m-7.299 17.51V5.394h7.422c6.532 0 9.69 4.078 9.69 10.12 0 6.102-3.189 10.028-9.69 10.028zm-13.411-4.753c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545c-.46.123-.981.245-1.778.245-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zm-6.66 1.993v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.943 8.004-7.943 1.38 0 2.454.184 3.65.736v2.454c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.514-5.612 5.49 0 2.974 1.656 5.488 5.674 5.488 1.564 0 2.545-.214 3.496-.552m-27.843-3.588v-8.985h2.637v9.261c0 2.76 1.104 3.987 3.619 3.987 2.453 0 4.14-1.625 4.14-4.723v-8.525h2.637V25.54h-2.637v-2.514c-.982 1.809-2.791 2.821-4.846 2.821-3.526 0-5.55-2.423-5.55-6.655m-14.987-1.318c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.932-4.906-4.171-4.906-2.974 0-4.508 1.962-4.508 5.52m8.679 7.667v-2.76c-.981 2.023-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005V3.798h2.637V25.54zm-20.698.306c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.943 7.299-7.943c4.569 0 7.237 3.343 7.237 7.943s-2.668 8.004-7.237 8.004m0-13.493c-3.282 0-4.723 2.576-4.723 5.49 0 2.912 1.441 5.55 4.723 5.55 3.25 0 4.661-2.638 4.661-5.55 0-2.914-1.411-5.49-4.661-5.49m-13.776 4.14v9.047h-2.576V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925m-5.002-4.385c0 4.385-2.454 6.838-7.483 6.838h-4.017v6.594h-2.76V5.393h6.777c5.03 0 7.483 2.576 7.483 6.716m-7.79 4.2c3.558.124 4.938-1.563 4.938-4.14 0-2.452-1.38-4.14-4.938-4.14h-3.71v8.28zM61.69 17.874c0 3.68 1.472 5.52 4.201 5.52 2.361 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.931-4.906-4.17-4.906-2.975 0-4.508 1.962-4.508 5.52m8.679 7.666v-2.76c-.982 2.024-2.822 3.067-5.183 3.067-4.079 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.974 6.44-7.974 2.24 0 3.957 1.012 4.877 3.006v-2.699h2.637V25.54zm-17.793-9.046v9.047H50V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925M42.89 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S45.805 8 44.73 8s-1.84-.675-1.84-1.84m.491 19.38V10.208h2.638v15.334zm-6.428-5.949V5.393h2.76v14.014c0 3.71-1.625 6.256-5.428 6.256-1.441 0-2.545-.245-3.312-.521v-2.668c.828.337 1.84.521 2.852.521 2.331 0 3.128-1.41 3.128-3.404" />
    </svg>`;
};
const $2341d6d9d5706d2e$export$c49a2b642fe9eef4 = ({ appearance: appearance, label: label = 'Jira Product Discovery', size: size = (0, $kpt43.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $kpt43.defaultLogoParams).iconColor, textColor: textColor = (0, $kpt43.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $6VxGE.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $j62qJ.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $2341d6d9d5706d2e$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("hWGQo", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0b007f69ad81895a86b02f3ac63c0846>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d10916601493b279$var$_react = $d10916601493b279$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $d10916601493b279$var$_premium = $d10916601493b279$var$_interopRequireDefault((parcelRequire("kDE7H")));

var $d10916601493b279$var$_premium2 = $d10916601493b279$var$_interopRequireDefault((parcelRequire("gRmq4")));
function $d10916601493b279$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for PremiumIcon.
 * This component is PremiumIcon, with `UNSAFE_fallbackIcon` set to "PremiumIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for premium features.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d10916601493b279$var$PremiumIcon = (props)=>/*#__PURE__*/ $d10916601493b279$var$_react.default.createElement($d10916601493b279$var$_premium.default, Object.assign({
        LEGACY_fallbackIcon: $d10916601493b279$var$_premium2.default
    }, props));
$d10916601493b279$var$PremiumIcon.Name = 'PremiumIconMigration';
var $d10916601493b279$var$_default = module.exports.default = $d10916601493b279$var$PremiumIcon;

});

parcelRegister("2Do6f", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2acc08ab6395d499b2798249d78c49fd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1eb1eb015eeff27d$var$_react = $1eb1eb015eeff27d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $1eb1eb015eeff27d$var$_arrowUpRight = $1eb1eb015eeff27d$var$_interopRequireDefault((parcelRequire("1vIgO")));

var $1eb1eb015eeff27d$var$_open = $1eb1eb015eeff27d$var$_interopRequireDefault((parcelRequire("ez2lY")));
function $1eb1eb015eeff27d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ArrowUpRightIcon.
 * This component is ArrowUpRightIcon, with `UNSAFE_fallbackIcon` set to "OpenIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1eb1eb015eeff27d$var$ArrowUpRightIcon = (props)=>/*#__PURE__*/ $1eb1eb015eeff27d$var$_react.default.createElement($1eb1eb015eeff27d$var$_arrowUpRight.default, Object.assign({
        LEGACY_fallbackIcon: $1eb1eb015eeff27d$var$_open.default
    }, props));
$1eb1eb015eeff27d$var$ArrowUpRightIcon.Name = 'ArrowUpRightIconMigration';
var $1eb1eb015eeff27d$var$_default = module.exports.default = $1eb1eb015eeff27d$var$ArrowUpRightIcon;

});

parcelRegister("6P0Kj", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bc9ca86dc3d7916919414cea3f7ddc7f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4f7815a46123bce3$var$_react = $4f7815a46123bce3$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $4f7815a46123bce3$var$_linkExternal = $4f7815a46123bce3$var$_interopRequireDefault((parcelRequire("lggcf")));

var $4f7815a46123bce3$var$_shortcut = $4f7815a46123bce3$var$_interopRequireDefault((parcelRequire("a8Wzb")));
function $4f7815a46123bce3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for LinkExternalIcon.
 * This component is LinkExternalIcon, with `UNSAFE_fallbackIcon` set to "ShortcutIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links that open up a new tab.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4f7815a46123bce3$var$LinkExternalIcon = (props)=>/*#__PURE__*/ $4f7815a46123bce3$var$_react.default.createElement($4f7815a46123bce3$var$_linkExternal.default, Object.assign({
        LEGACY_fallbackIcon: $4f7815a46123bce3$var$_shortcut.default
    }, props));
$4f7815a46123bce3$var$LinkExternalIcon.Name = 'LinkExternalIconMigration';
var $4f7815a46123bce3$var$_default = module.exports.default = $4f7815a46123bce3$var$LinkExternalIcon;

});

parcelRegister("4QlcP", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::aa501adbace966b726e3581e51103297>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $386c77cf1fb4f787$var$_react = $386c77cf1fb4f787$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $386c77cf1fb4f787$var$_search = $386c77cf1fb4f787$var$_interopRequireDefault((parcelRequire("aWy0H")));

var $386c77cf1fb4f787$var$_search2 = $386c77cf1fb4f787$var$_interopRequireDefault((parcelRequire("fVct6")));
function $386c77cf1fb4f787$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for SearchIcon.
 * This component is SearchIcon, with `UNSAFE_fallbackIcon` set to "SearchIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for searching objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $386c77cf1fb4f787$var$SearchIcon = (props)=>/*#__PURE__*/ $386c77cf1fb4f787$var$_react.default.createElement($386c77cf1fb4f787$var$_search.default, Object.assign({
        LEGACY_fallbackIcon: $386c77cf1fb4f787$var$_search2.default
    }, props));
$386c77cf1fb4f787$var$SearchIcon.Name = 'SearchIconMigration';
var $386c77cf1fb4f787$var$_default = module.exports.default = $386c77cf1fb4f787$var$SearchIcon;

});

parcelRegister("eBmnm", function(module, exports) {

$parcel$export(module.exports, "AppSwitcher", () => $0a4535fb412399f1$export$9923361bd43fa030);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $hbr4z = parcelRequire("hbr4z");

var $98YGb = parcelRequire("98YGb");

var $2JYdg = parcelRequire("2JYdg");
const $0a4535fb412399f1$export$9923361bd43fa030 = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { component: component, href: href, id: id, isDisabled: isDisabled, isSelected: isSelected, label: label, onBlur: onBlur, onClick: onClick, onFocus: onFocus, onMouseDown: onMouseDown, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, target: target, testId: testId, tooltip: tooltip, ...rest } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2JYdg.IconButton), {
        component: component,
        href: href,
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($98YGb))), {
            color: "currentColor",
            spacing: "spacious",
            label: typeof tooltip === 'string' ? tooltip : 'Switch apps'
        }),
        id: id,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onMouseUp: onMouseUp,
        ref: ref,
        target: target,
        testId: testId,
        tooltip: tooltip,
        ...rest
    });
});
const $0a4535fb412399f1$export$28833e0dfbd2ac80 = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { component: component, href: href, id: id, isDisabled: isDisabled, isSelected: isSelected, label: label, onBlur: onBlur, onClick: onClick, onFocus: onFocus, onMouseDown: onMouseDown, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, target: target, testId: testId, tooltip: tooltip, ...rest } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2JYdg.IconButton), {
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hbr4z))), {
            label: typeof tooltip === 'string' ? tooltip : 'Switch apps',
            color: "var(--ds-icon, #44546F)"
        }),
        component: component,
        href: href,
        id: id,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onMouseUp: onMouseUp,
        ref: ref,
        target: target,
        testId: testId,
        tooltip: tooltip,
        ...rest
    });
});
var // exists only to extract props
// eslint-disable-next-line import/no-anonymous-default-export
$0a4535fb412399f1$export$2e2bcd8739ae039 = (props)=>{};

});

parcelRegister("3BUx0", function(module, exports) {

$parcel$export(module.exports, "AppSwitcher", () => $1fce206d40d34bd4$export$9923361bd43fa030);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $hbr4z = parcelRequire("hbr4z");

var $3926G = parcelRequire("3926G");
const $1fce206d40d34bd4$var$toggleButtonTooltipOptions = {
    // We're disabling pointer events on the tooltip to prevent it from blocking mouse events, so that the side nav flyout stays open
    // when moving the mouse from the top bar to the side nav.
    ignoreTooltipPointerEvents: true
};
const $1fce206d40d34bd4$export$9923361bd43fa030 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ label: label, onClick: onClick, onMouseEnter: onMouseEnter, interactionName: interactionName, isSelected: isSelected, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup }, ref)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $3926G.IconButton), {
        ref: ref,
        "aria-controls": ariaControls,
        "aria-expanded": ariaExpanded,
        "aria-haspopup": ariaHasPopup,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hbr4z))),
        label: label,
        appearance: "subtle",
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        interactionName: interactionName,
        isTooltipDisabled: false,
        tooltip: $1fce206d40d34bd4$var$toggleButtonTooltipOptions,
        isSelected: isSelected
    }));

});

parcelRegister("zbAwE", function(module, exports) {

$parcel$export(module.exports, "default", () => $68e36a2b1e9b0e41$export$2e2bcd8739ae039);



var $lA9j2 = parcelRequire("lA9j2");

var $6cAn5 = parcelRequire("6cAn5");
/**
 * Takes a dot-separated token name and and an optional fallback, and returns the current computed CSS value for the
 * resulting CSS Custom Property.
 * This should be used for when the CSS cascade isn't available, eg. `<canvas>` elements, JS charting libraries, etc.
 *
 * Note: these values change depending on the theme so consider pairing them with `useThemeObserver` in React, or the
 * `ThemeMutationObserver` class elsewhere.
 *
 * @param {string} path - A dot-separated token name (example: `'color.background.brand'` or `'spacing.scale.100'`).
 * @param {string} [fallback] - The fallback value that should render when token CSS is not present in your app.
 *
 * @example
 * ```
 * const theme = useThemeObserver();
 *
 * useEffect(() => {
 *  const lineColor = getTokenValue('color.background.accent.blue.subtle', B400);
 * }, [theme]);
 * ```
 *
 */ function $68e36a2b1e9b0e41$var$getTokenValue(tokenId, fallback = '') {
    let token = (0, $lA9j2.default)[tokenId];
    let tokenValue = fallback;
    typeof $6cAn5;
    if (typeof window === 'undefined') return tokenValue;
    tokenValue = window.getComputedStyle(document.documentElement).getPropertyValue(token).trim();
    tokenValue = tokenValue || fallback;
    return tokenValue;
}
var $68e36a2b1e9b0e41$export$2e2bcd8739ae039 = $68e36a2b1e9b0e41$var$getTokenValue;

});

parcelRegister("jUalr", function(module, exports) {

$parcel$export(module.exports, "AtlassianNavigation", () => $01e61f1b649c7830$export$f66ccb39f60980e5);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $cnhic = parcelRequire("cnhic");



var $4ZDdq = parcelRequire("4ZDdq");
var $C4qHS = parcelRequire("C4qHS");

var $cQkeL = parcelRequire("cQkeL");
function $01e61f1b649c7830$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $01e61f1b649c7830$var$containerStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'flex',
    boxSizing: 'border-box',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: (0, $40a49d4606bee4e1$export$30fa7cc5f2690a43),
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexShrink: 0,
    borderBlockEnd: `1px solid ${`var(--ds-border, ${(0, $a7f8c6b391092279$export$3e51e8f1440314ba)})`}`,
    paddingInlineEnd: "var(--ds-space-150, 12px)",
    paddingInlineStart: "var(--ds-space-150, 12px)"
});
const $01e61f1b649c7830$var$leftStyles = {
    name: "vtikxo",
    styles: "display:flex;min-width:0;height:inherit;align-items:center;flex-grow:1;& > *{flex-shrink:0;}"
};
const $01e61f1b649c7830$var$rightStyles = {
    name: "1mwlrd6",
    styles: "display:flex;align-items:center;flex-shrink:0;& > *{flex-shrink:0;margin-inline-end:var(--ds-space-050, 4px);}"
};
const $01e61f1b649c7830$var$noRightMarginStyles = {
    name: "1oo7nc3",
    styles: "margin-inline-end:0"
};
const $01e61f1b649c7830$var$analyticsData = {
    attributes: {
        navigationLayer: 'global'
    },
    componentName: 'atlassianNavigation'
};
const $01e61f1b649c7830$export$f66ccb39f60980e5 = (props)=>{
    const { label: label, primaryItems: primaryItems = [], renderAppSwitcher: AppSwitcher, renderCreate: create, renderHelp: Help, renderNotifications: Notifications, renderProductHome: ProductHome, renderProfile: Profile, renderSearch: Search, renderSignIn: SignIn, renderSettings: Settings, moreLabel: moreLabel = "\u2026", theme: theme = (0, $4ZDdq.defaultTheme), testId: testId, isServer: isServer = false, isSSRPlaceholderEnabled: isSSRPlaceholderEnabled = false } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $C4qHS.ThemeProvider), {
        value: theme
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $cnhic.NavigationAnalyticsContext), {
        data: $01e61f1b649c7830$var$analyticsData
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("header", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: theme.mode.navigation,
        css: $01e61f1b649c7830$var$containerStyles,
        "data-testid": testId && `${testId}-header`,
        role: "banner",
        "data-vc": `atlassian-navigation${isServer ? '-ssr' : ''}`,
        ...isServer && isSSRPlaceholderEnabled && {
            'data-ssr-placeholder': 'atlassian-navigation-placeholder'
        },
        ...!isServer && isSSRPlaceholderEnabled && {
            'data-ssr-placeholder-replace': 'atlassian-navigation-placeholder'
        }
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("nav", {
        css: $01e61f1b649c7830$var$leftStyles,
        "aria-label": label
    }, AppSwitcher && /*#__PURE__*/ (0, $f8Sb3.jsx)(AppSwitcher, null), ProductHome && /*#__PURE__*/ (0, $f8Sb3.jsx)(ProductHome, null), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $cQkeL.PrimaryItemsContainer), {
        testId: testId,
        moreLabel: moreLabel,
        items: primaryItems,
        create: create,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        theme: theme
    })), /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $01e61f1b649c7830$var$rightStyles,
        "data-testid": testId && `${testId}-secondary-actions`
    }, Search && /*#__PURE__*/ (0, $f8Sb3.jsx)(Search, null), /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        role: "list",
        css: [
            $01e61f1b649c7830$var$rightStyles,
            $01e61f1b649c7830$var$noRightMarginStyles
        ],
        "data-vc": "atlassian-navigation-secondary-actions"
    }, Notifications && /*#__PURE__*/ (0, $f8Sb3.jsx)(Notifications, null), Help && /*#__PURE__*/ (0, $f8Sb3.jsx)(Help, null), Settings && /*#__PURE__*/ (0, $f8Sb3.jsx)(Settings, null), SignIn && /*#__PURE__*/ (0, $f8Sb3.jsx)(SignIn, null), Profile && /*#__PURE__*/ (0, $f8Sb3.jsx)(Profile, null))))));
};

});
const $40a49d4606bee4e1$export$30fa7cc5f2690a43 = 56;
const $40a49d4606bee4e1$export$4033a111ca79977d = 1280;
const $40a49d4606bee4e1$export$24ec62cee78b7042 = 1130;
const $40a49d4606bee4e1$export$d8bde68ac946124f = '--ds--ans--fbc';
const $40a49d4606bee4e1$export$73e44f54603a0964 = '--ds--ans--hbgc';
const $40a49d4606bee4e1$export$13f8aa8f663f4c99 = '--ds--ans--bgc';
const $40a49d4606bee4e1$export$d81606c1fc5119bc = '--ds--ans--c';
const $40a49d4606bee4e1$export$65f656ad520ea71 = '--ds--ans--bc';

parcelRegister("cQkeL", function(module, exports) {

$parcel$export(module.exports, "PrimaryItemsContainer", () => $89c0a7ff0d75527d$export$43e704064d596a9e);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $vCqQa = parcelRequire("vCqQa");


var $39GG1 = parcelRequire("39GG1");

var $2uT3N = parcelRequire("2uT3N");

var $jRAgj = parcelRequire("jRAgj");
function $89c0a7ff0d75527d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $89c0a7ff0d75527d$var$containerStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'flex',
    height: '100%',
    position: 'relative',
    alignItems: 'stretch',
    flexBasis: 0,
    flexGrow: 1,
    flexShrink: 0,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > *': {
        margin: `0 ${"var(--ds-space-050, 4px)"}`,
        flexShrink: 0
    }
});
const $89c0a7ff0d75527d$var$widthObserverContainerStyles = {
    name: "o1tvrz",
    styles: "width:100%;min-width:1px;margin:0px;position:relative;flex-shrink:1"
};
const $89c0a7ff0d75527d$var$overflowItemsStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    color: `var(--ds-text, ${(0, $a7f8c6b391092279$export$ad0bacf983b7ddaa)})`
});
const $89c0a7ff0d75527d$export$43e704064d596a9e = ({ moreLabel: moreLabel, items: items, create: Create, theme: theme, testId: testId })=>{
    const [isMoreOpen, setIsMoreOpen] = (0, $5uXOq.useState)(false);
    const { updateWidth: updateWidth, visibleItems: visibleItems, overflowItems: overflowItems } = (0, $2uT3N.useOverflowController)(items);
    const onMoreClick = (0, $5uXOq.useCallback)(()=>{
        setIsMoreOpen(!isMoreOpen);
    }, [
        isMoreOpen,
        setIsMoreOpen
    ]);
    const onMoreClose = (0, $5uXOq.useCallback)(()=>{
        setIsMoreOpen(false);
    }, []);
    const openOverflowMenu = (0, $5uXOq.useCallback)(()=>{
        setIsMoreOpen(true);
    }, []);
    const trigger = (0, $5uXOq.useCallback)((triggerProps)=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $jRAgj.PrimaryDropdownButton), {
            onClick: onMoreClick,
            isSelected: isMoreOpen,
            testId: testId ? `${testId}-overflow-menu-trigger` : 'overflow-menu-trigger',
            ...triggerProps
        }, moreLabel), [
        moreLabel,
        onMoreClick,
        isMoreOpen,
        testId
    ]);
    const content = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $2uT3N.OverflowProvider), {
            isVisible: false,
            openOverflowMenu: openOverflowMenu,
            closeOverflowMenu: onMoreClose
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: $89c0a7ff0d75527d$var$overflowItemsStyles
        }, overflowItems)), // Overflow items has an unstable reference - so we will only recalculate
    // content if `overflowItems` length changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        overflowItems.length,
        openOverflowMenu,
        onMoreClose
    ]);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $89c0a7ff0d75527d$var$containerStyles,
        "data-testid": testId && `${testId}-primary-actions`,
        role: "list"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $2uT3N.OverflowProvider), {
        isVisible: true,
        openOverflowMenu: openOverflowMenu,
        closeOverflowMenu: onMoreClose
    }, visibleItems), overflowItems.length > 0 && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $vCqQa.default), {
        shouldRenderToParent: true,
        placement: "bottom-start",
        content: content,
        isOpen: isMoreOpen,
        onClose: onMoreClose,
        trigger: trigger,
        testId: testId ? `${testId}-overflow-menu-popup` : 'overflow-menu-popup'
    }), Create && /*#__PURE__*/ (0, $f8Sb3.jsx)(Create, null), /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $89c0a7ff0d75527d$var$widthObserverContainerStyles
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $39GG1.WidthObserver), {
        offscreen: true,
        setWidth: updateWidth
    })));
};

});
parcelRegister("jRAgj", function(module, exports) {

$parcel$export(module.exports, "PrimaryDropdownButton", () => $c0995fd2e5296a83$export$bb3af89fb196520d);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $jVpd1 = parcelRequire("jVpd1");

var $dGKFs = parcelRequire("dGKFs");

var $fHpHg = parcelRequire("fHpHg");

var $eXSfx = parcelRequire("eXSfx");
const $c0995fd2e5296a83$export$bb3af89fb196520d = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { component: component, isHighlighted: isHighlighted, isLoading: isLoading, onClick: onClick, testId: testId, theme: theme, tooltip: tooltip, ...rest } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $eXSfx.PrimaryButton), {
        component: component,
        iconAfter: // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        (0, $fHpHg.fg)('platform-component-visual-refresh') ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jVpd1))), {
            label: "",
            color: "currentColor"
        }) : /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dGKFs))), {
            LEGACY_margin: `0 ${"var(--ds-space-negative-050, -4px)"} 0 ${"var(--ds-space-negative-100, -8px)"}`,
            color: "currentColor",
            label: ""
        }),
        isHighlighted: isHighlighted,
        isLoading: isLoading,
        onClick: onClick,
        ref: ref,
        testId: testId,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        theme: theme,
        tooltip: tooltip,
        ...rest
    });
});

});
parcelRegister("eXSfx", function(module, exports) {

$parcel$export(module.exports, "PrimaryButton", () => $83f5dffa97b97c7c$export$ac16a6a04d9b7c84);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $1nSOt = parcelRequire("1nSOt");

var $5KCCi = parcelRequire("5KCCi");

var $h4hQR = parcelRequire("h4hQR");

var $kJvrK = parcelRequire("kJvrK");
function $83f5dffa97b97c7c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $83f5dffa97b97c7c$var$VAR_BUTTON_SELECTED_COLOR = '--button-selected-color';
const $83f5dffa97b97c7c$var$VAR_BUTTON_SELECTED_BORDER_COLOR = '--button-selected-border-color';
const $83f5dffa97b97c7c$var$buttonBaseStyles = {
    name: "8cx1fx",
    styles: "display:flex;height:100%;position:relative;align-items:center;justify-content:center;flex-direction:column"
};
const $83f5dffa97b97c7c$var$buttonHighlightedStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&& > *': {
        color: `var(${$83f5dffa97b97c7c$var$VAR_BUTTON_SELECTED_COLOR})`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:after': {
        height: 3,
        position: 'absolute',
        backgroundColor: `var(${$83f5dffa97b97c7c$var$VAR_BUTTON_SELECTED_BORDER_COLOR})`,
        borderStartEndRadius: "var(--ds-border-radius-050, 1px)",
        borderStartStartRadius: "var(--ds-border-radius-050, 1px)",
        content: '""',
        insetBlockEnd: 0,
        insetInlineEnd: "var(--ds-space-050, 4px)",
        insetInlineStart: "var(--ds-space-050, 4px)"
    }
});
const $83f5dffa97b97c7c$export$ac16a6a04d9b7c84 = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { children: children, component: component, isHighlighted: isHighlighted, isLoading: isLoading, isSelected: isSelected, onClick: onClick, testId: testId, theme: theme, tooltip: tooltip, ...rest } = props;
    const themeFromContext = (0, $h4hQR.useTheme)();
    const button = /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        style: {
            [$83f5dffa97b97c7c$var$VAR_BUTTON_SELECTED_COLOR]: themeFromContext.mode.primaryButton.selected.color,
            [$83f5dffa97b97c7c$var$VAR_BUTTON_SELECTED_BORDER_COLOR]: themeFromContext.mode.primaryButton.selected.borderColor
        },
        css: [
            $83f5dffa97b97c7c$var$buttonBaseStyles,
            isHighlighted && $83f5dffa97b97c7c$var$buttonHighlightedStyles
        ],
        role: "listitem",
        "data-vc": "primary-button"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $1nSOt.default), {
        appearance: "primary",
        component: component,
        isLoading: isLoading,
        isSelected: isSelected,
        onClick: onClick,
        ref: ref,
        testId: testId,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides, @atlaskit/design-system/no-unsafe-style-overrides
        theme: theme || (0, $kJvrK.getPrimaryButtonTheme)(themeFromContext),
        ...rest
    }, children));
    if (tooltip) return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5KCCi.default), {
        content: tooltip,
        hideTooltipOnClick: true
    }, button);
    return button;
});

});
parcelRegister("kJvrK", function(module, exports) {

$parcel$export(module.exports, "getPrimaryButtonTheme", () => $9668d3612793a495$export$14dd6915caf431fe);
const $9668d3612793a495$export$14dd6915caf431fe = ({ mode: { primaryButton: primaryButton } })=>(current, props)=>{
        const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = current(props);
        return {
            buttonStyles: {
                ...buttonStyles,
                ...primaryButton.default,
                ...props.isSelected && primaryButton.selected,
                fontWeight: "var(--ds-font-weight-medium, 500)",
                padding: `0 ${"var(--ds-space-050, 4px)"}`,
                marginLeft: 0,
                marginRight: 0,
                ':hover': props.isSelected ? primaryButton.selectedHover : primaryButton.hover,
                ':focus': primaryButton.focus,
                // :active doesn't work in FF, because we do a
                // e.preventDefault() on mouse down in Button.
                // '&&' is required to add more CSS specificity
                // && it not a valid CSSObject property
                // @ts-ignore
                '&&': {
                    ...props.state === 'active' && primaryButton.active
                }
            },
            spinnerStyles: spinnerStyles
        };
    };

});





parcelRegister("kTvze", function(module, exports) {

$parcel$export(module.exports, "SkeletonSwitcherButton", () => $41fdca9aaa09ccc9$export$41b1bb24b7702cc2);
$parcel$export(module.exports, "Nav4SkeletonSwitcherButton", () => $41fdca9aaa09ccc9$export$68afc1d9d20a7bd8);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $hbr4z = parcelRequire("hbr4z");

var $98YGb = parcelRequire("98YGb");

var $inPL4 = parcelRequire("inPL4");

var $h4hQR = parcelRequire("h4hQR");
const $41fdca9aaa09ccc9$var$skeletonSwitcherButtonStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    margin: 0,
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    marginRight: "var(--ds-space-050, 4px)",
    padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-075, 6px)"}`,
    border: 0,
    borderRadius: "var(--ds-border-radius-circle, 100%)",
    pointerEvents: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':focus, :active, :hover': {
        appearance: 'none',
        border: 0,
        outline: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:only-of-type': {
        // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
        marginRight: 0
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > span': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 'normal'
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > img': {
        width: 24,
        height: 24,
        borderRadius: "var(--ds-border-radius-circle, 100%)",
        verticalAlign: 'middle'
    }
});
const $41fdca9aaa09ccc9$export$41b1bb24b7702cc2 = ({ label: label = '', testId: testId })=>{
    const theme = (0, $h4hQR.useTheme)();
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("button", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: theme.mode.iconButton.default,
        "data-testid": testId,
        css: $41fdca9aaa09ccc9$var$skeletonSwitcherButtonStyles,
        type: "button"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($98YGb))), {
        color: "currentColor",
        spacing: "spacious",
        label: label
    }));
};
const $41fdca9aaa09ccc9$export$68afc1d9d20a7bd8 = ({ label: label = '', testId: testId })=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $inPL4.SkeletonIconButton), null, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hbr4z))), {
        label: label,
        spacing: "spacious",
        color: "var(--ds-icon, #44546F)"
    }));

});
parcelRegister("inPL4", function(module, exports) {

$parcel$export(module.exports, "SkeletonIconButton", () => $7a6dd109d0ff6aba$export$7b398af37f6177e);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $h4hQR = parcelRequire("h4hQR");
function $7a6dd109d0ff6aba$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7a6dd109d0ff6aba$var$skeletonIconButtonStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    margin: 0,
    padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-075, 6px)"}`,
    border: 0,
    borderRadius: "var(--ds-border-radius-circle, 100%)",
    pointerEvents: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':focus, :active, :hover': {
        appearance: 'none',
        border: 0,
        outline: 0
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > span': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 'normal'
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > img': {
        width: 24,
        height: 24,
        borderRadius: "var(--ds-border-radius-circle, 100%)",
        verticalAlign: 'middle'
    }
});
const $7a6dd109d0ff6aba$var$buttonWrapperStyles = {
    name: "khzvr",
    styles: "margin-inline-end:var(--ds-space-050, 4px);&:only-of-type{margin-inline-end:0;}"
};
const $7a6dd109d0ff6aba$export$7b398af37f6177e = ({ children: children, testId: testId })=>{
    const theme = (0, $h4hQR.useTheme)();
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        role: "listitem",
        css: $7a6dd109d0ff6aba$var$buttonWrapperStyles
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("button", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: theme.mode.iconButton.default,
        "data-testid": testId,
        css: $7a6dd109d0ff6aba$var$skeletonIconButtonStyles,
        type: "button"
    }, children));
};

});


parcelRegister("6mZMG", function(module, exports) {

$parcel$export(module.exports, "Create", () => $adf8999434de9f1a$export$8ade6fcbf3a7de5d);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $1nSOt = parcelRequire("1nSOt");

var $g16BY = parcelRequire("g16BY");

var $5KCCi = parcelRequire("5KCCi");


var $h4hQR = parcelRequire("h4hQR");

var $2JYdg = parcelRequire("2JYdg");

var $aK4t5 = parcelRequire("aK4t5");
const $adf8999434de9f1a$var$wrapperStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'flex',
    alignItems: 'center',
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& [data-hide-on-smallscreens]': {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [`@media (max-width: ${(0, $40a49d4606bee4e1$export$24ec62cee78b7042) - 1}px)`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
            display: 'none !important'
        }
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& [data-hide-on-largescreens]': {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [`@media (min-width: ${0, $40a49d4606bee4e1$export$24ec62cee78b7042}px)`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
            display: 'none !important'
        }
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&&': {
        marginInlineStart: "var(--ds-space-150, 12px)"
    }
});
const $adf8999434de9f1a$var$TooltipSwitch = ({ buttonTooltip: buttonTooltip, children: children })=>buttonTooltip ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5KCCi.default), {
        content: buttonTooltip,
        hideTooltipOnClick: true
    }, children) : /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, children);
const $adf8999434de9f1a$export$8ade6fcbf3a7de5d = ({ onClick: onClick, href: href, text: text, buttonTooltip: buttonTooltip, iconButtonTooltip: iconButtonTooltip, testId: testId, label: label })=>{
    const theme = (0, $h4hQR.useTheme)();
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $adf8999434de9f1a$var$wrapperStyles,
        role: "listitem",
        "data-testid": "create-button-wrapper"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)($adf8999434de9f1a$var$TooltipSwitch, {
        buttonTooltip: buttonTooltip
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $1nSOt.default), {
        id: "createGlobalItem",
        "aria-label": label,
        onClick: onClick,
        href: href,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides, @atlaskit/design-system/no-unsafe-style-overrides
        theme: (0, $aK4t5.getCreateButtonTheme)(theme),
        testId: testId && `${testId}-button`,
        "data-hide-on-smallscreens": true
    }, text)), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $2JYdg.IconButton), {
        id: "createGlobalItemIconButton",
        testId: testId && `${testId}-icon-button`,
        icon: /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($g16BY))), {
            color: "currentColor",
            spacing: "spacious",
            label: text
        }),
        onClick: onClick,
        href: href,
        tooltip: iconButtonTooltip,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        theme: (0, $aK4t5.getCreateButtonTheme)(theme),
        "aria-label": text,
        "data-hide-on-largescreens": true
    }));
};

});
parcelRegister("g16BY", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cbaf72704b8a24398cb5b76f6fe1dbfe>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ba91de4015b9a0f6$var$_react = $ba91de4015b9a0f6$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $ba91de4015b9a0f6$var$_add = $ba91de4015b9a0f6$var$_interopRequireDefault((parcelRequire("46OkO")));

var $ba91de4015b9a0f6$var$_add2 = $ba91de4015b9a0f6$var$_interopRequireDefault((parcelRequire("9qRdk")));
function $ba91de4015b9a0f6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for AddIcon.
 * This component is AddIcon, with `UNSAFE_fallbackIcon` set to "EditorAddIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for creating and adding an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ba91de4015b9a0f6$var$AddIcon = (props)=>/*#__PURE__*/ $ba91de4015b9a0f6$var$_react.default.createElement($ba91de4015b9a0f6$var$_add.default, Object.assign({
        LEGACY_fallbackIcon: $ba91de4015b9a0f6$var$_add2.default
    }, props));
$ba91de4015b9a0f6$var$AddIcon.Name = 'AddIconMigration';
var $ba91de4015b9a0f6$var$_default = module.exports.default = $ba91de4015b9a0f6$var$AddIcon;

});

parcelRegister("aK4t5", function(module, exports) {

$parcel$export(module.exports, "getCreateButtonTheme", () => $45186f9e84c3f03d$export$256eebed8e934f30);
const $45186f9e84c3f03d$export$256eebed8e934f30 = ({ mode: { create: create } })=>(current, props)=>{
        const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = current(props);
        return {
            buttonStyles: {
                ...buttonStyles,
                ...create.default,
                margin: 0,
                fontWeight: "var(--ds-font-weight-medium, 500)",
                ':hover': create.hover,
                ':focus': create.focus,
                // :active doesn't work in FF, becasue we do a
                // e.preventDefault() on mouse down in Button.
                // '&&' is required to add more CSS specificity
                // && it not a valid CSSObject property
                // @ts-ignore
                '&&': {
                    ...props.state === 'active' && create.active
                }
            },
            spinnerStyles: spinnerStyles
        };
    };

});


parcelRegister("ayYib", function(module, exports) {

$parcel$export(module.exports, "SkeletonCreateButton", () => $42881ebafc12729d$export$e321b2260435e302);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $h4hQR = parcelRequire("h4hQR");
function $42881ebafc12729d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $42881ebafc12729d$var$skeletonCreateButtonStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    height: 32,
    padding: `0 ${"var(--ds-space-150, 12px)"}`,
    alignSelf: 'center',
    border: 0,
    borderRadius: "var(--ds-border-radius, 3px)",
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    pointerEvents: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':focus, :active, :hover': {
        appearance: 'none',
        border: 0,
        outline: 0
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&&': {
        marginInlineStart: "var(--ds-space-150, 12px)"
    }
});
const $42881ebafc12729d$var$buttonWrapperStyles = {
    name: "rfxc55",
    styles: "display:flex;margin:0"
};
const $42881ebafc12729d$export$e321b2260435e302 = ({ text: text, testId: testId })=>{
    const theme = (0, $h4hQR.useTheme)();
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        role: "listitem",
        css: $42881ebafc12729d$var$buttonWrapperStyles
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("button", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: theme.mode.create.default,
        css: $42881ebafc12729d$var$skeletonCreateButtonStyles,
        "data-testid": testId,
        type: "button"
    }, text));
};

});

parcelRegister("5CrDn", function(module, exports) {

$parcel$export(module.exports, "CreateButton", () => $81454236180dd5e2$export$6d3c345ce7c38fd9);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $46OkO = parcelRequire("46OkO");

var $3926G = parcelRequire("3926G");
const $81454236180dd5e2$export$6d3c345ce7c38fd9 = ({ children: children, onClick: onClick, testId: testId, interactionName: interactionName })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $3926G.Button), {
        appearance: "primary",
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($46OkO))),
        onClick: onClick,
        testId: testId,
        interactionName: interactionName,
        children: children
    });

});

parcelRegister("4ZDon", function(module, exports) {

$parcel$export(module.exports, "Help", () => $57b2629d40ced443$export$1be7516c0280bee8);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $3vNgn = parcelRequire("3vNgn");

var $h4hQR = parcelRequire("h4hQR");

var $8xcQd = parcelRequire("8xcQd");

var $2JYdg = parcelRequire("2JYdg");
const $57b2629d40ced443$var$HELP_NOTIFICATION_BADGE_ID = 'atlassian-navigation-help-notification-count';
const $57b2629d40ced443$export$1be7516c0280bee8 = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { badge: badge, component: component, href: href, id: id, isDisabled: isDisabled, isSelected: isSelected, label: label, onBlur: onBlur, onClick: onClick, onFocus: onFocus, onMouseDown: onMouseDown, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, target: target, testId: testId, tooltip: tooltip, ...rest } = props;
    const { mode: { navigation: navigation } } = (0, $h4hQR.useTheme)();
    const button = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2JYdg.IconButton), {
        component: component,
        href: href,
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3vNgn))), {
            label: typeof tooltip === 'string' ? tooltip : 'Help Icon',
            color: "currentColor",
            spacing: "spacious",
            LEGACY_secondaryColor: navigation.backgroundColor
        }),
        id: id,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onMouseUp: onMouseUp,
        ref: ref,
        target: target,
        testId: testId,
        tooltip: tooltip,
        isTooltipAnnouncementDisabled: true,
        ...rest
    });
    return badge ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8xcQd.BadgeContainer), {
        id: $57b2629d40ced443$var$HELP_NOTIFICATION_BADGE_ID,
        badge: badge,
        role: "listitem",
        children: button
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        role: "listitem",
        children: button
    });
});

});
parcelRegister("8xcQd", function(module, exports) {

$parcel$export(module.exports, "BadgeContainer", () => $71ae25c8440d3fb7$export$f710265eb5a003da);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");
function $71ae25c8440d3fb7$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $71ae25c8440d3fb7$var$badgeContainerStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    position: 'absolute',
    insetBlockStart: `${"var(--ds-space-negative-050, -4px)"}`,
    insetInlineEnd: `${"var(--ds-space-negative-025, -2px)"}`,
    pointerEvents: 'none'
});
const $71ae25c8440d3fb7$var$containerStyles = {
    name: "bjn8wh",
    styles: "position:relative"
};
const $71ae25c8440d3fb7$export$f710265eb5a003da = (props)=>{
    const { id: badgeId, badge: Badge, children: children, role: role } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $71ae25c8440d3fb7$var$containerStyles,
        role: role
    }, children, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $71ae25c8440d3fb7$var$badgeContainerStyles,
        id: badgeId,
        "aria-hidden": true
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)(Badge, null)));
};

});


parcelRegister("bp39N", function(module, exports) {

$parcel$export(module.exports, "SkeletonHelpButton", () => $015d71ebfe88e2d8$export$9ee5d6e291d4e456);
$parcel$export(module.exports, "Nav4SkeletonHelpButton", () => $015d71ebfe88e2d8$export$c25bc9ca782b25f4);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $3vNgn = parcelRequire("3vNgn");

var $4vF4i = parcelRequire("4vF4i");

var $inPL4 = parcelRequire("inPL4");

var $h4hQR = parcelRequire("h4hQR");
const $015d71ebfe88e2d8$export$9ee5d6e291d4e456 = ({ label: label = '' })=>{
    const { mode: { navigation: navigation } } = (0, $h4hQR.useTheme)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $inPL4.SkeletonIconButton), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3vNgn))), {
            label: label,
            color: "currentColor",
            LEGACY_secondaryColor: navigation.backgroundColor
        })
    });
};
const $015d71ebfe88e2d8$export$c25bc9ca782b25f4 = ({ label: label = '' })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $inPL4.SkeletonIconButton), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4vF4i))), {
            label: label,
            spacing: "spacious",
            color: "var(--ds-icon, #44546F)"
        })
    });

});

parcelRegister("fQryW", function(module, exports) {

$parcel$export(module.exports, "Help", () => $d102d4ae5ad6e5c8$export$1be7516c0280bee8);
/**
 * @jsxRuntime classic
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $4vF4i = parcelRequire("4vF4i");

var $78rFO = parcelRequire("78rFO");

var $92SLf = parcelRequire("92SLf");

var $3926G = parcelRequire("3926G");
const $d102d4ae5ad6e5c8$var$HELP_NOTIFICATION_BADGE_ID = 'atlassian-navigation-help-notification-count';
const $d102d4ae5ad6e5c8$export$1be7516c0280bee8 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ badge: badge, onClick: onClick, label: label, isSelected: isSelected, testId: testId, interactionName: interactionName }, forwardedRef)=>{
    const button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3926G.IconButton), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4vF4i))),
        label: label,
        onClick: onClick,
        appearance: "subtle",
        isSelected: isSelected,
        ref: forwardedRef,
        isTooltipDisabled: false,
        testId: testId,
        interactionName: interactionName
    });
    if (!badge) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $92SLf.ListItem), null, button);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $78rFO.BadgeContainer), {
        id: $d102d4ae5ad6e5c8$var$HELP_NOTIFICATION_BADGE_ID,
        badge: badge,
        role: "listitem"
    }, button);
});

});
parcelRegister("78rFO", function(module, exports) {

$parcel$export(module.exports, "BadgeContainer", () => $5111600779a1b8ba$export$f710265eb5a003da);
/* badge-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $5111600779a1b8ba$var$styles = {
    root: "_kqswh2mm _1e0c1txw",
    badgeContainer: "_kqswstnw _o5721q9c _152tr5cr _1e02utpp _lcxvglyw"
};
const $5111600779a1b8ba$export$f710265eb5a003da = ({ children: children, id: badgeId, badge: Badge, role: role })=>/*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        role: role,
        className: (0, $bwpsq.default)([
            $5111600779a1b8ba$var$styles.root
        ]),
        children: [
            children,
            /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                id: badgeId,
                "aria-hidden": true,
                className: (0, $bwpsq.default)([
                    $5111600779a1b8ba$var$styles.badgeContainer
                ]),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)(Badge, {})
            })
        ]
    });

});

parcelRegister("92SLf", function(module, exports) {

$parcel$export(module.exports, "ListItem", () => $7014f0aea9eca735$export$a7b06bfba60a8a78);
/* list-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
function $7014f0aea9eca735$var$_ListItem({ children: children, testId: testId, xcss: xcss }, ref) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        role: "listitem",
        ref: ref,
        className: xcss,
        "data-testid": testId,
        children: children
    });
}
const $7014f0aea9eca735$export$a7b06bfba60a8a78 = /*#__PURE__*/ (0, $5uXOq.forwardRef)($7014f0aea9eca735$var$_ListItem);

});


parcelRegister("iXjIy", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca62bd6606097a15$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");



var $h4hQR = parcelRequire("h4hQR");

var $49KW2 = parcelRequire("49KW2");
function $ca62bd6606097a15$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $ca62bd6606097a15$var$VAR_PRODUCT_HOME_COLOR_ACTIVE = '--product-home-color-active';
const $ca62bd6606097a15$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE = '--product-home-bg-color-active';
const $ca62bd6606097a15$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE = '--product-home-box-shadow-active';
const $ca62bd6606097a15$var$VAR_PRODUCT_HOME_COLOR_FOCUS = '--product-home-color-focus';
const $ca62bd6606097a15$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS = '--product-home-bg-color-focus';
const $ca62bd6606097a15$var$VAR_PRODUCT_HOME_BOX_SHADOW_FOCUS = '--product-home-box-shadow-focus';
const $ca62bd6606097a15$var$VAR_PRODUCT_HOME_COLOR_HOVER = '--product-home-color-hover';
const $ca62bd6606097a15$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER = '--product-home-bg-color-hover';
const $ca62bd6606097a15$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER = '--product-home-box-shadow-hover';
const $ca62bd6606097a15$var$productLogoStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // Ensure anything passed into
    // productHome is aligned correctly
    display: 'flex',
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (max-width: ${(0, $40a49d4606bee4e1$export$4033a111ca79977d) - 0.1}px)`]: {
        display: 'none'
    }
});
const $ca62bd6606097a15$var$customMaxHeightStyles = {
    name: "31vqaf",
    styles: "max-height:28px"
};
const $ca62bd6606097a15$var$productIconStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // Ensure anything passed into
    // productHome is aligned correctly
    display: 'flex',
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (min-width: ${0, $40a49d4606bee4e1$export$4033a111ca79977d}px)`]: {
        display: 'none'
    }
});
const $ca62bd6606097a15$var$productHomeButtonStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'flex',
    padding: "var(--ds-space-050, 4px)",
    alignItems: 'center',
    background: 'none',
    border: 0,
    borderRadius: "var(--ds-border-radius, 3px)",
    color: 'inherit',
    cursor: 'pointer',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&::-moz-focus-inner': {
        border: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:first-of-type': {
        marginInlineStart: 0
    },
    '&:hover': {
        backgroundColor: `var(${$ca62bd6606097a15$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER})`,
        boxShadow: `var(${$ca62bd6606097a15$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER})`,
        color: `var(${$ca62bd6606097a15$var$VAR_PRODUCT_HOME_COLOR_HOVER})`
    },
    '&:active': {
        backgroundColor: `var(${$ca62bd6606097a15$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE})`,
        boxShadow: `var(${$ca62bd6606097a15$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE})`,
        color: `var(${$ca62bd6606097a15$var$VAR_PRODUCT_HOME_COLOR_ACTIVE})`
    },
    '&:focus-visible': {
        backgroundColor: `var(${$ca62bd6606097a15$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS})`,
        color: `var(${$ca62bd6606097a15$var$VAR_PRODUCT_HOME_COLOR_FOCUS})`,
        outline: `2px solid ${`var(--ds-border-focused, ${(0, $a7f8c6b391092279$export$215b7063051591f1)})`}`
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    'div&': {
        pointerEvents: 'none'
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (max-width: ${(0, $40a49d4606bee4e1$export$4033a111ca79977d) - 0.1}px)`]: {
        margin: `0 ${"var(--ds-space-100, 8px)"}`
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (min-width: ${0, $40a49d4606bee4e1$export$4033a111ca79977d}px)`]: {
        margin: `0 ${"var(--ds-space-200, 16px)"}`
    }
});
const $ca62bd6606097a15$var$siteTitleStyles = {
    name: "1q75v0",
    styles: "display:flex;align-items:center;margin-inline-end:var(--ds-space-050, 4px);margin-inline-start:var(--ds-space-050, 4px);padding-inline-end:var(--ds-space-200, 16px)"
};
/**
 * __Custom product home__
 *
 * Use `CustomProductHome` to provide a custom logo and icon with URLs.
 *
 * - [Examples](https://atlassian.design/components/atlassian-navigation/examples#custom-product-home)
 * - [Code](https://atlassian.design/components/atlassian-navigation/code)
 */ const $ca62bd6606097a15$var$CustomProductHome = (props)=>{
    const { href: href, iconAlt: iconAlt, iconUrl: iconUrl, logoAlt: logoAlt, logoMaxWidth: logoMaxWidth = 260, logoUrl: logoUrl, onClick: onClick, onMouseDown: onMouseDown, siteTitle: siteTitle, testId: testId, ...rest } = props;
    const theme = (0, $h4hQR.useTheme)();
    const primaryButton = theme.mode.primaryButton;
    const Tag = (0, $49KW2.getTag)(onClick, href);
    const preventFocusRing = (event)=>{
        event.preventDefault();
        onMouseDown && onMouseDown(event);
    };
    const productHomeButtonDynamicStyles = {
        [$ca62bd6606097a15$var$VAR_PRODUCT_HOME_COLOR_ACTIVE]: primaryButton.active.color,
        [$ca62bd6606097a15$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE]: primaryButton.active.backgroundColor,
        [$ca62bd6606097a15$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE]: primaryButton.active.boxShadow,
        [$ca62bd6606097a15$var$VAR_PRODUCT_HOME_COLOR_FOCUS]: primaryButton.focus.color,
        [$ca62bd6606097a15$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS]: primaryButton.focus.backgroundColor,
        [$ca62bd6606097a15$var$VAR_PRODUCT_HOME_BOX_SHADOW_FOCUS]: primaryButton.focus.boxShadow,
        [$ca62bd6606097a15$var$VAR_PRODUCT_HOME_COLOR_HOVER]: primaryButton.hover.color,
        [$ca62bd6606097a15$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER]: primaryButton.hover.backgroundColor,
        [$ca62bd6606097a15$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER]: primaryButton.hover.boxShadow
    };
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, /*#__PURE__*/ (0, $f8Sb3.jsx)(Tag, {
        href: href,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: productHomeButtonDynamicStyles,
        css: $ca62bd6606097a15$var$productHomeButtonStyles,
        onClick: onClick,
        onMouseDown: preventFocusRing,
        "data-testid": testId && `${testId}-container`,
        ...rest
    }, logoUrl && /*#__PURE__*/ (0, $f8Sb3.jsx)("img", {
        style: {
            maxWidth: logoMaxWidth
        },
        css: [
            $ca62bd6606097a15$var$customMaxHeightStyles,
            $ca62bd6606097a15$var$productLogoStyles
        ],
        src: logoUrl,
        alt: logoAlt,
        "data-testid": testId && `${testId}-logo`,
        "data-vc": "custom-product-home-logo"
    }), iconUrl && /*#__PURE__*/ (0, $f8Sb3.jsx)("img", {
        style: {
            maxWidth: logoMaxWidth
        },
        css: [
            $ca62bd6606097a15$var$customMaxHeightStyles,
            $ca62bd6606097a15$var$productIconStyles
        ],
        src: iconUrl,
        alt: iconAlt,
        "data-testid": testId && `${testId}-icon`,
        "data-vc": "custom-product-home-icon"
    })), siteTitle && /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        style: {
            borderRight: theme.mode.productHome.borderRight
        },
        css: $ca62bd6606097a15$var$siteTitleStyles,
        "data-testid": testId && `${testId}-site-title`
    }, siteTitle));
};
var $ca62bd6606097a15$export$2e2bcd8739ae039 = $ca62bd6606097a15$var$CustomProductHome;

});
parcelRegister("49KW2", function(module, exports) {

$parcel$export(module.exports, "getTag", () => $6b927eda40aeb8e6$export$dad497fe1f6e27c0);
const $6b927eda40aeb8e6$export$dad497fe1f6e27c0 = (onClick, href)=>{
    if (href) return 'a';
    if (onClick) return 'button';
    return 'div';
};

});


parcelRegister("eUk3o", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e05473b886b5a77$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $fHpHg = parcelRequire("fHpHg");



var $h4hQR = parcelRequire("h4hQR");

var $hNUWC = parcelRequire("hNUWC");

var $49KW2 = parcelRequire("49KW2");
function $0e05473b886b5a77$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $0e05473b886b5a77$var$VAR_LOGO_MAX_WIDTH = '--logo-max-width';
const $0e05473b886b5a77$var$VAR_PRODUCT_HOME_COLOR_ACTIVE = '--product-home-color-active';
const $0e05473b886b5a77$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE = '--product-home-bg-color-active';
const $0e05473b886b5a77$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE = '--product-home-box-shadow-active';
const $0e05473b886b5a77$var$VAR_PRODUCT_HOME_COLOR_FOCUS = '--product-home-color-focus';
const $0e05473b886b5a77$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS = '--product-home-bg-color-focus';
const $0e05473b886b5a77$var$VAR_PRODUCT_HOME_BOX_SHADOW_FOCUS = '--product-home-box-shadow-focus';
const $0e05473b886b5a77$var$VAR_PRODUCT_HOME_COLOR_HOVER = '--product-home-color-hover';
const $0e05473b886b5a77$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER = '--product-home-bg-color-hover';
const $0e05473b886b5a77$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER = '--product-home-box-shadow-hover';
const $0e05473b886b5a77$var$productHomeButtonStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'flex',
    padding: "var(--ds-space-050, 4px)",
    alignItems: 'center',
    background: 'none',
    border: 0,
    borderRadius: "var(--ds-border-radius, 3px)",
    color: 'inherit',
    cursor: 'pointer',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&::-moz-focus-inner': {
        border: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:first-of-type': {
        marginInlineStart: 0
    },
    '&:hover': {
        backgroundColor: `var(${$0e05473b886b5a77$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER})`,
        boxShadow: `var(${$0e05473b886b5a77$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER})`,
        color: `var(${$0e05473b886b5a77$var$VAR_PRODUCT_HOME_COLOR_HOVER})`
    },
    '&:active': {
        backgroundColor: `var(${$0e05473b886b5a77$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE})`,
        boxShadow: `var(${$0e05473b886b5a77$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE})`,
        color: `var(${$0e05473b886b5a77$var$VAR_PRODUCT_HOME_COLOR_ACTIVE})`
    },
    '&:focus-visible': {
        backgroundColor: `var(${$0e05473b886b5a77$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS})`,
        color: `var(${$0e05473b886b5a77$var$VAR_PRODUCT_HOME_COLOR_FOCUS})`,
        outline: `${"var(--ds-border-width-outline, 2px)"} solid ${"var(--ds-border-focused, #4C9AFF)"}`
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    'div&': {
        pointerEvents: 'none'
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (max-width: ${(0, $40a49d4606bee4e1$export$4033a111ca79977d) - 0.1}px)`]: {
        margin: `0 ${"var(--ds-space-100, 8px)"}`
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (min-width: ${0, $40a49d4606bee4e1$export$4033a111ca79977d}px)`]: {
        margin: `0 ${"var(--ds-space-200, 16px)"}`
    }
});
const $0e05473b886b5a77$var$productLogoStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // Ensure anything passed into
    // productHome is aligned correctly
    display: 'flex',
    maxWidth: `var(${$0e05473b886b5a77$var$VAR_LOGO_MAX_WIDTH})`,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > *': {
        maxHeight: 24
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > span > svg': {
        maxWidth: `var(${$0e05473b886b5a77$var$VAR_LOGO_MAX_WIDTH})`
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (max-width: ${(0, $40a49d4606bee4e1$export$4033a111ca79977d) - 0.1}px)`]: {
        display: 'none'
    }
});
const $0e05473b886b5a77$var$customMaxHeightStyles = {
    name: "31vqaf",
    styles: "max-height:28px"
};
const $0e05473b886b5a77$var$productIconStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // Ensure anything passed into
    // productHome is aligned correctly
    display: 'flex',
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > *': {
        maxHeight: 24
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (min-width: ${0, $40a49d4606bee4e1$export$4033a111ca79977d}px)`]: {
        display: 'none'
    }
});
const $0e05473b886b5a77$var$siteTitleStyles = {
    name: "1q75v0",
    styles: "display:flex;align-items:center;margin-inline-end:var(--ds-space-050, 4px);margin-inline-start:var(--ds-space-050, 4px);padding-inline-end:var(--ds-space-200, 16px)"
};
/**
 * __Product home__
 *
 * The ProductHome component displays the product visual identity composed of:
 * logo, icon, and optional text. Values for logo and icon are never displayed
 * at the same time, where icon is used only when space is restricted. Should be
 * passed into `AtlassianNavigation`'s `renderProductHome` prop.
 *
 * - [Examples](https://atlassian.design/components/atlassian-navigation/examples#product-home)
 * - [Code](https://atlassian.design/components/atlassian-navigation/code)
 */ const $0e05473b886b5a77$var$ProductHome = ({ 'aria-label': ariaLabel, href: href, icon: Icon, logo: Logo, logoMaxWidth: logoMaxWidth = 260, onClick: onClick, onMouseDown: onMouseDown, siteTitle: siteTitle, testId: testId, ...rest })=>{
    const theme = (0, $h4hQR.useTheme)();
    const primaryButton = theme.mode.primaryButton;
    // After the brand refresh, iconColor and textColor should be set to 'undefined' to allow the original
    // multi-color logo tile colors to be visible, rather than a hardcoded blue.
    let { iconColor: iconColor = (0, $fHpHg.fg)('platform-team25-app-icon-tiles') ? undefined : 'inherit', textColor: textColor = (0, $fHpHg.fg)('platform-team25-app-icon-tiles') ? undefined : theme.mode.productHome.color } = theme.mode.productHome;
    // The default theme is set at module scope and immediately used in context.
    // To allow the feature flag to switch the logo color at runtime, we also detect the original hardcoded
    // values and override them to undefined.
    if (iconColor === '#357DE8' && textColor === `var(--ds-text, ${0, $a7f8c6b391092279$export$ad0bacf983b7ddaa})` && (0, $fHpHg.fg)('platform-team25-app-icon-tiles')) {
        iconColor = undefined;
        textColor = undefined;
    }
    const Tag = (0, $49KW2.getTag)(onClick, href);
    const preventFocusRing = (e)=>{
        e.preventDefault();
        onMouseDown && onMouseDown(e);
    };
    const productHomeButtonDynamicStyles = (0, $hNUWC.stripEmptyProperties)({
        [$0e05473b886b5a77$var$VAR_PRODUCT_HOME_COLOR_ACTIVE]: primaryButton.active.color,
        [$0e05473b886b5a77$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE]: primaryButton.active.backgroundColor,
        [$0e05473b886b5a77$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE]: primaryButton.active.boxShadow,
        [$0e05473b886b5a77$var$VAR_PRODUCT_HOME_COLOR_FOCUS]: primaryButton.focus.color,
        [$0e05473b886b5a77$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS]: primaryButton.focus.backgroundColor,
        [$0e05473b886b5a77$var$VAR_PRODUCT_HOME_BOX_SHADOW_FOCUS]: primaryButton.focus.boxShadow,
        [$0e05473b886b5a77$var$VAR_PRODUCT_HOME_COLOR_HOVER]: primaryButton.hover.color,
        [$0e05473b886b5a77$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER]: primaryButton.hover.backgroundColor,
        [$0e05473b886b5a77$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER]: primaryButton.hover.boxShadow,
        [$0e05473b886b5a77$var$VAR_LOGO_MAX_WIDTH]: `${logoMaxWidth}px`
    });
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, /*#__PURE__*/ (0, $f8Sb3.jsx)(Tag, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: productHomeButtonDynamicStyles,
        css: $0e05473b886b5a77$var$productHomeButtonStyles,
        href: href,
        onClick: onClick,
        onMouseDown: preventFocusRing,
        "data-testid": testId && `${testId}-container`,
        "aria-label": ariaLabel,
        ...rest
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            $0e05473b886b5a77$var$customMaxHeightStyles,
            $0e05473b886b5a77$var$productLogoStyles
        ],
        "data-testid": testId && `${testId}-logo`
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)(Logo, {
        iconColor: iconColor,
        textColor: textColor,
        // @ts-ignore - The new icons don't have an appearance prop at the moment
        appearance: (0, $fHpHg.fg)('platform-team25-app-icon-tiles') ? 'brand' : undefined
    })), /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            $0e05473b886b5a77$var$customMaxHeightStyles,
            $0e05473b886b5a77$var$productIconStyles
        ],
        "data-testid": testId && `${testId}-icon`
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)(Icon, {
        iconColor: iconColor,
        size: (0, $fHpHg.fg)('platform-team25-app-icon-tiles') ? 'small' : undefined,
        // @ts-ignore - The new icons don't have an appearance prop at the moment
        appearance: (0, $fHpHg.fg)('platform-team25-app-icon-tiles') ? 'brand' : undefined
    }))), siteTitle && /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        style: {
            borderRight: theme.mode.productHome.borderRight
        },
        css: $0e05473b886b5a77$var$siteTitleStyles,
        "data-testid": testId && `${testId}-site-title`
    }, siteTitle));
};
var $0e05473b886b5a77$export$2e2bcd8739ae039 = $0e05473b886b5a77$var$ProductHome;

});
parcelRegister("hNUWC", function(module, exports) {

$parcel$export(module.exports, "stripEmptyProperties", () => $18e51ed8c86f018a$export$e03bb5c7fd72635);
/**
 * Returns a new object with only non-empty properties of the input object.
 *
 * In this context, "empty" refers to properties with `null`, `undefined`, or `""`
 * (empty string) values.
 *
 * @param obj - The input object.
 * @returns A new object with non-empty properties of the input object.
 */ function $18e51ed8c86f018a$export$e03bb5c7fd72635(obj) {
    return Object.entries(obj).reduce((acc, [key, value])=>{
        if (value !== null && value !== undefined && value !== '') acc[key] = value;
        return acc;
    }, {});
}

});


parcelRegister("7esE0", function(module, exports) {

$parcel$export(module.exports, "AtlassianLogo", () => $6cadc4e4c1aae665$export$765cacec8b0843f3);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $6VxGE = parcelRequire("6VxGE");

var $kpt43 = parcelRequire("kpt43");

var $2uZGe = parcelRequire("2uZGe");

var $j62qJ = parcelRequire("j62qJ");
const $6cadc4e4c1aae665$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor,
        textColor: textColor,
        // We treat the word "Atlassian" differently to normal product logos, it has a bold brand look
        atlassianLogoTextColor: textColor
    };
    if (appearance) colors = (0, $2uZGe.getColorsFromAppearance)(appearance, colorMode);
    return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 198 32" focusable="false" aria-hidden="true" height="32" fill="none">
      <path fill=${colors.iconColor} d="M22.878 24.378 12.293 3.208c-.208-.458-.416-.541-.666-.541-.209 0-.459.083-.709.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.043 13.794.333.667.583.792 1.166.792h7.335c.542 0 .833-.208.833-.625 0-.208-.041-.333-.25-.75M7.501 14.377c-.833-1.25-1.083-1.334-1.292-1.334s-.333.083-.708.834L.208 24.46c-.166.334-.208.459-.208.625 0 .334.292.667.917.667h7.46c.5 0 .874-.416 1.083-1.208.25-1 .333-1.876.333-2.917 0-2.917-1.292-5.751-2.292-7.251z"/>
      <path fill=${colors.atlassianLogoTextColor} d="M107.447 10.828c0 2.972 1.345 5.308 6.795 6.37 3.185.707 3.893 1.203 3.893 2.265 0 1.061-.708 1.698-2.973 1.698-2.619 0-5.733-.92-7.785-2.123v4.813c1.627.778 3.751 1.698 7.785 1.698 5.662 0 7.856-2.548 7.856-6.228m0 .07c0-3.538-1.84-5.166-7.148-6.298-2.902-.637-3.61-1.274-3.61-2.194 0-1.133 1.062-1.628 2.973-1.628 2.335 0 4.6.708 6.794 1.698v-4.6c-1.557-.779-3.892-1.345-6.653-1.345-5.237 0-7.927 2.265-7.927 5.945m72.475-5.803v20.17h4.318V9.979l1.769 4.035 6.087 11.324h5.379V5.166h-4.247v13.022l-1.628-3.821-4.883-9.201zm-27.319 0h-4.671v20.17h4.671zm-10.05 14.154c0-3.538-1.841-5.166-7.149-6.298-2.902-.637-3.609-1.274-3.609-2.194 0-1.133 1.061-1.628 2.972-1.628 2.336 0 4.601.708 6.795 1.699v-4.6c-1.557-.78-3.893-1.346-6.653-1.346-5.238 0-7.927 2.265-7.927 5.946 0 2.972 1.344 5.308 6.794 6.37 3.185.707 3.893 1.203 3.893 2.264 0 1.062-.708 1.699-2.973 1.699-2.618 0-5.733-.92-7.785-2.123v4.812c1.628.779 3.751 1.699 7.785 1.699 5.592 0 7.857-2.548 7.857-6.3M71.069 5.166v20.17h9.625l1.486-4.387h-6.44V5.166zm-19.039 0v4.317h5.167v15.854h4.741V9.483h5.592V5.166zm-6.866 0h-6.157L32 25.336h5.379l.99-3.396c1.204.353 2.478.566 3.752.566s2.548-.213 3.751-.567l.991 3.398h5.379c-.07 0-7.078-20.171-7.078-20.171M42.05 18.259c-.92 0-1.77-.141-2.548-.354L42.05 9.13l2.548 8.776a9.6 9.6 0 0 1-2.548.354zM97.326 5.166H91.17l-7.078 20.17h5.38l.99-3.396c1.203.353 2.477.566 3.751.566s2.548-.213 3.751-.567l.991 3.398h5.379zm-3.114 13.093c-.92 0-1.77-.141-2.548-.354l2.548-8.776 2.548 8.776a9.6 9.6 0 0 1-2.548.354m75.306-13.093h-6.157l-7.007 20.17h5.379l.991-3.396c1.203.353 2.477.566 3.751.566s2.548-.213 3.751-.567l.991 3.398h5.379zm-3.043 13.093c-.92 0-1.77-.141-2.548-.354l2.548-8.776 2.548 8.776a10 10 0 0 1-2.548.354"/>
    </svg>`;
};
const $6cadc4e4c1aae665$export$765cacec8b0843f3 = ({ appearance: appearance, label: label = 'Atlassian', size: size = (0, $kpt43.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $kpt43.defaultLogoParams).iconColor, textColor: textColor = (0, $kpt43.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $6VxGE.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $j62qJ.default), {
        appearance: appearance,
        label: label,
        svg: $6cadc4e4c1aae665$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("41Nl9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0f847d1cd9da5a4c2f8db9579d329d66>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2eed875cab8a252f$var$_react = $2eed875cab8a252f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $2eed875cab8a252f$var$_app = $2eed875cab8a252f$var$_interopRequireDefault((parcelRequire("IS9QB")));

var $2eed875cab8a252f$var$_addon = $2eed875cab8a252f$var$_interopRequireDefault((parcelRequire("gOmoF")));
function $2eed875cab8a252f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for AppIcon.
 * This component is AppIcon, with `UNSAFE_fallbackIcon` set to "AddonIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for marketplace apps and integrations across products.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2eed875cab8a252f$var$AppIcon = (props)=>/*#__PURE__*/ $2eed875cab8a252f$var$_react.default.createElement($2eed875cab8a252f$var$_app.default, Object.assign({
        LEGACY_fallbackIcon: $2eed875cab8a252f$var$_addon.default
    }, props));
$2eed875cab8a252f$var$AppIcon.Name = 'AppIconMigration';
var $2eed875cab8a252f$var$_default = module.exports.default = $2eed875cab8a252f$var$AppIcon;

});

parcelRegister("ctLcP", function(module, exports) {

$parcel$export(module.exports, "Settings", () => $cbaa58e0e1c547c7$export$c72f6eaae7b9adff);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $51oeD = parcelRequire("51oeD");

var $ji50l = parcelRequire("ji50l");
const $cbaa58e0e1c547c7$export$c72f6eaae7b9adff = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $ji50l.UserAction), {
        ...props,
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($51oeD)))
    }));

});
parcelRegister("ji50l", function(module, exports) {

$parcel$export(module.exports, "UserAction", () => $1bc4d8d5e0829b69$export$d344b04822cd68e8);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $92SLf = parcelRequire("92SLf");

var $3926G = parcelRequire("3926G");
const $1bc4d8d5e0829b69$export$d344b04822cd68e8 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ label: label, icon: icon, onClick: onClick, onMouseEnter: onMouseEnter, isSelected: isSelected, testId: testId, interactionName: interactionName, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, isListItem: isListItem = true }, forwardedRef)=>{
    const Wrapper = isListItem ? (0, $92SLf.ListItem) : (0, $5uXOq.Fragment);
    return /*#__PURE__*/ (0, $2OMIu.jsx)(Wrapper, {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3926G.IconButton), {
            ref: forwardedRef,
            icon: icon,
            label: label,
            onClick: onClick,
            onMouseEnter: onMouseEnter,
            appearance: "subtle",
            isSelected: isSelected,
            isTooltipDisabled: false,
            testId: testId,
            interactionName: interactionName,
            "aria-controls": ariaControls,
            "aria-expanded": ariaExpanded,
            "aria-haspopup": ariaHasPopup
        })
    });
});

});


parcelRegister("lMdw2", function(module, exports) {

$parcel$export(module.exports, "Settings", () => $08a493525e25bcb9$export$c72f6eaae7b9adff);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $dnGcR = parcelRequire("dnGcR");

var $2JYdg = parcelRequire("2JYdg");
const $08a493525e25bcb9$export$c72f6eaae7b9adff = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { component: component, href: href, id: id, isDisabled: isDisabled, isSelected: isSelected, label: label, onBlur: onBlur, onClick: onClick, onFocus: onFocus, onMouseDown: onMouseDown, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, target: target, testId: testId, tooltip: tooltip, ...rest } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        role: "listitem",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2JYdg.IconButton), {
            component: component,
            href: href,
            icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dnGcR))), {
                color: "currentColor",
                spacing: "spacious",
                label: typeof tooltip === 'string' ? tooltip : 'Settings Icon'
            }),
            id: id,
            isDisabled: isDisabled,
            isSelected: isSelected,
            label: label,
            onBlur: onBlur,
            onClick: onClick,
            onFocus: onFocus,
            onMouseDown: onMouseDown,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            onMouseUp: onMouseUp,
            ref: ref,
            target: target,
            testId: testId,
            tooltip: tooltip,
            isTooltipAnnouncementDisabled: true,
            ...rest
        })
    });
});

});

parcelRegister("hpqc1", function(module, exports) {

$parcel$export(module.exports, "SkeletonSettingsButton", () => $a0eb7b2421483c06$export$914093d4d181ff4d);
$parcel$export(module.exports, "Nav4SkeletonSettingsButton", () => $a0eb7b2421483c06$export$beac98f336d7b14f);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $dnGcR = parcelRequire("dnGcR");

var $51oeD = parcelRequire("51oeD");

var $inPL4 = parcelRequire("inPL4");
const $a0eb7b2421483c06$export$914093d4d181ff4d = ({ label: label = '' })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $inPL4.SkeletonIconButton), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dnGcR))), {
            color: "currentColor",
            spacing: "spacious",
            label: label
        })
    });
const $a0eb7b2421483c06$export$beac98f336d7b14f = ({ label: label = '' })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $inPL4.SkeletonIconButton), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($51oeD))), {
            label: label,
            color: "var(--ds-icon, #44546F)"
        })
    });

});

parcelRegister("Wkf8o", function(module, exports) {

$parcel$export(module.exports, "default", () => $dcf8d984d7d5f846$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $lGEY5 = parcelRequire("lGEY5");

var $bKnKN = parcelRequire("bKnKN");


var $8rw4v = parcelRequire("8rw4v");
function $dcf8d984d7d5f846$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $dcf8d984d7d5f846$var$skeletonStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    paddingBlock: "var(--ds-space-0, 0px)",
    paddingInline: "var(--ds-space-200, 16px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '::after': {
        display: 'block',
        width: '30%',
        height: "var(--ds-space-100, 8px)",
        backgroundColor: `var(--ds-skeleton, ${(0, $a7f8c6b391092279$export$8d43898f60b96a82)})`,
        borderRadius: 100,
        content: '""'
    }
});
const $dcf8d984d7d5f846$var$defaultWidthStyles = {
    name: "me8tg7",
    styles: "::after{width:30%;}"
};
const $dcf8d984d7d5f846$var$customWidthStyles = {
    name: "ms0ivw",
    styles: "::after{width:var(--width);}"
};
/**
 * __Skeleton heading item__
 *
 * A skeleton heading item is used in place of a heading item when its contents it not ready.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/skeleton-heading-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ const $dcf8d984d7d5f846$var$SkeletonHeadingItem = ({ isShimmering: isShimmering = false, testId: testId, width: width, cssFn: cssFn = (0, $bKnKN.default) })=>{
    (0, $lGEY5.propDeprecationWarning)("platform-pkg", 'cssFn', cssFn !== (0, $bKnKN.default), '' // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    const UNSAFE_overrides = /*#__PURE__*/ (0, $f8Sb3.css)(cssFn(undefined));
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $8rw4v.default), {
        isShimmering: isShimmering
    }, ({ className: className })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            style: {
                '--width': width
            },
            css: [
                $dcf8d984d7d5f846$var$skeletonStyles,
                width ? $dcf8d984d7d5f846$var$customWidthStyles : $dcf8d984d7d5f846$var$defaultWidthStyles,
                // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
                UNSAFE_overrides
            ],
            "data-ds--menu--skeleton-heading-item": true,
            "data-testid": testId
        }));
};
var $dcf8d984d7d5f846$export$2e2bcd8739ae039 = $dcf8d984d7d5f846$var$SkeletonHeadingItem;

});

parcelRegister("ef9tG", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::aa2c753ece5041b181498943e0fe8bd9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a5e9d180c1885548$var$_react = $a5e9d180c1885548$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $a5e9d180c1885548$var$_dashboard = $a5e9d180c1885548$var$_interopRequireDefault((parcelRequire("gdqFV")));

var $a5e9d180c1885548$var$_activity = $a5e9d180c1885548$var$_interopRequireDefault((parcelRequire("cCv9R")));
function $a5e9d180c1885548$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for DashboardIcon.
 * This component is DashboardIcon, with `UNSAFE_fallbackIcon` set to "ActivityIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for dashboards in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a5e9d180c1885548$var$DashboardIcon = (props)=>/*#__PURE__*/ $a5e9d180c1885548$var$_react.default.createElement($a5e9d180c1885548$var$_dashboard.default, Object.assign({
        LEGACY_fallbackIcon: $a5e9d180c1885548$var$_activity.default
    }, props));
$a5e9d180c1885548$var$DashboardIcon.Name = 'DashboardIconMigration';
var $a5e9d180c1885548$var$_default = module.exports.default = $a5e9d180c1885548$var$DashboardIcon;

});

parcelRegister("8AbsI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e2f90a428e27c19a23210f4827b99818>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $63fa93aceefa72bd$var$_react = $63fa93aceefa72bd$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $63fa93aceefa72bd$var$_folderClosed = $63fa93aceefa72bd$var$_interopRequireDefault((parcelRequire("8P27X")));

var $63fa93aceefa72bd$var$_folder = $63fa93aceefa72bd$var$_interopRequireDefault((parcelRequire("8GE7C")));
function $63fa93aceefa72bd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for FolderClosedIcon.
 * This component is FolderClosedIcon, with `UNSAFE_fallbackIcon` set to "FolderIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for folders in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $63fa93aceefa72bd$var$FolderClosedIcon = (props)=>/*#__PURE__*/ $63fa93aceefa72bd$var$_react.default.createElement($63fa93aceefa72bd$var$_folderClosed.default, Object.assign({
        LEGACY_fallbackIcon: $63fa93aceefa72bd$var$_folder.default
    }, props));
$63fa93aceefa72bd$var$FolderClosedIcon.Name = 'FolderClosedIconMigration';
var $63fa93aceefa72bd$var$_default = module.exports.default = $63fa93aceefa72bd$var$FolderClosedIcon;

});

parcelRegister("i0frO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d92ee8885a3bd0486e697aace29ae839>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d1b435abda7c162e$var$_react = $d1b435abda7c162e$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $d1b435abda7c162e$var$_screen = $d1b435abda7c162e$var$_interopRequireDefault((parcelRequire("kAA90")));

var $d1b435abda7c162e$var$_screen2 = $d1b435abda7c162e$var$_interopRequireDefault((parcelRequire("cwZY7")));
function $d1b435abda7c162e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ScreenIcon.
 * This component is ScreenIcon, with `UNSAFE_fallbackIcon` set to "ScreenIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: assets in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d1b435abda7c162e$var$ScreenIcon = (props)=>/*#__PURE__*/ $d1b435abda7c162e$var$_react.default.createElement($d1b435abda7c162e$var$_screen.default, Object.assign({
        LEGACY_fallbackIcon: $d1b435abda7c162e$var$_screen2.default
    }, props));
$d1b435abda7c162e$var$ScreenIcon.Name = 'ScreenIconMigration';
var $d1b435abda7c162e$var$_default = module.exports.default = $d1b435abda7c162e$var$ScreenIcon;

});

parcelRegister("jPRPG", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c11af61bf1d5e1e60e3ad123179be896>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e70c89c3e3dc42f1$var$_react = $e70c89c3e3dc42f1$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $e70c89c3e3dc42f1$var$_personAvatar = $e70c89c3e3dc42f1$var$_interopRequireDefault((parcelRequire("l1s8i")));

var $e70c89c3e3dc42f1$var$_personCircle = $e70c89c3e3dc42f1$var$_interopRequireDefault((parcelRequire("jvjSq")));
function $e70c89c3e3dc42f1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for PersonAvatarIcon.
 * This component is PersonAvatarIcon, with `UNSAFE_fallbackIcon` set to "PersonCircleIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for user avatar.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e70c89c3e3dc42f1$var$PersonAvatarIcon = (props)=>/*#__PURE__*/ $e70c89c3e3dc42f1$var$_react.default.createElement($e70c89c3e3dc42f1$var$_personAvatar.default, Object.assign({
        LEGACY_fallbackIcon: $e70c89c3e3dc42f1$var$_personCircle.default
    }, props));
$e70c89c3e3dc42f1$var$PersonAvatarIcon.Name = 'PersonAvatarIconMigration';
var $e70c89c3e3dc42f1$var$_default = module.exports.default = $e70c89c3e3dc42f1$var$PersonAvatarIcon;

});

parcelRegister("dEOiD", function(module, exports) {

$parcel$export(module.exports, "SkeletonPrimaryButton", () => $4496e5dd400dec40$export$4a3049f952d3f130);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $h4hQR = parcelRequire("h4hQR");

var $hNUWC = parcelRequire("hNUWC");
function $4496e5dd400dec40$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $4496e5dd400dec40$var$VAR_PRIMARY_BUTTON_BEFORE_HIGHLIGHTED_BACKGROUND_COLOR = '--primary-button-before-highlighted-background-color';
const $4496e5dd400dec40$var$VAR_PRIMARY_BUTTON_AFTER_DROPDOWN_BORDER_COLOR = '--primary-button-after-dropdown-border-color';
const $4496e5dd400dec40$var$primaryButtonSkeletonStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    margin: `0 ${"var(--ds-space-075, 6px)"}`,
    padding: `0 ${"var(--ds-space-050, 4px)"}`,
    position: 'relative',
    appearance: 'none',
    border: 0,
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    pointerEvents: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':focus, :active, :hover': {
        appearance: 'none',
        border: 0,
        outline: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '::-moz-focus-inner': {
        border: 0
    }
});
const $4496e5dd400dec40$var$isHighlightedStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:before': {
        height: 3,
        position: 'absolute',
        backgroundColor: `var(${$4496e5dd400dec40$var$VAR_PRIMARY_BUTTON_BEFORE_HIGHLIGHTED_BACKGROUND_COLOR})`,
        borderStartEndRadius: "var(--ds-border-radius-050, 1px)",
        borderStartStartRadius: "var(--ds-border-radius-050, 1px)",
        content: '""',
        insetBlockEnd: 0,
        insetInlineStart: "var(--ds-space-025, 2px)"
    }
});
const $4496e5dd400dec40$var$isHighlightedAndDropdownButtonStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:before': {
        insetInlineEnd: -10
    }
});
const $4496e5dd400dec40$var$isHighlightedNotDropdownButtonStyles = {
    name: "1sue5tp",
    styles: "&:before{inset-inline-end:var(--ds-space-025, 2px);}"
};
const $4496e5dd400dec40$var$isDropdownButtonStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
    marginInlineEnd: 18,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:after': {
        display: 'inline-block',
        width: 4,
        height: 4,
        position: 'absolute',
        borderBlockEnd: '2px solid',
        borderColor: `var(${$4496e5dd400dec40$var$VAR_PRIMARY_BUTTON_AFTER_DROPDOWN_BORDER_COLOR})`,
        borderInlineEnd: '2px solid',
        borderRadius: "var(--ds-border-radius-050, 1px)",
        content: '""',
        insetBlockStart: 'calc(50% - 4px)',
        insetInlineStart: 'calc(100% - 3px)',
        marginInlineStart: "var(--ds-space-050, 4px)",
        transform: 'rotate(45deg) scale(1.05)',
        verticalAlign: 'middle'
    }
});
const $4496e5dd400dec40$var$buttonWrapperStyles = {
    name: "rfxc55",
    styles: "display:flex;margin:0"
};
const $4496e5dd400dec40$export$4a3049f952d3f130 = ({ isDropdownButton: isDropdownButton = false, isHighlighted: isHighlighted = false, text: text, children: children, testId: testId })=>{
    const theme = (0, $h4hQR.useTheme)();
    const primaryButton = theme.mode.primaryButton;
    const dynamicStyles = (0, $hNUWC.stripEmptyProperties)({
        ...primaryButton.default,
        ...isHighlighted && {
            color: primaryButton.selected.color
        },
        [$4496e5dd400dec40$var$VAR_PRIMARY_BUTTON_BEFORE_HIGHLIGHTED_BACKGROUND_COLOR]: primaryButton.selected.borderColor,
        [$4496e5dd400dec40$var$VAR_PRIMARY_BUTTON_AFTER_DROPDOWN_BORDER_COLOR]: isHighlighted ? primaryButton.default.borderColor : primaryButton.default.color
    });
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        role: "listitem",
        css: $4496e5dd400dec40$var$buttonWrapperStyles
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("button", {
        type: "button",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: dynamicStyles,
        css: [
            $4496e5dd400dec40$var$primaryButtonSkeletonStyles,
            isHighlighted && $4496e5dd400dec40$var$isHighlightedStyles,
            isDropdownButton && $4496e5dd400dec40$var$isDropdownButtonStyles,
            isHighlighted && (isDropdownButton ? $4496e5dd400dec40$var$isHighlightedAndDropdownButtonStyles : $4496e5dd400dec40$var$isHighlightedNotDropdownButtonStyles)
        ],
        "data-testid": testId
    }, text || children));
};

});

parcelRegister("kzEYk", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::14f14ae2593cbb89c3cab1b7918f4611>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $efa6dbbfa8796bfa$var$_react = $efa6dbbfa8796bfa$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $efa6dbbfa8796bfa$var$_baseNew = $efa6dbbfa8796bfa$var$_interopRequireDefault((parcelRequire("enEmH")));
function $efa6dbbfa8796bfa$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StarStarred".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for starred or favourited objects as a secondary/tertiary action.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $efa6dbbfa8796bfa$var$StarStarredIcon = (props)=>/*#__PURE__*/ $efa6dbbfa8796bfa$var$_react.default.createElement($efa6dbbfa8796bfa$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6 0a.75.75 0 0 1 .7.48l1.288 3.35 3.32.256a.75.75 0 0 1 .422 1.324L9.182 7.533l.945 3.523a.75.75 0 0 1-1.148.813L6 9.825l-2.979 2.042a.75.75 0 0 1-1.148-.812l.945-3.523L.27 5.41a.75.75 0 0 1 .422-1.324l3.32-.256L5.3.48A.75.75 0 0 1 6 0m0 2.84-.928 2.413-2.423.186 1.866 1.556-.667 2.488L6 8.007l2.152 1.476-.667-2.488L9.35 5.439l-2.423-.186z" clip-rule="evenodd"/><path fill="currentcolor" d="M5.072 5.253 6 2.84l.928 2.414 2.423.186-1.866 1.556.667 2.488L6 8.007 3.848 9.483l.667-2.488L2.65 5.439z"/>`,
        type: 'utility'
    }, props));
$efa6dbbfa8796bfa$var$StarStarredIcon.displayName = 'StarStarredIcon';
var $efa6dbbfa8796bfa$var$_default = module.exports.default = $efa6dbbfa8796bfa$var$StarStarredIcon;

});

parcelRegister("8nT7B", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::289d4f542a1ed26db6d28b87ad2efcf4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $61ab3abe1bd925f7$var$_react = $61ab3abe1bd925f7$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $61ab3abe1bd925f7$var$_filter = $61ab3abe1bd925f7$var$_interopRequireDefault((parcelRequire("2tGrM")));

var $61ab3abe1bd925f7$var$_filter2 = $61ab3abe1bd925f7$var$_interopRequireDefault((parcelRequire("26w26")));
function $61ab3abe1bd925f7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for FilterIcon.
 * This component is FilterIcon, with `UNSAFE_fallbackIcon` set to "FilterIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for filterting data or objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $61ab3abe1bd925f7$var$FilterIcon = (props)=>/*#__PURE__*/ $61ab3abe1bd925f7$var$_react.default.createElement($61ab3abe1bd925f7$var$_filter.default, Object.assign({
        LEGACY_fallbackIcon: $61ab3abe1bd925f7$var$_filter2.default
    }, props));
$61ab3abe1bd925f7$var$FilterIcon.Name = 'FilterIconMigration';
var $61ab3abe1bd925f7$var$_default = module.exports.default = $61ab3abe1bd925f7$var$FilterIcon;

});

parcelRegister("jjjbg", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7183201509c40b5c08006bcaf851f797>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e0eeab8fd53be857$var$_react = $e0eeab8fd53be857$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $e0eeab8fd53be857$var$_dashboard = $e0eeab8fd53be857$var$_interopRequireDefault((parcelRequire("gdqFV")));

var $e0eeab8fd53be857$var$_dashboard2 = $e0eeab8fd53be857$var$_interopRequireDefault((parcelRequire("5OyEj")));
function $e0eeab8fd53be857$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for DashboardIcon.
 * This component is DashboardIcon, with `UNSAFE_fallbackIcon` set to "DashboardIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for dashboards in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e0eeab8fd53be857$var$DashboardIcon = (props)=>/*#__PURE__*/ $e0eeab8fd53be857$var$_react.default.createElement($e0eeab8fd53be857$var$_dashboard.default, Object.assign({
        LEGACY_fallbackIcon: $e0eeab8fd53be857$var$_dashboard2.default
    }, props));
$e0eeab8fd53be857$var$DashboardIcon.Name = 'DashboardIconMigration';
var $e0eeab8fd53be857$var$_default = module.exports.default = $e0eeab8fd53be857$var$DashboardIcon;

});

parcelRegister("55UTN", function(module, exports) {

$parcel$export(module.exports, "Notifications", () => $4da567c797a436fb$export$36ba2f559d49a8f6);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $kQwUB = parcelRequire("kQwUB");

var $8xcQd = parcelRequire("8xcQd");

var $2JYdg = parcelRequire("2JYdg");
const $4da567c797a436fb$var$NOTIFICATIONS_BADGE_ID = 'atlassian-navigation-notification-count';
const $4da567c797a436fb$export$36ba2f559d49a8f6 = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { badge: badge, component: component, href: href, id: id, isDisabled: isDisabled, isSelected: isSelected, label: label, onBlur: onBlur, onClick: onClick, onFocus: onFocus, onMouseDown: onMouseDown, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, target: target, testId: testId, tooltip: tooltip, ...rest } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8xcQd.BadgeContainer), {
        id: $4da567c797a436fb$var$NOTIFICATIONS_BADGE_ID,
        badge: badge,
        role: "listitem",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2JYdg.IconButton), {
            "aria-describedby": $4da567c797a436fb$var$NOTIFICATIONS_BADGE_ID,
            component: component,
            href: href,
            icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kQwUB))), {
                spacing: "spacious",
                color: "currentColor",
                label: typeof tooltip === 'string' ? tooltip : 'Notification Icon'
            }),
            id: id,
            isDisabled: isDisabled,
            isSelected: isSelected,
            label: label,
            onBlur: onBlur,
            onClick: onClick,
            onFocus: onFocus,
            onMouseDown: onMouseDown,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            onMouseUp: onMouseUp,
            ref: ref,
            target: target,
            testId: testId,
            tooltip: tooltip,
            isTooltipAnnouncementDisabled: true,
            ...rest
        })
    });
});

});
parcelRegister("kQwUB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::01602fb49c3451f8884e2ed4b4e67e9f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f2d2319886cf4394$var$_react = $f2d2319886cf4394$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $f2d2319886cf4394$var$_notification = $f2d2319886cf4394$var$_interopRequireDefault((parcelRequire("imLNv")));

var $f2d2319886cf4394$var$_notification2 = $f2d2319886cf4394$var$_interopRequireDefault((parcelRequire("cELUk")));
function $f2d2319886cf4394$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for NotificationIcon.
 * This component is NotificationIcon, with `UNSAFE_fallbackIcon` set to "NotificationIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for notifications within global product navigation and within product screens.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f2d2319886cf4394$var$NotificationIcon = (props)=>/*#__PURE__*/ $f2d2319886cf4394$var$_react.default.createElement($f2d2319886cf4394$var$_notification.default, Object.assign({
        LEGACY_fallbackIcon: $f2d2319886cf4394$var$_notification2.default
    }, props));
$f2d2319886cf4394$var$NotificationIcon.Name = 'NotificationIconMigration';
var $f2d2319886cf4394$var$_default = module.exports.default = $f2d2319886cf4394$var$NotificationIcon;

});


parcelRegister("7g4lj", function(module, exports) {

$parcel$export(module.exports, "SkeletonNotificationButton", () => $8f42d1c3c9cf9b02$export$a14f01df37978534);
$parcel$export(module.exports, "Nav4SkeletonNotificationButton", () => $8f42d1c3c9cf9b02$export$6df5583c56de301f);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $kQwUB = parcelRequire("kQwUB");

var $imLNv = parcelRequire("imLNv");

var $inPL4 = parcelRequire("inPL4");
const $8f42d1c3c9cf9b02$export$a14f01df37978534 = ({ label: label = '' })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $inPL4.SkeletonIconButton), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kQwUB))), {
            color: "currentColor",
            spacing: "spacious",
            label: label
        })
    });
const $8f42d1c3c9cf9b02$export$6df5583c56de301f = ({ label: label = '' })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $inPL4.SkeletonIconButton), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($imLNv))), {
            label: label,
            color: "var(--ds-icon, #44546F)"
        })
    });

});

parcelRegister("eYOaQ", function(module, exports) {

$parcel$export(module.exports, "Notifications", () => $36064dc91f310b12$export$36ba2f559d49a8f6);
/* notifications.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $imLNv = parcelRequire("imLNv");

var $78rFO = parcelRequire("78rFO");

var $3926G = parcelRequire("3926G");
const $36064dc91f310b12$var$NOTIFICATIONS_BADGE_ID = 'atlassian-navigation-notification-count';
const $36064dc91f310b12$export$36ba2f559d49a8f6 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ badge: badge, onClick: onClick, label: label, isSelected: isSelected, testId: testId, interactionName: interactionName }, forwardedRef)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $78rFO.BadgeContainer), {
        id: $36064dc91f310b12$var$NOTIFICATIONS_BADGE_ID,
        badge: badge,
        role: "listitem",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3926G.IconButton), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($imLNv))),
            label: label,
            onClick: onClick,
            appearance: "subtle",
            isSelected: isSelected,
            ref: forwardedRef,
            isTooltipDisabled: false,
            testId: testId,
            interactionName: interactionName
        })
    }));

});

parcelRegister("hcJMf", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::27adf6ccfa0da2e986d1468bec1512ef>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c867110f758446e9$var$_react = $c867110f758446e9$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c867110f758446e9$var$_notification = $c867110f758446e9$var$_interopRequireDefault((parcelRequire("imLNv")));

var $c867110f758446e9$var$_notificationDirect = $c867110f758446e9$var$_interopRequireDefault((parcelRequire("9wCjp")));
function $c867110f758446e9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for NotificationIcon.
 * This component is NotificationIcon, with `UNSAFE_fallbackIcon` set to "NotificationDirectIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for notifications within global product navigation and within product screens.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c867110f758446e9$var$NotificationIcon = (props)=>/*#__PURE__*/ $c867110f758446e9$var$_react.default.createElement($c867110f758446e9$var$_notification.default, Object.assign({
        LEGACY_fallbackIcon: $c867110f758446e9$var$_notificationDirect.default
    }, props));
$c867110f758446e9$var$NotificationIcon.Name = 'NotificationIconMigration';
var $c867110f758446e9$var$_default = module.exports.default = $c867110f758446e9$var$NotificationIcon;

});

const $0b39752fc2bc7c2a$export$e4c79eb95c23a0da = 'atlaskit-portal-container';
const $0b39752fc2bc7c2a$export$72f415121273627e = 'body > .atlaskit-portal-container';
const $0b39752fc2bc7c2a$export$13f57c02915787b3 = 'atlaskit-portal';

const $6389428f3f803f5f$export$ed5835cc67e87f72 = 'akPortalMount';
const $6389428f3f803f5f$export$80816bd900e5bd00 = 'akPortalUnmount';

// Media uses a namespaced analytics context under the following key MEDIA_CONTEXT.
const $86eff7942395d7f1$export$70df29c238ba7306 = 'mediaCtx'; // However we don't export any JSX component to create that namespaced analytics context.
 // In media components, analytics context is being created by this component:
 // @see packages/media/media-common/src/analytics/withMediaAnalyticsContext.tsx

// same types defined in analytics-web-client but avoid creating dependency with that
const $4e2819b72987a07d$export$a1562d08625f5d7e = 'ui';
const $4e2819b72987a07d$export$947dac6c72b26f81 = 'track';
const $4e2819b72987a07d$export$f1d537d508d2945a = 'screen';
const $4e2819b72987a07d$export$12346a674644c156 = 'operational';
const $4e2819b72987a07d$export$b055de0e665cb20c = 'unknown';

const $4bcf9932c1d0df17$export$d6830277b06edd6 = 'normal';


$parcel$global.rlb("bYT2S")
//# sourceMappingURL=shared~atlassian-navigation~atlaskit~ar.c054a542.js.map
